import { g as getAugmentedNamespace, c as commonjsGlobal, a as getDefaultExportFromCjs, p as process$1 } from "./index-DdhVUaAV.js";
import qg, { PROPOSAL_EXPIRY_MESSAGE } from "@walletconnect/sign-client";
const global = globalThis || void 0 || self;
var buffer$1 = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$1 = 0, len = code.length; i$1 < len; ++i$1)
  lookup[i$1] = code[i$1], revLookup[code.charCodeAt(i$1)] = i$1;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(I) {
  var A = I.length;
  if (A % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var G = I.indexOf("=");
  G === -1 && (G = A);
  var J = G === A ? 0 : 4 - G % 4;
  return [G, J];
}
function byteLength(I) {
  var A = getLens(I), G = A[0], J = A[1];
  return (G + J) * 3 / 4 - J;
}
function _byteLength(I, A, G) {
  return (A + G) * 3 / 4 - G;
}
function toByteArray(I) {
  var A, G = getLens(I), J = G[0], _e = G[1], H = new Arr(_byteLength(I, J, _e)), De = 0, Ie = _e > 0 ? J - 4 : J, qe;
  for (qe = 0; qe < Ie; qe += 4)
    A = revLookup[I.charCodeAt(qe)] << 18 | revLookup[I.charCodeAt(qe + 1)] << 12 | revLookup[I.charCodeAt(qe + 2)] << 6 | revLookup[I.charCodeAt(qe + 3)], H[De++] = A >> 16 & 255, H[De++] = A >> 8 & 255, H[De++] = A & 255;
  return _e === 2 && (A = revLookup[I.charCodeAt(qe)] << 2 | revLookup[I.charCodeAt(qe + 1)] >> 4, H[De++] = A & 255), _e === 1 && (A = revLookup[I.charCodeAt(qe)] << 10 | revLookup[I.charCodeAt(qe + 1)] << 4 | revLookup[I.charCodeAt(qe + 2)] >> 2, H[De++] = A >> 8 & 255, H[De++] = A & 255), H;
}
function tripletToBase64(I) {
  return lookup[I >> 18 & 63] + lookup[I >> 12 & 63] + lookup[I >> 6 & 63] + lookup[I & 63];
}
function encodeChunk(I, A, G) {
  for (var J, _e = [], H = A; H < G; H += 3)
    J = (I[H] << 16 & 16711680) + (I[H + 1] << 8 & 65280) + (I[H + 2] & 255), _e.push(tripletToBase64(J));
  return _e.join("");
}
function fromByteArray(I) {
  for (var A, G = I.length, J = G % 3, _e = [], H = 16383, De = 0, Ie = G - J; De < Ie; De += H)
    _e.push(encodeChunk(I, De, De + H > Ie ? Ie : De + H));
  return J === 1 ? (A = I[G - 1], _e.push(
    lookup[A >> 2] + lookup[A << 4 & 63] + "=="
  )) : J === 2 && (A = (I[G - 2] << 8) + I[G - 1], _e.push(
    lookup[A >> 10] + lookup[A >> 4 & 63] + lookup[A << 2 & 63] + "="
  )), _e.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(I, A, G, J, _e) {
  var H, De, Ie = _e * 8 - J - 1, qe = (1 << Ie) - 1, Te = qe >> 1, Ee = -7, Oe = G ? _e - 1 : 0, Le = G ? -1 : 1, ke = I[A + Oe];
  for (Oe += Le, H = ke & (1 << -Ee) - 1, ke >>= -Ee, Ee += Ie; Ee > 0; H = H * 256 + I[A + Oe], Oe += Le, Ee -= 8)
    ;
  for (De = H & (1 << -Ee) - 1, H >>= -Ee, Ee += J; Ee > 0; De = De * 256 + I[A + Oe], Oe += Le, Ee -= 8)
    ;
  if (H === 0)
    H = 1 - Te;
  else {
    if (H === qe)
      return De ? NaN : (ke ? -1 : 1) * (1 / 0);
    De = De + Math.pow(2, J), H = H - Te;
  }
  return (ke ? -1 : 1) * De * Math.pow(2, H - J);
};
ieee754.write = function(I, A, G, J, _e, H) {
  var De, Ie, qe, Te = H * 8 - _e - 1, Ee = (1 << Te) - 1, Oe = Ee >> 1, Le = _e === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, ke = J ? 0 : H - 1, Fe = J ? 1 : -1, Ge = A < 0 || A === 0 && 1 / A < 0 ? 1 : 0;
  for (A = Math.abs(A), isNaN(A) || A === 1 / 0 ? (Ie = isNaN(A) ? 1 : 0, De = Ee) : (De = Math.floor(Math.log(A) / Math.LN2), A * (qe = Math.pow(2, -De)) < 1 && (De--, qe *= 2), De + Oe >= 1 ? A += Le / qe : A += Le * Math.pow(2, 1 - Oe), A * qe >= 2 && (De++, qe /= 2), De + Oe >= Ee ? (Ie = 0, De = Ee) : De + Oe >= 1 ? (Ie = (A * qe - 1) * Math.pow(2, _e), De = De + Oe) : (Ie = A * Math.pow(2, Oe - 1) * Math.pow(2, _e), De = 0)); _e >= 8; I[G + ke] = Ie & 255, ke += Fe, Ie /= 256, _e -= 8)
    ;
  for (De = De << _e | Ie, Te += _e; Te > 0; I[G + ke] = De & 255, ke += Fe, De /= 256, Te -= 8)
    ;
  I[G + ke - Fe] |= Ge * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(I) {
  const A = base64Js, G = ieee754, J = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  I.Buffer = Ee, I.SlowBuffer = lt, I.INSPECT_MAX_BYTES = 50;
  const _e = 2147483647;
  I.kMaxLength = _e;
  const { Uint8Array: H, ArrayBuffer: De, SharedArrayBuffer: Ie } = globalThis;
  Ee.TYPED_ARRAY_SUPPORT = qe(), !Ee.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function qe() {
    try {
      const ct = new H(1), Ze = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Ze, H.prototype), Object.setPrototypeOf(ct, Ze), ct.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(Ee.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (Ee.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(Ee.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (Ee.isBuffer(this))
        return this.byteOffset;
    }
  });
  function Te(ct) {
    if (ct > _e)
      throw new RangeError('The value "' + ct + '" is invalid for option "size"');
    const Ze = new H(ct);
    return Object.setPrototypeOf(Ze, Ee.prototype), Ze;
  }
  function Ee(ct, Ze, at) {
    if (typeof ct == "number") {
      if (typeof Ze == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return Fe(ct);
    }
    return Oe(ct, Ze, at);
  }
  Ee.poolSize = 8192;
  function Oe(ct, Ze, at) {
    if (typeof ct == "string")
      return Ge(ct, Ze);
    if (De.isView(ct))
      return Ve(ct);
    if (ct == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ct
      );
    if (Rt(ct, De) || ct && Rt(ct.buffer, De) || typeof Ie < "u" && (Rt(ct, Ie) || ct && Rt(ct.buffer, Ie)))
      return Je(ct, Ze, at);
    if (typeof ct == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const dt = ct.valueOf && ct.valueOf();
    if (dt != null && dt !== ct)
      return Ee.from(dt, Ze, at);
    const yt = ut(ct);
    if (yt) return yt;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof ct[Symbol.toPrimitive] == "function")
      return Ee.from(ct[Symbol.toPrimitive]("string"), Ze, at);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ct
    );
  }
  Ee.from = function(ct, Ze, at) {
    return Oe(ct, Ze, at);
  }, Object.setPrototypeOf(Ee.prototype, H.prototype), Object.setPrototypeOf(Ee, H);
  function Le(ct) {
    if (typeof ct != "number")
      throw new TypeError('"size" argument must be of type number');
    if (ct < 0)
      throw new RangeError('The value "' + ct + '" is invalid for option "size"');
  }
  function ke(ct, Ze, at) {
    return Le(ct), ct <= 0 ? Te(ct) : Ze !== void 0 ? typeof at == "string" ? Te(ct).fill(Ze, at) : Te(ct).fill(Ze) : Te(ct);
  }
  Ee.alloc = function(ct, Ze, at) {
    return ke(ct, Ze, at);
  };
  function Fe(ct) {
    return Le(ct), Te(ct < 0 ? 0 : rt(ct) | 0);
  }
  Ee.allocUnsafe = function(ct) {
    return Fe(ct);
  }, Ee.allocUnsafeSlow = function(ct) {
    return Fe(ct);
  };
  function Ge(ct, Ze) {
    if ((typeof Ze != "string" || Ze === "") && (Ze = "utf8"), !Ee.isEncoding(Ze))
      throw new TypeError("Unknown encoding: " + Ze);
    const at = vt(ct, Ze) | 0;
    let dt = Te(at);
    const yt = dt.write(ct, Ze);
    return yt !== at && (dt = dt.slice(0, yt)), dt;
  }
  function et(ct) {
    const Ze = ct.length < 0 ? 0 : rt(ct.length) | 0, at = Te(Ze);
    for (let dt = 0; dt < Ze; dt += 1)
      at[dt] = ct[dt] & 255;
    return at;
  }
  function Ve(ct) {
    if (Rt(ct, H)) {
      const Ze = new H(ct);
      return Je(Ze.buffer, Ze.byteOffset, Ze.byteLength);
    }
    return et(ct);
  }
  function Je(ct, Ze, at) {
    if (Ze < 0 || ct.byteLength < Ze)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (ct.byteLength < Ze + (at || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let dt;
    return Ze === void 0 && at === void 0 ? dt = new H(ct) : at === void 0 ? dt = new H(ct, Ze) : dt = new H(ct, Ze, at), Object.setPrototypeOf(dt, Ee.prototype), dt;
  }
  function ut(ct) {
    if (Ee.isBuffer(ct)) {
      const Ze = rt(ct.length) | 0, at = Te(Ze);
      return at.length === 0 || ct.copy(at, 0, 0, Ze), at;
    }
    if (ct.length !== void 0)
      return typeof ct.length != "number" || ai(ct.length) ? Te(0) : et(ct);
    if (ct.type === "Buffer" && Array.isArray(ct.data))
      return et(ct.data);
  }
  function rt(ct) {
    if (ct >= _e)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + _e.toString(16) + " bytes");
    return ct | 0;
  }
  function lt(ct) {
    return +ct != ct && (ct = 0), Ee.alloc(+ct);
  }
  Ee.isBuffer = function(Ze) {
    return Ze != null && Ze._isBuffer === !0 && Ze !== Ee.prototype;
  }, Ee.compare = function(Ze, at) {
    if (Rt(Ze, H) && (Ze = Ee.from(Ze, Ze.offset, Ze.byteLength)), Rt(at, H) && (at = Ee.from(at, at.offset, at.byteLength)), !Ee.isBuffer(Ze) || !Ee.isBuffer(at))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Ze === at) return 0;
    let dt = Ze.length, yt = at.length;
    for (let St = 0, xt = Math.min(dt, yt); St < xt; ++St)
      if (Ze[St] !== at[St]) {
        dt = Ze[St], yt = at[St];
        break;
      }
    return dt < yt ? -1 : yt < dt ? 1 : 0;
  }, Ee.isEncoding = function(Ze) {
    switch (String(Ze).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, Ee.concat = function(Ze, at) {
    if (!Array.isArray(Ze))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Ze.length === 0)
      return Ee.alloc(0);
    let dt;
    if (at === void 0)
      for (at = 0, dt = 0; dt < Ze.length; ++dt)
        at += Ze[dt].length;
    const yt = Ee.allocUnsafe(at);
    let St = 0;
    for (dt = 0; dt < Ze.length; ++dt) {
      let xt = Ze[dt];
      if (Rt(xt, H))
        St + xt.length > yt.length ? (Ee.isBuffer(xt) || (xt = Ee.from(xt)), xt.copy(yt, St)) : H.prototype.set.call(
          yt,
          xt,
          St
        );
      else if (Ee.isBuffer(xt))
        xt.copy(yt, St);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      St += xt.length;
    }
    return yt;
  };
  function vt(ct, Ze) {
    if (Ee.isBuffer(ct))
      return ct.length;
    if (De.isView(ct) || Rt(ct, De))
      return ct.byteLength;
    if (typeof ct != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof ct
      );
    const at = ct.length, dt = arguments.length > 2 && arguments[2] === !0;
    if (!dt && at === 0) return 0;
    let yt = !1;
    for (; ; )
      switch (Ze) {
        case "ascii":
        case "latin1":
        case "binary":
          return at;
        case "utf8":
        case "utf-8":
          return ni(ct).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return at * 2;
        case "hex":
          return at >>> 1;
        case "base64":
          return ii(ct).length;
        default:
          if (yt)
            return dt ? -1 : ni(ct).length;
          Ze = ("" + Ze).toLowerCase(), yt = !0;
      }
  }
  Ee.byteLength = vt;
  function Ye(ct, Ze, at) {
    let dt = !1;
    if ((Ze === void 0 || Ze < 0) && (Ze = 0), Ze > this.length || ((at === void 0 || at > this.length) && (at = this.length), at <= 0) || (at >>>= 0, Ze >>>= 0, at <= Ze))
      return "";
    for (ct || (ct = "utf8"); ; )
      switch (ct) {
        case "hex":
          return Ne(this, Ze, at);
        case "utf8":
        case "utf-8":
          return ge(this, Ze, at);
        case "ascii":
          return a(this, Ze, at);
        case "latin1":
        case "binary":
          return Y(this, Ze, at);
        case "base64":
          return ve(this, Ze, at);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ke(this, Ze, at);
        default:
          if (dt) throw new TypeError("Unknown encoding: " + ct);
          ct = (ct + "").toLowerCase(), dt = !0;
      }
  }
  Ee.prototype._isBuffer = !0;
  function pt(ct, Ze, at) {
    const dt = ct[Ze];
    ct[Ze] = ct[at], ct[at] = dt;
  }
  Ee.prototype.swap16 = function() {
    const Ze = this.length;
    if (Ze % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let at = 0; at < Ze; at += 2)
      pt(this, at, at + 1);
    return this;
  }, Ee.prototype.swap32 = function() {
    const Ze = this.length;
    if (Ze % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let at = 0; at < Ze; at += 4)
      pt(this, at, at + 3), pt(this, at + 1, at + 2);
    return this;
  }, Ee.prototype.swap64 = function() {
    const Ze = this.length;
    if (Ze % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let at = 0; at < Ze; at += 8)
      pt(this, at, at + 7), pt(this, at + 1, at + 6), pt(this, at + 2, at + 5), pt(this, at + 3, at + 4);
    return this;
  }, Ee.prototype.toString = function() {
    const Ze = this.length;
    return Ze === 0 ? "" : arguments.length === 0 ? ge(this, 0, Ze) : Ye.apply(this, arguments);
  }, Ee.prototype.toLocaleString = Ee.prototype.toString, Ee.prototype.equals = function(Ze) {
    if (!Ee.isBuffer(Ze)) throw new TypeError("Argument must be a Buffer");
    return this === Ze ? !0 : Ee.compare(this, Ze) === 0;
  }, Ee.prototype.inspect = function() {
    let Ze = "";
    const at = I.INSPECT_MAX_BYTES;
    return Ze = this.toString("hex", 0, at).replace(/(.{2})/g, "$1 ").trim(), this.length > at && (Ze += " ... "), "<Buffer " + Ze + ">";
  }, J && (Ee.prototype[J] = Ee.prototype.inspect), Ee.prototype.compare = function(Ze, at, dt, yt, St) {
    if (Rt(Ze, H) && (Ze = Ee.from(Ze, Ze.offset, Ze.byteLength)), !Ee.isBuffer(Ze))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Ze
      );
    if (at === void 0 && (at = 0), dt === void 0 && (dt = Ze ? Ze.length : 0), yt === void 0 && (yt = 0), St === void 0 && (St = this.length), at < 0 || dt > Ze.length || yt < 0 || St > this.length)
      throw new RangeError("out of range index");
    if (yt >= St && at >= dt)
      return 0;
    if (yt >= St)
      return -1;
    if (at >= dt)
      return 1;
    if (at >>>= 0, dt >>>= 0, yt >>>= 0, St >>>= 0, this === Ze) return 0;
    let xt = St - yt, Vt = dt - at;
    const ci = Math.min(xt, Vt), Qt = this.slice(yt, St), rr = Ze.slice(at, dt);
    for (let ui = 0; ui < ci; ++ui)
      if (Qt[ui] !== rr[ui]) {
        xt = Qt[ui], Vt = rr[ui];
        break;
      }
    return xt < Vt ? -1 : Vt < xt ? 1 : 0;
  };
  function bt(ct, Ze, at, dt, yt) {
    if (ct.length === 0) return -1;
    if (typeof at == "string" ? (dt = at, at = 0) : at > 2147483647 ? at = 2147483647 : at < -2147483648 && (at = -2147483648), at = +at, ai(at) && (at = yt ? 0 : ct.length - 1), at < 0 && (at = ct.length + at), at >= ct.length) {
      if (yt) return -1;
      at = ct.length - 1;
    } else if (at < 0)
      if (yt) at = 0;
      else return -1;
    if (typeof Ze == "string" && (Ze = Ee.from(Ze, dt)), Ee.isBuffer(Ze))
      return Ze.length === 0 ? -1 : Yt(ct, Ze, at, dt, yt);
    if (typeof Ze == "number")
      return Ze = Ze & 255, typeof H.prototype.indexOf == "function" ? yt ? H.prototype.indexOf.call(ct, Ze, at) : H.prototype.lastIndexOf.call(ct, Ze, at) : Yt(ct, [Ze], at, dt, yt);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Yt(ct, Ze, at, dt, yt) {
    let St = 1, xt = ct.length, Vt = Ze.length;
    if (dt !== void 0 && (dt = String(dt).toLowerCase(), dt === "ucs2" || dt === "ucs-2" || dt === "utf16le" || dt === "utf-16le")) {
      if (ct.length < 2 || Ze.length < 2)
        return -1;
      St = 2, xt /= 2, Vt /= 2, at /= 2;
    }
    function ci(rr, ui) {
      return St === 1 ? rr[ui] : rr.readUInt16BE(ui * St);
    }
    let Qt;
    if (yt) {
      let rr = -1;
      for (Qt = at; Qt < xt; Qt++)
        if (ci(ct, Qt) === ci(Ze, rr === -1 ? 0 : Qt - rr)) {
          if (rr === -1 && (rr = Qt), Qt - rr + 1 === Vt) return rr * St;
        } else
          rr !== -1 && (Qt -= Qt - rr), rr = -1;
    } else
      for (at + Vt > xt && (at = xt - Vt), Qt = at; Qt >= 0; Qt--) {
        let rr = !0;
        for (let ui = 0; ui < Vt; ui++)
          if (ci(ct, Qt + ui) !== ci(Ze, ui)) {
            rr = !1;
            break;
          }
        if (rr) return Qt;
      }
    return -1;
  }
  Ee.prototype.includes = function(Ze, at, dt) {
    return this.indexOf(Ze, at, dt) !== -1;
  }, Ee.prototype.indexOf = function(Ze, at, dt) {
    return bt(this, Ze, at, dt, !0);
  }, Ee.prototype.lastIndexOf = function(Ze, at, dt) {
    return bt(this, Ze, at, dt, !1);
  };
  function Se(ct, Ze, at, dt) {
    at = Number(at) || 0;
    const yt = ct.length - at;
    dt ? (dt = Number(dt), dt > yt && (dt = yt)) : dt = yt;
    const St = Ze.length;
    dt > St / 2 && (dt = St / 2);
    let xt;
    for (xt = 0; xt < dt; ++xt) {
      const Vt = parseInt(Ze.substr(xt * 2, 2), 16);
      if (ai(Vt)) return xt;
      ct[at + xt] = Vt;
    }
    return xt;
  }
  function t(ct, Ze, at, dt) {
    return Pt(ni(Ze, ct.length - at), ct, at, dt);
  }
  function h(ct, Ze, at, dt) {
    return Pt(Ct(Ze), ct, at, dt);
  }
  function B(ct, Ze, at, dt) {
    return Pt(ii(Ze), ct, at, dt);
  }
  function Z(ct, Ze, at, dt) {
    return Pt(Wt(Ze, ct.length - at), ct, at, dt);
  }
  Ee.prototype.write = function(Ze, at, dt, yt) {
    if (at === void 0)
      yt = "utf8", dt = this.length, at = 0;
    else if (dt === void 0 && typeof at == "string")
      yt = at, dt = this.length, at = 0;
    else if (isFinite(at))
      at = at >>> 0, isFinite(dt) ? (dt = dt >>> 0, yt === void 0 && (yt = "utf8")) : (yt = dt, dt = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const St = this.length - at;
    if ((dt === void 0 || dt > St) && (dt = St), Ze.length > 0 && (dt < 0 || at < 0) || at > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    yt || (yt = "utf8");
    let xt = !1;
    for (; ; )
      switch (yt) {
        case "hex":
          return Se(this, Ze, at, dt);
        case "utf8":
        case "utf-8":
          return t(this, Ze, at, dt);
        case "ascii":
        case "latin1":
        case "binary":
          return h(this, Ze, at, dt);
        case "base64":
          return B(this, Ze, at, dt);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Z(this, Ze, at, dt);
        default:
          if (xt) throw new TypeError("Unknown encoding: " + yt);
          yt = ("" + yt).toLowerCase(), xt = !0;
      }
  }, Ee.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ve(ct, Ze, at) {
    return Ze === 0 && at === ct.length ? A.fromByteArray(ct) : A.fromByteArray(ct.slice(Ze, at));
  }
  function ge(ct, Ze, at) {
    at = Math.min(ct.length, at);
    const dt = [];
    let yt = Ze;
    for (; yt < at; ) {
      const St = ct[yt];
      let xt = null, Vt = St > 239 ? 4 : St > 223 ? 3 : St > 191 ? 2 : 1;
      if (yt + Vt <= at) {
        let ci, Qt, rr, ui;
        switch (Vt) {
          case 1:
            St < 128 && (xt = St);
            break;
          case 2:
            ci = ct[yt + 1], (ci & 192) === 128 && (ui = (St & 31) << 6 | ci & 63, ui > 127 && (xt = ui));
            break;
          case 3:
            ci = ct[yt + 1], Qt = ct[yt + 2], (ci & 192) === 128 && (Qt & 192) === 128 && (ui = (St & 15) << 12 | (ci & 63) << 6 | Qt & 63, ui > 2047 && (ui < 55296 || ui > 57343) && (xt = ui));
            break;
          case 4:
            ci = ct[yt + 1], Qt = ct[yt + 2], rr = ct[yt + 3], (ci & 192) === 128 && (Qt & 192) === 128 && (rr & 192) === 128 && (ui = (St & 15) << 18 | (ci & 63) << 12 | (Qt & 63) << 6 | rr & 63, ui > 65535 && ui < 1114112 && (xt = ui));
        }
      }
      xt === null ? (xt = 65533, Vt = 1) : xt > 65535 && (xt -= 65536, dt.push(xt >>> 10 & 1023 | 55296), xt = 56320 | xt & 1023), dt.push(xt), yt += Vt;
    }
    return X(dt);
  }
  const xe = 4096;
  function X(ct) {
    const Ze = ct.length;
    if (Ze <= xe)
      return String.fromCharCode.apply(String, ct);
    let at = "", dt = 0;
    for (; dt < Ze; )
      at += String.fromCharCode.apply(
        String,
        ct.slice(dt, dt += xe)
      );
    return at;
  }
  function a(ct, Ze, at) {
    let dt = "";
    at = Math.min(ct.length, at);
    for (let yt = Ze; yt < at; ++yt)
      dt += String.fromCharCode(ct[yt] & 127);
    return dt;
  }
  function Y(ct, Ze, at) {
    let dt = "";
    at = Math.min(ct.length, at);
    for (let yt = Ze; yt < at; ++yt)
      dt += String.fromCharCode(ct[yt]);
    return dt;
  }
  function Ne(ct, Ze, at) {
    const dt = ct.length;
    (!Ze || Ze < 0) && (Ze = 0), (!at || at < 0 || at > dt) && (at = dt);
    let yt = "";
    for (let St = Ze; St < at; ++St)
      yt += Nt[ct[St]];
    return yt;
  }
  function Ke(ct, Ze, at) {
    const dt = ct.slice(Ze, at);
    let yt = "";
    for (let St = 0; St < dt.length - 1; St += 2)
      yt += String.fromCharCode(dt[St] + dt[St + 1] * 256);
    return yt;
  }
  Ee.prototype.slice = function(Ze, at) {
    const dt = this.length;
    Ze = ~~Ze, at = at === void 0 ? dt : ~~at, Ze < 0 ? (Ze += dt, Ze < 0 && (Ze = 0)) : Ze > dt && (Ze = dt), at < 0 ? (at += dt, at < 0 && (at = 0)) : at > dt && (at = dt), at < Ze && (at = Ze);
    const yt = this.subarray(Ze, at);
    return Object.setPrototypeOf(yt, Ee.prototype), yt;
  };
  function tt(ct, Ze, at) {
    if (ct % 1 !== 0 || ct < 0) throw new RangeError("offset is not uint");
    if (ct + Ze > at) throw new RangeError("Trying to access beyond buffer length");
  }
  Ee.prototype.readUintLE = Ee.prototype.readUIntLE = function(Ze, at, dt) {
    Ze = Ze >>> 0, at = at >>> 0, dt || tt(Ze, at, this.length);
    let yt = this[Ze], St = 1, xt = 0;
    for (; ++xt < at && (St *= 256); )
      yt += this[Ze + xt] * St;
    return yt;
  }, Ee.prototype.readUintBE = Ee.prototype.readUIntBE = function(Ze, at, dt) {
    Ze = Ze >>> 0, at = at >>> 0, dt || tt(Ze, at, this.length);
    let yt = this[Ze + --at], St = 1;
    for (; at > 0 && (St *= 256); )
      yt += this[Ze + --at] * St;
    return yt;
  }, Ee.prototype.readUint8 = Ee.prototype.readUInt8 = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 1, this.length), this[Ze];
  }, Ee.prototype.readUint16LE = Ee.prototype.readUInt16LE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 2, this.length), this[Ze] | this[Ze + 1] << 8;
  }, Ee.prototype.readUint16BE = Ee.prototype.readUInt16BE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 2, this.length), this[Ze] << 8 | this[Ze + 1];
  }, Ee.prototype.readUint32LE = Ee.prototype.readUInt32LE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 4, this.length), (this[Ze] | this[Ze + 1] << 8 | this[Ze + 2] << 16) + this[Ze + 3] * 16777216;
  }, Ee.prototype.readUint32BE = Ee.prototype.readUInt32BE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 4, this.length), this[Ze] * 16777216 + (this[Ze + 1] << 16 | this[Ze + 2] << 8 | this[Ze + 3]);
  }, Ee.prototype.readBigUInt64LE = qt(function(Ze) {
    Ze = Ze >>> 0, Et(Ze, "offset");
    const at = this[Ze], dt = this[Ze + 7];
    (at === void 0 || dt === void 0) && ei(Ze, this.length - 8);
    const yt = at + this[++Ze] * 2 ** 8 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 24, St = this[++Ze] + this[++Ze] * 2 ** 8 + this[++Ze] * 2 ** 16 + dt * 2 ** 24;
    return BigInt(yt) + (BigInt(St) << BigInt(32));
  }), Ee.prototype.readBigUInt64BE = qt(function(Ze) {
    Ze = Ze >>> 0, Et(Ze, "offset");
    const at = this[Ze], dt = this[Ze + 7];
    (at === void 0 || dt === void 0) && ei(Ze, this.length - 8);
    const yt = at * 2 ** 24 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 8 + this[++Ze], St = this[++Ze] * 2 ** 24 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 8 + dt;
    return (BigInt(yt) << BigInt(32)) + BigInt(St);
  }), Ee.prototype.readIntLE = function(Ze, at, dt) {
    Ze = Ze >>> 0, at = at >>> 0, dt || tt(Ze, at, this.length);
    let yt = this[Ze], St = 1, xt = 0;
    for (; ++xt < at && (St *= 256); )
      yt += this[Ze + xt] * St;
    return St *= 128, yt >= St && (yt -= Math.pow(2, 8 * at)), yt;
  }, Ee.prototype.readIntBE = function(Ze, at, dt) {
    Ze = Ze >>> 0, at = at >>> 0, dt || tt(Ze, at, this.length);
    let yt = at, St = 1, xt = this[Ze + --yt];
    for (; yt > 0 && (St *= 256); )
      xt += this[Ze + --yt] * St;
    return St *= 128, xt >= St && (xt -= Math.pow(2, 8 * at)), xt;
  }, Ee.prototype.readInt8 = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 1, this.length), this[Ze] & 128 ? (255 - this[Ze] + 1) * -1 : this[Ze];
  }, Ee.prototype.readInt16LE = function(Ze, at) {
    Ze = Ze >>> 0, at || tt(Ze, 2, this.length);
    const dt = this[Ze] | this[Ze + 1] << 8;
    return dt & 32768 ? dt | 4294901760 : dt;
  }, Ee.prototype.readInt16BE = function(Ze, at) {
    Ze = Ze >>> 0, at || tt(Ze, 2, this.length);
    const dt = this[Ze + 1] | this[Ze] << 8;
    return dt & 32768 ? dt | 4294901760 : dt;
  }, Ee.prototype.readInt32LE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 4, this.length), this[Ze] | this[Ze + 1] << 8 | this[Ze + 2] << 16 | this[Ze + 3] << 24;
  }, Ee.prototype.readInt32BE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 4, this.length), this[Ze] << 24 | this[Ze + 1] << 16 | this[Ze + 2] << 8 | this[Ze + 3];
  }, Ee.prototype.readBigInt64LE = qt(function(Ze) {
    Ze = Ze >>> 0, Et(Ze, "offset");
    const at = this[Ze], dt = this[Ze + 7];
    (at === void 0 || dt === void 0) && ei(Ze, this.length - 8);
    const yt = this[Ze + 4] + this[Ze + 5] * 2 ** 8 + this[Ze + 6] * 2 ** 16 + (dt << 24);
    return (BigInt(yt) << BigInt(32)) + BigInt(at + this[++Ze] * 2 ** 8 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 24);
  }), Ee.prototype.readBigInt64BE = qt(function(Ze) {
    Ze = Ze >>> 0, Et(Ze, "offset");
    const at = this[Ze], dt = this[Ze + 7];
    (at === void 0 || dt === void 0) && ei(Ze, this.length - 8);
    const yt = (at << 24) + // Overflow
    this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 8 + this[++Ze];
    return (BigInt(yt) << BigInt(32)) + BigInt(this[++Ze] * 2 ** 24 + this[++Ze] * 2 ** 16 + this[++Ze] * 2 ** 8 + dt);
  }), Ee.prototype.readFloatLE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 4, this.length), G.read(this, Ze, !0, 23, 4);
  }, Ee.prototype.readFloatBE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 4, this.length), G.read(this, Ze, !1, 23, 4);
  }, Ee.prototype.readDoubleLE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 8, this.length), G.read(this, Ze, !0, 52, 8);
  }, Ee.prototype.readDoubleBE = function(Ze, at) {
    return Ze = Ze >>> 0, at || tt(Ze, 8, this.length), G.read(this, Ze, !1, 52, 8);
  };
  function We(ct, Ze, at, dt, yt, St) {
    if (!Ee.isBuffer(ct)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Ze > yt || Ze < St) throw new RangeError('"value" argument is out of bounds');
    if (at + dt > ct.length) throw new RangeError("Index out of range");
  }
  Ee.prototype.writeUintLE = Ee.prototype.writeUIntLE = function(Ze, at, dt, yt) {
    if (Ze = +Ze, at = at >>> 0, dt = dt >>> 0, !yt) {
      const Vt = Math.pow(2, 8 * dt) - 1;
      We(this, Ze, at, dt, Vt, 0);
    }
    let St = 1, xt = 0;
    for (this[at] = Ze & 255; ++xt < dt && (St *= 256); )
      this[at + xt] = Ze / St & 255;
    return at + dt;
  }, Ee.prototype.writeUintBE = Ee.prototype.writeUIntBE = function(Ze, at, dt, yt) {
    if (Ze = +Ze, at = at >>> 0, dt = dt >>> 0, !yt) {
      const Vt = Math.pow(2, 8 * dt) - 1;
      We(this, Ze, at, dt, Vt, 0);
    }
    let St = dt - 1, xt = 1;
    for (this[at + St] = Ze & 255; --St >= 0 && (xt *= 256); )
      this[at + St] = Ze / xt & 255;
    return at + dt;
  }, Ee.prototype.writeUint8 = Ee.prototype.writeUInt8 = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 1, 255, 0), this[at] = Ze & 255, at + 1;
  }, Ee.prototype.writeUint16LE = Ee.prototype.writeUInt16LE = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 2, 65535, 0), this[at] = Ze & 255, this[at + 1] = Ze >>> 8, at + 2;
  }, Ee.prototype.writeUint16BE = Ee.prototype.writeUInt16BE = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 2, 65535, 0), this[at] = Ze >>> 8, this[at + 1] = Ze & 255, at + 2;
  }, Ee.prototype.writeUint32LE = Ee.prototype.writeUInt32LE = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 4, 4294967295, 0), this[at + 3] = Ze >>> 24, this[at + 2] = Ze >>> 16, this[at + 1] = Ze >>> 8, this[at] = Ze & 255, at + 4;
  }, Ee.prototype.writeUint32BE = Ee.prototype.writeUInt32BE = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 4, 4294967295, 0), this[at] = Ze >>> 24, this[at + 1] = Ze >>> 16, this[at + 2] = Ze >>> 8, this[at + 3] = Ze & 255, at + 4;
  };
  function ot(ct, Ze, at, dt, yt) {
    At(Ze, dt, yt, ct, at, 7);
    let St = Number(Ze & BigInt(4294967295));
    ct[at++] = St, St = St >> 8, ct[at++] = St, St = St >> 8, ct[at++] = St, St = St >> 8, ct[at++] = St;
    let xt = Number(Ze >> BigInt(32) & BigInt(4294967295));
    return ct[at++] = xt, xt = xt >> 8, ct[at++] = xt, xt = xt >> 8, ct[at++] = xt, xt = xt >> 8, ct[at++] = xt, at;
  }
  function He(ct, Ze, at, dt, yt) {
    At(Ze, dt, yt, ct, at, 7);
    let St = Number(Ze & BigInt(4294967295));
    ct[at + 7] = St, St = St >> 8, ct[at + 6] = St, St = St >> 8, ct[at + 5] = St, St = St >> 8, ct[at + 4] = St;
    let xt = Number(Ze >> BigInt(32) & BigInt(4294967295));
    return ct[at + 3] = xt, xt = xt >> 8, ct[at + 2] = xt, xt = xt >> 8, ct[at + 1] = xt, xt = xt >> 8, ct[at] = xt, at + 8;
  }
  Ee.prototype.writeBigUInt64LE = qt(function(Ze, at = 0) {
    return ot(this, Ze, at, BigInt(0), BigInt("0xffffffffffffffff"));
  }), Ee.prototype.writeBigUInt64BE = qt(function(Ze, at = 0) {
    return He(this, Ze, at, BigInt(0), BigInt("0xffffffffffffffff"));
  }), Ee.prototype.writeIntLE = function(Ze, at, dt, yt) {
    if (Ze = +Ze, at = at >>> 0, !yt) {
      const ci = Math.pow(2, 8 * dt - 1);
      We(this, Ze, at, dt, ci - 1, -ci);
    }
    let St = 0, xt = 1, Vt = 0;
    for (this[at] = Ze & 255; ++St < dt && (xt *= 256); )
      Ze < 0 && Vt === 0 && this[at + St - 1] !== 0 && (Vt = 1), this[at + St] = (Ze / xt >> 0) - Vt & 255;
    return at + dt;
  }, Ee.prototype.writeIntBE = function(Ze, at, dt, yt) {
    if (Ze = +Ze, at = at >>> 0, !yt) {
      const ci = Math.pow(2, 8 * dt - 1);
      We(this, Ze, at, dt, ci - 1, -ci);
    }
    let St = dt - 1, xt = 1, Vt = 0;
    for (this[at + St] = Ze & 255; --St >= 0 && (xt *= 256); )
      Ze < 0 && Vt === 0 && this[at + St + 1] !== 0 && (Vt = 1), this[at + St] = (Ze / xt >> 0) - Vt & 255;
    return at + dt;
  }, Ee.prototype.writeInt8 = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 1, 127, -128), Ze < 0 && (Ze = 255 + Ze + 1), this[at] = Ze & 255, at + 1;
  }, Ee.prototype.writeInt16LE = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 2, 32767, -32768), this[at] = Ze & 255, this[at + 1] = Ze >>> 8, at + 2;
  }, Ee.prototype.writeInt16BE = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 2, 32767, -32768), this[at] = Ze >>> 8, this[at + 1] = Ze & 255, at + 2;
  }, Ee.prototype.writeInt32LE = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 4, 2147483647, -2147483648), this[at] = Ze & 255, this[at + 1] = Ze >>> 8, this[at + 2] = Ze >>> 16, this[at + 3] = Ze >>> 24, at + 4;
  }, Ee.prototype.writeInt32BE = function(Ze, at, dt) {
    return Ze = +Ze, at = at >>> 0, dt || We(this, Ze, at, 4, 2147483647, -2147483648), Ze < 0 && (Ze = 4294967295 + Ze + 1), this[at] = Ze >>> 24, this[at + 1] = Ze >>> 16, this[at + 2] = Ze >>> 8, this[at + 3] = Ze & 255, at + 4;
  }, Ee.prototype.writeBigInt64LE = qt(function(Ze, at = 0) {
    return ot(this, Ze, at, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), Ee.prototype.writeBigInt64BE = qt(function(Ze, at = 0) {
    return He(this, Ze, at, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Qe(ct, Ze, at, dt, yt, St) {
    if (at + dt > ct.length) throw new RangeError("Index out of range");
    if (at < 0) throw new RangeError("Index out of range");
  }
  function nt(ct, Ze, at, dt, yt) {
    return Ze = +Ze, at = at >>> 0, yt || Qe(ct, Ze, at, 4), G.write(ct, Ze, at, dt, 23, 4), at + 4;
  }
  Ee.prototype.writeFloatLE = function(Ze, at, dt) {
    return nt(this, Ze, at, !0, dt);
  }, Ee.prototype.writeFloatBE = function(Ze, at, dt) {
    return nt(this, Ze, at, !1, dt);
  };
  function je(ct, Ze, at, dt, yt) {
    return Ze = +Ze, at = at >>> 0, yt || Qe(ct, Ze, at, 8), G.write(ct, Ze, at, dt, 52, 8), at + 8;
  }
  Ee.prototype.writeDoubleLE = function(Ze, at, dt) {
    return je(this, Ze, at, !0, dt);
  }, Ee.prototype.writeDoubleBE = function(Ze, at, dt) {
    return je(this, Ze, at, !1, dt);
  }, Ee.prototype.copy = function(Ze, at, dt, yt) {
    if (!Ee.isBuffer(Ze)) throw new TypeError("argument should be a Buffer");
    if (dt || (dt = 0), !yt && yt !== 0 && (yt = this.length), at >= Ze.length && (at = Ze.length), at || (at = 0), yt > 0 && yt < dt && (yt = dt), yt === dt || Ze.length === 0 || this.length === 0) return 0;
    if (at < 0)
      throw new RangeError("targetStart out of bounds");
    if (dt < 0 || dt >= this.length) throw new RangeError("Index out of range");
    if (yt < 0) throw new RangeError("sourceEnd out of bounds");
    yt > this.length && (yt = this.length), Ze.length - at < yt - dt && (yt = Ze.length - at + dt);
    const St = yt - dt;
    return this === Ze && typeof H.prototype.copyWithin == "function" ? this.copyWithin(at, dt, yt) : H.prototype.set.call(
      Ze,
      this.subarray(dt, yt),
      at
    ), St;
  }, Ee.prototype.fill = function(Ze, at, dt, yt) {
    if (typeof Ze == "string") {
      if (typeof at == "string" ? (yt = at, at = 0, dt = this.length) : typeof dt == "string" && (yt = dt, dt = this.length), yt !== void 0 && typeof yt != "string")
        throw new TypeError("encoding must be a string");
      if (typeof yt == "string" && !Ee.isEncoding(yt))
        throw new TypeError("Unknown encoding: " + yt);
      if (Ze.length === 1) {
        const xt = Ze.charCodeAt(0);
        (yt === "utf8" && xt < 128 || yt === "latin1") && (Ze = xt);
      }
    } else typeof Ze == "number" ? Ze = Ze & 255 : typeof Ze == "boolean" && (Ze = Number(Ze));
    if (at < 0 || this.length < at || this.length < dt)
      throw new RangeError("Out of range index");
    if (dt <= at)
      return this;
    at = at >>> 0, dt = dt === void 0 ? this.length : dt >>> 0, Ze || (Ze = 0);
    let St;
    if (typeof Ze == "number")
      for (St = at; St < dt; ++St)
        this[St] = Ze;
    else {
      const xt = Ee.isBuffer(Ze) ? Ze : Ee.from(Ze, yt), Vt = xt.length;
      if (Vt === 0)
        throw new TypeError('The value "' + Ze + '" is invalid for argument "value"');
      for (St = 0; St < dt - at; ++St)
        this[St + at] = xt[St % Vt];
    }
    return this;
  };
  const it = {};
  function st(ct, Ze, at) {
    it[ct] = class extends at {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Ze.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${ct}]`, this.stack, delete this.name;
      }
      get code() {
        return ct;
      }
      set code(yt) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: yt,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${ct}]: ${this.message}`;
      }
    };
  }
  st(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(ct) {
      return ct ? `${ct} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), st(
    "ERR_INVALID_ARG_TYPE",
    function(ct, Ze) {
      return `The "${ct}" argument must be of type number. Received type ${typeof Ze}`;
    },
    TypeError
  ), st(
    "ERR_OUT_OF_RANGE",
    function(ct, Ze, at) {
      let dt = `The value of "${ct}" is out of range.`, yt = at;
      return Number.isInteger(at) && Math.abs(at) > 2 ** 32 ? yt = gt(String(at)) : typeof at == "bigint" && (yt = String(at), (at > BigInt(2) ** BigInt(32) || at < -(BigInt(2) ** BigInt(32))) && (yt = gt(yt)), yt += "n"), dt += ` It must be ${Ze}. Received ${yt}`, dt;
    },
    RangeError
  );
  function gt(ct) {
    let Ze = "", at = ct.length;
    const dt = ct[0] === "-" ? 1 : 0;
    for (; at >= dt + 4; at -= 3)
      Ze = `_${ct.slice(at - 3, at)}${Ze}`;
    return `${ct.slice(0, at)}${Ze}`;
  }
  function It(ct, Ze, at) {
    Et(Ze, "offset"), (ct[Ze] === void 0 || ct[Ze + at] === void 0) && ei(Ze, ct.length - (at + 1));
  }
  function At(ct, Ze, at, dt, yt, St) {
    if (ct > at || ct < Ze) {
      const xt = typeof Ze == "bigint" ? "n" : "";
      let Vt;
      throw Ze === 0 || Ze === BigInt(0) ? Vt = `>= 0${xt} and < 2${xt} ** ${(St + 1) * 8}${xt}` : Vt = `>= -(2${xt} ** ${(St + 1) * 8 - 1}${xt}) and < 2 ** ${(St + 1) * 8 - 1}${xt}`, new it.ERR_OUT_OF_RANGE("value", Vt, ct);
    }
    It(dt, yt, St);
  }
  function Et(ct, Ze) {
    if (typeof ct != "number")
      throw new it.ERR_INVALID_ARG_TYPE(Ze, "number", ct);
  }
  function ei(ct, Ze, at) {
    throw Math.floor(ct) !== ct ? (Et(ct, at), new it.ERR_OUT_OF_RANGE("offset", "an integer", ct)) : Ze < 0 ? new it.ERR_BUFFER_OUT_OF_BOUNDS() : new it.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${Ze}`,
      ct
    );
  }
  const Xt = /[^+/0-9A-Za-z-_]/g;
  function _t(ct) {
    if (ct = ct.split("=")[0], ct = ct.trim().replace(Xt, ""), ct.length < 2) return "";
    for (; ct.length % 4 !== 0; )
      ct = ct + "=";
    return ct;
  }
  function ni(ct, Ze) {
    Ze = Ze || 1 / 0;
    let at;
    const dt = ct.length;
    let yt = null;
    const St = [];
    for (let xt = 0; xt < dt; ++xt) {
      if (at = ct.charCodeAt(xt), at > 55295 && at < 57344) {
        if (!yt) {
          if (at > 56319) {
            (Ze -= 3) > -1 && St.push(239, 191, 189);
            continue;
          } else if (xt + 1 === dt) {
            (Ze -= 3) > -1 && St.push(239, 191, 189);
            continue;
          }
          yt = at;
          continue;
        }
        if (at < 56320) {
          (Ze -= 3) > -1 && St.push(239, 191, 189), yt = at;
          continue;
        }
        at = (yt - 55296 << 10 | at - 56320) + 65536;
      } else yt && (Ze -= 3) > -1 && St.push(239, 191, 189);
      if (yt = null, at < 128) {
        if ((Ze -= 1) < 0) break;
        St.push(at);
      } else if (at < 2048) {
        if ((Ze -= 2) < 0) break;
        St.push(
          at >> 6 | 192,
          at & 63 | 128
        );
      } else if (at < 65536) {
        if ((Ze -= 3) < 0) break;
        St.push(
          at >> 12 | 224,
          at >> 6 & 63 | 128,
          at & 63 | 128
        );
      } else if (at < 1114112) {
        if ((Ze -= 4) < 0) break;
        St.push(
          at >> 18 | 240,
          at >> 12 & 63 | 128,
          at >> 6 & 63 | 128,
          at & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return St;
  }
  function Ct(ct) {
    const Ze = [];
    for (let at = 0; at < ct.length; ++at)
      Ze.push(ct.charCodeAt(at) & 255);
    return Ze;
  }
  function Wt(ct, Ze) {
    let at, dt, yt;
    const St = [];
    for (let xt = 0; xt < ct.length && !((Ze -= 2) < 0); ++xt)
      at = ct.charCodeAt(xt), dt = at >> 8, yt = at % 256, St.push(yt), St.push(dt);
    return St;
  }
  function ii(ct) {
    return A.toByteArray(_t(ct));
  }
  function Pt(ct, Ze, at, dt) {
    let yt;
    for (yt = 0; yt < dt && !(yt + at >= Ze.length || yt >= ct.length); ++yt)
      Ze[yt + at] = ct[yt];
    return yt;
  }
  function Rt(ct, Ze) {
    return ct instanceof Ze || ct != null && ct.constructor != null && ct.constructor.name != null && ct.constructor.name === Ze.name;
  }
  function ai(ct) {
    return ct !== ct;
  }
  const Nt = function() {
    const ct = "0123456789abcdef", Ze = new Array(256);
    for (let at = 0; at < 16; ++at) {
      const dt = at * 16;
      for (let yt = 0; yt < 16; ++yt)
        Ze[dt + yt] = ct[at] + ct[yt];
    }
    return Ze;
  }();
  function qt(ct) {
    return typeof BigInt > "u" ? oi : ct;
  }
  function oi() {
    throw new Error("BigInt not supported");
  }
})(buffer$1);
const Buffer$7 = buffer$1.Buffer, Blob$1 = buffer$1.Blob, BlobOptions = buffer$1.BlobOptions, Buffer$1$1 = buffer$1.Buffer, File = buffer$1.File, FileOptions = buffer$1.FileOptions, INSPECT_MAX_BYTES = buffer$1.INSPECT_MAX_BYTES, SlowBuffer = buffer$1.SlowBuffer, TranscodeEncoding = buffer$1.TranscodeEncoding, atob$1 = buffer$1.atob, btoa = buffer$1.btoa, constants$2 = buffer$1.constants, isAscii = buffer$1.isAscii, isUtf8 = buffer$1.isUtf8, kMaxLength = buffer$1.kMaxLength, kStringMaxLength = buffer$1.kStringMaxLength, resolveObjectURL = buffer$1.resolveObjectURL, transcode = buffer$1.transcode, dist = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: Blob$1,
  BlobOptions,
  Buffer: Buffer$1$1,
  File,
  FileOptions,
  INSPECT_MAX_BYTES,
  SlowBuffer,
  TranscodeEncoding,
  atob: atob$1,
  btoa,
  constants: constants$2,
  default: Buffer$7,
  isAscii,
  isUtf8,
  kMaxLength,
  kStringMaxLength,
  resolveObjectURL,
  transcode
}, Symbol.toStringTag, { value: "Module" }));
var bn$7 = { exports: {} };
const require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(dist);
bn$7.exports;
(function(I) {
  (function(A, G) {
    function J(h, B) {
      if (!h) throw new Error(B || "Assertion failed");
    }
    function _e(h, B) {
      h.super_ = B;
      var Z = function() {
      };
      Z.prototype = B.prototype, h.prototype = new Z(), h.prototype.constructor = h;
    }
    function H(h, B, Z) {
      if (H.isBN(h))
        return h;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, h !== null && ((B === "le" || B === "be") && (Z = B, B = 10), this._init(h || 0, B || 10, Z || "be"));
    }
    typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
    var De;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = require$$0$3.Buffer;
    } catch {
    }
    H.isBN = function(B) {
      return B instanceof H ? !0 : B !== null && typeof B == "object" && B.constructor.wordSize === H.wordSize && Array.isArray(B.words);
    }, H.max = function(B, Z) {
      return B.cmp(Z) > 0 ? B : Z;
    }, H.min = function(B, Z) {
      return B.cmp(Z) < 0 ? B : Z;
    }, H.prototype._init = function(B, Z, ve) {
      if (typeof B == "number")
        return this._initNumber(B, Z, ve);
      if (typeof B == "object")
        return this._initArray(B, Z, ve);
      Z === "hex" && (Z = 16), J(Z === (Z | 0) && Z >= 2 && Z <= 36), B = B.toString().replace(/\s+/g, "");
      var ge = 0;
      B[0] === "-" && (ge++, this.negative = 1), ge < B.length && (Z === 16 ? this._parseHex(B, ge, ve) : (this._parseBase(B, Z, ge), ve === "le" && this._initArray(this.toArray(), Z, ve)));
    }, H.prototype._initNumber = function(B, Z, ve) {
      B < 0 && (this.negative = 1, B = -B), B < 67108864 ? (this.words = [B & 67108863], this.length = 1) : B < 4503599627370496 ? (this.words = [
        B & 67108863,
        B / 67108864 & 67108863
      ], this.length = 2) : (J(B < 9007199254740992), this.words = [
        B & 67108863,
        B / 67108864 & 67108863,
        1
      ], this.length = 3), ve === "le" && this._initArray(this.toArray(), Z, ve);
    }, H.prototype._initArray = function(B, Z, ve) {
      if (J(typeof B.length == "number"), B.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(B.length / 3), this.words = new Array(this.length);
      for (var ge = 0; ge < this.length; ge++)
        this.words[ge] = 0;
      var xe, X, a = 0;
      if (ve === "be")
        for (ge = B.length - 1, xe = 0; ge >= 0; ge -= 3)
          X = B[ge] | B[ge - 1] << 8 | B[ge - 2] << 16, this.words[xe] |= X << a & 67108863, this.words[xe + 1] = X >>> 26 - a & 67108863, a += 24, a >= 26 && (a -= 26, xe++);
      else if (ve === "le")
        for (ge = 0, xe = 0; ge < B.length; ge += 3)
          X = B[ge] | B[ge + 1] << 8 | B[ge + 2] << 16, this.words[xe] |= X << a & 67108863, this.words[xe + 1] = X >>> 26 - a & 67108863, a += 24, a >= 26 && (a -= 26, xe++);
      return this._strip();
    };
    function Ie(h, B) {
      var Z = h.charCodeAt(B);
      if (Z >= 48 && Z <= 57)
        return Z - 48;
      if (Z >= 65 && Z <= 70)
        return Z - 55;
      if (Z >= 97 && Z <= 102)
        return Z - 87;
      J(!1, "Invalid character in " + h);
    }
    function qe(h, B, Z) {
      var ve = Ie(h, Z);
      return Z - 1 >= B && (ve |= Ie(h, Z - 1) << 4), ve;
    }
    H.prototype._parseHex = function(B, Z, ve) {
      this.length = Math.ceil((B.length - Z) / 6), this.words = new Array(this.length);
      for (var ge = 0; ge < this.length; ge++)
        this.words[ge] = 0;
      var xe = 0, X = 0, a;
      if (ve === "be")
        for (ge = B.length - 1; ge >= Z; ge -= 2)
          a = qe(B, Z, ge) << xe, this.words[X] |= a & 67108863, xe >= 18 ? (xe -= 18, X += 1, this.words[X] |= a >>> 26) : xe += 8;
      else {
        var Y = B.length - Z;
        for (ge = Y % 2 === 0 ? Z + 1 : Z; ge < B.length; ge += 2)
          a = qe(B, Z, ge) << xe, this.words[X] |= a & 67108863, xe >= 18 ? (xe -= 18, X += 1, this.words[X] |= a >>> 26) : xe += 8;
      }
      this._strip();
    };
    function Te(h, B, Z, ve) {
      for (var ge = 0, xe = 0, X = Math.min(h.length, Z), a = B; a < X; a++) {
        var Y = h.charCodeAt(a) - 48;
        ge *= ve, Y >= 49 ? xe = Y - 49 + 10 : Y >= 17 ? xe = Y - 17 + 10 : xe = Y, J(Y >= 0 && xe < ve, "Invalid character"), ge += xe;
      }
      return ge;
    }
    H.prototype._parseBase = function(B, Z, ve) {
      this.words = [0], this.length = 1;
      for (var ge = 0, xe = 1; xe <= 67108863; xe *= Z)
        ge++;
      ge--, xe = xe / Z | 0;
      for (var X = B.length - ve, a = X % ge, Y = Math.min(X, X - a) + ve, Ne = 0, Ke = ve; Ke < Y; Ke += ge)
        Ne = Te(B, Ke, Ke + ge, Z), this.imuln(xe), this.words[0] + Ne < 67108864 ? this.words[0] += Ne : this._iaddn(Ne);
      if (a !== 0) {
        var tt = 1;
        for (Ne = Te(B, Ke, B.length, Z), Ke = 0; Ke < a; Ke++)
          tt *= Z;
        this.imuln(tt), this.words[0] + Ne < 67108864 ? this.words[0] += Ne : this._iaddn(Ne);
      }
      this._strip();
    }, H.prototype.copy = function(B) {
      B.words = new Array(this.length);
      for (var Z = 0; Z < this.length; Z++)
        B.words[Z] = this.words[Z];
      B.length = this.length, B.negative = this.negative, B.red = this.red;
    };
    function Ee(h, B) {
      h.words = B.words, h.length = B.length, h.negative = B.negative, h.red = B.red;
    }
    if (H.prototype._move = function(B) {
      Ee(B, this);
    }, H.prototype.clone = function() {
      var B = new H(null);
      return this.copy(B), B;
    }, H.prototype._expand = function(B) {
      for (; this.length < B; )
        this.words[this.length++] = 0;
      return this;
    }, H.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, H.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        H.prototype[Symbol.for("nodejs.util.inspect.custom")] = Oe;
      } catch {
        H.prototype.inspect = Oe;
      }
    else
      H.prototype.inspect = Oe;
    function Oe() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var Le = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], ke = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Fe = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    H.prototype.toString = function(B, Z) {
      B = B || 10, Z = Z | 0 || 1;
      var ve;
      if (B === 16 || B === "hex") {
        ve = "";
        for (var ge = 0, xe = 0, X = 0; X < this.length; X++) {
          var a = this.words[X], Y = ((a << ge | xe) & 16777215).toString(16);
          xe = a >>> 24 - ge & 16777215, ge += 2, ge >= 26 && (ge -= 26, X--), xe !== 0 || X !== this.length - 1 ? ve = Le[6 - Y.length] + Y + ve : ve = Y + ve;
        }
        for (xe !== 0 && (ve = xe.toString(16) + ve); ve.length % Z !== 0; )
          ve = "0" + ve;
        return this.negative !== 0 && (ve = "-" + ve), ve;
      }
      if (B === (B | 0) && B >= 2 && B <= 36) {
        var Ne = ke[B], Ke = Fe[B];
        ve = "";
        var tt = this.clone();
        for (tt.negative = 0; !tt.isZero(); ) {
          var We = tt.modrn(Ke).toString(B);
          tt = tt.idivn(Ke), tt.isZero() ? ve = We + ve : ve = Le[Ne - We.length] + We + ve;
        }
        for (this.isZero() && (ve = "0" + ve); ve.length % Z !== 0; )
          ve = "0" + ve;
        return this.negative !== 0 && (ve = "-" + ve), ve;
      }
      J(!1, "Base should be between 2 and 36");
    }, H.prototype.toNumber = function() {
      var B = this.words[0];
      return this.length === 2 ? B += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? B += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -B : B;
    }, H.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, De && (H.prototype.toBuffer = function(B, Z) {
      return this.toArrayLike(De, B, Z);
    }), H.prototype.toArray = function(B, Z) {
      return this.toArrayLike(Array, B, Z);
    };
    var Ge = function(B, Z) {
      return B.allocUnsafe ? B.allocUnsafe(Z) : new B(Z);
    };
    H.prototype.toArrayLike = function(B, Z, ve) {
      this._strip();
      var ge = this.byteLength(), xe = ve || Math.max(1, ge);
      J(ge <= xe, "byte array longer than desired length"), J(xe > 0, "Requested array length <= 0");
      var X = Ge(B, xe), a = Z === "le" ? "LE" : "BE";
      return this["_toArrayLike" + a](X, ge), X;
    }, H.prototype._toArrayLikeLE = function(B, Z) {
      for (var ve = 0, ge = 0, xe = 0, X = 0; xe < this.length; xe++) {
        var a = this.words[xe] << X | ge;
        B[ve++] = a & 255, ve < B.length && (B[ve++] = a >> 8 & 255), ve < B.length && (B[ve++] = a >> 16 & 255), X === 6 ? (ve < B.length && (B[ve++] = a >> 24 & 255), ge = 0, X = 0) : (ge = a >>> 24, X += 2);
      }
      if (ve < B.length)
        for (B[ve++] = ge; ve < B.length; )
          B[ve++] = 0;
    }, H.prototype._toArrayLikeBE = function(B, Z) {
      for (var ve = B.length - 1, ge = 0, xe = 0, X = 0; xe < this.length; xe++) {
        var a = this.words[xe] << X | ge;
        B[ve--] = a & 255, ve >= 0 && (B[ve--] = a >> 8 & 255), ve >= 0 && (B[ve--] = a >> 16 & 255), X === 6 ? (ve >= 0 && (B[ve--] = a >> 24 & 255), ge = 0, X = 0) : (ge = a >>> 24, X += 2);
      }
      if (ve >= 0)
        for (B[ve--] = ge; ve >= 0; )
          B[ve--] = 0;
    }, Math.clz32 ? H.prototype._countBits = function(B) {
      return 32 - Math.clz32(B);
    } : H.prototype._countBits = function(B) {
      var Z = B, ve = 0;
      return Z >= 4096 && (ve += 13, Z >>>= 13), Z >= 64 && (ve += 7, Z >>>= 7), Z >= 8 && (ve += 4, Z >>>= 4), Z >= 2 && (ve += 2, Z >>>= 2), ve + Z;
    }, H.prototype._zeroBits = function(B) {
      if (B === 0) return 26;
      var Z = B, ve = 0;
      return Z & 8191 || (ve += 13, Z >>>= 13), Z & 127 || (ve += 7, Z >>>= 7), Z & 15 || (ve += 4, Z >>>= 4), Z & 3 || (ve += 2, Z >>>= 2), Z & 1 || ve++, ve;
    }, H.prototype.bitLength = function() {
      var B = this.words[this.length - 1], Z = this._countBits(B);
      return (this.length - 1) * 26 + Z;
    };
    function et(h) {
      for (var B = new Array(h.bitLength()), Z = 0; Z < B.length; Z++) {
        var ve = Z / 26 | 0, ge = Z % 26;
        B[Z] = h.words[ve] >>> ge & 1;
      }
      return B;
    }
    H.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var B = 0, Z = 0; Z < this.length; Z++) {
        var ve = this._zeroBits(this.words[Z]);
        if (B += ve, ve !== 26) break;
      }
      return B;
    }, H.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, H.prototype.toTwos = function(B) {
      return this.negative !== 0 ? this.abs().inotn(B).iaddn(1) : this.clone();
    }, H.prototype.fromTwos = function(B) {
      return this.testn(B - 1) ? this.notn(B).iaddn(1).ineg() : this.clone();
    }, H.prototype.isNeg = function() {
      return this.negative !== 0;
    }, H.prototype.neg = function() {
      return this.clone().ineg();
    }, H.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, H.prototype.iuor = function(B) {
      for (; this.length < B.length; )
        this.words[this.length++] = 0;
      for (var Z = 0; Z < B.length; Z++)
        this.words[Z] = this.words[Z] | B.words[Z];
      return this._strip();
    }, H.prototype.ior = function(B) {
      return J((this.negative | B.negative) === 0), this.iuor(B);
    }, H.prototype.or = function(B) {
      return this.length > B.length ? this.clone().ior(B) : B.clone().ior(this);
    }, H.prototype.uor = function(B) {
      return this.length > B.length ? this.clone().iuor(B) : B.clone().iuor(this);
    }, H.prototype.iuand = function(B) {
      var Z;
      this.length > B.length ? Z = B : Z = this;
      for (var ve = 0; ve < Z.length; ve++)
        this.words[ve] = this.words[ve] & B.words[ve];
      return this.length = Z.length, this._strip();
    }, H.prototype.iand = function(B) {
      return J((this.negative | B.negative) === 0), this.iuand(B);
    }, H.prototype.and = function(B) {
      return this.length > B.length ? this.clone().iand(B) : B.clone().iand(this);
    }, H.prototype.uand = function(B) {
      return this.length > B.length ? this.clone().iuand(B) : B.clone().iuand(this);
    }, H.prototype.iuxor = function(B) {
      var Z, ve;
      this.length > B.length ? (Z = this, ve = B) : (Z = B, ve = this);
      for (var ge = 0; ge < ve.length; ge++)
        this.words[ge] = Z.words[ge] ^ ve.words[ge];
      if (this !== Z)
        for (; ge < Z.length; ge++)
          this.words[ge] = Z.words[ge];
      return this.length = Z.length, this._strip();
    }, H.prototype.ixor = function(B) {
      return J((this.negative | B.negative) === 0), this.iuxor(B);
    }, H.prototype.xor = function(B) {
      return this.length > B.length ? this.clone().ixor(B) : B.clone().ixor(this);
    }, H.prototype.uxor = function(B) {
      return this.length > B.length ? this.clone().iuxor(B) : B.clone().iuxor(this);
    }, H.prototype.inotn = function(B) {
      J(typeof B == "number" && B >= 0);
      var Z = Math.ceil(B / 26) | 0, ve = B % 26;
      this._expand(Z), ve > 0 && Z--;
      for (var ge = 0; ge < Z; ge++)
        this.words[ge] = ~this.words[ge] & 67108863;
      return ve > 0 && (this.words[ge] = ~this.words[ge] & 67108863 >> 26 - ve), this._strip();
    }, H.prototype.notn = function(B) {
      return this.clone().inotn(B);
    }, H.prototype.setn = function(B, Z) {
      J(typeof B == "number" && B >= 0);
      var ve = B / 26 | 0, ge = B % 26;
      return this._expand(ve + 1), Z ? this.words[ve] = this.words[ve] | 1 << ge : this.words[ve] = this.words[ve] & ~(1 << ge), this._strip();
    }, H.prototype.iadd = function(B) {
      var Z;
      if (this.negative !== 0 && B.negative === 0)
        return this.negative = 0, Z = this.isub(B), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && B.negative !== 0)
        return B.negative = 0, Z = this.isub(B), B.negative = 1, Z._normSign();
      var ve, ge;
      this.length > B.length ? (ve = this, ge = B) : (ve = B, ge = this);
      for (var xe = 0, X = 0; X < ge.length; X++)
        Z = (ve.words[X] | 0) + (ge.words[X] | 0) + xe, this.words[X] = Z & 67108863, xe = Z >>> 26;
      for (; xe !== 0 && X < ve.length; X++)
        Z = (ve.words[X] | 0) + xe, this.words[X] = Z & 67108863, xe = Z >>> 26;
      if (this.length = ve.length, xe !== 0)
        this.words[this.length] = xe, this.length++;
      else if (ve !== this)
        for (; X < ve.length; X++)
          this.words[X] = ve.words[X];
      return this;
    }, H.prototype.add = function(B) {
      var Z;
      return B.negative !== 0 && this.negative === 0 ? (B.negative = 0, Z = this.sub(B), B.negative ^= 1, Z) : B.negative === 0 && this.negative !== 0 ? (this.negative = 0, Z = B.sub(this), this.negative = 1, Z) : this.length > B.length ? this.clone().iadd(B) : B.clone().iadd(this);
    }, H.prototype.isub = function(B) {
      if (B.negative !== 0) {
        B.negative = 0;
        var Z = this.iadd(B);
        return B.negative = 1, Z._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(B), this.negative = 1, this._normSign();
      var ve = this.cmp(B);
      if (ve === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var ge, xe;
      ve > 0 ? (ge = this, xe = B) : (ge = B, xe = this);
      for (var X = 0, a = 0; a < xe.length; a++)
        Z = (ge.words[a] | 0) - (xe.words[a] | 0) + X, X = Z >> 26, this.words[a] = Z & 67108863;
      for (; X !== 0 && a < ge.length; a++)
        Z = (ge.words[a] | 0) + X, X = Z >> 26, this.words[a] = Z & 67108863;
      if (X === 0 && a < ge.length && ge !== this)
        for (; a < ge.length; a++)
          this.words[a] = ge.words[a];
      return this.length = Math.max(this.length, a), ge !== this && (this.negative = 1), this._strip();
    }, H.prototype.sub = function(B) {
      return this.clone().isub(B);
    };
    function Ve(h, B, Z) {
      Z.negative = B.negative ^ h.negative;
      var ve = h.length + B.length | 0;
      Z.length = ve, ve = ve - 1 | 0;
      var ge = h.words[0] | 0, xe = B.words[0] | 0, X = ge * xe, a = X & 67108863, Y = X / 67108864 | 0;
      Z.words[0] = a;
      for (var Ne = 1; Ne < ve; Ne++) {
        for (var Ke = Y >>> 26, tt = Y & 67108863, We = Math.min(Ne, B.length - 1), ot = Math.max(0, Ne - h.length + 1); ot <= We; ot++) {
          var He = Ne - ot | 0;
          ge = h.words[He] | 0, xe = B.words[ot] | 0, X = ge * xe + tt, Ke += X / 67108864 | 0, tt = X & 67108863;
        }
        Z.words[Ne] = tt | 0, Y = Ke | 0;
      }
      return Y !== 0 ? Z.words[Ne] = Y | 0 : Z.length--, Z._strip();
    }
    var Je = function(B, Z, ve) {
      var ge = B.words, xe = Z.words, X = ve.words, a = 0, Y, Ne, Ke, tt = ge[0] | 0, We = tt & 8191, ot = tt >>> 13, He = ge[1] | 0, Qe = He & 8191, nt = He >>> 13, je = ge[2] | 0, it = je & 8191, st = je >>> 13, gt = ge[3] | 0, It = gt & 8191, At = gt >>> 13, Et = ge[4] | 0, ei = Et & 8191, Xt = Et >>> 13, _t = ge[5] | 0, ni = _t & 8191, Ct = _t >>> 13, Wt = ge[6] | 0, ii = Wt & 8191, Pt = Wt >>> 13, Rt = ge[7] | 0, ai = Rt & 8191, Nt = Rt >>> 13, qt = ge[8] | 0, oi = qt & 8191, ct = qt >>> 13, Ze = ge[9] | 0, at = Ze & 8191, dt = Ze >>> 13, yt = xe[0] | 0, St = yt & 8191, xt = yt >>> 13, Vt = xe[1] | 0, ci = Vt & 8191, Qt = Vt >>> 13, rr = xe[2] | 0, ui = rr & 8191, Gr = rr >>> 13, yr = xe[3] | 0, pi = yr & 8191, wr = yr >>> 13, _r = xe[4] | 0, di = _r & 8191, Sr = _r >>> 13, Br = xe[5] | 0, vi = Br & 8191, gr = Br >>> 13, $r = xe[6] | 0, li = $r & 8191, Ir = $r >>> 13, Cr = xe[7] | 0, mi = Cr & 8191, Pr = Cr >>> 13, Or = xe[8] | 0, yi = Or & 8191, Zr = Or >>> 13, Vr = xe[9] | 0, bi = Vr & 8191, Ai = Vr >>> 13;
      ve.negative = B.negative ^ Z.negative, ve.length = 19, Y = Math.imul(We, St), Ne = Math.imul(We, xt), Ne = Ne + Math.imul(ot, St) | 0, Ke = Math.imul(ot, xt);
      var Zi = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, Y = Math.imul(Qe, St), Ne = Math.imul(Qe, xt), Ne = Ne + Math.imul(nt, St) | 0, Ke = Math.imul(nt, xt), Y = Y + Math.imul(We, ci) | 0, Ne = Ne + Math.imul(We, Qt) | 0, Ne = Ne + Math.imul(ot, ci) | 0, Ke = Ke + Math.imul(ot, Qt) | 0;
      var Ji = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, Y = Math.imul(it, St), Ne = Math.imul(it, xt), Ne = Ne + Math.imul(st, St) | 0, Ke = Math.imul(st, xt), Y = Y + Math.imul(Qe, ci) | 0, Ne = Ne + Math.imul(Qe, Qt) | 0, Ne = Ne + Math.imul(nt, ci) | 0, Ke = Ke + Math.imul(nt, Qt) | 0, Y = Y + Math.imul(We, ui) | 0, Ne = Ne + Math.imul(We, Gr) | 0, Ne = Ne + Math.imul(ot, ui) | 0, Ke = Ke + Math.imul(ot, Gr) | 0;
      var Vi = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, Y = Math.imul(It, St), Ne = Math.imul(It, xt), Ne = Ne + Math.imul(At, St) | 0, Ke = Math.imul(At, xt), Y = Y + Math.imul(it, ci) | 0, Ne = Ne + Math.imul(it, Qt) | 0, Ne = Ne + Math.imul(st, ci) | 0, Ke = Ke + Math.imul(st, Qt) | 0, Y = Y + Math.imul(Qe, ui) | 0, Ne = Ne + Math.imul(Qe, Gr) | 0, Ne = Ne + Math.imul(nt, ui) | 0, Ke = Ke + Math.imul(nt, Gr) | 0, Y = Y + Math.imul(We, pi) | 0, Ne = Ne + Math.imul(We, wr) | 0, Ne = Ne + Math.imul(ot, pi) | 0, Ke = Ke + Math.imul(ot, wr) | 0;
      var Yi = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, Y = Math.imul(ei, St), Ne = Math.imul(ei, xt), Ne = Ne + Math.imul(Xt, St) | 0, Ke = Math.imul(Xt, xt), Y = Y + Math.imul(It, ci) | 0, Ne = Ne + Math.imul(It, Qt) | 0, Ne = Ne + Math.imul(At, ci) | 0, Ke = Ke + Math.imul(At, Qt) | 0, Y = Y + Math.imul(it, ui) | 0, Ne = Ne + Math.imul(it, Gr) | 0, Ne = Ne + Math.imul(st, ui) | 0, Ke = Ke + Math.imul(st, Gr) | 0, Y = Y + Math.imul(Qe, pi) | 0, Ne = Ne + Math.imul(Qe, wr) | 0, Ne = Ne + Math.imul(nt, pi) | 0, Ke = Ke + Math.imul(nt, wr) | 0, Y = Y + Math.imul(We, di) | 0, Ne = Ne + Math.imul(We, Sr) | 0, Ne = Ne + Math.imul(ot, di) | 0, Ke = Ke + Math.imul(ot, Sr) | 0;
      var Xi = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, Y = Math.imul(ni, St), Ne = Math.imul(ni, xt), Ne = Ne + Math.imul(Ct, St) | 0, Ke = Math.imul(Ct, xt), Y = Y + Math.imul(ei, ci) | 0, Ne = Ne + Math.imul(ei, Qt) | 0, Ne = Ne + Math.imul(Xt, ci) | 0, Ke = Ke + Math.imul(Xt, Qt) | 0, Y = Y + Math.imul(It, ui) | 0, Ne = Ne + Math.imul(It, Gr) | 0, Ne = Ne + Math.imul(At, ui) | 0, Ke = Ke + Math.imul(At, Gr) | 0, Y = Y + Math.imul(it, pi) | 0, Ne = Ne + Math.imul(it, wr) | 0, Ne = Ne + Math.imul(st, pi) | 0, Ke = Ke + Math.imul(st, wr) | 0, Y = Y + Math.imul(Qe, di) | 0, Ne = Ne + Math.imul(Qe, Sr) | 0, Ne = Ne + Math.imul(nt, di) | 0, Ke = Ke + Math.imul(nt, Sr) | 0, Y = Y + Math.imul(We, vi) | 0, Ne = Ne + Math.imul(We, gr) | 0, Ne = Ne + Math.imul(ot, vi) | 0, Ke = Ke + Math.imul(ot, gr) | 0;
      var en = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, Y = Math.imul(ii, St), Ne = Math.imul(ii, xt), Ne = Ne + Math.imul(Pt, St) | 0, Ke = Math.imul(Pt, xt), Y = Y + Math.imul(ni, ci) | 0, Ne = Ne + Math.imul(ni, Qt) | 0, Ne = Ne + Math.imul(Ct, ci) | 0, Ke = Ke + Math.imul(Ct, Qt) | 0, Y = Y + Math.imul(ei, ui) | 0, Ne = Ne + Math.imul(ei, Gr) | 0, Ne = Ne + Math.imul(Xt, ui) | 0, Ke = Ke + Math.imul(Xt, Gr) | 0, Y = Y + Math.imul(It, pi) | 0, Ne = Ne + Math.imul(It, wr) | 0, Ne = Ne + Math.imul(At, pi) | 0, Ke = Ke + Math.imul(At, wr) | 0, Y = Y + Math.imul(it, di) | 0, Ne = Ne + Math.imul(it, Sr) | 0, Ne = Ne + Math.imul(st, di) | 0, Ke = Ke + Math.imul(st, Sr) | 0, Y = Y + Math.imul(Qe, vi) | 0, Ne = Ne + Math.imul(Qe, gr) | 0, Ne = Ne + Math.imul(nt, vi) | 0, Ke = Ke + Math.imul(nt, gr) | 0, Y = Y + Math.imul(We, li) | 0, Ne = Ne + Math.imul(We, Ir) | 0, Ne = Ne + Math.imul(ot, li) | 0, Ke = Ke + Math.imul(ot, Ir) | 0;
      var hn = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, Y = Math.imul(ai, St), Ne = Math.imul(ai, xt), Ne = Ne + Math.imul(Nt, St) | 0, Ke = Math.imul(Nt, xt), Y = Y + Math.imul(ii, ci) | 0, Ne = Ne + Math.imul(ii, Qt) | 0, Ne = Ne + Math.imul(Pt, ci) | 0, Ke = Ke + Math.imul(Pt, Qt) | 0, Y = Y + Math.imul(ni, ui) | 0, Ne = Ne + Math.imul(ni, Gr) | 0, Ne = Ne + Math.imul(Ct, ui) | 0, Ke = Ke + Math.imul(Ct, Gr) | 0, Y = Y + Math.imul(ei, pi) | 0, Ne = Ne + Math.imul(ei, wr) | 0, Ne = Ne + Math.imul(Xt, pi) | 0, Ke = Ke + Math.imul(Xt, wr) | 0, Y = Y + Math.imul(It, di) | 0, Ne = Ne + Math.imul(It, Sr) | 0, Ne = Ne + Math.imul(At, di) | 0, Ke = Ke + Math.imul(At, Sr) | 0, Y = Y + Math.imul(it, vi) | 0, Ne = Ne + Math.imul(it, gr) | 0, Ne = Ne + Math.imul(st, vi) | 0, Ke = Ke + Math.imul(st, gr) | 0, Y = Y + Math.imul(Qe, li) | 0, Ne = Ne + Math.imul(Qe, Ir) | 0, Ne = Ne + Math.imul(nt, li) | 0, Ke = Ke + Math.imul(nt, Ir) | 0, Y = Y + Math.imul(We, mi) | 0, Ne = Ne + Math.imul(We, Pr) | 0, Ne = Ne + Math.imul(ot, mi) | 0, Ke = Ke + Math.imul(ot, Pr) | 0;
      var tn = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, Y = Math.imul(oi, St), Ne = Math.imul(oi, xt), Ne = Ne + Math.imul(ct, St) | 0, Ke = Math.imul(ct, xt), Y = Y + Math.imul(ai, ci) | 0, Ne = Ne + Math.imul(ai, Qt) | 0, Ne = Ne + Math.imul(Nt, ci) | 0, Ke = Ke + Math.imul(Nt, Qt) | 0, Y = Y + Math.imul(ii, ui) | 0, Ne = Ne + Math.imul(ii, Gr) | 0, Ne = Ne + Math.imul(Pt, ui) | 0, Ke = Ke + Math.imul(Pt, Gr) | 0, Y = Y + Math.imul(ni, pi) | 0, Ne = Ne + Math.imul(ni, wr) | 0, Ne = Ne + Math.imul(Ct, pi) | 0, Ke = Ke + Math.imul(Ct, wr) | 0, Y = Y + Math.imul(ei, di) | 0, Ne = Ne + Math.imul(ei, Sr) | 0, Ne = Ne + Math.imul(Xt, di) | 0, Ke = Ke + Math.imul(Xt, Sr) | 0, Y = Y + Math.imul(It, vi) | 0, Ne = Ne + Math.imul(It, gr) | 0, Ne = Ne + Math.imul(At, vi) | 0, Ke = Ke + Math.imul(At, gr) | 0, Y = Y + Math.imul(it, li) | 0, Ne = Ne + Math.imul(it, Ir) | 0, Ne = Ne + Math.imul(st, li) | 0, Ke = Ke + Math.imul(st, Ir) | 0, Y = Y + Math.imul(Qe, mi) | 0, Ne = Ne + Math.imul(Qe, Pr) | 0, Ne = Ne + Math.imul(nt, mi) | 0, Ke = Ke + Math.imul(nt, Pr) | 0, Y = Y + Math.imul(We, yi) | 0, Ne = Ne + Math.imul(We, Zr) | 0, Ne = Ne + Math.imul(ot, yi) | 0, Ke = Ke + Math.imul(ot, Zr) | 0;
      var un = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, Y = Math.imul(at, St), Ne = Math.imul(at, xt), Ne = Ne + Math.imul(dt, St) | 0, Ke = Math.imul(dt, xt), Y = Y + Math.imul(oi, ci) | 0, Ne = Ne + Math.imul(oi, Qt) | 0, Ne = Ne + Math.imul(ct, ci) | 0, Ke = Ke + Math.imul(ct, Qt) | 0, Y = Y + Math.imul(ai, ui) | 0, Ne = Ne + Math.imul(ai, Gr) | 0, Ne = Ne + Math.imul(Nt, ui) | 0, Ke = Ke + Math.imul(Nt, Gr) | 0, Y = Y + Math.imul(ii, pi) | 0, Ne = Ne + Math.imul(ii, wr) | 0, Ne = Ne + Math.imul(Pt, pi) | 0, Ke = Ke + Math.imul(Pt, wr) | 0, Y = Y + Math.imul(ni, di) | 0, Ne = Ne + Math.imul(ni, Sr) | 0, Ne = Ne + Math.imul(Ct, di) | 0, Ke = Ke + Math.imul(Ct, Sr) | 0, Y = Y + Math.imul(ei, vi) | 0, Ne = Ne + Math.imul(ei, gr) | 0, Ne = Ne + Math.imul(Xt, vi) | 0, Ke = Ke + Math.imul(Xt, gr) | 0, Y = Y + Math.imul(It, li) | 0, Ne = Ne + Math.imul(It, Ir) | 0, Ne = Ne + Math.imul(At, li) | 0, Ke = Ke + Math.imul(At, Ir) | 0, Y = Y + Math.imul(it, mi) | 0, Ne = Ne + Math.imul(it, Pr) | 0, Ne = Ne + Math.imul(st, mi) | 0, Ke = Ke + Math.imul(st, Pr) | 0, Y = Y + Math.imul(Qe, yi) | 0, Ne = Ne + Math.imul(Qe, Zr) | 0, Ne = Ne + Math.imul(nt, yi) | 0, Ke = Ke + Math.imul(nt, Zr) | 0, Y = Y + Math.imul(We, bi) | 0, Ne = Ne + Math.imul(We, Ai) | 0, Ne = Ne + Math.imul(ot, bi) | 0, Ke = Ke + Math.imul(ot, Ai) | 0;
      var cn = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, Y = Math.imul(at, ci), Ne = Math.imul(at, Qt), Ne = Ne + Math.imul(dt, ci) | 0, Ke = Math.imul(dt, Qt), Y = Y + Math.imul(oi, ui) | 0, Ne = Ne + Math.imul(oi, Gr) | 0, Ne = Ne + Math.imul(ct, ui) | 0, Ke = Ke + Math.imul(ct, Gr) | 0, Y = Y + Math.imul(ai, pi) | 0, Ne = Ne + Math.imul(ai, wr) | 0, Ne = Ne + Math.imul(Nt, pi) | 0, Ke = Ke + Math.imul(Nt, wr) | 0, Y = Y + Math.imul(ii, di) | 0, Ne = Ne + Math.imul(ii, Sr) | 0, Ne = Ne + Math.imul(Pt, di) | 0, Ke = Ke + Math.imul(Pt, Sr) | 0, Y = Y + Math.imul(ni, vi) | 0, Ne = Ne + Math.imul(ni, gr) | 0, Ne = Ne + Math.imul(Ct, vi) | 0, Ke = Ke + Math.imul(Ct, gr) | 0, Y = Y + Math.imul(ei, li) | 0, Ne = Ne + Math.imul(ei, Ir) | 0, Ne = Ne + Math.imul(Xt, li) | 0, Ke = Ke + Math.imul(Xt, Ir) | 0, Y = Y + Math.imul(It, mi) | 0, Ne = Ne + Math.imul(It, Pr) | 0, Ne = Ne + Math.imul(At, mi) | 0, Ke = Ke + Math.imul(At, Pr) | 0, Y = Y + Math.imul(it, yi) | 0, Ne = Ne + Math.imul(it, Zr) | 0, Ne = Ne + Math.imul(st, yi) | 0, Ke = Ke + Math.imul(st, Zr) | 0, Y = Y + Math.imul(Qe, bi) | 0, Ne = Ne + Math.imul(Qe, Ai) | 0, Ne = Ne + Math.imul(nt, bi) | 0, Ke = Ke + Math.imul(nt, Ai) | 0;
      var ln = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, Y = Math.imul(at, ui), Ne = Math.imul(at, Gr), Ne = Ne + Math.imul(dt, ui) | 0, Ke = Math.imul(dt, Gr), Y = Y + Math.imul(oi, pi) | 0, Ne = Ne + Math.imul(oi, wr) | 0, Ne = Ne + Math.imul(ct, pi) | 0, Ke = Ke + Math.imul(ct, wr) | 0, Y = Y + Math.imul(ai, di) | 0, Ne = Ne + Math.imul(ai, Sr) | 0, Ne = Ne + Math.imul(Nt, di) | 0, Ke = Ke + Math.imul(Nt, Sr) | 0, Y = Y + Math.imul(ii, vi) | 0, Ne = Ne + Math.imul(ii, gr) | 0, Ne = Ne + Math.imul(Pt, vi) | 0, Ke = Ke + Math.imul(Pt, gr) | 0, Y = Y + Math.imul(ni, li) | 0, Ne = Ne + Math.imul(ni, Ir) | 0, Ne = Ne + Math.imul(Ct, li) | 0, Ke = Ke + Math.imul(Ct, Ir) | 0, Y = Y + Math.imul(ei, mi) | 0, Ne = Ne + Math.imul(ei, Pr) | 0, Ne = Ne + Math.imul(Xt, mi) | 0, Ke = Ke + Math.imul(Xt, Pr) | 0, Y = Y + Math.imul(It, yi) | 0, Ne = Ne + Math.imul(It, Zr) | 0, Ne = Ne + Math.imul(At, yi) | 0, Ke = Ke + Math.imul(At, Zr) | 0, Y = Y + Math.imul(it, bi) | 0, Ne = Ne + Math.imul(it, Ai) | 0, Ne = Ne + Math.imul(st, bi) | 0, Ke = Ke + Math.imul(st, Ai) | 0;
      var an = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, Y = Math.imul(at, pi), Ne = Math.imul(at, wr), Ne = Ne + Math.imul(dt, pi) | 0, Ke = Math.imul(dt, wr), Y = Y + Math.imul(oi, di) | 0, Ne = Ne + Math.imul(oi, Sr) | 0, Ne = Ne + Math.imul(ct, di) | 0, Ke = Ke + Math.imul(ct, Sr) | 0, Y = Y + Math.imul(ai, vi) | 0, Ne = Ne + Math.imul(ai, gr) | 0, Ne = Ne + Math.imul(Nt, vi) | 0, Ke = Ke + Math.imul(Nt, gr) | 0, Y = Y + Math.imul(ii, li) | 0, Ne = Ne + Math.imul(ii, Ir) | 0, Ne = Ne + Math.imul(Pt, li) | 0, Ke = Ke + Math.imul(Pt, Ir) | 0, Y = Y + Math.imul(ni, mi) | 0, Ne = Ne + Math.imul(ni, Pr) | 0, Ne = Ne + Math.imul(Ct, mi) | 0, Ke = Ke + Math.imul(Ct, Pr) | 0, Y = Y + Math.imul(ei, yi) | 0, Ne = Ne + Math.imul(ei, Zr) | 0, Ne = Ne + Math.imul(Xt, yi) | 0, Ke = Ke + Math.imul(Xt, Zr) | 0, Y = Y + Math.imul(It, bi) | 0, Ne = Ne + Math.imul(It, Ai) | 0, Ne = Ne + Math.imul(At, bi) | 0, Ke = Ke + Math.imul(At, Ai) | 0;
      var fn = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, Y = Math.imul(at, di), Ne = Math.imul(at, Sr), Ne = Ne + Math.imul(dt, di) | 0, Ke = Math.imul(dt, Sr), Y = Y + Math.imul(oi, vi) | 0, Ne = Ne + Math.imul(oi, gr) | 0, Ne = Ne + Math.imul(ct, vi) | 0, Ke = Ke + Math.imul(ct, gr) | 0, Y = Y + Math.imul(ai, li) | 0, Ne = Ne + Math.imul(ai, Ir) | 0, Ne = Ne + Math.imul(Nt, li) | 0, Ke = Ke + Math.imul(Nt, Ir) | 0, Y = Y + Math.imul(ii, mi) | 0, Ne = Ne + Math.imul(ii, Pr) | 0, Ne = Ne + Math.imul(Pt, mi) | 0, Ke = Ke + Math.imul(Pt, Pr) | 0, Y = Y + Math.imul(ni, yi) | 0, Ne = Ne + Math.imul(ni, Zr) | 0, Ne = Ne + Math.imul(Ct, yi) | 0, Ke = Ke + Math.imul(Ct, Zr) | 0, Y = Y + Math.imul(ei, bi) | 0, Ne = Ne + Math.imul(ei, Ai) | 0, Ne = Ne + Math.imul(Xt, bi) | 0, Ke = Ke + Math.imul(Xt, Ai) | 0;
      var sn = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, Y = Math.imul(at, vi), Ne = Math.imul(at, gr), Ne = Ne + Math.imul(dt, vi) | 0, Ke = Math.imul(dt, gr), Y = Y + Math.imul(oi, li) | 0, Ne = Ne + Math.imul(oi, Ir) | 0, Ne = Ne + Math.imul(ct, li) | 0, Ke = Ke + Math.imul(ct, Ir) | 0, Y = Y + Math.imul(ai, mi) | 0, Ne = Ne + Math.imul(ai, Pr) | 0, Ne = Ne + Math.imul(Nt, mi) | 0, Ke = Ke + Math.imul(Nt, Pr) | 0, Y = Y + Math.imul(ii, yi) | 0, Ne = Ne + Math.imul(ii, Zr) | 0, Ne = Ne + Math.imul(Pt, yi) | 0, Ke = Ke + Math.imul(Pt, Zr) | 0, Y = Y + Math.imul(ni, bi) | 0, Ne = Ne + Math.imul(ni, Ai) | 0, Ne = Ne + Math.imul(Ct, bi) | 0, Ke = Ke + Math.imul(Ct, Ai) | 0;
      var dn = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, Y = Math.imul(at, li), Ne = Math.imul(at, Ir), Ne = Ne + Math.imul(dt, li) | 0, Ke = Math.imul(dt, Ir), Y = Y + Math.imul(oi, mi) | 0, Ne = Ne + Math.imul(oi, Pr) | 0, Ne = Ne + Math.imul(ct, mi) | 0, Ke = Ke + Math.imul(ct, Pr) | 0, Y = Y + Math.imul(ai, yi) | 0, Ne = Ne + Math.imul(ai, Zr) | 0, Ne = Ne + Math.imul(Nt, yi) | 0, Ke = Ke + Math.imul(Nt, Zr) | 0, Y = Y + Math.imul(ii, bi) | 0, Ne = Ne + Math.imul(ii, Ai) | 0, Ne = Ne + Math.imul(Pt, bi) | 0, Ke = Ke + Math.imul(Pt, Ai) | 0;
      var pn = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, Y = Math.imul(at, mi), Ne = Math.imul(at, Pr), Ne = Ne + Math.imul(dt, mi) | 0, Ke = Math.imul(dt, Pr), Y = Y + Math.imul(oi, yi) | 0, Ne = Ne + Math.imul(oi, Zr) | 0, Ne = Ne + Math.imul(ct, yi) | 0, Ke = Ke + Math.imul(ct, Zr) | 0, Y = Y + Math.imul(ai, bi) | 0, Ne = Ne + Math.imul(ai, Ai) | 0, Ne = Ne + Math.imul(Nt, bi) | 0, Ke = Ke + Math.imul(Nt, Ai) | 0;
      var vn = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, Y = Math.imul(at, yi), Ne = Math.imul(at, Zr), Ne = Ne + Math.imul(dt, yi) | 0, Ke = Math.imul(dt, Zr), Y = Y + Math.imul(oi, bi) | 0, Ne = Ne + Math.imul(oi, Ai) | 0, Ne = Ne + Math.imul(ct, bi) | 0, Ke = Ke + Math.imul(ct, Ai) | 0;
      var us = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      a = (Ke + (Ne >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, Y = Math.imul(at, bi), Ne = Math.imul(at, Ai), Ne = Ne + Math.imul(dt, bi) | 0, Ke = Math.imul(dt, Ai);
      var eo = (a + Y | 0) + ((Ne & 8191) << 13) | 0;
      return a = (Ke + (Ne >>> 13) | 0) + (eo >>> 26) | 0, eo &= 67108863, X[0] = Zi, X[1] = Ji, X[2] = Vi, X[3] = Yi, X[4] = Xi, X[5] = en, X[6] = hn, X[7] = tn, X[8] = un, X[9] = cn, X[10] = ln, X[11] = an, X[12] = fn, X[13] = sn, X[14] = dn, X[15] = pn, X[16] = vn, X[17] = us, X[18] = eo, a !== 0 && (X[19] = a, ve.length++), ve;
    };
    Math.imul || (Je = Ve);
    function ut(h, B, Z) {
      Z.negative = B.negative ^ h.negative, Z.length = h.length + B.length;
      for (var ve = 0, ge = 0, xe = 0; xe < Z.length - 1; xe++) {
        var X = ge;
        ge = 0;
        for (var a = ve & 67108863, Y = Math.min(xe, B.length - 1), Ne = Math.max(0, xe - h.length + 1); Ne <= Y; Ne++) {
          var Ke = xe - Ne, tt = h.words[Ke] | 0, We = B.words[Ne] | 0, ot = tt * We, He = ot & 67108863;
          X = X + (ot / 67108864 | 0) | 0, He = He + a | 0, a = He & 67108863, X = X + (He >>> 26) | 0, ge += X >>> 26, X &= 67108863;
        }
        Z.words[xe] = a, ve = X, X = ge;
      }
      return ve !== 0 ? Z.words[xe] = ve : Z.length--, Z._strip();
    }
    function rt(h, B, Z) {
      return ut(h, B, Z);
    }
    H.prototype.mulTo = function(B, Z) {
      var ve, ge = this.length + B.length;
      return this.length === 10 && B.length === 10 ? ve = Je(this, B, Z) : ge < 63 ? ve = Ve(this, B, Z) : ge < 1024 ? ve = ut(this, B, Z) : ve = rt(this, B, Z), ve;
    }, H.prototype.mul = function(B) {
      var Z = new H(null);
      return Z.words = new Array(this.length + B.length), this.mulTo(B, Z);
    }, H.prototype.mulf = function(B) {
      var Z = new H(null);
      return Z.words = new Array(this.length + B.length), rt(this, B, Z);
    }, H.prototype.imul = function(B) {
      return this.clone().mulTo(B, this);
    }, H.prototype.imuln = function(B) {
      var Z = B < 0;
      Z && (B = -B), J(typeof B == "number"), J(B < 67108864);
      for (var ve = 0, ge = 0; ge < this.length; ge++) {
        var xe = (this.words[ge] | 0) * B, X = (xe & 67108863) + (ve & 67108863);
        ve >>= 26, ve += xe / 67108864 | 0, ve += X >>> 26, this.words[ge] = X & 67108863;
      }
      return ve !== 0 && (this.words[ge] = ve, this.length++), Z ? this.ineg() : this;
    }, H.prototype.muln = function(B) {
      return this.clone().imuln(B);
    }, H.prototype.sqr = function() {
      return this.mul(this);
    }, H.prototype.isqr = function() {
      return this.imul(this.clone());
    }, H.prototype.pow = function(B) {
      var Z = et(B);
      if (Z.length === 0) return new H(1);
      for (var ve = this, ge = 0; ge < Z.length && Z[ge] === 0; ge++, ve = ve.sqr())
        ;
      if (++ge < Z.length)
        for (var xe = ve.sqr(); ge < Z.length; ge++, xe = xe.sqr())
          Z[ge] !== 0 && (ve = ve.mul(xe));
      return ve;
    }, H.prototype.iushln = function(B) {
      J(typeof B == "number" && B >= 0);
      var Z = B % 26, ve = (B - Z) / 26, ge = 67108863 >>> 26 - Z << 26 - Z, xe;
      if (Z !== 0) {
        var X = 0;
        for (xe = 0; xe < this.length; xe++) {
          var a = this.words[xe] & ge, Y = (this.words[xe] | 0) - a << Z;
          this.words[xe] = Y | X, X = a >>> 26 - Z;
        }
        X && (this.words[xe] = X, this.length++);
      }
      if (ve !== 0) {
        for (xe = this.length - 1; xe >= 0; xe--)
          this.words[xe + ve] = this.words[xe];
        for (xe = 0; xe < ve; xe++)
          this.words[xe] = 0;
        this.length += ve;
      }
      return this._strip();
    }, H.prototype.ishln = function(B) {
      return J(this.negative === 0), this.iushln(B);
    }, H.prototype.iushrn = function(B, Z, ve) {
      J(typeof B == "number" && B >= 0);
      var ge;
      Z ? ge = (Z - Z % 26) / 26 : ge = 0;
      var xe = B % 26, X = Math.min((B - xe) / 26, this.length), a = 67108863 ^ 67108863 >>> xe << xe, Y = ve;
      if (ge -= X, ge = Math.max(0, ge), Y) {
        for (var Ne = 0; Ne < X; Ne++)
          Y.words[Ne] = this.words[Ne];
        Y.length = X;
      }
      if (X !== 0) if (this.length > X)
        for (this.length -= X, Ne = 0; Ne < this.length; Ne++)
          this.words[Ne] = this.words[Ne + X];
      else
        this.words[0] = 0, this.length = 1;
      var Ke = 0;
      for (Ne = this.length - 1; Ne >= 0 && (Ke !== 0 || Ne >= ge); Ne--) {
        var tt = this.words[Ne] | 0;
        this.words[Ne] = Ke << 26 - xe | tt >>> xe, Ke = tt & a;
      }
      return Y && Ke !== 0 && (Y.words[Y.length++] = Ke), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, H.prototype.ishrn = function(B, Z, ve) {
      return J(this.negative === 0), this.iushrn(B, Z, ve);
    }, H.prototype.shln = function(B) {
      return this.clone().ishln(B);
    }, H.prototype.ushln = function(B) {
      return this.clone().iushln(B);
    }, H.prototype.shrn = function(B) {
      return this.clone().ishrn(B);
    }, H.prototype.ushrn = function(B) {
      return this.clone().iushrn(B);
    }, H.prototype.testn = function(B) {
      J(typeof B == "number" && B >= 0);
      var Z = B % 26, ve = (B - Z) / 26, ge = 1 << Z;
      if (this.length <= ve) return !1;
      var xe = this.words[ve];
      return !!(xe & ge);
    }, H.prototype.imaskn = function(B) {
      J(typeof B == "number" && B >= 0);
      var Z = B % 26, ve = (B - Z) / 26;
      if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ve)
        return this;
      if (Z !== 0 && ve++, this.length = Math.min(ve, this.length), Z !== 0) {
        var ge = 67108863 ^ 67108863 >>> Z << Z;
        this.words[this.length - 1] &= ge;
      }
      return this._strip();
    }, H.prototype.maskn = function(B) {
      return this.clone().imaskn(B);
    }, H.prototype.iaddn = function(B) {
      return J(typeof B == "number"), J(B < 67108864), B < 0 ? this.isubn(-B) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= B ? (this.words[0] = B - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(B), this.negative = 1, this) : this._iaddn(B);
    }, H.prototype._iaddn = function(B) {
      this.words[0] += B;
      for (var Z = 0; Z < this.length && this.words[Z] >= 67108864; Z++)
        this.words[Z] -= 67108864, Z === this.length - 1 ? this.words[Z + 1] = 1 : this.words[Z + 1]++;
      return this.length = Math.max(this.length, Z + 1), this;
    }, H.prototype.isubn = function(B) {
      if (J(typeof B == "number"), J(B < 67108864), B < 0) return this.iaddn(-B);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(B), this.negative = 1, this;
      if (this.words[0] -= B, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var Z = 0; Z < this.length && this.words[Z] < 0; Z++)
          this.words[Z] += 67108864, this.words[Z + 1] -= 1;
      return this._strip();
    }, H.prototype.addn = function(B) {
      return this.clone().iaddn(B);
    }, H.prototype.subn = function(B) {
      return this.clone().isubn(B);
    }, H.prototype.iabs = function() {
      return this.negative = 0, this;
    }, H.prototype.abs = function() {
      return this.clone().iabs();
    }, H.prototype._ishlnsubmul = function(B, Z, ve) {
      var ge = B.length + ve, xe;
      this._expand(ge);
      var X, a = 0;
      for (xe = 0; xe < B.length; xe++) {
        X = (this.words[xe + ve] | 0) + a;
        var Y = (B.words[xe] | 0) * Z;
        X -= Y & 67108863, a = (X >> 26) - (Y / 67108864 | 0), this.words[xe + ve] = X & 67108863;
      }
      for (; xe < this.length - ve; xe++)
        X = (this.words[xe + ve] | 0) + a, a = X >> 26, this.words[xe + ve] = X & 67108863;
      if (a === 0) return this._strip();
      for (J(a === -1), a = 0, xe = 0; xe < this.length; xe++)
        X = -(this.words[xe] | 0) + a, a = X >> 26, this.words[xe] = X & 67108863;
      return this.negative = 1, this._strip();
    }, H.prototype._wordDiv = function(B, Z) {
      var ve = this.length - B.length, ge = this.clone(), xe = B, X = xe.words[xe.length - 1] | 0, a = this._countBits(X);
      ve = 26 - a, ve !== 0 && (xe = xe.ushln(ve), ge.iushln(ve), X = xe.words[xe.length - 1] | 0);
      var Y = ge.length - xe.length, Ne;
      if (Z !== "mod") {
        Ne = new H(null), Ne.length = Y + 1, Ne.words = new Array(Ne.length);
        for (var Ke = 0; Ke < Ne.length; Ke++)
          Ne.words[Ke] = 0;
      }
      var tt = ge.clone()._ishlnsubmul(xe, 1, Y);
      tt.negative === 0 && (ge = tt, Ne && (Ne.words[Y] = 1));
      for (var We = Y - 1; We >= 0; We--) {
        var ot = (ge.words[xe.length + We] | 0) * 67108864 + (ge.words[xe.length + We - 1] | 0);
        for (ot = Math.min(ot / X | 0, 67108863), ge._ishlnsubmul(xe, ot, We); ge.negative !== 0; )
          ot--, ge.negative = 0, ge._ishlnsubmul(xe, 1, We), ge.isZero() || (ge.negative ^= 1);
        Ne && (Ne.words[We] = ot);
      }
      return Ne && Ne._strip(), ge._strip(), Z !== "div" && ve !== 0 && ge.iushrn(ve), {
        div: Ne || null,
        mod: ge
      };
    }, H.prototype.divmod = function(B, Z, ve) {
      if (J(!B.isZero()), this.isZero())
        return {
          div: new H(0),
          mod: new H(0)
        };
      var ge, xe, X;
      return this.negative !== 0 && B.negative === 0 ? (X = this.neg().divmod(B, Z), Z !== "mod" && (ge = X.div.neg()), Z !== "div" && (xe = X.mod.neg(), ve && xe.negative !== 0 && xe.iadd(B)), {
        div: ge,
        mod: xe
      }) : this.negative === 0 && B.negative !== 0 ? (X = this.divmod(B.neg(), Z), Z !== "mod" && (ge = X.div.neg()), {
        div: ge,
        mod: X.mod
      }) : this.negative & B.negative ? (X = this.neg().divmod(B.neg(), Z), Z !== "div" && (xe = X.mod.neg(), ve && xe.negative !== 0 && xe.isub(B)), {
        div: X.div,
        mod: xe
      }) : B.length > this.length || this.cmp(B) < 0 ? {
        div: new H(0),
        mod: this
      } : B.length === 1 ? Z === "div" ? {
        div: this.divn(B.words[0]),
        mod: null
      } : Z === "mod" ? {
        div: null,
        mod: new H(this.modrn(B.words[0]))
      } : {
        div: this.divn(B.words[0]),
        mod: new H(this.modrn(B.words[0]))
      } : this._wordDiv(B, Z);
    }, H.prototype.div = function(B) {
      return this.divmod(B, "div", !1).div;
    }, H.prototype.mod = function(B) {
      return this.divmod(B, "mod", !1).mod;
    }, H.prototype.umod = function(B) {
      return this.divmod(B, "mod", !0).mod;
    }, H.prototype.divRound = function(B) {
      var Z = this.divmod(B);
      if (Z.mod.isZero()) return Z.div;
      var ve = Z.div.negative !== 0 ? Z.mod.isub(B) : Z.mod, ge = B.ushrn(1), xe = B.andln(1), X = ve.cmp(ge);
      return X < 0 || xe === 1 && X === 0 ? Z.div : Z.div.negative !== 0 ? Z.div.isubn(1) : Z.div.iaddn(1);
    }, H.prototype.modrn = function(B) {
      var Z = B < 0;
      Z && (B = -B), J(B <= 67108863);
      for (var ve = (1 << 26) % B, ge = 0, xe = this.length - 1; xe >= 0; xe--)
        ge = (ve * ge + (this.words[xe] | 0)) % B;
      return Z ? -ge : ge;
    }, H.prototype.modn = function(B) {
      return this.modrn(B);
    }, H.prototype.idivn = function(B) {
      var Z = B < 0;
      Z && (B = -B), J(B <= 67108863);
      for (var ve = 0, ge = this.length - 1; ge >= 0; ge--) {
        var xe = (this.words[ge] | 0) + ve * 67108864;
        this.words[ge] = xe / B | 0, ve = xe % B;
      }
      return this._strip(), Z ? this.ineg() : this;
    }, H.prototype.divn = function(B) {
      return this.clone().idivn(B);
    }, H.prototype.egcd = function(B) {
      J(B.negative === 0), J(!B.isZero());
      var Z = this, ve = B.clone();
      Z.negative !== 0 ? Z = Z.umod(B) : Z = Z.clone();
      for (var ge = new H(1), xe = new H(0), X = new H(0), a = new H(1), Y = 0; Z.isEven() && ve.isEven(); )
        Z.iushrn(1), ve.iushrn(1), ++Y;
      for (var Ne = ve.clone(), Ke = Z.clone(); !Z.isZero(); ) {
        for (var tt = 0, We = 1; !(Z.words[0] & We) && tt < 26; ++tt, We <<= 1) ;
        if (tt > 0)
          for (Z.iushrn(tt); tt-- > 0; )
            (ge.isOdd() || xe.isOdd()) && (ge.iadd(Ne), xe.isub(Ke)), ge.iushrn(1), xe.iushrn(1);
        for (var ot = 0, He = 1; !(ve.words[0] & He) && ot < 26; ++ot, He <<= 1) ;
        if (ot > 0)
          for (ve.iushrn(ot); ot-- > 0; )
            (X.isOdd() || a.isOdd()) && (X.iadd(Ne), a.isub(Ke)), X.iushrn(1), a.iushrn(1);
        Z.cmp(ve) >= 0 ? (Z.isub(ve), ge.isub(X), xe.isub(a)) : (ve.isub(Z), X.isub(ge), a.isub(xe));
      }
      return {
        a: X,
        b: a,
        gcd: ve.iushln(Y)
      };
    }, H.prototype._invmp = function(B) {
      J(B.negative === 0), J(!B.isZero());
      var Z = this, ve = B.clone();
      Z.negative !== 0 ? Z = Z.umod(B) : Z = Z.clone();
      for (var ge = new H(1), xe = new H(0), X = ve.clone(); Z.cmpn(1) > 0 && ve.cmpn(1) > 0; ) {
        for (var a = 0, Y = 1; !(Z.words[0] & Y) && a < 26; ++a, Y <<= 1) ;
        if (a > 0)
          for (Z.iushrn(a); a-- > 0; )
            ge.isOdd() && ge.iadd(X), ge.iushrn(1);
        for (var Ne = 0, Ke = 1; !(ve.words[0] & Ke) && Ne < 26; ++Ne, Ke <<= 1) ;
        if (Ne > 0)
          for (ve.iushrn(Ne); Ne-- > 0; )
            xe.isOdd() && xe.iadd(X), xe.iushrn(1);
        Z.cmp(ve) >= 0 ? (Z.isub(ve), ge.isub(xe)) : (ve.isub(Z), xe.isub(ge));
      }
      var tt;
      return Z.cmpn(1) === 0 ? tt = ge : tt = xe, tt.cmpn(0) < 0 && tt.iadd(B), tt;
    }, H.prototype.gcd = function(B) {
      if (this.isZero()) return B.abs();
      if (B.isZero()) return this.abs();
      var Z = this.clone(), ve = B.clone();
      Z.negative = 0, ve.negative = 0;
      for (var ge = 0; Z.isEven() && ve.isEven(); ge++)
        Z.iushrn(1), ve.iushrn(1);
      do {
        for (; Z.isEven(); )
          Z.iushrn(1);
        for (; ve.isEven(); )
          ve.iushrn(1);
        var xe = Z.cmp(ve);
        if (xe < 0) {
          var X = Z;
          Z = ve, ve = X;
        } else if (xe === 0 || ve.cmpn(1) === 0)
          break;
        Z.isub(ve);
      } while (!0);
      return ve.iushln(ge);
    }, H.prototype.invm = function(B) {
      return this.egcd(B).a.umod(B);
    }, H.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, H.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, H.prototype.andln = function(B) {
      return this.words[0] & B;
    }, H.prototype.bincn = function(B) {
      J(typeof B == "number");
      var Z = B % 26, ve = (B - Z) / 26, ge = 1 << Z;
      if (this.length <= ve)
        return this._expand(ve + 1), this.words[ve] |= ge, this;
      for (var xe = ge, X = ve; xe !== 0 && X < this.length; X++) {
        var a = this.words[X] | 0;
        a += xe, xe = a >>> 26, a &= 67108863, this.words[X] = a;
      }
      return xe !== 0 && (this.words[X] = xe, this.length++), this;
    }, H.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, H.prototype.cmpn = function(B) {
      var Z = B < 0;
      if (this.negative !== 0 && !Z) return -1;
      if (this.negative === 0 && Z) return 1;
      this._strip();
      var ve;
      if (this.length > 1)
        ve = 1;
      else {
        Z && (B = -B), J(B <= 67108863, "Number is too big");
        var ge = this.words[0] | 0;
        ve = ge === B ? 0 : ge < B ? -1 : 1;
      }
      return this.negative !== 0 ? -ve | 0 : ve;
    }, H.prototype.cmp = function(B) {
      if (this.negative !== 0 && B.negative === 0) return -1;
      if (this.negative === 0 && B.negative !== 0) return 1;
      var Z = this.ucmp(B);
      return this.negative !== 0 ? -Z | 0 : Z;
    }, H.prototype.ucmp = function(B) {
      if (this.length > B.length) return 1;
      if (this.length < B.length) return -1;
      for (var Z = 0, ve = this.length - 1; ve >= 0; ve--) {
        var ge = this.words[ve] | 0, xe = B.words[ve] | 0;
        if (ge !== xe) {
          ge < xe ? Z = -1 : ge > xe && (Z = 1);
          break;
        }
      }
      return Z;
    }, H.prototype.gtn = function(B) {
      return this.cmpn(B) === 1;
    }, H.prototype.gt = function(B) {
      return this.cmp(B) === 1;
    }, H.prototype.gten = function(B) {
      return this.cmpn(B) >= 0;
    }, H.prototype.gte = function(B) {
      return this.cmp(B) >= 0;
    }, H.prototype.ltn = function(B) {
      return this.cmpn(B) === -1;
    }, H.prototype.lt = function(B) {
      return this.cmp(B) === -1;
    }, H.prototype.lten = function(B) {
      return this.cmpn(B) <= 0;
    }, H.prototype.lte = function(B) {
      return this.cmp(B) <= 0;
    }, H.prototype.eqn = function(B) {
      return this.cmpn(B) === 0;
    }, H.prototype.eq = function(B) {
      return this.cmp(B) === 0;
    }, H.red = function(B) {
      return new Se(B);
    }, H.prototype.toRed = function(B) {
      return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), B.convertTo(this)._forceRed(B);
    }, H.prototype.fromRed = function() {
      return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, H.prototype._forceRed = function(B) {
      return this.red = B, this;
    }, H.prototype.forceRed = function(B) {
      return J(!this.red, "Already a number in reduction context"), this._forceRed(B);
    }, H.prototype.redAdd = function(B) {
      return J(this.red, "redAdd works only with red numbers"), this.red.add(this, B);
    }, H.prototype.redIAdd = function(B) {
      return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, B);
    }, H.prototype.redSub = function(B) {
      return J(this.red, "redSub works only with red numbers"), this.red.sub(this, B);
    }, H.prototype.redISub = function(B) {
      return J(this.red, "redISub works only with red numbers"), this.red.isub(this, B);
    }, H.prototype.redShl = function(B) {
      return J(this.red, "redShl works only with red numbers"), this.red.shl(this, B);
    }, H.prototype.redMul = function(B) {
      return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, B), this.red.mul(this, B);
    }, H.prototype.redIMul = function(B) {
      return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, B), this.red.imul(this, B);
    }, H.prototype.redSqr = function() {
      return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, H.prototype.redISqr = function() {
      return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, H.prototype.redSqrt = function() {
      return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, H.prototype.redInvm = function() {
      return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, H.prototype.redNeg = function() {
      return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, H.prototype.redPow = function(B) {
      return J(this.red && !B.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, B);
    };
    var lt = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function vt(h, B) {
      this.name = h, this.p = new H(B, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    vt.prototype._tmp = function() {
      var B = new H(null);
      return B.words = new Array(Math.ceil(this.n / 13)), B;
    }, vt.prototype.ireduce = function(B) {
      var Z = B, ve;
      do
        this.split(Z, this.tmp), Z = this.imulK(Z), Z = Z.iadd(this.tmp), ve = Z.bitLength();
      while (ve > this.n);
      var ge = ve < this.n ? -1 : Z.ucmp(this.p);
      return ge === 0 ? (Z.words[0] = 0, Z.length = 1) : ge > 0 ? Z.isub(this.p) : Z.strip !== void 0 ? Z.strip() : Z._strip(), Z;
    }, vt.prototype.split = function(B, Z) {
      B.iushrn(this.n, 0, Z);
    }, vt.prototype.imulK = function(B) {
      return B.imul(this.k);
    };
    function Ye() {
      vt.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    _e(Ye, vt), Ye.prototype.split = function(B, Z) {
      for (var ve = 4194303, ge = Math.min(B.length, 9), xe = 0; xe < ge; xe++)
        Z.words[xe] = B.words[xe];
      if (Z.length = ge, B.length <= 9) {
        B.words[0] = 0, B.length = 1;
        return;
      }
      var X = B.words[9];
      for (Z.words[Z.length++] = X & ve, xe = 10; xe < B.length; xe++) {
        var a = B.words[xe] | 0;
        B.words[xe - 10] = (a & ve) << 4 | X >>> 22, X = a;
      }
      X >>>= 22, B.words[xe - 10] = X, X === 0 && B.length > 10 ? B.length -= 10 : B.length -= 9;
    }, Ye.prototype.imulK = function(B) {
      B.words[B.length] = 0, B.words[B.length + 1] = 0, B.length += 2;
      for (var Z = 0, ve = 0; ve < B.length; ve++) {
        var ge = B.words[ve] | 0;
        Z += ge * 977, B.words[ve] = Z & 67108863, Z = ge * 64 + (Z / 67108864 | 0);
      }
      return B.words[B.length - 1] === 0 && (B.length--, B.words[B.length - 1] === 0 && B.length--), B;
    };
    function pt() {
      vt.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    _e(pt, vt);
    function bt() {
      vt.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    _e(bt, vt);
    function Yt() {
      vt.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    _e(Yt, vt), Yt.prototype.imulK = function(B) {
      for (var Z = 0, ve = 0; ve < B.length; ve++) {
        var ge = (B.words[ve] | 0) * 19 + Z, xe = ge & 67108863;
        ge >>>= 26, B.words[ve] = xe, Z = ge;
      }
      return Z !== 0 && (B.words[B.length++] = Z), B;
    }, H._prime = function(B) {
      if (lt[B]) return lt[B];
      var Z;
      if (B === "k256")
        Z = new Ye();
      else if (B === "p224")
        Z = new pt();
      else if (B === "p192")
        Z = new bt();
      else if (B === "p25519")
        Z = new Yt();
      else
        throw new Error("Unknown prime " + B);
      return lt[B] = Z, Z;
    };
    function Se(h) {
      if (typeof h == "string") {
        var B = H._prime(h);
        this.m = B.p, this.prime = B;
      } else
        J(h.gtn(1), "modulus must be greater than 1"), this.m = h, this.prime = null;
    }
    Se.prototype._verify1 = function(B) {
      J(B.negative === 0, "red works only with positives"), J(B.red, "red works only with red numbers");
    }, Se.prototype._verify2 = function(B, Z) {
      J((B.negative | Z.negative) === 0, "red works only with positives"), J(
        B.red && B.red === Z.red,
        "red works only with red numbers"
      );
    }, Se.prototype.imod = function(B) {
      return this.prime ? this.prime.ireduce(B)._forceRed(this) : (Ee(B, B.umod(this.m)._forceRed(this)), B);
    }, Se.prototype.neg = function(B) {
      return B.isZero() ? B.clone() : this.m.sub(B)._forceRed(this);
    }, Se.prototype.add = function(B, Z) {
      this._verify2(B, Z);
      var ve = B.add(Z);
      return ve.cmp(this.m) >= 0 && ve.isub(this.m), ve._forceRed(this);
    }, Se.prototype.iadd = function(B, Z) {
      this._verify2(B, Z);
      var ve = B.iadd(Z);
      return ve.cmp(this.m) >= 0 && ve.isub(this.m), ve;
    }, Se.prototype.sub = function(B, Z) {
      this._verify2(B, Z);
      var ve = B.sub(Z);
      return ve.cmpn(0) < 0 && ve.iadd(this.m), ve._forceRed(this);
    }, Se.prototype.isub = function(B, Z) {
      this._verify2(B, Z);
      var ve = B.isub(Z);
      return ve.cmpn(0) < 0 && ve.iadd(this.m), ve;
    }, Se.prototype.shl = function(B, Z) {
      return this._verify1(B), this.imod(B.ushln(Z));
    }, Se.prototype.imul = function(B, Z) {
      return this._verify2(B, Z), this.imod(B.imul(Z));
    }, Se.prototype.mul = function(B, Z) {
      return this._verify2(B, Z), this.imod(B.mul(Z));
    }, Se.prototype.isqr = function(B) {
      return this.imul(B, B.clone());
    }, Se.prototype.sqr = function(B) {
      return this.mul(B, B);
    }, Se.prototype.sqrt = function(B) {
      if (B.isZero()) return B.clone();
      var Z = this.m.andln(3);
      if (J(Z % 2 === 1), Z === 3) {
        var ve = this.m.add(new H(1)).iushrn(2);
        return this.pow(B, ve);
      }
      for (var ge = this.m.subn(1), xe = 0; !ge.isZero() && ge.andln(1) === 0; )
        xe++, ge.iushrn(1);
      J(!ge.isZero());
      var X = new H(1).toRed(this), a = X.redNeg(), Y = this.m.subn(1).iushrn(1), Ne = this.m.bitLength();
      for (Ne = new H(2 * Ne * Ne).toRed(this); this.pow(Ne, Y).cmp(a) !== 0; )
        Ne.redIAdd(a);
      for (var Ke = this.pow(Ne, ge), tt = this.pow(B, ge.addn(1).iushrn(1)), We = this.pow(B, ge), ot = xe; We.cmp(X) !== 0; ) {
        for (var He = We, Qe = 0; He.cmp(X) !== 0; Qe++)
          He = He.redSqr();
        J(Qe < ot);
        var nt = this.pow(Ke, new H(1).iushln(ot - Qe - 1));
        tt = tt.redMul(nt), Ke = nt.redSqr(), We = We.redMul(Ke), ot = Qe;
      }
      return tt;
    }, Se.prototype.invm = function(B) {
      var Z = B._invmp(this.m);
      return Z.negative !== 0 ? (Z.negative = 0, this.imod(Z).redNeg()) : this.imod(Z);
    }, Se.prototype.pow = function(B, Z) {
      if (Z.isZero()) return new H(1).toRed(this);
      if (Z.cmpn(1) === 0) return B.clone();
      var ve = 4, ge = new Array(1 << ve);
      ge[0] = new H(1).toRed(this), ge[1] = B;
      for (var xe = 2; xe < ge.length; xe++)
        ge[xe] = this.mul(ge[xe - 1], B);
      var X = ge[0], a = 0, Y = 0, Ne = Z.bitLength() % 26;
      for (Ne === 0 && (Ne = 26), xe = Z.length - 1; xe >= 0; xe--) {
        for (var Ke = Z.words[xe], tt = Ne - 1; tt >= 0; tt--) {
          var We = Ke >> tt & 1;
          if (X !== ge[0] && (X = this.sqr(X)), We === 0 && a === 0) {
            Y = 0;
            continue;
          }
          a <<= 1, a |= We, Y++, !(Y !== ve && (xe !== 0 || tt !== 0)) && (X = this.mul(X, ge[a]), Y = 0, a = 0);
        }
        Ne = 26;
      }
      return X;
    }, Se.prototype.convertTo = function(B) {
      var Z = B.umod(this.m);
      return Z === B ? Z.clone() : Z;
    }, Se.prototype.convertFrom = function(B) {
      var Z = B.clone();
      return Z.red = null, Z;
    }, H.mont = function(B) {
      return new t(B);
    };
    function t(h) {
      Se.call(this, h), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    _e(t, Se), t.prototype.convertTo = function(B) {
      return this.imod(B.ushln(this.shift));
    }, t.prototype.convertFrom = function(B) {
      var Z = this.imod(B.mul(this.rinv));
      return Z.red = null, Z;
    }, t.prototype.imul = function(B, Z) {
      if (B.isZero() || Z.isZero())
        return B.words[0] = 0, B.length = 1, B;
      var ve = B.imul(Z), ge = ve.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), xe = ve.isub(ge).iushrn(this.shift), X = xe;
      return xe.cmp(this.m) >= 0 ? X = xe.isub(this.m) : xe.cmpn(0) < 0 && (X = xe.iadd(this.m)), X._forceRed(this);
    }, t.prototype.mul = function(B, Z) {
      if (B.isZero() || Z.isZero()) return new H(0)._forceRed(this);
      var ve = B.mul(Z), ge = ve.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), xe = ve.isub(ge).iushrn(this.shift), X = xe;
      return xe.cmp(this.m) >= 0 ? X = xe.isub(this.m) : xe.cmpn(0) < 0 && (X = xe.iadd(this.m)), X._forceRed(this);
    }, t.prototype.invm = function(B) {
      var Z = this.imod(B._invmp(this.m).mul(this.r2));
      return Z._forceRed(this);
    };
  })(I, commonjsGlobal);
})(bn$7);
var bnExports$1 = bn$7.exports, sha_js = { exports: {} }, inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(A, G) {
  G && (A.super_ = G, A.prototype = Object.create(G.prototype, {
    constructor: {
      value: A,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser.exports = function(A, G) {
  if (G) {
    A.super_ = G;
    var J = function() {
    };
    J.prototype = G.prototype, A.prototype = new J(), A.prototype.constructor = A;
  }
};
var inherits_browserExports = inherits_browser.exports, safeBuffer$1 = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(I, A) {
  var G = require$$0$3, J = G.Buffer;
  function _e(De, Ie) {
    for (var qe in De)
      Ie[qe] = De[qe];
  }
  J.from && J.alloc && J.allocUnsafe && J.allocUnsafeSlow ? I.exports = G : (_e(G, A), A.Buffer = H);
  function H(De, Ie, qe) {
    return J(De, Ie, qe);
  }
  H.prototype = Object.create(J.prototype), _e(J, H), H.from = function(De, Ie, qe) {
    if (typeof De == "number")
      throw new TypeError("Argument must not be a number");
    return J(De, Ie, qe);
  }, H.alloc = function(De, Ie, qe) {
    if (typeof De != "number")
      throw new TypeError("Argument must be a number");
    var Te = J(De);
    return Ie !== void 0 ? typeof qe == "string" ? Te.fill(Ie, qe) : Te.fill(Ie) : Te.fill(0), Te;
  }, H.allocUnsafe = function(De) {
    if (typeof De != "number")
      throw new TypeError("Argument must be a number");
    return J(De);
  }, H.allocUnsafeSlow = function(De) {
    if (typeof De != "number")
      throw new TypeError("Argument must be a number");
    return G.SlowBuffer(De);
  };
})(safeBuffer$1, safeBuffer$1.exports);
var safeBufferExports = safeBuffer$1.exports, Buffer$6 = safeBufferExports.Buffer;
function Hash$6(I, A) {
  this._block = Buffer$6.alloc(I), this._finalSize = A, this._blockSize = I, this._len = 0;
}
Hash$6.prototype.update = function(I, A) {
  typeof I == "string" && (A = A || "utf8", I = Buffer$6.from(I, A));
  for (var G = this._block, J = this._blockSize, _e = I.length, H = this._len, De = 0; De < _e; ) {
    for (var Ie = H % J, qe = Math.min(_e - De, J - Ie), Te = 0; Te < qe; Te++)
      G[Ie + Te] = I[De + Te];
    H += qe, De += qe, H % J === 0 && this._update(G);
  }
  return this._len += _e, this;
};
Hash$6.prototype.digest = function(I) {
  var A = this._len % this._blockSize;
  this._block[A] = 128, this._block.fill(0, A + 1), A >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var G = this._len * 8;
  if (G <= 4294967295)
    this._block.writeUInt32BE(G, this._blockSize - 4);
  else {
    var J = (G & 4294967295) >>> 0, _e = (G - J) / 4294967296;
    this._block.writeUInt32BE(_e, this._blockSize - 8), this._block.writeUInt32BE(J, this._blockSize - 4);
  }
  this._update(this._block);
  var H = this._hash();
  return I ? H.toString(I) : H;
};
Hash$6.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var hash$4 = Hash$6, inherits$9 = inherits_browserExports, Hash$5 = hash$4, Buffer$5 = safeBufferExports.Buffer, K$5 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], W$5 = new Array(80);
function Sha() {
  this.init(), this._w = W$5, Hash$5.call(this, 64, 56);
}
inherits$9(Sha, Hash$5);
Sha.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rotl5$1(I) {
  return I << 5 | I >>> 27;
}
function rotl30$1(I) {
  return I << 30 | I >>> 2;
}
function ft$1(I, A, G, J) {
  return I === 0 ? A & G | ~A & J : I === 2 ? A & G | A & J | G & J : A ^ G ^ J;
}
Sha.prototype._update = function(I) {
  for (var A = this._w, G = this._a | 0, J = this._b | 0, _e = this._c | 0, H = this._d | 0, De = this._e | 0, Ie = 0; Ie < 16; ++Ie) A[Ie] = I.readInt32BE(Ie * 4);
  for (; Ie < 80; ++Ie) A[Ie] = A[Ie - 3] ^ A[Ie - 8] ^ A[Ie - 14] ^ A[Ie - 16];
  for (var qe = 0; qe < 80; ++qe) {
    var Te = ~~(qe / 20), Ee = rotl5$1(G) + ft$1(Te, J, _e, H) + De + A[qe] + K$5[Te] | 0;
    De = H, H = _e, _e = rotl30$1(J), J = G, G = Ee;
  }
  this._a = G + this._a | 0, this._b = J + this._b | 0, this._c = _e + this._c | 0, this._d = H + this._d | 0, this._e = De + this._e | 0;
};
Sha.prototype._hash = function() {
  var I = Buffer$5.allocUnsafe(20);
  return I.writeInt32BE(this._a | 0, 0), I.writeInt32BE(this._b | 0, 4), I.writeInt32BE(this._c | 0, 8), I.writeInt32BE(this._d | 0, 12), I.writeInt32BE(this._e | 0, 16), I;
};
var sha$1 = Sha, inherits$8 = inherits_browserExports, Hash$4 = hash$4, Buffer$4 = safeBufferExports.Buffer, K$4 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], W$4 = new Array(80);
function Sha1() {
  this.init(), this._w = W$4, Hash$4.call(this, 64, 56);
}
inherits$8(Sha1, Hash$4);
Sha1.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rotl1(I) {
  return I << 1 | I >>> 31;
}
function rotl5(I) {
  return I << 5 | I >>> 27;
}
function rotl30(I) {
  return I << 30 | I >>> 2;
}
function ft(I, A, G, J) {
  return I === 0 ? A & G | ~A & J : I === 2 ? A & G | A & J | G & J : A ^ G ^ J;
}
Sha1.prototype._update = function(I) {
  for (var A = this._w, G = this._a | 0, J = this._b | 0, _e = this._c | 0, H = this._d | 0, De = this._e | 0, Ie = 0; Ie < 16; ++Ie) A[Ie] = I.readInt32BE(Ie * 4);
  for (; Ie < 80; ++Ie) A[Ie] = rotl1(A[Ie - 3] ^ A[Ie - 8] ^ A[Ie - 14] ^ A[Ie - 16]);
  for (var qe = 0; qe < 80; ++qe) {
    var Te = ~~(qe / 20), Ee = rotl5(G) + ft(Te, J, _e, H) + De + A[qe] + K$4[Te] | 0;
    De = H, H = _e, _e = rotl30(J), J = G, G = Ee;
  }
  this._a = G + this._a | 0, this._b = J + this._b | 0, this._c = _e + this._c | 0, this._d = H + this._d | 0, this._e = De + this._e | 0;
};
Sha1.prototype._hash = function() {
  var I = Buffer$4.allocUnsafe(20);
  return I.writeInt32BE(this._a | 0, 0), I.writeInt32BE(this._b | 0, 4), I.writeInt32BE(this._c | 0, 8), I.writeInt32BE(this._d | 0, 12), I.writeInt32BE(this._e | 0, 16), I;
};
var sha1 = Sha1, inherits$7 = inherits_browserExports, Hash$3 = hash$4, Buffer$3 = safeBufferExports.Buffer, K$3 = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], W$3 = new Array(64);
function Sha256$1() {
  this.init(), this._w = W$3, Hash$3.call(this, 64, 56);
}
inherits$7(Sha256$1, Hash$3);
Sha256$1.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function ch(I, A, G) {
  return G ^ I & (A ^ G);
}
function maj$1(I, A, G) {
  return I & A | G & (I | A);
}
function sigma0$1(I) {
  return (I >>> 2 | I << 30) ^ (I >>> 13 | I << 19) ^ (I >>> 22 | I << 10);
}
function sigma1$1(I) {
  return (I >>> 6 | I << 26) ^ (I >>> 11 | I << 21) ^ (I >>> 25 | I << 7);
}
function gamma0(I) {
  return (I >>> 7 | I << 25) ^ (I >>> 18 | I << 14) ^ I >>> 3;
}
function gamma1(I) {
  return (I >>> 17 | I << 15) ^ (I >>> 19 | I << 13) ^ I >>> 10;
}
Sha256$1.prototype._update = function(I) {
  for (var A = this._w, G = this._a | 0, J = this._b | 0, _e = this._c | 0, H = this._d | 0, De = this._e | 0, Ie = this._f | 0, qe = this._g | 0, Te = this._h | 0, Ee = 0; Ee < 16; ++Ee) A[Ee] = I.readInt32BE(Ee * 4);
  for (; Ee < 64; ++Ee) A[Ee] = gamma1(A[Ee - 2]) + A[Ee - 7] + gamma0(A[Ee - 15]) + A[Ee - 16] | 0;
  for (var Oe = 0; Oe < 64; ++Oe) {
    var Le = Te + sigma1$1(De) + ch(De, Ie, qe) + K$3[Oe] + A[Oe] | 0, ke = sigma0$1(G) + maj$1(G, J, _e) | 0;
    Te = qe, qe = Ie, Ie = De, De = H + Le | 0, H = _e, _e = J, J = G, G = Le + ke | 0;
  }
  this._a = G + this._a | 0, this._b = J + this._b | 0, this._c = _e + this._c | 0, this._d = H + this._d | 0, this._e = De + this._e | 0, this._f = Ie + this._f | 0, this._g = qe + this._g | 0, this._h = Te + this._h | 0;
};
Sha256$1.prototype._hash = function() {
  var I = Buffer$3.allocUnsafe(32);
  return I.writeInt32BE(this._a, 0), I.writeInt32BE(this._b, 4), I.writeInt32BE(this._c, 8), I.writeInt32BE(this._d, 12), I.writeInt32BE(this._e, 16), I.writeInt32BE(this._f, 20), I.writeInt32BE(this._g, 24), I.writeInt32BE(this._h, 28), I;
};
var sha256$2 = Sha256$1, inherits$6 = inherits_browserExports, Sha256 = sha256$2, Hash$2 = hash$4, Buffer$2 = safeBufferExports.Buffer, W$2 = new Array(64);
function Sha224() {
  this.init(), this._w = W$2, Hash$2.call(this, 64, 56);
}
inherits$6(Sha224, Sha256);
Sha224.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
Sha224.prototype._hash = function() {
  var I = Buffer$2.allocUnsafe(28);
  return I.writeInt32BE(this._a, 0), I.writeInt32BE(this._b, 4), I.writeInt32BE(this._c, 8), I.writeInt32BE(this._d, 12), I.writeInt32BE(this._e, 16), I.writeInt32BE(this._f, 20), I.writeInt32BE(this._g, 24), I;
};
var sha224$1 = Sha224, inherits$5 = inherits_browserExports, Hash$1 = hash$4, Buffer$1 = safeBufferExports.Buffer, K$2 = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], W$1 = new Array(160);
function Sha512() {
  this.init(), this._w = W$1, Hash$1.call(this, 128, 112);
}
inherits$5(Sha512, Hash$1);
Sha512.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function Ch(I, A, G) {
  return G ^ I & (A ^ G);
}
function maj(I, A, G) {
  return I & A | G & (I | A);
}
function sigma0(I, A) {
  return (I >>> 28 | A << 4) ^ (A >>> 2 | I << 30) ^ (A >>> 7 | I << 25);
}
function sigma1(I, A) {
  return (I >>> 14 | A << 18) ^ (I >>> 18 | A << 14) ^ (A >>> 9 | I << 23);
}
function Gamma0(I, A) {
  return (I >>> 1 | A << 31) ^ (I >>> 8 | A << 24) ^ I >>> 7;
}
function Gamma0l(I, A) {
  return (I >>> 1 | A << 31) ^ (I >>> 8 | A << 24) ^ (I >>> 7 | A << 25);
}
function Gamma1(I, A) {
  return (I >>> 19 | A << 13) ^ (A >>> 29 | I << 3) ^ I >>> 6;
}
function Gamma1l(I, A) {
  return (I >>> 19 | A << 13) ^ (A >>> 29 | I << 3) ^ (I >>> 6 | A << 26);
}
function getCarry(I, A) {
  return I >>> 0 < A >>> 0 ? 1 : 0;
}
Sha512.prototype._update = function(I) {
  for (var A = this._w, G = this._ah | 0, J = this._bh | 0, _e = this._ch | 0, H = this._dh | 0, De = this._eh | 0, Ie = this._fh | 0, qe = this._gh | 0, Te = this._hh | 0, Ee = this._al | 0, Oe = this._bl | 0, Le = this._cl | 0, ke = this._dl | 0, Fe = this._el | 0, Ge = this._fl | 0, et = this._gl | 0, Ve = this._hl | 0, Je = 0; Je < 32; Je += 2)
    A[Je] = I.readInt32BE(Je * 4), A[Je + 1] = I.readInt32BE(Je * 4 + 4);
  for (; Je < 160; Je += 2) {
    var ut = A[Je - 30], rt = A[Je - 15 * 2 + 1], lt = Gamma0(ut, rt), vt = Gamma0l(rt, ut);
    ut = A[Je - 2 * 2], rt = A[Je - 2 * 2 + 1];
    var Ye = Gamma1(ut, rt), pt = Gamma1l(rt, ut), bt = A[Je - 7 * 2], Yt = A[Je - 7 * 2 + 1], Se = A[Je - 16 * 2], t = A[Je - 16 * 2 + 1], h = vt + Yt | 0, B = lt + bt + getCarry(h, vt) | 0;
    h = h + pt | 0, B = B + Ye + getCarry(h, pt) | 0, h = h + t | 0, B = B + Se + getCarry(h, t) | 0, A[Je] = B, A[Je + 1] = h;
  }
  for (var Z = 0; Z < 160; Z += 2) {
    B = A[Z], h = A[Z + 1];
    var ve = maj(G, J, _e), ge = maj(Ee, Oe, Le), xe = sigma0(G, Ee), X = sigma0(Ee, G), a = sigma1(De, Fe), Y = sigma1(Fe, De), Ne = K$2[Z], Ke = K$2[Z + 1], tt = Ch(De, Ie, qe), We = Ch(Fe, Ge, et), ot = Ve + Y | 0, He = Te + a + getCarry(ot, Ve) | 0;
    ot = ot + We | 0, He = He + tt + getCarry(ot, We) | 0, ot = ot + Ke | 0, He = He + Ne + getCarry(ot, Ke) | 0, ot = ot + h | 0, He = He + B + getCarry(ot, h) | 0;
    var Qe = X + ge | 0, nt = xe + ve + getCarry(Qe, X) | 0;
    Te = qe, Ve = et, qe = Ie, et = Ge, Ie = De, Ge = Fe, Fe = ke + ot | 0, De = H + He + getCarry(Fe, ke) | 0, H = _e, ke = Le, _e = J, Le = Oe, J = G, Oe = Ee, Ee = ot + Qe | 0, G = He + nt + getCarry(Ee, ot) | 0;
  }
  this._al = this._al + Ee | 0, this._bl = this._bl + Oe | 0, this._cl = this._cl + Le | 0, this._dl = this._dl + ke | 0, this._el = this._el + Fe | 0, this._fl = this._fl + Ge | 0, this._gl = this._gl + et | 0, this._hl = this._hl + Ve | 0, this._ah = this._ah + G + getCarry(this._al, Ee) | 0, this._bh = this._bh + J + getCarry(this._bl, Oe) | 0, this._ch = this._ch + _e + getCarry(this._cl, Le) | 0, this._dh = this._dh + H + getCarry(this._dl, ke) | 0, this._eh = this._eh + De + getCarry(this._el, Fe) | 0, this._fh = this._fh + Ie + getCarry(this._fl, Ge) | 0, this._gh = this._gh + qe + getCarry(this._gl, et) | 0, this._hh = this._hh + Te + getCarry(this._hl, Ve) | 0;
};
Sha512.prototype._hash = function() {
  var I = Buffer$1.allocUnsafe(64);
  function A(G, J, _e) {
    I.writeInt32BE(G, _e), I.writeInt32BE(J, _e + 4);
  }
  return A(this._ah, this._al, 0), A(this._bh, this._bl, 8), A(this._ch, this._cl, 16), A(this._dh, this._dl, 24), A(this._eh, this._el, 32), A(this._fh, this._fl, 40), A(this._gh, this._gl, 48), A(this._hh, this._hl, 56), I;
};
var sha512$2 = Sha512, inherits$4 = inherits_browserExports, SHA512$2 = sha512$2, Hash = hash$4, Buffer = safeBufferExports.Buffer, W = new Array(160);
function Sha384() {
  this.init(), this._w = W, Hash.call(this, 128, 112);
}
inherits$4(Sha384, SHA512$2);
Sha384.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
Sha384.prototype._hash = function() {
  var I = Buffer.allocUnsafe(48);
  function A(G, J, _e) {
    I.writeInt32BE(G, _e), I.writeInt32BE(J, _e + 4);
  }
  return A(this._ah, this._al, 0), A(this._bh, this._bl, 8), A(this._ch, this._cl, 16), A(this._dh, this._dl, 24), A(this._eh, this._el, 32), A(this._fh, this._fl, 40), I;
};
var sha384$1 = Sha384, exports = sha_js.exports = function(A) {
  A = A.toLowerCase();
  var G = exports[A];
  if (!G) throw new Error(A + " is not supported (we accept pull requests)");
  return new G();
};
exports.sha = sha$1;
exports.sha1 = sha1;
exports.sha224 = sha224$1;
exports.sha256 = sha256$2;
exports.sha384 = sha384$1;
exports.sha512 = sha512$2;
var sha_jsExports = sha_js.exports, readableBrowser$1 = { exports: {} }, events = { exports: {} }, R$1 = typeof Reflect == "object" ? Reflect : null, ReflectApply = R$1 && typeof R$1.apply == "function" ? R$1.apply : function(A, G, J) {
  return Function.prototype.apply.call(A, G, J);
}, ReflectOwnKeys;
R$1 && typeof R$1.ownKeys == "function" ? ReflectOwnKeys = R$1.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(A) {
  return Object.getOwnPropertyNames(A).concat(Object.getOwnPropertySymbols(A));
} : ReflectOwnKeys = function(A) {
  return Object.getOwnPropertyNames(A);
};
function ProcessEmitWarning(I) {
  console && console.warn && console.warn(I);
}
var NumberIsNaN = Number.isNaN || function(A) {
  return A !== A;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once$2;
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(I) {
  if (typeof I != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof I);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(I) {
    if (typeof I != "number" || I < 0 || NumberIsNaN(I))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + I + ".");
    defaultMaxListeners = I;
  }
});
EventEmitter.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function(A) {
  if (typeof A != "number" || A < 0 || NumberIsNaN(A))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + A + ".");
  return this._maxListeners = A, this;
};
function _getMaxListeners(I) {
  return I._maxListeners === void 0 ? EventEmitter.defaultMaxListeners : I._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function(A) {
  for (var G = [], J = 1; J < arguments.length; J++) G.push(arguments[J]);
  var _e = A === "error", H = this._events;
  if (H !== void 0)
    _e = _e && H.error === void 0;
  else if (!_e)
    return !1;
  if (_e) {
    var De;
    if (G.length > 0 && (De = G[0]), De instanceof Error)
      throw De;
    var Ie = new Error("Unhandled error." + (De ? " (" + De.message + ")" : ""));
    throw Ie.context = De, Ie;
  }
  var qe = H[A];
  if (qe === void 0)
    return !1;
  if (typeof qe == "function")
    ReflectApply(qe, this, G);
  else
    for (var Te = qe.length, Ee = arrayClone(qe, Te), J = 0; J < Te; ++J)
      ReflectApply(Ee[J], this, G);
  return !0;
};
function _addListener(I, A, G, J) {
  var _e, H, De;
  if (checkListener(G), H = I._events, H === void 0 ? (H = I._events = /* @__PURE__ */ Object.create(null), I._eventsCount = 0) : (H.newListener !== void 0 && (I.emit(
    "newListener",
    A,
    G.listener ? G.listener : G
  ), H = I._events), De = H[A]), De === void 0)
    De = H[A] = G, ++I._eventsCount;
  else if (typeof De == "function" ? De = H[A] = J ? [G, De] : [De, G] : J ? De.unshift(G) : De.push(G), _e = _getMaxListeners(I), _e > 0 && De.length > _e && !De.warned) {
    De.warned = !0;
    var Ie = new Error("Possible EventEmitter memory leak detected. " + De.length + " " + String(A) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    Ie.name = "MaxListenersExceededWarning", Ie.emitter = I, Ie.type = A, Ie.count = De.length, ProcessEmitWarning(Ie);
  }
  return I;
}
EventEmitter.prototype.addListener = function(A, G) {
  return _addListener(this, A, G, !1);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function(A, G) {
  return _addListener(this, A, G, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(I, A, G) {
  var J = { fired: !1, wrapFn: void 0, target: I, type: A, listener: G }, _e = onceWrapper.bind(J);
  return _e.listener = G, J.wrapFn = _e, _e;
}
EventEmitter.prototype.once = function(A, G) {
  return checkListener(G), this.on(A, _onceWrap(this, A, G)), this;
};
EventEmitter.prototype.prependOnceListener = function(A, G) {
  return checkListener(G), this.prependListener(A, _onceWrap(this, A, G)), this;
};
EventEmitter.prototype.removeListener = function(A, G) {
  var J, _e, H, De, Ie;
  if (checkListener(G), _e = this._events, _e === void 0)
    return this;
  if (J = _e[A], J === void 0)
    return this;
  if (J === G || J.listener === G)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete _e[A], _e.removeListener && this.emit("removeListener", A, J.listener || G));
  else if (typeof J != "function") {
    for (H = -1, De = J.length - 1; De >= 0; De--)
      if (J[De] === G || J[De].listener === G) {
        Ie = J[De].listener, H = De;
        break;
      }
    if (H < 0)
      return this;
    H === 0 ? J.shift() : spliceOne(J, H), J.length === 1 && (_e[A] = J[0]), _e.removeListener !== void 0 && this.emit("removeListener", A, Ie || G);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function(A) {
  var G, J, _e;
  if (J = this._events, J === void 0)
    return this;
  if (J.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : J[A] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete J[A]), this;
  if (arguments.length === 0) {
    var H = Object.keys(J), De;
    for (_e = 0; _e < H.length; ++_e)
      De = H[_e], De !== "removeListener" && this.removeAllListeners(De);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (G = J[A], typeof G == "function")
    this.removeListener(A, G);
  else if (G !== void 0)
    for (_e = G.length - 1; _e >= 0; _e--)
      this.removeListener(A, G[_e]);
  return this;
};
function _listeners(I, A, G) {
  var J = I._events;
  if (J === void 0)
    return [];
  var _e = J[A];
  return _e === void 0 ? [] : typeof _e == "function" ? G ? [_e.listener || _e] : [_e] : G ? unwrapListeners(_e) : arrayClone(_e, _e.length);
}
EventEmitter.prototype.listeners = function(A) {
  return _listeners(this, A, !0);
};
EventEmitter.prototype.rawListeners = function(A) {
  return _listeners(this, A, !1);
};
EventEmitter.listenerCount = function(I, A) {
  return typeof I.listenerCount == "function" ? I.listenerCount(A) : listenerCount.call(I, A);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(I) {
  var A = this._events;
  if (A !== void 0) {
    var G = A[I];
    if (typeof G == "function")
      return 1;
    if (G !== void 0)
      return G.length;
  }
  return 0;
}
EventEmitter.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(I, A) {
  for (var G = new Array(A), J = 0; J < A; ++J)
    G[J] = I[J];
  return G;
}
function spliceOne(I, A) {
  for (; A + 1 < I.length; A++)
    I[A] = I[A + 1];
  I.pop();
}
function unwrapListeners(I) {
  for (var A = new Array(I.length), G = 0; G < A.length; ++G)
    A[G] = I[G].listener || I[G];
  return A;
}
function once$2(I, A) {
  return new Promise(function(G, J) {
    function _e(De) {
      I.removeListener(A, H), J(De);
    }
    function H() {
      typeof I.removeListener == "function" && I.removeListener("error", _e), G([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(I, A, H, { once: !0 }), A !== "error" && addErrorHandlerIfEventEmitter(I, _e, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(I, A, G) {
  typeof I.on == "function" && eventTargetAgnosticAddListener(I, "error", A, G);
}
function eventTargetAgnosticAddListener(I, A, G, J) {
  if (typeof I.on == "function")
    J.once ? I.once(A, G) : I.on(A, G);
  else if (typeof I.addEventListener == "function")
    I.addEventListener(A, function _e(H) {
      J.once && I.removeEventListener(A, _e), G(H);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof I);
}
var eventsExports = events.exports;
const Jg = /* @__PURE__ */ getDefaultExportFromCjs(eventsExports);
var streamBrowser$1 = eventsExports.EventEmitter, util$1 = {}, types$1 = {}, shams$1 = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var A = {}, G = Symbol("test"), J = Object(G);
  if (typeof G == "string" || Object.prototype.toString.call(G) !== "[object Symbol]" || Object.prototype.toString.call(J) !== "[object Symbol]")
    return !1;
  var _e = 42;
  A[G] = _e;
  for (G in A)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(A).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(A).length !== 0)
    return !1;
  var H = Object.getOwnPropertySymbols(A);
  if (H.length !== 1 || H[0] !== G || !Object.prototype.propertyIsEnumerable.call(A, G))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var De = Object.getOwnPropertyDescriptor(A, G);
    if (De.value !== _e || De.enumerable !== !0)
      return !1;
  }
  return !0;
}, hasSymbols$2 = shams$1, shams = function() {
  return hasSymbols$2() && !!Symbol.toStringTag;
}, esErrors = Error, _eval = EvalError, range = RangeError, ref = ReferenceError, syntax = SyntaxError, type = TypeError, uri = URIError, origSymbol = typeof Symbol < "u" && Symbol, hasSymbolSham = shams$1, hasSymbols$1 = function() {
  return typeof origSymbol != "function" || typeof Symbol != "function" || typeof origSymbol("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : hasSymbolSham();
}, test = {
  __proto__: null,
  foo: {}
}, $Object = Object, hasProto$1 = function() {
  return { __proto__: test }.foo === test.foo && !(test instanceof $Object);
}, ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", toStr$3 = Object.prototype.toString, max = Math.max, funcType = "[object Function]", concatty = function(A, G) {
  for (var J = [], _e = 0; _e < A.length; _e += 1)
    J[_e] = A[_e];
  for (var H = 0; H < G.length; H += 1)
    J[H + A.length] = G[H];
  return J;
}, slicy = function(A, G) {
  for (var J = [], _e = G, H = 0; _e < A.length; _e += 1, H += 1)
    J[H] = A[_e];
  return J;
}, joiny = function(I, A) {
  for (var G = "", J = 0; J < I.length; J += 1)
    G += I[J], J + 1 < I.length && (G += A);
  return G;
}, implementation$1 = function(A) {
  var G = this;
  if (typeof G != "function" || toStr$3.apply(G) !== funcType)
    throw new TypeError(ERROR_MESSAGE + G);
  for (var J = slicy(arguments, 1), _e, H = function() {
    if (this instanceof _e) {
      var Ee = G.apply(
        this,
        concatty(J, arguments)
      );
      return Object(Ee) === Ee ? Ee : this;
    }
    return G.apply(
      A,
      concatty(J, arguments)
    );
  }, De = max(0, G.length - J.length), Ie = [], qe = 0; qe < De; qe++)
    Ie[qe] = "$" + qe;
  if (_e = Function("binder", "return function (" + joiny(Ie, ",") + "){ return binder.apply(this,arguments); }")(H), G.prototype) {
    var Te = function() {
    };
    Te.prototype = G.prototype, _e.prototype = new Te(), Te.prototype = null;
  }
  return _e;
}, implementation = implementation$1, functionBind = Function.prototype.bind || implementation, call$1 = Function.prototype.call, $hasOwn = Object.prototype.hasOwnProperty, bind$2 = functionBind, hasown = bind$2.call(call$1, $hasOwn), undefined$1, $Error = esErrors, $EvalError = _eval, $RangeError = range, $ReferenceError = ref, $SyntaxError$1 = syntax, $TypeError$2 = type, $URIError = uri, $Function = Function, getEvalledConstructor = function(I) {
  try {
    return $Function('"use strict"; return (' + I + ").constructor;")();
  } catch {
  }
}, $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1)
  try {
    $gOPD$1({}, "");
  } catch {
    $gOPD$1 = null;
  }
var throwTypeError = function() {
  throw new $TypeError$2();
}, ThrowTypeError = $gOPD$1 ? function() {
  try {
    return arguments.callee, throwTypeError;
  } catch {
    try {
      return $gOPD$1(arguments, "callee").get;
    } catch {
      return throwTypeError;
    }
  }
}() : throwTypeError, hasSymbols = hasSymbols$1(), hasProto = hasProto$1(), getProto$1 = Object.getPrototypeOf || (hasProto ? function(I) {
  return I.__proto__;
} : null), needsEval = {}, TypedArray = typeof Uint8Array > "u" || !getProto$1 ? undefined$1 : getProto$1(Uint8Array), INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics > "u" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$1,
  "%Map%": typeof Map > "u" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols && getProto$1 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$2,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$1 : WeakSet
};
if (getProto$1)
  try {
    null.error;
  } catch (I) {
    var errorProto = getProto$1(getProto$1(I));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
var doEval = function I(A) {
  var G;
  if (A === "%AsyncFunction%")
    G = getEvalledConstructor("async function () {}");
  else if (A === "%GeneratorFunction%")
    G = getEvalledConstructor("function* () {}");
  else if (A === "%AsyncGeneratorFunction%")
    G = getEvalledConstructor("async function* () {}");
  else if (A === "%AsyncGenerator%") {
    var J = I("%AsyncGeneratorFunction%");
    J && (G = J.prototype);
  } else if (A === "%AsyncIteratorPrototype%") {
    var _e = I("%AsyncGenerator%");
    _e && getProto$1 && (G = getProto$1(_e.prototype));
  }
  return INTRINSICS[A] = G, G;
}, LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind$1 = functionBind, hasOwn = hasown, $concat = bind$1.call(Function.call, Array.prototype.concat), $spliceApply = bind$1.call(Function.apply, Array.prototype.splice), $replace = bind$1.call(Function.call, String.prototype.replace), $strSlice = bind$1.call(Function.call, String.prototype.slice), $exec = bind$1.call(Function.call, RegExp.prototype.exec), rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = function(A) {
  var G = $strSlice(A, 0, 1), J = $strSlice(A, -1);
  if (G === "%" && J !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  if (J === "%" && G !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  var _e = [];
  return $replace(A, rePropName, function(H, De, Ie, qe) {
    _e[_e.length] = Ie ? $replace(qe, reEscapeChar, "$1") : De || H;
  }), _e;
}, getBaseIntrinsic = function(A, G) {
  var J = A, _e;
  if (hasOwn(LEGACY_ALIASES, J) && (_e = LEGACY_ALIASES[J], J = "%" + _e[0] + "%"), hasOwn(INTRINSICS, J)) {
    var H = INTRINSICS[J];
    if (H === needsEval && (H = doEval(J)), typeof H > "u" && !G)
      throw new $TypeError$2("intrinsic " + A + " exists, but is not available. Please file an issue!");
    return {
      alias: _e,
      name: J,
      value: H
    };
  }
  throw new $SyntaxError$1("intrinsic " + A + " does not exist!");
}, getIntrinsic = function(A, G) {
  if (typeof A != "string" || A.length === 0)
    throw new $TypeError$2("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof G != "boolean")
    throw new $TypeError$2('"allowMissing" argument must be a boolean');
  if ($exec(/^%?[^%]*%?$/, A) === null)
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var J = stringToPath(A), _e = J.length > 0 ? J[0] : "", H = getBaseIntrinsic("%" + _e + "%", G), De = H.name, Ie = H.value, qe = !1, Te = H.alias;
  Te && (_e = Te[0], $spliceApply(J, $concat([0, 1], Te)));
  for (var Ee = 1, Oe = !0; Ee < J.length; Ee += 1) {
    var Le = J[Ee], ke = $strSlice(Le, 0, 1), Fe = $strSlice(Le, -1);
    if ((ke === '"' || ke === "'" || ke === "`" || Fe === '"' || Fe === "'" || Fe === "`") && ke !== Fe)
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    if ((Le === "constructor" || !Oe) && (qe = !0), _e += "." + Le, De = "%" + _e + "%", hasOwn(INTRINSICS, De))
      Ie = INTRINSICS[De];
    else if (Ie != null) {
      if (!(Le in Ie)) {
        if (!G)
          throw new $TypeError$2("base intrinsic for " + A + " exists, but the property is not available.");
        return;
      }
      if ($gOPD$1 && Ee + 1 >= J.length) {
        var Ge = $gOPD$1(Ie, Le);
        Oe = !!Ge, Oe && "get" in Ge && !("originalValue" in Ge.get) ? Ie = Ge.get : Ie = Ie[Le];
      } else
        Oe = hasOwn(Ie, Le), Ie = Ie[Le];
      Oe && !qe && (INTRINSICS[De] = Ie);
    }
  }
  return Ie;
}, callBind$2 = { exports: {} }, esDefineProperty, hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var I = getIntrinsic, A = I("%Object.defineProperty%", !0) || !1;
  if (A)
    try {
      A({}, "a", { value: 1 });
    } catch {
      A = !1;
    }
  return esDefineProperty = A, esDefineProperty;
}
var GetIntrinsic$2 = getIntrinsic, $gOPD = GetIntrinsic$2("%Object.getOwnPropertyDescriptor%", !0);
if ($gOPD)
  try {
    $gOPD([], "length");
  } catch {
    $gOPD = null;
  }
var gopd$1 = $gOPD, $defineProperty$1 = requireEsDefineProperty(), $SyntaxError = syntax, $TypeError$1 = type, gopd = gopd$1, defineDataProperty = function(A, G, J) {
  if (!A || typeof A != "object" && typeof A != "function")
    throw new $TypeError$1("`obj` must be an object or a function`");
  if (typeof G != "string" && typeof G != "symbol")
    throw new $TypeError$1("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new $TypeError$1("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new $TypeError$1("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new $TypeError$1("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new $TypeError$1("`loose`, if provided, must be a boolean");
  var _e = arguments.length > 3 ? arguments[3] : null, H = arguments.length > 4 ? arguments[4] : null, De = arguments.length > 5 ? arguments[5] : null, Ie = arguments.length > 6 ? arguments[6] : !1, qe = !!gopd && gopd(A, G);
  if ($defineProperty$1)
    $defineProperty$1(A, G, {
      configurable: De === null && qe ? qe.configurable : !De,
      enumerable: _e === null && qe ? qe.enumerable : !_e,
      value: J,
      writable: H === null && qe ? qe.writable : !H
    });
  else if (Ie || !_e && !H && !De)
    A[G] = J;
  else
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, $defineProperty = requireEsDefineProperty(), hasPropertyDescriptors = function() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function() {
  if (!$defineProperty)
    return null;
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors, GetIntrinsic$1 = getIntrinsic, define = defineDataProperty, hasDescriptors = hasPropertyDescriptors_1(), gOPD$1 = gopd$1, $TypeError = type, $floor = GetIntrinsic$1("%Math.floor%"), setFunctionLength = function(A, G) {
  if (typeof A != "function")
    throw new $TypeError("`fn` is not a function");
  if (typeof G != "number" || G < 0 || G > 4294967295 || $floor(G) !== G)
    throw new $TypeError("`length` must be a positive 32-bit integer");
  var J = arguments.length > 2 && !!arguments[2], _e = !0, H = !0;
  if ("length" in A && gOPD$1) {
    var De = gOPD$1(A, "length");
    De && !De.configurable && (_e = !1), De && !De.writable && (H = !1);
  }
  return (_e || H || !J) && (hasDescriptors ? define(
    /** @type {Parameters<define>[0]} */
    A,
    "length",
    G,
    !0,
    !0
  ) : define(
    /** @type {Parameters<define>[0]} */
    A,
    "length",
    G
  )), A;
};
(function(I) {
  var A = functionBind, G = getIntrinsic, J = setFunctionLength, _e = type, H = G("%Function.prototype.apply%"), De = G("%Function.prototype.call%"), Ie = G("%Reflect.apply%", !0) || A.call(De, H), qe = requireEsDefineProperty(), Te = G("%Math.max%");
  I.exports = function(Le) {
    if (typeof Le != "function")
      throw new _e("a function is required");
    var ke = Ie(A, De, arguments);
    return J(
      ke,
      1 + Te(0, Le.length - (arguments.length - 1)),
      !0
    );
  };
  var Ee = function() {
    return Ie(A, H, arguments);
  };
  qe ? qe(I.exports, "apply", { value: Ee }) : I.exports.apply = Ee;
})(callBind$2);
var callBindExports = callBind$2.exports, GetIntrinsic = getIntrinsic, callBind$1 = callBindExports, $indexOf$1 = callBind$1(GetIntrinsic("String.prototype.indexOf")), callBound$2 = function(A, G) {
  var J = GetIntrinsic(A, !!G);
  return typeof J == "function" && $indexOf$1(A, ".prototype.") > -1 ? callBind$1(J) : J;
}, hasToStringTag$3 = shams(), callBound$1 = callBound$2, $toString$1 = callBound$1("Object.prototype.toString"), isStandardArguments = function(A) {
  return hasToStringTag$3 && A && typeof A == "object" && Symbol.toStringTag in A ? !1 : $toString$1(A) === "[object Arguments]";
}, isLegacyArguments = function(A) {
  return isStandardArguments(A) ? !0 : A !== null && typeof A == "object" && typeof A.length == "number" && A.length >= 0 && $toString$1(A) !== "[object Array]" && $toString$1(A.callee) === "[object Function]";
}, supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments = supportsStandardArguments ? isStandardArguments : isLegacyArguments, toStr$2 = Object.prototype.toString, fnToStr$1 = Function.prototype.toString, isFnRegex = /^\s*(?:function)?\*/, hasToStringTag$2 = shams(), getProto = Object.getPrototypeOf, getGeneratorFunc = function() {
  if (!hasToStringTag$2)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, GeneratorFunction, isGeneratorFunction = function(A) {
  if (typeof A != "function")
    return !1;
  if (isFnRegex.test(fnToStr$1.call(A)))
    return !0;
  if (!hasToStringTag$2) {
    var G = toStr$2.call(A);
    return G === "[object GeneratorFunction]";
  }
  if (!getProto)
    return !1;
  if (typeof GeneratorFunction > "u") {
    var J = getGeneratorFunc();
    GeneratorFunction = J ? getProto(J) : !1;
  }
  return getProto(A) === GeneratorFunction;
}, fnToStr = Function.prototype.toString, reflectApply = typeof Reflect == "object" && Reflect !== null && Reflect.apply, badArrayLike, isCallableMarker;
if (typeof reflectApply == "function" && typeof Object.defineProperty == "function")
  try {
    badArrayLike = Object.defineProperty({}, "length", {
      get: function() {
        throw isCallableMarker;
      }
    }), isCallableMarker = {}, reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (I) {
    I !== isCallableMarker && (reflectApply = null);
  }
else
  reflectApply = null;
var constructorRegex = /^\s*class\b/, isES6ClassFn = function(A) {
  try {
    var G = fnToStr.call(A);
    return constructorRegex.test(G);
  } catch {
    return !1;
  }
}, tryFunctionObject = function(A) {
  try {
    return isES6ClassFn(A) ? !1 : (fnToStr.call(A), !0);
  } catch {
    return !1;
  }
}, toStr$1 = Object.prototype.toString, objectClass = "[object Object]", fnClass = "[object Function]", genClass = "[object GeneratorFunction]", ddaClass = "[object HTMLAllCollection]", ddaClass2 = "[object HTML document.all class]", ddaClass3 = "[object HTMLCollection]", hasToStringTag$1 = typeof Symbol == "function" && !!Symbol.toStringTag, isIE68 = !(0 in [,]), isDDA = function() {
  return !1;
};
if (typeof document == "object") {
  var all = document.all;
  toStr$1.call(all) === toStr$1.call(document.all) && (isDDA = function(A) {
    if ((isIE68 || !A) && (typeof A > "u" || typeof A == "object"))
      try {
        var G = toStr$1.call(A);
        return (G === ddaClass || G === ddaClass2 || G === ddaClass3 || G === objectClass) && A("") == null;
      } catch {
      }
    return !1;
  });
}
var isCallable$1 = reflectApply ? function(A) {
  if (isDDA(A))
    return !0;
  if (!A || typeof A != "function" && typeof A != "object")
    return !1;
  try {
    reflectApply(A, null, badArrayLike);
  } catch (G) {
    if (G !== isCallableMarker)
      return !1;
  }
  return !isES6ClassFn(A) && tryFunctionObject(A);
} : function(A) {
  if (isDDA(A))
    return !0;
  if (!A || typeof A != "function" && typeof A != "object")
    return !1;
  if (hasToStringTag$1)
    return tryFunctionObject(A);
  if (isES6ClassFn(A))
    return !1;
  var G = toStr$1.call(A);
  return G !== fnClass && G !== genClass && !/^\[object HTML/.test(G) ? !1 : tryFunctionObject(A);
}, isCallable = isCallable$1, toStr = Object.prototype.toString, hasOwnProperty = Object.prototype.hasOwnProperty, forEachArray = function(A, G, J) {
  for (var _e = 0, H = A.length; _e < H; _e++)
    hasOwnProperty.call(A, _e) && (J == null ? G(A[_e], _e, A) : G.call(J, A[_e], _e, A));
}, forEachString = function(A, G, J) {
  for (var _e = 0, H = A.length; _e < H; _e++)
    J == null ? G(A.charAt(_e), _e, A) : G.call(J, A.charAt(_e), _e, A);
}, forEachObject = function(A, G, J) {
  for (var _e in A)
    hasOwnProperty.call(A, _e) && (J == null ? G(A[_e], _e, A) : G.call(J, A[_e], _e, A));
}, forEach$1 = function(A, G, J) {
  if (!isCallable(G))
    throw new TypeError("iterator must be a function");
  var _e;
  arguments.length >= 3 && (_e = J), toStr.call(A) === "[object Array]" ? forEachArray(A, G, _e) : typeof A == "string" ? forEachString(A, G, _e) : forEachObject(A, G, _e);
}, forEach_1 = forEach$1, possibleTypedArrayNames = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], possibleNames = possibleTypedArrayNames, g$4 = typeof globalThis > "u" ? commonjsGlobal : globalThis, availableTypedArrays$1 = function() {
  for (var A = [], G = 0; G < possibleNames.length; G++)
    typeof g$4[possibleNames[G]] == "function" && (A[A.length] = possibleNames[G]);
  return A;
}, forEach = forEach_1, availableTypedArrays = availableTypedArrays$1, callBind = callBindExports, callBound = callBound$2, gOPD = gopd$1, $toString = callBound("Object.prototype.toString"), hasToStringTag = shams(), g$3 = typeof globalThis > "u" ? commonjsGlobal : globalThis, typedArrays = availableTypedArrays(), $slice = callBound("String.prototype.slice"), getPrototypeOf = Object.getPrototypeOf, $indexOf = callBound("Array.prototype.indexOf", !0) || function(A, G) {
  for (var J = 0; J < A.length; J += 1)
    if (A[J] === G)
      return J;
  return -1;
}, cache = { __proto__: null };
hasToStringTag && gOPD && getPrototypeOf ? forEach(typedArrays, function(I) {
  var A = new g$3[I]();
  if (Symbol.toStringTag in A) {
    var G = getPrototypeOf(A), J = gOPD(G, Symbol.toStringTag);
    if (!J) {
      var _e = getPrototypeOf(G);
      J = gOPD(_e, Symbol.toStringTag);
    }
    cache["$" + I] = callBind(J.get);
  }
}) : forEach(typedArrays, function(I) {
  var A = new g$3[I](), G = A.slice || A.set;
  G && (cache["$" + I] = callBind(G));
});
var tryTypedArrays = function(A) {
  var G = !1;
  return forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(J, _e) {
      if (!G)
        try {
          "$" + J(A) === _e && (G = $slice(_e, 1));
        } catch {
        }
    }
  ), G;
}, trySlices = function(A) {
  var G = !1;
  return forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(J, _e) {
      if (!G)
        try {
          J(A), G = $slice(_e, 1);
        } catch {
        }
    }
  ), G;
}, whichTypedArray$1 = function(A) {
  if (!A || typeof A != "object")
    return !1;
  if (!hasToStringTag) {
    var G = $slice($toString(A), 8, -1);
    return $indexOf(typedArrays, G) > -1 ? G : G !== "Object" ? !1 : trySlices(A);
  }
  return gOPD ? tryTypedArrays(A) : null;
}, whichTypedArray = whichTypedArray$1, isTypedArray = function(A) {
  return !!whichTypedArray(A);
};
(function(I) {
  var A = isArguments, G = isGeneratorFunction, J = whichTypedArray$1, _e = isTypedArray;
  function H(_t) {
    return _t.call.bind(_t);
  }
  var De = typeof BigInt < "u", Ie = typeof Symbol < "u", qe = H(Object.prototype.toString), Te = H(Number.prototype.valueOf), Ee = H(String.prototype.valueOf), Oe = H(Boolean.prototype.valueOf);
  if (De)
    var Le = H(BigInt.prototype.valueOf);
  if (Ie)
    var ke = H(Symbol.prototype.valueOf);
  function Fe(_t, ni) {
    if (typeof _t != "object")
      return !1;
    try {
      return ni(_t), !0;
    } catch {
      return !1;
    }
  }
  I.isArgumentsObject = A, I.isGeneratorFunction = G, I.isTypedArray = _e;
  function Ge(_t) {
    return typeof Promise < "u" && _t instanceof Promise || _t !== null && typeof _t == "object" && typeof _t.then == "function" && typeof _t.catch == "function";
  }
  I.isPromise = Ge;
  function et(_t) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(_t) : _e(_t) || Ke(_t);
  }
  I.isArrayBufferView = et;
  function Ve(_t) {
    return J(_t) === "Uint8Array";
  }
  I.isUint8Array = Ve;
  function Je(_t) {
    return J(_t) === "Uint8ClampedArray";
  }
  I.isUint8ClampedArray = Je;
  function ut(_t) {
    return J(_t) === "Uint16Array";
  }
  I.isUint16Array = ut;
  function rt(_t) {
    return J(_t) === "Uint32Array";
  }
  I.isUint32Array = rt;
  function lt(_t) {
    return J(_t) === "Int8Array";
  }
  I.isInt8Array = lt;
  function vt(_t) {
    return J(_t) === "Int16Array";
  }
  I.isInt16Array = vt;
  function Ye(_t) {
    return J(_t) === "Int32Array";
  }
  I.isInt32Array = Ye;
  function pt(_t) {
    return J(_t) === "Float32Array";
  }
  I.isFloat32Array = pt;
  function bt(_t) {
    return J(_t) === "Float64Array";
  }
  I.isFloat64Array = bt;
  function Yt(_t) {
    return J(_t) === "BigInt64Array";
  }
  I.isBigInt64Array = Yt;
  function Se(_t) {
    return J(_t) === "BigUint64Array";
  }
  I.isBigUint64Array = Se;
  function t(_t) {
    return qe(_t) === "[object Map]";
  }
  t.working = typeof Map < "u" && t(/* @__PURE__ */ new Map());
  function h(_t) {
    return typeof Map > "u" ? !1 : t.working ? t(_t) : _t instanceof Map;
  }
  I.isMap = h;
  function B(_t) {
    return qe(_t) === "[object Set]";
  }
  B.working = typeof Set < "u" && B(/* @__PURE__ */ new Set());
  function Z(_t) {
    return typeof Set > "u" ? !1 : B.working ? B(_t) : _t instanceof Set;
  }
  I.isSet = Z;
  function ve(_t) {
    return qe(_t) === "[object WeakMap]";
  }
  ve.working = typeof WeakMap < "u" && ve(/* @__PURE__ */ new WeakMap());
  function ge(_t) {
    return typeof WeakMap > "u" ? !1 : ve.working ? ve(_t) : _t instanceof WeakMap;
  }
  I.isWeakMap = ge;
  function xe(_t) {
    return qe(_t) === "[object WeakSet]";
  }
  xe.working = typeof WeakSet < "u" && xe(/* @__PURE__ */ new WeakSet());
  function X(_t) {
    return xe(_t);
  }
  I.isWeakSet = X;
  function a(_t) {
    return qe(_t) === "[object ArrayBuffer]";
  }
  a.working = typeof ArrayBuffer < "u" && a(new ArrayBuffer());
  function Y(_t) {
    return typeof ArrayBuffer > "u" ? !1 : a.working ? a(_t) : _t instanceof ArrayBuffer;
  }
  I.isArrayBuffer = Y;
  function Ne(_t) {
    return qe(_t) === "[object DataView]";
  }
  Ne.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && Ne(new DataView(new ArrayBuffer(1), 0, 1));
  function Ke(_t) {
    return typeof DataView > "u" ? !1 : Ne.working ? Ne(_t) : _t instanceof DataView;
  }
  I.isDataView = Ke;
  var tt = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function We(_t) {
    return qe(_t) === "[object SharedArrayBuffer]";
  }
  function ot(_t) {
    return typeof tt > "u" ? !1 : (typeof We.working > "u" && (We.working = We(new tt())), We.working ? We(_t) : _t instanceof tt);
  }
  I.isSharedArrayBuffer = ot;
  function He(_t) {
    return qe(_t) === "[object AsyncFunction]";
  }
  I.isAsyncFunction = He;
  function Qe(_t) {
    return qe(_t) === "[object Map Iterator]";
  }
  I.isMapIterator = Qe;
  function nt(_t) {
    return qe(_t) === "[object Set Iterator]";
  }
  I.isSetIterator = nt;
  function je(_t) {
    return qe(_t) === "[object Generator]";
  }
  I.isGeneratorObject = je;
  function it(_t) {
    return qe(_t) === "[object WebAssembly.Module]";
  }
  I.isWebAssemblyCompiledModule = it;
  function st(_t) {
    return Fe(_t, Te);
  }
  I.isNumberObject = st;
  function gt(_t) {
    return Fe(_t, Ee);
  }
  I.isStringObject = gt;
  function It(_t) {
    return Fe(_t, Oe);
  }
  I.isBooleanObject = It;
  function At(_t) {
    return De && Fe(_t, Le);
  }
  I.isBigIntObject = At;
  function Et(_t) {
    return Ie && Fe(_t, ke);
  }
  I.isSymbolObject = Et;
  function ei(_t) {
    return st(_t) || gt(_t) || It(_t) || At(_t) || Et(_t);
  }
  I.isBoxedPrimitive = ei;
  function Xt(_t) {
    return typeof Uint8Array < "u" && (Y(_t) || ot(_t));
  }
  I.isAnyArrayBuffer = Xt, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(_t) {
    Object.defineProperty(I, _t, {
      enumerable: !1,
      value: function() {
        throw new Error(_t + " is not supported in userland");
      }
    });
  });
})(types$1);
var isBufferBrowser = function(A) {
  return A && typeof A == "object" && typeof A.copy == "function" && typeof A.fill == "function" && typeof A.readUInt8 == "function";
};
(function(I) {
  var A = Object.getOwnPropertyDescriptors || function(Ke) {
    for (var tt = Object.keys(Ke), We = {}, ot = 0; ot < tt.length; ot++)
      We[tt[ot]] = Object.getOwnPropertyDescriptor(Ke, tt[ot]);
    return We;
  }, G = /%[sdj%]/g;
  I.format = function(Ne) {
    if (!lt(Ne)) {
      for (var Ke = [], tt = 0; tt < arguments.length; tt++)
        Ke.push(De(arguments[tt]));
      return Ke.join(" ");
    }
    for (var tt = 1, We = arguments, ot = We.length, He = String(Ne).replace(G, function(nt) {
      if (nt === "%%") return "%";
      if (tt >= ot) return nt;
      switch (nt) {
        case "%s":
          return String(We[tt++]);
        case "%d":
          return Number(We[tt++]);
        case "%j":
          try {
            return JSON.stringify(We[tt++]);
          } catch {
            return "[Circular]";
          }
        default:
          return nt;
      }
    }), Qe = We[tt]; tt < ot; Qe = We[++tt])
      Je(Qe) || !bt(Qe) ? He += " " + Qe : He += " " + De(Qe);
    return He;
  }, I.deprecate = function(Ne, Ke) {
    if (typeof process$1 < "u" && process$1.noDeprecation === !0)
      return Ne;
    if (typeof process$1 > "u")
      return function() {
        return I.deprecate(Ne, Ke).apply(this, arguments);
      };
    var tt = !1;
    function We() {
      if (!tt) {
        if (process$1.throwDeprecation)
          throw new Error(Ke);
        process$1.traceDeprecation ? console.trace(Ke) : console.error(Ke), tt = !0;
      }
      return Ne.apply(this, arguments);
    }
    return We;
  };
  var J = {}, _e = /^$/;
  if (process$1.env.NODE_DEBUG) {
    var H = process$1.env.NODE_DEBUG;
    H = H.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), _e = new RegExp("^" + H + "$", "i");
  }
  I.debuglog = function(Ne) {
    if (Ne = Ne.toUpperCase(), !J[Ne])
      if (_e.test(Ne)) {
        var Ke = process$1.pid;
        J[Ne] = function() {
          var tt = I.format.apply(I, arguments);
          console.error("%s %d: %s", Ne, Ke, tt);
        };
      } else
        J[Ne] = function() {
        };
    return J[Ne];
  };
  function De(Ne, Ke) {
    var tt = {
      seen: [],
      stylize: qe
    };
    return arguments.length >= 3 && (tt.depth = arguments[2]), arguments.length >= 4 && (tt.colors = arguments[3]), Ve(Ke) ? tt.showHidden = Ke : Ke && I._extend(tt, Ke), Ye(tt.showHidden) && (tt.showHidden = !1), Ye(tt.depth) && (tt.depth = 2), Ye(tt.colors) && (tt.colors = !1), Ye(tt.customInspect) && (tt.customInspect = !0), tt.colors && (tt.stylize = Ie), Ee(tt, Ne, tt.depth);
  }
  I.inspect = De, De.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, De.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function Ie(Ne, Ke) {
    var tt = De.styles[Ke];
    return tt ? "\x1B[" + De.colors[tt][0] + "m" + Ne + "\x1B[" + De.colors[tt][1] + "m" : Ne;
  }
  function qe(Ne, Ke) {
    return Ne;
  }
  function Te(Ne) {
    var Ke = {};
    return Ne.forEach(function(tt, We) {
      Ke[tt] = !0;
    }), Ke;
  }
  function Ee(Ne, Ke, tt) {
    if (Ne.customInspect && Ke && t(Ke.inspect) && // Filter out the util module, it's inspect function is special
    Ke.inspect !== I.inspect && // Also filter out any prototype objects using the circular check.
    !(Ke.constructor && Ke.constructor.prototype === Ke)) {
      var We = Ke.inspect(tt, Ne);
      return lt(We) || (We = Ee(Ne, We, tt)), We;
    }
    var ot = Oe(Ne, Ke);
    if (ot)
      return ot;
    var He = Object.keys(Ke), Qe = Te(He);
    if (Ne.showHidden && (He = Object.getOwnPropertyNames(Ke)), Se(Ke) && (He.indexOf("message") >= 0 || He.indexOf("description") >= 0))
      return Le(Ke);
    if (He.length === 0) {
      if (t(Ke)) {
        var nt = Ke.name ? ": " + Ke.name : "";
        return Ne.stylize("[Function" + nt + "]", "special");
      }
      if (pt(Ke))
        return Ne.stylize(RegExp.prototype.toString.call(Ke), "regexp");
      if (Yt(Ke))
        return Ne.stylize(Date.prototype.toString.call(Ke), "date");
      if (Se(Ke))
        return Le(Ke);
    }
    var je = "", it = !1, st = ["{", "}"];
    if (et(Ke) && (it = !0, st = ["[", "]"]), t(Ke)) {
      var gt = Ke.name ? ": " + Ke.name : "";
      je = " [Function" + gt + "]";
    }
    if (pt(Ke) && (je = " " + RegExp.prototype.toString.call(Ke)), Yt(Ke) && (je = " " + Date.prototype.toUTCString.call(Ke)), Se(Ke) && (je = " " + Le(Ke)), He.length === 0 && (!it || Ke.length == 0))
      return st[0] + je + st[1];
    if (tt < 0)
      return pt(Ke) ? Ne.stylize(RegExp.prototype.toString.call(Ke), "regexp") : Ne.stylize("[Object]", "special");
    Ne.seen.push(Ke);
    var It;
    return it ? It = ke(Ne, Ke, tt, Qe, He) : It = He.map(function(At) {
      return Fe(Ne, Ke, tt, Qe, At, it);
    }), Ne.seen.pop(), Ge(It, je, st);
  }
  function Oe(Ne, Ke) {
    if (Ye(Ke))
      return Ne.stylize("undefined", "undefined");
    if (lt(Ke)) {
      var tt = "'" + JSON.stringify(Ke).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return Ne.stylize(tt, "string");
    }
    if (rt(Ke))
      return Ne.stylize("" + Ke, "number");
    if (Ve(Ke))
      return Ne.stylize("" + Ke, "boolean");
    if (Je(Ke))
      return Ne.stylize("null", "null");
  }
  function Le(Ne) {
    return "[" + Error.prototype.toString.call(Ne) + "]";
  }
  function ke(Ne, Ke, tt, We, ot) {
    for (var He = [], Qe = 0, nt = Ke.length; Qe < nt; ++Qe)
      xe(Ke, String(Qe)) ? He.push(Fe(
        Ne,
        Ke,
        tt,
        We,
        String(Qe),
        !0
      )) : He.push("");
    return ot.forEach(function(je) {
      je.match(/^\d+$/) || He.push(Fe(
        Ne,
        Ke,
        tt,
        We,
        je,
        !0
      ));
    }), He;
  }
  function Fe(Ne, Ke, tt, We, ot, He) {
    var Qe, nt, je;
    if (je = Object.getOwnPropertyDescriptor(Ke, ot) || { value: Ke[ot] }, je.get ? je.set ? nt = Ne.stylize("[Getter/Setter]", "special") : nt = Ne.stylize("[Getter]", "special") : je.set && (nt = Ne.stylize("[Setter]", "special")), xe(We, ot) || (Qe = "[" + ot + "]"), nt || (Ne.seen.indexOf(je.value) < 0 ? (Je(tt) ? nt = Ee(Ne, je.value, null) : nt = Ee(Ne, je.value, tt - 1), nt.indexOf(`
`) > -1 && (He ? nt = nt.split(`
`).map(function(it) {
      return "  " + it;
    }).join(`
`).slice(2) : nt = `
` + nt.split(`
`).map(function(it) {
      return "   " + it;
    }).join(`
`))) : nt = Ne.stylize("[Circular]", "special")), Ye(Qe)) {
      if (He && ot.match(/^\d+$/))
        return nt;
      Qe = JSON.stringify("" + ot), Qe.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Qe = Qe.slice(1, -1), Qe = Ne.stylize(Qe, "name")) : (Qe = Qe.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Qe = Ne.stylize(Qe, "string"));
    }
    return Qe + ": " + nt;
  }
  function Ge(Ne, Ke, tt) {
    var We = Ne.reduce(function(ot, He) {
      return He.indexOf(`
`) >= 0, ot + He.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return We > 60 ? tt[0] + (Ke === "" ? "" : Ke + `
 `) + " " + Ne.join(`,
  `) + " " + tt[1] : tt[0] + Ke + " " + Ne.join(", ") + " " + tt[1];
  }
  I.types = types$1;
  function et(Ne) {
    return Array.isArray(Ne);
  }
  I.isArray = et;
  function Ve(Ne) {
    return typeof Ne == "boolean";
  }
  I.isBoolean = Ve;
  function Je(Ne) {
    return Ne === null;
  }
  I.isNull = Je;
  function ut(Ne) {
    return Ne == null;
  }
  I.isNullOrUndefined = ut;
  function rt(Ne) {
    return typeof Ne == "number";
  }
  I.isNumber = rt;
  function lt(Ne) {
    return typeof Ne == "string";
  }
  I.isString = lt;
  function vt(Ne) {
    return typeof Ne == "symbol";
  }
  I.isSymbol = vt;
  function Ye(Ne) {
    return Ne === void 0;
  }
  I.isUndefined = Ye;
  function pt(Ne) {
    return bt(Ne) && B(Ne) === "[object RegExp]";
  }
  I.isRegExp = pt, I.types.isRegExp = pt;
  function bt(Ne) {
    return typeof Ne == "object" && Ne !== null;
  }
  I.isObject = bt;
  function Yt(Ne) {
    return bt(Ne) && B(Ne) === "[object Date]";
  }
  I.isDate = Yt, I.types.isDate = Yt;
  function Se(Ne) {
    return bt(Ne) && (B(Ne) === "[object Error]" || Ne instanceof Error);
  }
  I.isError = Se, I.types.isNativeError = Se;
  function t(Ne) {
    return typeof Ne == "function";
  }
  I.isFunction = t;
  function h(Ne) {
    return Ne === null || typeof Ne == "boolean" || typeof Ne == "number" || typeof Ne == "string" || typeof Ne == "symbol" || // ES6 symbol
    typeof Ne > "u";
  }
  I.isPrimitive = h, I.isBuffer = isBufferBrowser;
  function B(Ne) {
    return Object.prototype.toString.call(Ne);
  }
  function Z(Ne) {
    return Ne < 10 ? "0" + Ne.toString(10) : Ne.toString(10);
  }
  var ve = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function ge() {
    var Ne = /* @__PURE__ */ new Date(), Ke = [
      Z(Ne.getHours()),
      Z(Ne.getMinutes()),
      Z(Ne.getSeconds())
    ].join(":");
    return [Ne.getDate(), ve[Ne.getMonth()], Ke].join(" ");
  }
  I.log = function() {
    console.log("%s - %s", ge(), I.format.apply(I, arguments));
  }, I.inherits = inherits_browserExports, I._extend = function(Ne, Ke) {
    if (!Ke || !bt(Ke)) return Ne;
    for (var tt = Object.keys(Ke), We = tt.length; We--; )
      Ne[tt[We]] = Ke[tt[We]];
    return Ne;
  };
  function xe(Ne, Ke) {
    return Object.prototype.hasOwnProperty.call(Ne, Ke);
  }
  var X = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  I.promisify = function(Ke) {
    if (typeof Ke != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (X && Ke[X]) {
      var tt = Ke[X];
      if (typeof tt != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(tt, X, {
        value: tt,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), tt;
    }
    function tt() {
      for (var We, ot, He = new Promise(function(je, it) {
        We = je, ot = it;
      }), Qe = [], nt = 0; nt < arguments.length; nt++)
        Qe.push(arguments[nt]);
      Qe.push(function(je, it) {
        je ? ot(je) : We(it);
      });
      try {
        Ke.apply(this, Qe);
      } catch (je) {
        ot(je);
      }
      return He;
    }
    return Object.setPrototypeOf(tt, Object.getPrototypeOf(Ke)), X && Object.defineProperty(tt, X, {
      value: tt,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      tt,
      A(Ke)
    );
  }, I.promisify.custom = X;
  function a(Ne, Ke) {
    if (!Ne) {
      var tt = new Error("Promise was rejected with a falsy value");
      tt.reason = Ne, Ne = tt;
    }
    return Ke(Ne);
  }
  function Y(Ne) {
    if (typeof Ne != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function Ke() {
      for (var tt = [], We = 0; We < arguments.length; We++)
        tt.push(arguments[We]);
      var ot = tt.pop();
      if (typeof ot != "function")
        throw new TypeError("The last argument must be of type Function");
      var He = this, Qe = function() {
        return ot.apply(He, arguments);
      };
      Ne.apply(this, tt).then(
        function(nt) {
          process$1.nextTick(Qe.bind(null, null, nt));
        },
        function(nt) {
          process$1.nextTick(a.bind(null, nt, Qe));
        }
      );
    }
    return Object.setPrototypeOf(Ke, Object.getPrototypeOf(Ne)), Object.defineProperties(
      Ke,
      A(Ne)
    ), Ke;
  }
  I.callbackify = Y;
})(util$1);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list) return buffer_list;
  hasRequiredBuffer_list = 1;
  function I(Fe, Ge) {
    var et = Object.keys(Fe);
    if (Object.getOwnPropertySymbols) {
      var Ve = Object.getOwnPropertySymbols(Fe);
      Ge && (Ve = Ve.filter(function(Je) {
        return Object.getOwnPropertyDescriptor(Fe, Je).enumerable;
      })), et.push.apply(et, Ve);
    }
    return et;
  }
  function A(Fe) {
    for (var Ge = 1; Ge < arguments.length; Ge++) {
      var et = arguments[Ge] != null ? arguments[Ge] : {};
      Ge % 2 ? I(Object(et), !0).forEach(function(Ve) {
        G(Fe, Ve, et[Ve]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Fe, Object.getOwnPropertyDescriptors(et)) : I(Object(et)).forEach(function(Ve) {
        Object.defineProperty(Fe, Ve, Object.getOwnPropertyDescriptor(et, Ve));
      });
    }
    return Fe;
  }
  function G(Fe, Ge, et) {
    return Ge = De(Ge), Ge in Fe ? Object.defineProperty(Fe, Ge, { value: et, enumerable: !0, configurable: !0, writable: !0 }) : Fe[Ge] = et, Fe;
  }
  function J(Fe, Ge) {
    if (!(Fe instanceof Ge))
      throw new TypeError("Cannot call a class as a function");
  }
  function _e(Fe, Ge) {
    for (var et = 0; et < Ge.length; et++) {
      var Ve = Ge[et];
      Ve.enumerable = Ve.enumerable || !1, Ve.configurable = !0, "value" in Ve && (Ve.writable = !0), Object.defineProperty(Fe, De(Ve.key), Ve);
    }
  }
  function H(Fe, Ge, et) {
    return Ge && _e(Fe.prototype, Ge), Object.defineProperty(Fe, "prototype", { writable: !1 }), Fe;
  }
  function De(Fe) {
    var Ge = Ie(Fe, "string");
    return typeof Ge == "symbol" ? Ge : String(Ge);
  }
  function Ie(Fe, Ge) {
    if (typeof Fe != "object" || Fe === null) return Fe;
    var et = Fe[Symbol.toPrimitive];
    if (et !== void 0) {
      var Ve = et.call(Fe, Ge || "default");
      if (typeof Ve != "object") return Ve;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Ge === "string" ? String : Number)(Fe);
  }
  var qe = require$$0$3, Te = qe.Buffer, Ee = util$1, Oe = Ee.inspect, Le = Oe && Oe.custom || "inspect";
  function ke(Fe, Ge, et) {
    Te.prototype.copy.call(Fe, Ge, et);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function Fe() {
      J(this, Fe), this.head = null, this.tail = null, this.length = 0;
    }
    return H(Fe, [{
      key: "push",
      value: function(et) {
        var Ve = {
          data: et,
          next: null
        };
        this.length > 0 ? this.tail.next = Ve : this.head = Ve, this.tail = Ve, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(et) {
        var Ve = {
          data: et,
          next: this.head
        };
        this.length === 0 && (this.tail = Ve), this.head = Ve, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var et = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, et;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(et) {
        if (this.length === 0) return "";
        for (var Ve = this.head, Je = "" + Ve.data; Ve = Ve.next; ) Je += et + Ve.data;
        return Je;
      }
    }, {
      key: "concat",
      value: function(et) {
        if (this.length === 0) return Te.alloc(0);
        for (var Ve = Te.allocUnsafe(et >>> 0), Je = this.head, ut = 0; Je; )
          ke(Je.data, Ve, ut), ut += Je.data.length, Je = Je.next;
        return Ve;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(et, Ve) {
        var Je;
        return et < this.head.data.length ? (Je = this.head.data.slice(0, et), this.head.data = this.head.data.slice(et)) : et === this.head.data.length ? Je = this.shift() : Je = Ve ? this._getString(et) : this._getBuffer(et), Je;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(et) {
        var Ve = this.head, Je = 1, ut = Ve.data;
        for (et -= ut.length; Ve = Ve.next; ) {
          var rt = Ve.data, lt = et > rt.length ? rt.length : et;
          if (lt === rt.length ? ut += rt : ut += rt.slice(0, et), et -= lt, et === 0) {
            lt === rt.length ? (++Je, Ve.next ? this.head = Ve.next : this.head = this.tail = null) : (this.head = Ve, Ve.data = rt.slice(lt));
            break;
          }
          ++Je;
        }
        return this.length -= Je, ut;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(et) {
        var Ve = Te.allocUnsafe(et), Je = this.head, ut = 1;
        for (Je.data.copy(Ve), et -= Je.data.length; Je = Je.next; ) {
          var rt = Je.data, lt = et > rt.length ? rt.length : et;
          if (rt.copy(Ve, Ve.length - et, 0, lt), et -= lt, et === 0) {
            lt === rt.length ? (++ut, Je.next ? this.head = Je.next : this.head = this.tail = null) : (this.head = Je, Je.data = rt.slice(lt));
            break;
          }
          ++ut;
        }
        return this.length -= ut, Ve;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: Le,
      value: function(et, Ve) {
        return Oe(this, A(A({}, Ve), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), Fe;
  }(), buffer_list;
}
function destroy(I, A) {
  var G = this, J = this._readableState && this._readableState.destroyed, _e = this._writableState && this._writableState.destroyed;
  return J || _e ? (A ? A(I) : I && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process$1.nextTick(emitErrorNT, this, I)) : process$1.nextTick(emitErrorNT, this, I)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(I || null, function(H) {
    !A && H ? G._writableState ? G._writableState.errorEmitted ? process$1.nextTick(emitCloseNT, G) : (G._writableState.errorEmitted = !0, process$1.nextTick(emitErrorAndCloseNT, G, H)) : process$1.nextTick(emitErrorAndCloseNT, G, H) : A ? (process$1.nextTick(emitCloseNT, G), A(H)) : process$1.nextTick(emitCloseNT, G);
  }), this);
}
function emitErrorAndCloseNT(I, A) {
  emitErrorNT(I, A), emitCloseNT(I);
}
function emitCloseNT(I) {
  I._writableState && !I._writableState.emitClose || I._readableState && !I._readableState.emitClose || I.emit("close");
}
function undestroy() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function emitErrorNT(I, A) {
  I.emit("error", A);
}
function errorOrDestroy(I, A) {
  var G = I._readableState, J = I._writableState;
  G && G.autoDestroy || J && J.autoDestroy ? I.destroy(A) : I.emit("error", A);
}
var destroy_1$1 = {
  destroy,
  undestroy,
  errorOrDestroy
}, errorsBrowser = {};
function _inheritsLoose(I, A) {
  I.prototype = Object.create(A.prototype), I.prototype.constructor = I, I.__proto__ = A;
}
var codes = {};
function createErrorType(I, A, G) {
  G || (G = Error);
  function J(H, De, Ie) {
    return typeof A == "string" ? A : A(H, De, Ie);
  }
  var _e = /* @__PURE__ */ function(H) {
    _inheritsLoose(De, H);
    function De(Ie, qe, Te) {
      return H.call(this, J(Ie, qe, Te)) || this;
    }
    return De;
  }(G);
  _e.prototype.name = G.name, _e.prototype.code = I, codes[I] = _e;
}
function oneOf(I, A) {
  if (Array.isArray(I)) {
    var G = I.length;
    return I = I.map(function(J) {
      return String(J);
    }), G > 2 ? "one of ".concat(A, " ").concat(I.slice(0, G - 1).join(", "), ", or ") + I[G - 1] : G === 2 ? "one of ".concat(A, " ").concat(I[0], " or ").concat(I[1]) : "of ".concat(A, " ").concat(I[0]);
  } else
    return "of ".concat(A, " ").concat(String(I));
}
function startsWith(I, A, G) {
  return I.substr(0, A.length) === A;
}
function endsWith(I, A, G) {
  return (G === void 0 || G > I.length) && (G = I.length), I.substring(G - A.length, G) === A;
}
function includes(I, A, G) {
  return typeof G != "number" && (G = 0), G + A.length > I.length ? !1 : I.indexOf(A, G) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(I, A) {
  return 'The value "' + A + '" is invalid for option "' + I + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(I, A, G) {
  var J;
  typeof A == "string" && startsWith(A, "not ") ? (J = "must not be", A = A.replace(/^not /, "")) : J = "must be";
  var _e;
  if (endsWith(I, " argument"))
    _e = "The ".concat(I, " ").concat(J, " ").concat(oneOf(A, "type"));
  else {
    var H = includes(I, ".") ? "property" : "argument";
    _e = 'The "'.concat(I, '" ').concat(H, " ").concat(J, " ").concat(oneOf(A, "type"));
  }
  return _e += ". Received type ".concat(typeof G), _e;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(I) {
  return "The " + I + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(I) {
  return "Cannot call " + I + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(I) {
  return "Unknown encoding: " + I;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
errorsBrowser.codes = codes;
var ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(I, A, G) {
  return I.highWaterMark != null ? I.highWaterMark : A ? I[G] : null;
}
function getHighWaterMark(I, A, G, J) {
  var _e = highWaterMarkFrom(A, J, G);
  if (_e != null) {
    if (!(isFinite(_e) && Math.floor(_e) === _e) || _e < 0) {
      var H = J ? G : "highWaterMark";
      throw new ERR_INVALID_OPT_VALUE(H, _e);
    }
    return Math.floor(_e);
  }
  return I.objectMode ? 16 : 16 * 1024;
}
var state = {
  getHighWaterMark
}, browser$d = deprecate;
function deprecate(I, A) {
  if (config("noDeprecation"))
    return I;
  var G = !1;
  function J() {
    if (!G) {
      if (config("throwDeprecation"))
        throw new Error(A);
      config("traceDeprecation") ? console.trace(A) : console.warn(A), G = !0;
    }
    return I.apply(this, arguments);
  }
  return J;
}
function config(I) {
  try {
    if (!commonjsGlobal.localStorage) return !1;
  } catch {
    return !1;
  }
  var A = commonjsGlobal.localStorage[I];
  return A == null ? !1 : String(A).toLowerCase() === "true";
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1) return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = pt;
  function I(ot) {
    var He = this;
    this.next = null, this.entry = null, this.finish = function() {
      We(He, ot);
    };
  }
  var A;
  pt.WritableState = vt;
  var G = {
    deprecate: browser$d
  }, J = streamBrowser$1, _e = require$$0$3.Buffer, H = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function De(ot) {
    return _e.from(ot);
  }
  function Ie(ot) {
    return _e.isBuffer(ot) || ot instanceof H;
  }
  var qe = destroy_1$1, Te = state, Ee = Te.getHighWaterMark, Oe = errorsBrowser.codes, Le = Oe.ERR_INVALID_ARG_TYPE, ke = Oe.ERR_METHOD_NOT_IMPLEMENTED, Fe = Oe.ERR_MULTIPLE_CALLBACK, Ge = Oe.ERR_STREAM_CANNOT_PIPE, et = Oe.ERR_STREAM_DESTROYED, Ve = Oe.ERR_STREAM_NULL_VALUES, Je = Oe.ERR_STREAM_WRITE_AFTER_END, ut = Oe.ERR_UNKNOWN_ENCODING, rt = qe.errorOrDestroy;
  inherits_browserExports(pt, J);
  function lt() {
  }
  function vt(ot, He, Qe) {
    A = A || require_stream_duplex$1(), ot = ot || {}, typeof Qe != "boolean" && (Qe = He instanceof A), this.objectMode = !!ot.objectMode, Qe && (this.objectMode = this.objectMode || !!ot.writableObjectMode), this.highWaterMark = Ee(this, ot, "writableHighWaterMark", Qe), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var nt = ot.decodeStrings === !1;
    this.decodeStrings = !nt, this.defaultEncoding = ot.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(je) {
      ve(He, je);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = ot.emitClose !== !1, this.autoDestroy = !!ot.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new I(this);
  }
  vt.prototype.getBuffer = function() {
    for (var He = this.bufferedRequest, Qe = []; He; )
      Qe.push(He), He = He.next;
    return Qe;
  }, function() {
    try {
      Object.defineProperty(vt.prototype, "buffer", {
        get: G.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Ye;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Ye = Function.prototype[Symbol.hasInstance], Object.defineProperty(pt, Symbol.hasInstance, {
    value: function(He) {
      return Ye.call(this, He) ? !0 : this !== pt ? !1 : He && He._writableState instanceof vt;
    }
  })) : Ye = function(He) {
    return He instanceof this;
  };
  function pt(ot) {
    A = A || require_stream_duplex$1();
    var He = this instanceof A;
    if (!He && !Ye.call(pt, this)) return new pt(ot);
    this._writableState = new vt(ot, this, He), this.writable = !0, ot && (typeof ot.write == "function" && (this._write = ot.write), typeof ot.writev == "function" && (this._writev = ot.writev), typeof ot.destroy == "function" && (this._destroy = ot.destroy), typeof ot.final == "function" && (this._final = ot.final)), J.call(this);
  }
  pt.prototype.pipe = function() {
    rt(this, new Ge());
  };
  function bt(ot, He) {
    var Qe = new Je();
    rt(ot, Qe), process$1.nextTick(He, Qe);
  }
  function Yt(ot, He, Qe, nt) {
    var je;
    return Qe === null ? je = new Ve() : typeof Qe != "string" && !He.objectMode && (je = new Le("chunk", ["string", "Buffer"], Qe)), je ? (rt(ot, je), process$1.nextTick(nt, je), !1) : !0;
  }
  pt.prototype.write = function(ot, He, Qe) {
    var nt = this._writableState, je = !1, it = !nt.objectMode && Ie(ot);
    return it && !_e.isBuffer(ot) && (ot = De(ot)), typeof He == "function" && (Qe = He, He = null), it ? He = "buffer" : He || (He = nt.defaultEncoding), typeof Qe != "function" && (Qe = lt), nt.ending ? bt(this, Qe) : (it || Yt(this, nt, ot, Qe)) && (nt.pendingcb++, je = t(this, nt, it, ot, He, Qe)), je;
  }, pt.prototype.cork = function() {
    this._writableState.corked++;
  }, pt.prototype.uncork = function() {
    var ot = this._writableState;
    ot.corked && (ot.corked--, !ot.writing && !ot.corked && !ot.bufferProcessing && ot.bufferedRequest && X(this, ot));
  }, pt.prototype.setDefaultEncoding = function(He) {
    if (typeof He == "string" && (He = He.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((He + "").toLowerCase()) > -1)) throw new ut(He);
    return this._writableState.defaultEncoding = He, this;
  }, Object.defineProperty(pt.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function Se(ot, He, Qe) {
    return !ot.objectMode && ot.decodeStrings !== !1 && typeof He == "string" && (He = _e.from(He, Qe)), He;
  }
  Object.defineProperty(pt.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function t(ot, He, Qe, nt, je, it) {
    if (!Qe) {
      var st = Se(He, nt, je);
      nt !== st && (Qe = !0, je = "buffer", nt = st);
    }
    var gt = He.objectMode ? 1 : nt.length;
    He.length += gt;
    var It = He.length < He.highWaterMark;
    if (It || (He.needDrain = !0), He.writing || He.corked) {
      var At = He.lastBufferedRequest;
      He.lastBufferedRequest = {
        chunk: nt,
        encoding: je,
        isBuf: Qe,
        callback: it,
        next: null
      }, At ? At.next = He.lastBufferedRequest : He.bufferedRequest = He.lastBufferedRequest, He.bufferedRequestCount += 1;
    } else
      h(ot, He, !1, gt, nt, je, it);
    return It;
  }
  function h(ot, He, Qe, nt, je, it, st) {
    He.writelen = nt, He.writecb = st, He.writing = !0, He.sync = !0, He.destroyed ? He.onwrite(new et("write")) : Qe ? ot._writev(je, He.onwrite) : ot._write(je, it, He.onwrite), He.sync = !1;
  }
  function B(ot, He, Qe, nt, je) {
    --He.pendingcb, Qe ? (process$1.nextTick(je, nt), process$1.nextTick(Ke, ot, He), ot._writableState.errorEmitted = !0, rt(ot, nt)) : (je(nt), ot._writableState.errorEmitted = !0, rt(ot, nt), Ke(ot, He));
  }
  function Z(ot) {
    ot.writing = !1, ot.writecb = null, ot.length -= ot.writelen, ot.writelen = 0;
  }
  function ve(ot, He) {
    var Qe = ot._writableState, nt = Qe.sync, je = Qe.writecb;
    if (typeof je != "function") throw new Fe();
    if (Z(Qe), He) B(ot, Qe, nt, He, je);
    else {
      var it = a(Qe) || ot.destroyed;
      !it && !Qe.corked && !Qe.bufferProcessing && Qe.bufferedRequest && X(ot, Qe), nt ? process$1.nextTick(ge, ot, Qe, it, je) : ge(ot, Qe, it, je);
    }
  }
  function ge(ot, He, Qe, nt) {
    Qe || xe(ot, He), He.pendingcb--, nt(), Ke(ot, He);
  }
  function xe(ot, He) {
    He.length === 0 && He.needDrain && (He.needDrain = !1, ot.emit("drain"));
  }
  function X(ot, He) {
    He.bufferProcessing = !0;
    var Qe = He.bufferedRequest;
    if (ot._writev && Qe && Qe.next) {
      var nt = He.bufferedRequestCount, je = new Array(nt), it = He.corkedRequestsFree;
      it.entry = Qe;
      for (var st = 0, gt = !0; Qe; )
        je[st] = Qe, Qe.isBuf || (gt = !1), Qe = Qe.next, st += 1;
      je.allBuffers = gt, h(ot, He, !0, He.length, je, "", it.finish), He.pendingcb++, He.lastBufferedRequest = null, it.next ? (He.corkedRequestsFree = it.next, it.next = null) : He.corkedRequestsFree = new I(He), He.bufferedRequestCount = 0;
    } else {
      for (; Qe; ) {
        var It = Qe.chunk, At = Qe.encoding, Et = Qe.callback, ei = He.objectMode ? 1 : It.length;
        if (h(ot, He, !1, ei, It, At, Et), Qe = Qe.next, He.bufferedRequestCount--, He.writing)
          break;
      }
      Qe === null && (He.lastBufferedRequest = null);
    }
    He.bufferedRequest = Qe, He.bufferProcessing = !1;
  }
  pt.prototype._write = function(ot, He, Qe) {
    Qe(new ke("_write()"));
  }, pt.prototype._writev = null, pt.prototype.end = function(ot, He, Qe) {
    var nt = this._writableState;
    return typeof ot == "function" ? (Qe = ot, ot = null, He = null) : typeof He == "function" && (Qe = He, He = null), ot != null && this.write(ot, He), nt.corked && (nt.corked = 1, this.uncork()), nt.ending || tt(this, nt, Qe), this;
  }, Object.defineProperty(pt.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function a(ot) {
    return ot.ending && ot.length === 0 && ot.bufferedRequest === null && !ot.finished && !ot.writing;
  }
  function Y(ot, He) {
    ot._final(function(Qe) {
      He.pendingcb--, Qe && rt(ot, Qe), He.prefinished = !0, ot.emit("prefinish"), Ke(ot, He);
    });
  }
  function Ne(ot, He) {
    !He.prefinished && !He.finalCalled && (typeof ot._final == "function" && !He.destroyed ? (He.pendingcb++, He.finalCalled = !0, process$1.nextTick(Y, ot, He)) : (He.prefinished = !0, ot.emit("prefinish")));
  }
  function Ke(ot, He) {
    var Qe = a(He);
    if (Qe && (Ne(ot, He), He.pendingcb === 0 && (He.finished = !0, ot.emit("finish"), He.autoDestroy))) {
      var nt = ot._readableState;
      (!nt || nt.autoDestroy && nt.endEmitted) && ot.destroy();
    }
    return Qe;
  }
  function tt(ot, He, Qe) {
    He.ending = !0, Ke(ot, He), Qe && (He.finished ? process$1.nextTick(Qe) : ot.once("finish", Qe)), He.ended = !0, ot.writable = !1;
  }
  function We(ot, He, Qe) {
    var nt = ot.entry;
    for (ot.entry = null; nt; ) {
      var je = nt.callback;
      He.pendingcb--, je(Qe), nt = nt.next;
    }
    He.corkedRequestsFree.next = ot;
  }
  return Object.defineProperty(pt.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(He) {
      this._writableState && (this._writableState.destroyed = He);
    }
  }), pt.prototype.destroy = qe.destroy, pt.prototype._undestroy = qe.undestroy, pt.prototype._destroy = function(ot, He) {
    He(ot);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1) return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var I = Object.keys || function(Te) {
    var Ee = [];
    for (var Oe in Te) Ee.push(Oe);
    return Ee;
  };
  _stream_duplex$1 = De;
  var A = require_stream_readable$1(), G = require_stream_writable$1();
  inherits_browserExports(De, A);
  for (var J = I(G.prototype), _e = 0; _e < J.length; _e++) {
    var H = J[_e];
    De.prototype[H] || (De.prototype[H] = G.prototype[H]);
  }
  function De(Te) {
    if (!(this instanceof De)) return new De(Te);
    A.call(this, Te), G.call(this, Te), this.allowHalfOpen = !0, Te && (Te.readable === !1 && (this.readable = !1), Te.writable === !1 && (this.writable = !1), Te.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", Ie)));
  }
  Object.defineProperty(De.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(De.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(De.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function Ie() {
    this._writableState.ended || process$1.nextTick(qe, this);
  }
  function qe(Te) {
    Te.end();
  }
  return Object.defineProperty(De.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(Ee) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = Ee, this._writableState.destroyed = Ee);
    }
  }), _stream_duplex$1;
}
var string_decoder = {}, hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder) return string_decoder;
  hasRequiredString_decoder = 1;
  var I = safeBufferExports.Buffer, A = I.isEncoding || function(Ve) {
    switch (Ve = "" + Ve, Ve && Ve.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function G(Ve) {
    if (!Ve) return "utf8";
    for (var Je; ; )
      switch (Ve) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return Ve;
        default:
          if (Je) return;
          Ve = ("" + Ve).toLowerCase(), Je = !0;
      }
  }
  function J(Ve) {
    var Je = G(Ve);
    if (typeof Je != "string" && (I.isEncoding === A || !A(Ve))) throw new Error("Unknown encoding: " + Ve);
    return Je || Ve;
  }
  string_decoder.StringDecoder = _e;
  function _e(Ve) {
    this.encoding = J(Ve);
    var Je;
    switch (this.encoding) {
      case "utf16le":
        this.text = Oe, this.end = Le, Je = 4;
        break;
      case "utf8":
        this.fillLast = qe, Je = 4;
        break;
      case "base64":
        this.text = ke, this.end = Fe, Je = 3;
        break;
      default:
        this.write = Ge, this.end = et;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = I.allocUnsafe(Je);
  }
  _e.prototype.write = function(Ve) {
    if (Ve.length === 0) return "";
    var Je, ut;
    if (this.lastNeed) {
      if (Je = this.fillLast(Ve), Je === void 0) return "";
      ut = this.lastNeed, this.lastNeed = 0;
    } else
      ut = 0;
    return ut < Ve.length ? Je ? Je + this.text(Ve, ut) : this.text(Ve, ut) : Je || "";
  }, _e.prototype.end = Ee, _e.prototype.text = Te, _e.prototype.fillLast = function(Ve) {
    if (this.lastNeed <= Ve.length)
      return Ve.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Ve.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, Ve.length), this.lastNeed -= Ve.length;
  };
  function H(Ve) {
    return Ve <= 127 ? 0 : Ve >> 5 === 6 ? 2 : Ve >> 4 === 14 ? 3 : Ve >> 3 === 30 ? 4 : Ve >> 6 === 2 ? -1 : -2;
  }
  function De(Ve, Je, ut) {
    var rt = Je.length - 1;
    if (rt < ut) return 0;
    var lt = H(Je[rt]);
    return lt >= 0 ? (lt > 0 && (Ve.lastNeed = lt - 1), lt) : --rt < ut || lt === -2 ? 0 : (lt = H(Je[rt]), lt >= 0 ? (lt > 0 && (Ve.lastNeed = lt - 2), lt) : --rt < ut || lt === -2 ? 0 : (lt = H(Je[rt]), lt >= 0 ? (lt > 0 && (lt === 2 ? lt = 0 : Ve.lastNeed = lt - 3), lt) : 0));
  }
  function Ie(Ve, Je, ut) {
    if ((Je[0] & 192) !== 128)
      return Ve.lastNeed = 0, "�";
    if (Ve.lastNeed > 1 && Je.length > 1) {
      if ((Je[1] & 192) !== 128)
        return Ve.lastNeed = 1, "�";
      if (Ve.lastNeed > 2 && Je.length > 2 && (Je[2] & 192) !== 128)
        return Ve.lastNeed = 2, "�";
    }
  }
  function qe(Ve) {
    var Je = this.lastTotal - this.lastNeed, ut = Ie(this, Ve);
    if (ut !== void 0) return ut;
    if (this.lastNeed <= Ve.length)
      return Ve.copy(this.lastChar, Je, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    Ve.copy(this.lastChar, Je, 0, Ve.length), this.lastNeed -= Ve.length;
  }
  function Te(Ve, Je) {
    var ut = De(this, Ve, Je);
    if (!this.lastNeed) return Ve.toString("utf8", Je);
    this.lastTotal = ut;
    var rt = Ve.length - (ut - this.lastNeed);
    return Ve.copy(this.lastChar, 0, rt), Ve.toString("utf8", Je, rt);
  }
  function Ee(Ve) {
    var Je = Ve && Ve.length ? this.write(Ve) : "";
    return this.lastNeed ? Je + "�" : Je;
  }
  function Oe(Ve, Je) {
    if ((Ve.length - Je) % 2 === 0) {
      var ut = Ve.toString("utf16le", Je);
      if (ut) {
        var rt = ut.charCodeAt(ut.length - 1);
        if (rt >= 55296 && rt <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = Ve[Ve.length - 2], this.lastChar[1] = Ve[Ve.length - 1], ut.slice(0, -1);
      }
      return ut;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = Ve[Ve.length - 1], Ve.toString("utf16le", Je, Ve.length - 1);
  }
  function Le(Ve) {
    var Je = Ve && Ve.length ? this.write(Ve) : "";
    if (this.lastNeed) {
      var ut = this.lastTotal - this.lastNeed;
      return Je + this.lastChar.toString("utf16le", 0, ut);
    }
    return Je;
  }
  function ke(Ve, Je) {
    var ut = (Ve.length - Je) % 3;
    return ut === 0 ? Ve.toString("base64", Je) : (this.lastNeed = 3 - ut, this.lastTotal = 3, ut === 1 ? this.lastChar[0] = Ve[Ve.length - 1] : (this.lastChar[0] = Ve[Ve.length - 2], this.lastChar[1] = Ve[Ve.length - 1]), Ve.toString("base64", Je, Ve.length - ut));
  }
  function Fe(Ve) {
    var Je = Ve && Ve.length ? this.write(Ve) : "";
    return this.lastNeed ? Je + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Je;
  }
  function Ge(Ve) {
    return Ve.toString(this.encoding);
  }
  function et(Ve) {
    return Ve && Ve.length ? this.write(Ve) : "";
  }
  return string_decoder;
}
var ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;
function once$1(I) {
  var A = !1;
  return function() {
    if (!A) {
      A = !0;
      for (var G = arguments.length, J = new Array(G), _e = 0; _e < G; _e++)
        J[_e] = arguments[_e];
      I.apply(this, J);
    }
  };
}
function noop$2() {
}
function isRequest$1(I) {
  return I.setHeader && typeof I.abort == "function";
}
function eos$1(I, A, G) {
  if (typeof A == "function") return eos$1(I, null, A);
  A || (A = {}), G = once$1(G || noop$2);
  var J = A.readable || A.readable !== !1 && I.readable, _e = A.writable || A.writable !== !1 && I.writable, H = function() {
    I.writable || Ie();
  }, De = I._writableState && I._writableState.finished, Ie = function() {
    _e = !1, De = !0, J || G.call(I);
  }, qe = I._readableState && I._readableState.endEmitted, Te = function() {
    J = !1, qe = !0, _e || G.call(I);
  }, Ee = function(Fe) {
    G.call(I, Fe);
  }, Oe = function() {
    var Fe;
    if (J && !qe)
      return (!I._readableState || !I._readableState.ended) && (Fe = new ERR_STREAM_PREMATURE_CLOSE()), G.call(I, Fe);
    if (_e && !De)
      return (!I._writableState || !I._writableState.ended) && (Fe = new ERR_STREAM_PREMATURE_CLOSE()), G.call(I, Fe);
  }, Le = function() {
    I.req.on("finish", Ie);
  };
  return isRequest$1(I) ? (I.on("complete", Ie), I.on("abort", Oe), I.req ? Le() : I.on("request", Le)) : _e && !I._writableState && (I.on("end", H), I.on("close", H)), I.on("end", Te), I.on("finish", Ie), A.error !== !1 && I.on("error", Ee), I.on("close", Oe), function() {
    I.removeListener("complete", Ie), I.removeListener("abort", Oe), I.removeListener("request", Le), I.req && I.req.removeListener("finish", Ie), I.removeListener("end", H), I.removeListener("close", H), I.removeListener("finish", Ie), I.removeListener("end", Te), I.removeListener("error", Ee), I.removeListener("close", Oe);
  };
}
var endOfStream = eos$1, async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator) return async_iterator;
  hasRequiredAsync_iterator = 1;
  var I;
  function A(ut, rt, lt) {
    return rt = G(rt), rt in ut ? Object.defineProperty(ut, rt, { value: lt, enumerable: !0, configurable: !0, writable: !0 }) : ut[rt] = lt, ut;
  }
  function G(ut) {
    var rt = J(ut, "string");
    return typeof rt == "symbol" ? rt : String(rt);
  }
  function J(ut, rt) {
    if (typeof ut != "object" || ut === null) return ut;
    var lt = ut[Symbol.toPrimitive];
    if (lt !== void 0) {
      var vt = lt.call(ut, rt || "default");
      if (typeof vt != "object") return vt;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (rt === "string" ? String : Number)(ut);
  }
  var _e = endOfStream, H = Symbol("lastResolve"), De = Symbol("lastReject"), Ie = Symbol("error"), qe = Symbol("ended"), Te = Symbol("lastPromise"), Ee = Symbol("handlePromise"), Oe = Symbol("stream");
  function Le(ut, rt) {
    return {
      value: ut,
      done: rt
    };
  }
  function ke(ut) {
    var rt = ut[H];
    if (rt !== null) {
      var lt = ut[Oe].read();
      lt !== null && (ut[Te] = null, ut[H] = null, ut[De] = null, rt(Le(lt, !1)));
    }
  }
  function Fe(ut) {
    process$1.nextTick(ke, ut);
  }
  function Ge(ut, rt) {
    return function(lt, vt) {
      ut.then(function() {
        if (rt[qe]) {
          lt(Le(void 0, !0));
          return;
        }
        rt[Ee](lt, vt);
      }, vt);
    };
  }
  var et = Object.getPrototypeOf(function() {
  }), Ve = Object.setPrototypeOf((I = {
    get stream() {
      return this[Oe];
    },
    next: function() {
      var rt = this, lt = this[Ie];
      if (lt !== null)
        return Promise.reject(lt);
      if (this[qe])
        return Promise.resolve(Le(void 0, !0));
      if (this[Oe].destroyed)
        return new Promise(function(bt, Yt) {
          process$1.nextTick(function() {
            rt[Ie] ? Yt(rt[Ie]) : bt(Le(void 0, !0));
          });
        });
      var vt = this[Te], Ye;
      if (vt)
        Ye = new Promise(Ge(vt, this));
      else {
        var pt = this[Oe].read();
        if (pt !== null)
          return Promise.resolve(Le(pt, !1));
        Ye = new Promise(this[Ee]);
      }
      return this[Te] = Ye, Ye;
    }
  }, A(I, Symbol.asyncIterator, function() {
    return this;
  }), A(I, "return", function() {
    var rt = this;
    return new Promise(function(lt, vt) {
      rt[Oe].destroy(null, function(Ye) {
        if (Ye) {
          vt(Ye);
          return;
        }
        lt(Le(void 0, !0));
      });
    });
  }), I), et), Je = function(rt) {
    var lt, vt = Object.create(Ve, (lt = {}, A(lt, Oe, {
      value: rt,
      writable: !0
    }), A(lt, H, {
      value: null,
      writable: !0
    }), A(lt, De, {
      value: null,
      writable: !0
    }), A(lt, Ie, {
      value: null,
      writable: !0
    }), A(lt, qe, {
      value: rt._readableState.endEmitted,
      writable: !0
    }), A(lt, Ee, {
      value: function(pt, bt) {
        var Yt = vt[Oe].read();
        Yt ? (vt[Te] = null, vt[H] = null, vt[De] = null, pt(Le(Yt, !1))) : (vt[H] = pt, vt[De] = bt);
      },
      writable: !0
    }), lt));
    return vt[Te] = null, _e(rt, function(Ye) {
      if (Ye && Ye.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var pt = vt[De];
        pt !== null && (vt[Te] = null, vt[H] = null, vt[De] = null, pt(Ye)), vt[Ie] = Ye;
        return;
      }
      var bt = vt[H];
      bt !== null && (vt[Te] = null, vt[H] = null, vt[De] = null, bt(Le(void 0, !0))), vt[qe] = !0;
    }), rt.on("readable", Fe.bind(null, vt)), vt;
  };
  return async_iterator = Je, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1) return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = bt;
  var I;
  bt.ReadableState = pt, eventsExports.EventEmitter;
  var A = function(st, gt) {
    return st.listeners(gt).length;
  }, G = streamBrowser$1, J = require$$0$3.Buffer, _e = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function H(it) {
    return J.from(it);
  }
  function De(it) {
    return J.isBuffer(it) || it instanceof _e;
  }
  var Ie = util$1, qe;
  Ie && Ie.debuglog ? qe = Ie.debuglog("stream") : qe = function() {
  };
  var Te = requireBuffer_list(), Ee = destroy_1$1, Oe = state, Le = Oe.getHighWaterMark, ke = errorsBrowser.codes, Fe = ke.ERR_INVALID_ARG_TYPE, Ge = ke.ERR_STREAM_PUSH_AFTER_EOF, et = ke.ERR_METHOD_NOT_IMPLEMENTED, Ve = ke.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Je, ut, rt;
  inherits_browserExports(bt, G);
  var lt = Ee.errorOrDestroy, vt = ["error", "close", "destroy", "pause", "resume"];
  function Ye(it, st, gt) {
    if (typeof it.prependListener == "function") return it.prependListener(st, gt);
    !it._events || !it._events[st] ? it.on(st, gt) : Array.isArray(it._events[st]) ? it._events[st].unshift(gt) : it._events[st] = [gt, it._events[st]];
  }
  function pt(it, st, gt) {
    I = I || require_stream_duplex$1(), it = it || {}, typeof gt != "boolean" && (gt = st instanceof I), this.objectMode = !!it.objectMode, gt && (this.objectMode = this.objectMode || !!it.readableObjectMode), this.highWaterMark = Le(this, it, "readableHighWaterMark", gt), this.buffer = new Te(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = it.emitClose !== !1, this.autoDestroy = !!it.autoDestroy, this.destroyed = !1, this.defaultEncoding = it.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, it.encoding && (Je || (Je = requireString_decoder().StringDecoder), this.decoder = new Je(it.encoding), this.encoding = it.encoding);
  }
  function bt(it) {
    if (I = I || require_stream_duplex$1(), !(this instanceof bt)) return new bt(it);
    var st = this instanceof I;
    this._readableState = new pt(it, this, st), this.readable = !0, it && (typeof it.read == "function" && (this._read = it.read), typeof it.destroy == "function" && (this._destroy = it.destroy)), G.call(this);
  }
  Object.defineProperty(bt.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(st) {
      this._readableState && (this._readableState.destroyed = st);
    }
  }), bt.prototype.destroy = Ee.destroy, bt.prototype._undestroy = Ee.undestroy, bt.prototype._destroy = function(it, st) {
    st(it);
  }, bt.prototype.push = function(it, st) {
    var gt = this._readableState, It;
    return gt.objectMode ? It = !0 : typeof it == "string" && (st = st || gt.defaultEncoding, st !== gt.encoding && (it = J.from(it, st), st = ""), It = !0), Yt(this, it, st, !1, It);
  }, bt.prototype.unshift = function(it) {
    return Yt(this, it, null, !0, !1);
  };
  function Yt(it, st, gt, It, At) {
    qe("readableAddChunk", st);
    var Et = it._readableState;
    if (st === null)
      Et.reading = !1, ve(it, Et);
    else {
      var ei;
      if (At || (ei = t(Et, st)), ei)
        lt(it, ei);
      else if (Et.objectMode || st && st.length > 0)
        if (typeof st != "string" && !Et.objectMode && Object.getPrototypeOf(st) !== J.prototype && (st = H(st)), It)
          Et.endEmitted ? lt(it, new Ve()) : Se(it, Et, st, !0);
        else if (Et.ended)
          lt(it, new Ge());
        else {
          if (Et.destroyed)
            return !1;
          Et.reading = !1, Et.decoder && !gt ? (st = Et.decoder.write(st), Et.objectMode || st.length !== 0 ? Se(it, Et, st, !1) : X(it, Et)) : Se(it, Et, st, !1);
        }
      else It || (Et.reading = !1, X(it, Et));
    }
    return !Et.ended && (Et.length < Et.highWaterMark || Et.length === 0);
  }
  function Se(it, st, gt, It) {
    st.flowing && st.length === 0 && !st.sync ? (st.awaitDrain = 0, it.emit("data", gt)) : (st.length += st.objectMode ? 1 : gt.length, It ? st.buffer.unshift(gt) : st.buffer.push(gt), st.needReadable && ge(it)), X(it, st);
  }
  function t(it, st) {
    var gt;
    return !De(st) && typeof st != "string" && st !== void 0 && !it.objectMode && (gt = new Fe("chunk", ["string", "Buffer", "Uint8Array"], st)), gt;
  }
  bt.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, bt.prototype.setEncoding = function(it) {
    Je || (Je = requireString_decoder().StringDecoder);
    var st = new Je(it);
    this._readableState.decoder = st, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var gt = this._readableState.buffer.head, It = ""; gt !== null; )
      It += st.write(gt.data), gt = gt.next;
    return this._readableState.buffer.clear(), It !== "" && this._readableState.buffer.push(It), this._readableState.length = It.length, this;
  };
  var h = 1073741824;
  function B(it) {
    return it >= h ? it = h : (it--, it |= it >>> 1, it |= it >>> 2, it |= it >>> 4, it |= it >>> 8, it |= it >>> 16, it++), it;
  }
  function Z(it, st) {
    return it <= 0 || st.length === 0 && st.ended ? 0 : st.objectMode ? 1 : it !== it ? st.flowing && st.length ? st.buffer.head.data.length : st.length : (it > st.highWaterMark && (st.highWaterMark = B(it)), it <= st.length ? it : st.ended ? st.length : (st.needReadable = !0, 0));
  }
  bt.prototype.read = function(it) {
    qe("read", it), it = parseInt(it, 10);
    var st = this._readableState, gt = it;
    if (it !== 0 && (st.emittedReadable = !1), it === 0 && st.needReadable && ((st.highWaterMark !== 0 ? st.length >= st.highWaterMark : st.length > 0) || st.ended))
      return qe("read: emitReadable", st.length, st.ended), st.length === 0 && st.ended ? Qe(this) : ge(this), null;
    if (it = Z(it, st), it === 0 && st.ended)
      return st.length === 0 && Qe(this), null;
    var It = st.needReadable;
    qe("need readable", It), (st.length === 0 || st.length - it < st.highWaterMark) && (It = !0, qe("length less than watermark", It)), st.ended || st.reading ? (It = !1, qe("reading or ended", It)) : It && (qe("do read"), st.reading = !0, st.sync = !0, st.length === 0 && (st.needReadable = !0), this._read(st.highWaterMark), st.sync = !1, st.reading || (it = Z(gt, st)));
    var At;
    return it > 0 ? At = He(it, st) : At = null, At === null ? (st.needReadable = st.length <= st.highWaterMark, it = 0) : (st.length -= it, st.awaitDrain = 0), st.length === 0 && (st.ended || (st.needReadable = !0), gt !== it && st.ended && Qe(this)), At !== null && this.emit("data", At), At;
  };
  function ve(it, st) {
    if (qe("onEofChunk"), !st.ended) {
      if (st.decoder) {
        var gt = st.decoder.end();
        gt && gt.length && (st.buffer.push(gt), st.length += st.objectMode ? 1 : gt.length);
      }
      st.ended = !0, st.sync ? ge(it) : (st.needReadable = !1, st.emittedReadable || (st.emittedReadable = !0, xe(it)));
    }
  }
  function ge(it) {
    var st = it._readableState;
    qe("emitReadable", st.needReadable, st.emittedReadable), st.needReadable = !1, st.emittedReadable || (qe("emitReadable", st.flowing), st.emittedReadable = !0, process$1.nextTick(xe, it));
  }
  function xe(it) {
    var st = it._readableState;
    qe("emitReadable_", st.destroyed, st.length, st.ended), !st.destroyed && (st.length || st.ended) && (it.emit("readable"), st.emittedReadable = !1), st.needReadable = !st.flowing && !st.ended && st.length <= st.highWaterMark, ot(it);
  }
  function X(it, st) {
    st.readingMore || (st.readingMore = !0, process$1.nextTick(a, it, st));
  }
  function a(it, st) {
    for (; !st.reading && !st.ended && (st.length < st.highWaterMark || st.flowing && st.length === 0); ) {
      var gt = st.length;
      if (qe("maybeReadMore read 0"), it.read(0), gt === st.length)
        break;
    }
    st.readingMore = !1;
  }
  bt.prototype._read = function(it) {
    lt(this, new et("_read()"));
  }, bt.prototype.pipe = function(it, st) {
    var gt = this, It = this._readableState;
    switch (It.pipesCount) {
      case 0:
        It.pipes = it;
        break;
      case 1:
        It.pipes = [It.pipes, it];
        break;
      default:
        It.pipes.push(it);
        break;
    }
    It.pipesCount += 1, qe("pipe count=%d opts=%j", It.pipesCount, st);
    var At = (!st || st.end !== !1) && it !== process$1.stdout && it !== process$1.stderr, Et = At ? Xt : ai;
    It.endEmitted ? process$1.nextTick(Et) : gt.once("end", Et), it.on("unpipe", ei);
    function ei(Nt, qt) {
      qe("onunpipe"), Nt === gt && qt && qt.hasUnpiped === !1 && (qt.hasUnpiped = !0, Ct());
    }
    function Xt() {
      qe("onend"), it.end();
    }
    var _t = Y(gt);
    it.on("drain", _t);
    var ni = !1;
    function Ct() {
      qe("cleanup"), it.removeListener("close", Pt), it.removeListener("finish", Rt), it.removeListener("drain", _t), it.removeListener("error", ii), it.removeListener("unpipe", ei), gt.removeListener("end", Xt), gt.removeListener("end", ai), gt.removeListener("data", Wt), ni = !0, It.awaitDrain && (!it._writableState || it._writableState.needDrain) && _t();
    }
    gt.on("data", Wt);
    function Wt(Nt) {
      qe("ondata");
      var qt = it.write(Nt);
      qe("dest.write", qt), qt === !1 && ((It.pipesCount === 1 && It.pipes === it || It.pipesCount > 1 && je(It.pipes, it) !== -1) && !ni && (qe("false write response, pause", It.awaitDrain), It.awaitDrain++), gt.pause());
    }
    function ii(Nt) {
      qe("onerror", Nt), ai(), it.removeListener("error", ii), A(it, "error") === 0 && lt(it, Nt);
    }
    Ye(it, "error", ii);
    function Pt() {
      it.removeListener("finish", Rt), ai();
    }
    it.once("close", Pt);
    function Rt() {
      qe("onfinish"), it.removeListener("close", Pt), ai();
    }
    it.once("finish", Rt);
    function ai() {
      qe("unpipe"), gt.unpipe(it);
    }
    return it.emit("pipe", gt), It.flowing || (qe("pipe resume"), gt.resume()), it;
  };
  function Y(it) {
    return function() {
      var gt = it._readableState;
      qe("pipeOnDrain", gt.awaitDrain), gt.awaitDrain && gt.awaitDrain--, gt.awaitDrain === 0 && A(it, "data") && (gt.flowing = !0, ot(it));
    };
  }
  bt.prototype.unpipe = function(it) {
    var st = this._readableState, gt = {
      hasUnpiped: !1
    };
    if (st.pipesCount === 0) return this;
    if (st.pipesCount === 1)
      return it && it !== st.pipes ? this : (it || (it = st.pipes), st.pipes = null, st.pipesCount = 0, st.flowing = !1, it && it.emit("unpipe", this, gt), this);
    if (!it) {
      var It = st.pipes, At = st.pipesCount;
      st.pipes = null, st.pipesCount = 0, st.flowing = !1;
      for (var Et = 0; Et < At; Et++) It[Et].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var ei = je(st.pipes, it);
    return ei === -1 ? this : (st.pipes.splice(ei, 1), st.pipesCount -= 1, st.pipesCount === 1 && (st.pipes = st.pipes[0]), it.emit("unpipe", this, gt), this);
  }, bt.prototype.on = function(it, st) {
    var gt = G.prototype.on.call(this, it, st), It = this._readableState;
    return it === "data" ? (It.readableListening = this.listenerCount("readable") > 0, It.flowing !== !1 && this.resume()) : it === "readable" && !It.endEmitted && !It.readableListening && (It.readableListening = It.needReadable = !0, It.flowing = !1, It.emittedReadable = !1, qe("on readable", It.length, It.reading), It.length ? ge(this) : It.reading || process$1.nextTick(Ke, this)), gt;
  }, bt.prototype.addListener = bt.prototype.on, bt.prototype.removeListener = function(it, st) {
    var gt = G.prototype.removeListener.call(this, it, st);
    return it === "readable" && process$1.nextTick(Ne, this), gt;
  }, bt.prototype.removeAllListeners = function(it) {
    var st = G.prototype.removeAllListeners.apply(this, arguments);
    return (it === "readable" || it === void 0) && process$1.nextTick(Ne, this), st;
  };
  function Ne(it) {
    var st = it._readableState;
    st.readableListening = it.listenerCount("readable") > 0, st.resumeScheduled && !st.paused ? st.flowing = !0 : it.listenerCount("data") > 0 && it.resume();
  }
  function Ke(it) {
    qe("readable nexttick read 0"), it.read(0);
  }
  bt.prototype.resume = function() {
    var it = this._readableState;
    return it.flowing || (qe("resume"), it.flowing = !it.readableListening, tt(this, it)), it.paused = !1, this;
  };
  function tt(it, st) {
    st.resumeScheduled || (st.resumeScheduled = !0, process$1.nextTick(We, it, st));
  }
  function We(it, st) {
    qe("resume", st.reading), st.reading || it.read(0), st.resumeScheduled = !1, it.emit("resume"), ot(it), st.flowing && !st.reading && it.read(0);
  }
  bt.prototype.pause = function() {
    return qe("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (qe("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function ot(it) {
    var st = it._readableState;
    for (qe("flow", st.flowing); st.flowing && it.read() !== null; ) ;
  }
  bt.prototype.wrap = function(it) {
    var st = this, gt = this._readableState, It = !1;
    it.on("end", function() {
      if (qe("wrapped end"), gt.decoder && !gt.ended) {
        var ei = gt.decoder.end();
        ei && ei.length && st.push(ei);
      }
      st.push(null);
    }), it.on("data", function(ei) {
      if (qe("wrapped data"), gt.decoder && (ei = gt.decoder.write(ei)), !(gt.objectMode && ei == null) && !(!gt.objectMode && (!ei || !ei.length))) {
        var Xt = st.push(ei);
        Xt || (It = !0, it.pause());
      }
    });
    for (var At in it)
      this[At] === void 0 && typeof it[At] == "function" && (this[At] = /* @__PURE__ */ function(Xt) {
        return function() {
          return it[Xt].apply(it, arguments);
        };
      }(At));
    for (var Et = 0; Et < vt.length; Et++)
      it.on(vt[Et], this.emit.bind(this, vt[Et]));
    return this._read = function(ei) {
      qe("wrapped _read", ei), It && (It = !1, it.resume());
    }, this;
  }, typeof Symbol == "function" && (bt.prototype[Symbol.asyncIterator] = function() {
    return ut === void 0 && (ut = requireAsync_iterator()), ut(this);
  }), Object.defineProperty(bt.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(bt.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(bt.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(st) {
      this._readableState && (this._readableState.flowing = st);
    }
  }), bt._fromList = He, Object.defineProperty(bt.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function He(it, st) {
    if (st.length === 0) return null;
    var gt;
    return st.objectMode ? gt = st.buffer.shift() : !it || it >= st.length ? (st.decoder ? gt = st.buffer.join("") : st.buffer.length === 1 ? gt = st.buffer.first() : gt = st.buffer.concat(st.length), st.buffer.clear()) : gt = st.buffer.consume(it, st.decoder), gt;
  }
  function Qe(it) {
    var st = it._readableState;
    qe("endReadable", st.endEmitted), st.endEmitted || (st.ended = !0, process$1.nextTick(nt, st, it));
  }
  function nt(it, st) {
    if (qe("endReadableNT", it.endEmitted, it.length), !it.endEmitted && it.length === 0 && (it.endEmitted = !0, st.readable = !1, st.emit("end"), it.autoDestroy)) {
      var gt = st._writableState;
      (!gt || gt.autoDestroy && gt.finished) && st.destroy();
    }
  }
  typeof Symbol == "function" && (bt.from = function(it, st) {
    return rt === void 0 && (rt = requireFromBrowser()), rt(bt, it, st);
  });
  function je(it, st) {
    for (var gt = 0, It = it.length; gt < It; gt++)
      if (it[gt] === st) return gt;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1 = Transform$1, _require$codes$1 = errorsBrowser.codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0, Duplex = require_stream_duplex$1();
inherits_browserExports(Transform$1, Duplex);
function afterTransform(I, A) {
  var G = this._transformState;
  G.transforming = !1;
  var J = G.writecb;
  if (J === null)
    return this.emit("error", new ERR_MULTIPLE_CALLBACK());
  G.writechunk = null, G.writecb = null, A != null && this.push(A), J(I);
  var _e = this._readableState;
  _e.reading = !1, (_e.needReadable || _e.length < _e.highWaterMark) && this._read(_e.highWaterMark);
}
function Transform$1(I) {
  if (!(this instanceof Transform$1)) return new Transform$1(I);
  Duplex.call(this, I), this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, I && (typeof I.transform == "function" && (this._transform = I.transform), typeof I.flush == "function" && (this._flush = I.flush)), this.on("prefinish", prefinish);
}
function prefinish() {
  var I = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(A, G) {
    done(I, A, G);
  }) : done(this, null, null);
}
Transform$1.prototype.push = function(I, A) {
  return this._transformState.needTransform = !1, Duplex.prototype.push.call(this, I, A);
};
Transform$1.prototype._transform = function(I, A, G) {
  G(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform$1.prototype._write = function(I, A, G) {
  var J = this._transformState;
  if (J.writecb = G, J.writechunk = I, J.writeencoding = A, !J.transforming) {
    var _e = this._readableState;
    (J.needTransform || _e.needReadable || _e.length < _e.highWaterMark) && this._read(_e.highWaterMark);
  }
};
Transform$1.prototype._read = function(I) {
  var A = this._transformState;
  A.writechunk !== null && !A.transforming ? (A.transforming = !0, this._transform(A.writechunk, A.writeencoding, A.afterTransform)) : A.needTransform = !0;
};
Transform$1.prototype._destroy = function(I, A) {
  Duplex.prototype._destroy.call(this, I, function(G) {
    A(G);
  });
};
function done(I, A, G) {
  if (A) return I.emit("error", A);
  if (G != null && I.push(G), I._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (I._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return I.push(null);
}
var _stream_passthrough$1 = PassThrough, Transform = _stream_transform$1;
inherits_browserExports(PassThrough, Transform);
function PassThrough(I) {
  if (!(this instanceof PassThrough)) return new PassThrough(I);
  Transform.call(this, I);
}
PassThrough.prototype._transform = function(I, A, G) {
  G(null, I);
};
var eos;
function once(I) {
  var A = !1;
  return function() {
    A || (A = !0, I.apply(void 0, arguments));
  };
}
var _require$codes = errorsBrowser.codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop$1(I) {
  if (I) throw I;
}
function isRequest(I) {
  return I.setHeader && typeof I.abort == "function";
}
function destroyer(I, A, G, J) {
  J = once(J);
  var _e = !1;
  I.on("close", function() {
    _e = !0;
  }), eos === void 0 && (eos = endOfStream), eos(I, {
    readable: A,
    writable: G
  }, function(De) {
    if (De) return J(De);
    _e = !0, J();
  });
  var H = !1;
  return function(De) {
    if (!_e && !H) {
      if (H = !0, isRequest(I)) return I.abort();
      if (typeof I.destroy == "function") return I.destroy();
      J(De || new ERR_STREAM_DESTROYED("pipe"));
    }
  };
}
function call(I) {
  I();
}
function pipe(I, A) {
  return I.pipe(A);
}
function popCallback(I) {
  return !I.length || typeof I[I.length - 1] != "function" ? noop$1 : I.pop();
}
function pipeline() {
  for (var I = arguments.length, A = new Array(I), G = 0; G < I; G++)
    A[G] = arguments[G];
  var J = popCallback(A);
  if (Array.isArray(A[0]) && (A = A[0]), A.length < 2)
    throw new ERR_MISSING_ARGS("streams");
  var _e, H = A.map(function(De, Ie) {
    var qe = Ie < A.length - 1, Te = Ie > 0;
    return destroyer(De, qe, Te, function(Ee) {
      _e || (_e = Ee), Ee && H.forEach(call), !qe && (H.forEach(call), J(_e));
    });
  });
  return A.reduce(pipe);
}
var pipeline_1 = pipeline;
(function(I, A) {
  A = I.exports = require_stream_readable$1(), A.Stream = A, A.Readable = A, A.Writable = require_stream_writable$1(), A.Duplex = require_stream_duplex$1(), A.Transform = _stream_transform$1, A.PassThrough = _stream_passthrough$1, A.finished = endOfStream, A.pipeline = pipeline_1;
})(readableBrowser$1, readableBrowser$1.exports);
var readableBrowserExports = readableBrowser$1.exports, cjs$3 = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(I, A) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(G, J) {
    G.__proto__ = J;
  } || function(G, J) {
    for (var _e in J) J.hasOwnProperty(_e) && (G[_e] = J[_e]);
  }, extendStatics(I, A);
};
function __extends(I, A) {
  extendStatics(I, A);
  function G() {
    this.constructor = I;
  }
  I.prototype = A === null ? Object.create(A) : (G.prototype = A.prototype, new G());
}
var __assign = function() {
  return __assign = Object.assign || function(A) {
    for (var G, J = 1, _e = arguments.length; J < _e; J++) {
      G = arguments[J];
      for (var H in G) Object.prototype.hasOwnProperty.call(G, H) && (A[H] = G[H]);
    }
    return A;
  }, __assign.apply(this, arguments);
};
function __rest(I, A) {
  var G = {};
  for (var J in I) Object.prototype.hasOwnProperty.call(I, J) && A.indexOf(J) < 0 && (G[J] = I[J]);
  if (I != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, J = Object.getOwnPropertySymbols(I); _e < J.length; _e++)
      A.indexOf(J[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(I, J[_e]) && (G[J[_e]] = I[J[_e]]);
  return G;
}
function __decorate(I, A, G, J) {
  var _e = arguments.length, H = _e < 3 ? A : J === null ? J = Object.getOwnPropertyDescriptor(A, G) : J, De;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") H = Reflect.decorate(I, A, G, J);
  else for (var Ie = I.length - 1; Ie >= 0; Ie--) (De = I[Ie]) && (H = (_e < 3 ? De(H) : _e > 3 ? De(A, G, H) : De(A, G)) || H);
  return _e > 3 && H && Object.defineProperty(A, G, H), H;
}
function __param(I, A) {
  return function(G, J) {
    A(G, J, I);
  };
}
function __metadata(I, A) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(I, A);
}
function __awaiter(I, A, G, J) {
  function _e(H) {
    return H instanceof G ? H : new G(function(De) {
      De(H);
    });
  }
  return new (G || (G = Promise))(function(H, De) {
    function Ie(Ee) {
      try {
        Te(J.next(Ee));
      } catch (Oe) {
        De(Oe);
      }
    }
    function qe(Ee) {
      try {
        Te(J.throw(Ee));
      } catch (Oe) {
        De(Oe);
      }
    }
    function Te(Ee) {
      Ee.done ? H(Ee.value) : _e(Ee.value).then(Ie, qe);
    }
    Te((J = J.apply(I, A || [])).next());
  });
}
function __generator(I, A) {
  var G = { label: 0, sent: function() {
    if (H[0] & 1) throw H[1];
    return H[1];
  }, trys: [], ops: [] }, J, _e, H, De;
  return De = { next: Ie(0), throw: Ie(1), return: Ie(2) }, typeof Symbol == "function" && (De[Symbol.iterator] = function() {
    return this;
  }), De;
  function Ie(Te) {
    return function(Ee) {
      return qe([Te, Ee]);
    };
  }
  function qe(Te) {
    if (J) throw new TypeError("Generator is already executing.");
    for (; G; ) try {
      if (J = 1, _e && (H = Te[0] & 2 ? _e.return : Te[0] ? _e.throw || ((H = _e.return) && H.call(_e), 0) : _e.next) && !(H = H.call(_e, Te[1])).done) return H;
      switch (_e = 0, H && (Te = [Te[0] & 2, H.value]), Te[0]) {
        case 0:
        case 1:
          H = Te;
          break;
        case 4:
          return G.label++, { value: Te[1], done: !1 };
        case 5:
          G.label++, _e = Te[1], Te = [0];
          continue;
        case 7:
          Te = G.ops.pop(), G.trys.pop();
          continue;
        default:
          if (H = G.trys, !(H = H.length > 0 && H[H.length - 1]) && (Te[0] === 6 || Te[0] === 2)) {
            G = 0;
            continue;
          }
          if (Te[0] === 3 && (!H || Te[1] > H[0] && Te[1] < H[3])) {
            G.label = Te[1];
            break;
          }
          if (Te[0] === 6 && G.label < H[1]) {
            G.label = H[1], H = Te;
            break;
          }
          if (H && G.label < H[2]) {
            G.label = H[2], G.ops.push(Te);
            break;
          }
          H[2] && G.ops.pop(), G.trys.pop();
          continue;
      }
      Te = A.call(I, G);
    } catch (Ee) {
      Te = [6, Ee], _e = 0;
    } finally {
      J = H = 0;
    }
    if (Te[0] & 5) throw Te[1];
    return { value: Te[0] ? Te[1] : void 0, done: !0 };
  }
}
function __createBinding(I, A, G, J) {
  J === void 0 && (J = G), I[J] = A[G];
}
function __exportStar(I, A) {
  for (var G in I) G !== "default" && !A.hasOwnProperty(G) && (A[G] = I[G]);
}
function __values(I) {
  var A = typeof Symbol == "function" && Symbol.iterator, G = A && I[A], J = 0;
  if (G) return G.call(I);
  if (I && typeof I.length == "number") return {
    next: function() {
      return I && J >= I.length && (I = void 0), { value: I && I[J++], done: !I };
    }
  };
  throw new TypeError(A ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(I, A) {
  var G = typeof Symbol == "function" && I[Symbol.iterator];
  if (!G) return I;
  var J = G.call(I), _e, H = [], De;
  try {
    for (; (A === void 0 || A-- > 0) && !(_e = J.next()).done; ) H.push(_e.value);
  } catch (Ie) {
    De = { error: Ie };
  } finally {
    try {
      _e && !_e.done && (G = J.return) && G.call(J);
    } finally {
      if (De) throw De.error;
    }
  }
  return H;
}
function __spread() {
  for (var I = [], A = 0; A < arguments.length; A++)
    I = I.concat(__read(arguments[A]));
  return I;
}
function __spreadArrays() {
  for (var I = 0, A = 0, G = arguments.length; A < G; A++) I += arguments[A].length;
  for (var J = Array(I), _e = 0, A = 0; A < G; A++)
    for (var H = arguments[A], De = 0, Ie = H.length; De < Ie; De++, _e++)
      J[_e] = H[De];
  return J;
}
function __await(I) {
  return this instanceof __await ? (this.v = I, this) : new __await(I);
}
function __asyncGenerator(I, A, G) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var J = G.apply(I, A || []), _e, H = [];
  return _e = {}, De("next"), De("throw"), De("return"), _e[Symbol.asyncIterator] = function() {
    return this;
  }, _e;
  function De(Le) {
    J[Le] && (_e[Le] = function(ke) {
      return new Promise(function(Fe, Ge) {
        H.push([Le, ke, Fe, Ge]) > 1 || Ie(Le, ke);
      });
    });
  }
  function Ie(Le, ke) {
    try {
      qe(J[Le](ke));
    } catch (Fe) {
      Oe(H[0][3], Fe);
    }
  }
  function qe(Le) {
    Le.value instanceof __await ? Promise.resolve(Le.value.v).then(Te, Ee) : Oe(H[0][2], Le);
  }
  function Te(Le) {
    Ie("next", Le);
  }
  function Ee(Le) {
    Ie("throw", Le);
  }
  function Oe(Le, ke) {
    Le(ke), H.shift(), H.length && Ie(H[0][0], H[0][1]);
  }
}
function __asyncDelegator(I) {
  var A, G;
  return A = {}, J("next"), J("throw", function(_e) {
    throw _e;
  }), J("return"), A[Symbol.iterator] = function() {
    return this;
  }, A;
  function J(_e, H) {
    A[_e] = I[_e] ? function(De) {
      return (G = !G) ? { value: __await(I[_e](De)), done: _e === "return" } : H ? H(De) : De;
    } : H;
  }
}
function __asyncValues(I) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var A = I[Symbol.asyncIterator], G;
  return A ? A.call(I) : (I = typeof __values == "function" ? __values(I) : I[Symbol.iterator](), G = {}, J("next"), J("throw"), J("return"), G[Symbol.asyncIterator] = function() {
    return this;
  }, G);
  function J(H) {
    G[H] = I[H] && function(De) {
      return new Promise(function(Ie, qe) {
        De = I[H](De), _e(Ie, qe, De.done, De.value);
      });
    };
  }
  function _e(H, De, Ie, qe) {
    Promise.resolve(qe).then(function(Te) {
      H({ value: Te, done: Ie });
    }, De);
  }
}
function __makeTemplateObject(I, A) {
  return Object.defineProperty ? Object.defineProperty(I, "raw", { value: A }) : I.raw = A, I;
}
function __importStar(I) {
  if (I && I.__esModule) return I;
  var A = {};
  if (I != null) for (var G in I) Object.hasOwnProperty.call(I, G) && (A[G] = I[G]);
  return A.default = I, A;
}
function __importDefault(I) {
  return I && I.__esModule ? I : { default: I };
}
function __classPrivateFieldGet(I, A) {
  if (!A.has(I))
    throw new TypeError("attempted to get private field on non-instance");
  return A.get(I);
}
function __classPrivateFieldSet(I, A, G) {
  if (!A.has(I))
    throw new TypeError("attempted to set private field on non-instance");
  return A.set(I, G), G;
}
const tslib_es6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return __assign;
  },
  __asyncDelegator,
  __asyncGenerator,
  __asyncValues,
  __await,
  __awaiter,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __createBinding,
  __decorate,
  __exportStar,
  __extends,
  __generator,
  __importDefault,
  __importStar,
  __makeTemplateObject,
  __metadata,
  __param,
  __read,
  __rest,
  __spread,
  __spreadArrays,
  __values
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(tslib_es6);
var utils$p = {}, delay = {}, hasRequiredDelay;
function requireDelay() {
  if (hasRequiredDelay) return delay;
  hasRequiredDelay = 1, Object.defineProperty(delay, "__esModule", { value: !0 }), delay.delay = void 0;
  function I(A) {
    return new Promise((G) => {
      setTimeout(() => {
        G(!0);
      }, A);
    });
  }
  return delay.delay = I, delay;
}
var convert = {}, constants$1 = {}, misc = {}, hasRequiredMisc;
function requireMisc() {
  return hasRequiredMisc || (hasRequiredMisc = 1, Object.defineProperty(misc, "__esModule", { value: !0 }), misc.ONE_THOUSAND = misc.ONE_HUNDRED = void 0, misc.ONE_HUNDRED = 100, misc.ONE_THOUSAND = 1e3), misc;
}
var time = {}, hasRequiredTime;
function requireTime() {
  return hasRequiredTime || (hasRequiredTime = 1, function(I) {
    Object.defineProperty(I, "__esModule", { value: !0 }), I.ONE_YEAR = I.FOUR_WEEKS = I.THREE_WEEKS = I.TWO_WEEKS = I.ONE_WEEK = I.THIRTY_DAYS = I.SEVEN_DAYS = I.FIVE_DAYS = I.THREE_DAYS = I.ONE_DAY = I.TWENTY_FOUR_HOURS = I.TWELVE_HOURS = I.SIX_HOURS = I.THREE_HOURS = I.ONE_HOUR = I.SIXTY_MINUTES = I.THIRTY_MINUTES = I.TEN_MINUTES = I.FIVE_MINUTES = I.ONE_MINUTE = I.SIXTY_SECONDS = I.THIRTY_SECONDS = I.TEN_SECONDS = I.FIVE_SECONDS = I.ONE_SECOND = void 0, I.ONE_SECOND = 1, I.FIVE_SECONDS = 5, I.TEN_SECONDS = 10, I.THIRTY_SECONDS = 30, I.SIXTY_SECONDS = 60, I.ONE_MINUTE = I.SIXTY_SECONDS, I.FIVE_MINUTES = I.ONE_MINUTE * 5, I.TEN_MINUTES = I.ONE_MINUTE * 10, I.THIRTY_MINUTES = I.ONE_MINUTE * 30, I.SIXTY_MINUTES = I.ONE_MINUTE * 60, I.ONE_HOUR = I.SIXTY_MINUTES, I.THREE_HOURS = I.ONE_HOUR * 3, I.SIX_HOURS = I.ONE_HOUR * 6, I.TWELVE_HOURS = I.ONE_HOUR * 12, I.TWENTY_FOUR_HOURS = I.ONE_HOUR * 24, I.ONE_DAY = I.TWENTY_FOUR_HOURS, I.THREE_DAYS = I.ONE_DAY * 3, I.FIVE_DAYS = I.ONE_DAY * 5, I.SEVEN_DAYS = I.ONE_DAY * 7, I.THIRTY_DAYS = I.ONE_DAY * 30, I.ONE_WEEK = I.SEVEN_DAYS, I.TWO_WEEKS = I.ONE_WEEK * 2, I.THREE_WEEKS = I.ONE_WEEK * 3, I.FOUR_WEEKS = I.ONE_WEEK * 4, I.ONE_YEAR = I.ONE_DAY * 365;
  }(time)), time;
}
var hasRequiredConstants$1;
function requireConstants$1() {
  return hasRequiredConstants$1 || (hasRequiredConstants$1 = 1, function(I) {
    Object.defineProperty(I, "__esModule", { value: !0 });
    const A = require$$0$2;
    A.__exportStar(requireMisc(), I), A.__exportStar(requireTime(), I);
  }(constants$1)), constants$1;
}
var hasRequiredConvert;
function requireConvert() {
  if (hasRequiredConvert) return convert;
  hasRequiredConvert = 1, Object.defineProperty(convert, "__esModule", { value: !0 }), convert.fromMiliseconds = convert.toMiliseconds = void 0;
  const I = requireConstants$1();
  function A(J) {
    return J * I.ONE_THOUSAND;
  }
  convert.toMiliseconds = A;
  function G(J) {
    return Math.floor(J / I.ONE_THOUSAND);
  }
  return convert.fromMiliseconds = G, convert;
}
var hasRequiredUtils$2;
function requireUtils$2() {
  return hasRequiredUtils$2 || (hasRequiredUtils$2 = 1, function(I) {
    Object.defineProperty(I, "__esModule", { value: !0 });
    const A = require$$0$2;
    A.__exportStar(requireDelay(), I), A.__exportStar(requireConvert(), I);
  }(utils$p)), utils$p;
}
var watch$1 = {}, hasRequiredWatch$1;
function requireWatch$1() {
  if (hasRequiredWatch$1) return watch$1;
  hasRequiredWatch$1 = 1, Object.defineProperty(watch$1, "__esModule", { value: !0 }), watch$1.Watch = void 0;
  class I {
    constructor() {
      this.timestamps = /* @__PURE__ */ new Map();
    }
    start(G) {
      if (this.timestamps.has(G))
        throw new Error(`Watch already started for label: ${G}`);
      this.timestamps.set(G, { started: Date.now() });
    }
    stop(G) {
      const J = this.get(G);
      if (typeof J.elapsed < "u")
        throw new Error(`Watch already stopped for label: ${G}`);
      const _e = Date.now() - J.started;
      this.timestamps.set(G, { started: J.started, elapsed: _e });
    }
    get(G) {
      const J = this.timestamps.get(G);
      if (typeof J > "u")
        throw new Error(`No timestamp found for label: ${G}`);
      return J;
    }
    elapsed(G) {
      const J = this.get(G);
      return J.elapsed || Date.now() - J.started;
    }
  }
  return watch$1.Watch = I, watch$1.default = I, watch$1;
}
var types = {}, watch = {}, hasRequiredWatch;
function requireWatch() {
  if (hasRequiredWatch) return watch;
  hasRequiredWatch = 1, Object.defineProperty(watch, "__esModule", { value: !0 }), watch.IWatch = void 0;
  class I {
  }
  return watch.IWatch = I, watch;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, function(I) {
    Object.defineProperty(I, "__esModule", { value: !0 }), require$$0$2.__exportStar(requireWatch(), I);
  }(types)), types;
}
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  const A = require$$0$2;
  A.__exportStar(requireUtils$2(), I), A.__exportStar(requireWatch$1(), I), A.__exportStar(requireTypes(), I), A.__exportStar(requireConstants$1(), I);
})(cjs$3);
var cjs$2 = {};
Object.defineProperty(cjs$2, "__esModule", { value: !0 });
cjs$2.getLocalStorage = cjs$2.getLocalStorageOrThrow = cjs$2.getCrypto = cjs$2.getCryptoOrThrow = cjs$2.getLocation = cjs$2.getLocationOrThrow = cjs$2.getNavigator = cjs$2.getNavigatorOrThrow = cjs$2.getDocument = cjs$2.getDocumentOrThrow = cjs$2.getFromWindowOrThrow = cjs$2.getFromWindow = void 0;
function getFromWindow(I) {
  let A;
  return typeof window < "u" && typeof window[I] < "u" && (A = window[I]), A;
}
cjs$2.getFromWindow = getFromWindow;
function getFromWindowOrThrow(I) {
  const A = getFromWindow(I);
  if (!A)
    throw new Error(`${I} is not defined in Window`);
  return A;
}
cjs$2.getFromWindowOrThrow = getFromWindowOrThrow;
function getDocumentOrThrow() {
  return getFromWindowOrThrow("document");
}
cjs$2.getDocumentOrThrow = getDocumentOrThrow;
function getDocument() {
  return getFromWindow("document");
}
cjs$2.getDocument = getDocument;
function getNavigatorOrThrow() {
  return getFromWindowOrThrow("navigator");
}
cjs$2.getNavigatorOrThrow = getNavigatorOrThrow;
function getNavigator() {
  return getFromWindow("navigator");
}
cjs$2.getNavigator = getNavigator;
function getLocationOrThrow() {
  return getFromWindowOrThrow("location");
}
cjs$2.getLocationOrThrow = getLocationOrThrow;
function getLocation() {
  return getFromWindow("location");
}
cjs$2.getLocation = getLocation;
function getCryptoOrThrow() {
  return getFromWindowOrThrow("crypto");
}
cjs$2.getCryptoOrThrow = getCryptoOrThrow;
function getCrypto() {
  return getFromWindow("crypto");
}
cjs$2.getCrypto = getCrypto;
function getLocalStorageOrThrow() {
  return getFromWindowOrThrow("localStorage");
}
cjs$2.getLocalStorageOrThrow = getLocalStorageOrThrow;
function getLocalStorage() {
  return getFromWindow("localStorage");
}
cjs$2.getLocalStorage = getLocalStorage;
var cjs$1 = {};
Object.defineProperty(cjs$1, "__esModule", { value: !0 });
cjs$1.getWindowMetadata = void 0;
const window_getters_1 = cjs$2;
function getWindowMetadata() {
  let I, A;
  try {
    I = window_getters_1.getDocumentOrThrow(), A = window_getters_1.getLocationOrThrow();
  } catch {
    return null;
  }
  function G() {
    const Oe = I.getElementsByTagName("link"), Le = [];
    for (let ke = 0; ke < Oe.length; ke++) {
      const Fe = Oe[ke], Ge = Fe.getAttribute("rel");
      if (Ge && Ge.toLowerCase().indexOf("icon") > -1) {
        const et = Fe.getAttribute("href");
        if (et)
          if (et.toLowerCase().indexOf("https:") === -1 && et.toLowerCase().indexOf("http:") === -1 && et.indexOf("//") !== 0) {
            let Ve = A.protocol + "//" + A.host;
            if (et.indexOf("/") === 0)
              Ve += et;
            else {
              const Je = A.pathname.split("/");
              Je.pop();
              const ut = Je.join("/");
              Ve += ut + "/" + et;
            }
            Le.push(Ve);
          } else if (et.indexOf("//") === 0) {
            const Ve = A.protocol + et;
            Le.push(Ve);
          } else
            Le.push(et);
      }
    }
    return Le;
  }
  function J(...Oe) {
    const Le = I.getElementsByTagName("meta");
    for (let ke = 0; ke < Le.length; ke++) {
      const Fe = Le[ke], Ge = ["itemprop", "property", "name"].map((et) => Fe.getAttribute(et)).filter((et) => et ? Oe.includes(et) : !1);
      if (Ge.length && Ge) {
        const et = Fe.getAttribute("content");
        if (et)
          return et;
      }
    }
    return "";
  }
  function _e() {
    let Oe = J("name", "og:site_name", "og:title", "twitter:title");
    return Oe || (Oe = I.title), Oe;
  }
  function H() {
    return J("description", "og:description", "twitter:description", "keywords");
  }
  const De = _e(), Ie = H(), qe = A.origin, Te = G();
  return {
    description: Ie,
    url: qe,
    icons: Te,
    name: De
  };
}
cjs$1.getWindowMetadata = getWindowMetadata;
var queryString = {}, strictUriEncode = (I) => encodeURIComponent(I).replace(/[!'()*]/g, (A) => `%${A.charCodeAt(0).toString(16).toUpperCase()}`), token = "%[a-f0-9]{2}", singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi"), multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(I, A) {
  try {
    return [decodeURIComponent(I.join(""))];
  } catch {
  }
  if (I.length === 1)
    return I;
  A = A || 1;
  var G = I.slice(0, A), J = I.slice(A);
  return Array.prototype.concat.call([], decodeComponents(G), decodeComponents(J));
}
function decode$2(I) {
  try {
    return decodeURIComponent(I);
  } catch {
    for (var A = I.match(singleMatcher) || [], G = 1; G < A.length; G++)
      I = decodeComponents(A, G).join(""), A = I.match(singleMatcher) || [];
    return I;
  }
}
function customDecodeURIComponent(I) {
  for (var A = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, G = multiMatcher.exec(I); G; ) {
    try {
      A[G[0]] = decodeURIComponent(G[0]);
    } catch {
      var J = decode$2(G[0]);
      J !== G[0] && (A[G[0]] = J);
    }
    G = multiMatcher.exec(I);
  }
  A["%C2"] = "�";
  for (var _e = Object.keys(A), H = 0; H < _e.length; H++) {
    var De = _e[H];
    I = I.replace(new RegExp(De, "g"), A[De]);
  }
  return I;
}
var decodeUriComponent = function(I) {
  if (typeof I != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof I + "`");
  try {
    return I = I.replace(/\+/g, " "), decodeURIComponent(I);
  } catch {
    return customDecodeURIComponent(I);
  }
}, splitOnFirst = (I, A) => {
  if (!(typeof I == "string" && typeof A == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (A === "")
    return [I];
  const G = I.indexOf(A);
  return G === -1 ? [I] : [
    I.slice(0, G),
    I.slice(G + A.length)
  ];
}, filterObj = function(I, A) {
  for (var G = {}, J = Object.keys(I), _e = Array.isArray(A), H = 0; H < J.length; H++) {
    var De = J[H], Ie = I[De];
    (_e ? A.indexOf(De) !== -1 : A(De, Ie, I)) && (G[De] = Ie);
  }
  return G;
};
(function(I) {
  const A = strictUriEncode, G = decodeUriComponent, J = splitOnFirst, _e = filterObj, H = (Je) => Je == null, De = Symbol("encodeFragmentIdentifier");
  function Ie(Je) {
    switch (Je.arrayFormat) {
      case "index":
        return (ut) => (rt, lt) => {
          const vt = rt.length;
          return lt === void 0 || Je.skipNull && lt === null || Je.skipEmptyString && lt === "" ? rt : lt === null ? [...rt, [Ee(ut, Je), "[", vt, "]"].join("")] : [
            ...rt,
            [Ee(ut, Je), "[", Ee(vt, Je), "]=", Ee(lt, Je)].join("")
          ];
        };
      case "bracket":
        return (ut) => (rt, lt) => lt === void 0 || Je.skipNull && lt === null || Je.skipEmptyString && lt === "" ? rt : lt === null ? [...rt, [Ee(ut, Je), "[]"].join("")] : [...rt, [Ee(ut, Je), "[]=", Ee(lt, Je)].join("")];
      case "colon-list-separator":
        return (ut) => (rt, lt) => lt === void 0 || Je.skipNull && lt === null || Je.skipEmptyString && lt === "" ? rt : lt === null ? [...rt, [Ee(ut, Je), ":list="].join("")] : [...rt, [Ee(ut, Je), ":list=", Ee(lt, Je)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const ut = Je.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (rt) => (lt, vt) => vt === void 0 || Je.skipNull && vt === null || Je.skipEmptyString && vt === "" ? lt : (vt = vt === null ? "" : vt, lt.length === 0 ? [[Ee(rt, Je), ut, Ee(vt, Je)].join("")] : [[lt, Ee(vt, Je)].join(Je.arrayFormatSeparator)]);
      }
      default:
        return (ut) => (rt, lt) => lt === void 0 || Je.skipNull && lt === null || Je.skipEmptyString && lt === "" ? rt : lt === null ? [...rt, Ee(ut, Je)] : [...rt, [Ee(ut, Je), "=", Ee(lt, Je)].join("")];
    }
  }
  function qe(Je) {
    let ut;
    switch (Je.arrayFormat) {
      case "index":
        return (rt, lt, vt) => {
          if (ut = /\[(\d*)\]$/.exec(rt), rt = rt.replace(/\[\d*\]$/, ""), !ut) {
            vt[rt] = lt;
            return;
          }
          vt[rt] === void 0 && (vt[rt] = {}), vt[rt][ut[1]] = lt;
        };
      case "bracket":
        return (rt, lt, vt) => {
          if (ut = /(\[\])$/.exec(rt), rt = rt.replace(/\[\]$/, ""), !ut) {
            vt[rt] = lt;
            return;
          }
          if (vt[rt] === void 0) {
            vt[rt] = [lt];
            return;
          }
          vt[rt] = [].concat(vt[rt], lt);
        };
      case "colon-list-separator":
        return (rt, lt, vt) => {
          if (ut = /(:list)$/.exec(rt), rt = rt.replace(/:list$/, ""), !ut) {
            vt[rt] = lt;
            return;
          }
          if (vt[rt] === void 0) {
            vt[rt] = [lt];
            return;
          }
          vt[rt] = [].concat(vt[rt], lt);
        };
      case "comma":
      case "separator":
        return (rt, lt, vt) => {
          const Ye = typeof lt == "string" && lt.includes(Je.arrayFormatSeparator), pt = typeof lt == "string" && !Ye && Oe(lt, Je).includes(Je.arrayFormatSeparator);
          lt = pt ? Oe(lt, Je) : lt;
          const bt = Ye || pt ? lt.split(Je.arrayFormatSeparator).map((Yt) => Oe(Yt, Je)) : lt === null ? lt : Oe(lt, Je);
          vt[rt] = bt;
        };
      case "bracket-separator":
        return (rt, lt, vt) => {
          const Ye = /(\[\])$/.test(rt);
          if (rt = rt.replace(/\[\]$/, ""), !Ye) {
            vt[rt] = lt && Oe(lt, Je);
            return;
          }
          const pt = lt === null ? [] : lt.split(Je.arrayFormatSeparator).map((bt) => Oe(bt, Je));
          if (vt[rt] === void 0) {
            vt[rt] = pt;
            return;
          }
          vt[rt] = [].concat(vt[rt], pt);
        };
      default:
        return (rt, lt, vt) => {
          if (vt[rt] === void 0) {
            vt[rt] = lt;
            return;
          }
          vt[rt] = [].concat(vt[rt], lt);
        };
    }
  }
  function Te(Je) {
    if (typeof Je != "string" || Je.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function Ee(Je, ut) {
    return ut.encode ? ut.strict ? A(Je) : encodeURIComponent(Je) : Je;
  }
  function Oe(Je, ut) {
    return ut.decode ? G(Je) : Je;
  }
  function Le(Je) {
    return Array.isArray(Je) ? Je.sort() : typeof Je == "object" ? Le(Object.keys(Je)).sort((ut, rt) => Number(ut) - Number(rt)).map((ut) => Je[ut]) : Je;
  }
  function ke(Je) {
    const ut = Je.indexOf("#");
    return ut !== -1 && (Je = Je.slice(0, ut)), Je;
  }
  function Fe(Je) {
    let ut = "";
    const rt = Je.indexOf("#");
    return rt !== -1 && (ut = Je.slice(rt)), ut;
  }
  function Ge(Je) {
    Je = ke(Je);
    const ut = Je.indexOf("?");
    return ut === -1 ? "" : Je.slice(ut + 1);
  }
  function et(Je, ut) {
    return ut.parseNumbers && !Number.isNaN(Number(Je)) && typeof Je == "string" && Je.trim() !== "" ? Je = Number(Je) : ut.parseBooleans && Je !== null && (Je.toLowerCase() === "true" || Je.toLowerCase() === "false") && (Je = Je.toLowerCase() === "true"), Je;
  }
  function Ve(Je, ut) {
    ut = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, ut), Te(ut.arrayFormatSeparator);
    const rt = qe(ut), lt = /* @__PURE__ */ Object.create(null);
    if (typeof Je != "string" || (Je = Je.trim().replace(/^[?#&]/, ""), !Je))
      return lt;
    for (const vt of Je.split("&")) {
      if (vt === "")
        continue;
      let [Ye, pt] = J(ut.decode ? vt.replace(/\+/g, " ") : vt, "=");
      pt = pt === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(ut.arrayFormat) ? pt : Oe(pt, ut), rt(Oe(Ye, ut), pt, lt);
    }
    for (const vt of Object.keys(lt)) {
      const Ye = lt[vt];
      if (typeof Ye == "object" && Ye !== null)
        for (const pt of Object.keys(Ye))
          Ye[pt] = et(Ye[pt], ut);
      else
        lt[vt] = et(Ye, ut);
    }
    return ut.sort === !1 ? lt : (ut.sort === !0 ? Object.keys(lt).sort() : Object.keys(lt).sort(ut.sort)).reduce((vt, Ye) => {
      const pt = lt[Ye];
      return pt && typeof pt == "object" && !Array.isArray(pt) ? vt[Ye] = Le(pt) : vt[Ye] = pt, vt;
    }, /* @__PURE__ */ Object.create(null));
  }
  I.extract = Ge, I.parse = Ve, I.stringify = (Je, ut) => {
    if (!Je)
      return "";
    ut = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, ut), Te(ut.arrayFormatSeparator);
    const rt = (pt) => ut.skipNull && H(Je[pt]) || ut.skipEmptyString && Je[pt] === "", lt = Ie(ut), vt = {};
    for (const pt of Object.keys(Je))
      rt(pt) || (vt[pt] = Je[pt]);
    const Ye = Object.keys(vt);
    return ut.sort !== !1 && Ye.sort(ut.sort), Ye.map((pt) => {
      const bt = Je[pt];
      return bt === void 0 ? "" : bt === null ? Ee(pt, ut) : Array.isArray(bt) ? bt.length === 0 && ut.arrayFormat === "bracket-separator" ? Ee(pt, ut) + "[]" : bt.reduce(lt(pt), []).join("&") : Ee(pt, ut) + "=" + Ee(bt, ut);
    }).filter((pt) => pt.length > 0).join("&");
  }, I.parseUrl = (Je, ut) => {
    ut = Object.assign({
      decode: !0
    }, ut);
    const [rt, lt] = J(Je, "#");
    return Object.assign(
      {
        url: rt.split("?")[0] || "",
        query: Ve(Ge(Je), ut)
      },
      ut && ut.parseFragmentIdentifier && lt ? { fragmentIdentifier: Oe(lt, ut) } : {}
    );
  }, I.stringifyUrl = (Je, ut) => {
    ut = Object.assign({
      encode: !0,
      strict: !0,
      [De]: !0
    }, ut);
    const rt = ke(Je.url).split("?")[0] || "", lt = I.extract(Je.url), vt = I.parse(lt, { sort: !1 }), Ye = Object.assign(vt, Je.query);
    let pt = I.stringify(Ye, ut);
    pt && (pt = `?${pt}`);
    let bt = Fe(Je.url);
    return Je.fragmentIdentifier && (bt = `#${ut[De] ? Ee(Je.fragmentIdentifier, ut) : Je.fragmentIdentifier}`), `${rt}${pt}${bt}`;
  }, I.pick = (Je, ut, rt) => {
    rt = Object.assign({
      parseFragmentIdentifier: !0,
      [De]: !1
    }, rt);
    const { url: lt, query: vt, fragmentIdentifier: Ye } = I.parseUrl(Je, rt);
    return I.stringifyUrl({
      url: lt,
      query: _e(vt, ut),
      fragmentIdentifier: Ye
    }, rt);
  }, I.exclude = (Je, ut, rt) => {
    const lt = Array.isArray(ut) ? (vt) => !ut.includes(vt) : (vt, Ye) => !ut(vt, Ye);
    return I.pick(Je, lt, rt);
  };
})(queryString);
var chacha20poly1305 = {}, chacha = {}, binary = {}, int = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  function A(Ie, qe) {
    var Te = Ie >>> 16 & 65535, Ee = Ie & 65535, Oe = qe >>> 16 & 65535, Le = qe & 65535;
    return Ee * Le + (Te * Le + Ee * Oe << 16 >>> 0) | 0;
  }
  I.mul = Math.imul || A;
  function G(Ie, qe) {
    return Ie + qe | 0;
  }
  I.add = G;
  function J(Ie, qe) {
    return Ie - qe | 0;
  }
  I.sub = J;
  function _e(Ie, qe) {
    return Ie << qe | Ie >>> 32 - qe;
  }
  I.rotl = _e;
  function H(Ie, qe) {
    return Ie << 32 - qe | Ie >>> qe;
  }
  I.rotr = H;
  function De(Ie) {
    return typeof Ie == "number" && isFinite(Ie) && Math.floor(Ie) === Ie;
  }
  I.isInteger = Number.isInteger || De, I.MAX_SAFE_INTEGER = 9007199254740991, I.isSafeInteger = function(Ie) {
    return I.isInteger(Ie) && Ie >= -I.MAX_SAFE_INTEGER && Ie <= I.MAX_SAFE_INTEGER;
  };
})(int);
Object.defineProperty(binary, "__esModule", { value: !0 });
var int_1 = int;
function readInt16BE(I, A) {
  return A === void 0 && (A = 0), (I[A + 0] << 8 | I[A + 1]) << 16 >> 16;
}
binary.readInt16BE = readInt16BE;
function readUint16BE(I, A) {
  return A === void 0 && (A = 0), (I[A + 0] << 8 | I[A + 1]) >>> 0;
}
binary.readUint16BE = readUint16BE;
function readInt16LE(I, A) {
  return A === void 0 && (A = 0), (I[A + 1] << 8 | I[A]) << 16 >> 16;
}
binary.readInt16LE = readInt16LE;
function readUint16LE(I, A) {
  return A === void 0 && (A = 0), (I[A + 1] << 8 | I[A]) >>> 0;
}
binary.readUint16LE = readUint16LE;
function writeUint16BE(I, A, G) {
  return A === void 0 && (A = new Uint8Array(2)), G === void 0 && (G = 0), A[G + 0] = I >>> 8, A[G + 1] = I >>> 0, A;
}
binary.writeUint16BE = writeUint16BE;
binary.writeInt16BE = writeUint16BE;
function writeUint16LE(I, A, G) {
  return A === void 0 && (A = new Uint8Array(2)), G === void 0 && (G = 0), A[G + 0] = I >>> 0, A[G + 1] = I >>> 8, A;
}
binary.writeUint16LE = writeUint16LE;
binary.writeInt16LE = writeUint16LE;
function readInt32BE(I, A) {
  return A === void 0 && (A = 0), I[A] << 24 | I[A + 1] << 16 | I[A + 2] << 8 | I[A + 3];
}
binary.readInt32BE = readInt32BE;
function readUint32BE(I, A) {
  return A === void 0 && (A = 0), (I[A] << 24 | I[A + 1] << 16 | I[A + 2] << 8 | I[A + 3]) >>> 0;
}
binary.readUint32BE = readUint32BE;
function readInt32LE(I, A) {
  return A === void 0 && (A = 0), I[A + 3] << 24 | I[A + 2] << 16 | I[A + 1] << 8 | I[A];
}
binary.readInt32LE = readInt32LE;
function readUint32LE(I, A) {
  return A === void 0 && (A = 0), (I[A + 3] << 24 | I[A + 2] << 16 | I[A + 1] << 8 | I[A]) >>> 0;
}
binary.readUint32LE = readUint32LE;
function writeUint32BE(I, A, G) {
  return A === void 0 && (A = new Uint8Array(4)), G === void 0 && (G = 0), A[G + 0] = I >>> 24, A[G + 1] = I >>> 16, A[G + 2] = I >>> 8, A[G + 3] = I >>> 0, A;
}
binary.writeUint32BE = writeUint32BE;
binary.writeInt32BE = writeUint32BE;
function writeUint32LE(I, A, G) {
  return A === void 0 && (A = new Uint8Array(4)), G === void 0 && (G = 0), A[G + 0] = I >>> 0, A[G + 1] = I >>> 8, A[G + 2] = I >>> 16, A[G + 3] = I >>> 24, A;
}
binary.writeUint32LE = writeUint32LE;
binary.writeInt32LE = writeUint32LE;
function readInt64BE(I, A) {
  A === void 0 && (A = 0);
  var G = readInt32BE(I, A), J = readInt32BE(I, A + 4);
  return G * 4294967296 + J - (J >> 31) * 4294967296;
}
binary.readInt64BE = readInt64BE;
function readUint64BE(I, A) {
  A === void 0 && (A = 0);
  var G = readUint32BE(I, A), J = readUint32BE(I, A + 4);
  return G * 4294967296 + J;
}
binary.readUint64BE = readUint64BE;
function readInt64LE(I, A) {
  A === void 0 && (A = 0);
  var G = readInt32LE(I, A), J = readInt32LE(I, A + 4);
  return J * 4294967296 + G - (G >> 31) * 4294967296;
}
binary.readInt64LE = readInt64LE;
function readUint64LE(I, A) {
  A === void 0 && (A = 0);
  var G = readUint32LE(I, A), J = readUint32LE(I, A + 4);
  return J * 4294967296 + G;
}
binary.readUint64LE = readUint64LE;
function writeUint64BE(I, A, G) {
  return A === void 0 && (A = new Uint8Array(8)), G === void 0 && (G = 0), writeUint32BE(I / 4294967296 >>> 0, A, G), writeUint32BE(I >>> 0, A, G + 4), A;
}
binary.writeUint64BE = writeUint64BE;
binary.writeInt64BE = writeUint64BE;
function writeUint64LE(I, A, G) {
  return A === void 0 && (A = new Uint8Array(8)), G === void 0 && (G = 0), writeUint32LE(I >>> 0, A, G), writeUint32LE(I / 4294967296 >>> 0, A, G + 4), A;
}
binary.writeUint64LE = writeUint64LE;
binary.writeInt64LE = writeUint64LE;
function readUintBE(I, A, G) {
  if (G === void 0 && (G = 0), I % 8 !== 0)
    throw new Error("readUintBE supports only bitLengths divisible by 8");
  if (I / 8 > A.length - G)
    throw new Error("readUintBE: array is too short for the given bitLength");
  for (var J = 0, _e = 1, H = I / 8 + G - 1; H >= G; H--)
    J += A[H] * _e, _e *= 256;
  return J;
}
binary.readUintBE = readUintBE;
function readUintLE(I, A, G) {
  if (G === void 0 && (G = 0), I % 8 !== 0)
    throw new Error("readUintLE supports only bitLengths divisible by 8");
  if (I / 8 > A.length - G)
    throw new Error("readUintLE: array is too short for the given bitLength");
  for (var J = 0, _e = 1, H = G; H < G + I / 8; H++)
    J += A[H] * _e, _e *= 256;
  return J;
}
binary.readUintLE = readUintLE;
function writeUintBE(I, A, G, J) {
  if (G === void 0 && (G = new Uint8Array(I / 8)), J === void 0 && (J = 0), I % 8 !== 0)
    throw new Error("writeUintBE supports only bitLengths divisible by 8");
  if (!int_1.isSafeInteger(A))
    throw new Error("writeUintBE value must be an integer");
  for (var _e = 1, H = I / 8 + J - 1; H >= J; H--)
    G[H] = A / _e & 255, _e *= 256;
  return G;
}
binary.writeUintBE = writeUintBE;
function writeUintLE(I, A, G, J) {
  if (G === void 0 && (G = new Uint8Array(I / 8)), J === void 0 && (J = 0), I % 8 !== 0)
    throw new Error("writeUintLE supports only bitLengths divisible by 8");
  if (!int_1.isSafeInteger(A))
    throw new Error("writeUintLE value must be an integer");
  for (var _e = 1, H = J; H < J + I / 8; H++)
    G[H] = A / _e & 255, _e *= 256;
  return G;
}
binary.writeUintLE = writeUintLE;
function readFloat32BE(I, A) {
  A === void 0 && (A = 0);
  var G = new DataView(I.buffer, I.byteOffset, I.byteLength);
  return G.getFloat32(A);
}
binary.readFloat32BE = readFloat32BE;
function readFloat32LE(I, A) {
  A === void 0 && (A = 0);
  var G = new DataView(I.buffer, I.byteOffset, I.byteLength);
  return G.getFloat32(A, !0);
}
binary.readFloat32LE = readFloat32LE;
function readFloat64BE(I, A) {
  A === void 0 && (A = 0);
  var G = new DataView(I.buffer, I.byteOffset, I.byteLength);
  return G.getFloat64(A);
}
binary.readFloat64BE = readFloat64BE;
function readFloat64LE(I, A) {
  A === void 0 && (A = 0);
  var G = new DataView(I.buffer, I.byteOffset, I.byteLength);
  return G.getFloat64(A, !0);
}
binary.readFloat64LE = readFloat64LE;
function writeFloat32BE(I, A, G) {
  A === void 0 && (A = new Uint8Array(4)), G === void 0 && (G = 0);
  var J = new DataView(A.buffer, A.byteOffset, A.byteLength);
  return J.setFloat32(G, I), A;
}
binary.writeFloat32BE = writeFloat32BE;
function writeFloat32LE(I, A, G) {
  A === void 0 && (A = new Uint8Array(4)), G === void 0 && (G = 0);
  var J = new DataView(A.buffer, A.byteOffset, A.byteLength);
  return J.setFloat32(G, I, !0), A;
}
binary.writeFloat32LE = writeFloat32LE;
function writeFloat64BE(I, A, G) {
  A === void 0 && (A = new Uint8Array(8)), G === void 0 && (G = 0);
  var J = new DataView(A.buffer, A.byteOffset, A.byteLength);
  return J.setFloat64(G, I), A;
}
binary.writeFloat64BE = writeFloat64BE;
function writeFloat64LE(I, A, G) {
  A === void 0 && (A = new Uint8Array(8)), G === void 0 && (G = 0);
  var J = new DataView(A.buffer, A.byteOffset, A.byteLength);
  return J.setFloat64(G, I, !0), A;
}
binary.writeFloat64LE = writeFloat64LE;
var wipe$1 = {};
Object.defineProperty(wipe$1, "__esModule", { value: !0 });
function wipe(I) {
  for (var A = 0; A < I.length; A++)
    I[A] = 0;
  return I;
}
wipe$1.wipe = wipe;
Object.defineProperty(chacha, "__esModule", { value: !0 });
var binary_1 = binary, wipe_1$3 = wipe$1, ROUNDS = 20;
function core(I, A, G) {
  for (var J = 1634760805, _e = 857760878, H = 2036477234, De = 1797285236, Ie = G[3] << 24 | G[2] << 16 | G[1] << 8 | G[0], qe = G[7] << 24 | G[6] << 16 | G[5] << 8 | G[4], Te = G[11] << 24 | G[10] << 16 | G[9] << 8 | G[8], Ee = G[15] << 24 | G[14] << 16 | G[13] << 8 | G[12], Oe = G[19] << 24 | G[18] << 16 | G[17] << 8 | G[16], Le = G[23] << 24 | G[22] << 16 | G[21] << 8 | G[20], ke = G[27] << 24 | G[26] << 16 | G[25] << 8 | G[24], Fe = G[31] << 24 | G[30] << 16 | G[29] << 8 | G[28], Ge = A[3] << 24 | A[2] << 16 | A[1] << 8 | A[0], et = A[7] << 24 | A[6] << 16 | A[5] << 8 | A[4], Ve = A[11] << 24 | A[10] << 16 | A[9] << 8 | A[8], Je = A[15] << 24 | A[14] << 16 | A[13] << 8 | A[12], ut = J, rt = _e, lt = H, vt = De, Ye = Ie, pt = qe, bt = Te, Yt = Ee, Se = Oe, t = Le, h = ke, B = Fe, Z = Ge, ve = et, ge = Ve, xe = Je, X = 0; X < ROUNDS; X += 2)
    ut = ut + Ye | 0, Z ^= ut, Z = Z >>> 16 | Z << 16, Se = Se + Z | 0, Ye ^= Se, Ye = Ye >>> 20 | Ye << 12, rt = rt + pt | 0, ve ^= rt, ve = ve >>> 16 | ve << 16, t = t + ve | 0, pt ^= t, pt = pt >>> 20 | pt << 12, lt = lt + bt | 0, ge ^= lt, ge = ge >>> 16 | ge << 16, h = h + ge | 0, bt ^= h, bt = bt >>> 20 | bt << 12, vt = vt + Yt | 0, xe ^= vt, xe = xe >>> 16 | xe << 16, B = B + xe | 0, Yt ^= B, Yt = Yt >>> 20 | Yt << 12, lt = lt + bt | 0, ge ^= lt, ge = ge >>> 24 | ge << 8, h = h + ge | 0, bt ^= h, bt = bt >>> 25 | bt << 7, vt = vt + Yt | 0, xe ^= vt, xe = xe >>> 24 | xe << 8, B = B + xe | 0, Yt ^= B, Yt = Yt >>> 25 | Yt << 7, rt = rt + pt | 0, ve ^= rt, ve = ve >>> 24 | ve << 8, t = t + ve | 0, pt ^= t, pt = pt >>> 25 | pt << 7, ut = ut + Ye | 0, Z ^= ut, Z = Z >>> 24 | Z << 8, Se = Se + Z | 0, Ye ^= Se, Ye = Ye >>> 25 | Ye << 7, ut = ut + pt | 0, xe ^= ut, xe = xe >>> 16 | xe << 16, h = h + xe | 0, pt ^= h, pt = pt >>> 20 | pt << 12, rt = rt + bt | 0, Z ^= rt, Z = Z >>> 16 | Z << 16, B = B + Z | 0, bt ^= B, bt = bt >>> 20 | bt << 12, lt = lt + Yt | 0, ve ^= lt, ve = ve >>> 16 | ve << 16, Se = Se + ve | 0, Yt ^= Se, Yt = Yt >>> 20 | Yt << 12, vt = vt + Ye | 0, ge ^= vt, ge = ge >>> 16 | ge << 16, t = t + ge | 0, Ye ^= t, Ye = Ye >>> 20 | Ye << 12, lt = lt + Yt | 0, ve ^= lt, ve = ve >>> 24 | ve << 8, Se = Se + ve | 0, Yt ^= Se, Yt = Yt >>> 25 | Yt << 7, vt = vt + Ye | 0, ge ^= vt, ge = ge >>> 24 | ge << 8, t = t + ge | 0, Ye ^= t, Ye = Ye >>> 25 | Ye << 7, rt = rt + bt | 0, Z ^= rt, Z = Z >>> 24 | Z << 8, B = B + Z | 0, bt ^= B, bt = bt >>> 25 | bt << 7, ut = ut + pt | 0, xe ^= ut, xe = xe >>> 24 | xe << 8, h = h + xe | 0, pt ^= h, pt = pt >>> 25 | pt << 7;
  binary_1.writeUint32LE(ut + J | 0, I, 0), binary_1.writeUint32LE(rt + _e | 0, I, 4), binary_1.writeUint32LE(lt + H | 0, I, 8), binary_1.writeUint32LE(vt + De | 0, I, 12), binary_1.writeUint32LE(Ye + Ie | 0, I, 16), binary_1.writeUint32LE(pt + qe | 0, I, 20), binary_1.writeUint32LE(bt + Te | 0, I, 24), binary_1.writeUint32LE(Yt + Ee | 0, I, 28), binary_1.writeUint32LE(Se + Oe | 0, I, 32), binary_1.writeUint32LE(t + Le | 0, I, 36), binary_1.writeUint32LE(h + ke | 0, I, 40), binary_1.writeUint32LE(B + Fe | 0, I, 44), binary_1.writeUint32LE(Z + Ge | 0, I, 48), binary_1.writeUint32LE(ve + et | 0, I, 52), binary_1.writeUint32LE(ge + Ve | 0, I, 56), binary_1.writeUint32LE(xe + Je | 0, I, 60);
}
function streamXOR(I, A, G, J, _e) {
  if (_e === void 0 && (_e = 0), I.length !== 32)
    throw new Error("ChaCha: key size must be 32 bytes");
  if (J.length < G.length)
    throw new Error("ChaCha: destination is shorter than source");
  var H, De;
  if (_e === 0) {
    if (A.length !== 8 && A.length !== 12)
      throw new Error("ChaCha nonce must be 8 or 12 bytes");
    H = new Uint8Array(16), De = H.length - A.length, H.set(A, De);
  } else {
    if (A.length !== 16)
      throw new Error("ChaCha nonce with counter must be 16 bytes");
    H = A, De = _e;
  }
  for (var Ie = new Uint8Array(64), qe = 0; qe < G.length; qe += 64) {
    core(Ie, H, I);
    for (var Te = qe; Te < qe + 64 && Te < G.length; Te++)
      J[Te] = G[Te] ^ Ie[Te - qe];
    incrementCounter(H, 0, De);
  }
  return wipe_1$3.wipe(Ie), _e === 0 && wipe_1$3.wipe(H), J;
}
chacha.streamXOR = streamXOR;
function stream(I, A, G, J) {
  return J === void 0 && (J = 0), wipe_1$3.wipe(G), streamXOR(I, A, G, G, J);
}
chacha.stream = stream;
function incrementCounter(I, A, G) {
  for (var J = 1; G--; )
    J = J + (I[A] & 255) | 0, I[A] = J & 255, J >>>= 8, A++;
  if (J > 0)
    throw new Error("ChaCha: counter overflow");
}
var poly1305 = {}, constantTime = {};
Object.defineProperty(constantTime, "__esModule", { value: !0 });
function select(I, A, G) {
  return ~(I - 1) & A | I - 1 & G;
}
constantTime.select = select;
function lessOrEqual(I, A) {
  return (I | 0) - (A | 0) - 1 >>> 31 & 1;
}
constantTime.lessOrEqual = lessOrEqual;
function compare(I, A) {
  if (I.length !== A.length)
    return 0;
  for (var G = 0, J = 0; J < I.length; J++)
    G |= I[J] ^ A[J];
  return 1 & G - 1 >>> 8;
}
constantTime.compare = compare;
function equal(I, A) {
  return I.length === 0 || A.length === 0 ? !1 : compare(I, A) !== 0;
}
constantTime.equal = equal;
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var A = constantTime, G = wipe$1;
  I.DIGEST_LENGTH = 16;
  var J = (
    /** @class */
    function() {
      function De(Ie) {
        this.digestLength = I.DIGEST_LENGTH, this._buffer = new Uint8Array(16), this._r = new Uint16Array(10), this._h = new Uint16Array(10), this._pad = new Uint16Array(8), this._leftover = 0, this._fin = 0, this._finished = !1;
        var qe = Ie[0] | Ie[1] << 8;
        this._r[0] = qe & 8191;
        var Te = Ie[2] | Ie[3] << 8;
        this._r[1] = (qe >>> 13 | Te << 3) & 8191;
        var Ee = Ie[4] | Ie[5] << 8;
        this._r[2] = (Te >>> 10 | Ee << 6) & 7939;
        var Oe = Ie[6] | Ie[7] << 8;
        this._r[3] = (Ee >>> 7 | Oe << 9) & 8191;
        var Le = Ie[8] | Ie[9] << 8;
        this._r[4] = (Oe >>> 4 | Le << 12) & 255, this._r[5] = Le >>> 1 & 8190;
        var ke = Ie[10] | Ie[11] << 8;
        this._r[6] = (Le >>> 14 | ke << 2) & 8191;
        var Fe = Ie[12] | Ie[13] << 8;
        this._r[7] = (ke >>> 11 | Fe << 5) & 8065;
        var Ge = Ie[14] | Ie[15] << 8;
        this._r[8] = (Fe >>> 8 | Ge << 8) & 8191, this._r[9] = Ge >>> 5 & 127, this._pad[0] = Ie[16] | Ie[17] << 8, this._pad[1] = Ie[18] | Ie[19] << 8, this._pad[2] = Ie[20] | Ie[21] << 8, this._pad[3] = Ie[22] | Ie[23] << 8, this._pad[4] = Ie[24] | Ie[25] << 8, this._pad[5] = Ie[26] | Ie[27] << 8, this._pad[6] = Ie[28] | Ie[29] << 8, this._pad[7] = Ie[30] | Ie[31] << 8;
      }
      return De.prototype._blocks = function(Ie, qe, Te) {
        for (var Ee = this._fin ? 0 : 2048, Oe = this._h[0], Le = this._h[1], ke = this._h[2], Fe = this._h[3], Ge = this._h[4], et = this._h[5], Ve = this._h[6], Je = this._h[7], ut = this._h[8], rt = this._h[9], lt = this._r[0], vt = this._r[1], Ye = this._r[2], pt = this._r[3], bt = this._r[4], Yt = this._r[5], Se = this._r[6], t = this._r[7], h = this._r[8], B = this._r[9]; Te >= 16; ) {
          var Z = Ie[qe + 0] | Ie[qe + 1] << 8;
          Oe += Z & 8191;
          var ve = Ie[qe + 2] | Ie[qe + 3] << 8;
          Le += (Z >>> 13 | ve << 3) & 8191;
          var ge = Ie[qe + 4] | Ie[qe + 5] << 8;
          ke += (ve >>> 10 | ge << 6) & 8191;
          var xe = Ie[qe + 6] | Ie[qe + 7] << 8;
          Fe += (ge >>> 7 | xe << 9) & 8191;
          var X = Ie[qe + 8] | Ie[qe + 9] << 8;
          Ge += (xe >>> 4 | X << 12) & 8191, et += X >>> 1 & 8191;
          var a = Ie[qe + 10] | Ie[qe + 11] << 8;
          Ve += (X >>> 14 | a << 2) & 8191;
          var Y = Ie[qe + 12] | Ie[qe + 13] << 8;
          Je += (a >>> 11 | Y << 5) & 8191;
          var Ne = Ie[qe + 14] | Ie[qe + 15] << 8;
          ut += (Y >>> 8 | Ne << 8) & 8191, rt += Ne >>> 5 | Ee;
          var Ke = 0, tt = Ke;
          tt += Oe * lt, tt += Le * (5 * B), tt += ke * (5 * h), tt += Fe * (5 * t), tt += Ge * (5 * Se), Ke = tt >>> 13, tt &= 8191, tt += et * (5 * Yt), tt += Ve * (5 * bt), tt += Je * (5 * pt), tt += ut * (5 * Ye), tt += rt * (5 * vt), Ke += tt >>> 13, tt &= 8191;
          var We = Ke;
          We += Oe * vt, We += Le * lt, We += ke * (5 * B), We += Fe * (5 * h), We += Ge * (5 * t), Ke = We >>> 13, We &= 8191, We += et * (5 * Se), We += Ve * (5 * Yt), We += Je * (5 * bt), We += ut * (5 * pt), We += rt * (5 * Ye), Ke += We >>> 13, We &= 8191;
          var ot = Ke;
          ot += Oe * Ye, ot += Le * vt, ot += ke * lt, ot += Fe * (5 * B), ot += Ge * (5 * h), Ke = ot >>> 13, ot &= 8191, ot += et * (5 * t), ot += Ve * (5 * Se), ot += Je * (5 * Yt), ot += ut * (5 * bt), ot += rt * (5 * pt), Ke += ot >>> 13, ot &= 8191;
          var He = Ke;
          He += Oe * pt, He += Le * Ye, He += ke * vt, He += Fe * lt, He += Ge * (5 * B), Ke = He >>> 13, He &= 8191, He += et * (5 * h), He += Ve * (5 * t), He += Je * (5 * Se), He += ut * (5 * Yt), He += rt * (5 * bt), Ke += He >>> 13, He &= 8191;
          var Qe = Ke;
          Qe += Oe * bt, Qe += Le * pt, Qe += ke * Ye, Qe += Fe * vt, Qe += Ge * lt, Ke = Qe >>> 13, Qe &= 8191, Qe += et * (5 * B), Qe += Ve * (5 * h), Qe += Je * (5 * t), Qe += ut * (5 * Se), Qe += rt * (5 * Yt), Ke += Qe >>> 13, Qe &= 8191;
          var nt = Ke;
          nt += Oe * Yt, nt += Le * bt, nt += ke * pt, nt += Fe * Ye, nt += Ge * vt, Ke = nt >>> 13, nt &= 8191, nt += et * lt, nt += Ve * (5 * B), nt += Je * (5 * h), nt += ut * (5 * t), nt += rt * (5 * Se), Ke += nt >>> 13, nt &= 8191;
          var je = Ke;
          je += Oe * Se, je += Le * Yt, je += ke * bt, je += Fe * pt, je += Ge * Ye, Ke = je >>> 13, je &= 8191, je += et * vt, je += Ve * lt, je += Je * (5 * B), je += ut * (5 * h), je += rt * (5 * t), Ke += je >>> 13, je &= 8191;
          var it = Ke;
          it += Oe * t, it += Le * Se, it += ke * Yt, it += Fe * bt, it += Ge * pt, Ke = it >>> 13, it &= 8191, it += et * Ye, it += Ve * vt, it += Je * lt, it += ut * (5 * B), it += rt * (5 * h), Ke += it >>> 13, it &= 8191;
          var st = Ke;
          st += Oe * h, st += Le * t, st += ke * Se, st += Fe * Yt, st += Ge * bt, Ke = st >>> 13, st &= 8191, st += et * pt, st += Ve * Ye, st += Je * vt, st += ut * lt, st += rt * (5 * B), Ke += st >>> 13, st &= 8191;
          var gt = Ke;
          gt += Oe * B, gt += Le * h, gt += ke * t, gt += Fe * Se, gt += Ge * Yt, Ke = gt >>> 13, gt &= 8191, gt += et * bt, gt += Ve * pt, gt += Je * Ye, gt += ut * vt, gt += rt * lt, Ke += gt >>> 13, gt &= 8191, Ke = (Ke << 2) + Ke | 0, Ke = Ke + tt | 0, tt = Ke & 8191, Ke = Ke >>> 13, We += Ke, Oe = tt, Le = We, ke = ot, Fe = He, Ge = Qe, et = nt, Ve = je, Je = it, ut = st, rt = gt, qe += 16, Te -= 16;
        }
        this._h[0] = Oe, this._h[1] = Le, this._h[2] = ke, this._h[3] = Fe, this._h[4] = Ge, this._h[5] = et, this._h[6] = Ve, this._h[7] = Je, this._h[8] = ut, this._h[9] = rt;
      }, De.prototype.finish = function(Ie, qe) {
        qe === void 0 && (qe = 0);
        var Te = new Uint16Array(10), Ee, Oe, Le, ke;
        if (this._leftover) {
          for (ke = this._leftover, this._buffer[ke++] = 1; ke < 16; ke++)
            this._buffer[ke] = 0;
          this._fin = 1, this._blocks(this._buffer, 0, 16);
        }
        for (Ee = this._h[1] >>> 13, this._h[1] &= 8191, ke = 2; ke < 10; ke++)
          this._h[ke] += Ee, Ee = this._h[ke] >>> 13, this._h[ke] &= 8191;
        for (this._h[0] += Ee * 5, Ee = this._h[0] >>> 13, this._h[0] &= 8191, this._h[1] += Ee, Ee = this._h[1] >>> 13, this._h[1] &= 8191, this._h[2] += Ee, Te[0] = this._h[0] + 5, Ee = Te[0] >>> 13, Te[0] &= 8191, ke = 1; ke < 10; ke++)
          Te[ke] = this._h[ke] + Ee, Ee = Te[ke] >>> 13, Te[ke] &= 8191;
        for (Te[9] -= 8192, Oe = (Ee ^ 1) - 1, ke = 0; ke < 10; ke++)
          Te[ke] &= Oe;
        for (Oe = ~Oe, ke = 0; ke < 10; ke++)
          this._h[ke] = this._h[ke] & Oe | Te[ke];
        for (this._h[0] = (this._h[0] | this._h[1] << 13) & 65535, this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 65535, this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 65535, this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 65535, this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 65535, this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 65535, this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 65535, this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 65535, Le = this._h[0] + this._pad[0], this._h[0] = Le & 65535, ke = 1; ke < 8; ke++)
          Le = (this._h[ke] + this._pad[ke] | 0) + (Le >>> 16) | 0, this._h[ke] = Le & 65535;
        return Ie[qe + 0] = this._h[0] >>> 0, Ie[qe + 1] = this._h[0] >>> 8, Ie[qe + 2] = this._h[1] >>> 0, Ie[qe + 3] = this._h[1] >>> 8, Ie[qe + 4] = this._h[2] >>> 0, Ie[qe + 5] = this._h[2] >>> 8, Ie[qe + 6] = this._h[3] >>> 0, Ie[qe + 7] = this._h[3] >>> 8, Ie[qe + 8] = this._h[4] >>> 0, Ie[qe + 9] = this._h[4] >>> 8, Ie[qe + 10] = this._h[5] >>> 0, Ie[qe + 11] = this._h[5] >>> 8, Ie[qe + 12] = this._h[6] >>> 0, Ie[qe + 13] = this._h[6] >>> 8, Ie[qe + 14] = this._h[7] >>> 0, Ie[qe + 15] = this._h[7] >>> 8, this._finished = !0, this;
      }, De.prototype.update = function(Ie) {
        var qe = 0, Te = Ie.length, Ee;
        if (this._leftover) {
          Ee = 16 - this._leftover, Ee > Te && (Ee = Te);
          for (var Oe = 0; Oe < Ee; Oe++)
            this._buffer[this._leftover + Oe] = Ie[qe + Oe];
          if (Te -= Ee, qe += Ee, this._leftover += Ee, this._leftover < 16)
            return this;
          this._blocks(this._buffer, 0, 16), this._leftover = 0;
        }
        if (Te >= 16 && (Ee = Te - Te % 16, this._blocks(Ie, qe, Ee), qe += Ee, Te -= Ee), Te) {
          for (var Oe = 0; Oe < Te; Oe++)
            this._buffer[this._leftover + Oe] = Ie[qe + Oe];
          this._leftover += Te;
        }
        return this;
      }, De.prototype.digest = function() {
        if (this._finished)
          throw new Error("Poly1305 was finished");
        var Ie = new Uint8Array(16);
        return this.finish(Ie), Ie;
      }, De.prototype.clean = function() {
        return G.wipe(this._buffer), G.wipe(this._r), G.wipe(this._h), G.wipe(this._pad), this._leftover = 0, this._fin = 0, this._finished = !0, this;
      }, De;
    }()
  );
  I.Poly1305 = J;
  function _e(De, Ie) {
    var qe = new J(De);
    qe.update(Ie);
    var Te = qe.digest();
    return qe.clean(), Te;
  }
  I.oneTimeAuth = _e;
  function H(De, Ie) {
    return De.length !== I.DIGEST_LENGTH || Ie.length !== I.DIGEST_LENGTH ? !1 : A.equal(De, Ie);
  }
  I.equal = H;
})(poly1305);
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var A = chacha, G = poly1305, J = wipe$1, _e = binary, H = constantTime;
  I.KEY_LENGTH = 32, I.NONCE_LENGTH = 12, I.TAG_LENGTH = 16;
  var De = new Uint8Array(16), Ie = (
    /** @class */
    function() {
      function qe(Te) {
        if (this.nonceLength = I.NONCE_LENGTH, this.tagLength = I.TAG_LENGTH, Te.length !== I.KEY_LENGTH)
          throw new Error("ChaCha20Poly1305 needs 32-byte key");
        this._key = new Uint8Array(Te);
      }
      return qe.prototype.seal = function(Te, Ee, Oe, Le) {
        if (Te.length > 16)
          throw new Error("ChaCha20Poly1305: incorrect nonce length");
        var ke = new Uint8Array(16);
        ke.set(Te, ke.length - Te.length);
        var Fe = new Uint8Array(32);
        A.stream(this._key, ke, Fe, 4);
        var Ge = Ee.length + this.tagLength, et;
        if (Le) {
          if (Le.length !== Ge)
            throw new Error("ChaCha20Poly1305: incorrect destination length");
          et = Le;
        } else
          et = new Uint8Array(Ge);
        return A.streamXOR(this._key, ke, Ee, et, 4), this._authenticate(et.subarray(et.length - this.tagLength, et.length), Fe, et.subarray(0, et.length - this.tagLength), Oe), J.wipe(ke), et;
      }, qe.prototype.open = function(Te, Ee, Oe, Le) {
        if (Te.length > 16)
          throw new Error("ChaCha20Poly1305: incorrect nonce length");
        if (Ee.length < this.tagLength)
          return null;
        var ke = new Uint8Array(16);
        ke.set(Te, ke.length - Te.length);
        var Fe = new Uint8Array(32);
        A.stream(this._key, ke, Fe, 4);
        var Ge = new Uint8Array(this.tagLength);
        if (this._authenticate(Ge, Fe, Ee.subarray(0, Ee.length - this.tagLength), Oe), !H.equal(Ge, Ee.subarray(Ee.length - this.tagLength, Ee.length)))
          return null;
        var et = Ee.length - this.tagLength, Ve;
        if (Le) {
          if (Le.length !== et)
            throw new Error("ChaCha20Poly1305: incorrect destination length");
          Ve = Le;
        } else
          Ve = new Uint8Array(et);
        return A.streamXOR(this._key, ke, Ee.subarray(0, Ee.length - this.tagLength), Ve, 4), J.wipe(ke), Ve;
      }, qe.prototype.clean = function() {
        return J.wipe(this._key), this;
      }, qe.prototype._authenticate = function(Te, Ee, Oe, Le) {
        var ke = new G.Poly1305(Ee);
        Le && (ke.update(Le), Le.length % 16 > 0 && ke.update(De.subarray(Le.length % 16))), ke.update(Oe), Oe.length % 16 > 0 && ke.update(De.subarray(Oe.length % 16));
        var Fe = new Uint8Array(8);
        Le && _e.writeUint64LE(Le.length, Fe), ke.update(Fe), _e.writeUint64LE(Oe.length, Fe), ke.update(Fe);
        for (var Ge = ke.digest(), et = 0; et < Ge.length; et++)
          Te[et] = Ge[et];
        ke.clean(), J.wipe(Ge), J.wipe(Fe);
      }, qe;
    }()
  );
  I.ChaCha20Poly1305 = Ie;
})(chacha20poly1305);
var hkdf = {}, hmac$2 = {}, hash$3 = {};
Object.defineProperty(hash$3, "__esModule", { value: !0 });
function isSerializableHash(I) {
  return typeof I.saveState < "u" && typeof I.restoreState < "u" && typeof I.cleanSavedState < "u";
}
hash$3.isSerializableHash = isSerializableHash;
Object.defineProperty(hmac$2, "__esModule", { value: !0 });
var hash_1 = hash$3, constant_time_1 = constantTime, wipe_1$2 = wipe$1, HMAC = (
  /** @class */
  function() {
    function I(A, G) {
      this._finished = !1, this._inner = new A(), this._outer = new A(), this.blockSize = this._outer.blockSize, this.digestLength = this._outer.digestLength;
      var J = new Uint8Array(this.blockSize);
      G.length > this.blockSize ? this._inner.update(G).finish(J).clean() : J.set(G);
      for (var _e = 0; _e < J.length; _e++)
        J[_e] ^= 54;
      this._inner.update(J);
      for (var _e = 0; _e < J.length; _e++)
        J[_e] ^= 106;
      this._outer.update(J), hash_1.isSerializableHash(this._inner) && hash_1.isSerializableHash(this._outer) && (this._innerKeyedState = this._inner.saveState(), this._outerKeyedState = this._outer.saveState()), wipe_1$2.wipe(J);
    }
    return I.prototype.reset = function() {
      if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer))
        throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
      return this._inner.restoreState(this._innerKeyedState), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
    }, I.prototype.clean = function() {
      hash_1.isSerializableHash(this._inner) && this._inner.cleanSavedState(this._innerKeyedState), hash_1.isSerializableHash(this._outer) && this._outer.cleanSavedState(this._outerKeyedState), this._inner.clean(), this._outer.clean();
    }, I.prototype.update = function(A) {
      return this._inner.update(A), this;
    }, I.prototype.finish = function(A) {
      return this._finished ? (this._outer.finish(A), this) : (this._inner.finish(A), this._outer.update(A.subarray(0, this.digestLength)).finish(A), this._finished = !0, this);
    }, I.prototype.digest = function() {
      var A = new Uint8Array(this.digestLength);
      return this.finish(A), A;
    }, I.prototype.saveState = function() {
      if (!hash_1.isSerializableHash(this._inner))
        throw new Error("hmac: can't saveState() because hash doesn't implement it");
      return this._inner.saveState();
    }, I.prototype.restoreState = function(A) {
      if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer))
        throw new Error("hmac: can't restoreState() because hash doesn't implement it");
      return this._inner.restoreState(A), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
    }, I.prototype.cleanSavedState = function(A) {
      if (!hash_1.isSerializableHash(this._inner))
        throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
      this._inner.cleanSavedState(A);
    }, I;
  }()
);
hmac$2.HMAC = HMAC;
function hmac$1(I, A, G) {
  var J = new HMAC(I, A);
  J.update(G);
  var _e = J.digest();
  return J.clean(), _e;
}
hmac$2.hmac = hmac$1;
hmac$2.equal = constant_time_1.equal;
Object.defineProperty(hkdf, "__esModule", { value: !0 });
var hmac_1 = hmac$2, wipe_1$1 = wipe$1, HKDF = (
  /** @class */
  function() {
    function I(A, G, J, _e) {
      J === void 0 && (J = new Uint8Array(0)), this._counter = new Uint8Array(1), this._hash = A, this._info = _e;
      var H = hmac_1.hmac(this._hash, J, G);
      this._hmac = new hmac_1.HMAC(A, H), this._buffer = new Uint8Array(this._hmac.digestLength), this._bufpos = this._buffer.length;
    }
    return I.prototype._fillBuffer = function() {
      this._counter[0]++;
      var A = this._counter[0];
      if (A === 0)
        throw new Error("hkdf: cannot expand more");
      this._hmac.reset(), A > 1 && this._hmac.update(this._buffer), this._info && this._hmac.update(this._info), this._hmac.update(this._counter), this._hmac.finish(this._buffer), this._bufpos = 0;
    }, I.prototype.expand = function(A) {
      for (var G = new Uint8Array(A), J = 0; J < G.length; J++)
        this._bufpos === this._buffer.length && this._fillBuffer(), G[J] = this._buffer[this._bufpos++];
      return G;
    }, I.prototype.clean = function() {
      this._hmac.clean(), wipe_1$1.wipe(this._buffer), wipe_1$1.wipe(this._counter), this._bufpos = 0;
    }, I;
  }()
);
hkdf.HKDF = HKDF;
var random = {}, system = {}, browser$c = {};
Object.defineProperty(browser$c, "__esModule", { value: !0 });
browser$c.BrowserRandomSource = void 0;
const QUOTA = 65536;
class BrowserRandomSource {
  constructor() {
    this.isAvailable = !1, this.isInstantiated = !1;
    const A = typeof self < "u" ? self.crypto || self.msCrypto : null;
    A && A.getRandomValues !== void 0 && (this._crypto = A, this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(A) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Browser random byte generator is not available.");
    const G = new Uint8Array(A);
    for (let J = 0; J < G.length; J += QUOTA)
      this._crypto.getRandomValues(G.subarray(J, J + Math.min(G.length - J, QUOTA)));
    return G;
  }
}
browser$c.BrowserRandomSource = BrowserRandomSource;
function commonjsRequire(I) {
  throw new Error('Could not dynamically require "' + I + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var node$1 = {}, cryptoBrowserify = {}, browser$b = { exports: {} }, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a) return browser$b.exports;
  hasRequiredBrowser$a = 1;
  var I = 65536, A = 4294967295;
  function G() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var J = safeBufferExports.Buffer, _e = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
  _e && _e.getRandomValues ? browser$b.exports = H : browser$b.exports = G;
  function H(De, Ie) {
    if (De > A) throw new RangeError("requested too many random bytes");
    var qe = J.allocUnsafe(De);
    if (De > 0)
      if (De > I)
        for (var Te = 0; Te < De; Te += I)
          _e.getRandomValues(qe.slice(Te, Te + I));
      else
        _e.getRandomValues(qe);
    return typeof Ie == "function" ? process$1.nextTick(function() {
      Ie(null, qe);
    }) : qe;
  }
  return browser$b.exports;
}
var hashBase$1, hasRequiredHashBase$1;
function requireHashBase$1() {
  if (hasRequiredHashBase$1) return hashBase$1;
  hasRequiredHashBase$1 = 1;
  var I = safeBufferExports.Buffer, A = readableBrowserExports.Transform, G = inherits_browserExports;
  function J(H, De) {
    if (!I.isBuffer(H) && typeof H != "string")
      throw new TypeError(De + " must be a string or a buffer");
  }
  function _e(H) {
    A.call(this), this._block = I.allocUnsafe(H), this._blockSize = H, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return G(_e, A), _e.prototype._transform = function(H, De, Ie) {
    var qe = null;
    try {
      this.update(H, De);
    } catch (Te) {
      qe = Te;
    }
    Ie(qe);
  }, _e.prototype._flush = function(H) {
    var De = null;
    try {
      this.push(this.digest());
    } catch (Ie) {
      De = Ie;
    }
    H(De);
  }, _e.prototype.update = function(H, De) {
    if (J(H, "Data"), this._finalized) throw new Error("Digest already called");
    I.isBuffer(H) || (H = I.from(H, De));
    for (var Ie = this._block, qe = 0; this._blockOffset + H.length - qe >= this._blockSize; ) {
      for (var Te = this._blockOffset; Te < this._blockSize; ) Ie[Te++] = H[qe++];
      this._update(), this._blockOffset = 0;
    }
    for (; qe < H.length; ) Ie[this._blockOffset++] = H[qe++];
    for (var Ee = 0, Oe = H.length * 8; Oe > 0; ++Ee)
      this._length[Ee] += Oe, Oe = this._length[Ee] / 4294967296 | 0, Oe > 0 && (this._length[Ee] -= 4294967296 * Oe);
    return this;
  }, _e.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, _e.prototype.digest = function(H) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var De = this._digest();
    H !== void 0 && (De = De.toString(H)), this._block.fill(0), this._blockOffset = 0;
    for (var Ie = 0; Ie < 4; ++Ie) this._length[Ie] = 0;
    return De;
  }, _e.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase$1 = _e, hashBase$1;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js) return md5_js;
  hasRequiredMd5_js = 1;
  var I = inherits_browserExports, A = requireHashBase$1(), G = safeBufferExports.Buffer, J = new Array(16);
  function _e() {
    A.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  I(_e, A), _e.prototype._update = function() {
    for (var Ee = J, Oe = 0; Oe < 16; ++Oe) Ee[Oe] = this._block.readInt32LE(Oe * 4);
    var Le = this._a, ke = this._b, Fe = this._c, Ge = this._d;
    Le = De(Le, ke, Fe, Ge, Ee[0], 3614090360, 7), Ge = De(Ge, Le, ke, Fe, Ee[1], 3905402710, 12), Fe = De(Fe, Ge, Le, ke, Ee[2], 606105819, 17), ke = De(ke, Fe, Ge, Le, Ee[3], 3250441966, 22), Le = De(Le, ke, Fe, Ge, Ee[4], 4118548399, 7), Ge = De(Ge, Le, ke, Fe, Ee[5], 1200080426, 12), Fe = De(Fe, Ge, Le, ke, Ee[6], 2821735955, 17), ke = De(ke, Fe, Ge, Le, Ee[7], 4249261313, 22), Le = De(Le, ke, Fe, Ge, Ee[8], 1770035416, 7), Ge = De(Ge, Le, ke, Fe, Ee[9], 2336552879, 12), Fe = De(Fe, Ge, Le, ke, Ee[10], 4294925233, 17), ke = De(ke, Fe, Ge, Le, Ee[11], 2304563134, 22), Le = De(Le, ke, Fe, Ge, Ee[12], 1804603682, 7), Ge = De(Ge, Le, ke, Fe, Ee[13], 4254626195, 12), Fe = De(Fe, Ge, Le, ke, Ee[14], 2792965006, 17), ke = De(ke, Fe, Ge, Le, Ee[15], 1236535329, 22), Le = Ie(Le, ke, Fe, Ge, Ee[1], 4129170786, 5), Ge = Ie(Ge, Le, ke, Fe, Ee[6], 3225465664, 9), Fe = Ie(Fe, Ge, Le, ke, Ee[11], 643717713, 14), ke = Ie(ke, Fe, Ge, Le, Ee[0], 3921069994, 20), Le = Ie(Le, ke, Fe, Ge, Ee[5], 3593408605, 5), Ge = Ie(Ge, Le, ke, Fe, Ee[10], 38016083, 9), Fe = Ie(Fe, Ge, Le, ke, Ee[15], 3634488961, 14), ke = Ie(ke, Fe, Ge, Le, Ee[4], 3889429448, 20), Le = Ie(Le, ke, Fe, Ge, Ee[9], 568446438, 5), Ge = Ie(Ge, Le, ke, Fe, Ee[14], 3275163606, 9), Fe = Ie(Fe, Ge, Le, ke, Ee[3], 4107603335, 14), ke = Ie(ke, Fe, Ge, Le, Ee[8], 1163531501, 20), Le = Ie(Le, ke, Fe, Ge, Ee[13], 2850285829, 5), Ge = Ie(Ge, Le, ke, Fe, Ee[2], 4243563512, 9), Fe = Ie(Fe, Ge, Le, ke, Ee[7], 1735328473, 14), ke = Ie(ke, Fe, Ge, Le, Ee[12], 2368359562, 20), Le = qe(Le, ke, Fe, Ge, Ee[5], 4294588738, 4), Ge = qe(Ge, Le, ke, Fe, Ee[8], 2272392833, 11), Fe = qe(Fe, Ge, Le, ke, Ee[11], 1839030562, 16), ke = qe(ke, Fe, Ge, Le, Ee[14], 4259657740, 23), Le = qe(Le, ke, Fe, Ge, Ee[1], 2763975236, 4), Ge = qe(Ge, Le, ke, Fe, Ee[4], 1272893353, 11), Fe = qe(Fe, Ge, Le, ke, Ee[7], 4139469664, 16), ke = qe(ke, Fe, Ge, Le, Ee[10], 3200236656, 23), Le = qe(Le, ke, Fe, Ge, Ee[13], 681279174, 4), Ge = qe(Ge, Le, ke, Fe, Ee[0], 3936430074, 11), Fe = qe(Fe, Ge, Le, ke, Ee[3], 3572445317, 16), ke = qe(ke, Fe, Ge, Le, Ee[6], 76029189, 23), Le = qe(Le, ke, Fe, Ge, Ee[9], 3654602809, 4), Ge = qe(Ge, Le, ke, Fe, Ee[12], 3873151461, 11), Fe = qe(Fe, Ge, Le, ke, Ee[15], 530742520, 16), ke = qe(ke, Fe, Ge, Le, Ee[2], 3299628645, 23), Le = Te(Le, ke, Fe, Ge, Ee[0], 4096336452, 6), Ge = Te(Ge, Le, ke, Fe, Ee[7], 1126891415, 10), Fe = Te(Fe, Ge, Le, ke, Ee[14], 2878612391, 15), ke = Te(ke, Fe, Ge, Le, Ee[5], 4237533241, 21), Le = Te(Le, ke, Fe, Ge, Ee[12], 1700485571, 6), Ge = Te(Ge, Le, ke, Fe, Ee[3], 2399980690, 10), Fe = Te(Fe, Ge, Le, ke, Ee[10], 4293915773, 15), ke = Te(ke, Fe, Ge, Le, Ee[1], 2240044497, 21), Le = Te(Le, ke, Fe, Ge, Ee[8], 1873313359, 6), Ge = Te(Ge, Le, ke, Fe, Ee[15], 4264355552, 10), Fe = Te(Fe, Ge, Le, ke, Ee[6], 2734768916, 15), ke = Te(ke, Fe, Ge, Le, Ee[13], 1309151649, 21), Le = Te(Le, ke, Fe, Ge, Ee[4], 4149444226, 6), Ge = Te(Ge, Le, ke, Fe, Ee[11], 3174756917, 10), Fe = Te(Fe, Ge, Le, ke, Ee[2], 718787259, 15), ke = Te(ke, Fe, Ge, Le, Ee[9], 3951481745, 21), this._a = this._a + Le | 0, this._b = this._b + ke | 0, this._c = this._c + Fe | 0, this._d = this._d + Ge | 0;
  }, _e.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var Ee = G.allocUnsafe(16);
    return Ee.writeInt32LE(this._a, 0), Ee.writeInt32LE(this._b, 4), Ee.writeInt32LE(this._c, 8), Ee.writeInt32LE(this._d, 12), Ee;
  };
  function H(Ee, Oe) {
    return Ee << Oe | Ee >>> 32 - Oe;
  }
  function De(Ee, Oe, Le, ke, Fe, Ge, et) {
    return H(Ee + (Oe & Le | ~Oe & ke) + Fe + Ge | 0, et) + Oe | 0;
  }
  function Ie(Ee, Oe, Le, ke, Fe, Ge, et) {
    return H(Ee + (Oe & ke | Le & ~ke) + Fe + Ge | 0, et) + Oe | 0;
  }
  function qe(Ee, Oe, Le, ke, Fe, Ge, et) {
    return H(Ee + (Oe ^ Le ^ ke) + Fe + Ge | 0, et) + Oe | 0;
  }
  function Te(Ee, Oe, Le, ke, Fe, Ge, et) {
    return H(Ee + (Le ^ (Oe | ~ke)) + Fe + Ge | 0, et) + Oe | 0;
  }
  return md5_js = _e, md5_js;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase) return hashBase;
  hasRequiredHashBase = 1;
  var I = safeBufferExports.Buffer, A = readableBrowserExports.Transform, G = inherits_browserExports;
  function J(H, De) {
    if (!I.isBuffer(H) && typeof H != "string")
      throw new TypeError(De + " must be a string or a buffer");
  }
  function _e(H) {
    A.call(this), this._block = I.allocUnsafe(H), this._blockSize = H, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return G(_e, A), _e.prototype._transform = function(H, De, Ie) {
    var qe = null;
    try {
      this.update(H, De);
    } catch (Te) {
      qe = Te;
    }
    Ie(qe);
  }, _e.prototype._flush = function(H) {
    var De = null;
    try {
      this.push(this.digest());
    } catch (Ie) {
      De = Ie;
    }
    H(De);
  }, _e.prototype.update = function(H, De) {
    if (J(H, "Data"), this._finalized) throw new Error("Digest already called");
    I.isBuffer(H) || (H = I.from(H, De));
    for (var Ie = this._block, qe = 0; this._blockOffset + H.length - qe >= this._blockSize; ) {
      for (var Te = this._blockOffset; Te < this._blockSize; ) Ie[Te++] = H[qe++];
      this._update(), this._blockOffset = 0;
    }
    for (; qe < H.length; ) Ie[this._blockOffset++] = H[qe++];
    for (var Ee = 0, Oe = H.length * 8; Oe > 0; ++Ee)
      this._length[Ee] += Oe, Oe = this._length[Ee] / 4294967296 | 0, Oe > 0 && (this._length[Ee] -= 4294967296 * Oe);
    return this;
  }, _e.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, _e.prototype.digest = function(H) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var De = this._digest();
    H !== void 0 && (De = De.toString(H)), this._block.fill(0), this._blockOffset = 0;
    for (var Ie = 0; Ie < 4; ++Ie) this._length[Ie] = 0;
    return De;
  }, _e.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = _e, hashBase;
}
var ripemd160, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160) return ripemd160;
  hasRequiredRipemd160 = 1;
  var I = require$$0$3.Buffer, A = inherits_browserExports, G = requireHashBase(), J = new Array(16), _e = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], H = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], De = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], Ie = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], qe = [0, 1518500249, 1859775393, 2400959708, 2840853838], Te = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function Ee() {
    G.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  A(Ee, G), Ee.prototype._update = function() {
    for (var Ve = J, Je = 0; Je < 16; ++Je) Ve[Je] = this._block.readInt32LE(Je * 4);
    for (var ut = this._a | 0, rt = this._b | 0, lt = this._c | 0, vt = this._d | 0, Ye = this._e | 0, pt = this._a | 0, bt = this._b | 0, Yt = this._c | 0, Se = this._d | 0, t = this._e | 0, h = 0; h < 80; h += 1) {
      var B, Z;
      h < 16 ? (B = Le(ut, rt, lt, vt, Ye, Ve[_e[h]], qe[0], De[h]), Z = et(pt, bt, Yt, Se, t, Ve[H[h]], Te[0], Ie[h])) : h < 32 ? (B = ke(ut, rt, lt, vt, Ye, Ve[_e[h]], qe[1], De[h]), Z = Ge(pt, bt, Yt, Se, t, Ve[H[h]], Te[1], Ie[h])) : h < 48 ? (B = Fe(ut, rt, lt, vt, Ye, Ve[_e[h]], qe[2], De[h]), Z = Fe(pt, bt, Yt, Se, t, Ve[H[h]], Te[2], Ie[h])) : h < 64 ? (B = Ge(ut, rt, lt, vt, Ye, Ve[_e[h]], qe[3], De[h]), Z = ke(pt, bt, Yt, Se, t, Ve[H[h]], Te[3], Ie[h])) : (B = et(ut, rt, lt, vt, Ye, Ve[_e[h]], qe[4], De[h]), Z = Le(pt, bt, Yt, Se, t, Ve[H[h]], Te[4], Ie[h])), ut = Ye, Ye = vt, vt = Oe(lt, 10), lt = rt, rt = B, pt = t, t = Se, Se = Oe(Yt, 10), Yt = bt, bt = Z;
    }
    var ve = this._b + lt + Se | 0;
    this._b = this._c + vt + t | 0, this._c = this._d + Ye + pt | 0, this._d = this._e + ut + bt | 0, this._e = this._a + rt + Yt | 0, this._a = ve;
  }, Ee.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var Ve = I.alloc ? I.alloc(20) : new I(20);
    return Ve.writeInt32LE(this._a, 0), Ve.writeInt32LE(this._b, 4), Ve.writeInt32LE(this._c, 8), Ve.writeInt32LE(this._d, 12), Ve.writeInt32LE(this._e, 16), Ve;
  };
  function Oe(Ve, Je) {
    return Ve << Je | Ve >>> 32 - Je;
  }
  function Le(Ve, Je, ut, rt, lt, vt, Ye, pt) {
    return Oe(Ve + (Je ^ ut ^ rt) + vt + Ye | 0, pt) + lt | 0;
  }
  function ke(Ve, Je, ut, rt, lt, vt, Ye, pt) {
    return Oe(Ve + (Je & ut | ~Je & rt) + vt + Ye | 0, pt) + lt | 0;
  }
  function Fe(Ve, Je, ut, rt, lt, vt, Ye, pt) {
    return Oe(Ve + ((Je | ~ut) ^ rt) + vt + Ye | 0, pt) + lt | 0;
  }
  function Ge(Ve, Je, ut, rt, lt, vt, Ye, pt) {
    return Oe(Ve + (Je & rt | ut & ~rt) + vt + Ye | 0, pt) + lt | 0;
  }
  function et(Ve, Je, ut, rt, lt, vt, Ye, pt) {
    return Oe(Ve + (Je ^ (ut | ~rt)) + vt + Ye | 0, pt) + lt | 0;
  }
  return ripemd160 = Ee, ripemd160;
}
var streamBrowserify, hasRequiredStreamBrowserify;
function requireStreamBrowserify() {
  if (hasRequiredStreamBrowserify) return streamBrowserify;
  hasRequiredStreamBrowserify = 1, streamBrowserify = G;
  var I = eventsExports.EventEmitter, A = inherits_browserExports;
  A(G, I), G.Readable = require_stream_readable$1(), G.Writable = require_stream_writable$1(), G.Duplex = require_stream_duplex$1(), G.Transform = _stream_transform$1, G.PassThrough = _stream_passthrough$1, G.finished = endOfStream, G.pipeline = pipeline_1, G.Stream = G;
  function G() {
    I.call(this);
  }
  return G.prototype.pipe = function(J, _e) {
    var H = this;
    function De(ke) {
      J.writable && J.write(ke) === !1 && H.pause && H.pause();
    }
    H.on("data", De);
    function Ie() {
      H.readable && H.resume && H.resume();
    }
    J.on("drain", Ie), !J._isStdio && (!_e || _e.end !== !1) && (H.on("end", Te), H.on("close", Ee));
    var qe = !1;
    function Te() {
      qe || (qe = !0, J.end());
    }
    function Ee() {
      qe || (qe = !0, typeof J.destroy == "function" && J.destroy());
    }
    function Oe(ke) {
      if (Le(), I.listenerCount(this, "error") === 0)
        throw ke;
    }
    H.on("error", Oe), J.on("error", Oe);
    function Le() {
      H.removeListener("data", De), J.removeListener("drain", Ie), H.removeListener("end", Te), H.removeListener("close", Ee), H.removeListener("error", Oe), J.removeListener("error", Oe), H.removeListener("end", Le), H.removeListener("close", Le), J.removeListener("close", Le);
    }
    return H.on("end", Le), H.on("close", Le), J.on("close", Le), J.emit("pipe", H), J;
  }, streamBrowserify;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase) return cipherBase;
  hasRequiredCipherBase = 1;
  var I = safeBufferExports.Buffer, A = requireStreamBrowserify().Transform, G = requireString_decoder().StringDecoder, J = inherits_browserExports;
  function _e(H) {
    A.call(this), this.hashMode = typeof H == "string", this.hashMode ? this[H] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  return J(_e, A), _e.prototype.update = function(H, De, Ie) {
    typeof H == "string" && (H = I.from(H, De));
    var qe = this._update(H);
    return this.hashMode ? this : (Ie && (qe = this._toString(qe, Ie)), qe);
  }, _e.prototype.setAutoPadding = function() {
  }, _e.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, _e.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, _e.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, _e.prototype._transform = function(H, De, Ie) {
    var qe;
    try {
      this.hashMode ? this._update(H) : this.push(this._update(H));
    } catch (Te) {
      qe = Te;
    } finally {
      Ie(qe);
    }
  }, _e.prototype._flush = function(H) {
    var De;
    try {
      this.push(this.__final());
    } catch (Ie) {
      De = Ie;
    }
    H(De);
  }, _e.prototype._finalOrDigest = function(H) {
    var De = this.__final() || I.alloc(0);
    return H && (De = this._toString(De, H, !0)), De;
  }, _e.prototype._toString = function(H, De, Ie) {
    if (this._decoder || (this._decoder = new G(De), this._encoding = De), this._encoding !== De) throw new Error("can't switch encodings");
    var qe = this._decoder.write(H);
    return Ie && (qe += this._decoder.end()), qe;
  }, cipherBase = _e, cipherBase;
}
var browser$a, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9) return browser$a;
  hasRequiredBrowser$9 = 1;
  var I = inherits_browserExports, A = requireMd5_js(), G = requireRipemd160(), J = sha_jsExports, _e = requireCipherBase();
  function H(De) {
    _e.call(this, "digest"), this._hash = De;
  }
  return I(H, _e), H.prototype._update = function(De) {
    this._hash.update(De);
  }, H.prototype._final = function() {
    return this._hash.digest();
  }, browser$a = function(Ie) {
    return Ie = Ie.toLowerCase(), Ie === "md5" ? new A() : Ie === "rmd160" || Ie === "ripemd160" ? new G() : new H(J(Ie));
  }, browser$a;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy) return legacy;
  hasRequiredLegacy = 1;
  var I = inherits_browserExports, A = safeBufferExports.Buffer, G = requireCipherBase(), J = A.alloc(128), _e = 64;
  function H(De, Ie) {
    G.call(this, "digest"), typeof Ie == "string" && (Ie = A.from(Ie)), this._alg = De, this._key = Ie, Ie.length > _e ? Ie = De(Ie) : Ie.length < _e && (Ie = A.concat([Ie, J], _e));
    for (var qe = this._ipad = A.allocUnsafe(_e), Te = this._opad = A.allocUnsafe(_e), Ee = 0; Ee < _e; Ee++)
      qe[Ee] = Ie[Ee] ^ 54, Te[Ee] = Ie[Ee] ^ 92;
    this._hash = [qe];
  }
  return I(H, G), H.prototype._update = function(De) {
    this._hash.push(De);
  }, H.prototype._final = function() {
    var De = this._alg(A.concat(this._hash));
    return this._alg(A.concat([this._opad, De]));
  }, legacy = H, legacy;
}
var md5, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5) return md5;
  hasRequiredMd5 = 1;
  var I = requireMd5_js();
  return md5 = function(A) {
    return new I().update(A).digest();
  }, md5;
}
var browser$9, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8) return browser$9;
  hasRequiredBrowser$8 = 1;
  var I = inherits_browserExports, A = requireLegacy(), G = requireCipherBase(), J = safeBufferExports.Buffer, _e = requireMd5(), H = requireRipemd160(), De = sha_jsExports, Ie = J.alloc(128);
  function qe(Te, Ee) {
    G.call(this, "digest"), typeof Ee == "string" && (Ee = J.from(Ee));
    var Oe = Te === "sha512" || Te === "sha384" ? 128 : 64;
    if (this._alg = Te, this._key = Ee, Ee.length > Oe) {
      var Le = Te === "rmd160" ? new H() : De(Te);
      Ee = Le.update(Ee).digest();
    } else Ee.length < Oe && (Ee = J.concat([Ee, Ie], Oe));
    for (var ke = this._ipad = J.allocUnsafe(Oe), Fe = this._opad = J.allocUnsafe(Oe), Ge = 0; Ge < Oe; Ge++)
      ke[Ge] = Ee[Ge] ^ 54, Fe[Ge] = Ee[Ge] ^ 92;
    this._hash = Te === "rmd160" ? new H() : De(Te), this._hash.update(ke);
  }
  return I(qe, G), qe.prototype._update = function(Te) {
    this._hash.update(Te);
  }, qe.prototype._final = function() {
    var Te = this._hash.digest(), Ee = this._alg === "rmd160" ? new H() : De(this._alg);
    return Ee.update(this._opad).update(Te).digest();
  }, browser$9 = function(Ee, Oe) {
    return Ee = Ee.toLowerCase(), Ee === "rmd160" || Ee === "ripemd160" ? new qe("rmd160", Oe) : Ee === "md5" ? new A(_e, Oe) : new qe(Ee, Oe);
  }, browser$9;
}
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256$1 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512$1 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: sha256$1,
  sha224,
  sha384,
  sha512: sha512$1,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6), algos;
}
var browser$8 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition) return precondition;
  hasRequiredPrecondition = 1;
  var I = Math.pow(2, 30) - 1;
  return precondition = function(A, G) {
    if (typeof A != "number")
      throw new TypeError("Iterations not a number");
    if (A < 0)
      throw new TypeError("Bad iterations");
    if (typeof G != "number")
      throw new TypeError("Key length not a number");
    if (G < 0 || G > I || G !== G)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding) return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var I;
  if (commonjsGlobal.process && commonjsGlobal.process.browser)
    I = "utf-8";
  else if (commonjsGlobal.process && commonjsGlobal.process.version) {
    var A = parseInt(process$1.version.split(".")[0].slice(1), 10);
    I = A >= 6 ? "utf-8" : "binary";
  } else
    I = "utf-8";
  return defaultEncoding_1 = I, defaultEncoding_1;
}
var toBuffer, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer) return toBuffer;
  hasRequiredToBuffer = 1;
  var I = safeBufferExports.Buffer;
  return toBuffer = function(A, G, J) {
    if (I.isBuffer(A))
      return A;
    if (typeof A == "string")
      return I.from(A, G);
    if (ArrayBuffer.isView(A))
      return I.from(A.buffer);
    throw new TypeError(J + " must be a string, a Buffer, a typed array or a DataView");
  }, toBuffer;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser) return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var I = requireMd5(), A = requireRipemd160(), G = sha_jsExports, J = safeBufferExports.Buffer, _e = requirePrecondition(), H = requireDefaultEncoding(), De = requireToBuffer(), Ie = J.alloc(128), qe = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function Te(Le, ke, Fe) {
    var Ge = Ee(Le), et = Le === "sha512" || Le === "sha384" ? 128 : 64;
    ke.length > et ? ke = Ge(ke) : ke.length < et && (ke = J.concat([ke, Ie], et));
    for (var Ve = J.allocUnsafe(et + qe[Le]), Je = J.allocUnsafe(et + qe[Le]), ut = 0; ut < et; ut++)
      Ve[ut] = ke[ut] ^ 54, Je[ut] = ke[ut] ^ 92;
    var rt = J.allocUnsafe(et + Fe + 4);
    Ve.copy(rt, 0, 0, et), this.ipad1 = rt, this.ipad2 = Ve, this.opad = Je, this.alg = Le, this.blocksize = et, this.hash = Ge, this.size = qe[Le];
  }
  Te.prototype.run = function(Le, ke) {
    Le.copy(ke, this.blocksize);
    var Fe = this.hash(ke);
    return Fe.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function Ee(Le) {
    function ke(Ge) {
      return G(Le).update(Ge).digest();
    }
    function Fe(Ge) {
      return new A().update(Ge).digest();
    }
    return Le === "rmd160" || Le === "ripemd160" ? Fe : Le === "md5" ? I : ke;
  }
  function Oe(Le, ke, Fe, Ge, et) {
    _e(Fe, Ge), Le = De(Le, H, "Password"), ke = De(ke, H, "Salt"), et = et || "sha1";
    var Ve = new Te(et, Le, ke.length), Je = J.allocUnsafe(Ge), ut = J.allocUnsafe(ke.length + 4);
    ke.copy(ut, 0, 0, ke.length);
    for (var rt = 0, lt = qe[et], vt = Math.ceil(Ge / lt), Ye = 1; Ye <= vt; Ye++) {
      ut.writeUInt32BE(Ye, ke.length);
      for (var pt = Ve.run(ut, Ve.ipad1), bt = pt, Yt = 1; Yt < Fe; Yt++) {
        bt = Ve.run(bt, Ve.ipad2);
        for (var Se = 0; Se < lt; Se++) pt[Se] ^= bt[Se];
      }
      pt.copy(Je, rt), rt += lt;
    }
    return Je;
  }
  return syncBrowser = Oe, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync) return async;
  hasRequiredAsync = 1;
  var I = safeBufferExports.Buffer, A = requirePrecondition(), G = requireDefaultEncoding(), J = requireSyncBrowser(), _e = requireToBuffer(), H, De = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, Ie = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, qe = [];
  function Te(Fe) {
    if (commonjsGlobal.process && !commonjsGlobal.process.browser || !De || !De.importKey || !De.deriveBits)
      return Promise.resolve(!1);
    if (qe[Fe] !== void 0)
      return qe[Fe];
    H = H || I.alloc(8);
    var Ge = Le(H, H, 10, 128, Fe).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return qe[Fe] = Ge, Ge;
  }
  var Ee;
  function Oe() {
    return Ee || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? Ee = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? Ee = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? Ee = commonjsGlobal.setImmediate : Ee = commonjsGlobal.setTimeout, Ee);
  }
  function Le(Fe, Ge, et, Ve, Je) {
    return De.importKey(
      "raw",
      Fe,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(ut) {
      return De.deriveBits({
        name: "PBKDF2",
        salt: Ge,
        iterations: et,
        hash: {
          name: Je
        }
      }, ut, Ve << 3);
    }).then(function(ut) {
      return I.from(ut);
    });
  }
  function ke(Fe, Ge) {
    Fe.then(function(et) {
      Oe()(function() {
        Ge(null, et);
      });
    }, function(et) {
      Oe()(function() {
        Ge(et);
      });
    });
  }
  return async = function(Fe, Ge, et, Ve, Je, ut) {
    typeof Je == "function" && (ut = Je, Je = void 0), Je = Je || "sha1";
    var rt = Ie[Je.toLowerCase()];
    if (!rt || typeof commonjsGlobal.Promise != "function") {
      Oe()(function() {
        var lt;
        try {
          lt = J(Fe, Ge, et, Ve, Je);
        } catch (vt) {
          return ut(vt);
        }
        ut(null, lt);
      });
      return;
    }
    if (A(et, Ve), Fe = _e(Fe, G, "Password"), Ge = _e(Ge, G, "Salt"), typeof ut != "function") throw new Error("No callback provided to pbkdf2");
    ke(Te(rt).then(function(lt) {
      return lt ? Le(Fe, Ge, et, Ve, rt) : J(Fe, Ge, et, Ve, Je);
    }), ut);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$8.pbkdf2 = requireAsync(), browser$8.pbkdf2Sync = requireSyncBrowser()), browser$8;
}
var browser$7 = {}, des$1 = {}, utils$o = {}, hasRequiredUtils$1;
function requireUtils$1() {
  if (hasRequiredUtils$1) return utils$o;
  hasRequiredUtils$1 = 1, utils$o.readUInt32BE = function(_e, H) {
    var De = _e[0 + H] << 24 | _e[1 + H] << 16 | _e[2 + H] << 8 | _e[3 + H];
    return De >>> 0;
  }, utils$o.writeUInt32BE = function(_e, H, De) {
    _e[0 + De] = H >>> 24, _e[1 + De] = H >>> 16 & 255, _e[2 + De] = H >>> 8 & 255, _e[3 + De] = H & 255;
  }, utils$o.ip = function(_e, H, De, Ie) {
    for (var qe = 0, Te = 0, Ee = 6; Ee >= 0; Ee -= 2) {
      for (var Oe = 0; Oe <= 24; Oe += 8)
        qe <<= 1, qe |= H >>> Oe + Ee & 1;
      for (var Oe = 0; Oe <= 24; Oe += 8)
        qe <<= 1, qe |= _e >>> Oe + Ee & 1;
    }
    for (var Ee = 6; Ee >= 0; Ee -= 2) {
      for (var Oe = 1; Oe <= 25; Oe += 8)
        Te <<= 1, Te |= H >>> Oe + Ee & 1;
      for (var Oe = 1; Oe <= 25; Oe += 8)
        Te <<= 1, Te |= _e >>> Oe + Ee & 1;
    }
    De[Ie + 0] = qe >>> 0, De[Ie + 1] = Te >>> 0;
  }, utils$o.rip = function(_e, H, De, Ie) {
    for (var qe = 0, Te = 0, Ee = 0; Ee < 4; Ee++)
      for (var Oe = 24; Oe >= 0; Oe -= 8)
        qe <<= 1, qe |= H >>> Oe + Ee & 1, qe <<= 1, qe |= _e >>> Oe + Ee & 1;
    for (var Ee = 4; Ee < 8; Ee++)
      for (var Oe = 24; Oe >= 0; Oe -= 8)
        Te <<= 1, Te |= H >>> Oe + Ee & 1, Te <<= 1, Te |= _e >>> Oe + Ee & 1;
    De[Ie + 0] = qe >>> 0, De[Ie + 1] = Te >>> 0;
  }, utils$o.pc1 = function(_e, H, De, Ie) {
    for (var qe = 0, Te = 0, Ee = 7; Ee >= 5; Ee--) {
      for (var Oe = 0; Oe <= 24; Oe += 8)
        qe <<= 1, qe |= H >> Oe + Ee & 1;
      for (var Oe = 0; Oe <= 24; Oe += 8)
        qe <<= 1, qe |= _e >> Oe + Ee & 1;
    }
    for (var Oe = 0; Oe <= 24; Oe += 8)
      qe <<= 1, qe |= H >> Oe + Ee & 1;
    for (var Ee = 1; Ee <= 3; Ee++) {
      for (var Oe = 0; Oe <= 24; Oe += 8)
        Te <<= 1, Te |= H >> Oe + Ee & 1;
      for (var Oe = 0; Oe <= 24; Oe += 8)
        Te <<= 1, Te |= _e >> Oe + Ee & 1;
    }
    for (var Oe = 0; Oe <= 24; Oe += 8)
      Te <<= 1, Te |= _e >> Oe + Ee & 1;
    De[Ie + 0] = qe >>> 0, De[Ie + 1] = Te >>> 0;
  }, utils$o.r28shl = function(_e, H) {
    return _e << H & 268435455 | _e >>> 28 - H;
  };
  var I = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$o.pc2 = function(_e, H, De, Ie) {
    for (var qe = 0, Te = 0, Ee = I.length >>> 1, Oe = 0; Oe < Ee; Oe++)
      qe <<= 1, qe |= _e >>> I[Oe] & 1;
    for (var Oe = Ee; Oe < I.length; Oe++)
      Te <<= 1, Te |= H >>> I[Oe] & 1;
    De[Ie + 0] = qe >>> 0, De[Ie + 1] = Te >>> 0;
  }, utils$o.expand = function(_e, H, De) {
    var Ie = 0, qe = 0;
    Ie = (_e & 1) << 5 | _e >>> 27;
    for (var Te = 23; Te >= 15; Te -= 4)
      Ie <<= 6, Ie |= _e >>> Te & 63;
    for (var Te = 11; Te >= 3; Te -= 4)
      qe |= _e >>> Te & 63, qe <<= 6;
    qe |= (_e & 31) << 1 | _e >>> 31, H[De + 0] = Ie >>> 0, H[De + 1] = qe >>> 0;
  };
  var A = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$o.substitute = function(_e, H) {
    for (var De = 0, Ie = 0; Ie < 4; Ie++) {
      var qe = _e >>> 18 - Ie * 6 & 63, Te = A[Ie * 64 + qe];
      De <<= 4, De |= Te;
    }
    for (var Ie = 0; Ie < 4; Ie++) {
      var qe = H >>> 18 - Ie * 6 & 63, Te = A[4 * 64 + Ie * 64 + qe];
      De <<= 4, De |= Te;
    }
    return De >>> 0;
  };
  var G = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$o.permute = function(_e) {
    for (var H = 0, De = 0; De < G.length; De++)
      H <<= 1, H |= _e >>> G[De] & 1;
    return H >>> 0;
  }, utils$o.padSplit = function(_e, H, De) {
    for (var Ie = _e.toString(2); Ie.length < H; )
      Ie = "0" + Ie;
    for (var qe = [], Te = 0; Te < H; Te += De)
      qe.push(Ie.slice(Te, Te + De));
    return qe.join(" ");
  }, utils$o;
}
var minimalisticAssert = assert$f;
function assert$f(I, A) {
  if (!I)
    throw new Error(A || "Assertion failed");
}
assert$f.equal = function(A, G, J) {
  if (A != G)
    throw new Error(J || "Assertion failed: " + A + " != " + G);
};
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher) return cipher;
  hasRequiredCipher = 1;
  var I = minimalisticAssert;
  function A(G) {
    this.options = G, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = G.padding !== !1;
  }
  return cipher = A, A.prototype._init = function() {
  }, A.prototype.update = function(J) {
    return J.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(J) : this._updateEncrypt(J);
  }, A.prototype._buffer = function(J, _e) {
    for (var H = Math.min(this.buffer.length - this.bufferOff, J.length - _e), De = 0; De < H; De++)
      this.buffer[this.bufferOff + De] = J[_e + De];
    return this.bufferOff += H, H;
  }, A.prototype._flushBuffer = function(J, _e) {
    return this._update(this.buffer, 0, J, _e), this.bufferOff = 0, this.blockSize;
  }, A.prototype._updateEncrypt = function(J) {
    var _e = 0, H = 0, De = (this.bufferOff + J.length) / this.blockSize | 0, Ie = new Array(De * this.blockSize);
    this.bufferOff !== 0 && (_e += this._buffer(J, _e), this.bufferOff === this.buffer.length && (H += this._flushBuffer(Ie, H)));
    for (var qe = J.length - (J.length - _e) % this.blockSize; _e < qe; _e += this.blockSize)
      this._update(J, _e, Ie, H), H += this.blockSize;
    for (; _e < J.length; _e++, this.bufferOff++)
      this.buffer[this.bufferOff] = J[_e];
    return Ie;
  }, A.prototype._updateDecrypt = function(J) {
    for (var _e = 0, H = 0, De = Math.ceil((this.bufferOff + J.length) / this.blockSize) - 1, Ie = new Array(De * this.blockSize); De > 0; De--)
      _e += this._buffer(J, _e), H += this._flushBuffer(Ie, H);
    return _e += this._buffer(J, _e), Ie;
  }, A.prototype.final = function(J) {
    var _e;
    J && (_e = this.update(J));
    var H;
    return this.type === "encrypt" ? H = this._finalEncrypt() : H = this._finalDecrypt(), _e ? _e.concat(H) : H;
  }, A.prototype._pad = function(J, _e) {
    if (_e === 0)
      return !1;
    for (; _e < J.length; )
      J[_e++] = 0;
    return !0;
  }, A.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var J = new Array(this.blockSize);
    return this._update(this.buffer, 0, J, 0), J;
  }, A.prototype._unpad = function(J) {
    return J;
  }, A.prototype._finalDecrypt = function() {
    I.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var J = new Array(this.blockSize);
    return this._flushBuffer(J, 0), this._unpad(J);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1) return des;
  hasRequiredDes$1 = 1;
  var I = minimalisticAssert, A = inherits_browserExports, G = requireUtils$1(), J = requireCipher();
  function _e() {
    this.tmp = new Array(2), this.keys = null;
  }
  function H(Ie) {
    J.call(this, Ie);
    var qe = new _e();
    this._desState = qe, this.deriveKeys(qe, Ie.key);
  }
  A(H, J), des = H, H.create = function(qe) {
    return new H(qe);
  };
  var De = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return H.prototype.deriveKeys = function(qe, Te) {
    qe.keys = new Array(16 * 2), I.equal(Te.length, this.blockSize, "Invalid key length");
    var Ee = G.readUInt32BE(Te, 0), Oe = G.readUInt32BE(Te, 4);
    G.pc1(Ee, Oe, qe.tmp, 0), Ee = qe.tmp[0], Oe = qe.tmp[1];
    for (var Le = 0; Le < qe.keys.length; Le += 2) {
      var ke = De[Le >>> 1];
      Ee = G.r28shl(Ee, ke), Oe = G.r28shl(Oe, ke), G.pc2(Ee, Oe, qe.keys, Le);
    }
  }, H.prototype._update = function(qe, Te, Ee, Oe) {
    var Le = this._desState, ke = G.readUInt32BE(qe, Te), Fe = G.readUInt32BE(qe, Te + 4);
    G.ip(ke, Fe, Le.tmp, 0), ke = Le.tmp[0], Fe = Le.tmp[1], this.type === "encrypt" ? this._encrypt(Le, ke, Fe, Le.tmp, 0) : this._decrypt(Le, ke, Fe, Le.tmp, 0), ke = Le.tmp[0], Fe = Le.tmp[1], G.writeUInt32BE(Ee, ke, Oe), G.writeUInt32BE(Ee, Fe, Oe + 4);
  }, H.prototype._pad = function(qe, Te) {
    if (this.padding === !1)
      return !1;
    for (var Ee = qe.length - Te, Oe = Te; Oe < qe.length; Oe++)
      qe[Oe] = Ee;
    return !0;
  }, H.prototype._unpad = function(qe) {
    if (this.padding === !1)
      return qe;
    for (var Te = qe[qe.length - 1], Ee = qe.length - Te; Ee < qe.length; Ee++)
      I.equal(qe[Ee], Te);
    return qe.slice(0, qe.length - Te);
  }, H.prototype._encrypt = function(qe, Te, Ee, Oe, Le) {
    for (var ke = Te, Fe = Ee, Ge = 0; Ge < qe.keys.length; Ge += 2) {
      var et = qe.keys[Ge], Ve = qe.keys[Ge + 1];
      G.expand(Fe, qe.tmp, 0), et ^= qe.tmp[0], Ve ^= qe.tmp[1];
      var Je = G.substitute(et, Ve), ut = G.permute(Je), rt = Fe;
      Fe = (ke ^ ut) >>> 0, ke = rt;
    }
    G.rip(Fe, ke, Oe, Le);
  }, H.prototype._decrypt = function(qe, Te, Ee, Oe, Le) {
    for (var ke = Ee, Fe = Te, Ge = qe.keys.length - 2; Ge >= 0; Ge -= 2) {
      var et = qe.keys[Ge], Ve = qe.keys[Ge + 1];
      G.expand(ke, qe.tmp, 0), et ^= qe.tmp[0], Ve ^= qe.tmp[1];
      var Je = G.substitute(et, Ve), ut = G.permute(Je), rt = ke;
      ke = (Fe ^ ut) >>> 0, Fe = rt;
    }
    G.rip(ke, Fe, Oe, Le);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1) return cbc$1;
  hasRequiredCbc$1 = 1;
  var I = minimalisticAssert, A = inherits_browserExports, G = {};
  function J(H) {
    I.equal(H.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var De = 0; De < this.iv.length; De++)
      this.iv[De] = H[De];
  }
  function _e(H) {
    function De(Ee) {
      H.call(this, Ee), this._cbcInit();
    }
    A(De, H);
    for (var Ie = Object.keys(G), qe = 0; qe < Ie.length; qe++) {
      var Te = Ie[qe];
      De.prototype[Te] = G[Te];
    }
    return De.create = function(Oe) {
      return new De(Oe);
    }, De;
  }
  return cbc$1.instantiate = _e, G._cbcInit = function() {
    var De = new J(this.options.iv);
    this._cbcState = De;
  }, G._update = function(De, Ie, qe, Te) {
    var Ee = this._cbcState, Oe = this.constructor.super_.prototype, Le = Ee.iv;
    if (this.type === "encrypt") {
      for (var ke = 0; ke < this.blockSize; ke++)
        Le[ke] ^= De[Ie + ke];
      Oe._update.call(this, Le, 0, qe, Te);
      for (var ke = 0; ke < this.blockSize; ke++)
        Le[ke] = qe[Te + ke];
    } else {
      Oe._update.call(this, De, Ie, qe, Te);
      for (var ke = 0; ke < this.blockSize; ke++)
        qe[Te + ke] ^= Le[ke];
      for (var ke = 0; ke < this.blockSize; ke++)
        Le[ke] = De[Ie + ke];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde) return ede;
  hasRequiredEde = 1;
  var I = minimalisticAssert, A = inherits_browserExports, G = requireCipher(), J = requireDes$1();
  function _e(De, Ie) {
    I.equal(Ie.length, 24, "Invalid key length");
    var qe = Ie.slice(0, 8), Te = Ie.slice(8, 16), Ee = Ie.slice(16, 24);
    De === "encrypt" ? this.ciphers = [
      J.create({ type: "encrypt", key: qe }),
      J.create({ type: "decrypt", key: Te }),
      J.create({ type: "encrypt", key: Ee })
    ] : this.ciphers = [
      J.create({ type: "decrypt", key: Ee }),
      J.create({ type: "encrypt", key: Te }),
      J.create({ type: "decrypt", key: qe })
    ];
  }
  function H(De) {
    G.call(this, De);
    var Ie = new _e(this.type, this.options.key);
    this._edeState = Ie;
  }
  return A(H, G), ede = H, H.create = function(Ie) {
    return new H(Ie);
  }, H.prototype._update = function(Ie, qe, Te, Ee) {
    var Oe = this._edeState;
    Oe.ciphers[0]._update(Ie, qe, Te, Ee), Oe.ciphers[1]._update(Te, Ee, Te, Ee), Oe.ciphers[2]._update(Te, Ee, Te, Ee);
  }, H.prototype._pad = J.prototype._pad, H.prototype._unpad = J.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils$1(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes) return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var I = requireCipherBase(), A = requireDes(), G = inherits_browserExports, J = safeBufferExports.Buffer, _e = {
    "des-ede3-cbc": A.CBC.instantiate(A.EDE),
    "des-ede3": A.EDE,
    "des-ede-cbc": A.CBC.instantiate(A.EDE),
    "des-ede": A.EDE,
    "des-cbc": A.CBC.instantiate(A.DES),
    "des-ecb": A.DES
  };
  _e.des = _e["des-cbc"], _e.des3 = _e["des-ede3-cbc"], browserifyDes = H, G(H, I);
  function H(De) {
    I.call(this);
    var Ie = De.mode.toLowerCase(), qe = _e[Ie], Te;
    De.decrypt ? Te = "decrypt" : Te = "encrypt";
    var Ee = De.key;
    J.isBuffer(Ee) || (Ee = J.from(Ee)), (Ie === "des-ede" || Ie === "des-ede-cbc") && (Ee = J.concat([Ee, Ee.slice(0, 8)]));
    var Oe = De.iv;
    J.isBuffer(Oe) || (Oe = J.from(Oe)), this._des = qe.create({
      key: Ee,
      iv: Oe,
      type: Te
    });
  }
  return H.prototype._update = function(De) {
    return J.from(this._des.update(De));
  }, H.prototype._final = function() {
    return J.from(this._des.final());
  }, browserifyDes;
}
var browser$6 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(I, A) {
    return I._cipher.encryptBlock(A);
  }, ecb.decrypt = function(I, A) {
    return I._cipher.decryptBlock(A);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(A, G) {
    for (var J = Math.min(A.length, G.length), _e = new Buffer$7(J), H = 0; H < J; ++H)
      _e[H] = A[H] ^ G[H];
    return _e;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc) return cbc;
  hasRequiredCbc = 1;
  var I = requireBufferXor();
  return cbc.encrypt = function(A, G) {
    var J = I(G, A._prev);
    return A._prev = A._cipher.encryptBlock(J), A._prev;
  }, cbc.decrypt = function(A, G) {
    var J = A._prev;
    A._prev = G;
    var _e = A._cipher.decryptBlock(G);
    return I(_e, J);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb) return cfb;
  hasRequiredCfb = 1;
  var I = safeBufferExports.Buffer, A = requireBufferXor();
  function G(J, _e, H) {
    var De = _e.length, Ie = A(_e, J._cache);
    return J._cache = J._cache.slice(De), J._prev = I.concat([J._prev, H ? _e : Ie]), Ie;
  }
  return cfb.encrypt = function(J, _e, H) {
    for (var De = I.allocUnsafe(0), Ie; _e.length; )
      if (J._cache.length === 0 && (J._cache = J._cipher.encryptBlock(J._prev), J._prev = I.allocUnsafe(0)), J._cache.length <= _e.length)
        Ie = J._cache.length, De = I.concat([De, G(J, _e.slice(0, Ie), H)]), _e = _e.slice(Ie);
      else {
        De = I.concat([De, G(J, _e, H)]);
        break;
      }
    return De;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8) return cfb8;
  hasRequiredCfb8 = 1;
  var I = safeBufferExports.Buffer;
  function A(G, J, _e) {
    var H = G._cipher.encryptBlock(G._prev), De = H[0] ^ J;
    return G._prev = I.concat([
      G._prev.slice(1),
      I.from([_e ? J : De])
    ]), De;
  }
  return cfb8.encrypt = function(G, J, _e) {
    for (var H = J.length, De = I.allocUnsafe(H), Ie = -1; ++Ie < H; )
      De[Ie] = A(G, J[Ie], _e);
    return De;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1) return cfb1;
  hasRequiredCfb1 = 1;
  var I = safeBufferExports.Buffer;
  function A(J, _e, H) {
    for (var De, Ie = -1, qe = 8, Te = 0, Ee, Oe; ++Ie < qe; )
      De = J._cipher.encryptBlock(J._prev), Ee = _e & 1 << 7 - Ie ? 128 : 0, Oe = De[0] ^ Ee, Te += (Oe & 128) >> Ie % 8, J._prev = G(J._prev, H ? Ee : Oe);
    return Te;
  }
  function G(J, _e) {
    var H = J.length, De = -1, Ie = I.allocUnsafe(J.length);
    for (J = I.concat([J, I.from([_e])]); ++De < H; )
      Ie[De] = J[De] << 1 | J[De + 1] >> 7;
    return Ie;
  }
  return cfb1.encrypt = function(J, _e, H) {
    for (var De = _e.length, Ie = I.allocUnsafe(De), qe = -1; ++qe < De; )
      Ie[qe] = A(J, _e[qe], H);
    return Ie;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb) return ofb;
  hasRequiredOfb = 1;
  var I = requireBufferXor();
  function A(G) {
    return G._prev = G._cipher.encryptBlock(G._prev), G._prev;
  }
  return ofb.encrypt = function(G, J) {
    for (; G._cache.length < J.length; )
      G._cache = Buffer$7.concat([G._cache, A(G)]);
    var _e = G._cache.slice(0, J.length);
    return G._cache = G._cache.slice(J.length), I(J, _e);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32) return incr32_1;
  hasRequiredIncr32 = 1;
  function I(A) {
    for (var G = A.length, J; G--; )
      if (J = A.readUInt8(G), J === 255)
        A.writeUInt8(0, G);
      else {
        J++, A.writeUInt8(J, G);
        break;
      }
  }
  return incr32_1 = I, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr) return ctr;
  hasRequiredCtr = 1;
  var I = requireBufferXor(), A = safeBufferExports.Buffer, G = requireIncr32();
  function J(H) {
    var De = H._cipher.encryptBlockRaw(H._prev);
    return G(H._prev), De;
  }
  var _e = 16;
  return ctr.encrypt = function(H, De) {
    var Ie = Math.ceil(De.length / _e), qe = H._cache.length;
    H._cache = A.concat([
      H._cache,
      A.allocUnsafe(Ie * _e)
    ]);
    for (var Te = 0; Te < Ie; Te++) {
      var Ee = J(H), Oe = qe + Te * _e;
      H._cache.writeUInt32BE(Ee[0], Oe + 0), H._cache.writeUInt32BE(Ee[1], Oe + 4), H._cache.writeUInt32BE(Ee[2], Oe + 8), H._cache.writeUInt32BE(Ee[3], Oe + 12);
    }
    var Le = H._cache.slice(0, De.length);
    return H._cache = H._cache.slice(De.length), I(De, Le);
  }, ctr;
}
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1) return modes_1;
  hasRequiredModes$1 = 1;
  var I = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, A = require$$2;
  for (var G in A)
    A[G].module = I[A[G].mode];
  return modes_1 = A, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes) return aes;
  hasRequiredAes = 1;
  var I = safeBufferExports.Buffer;
  function A(Ie) {
    I.isBuffer(Ie) || (Ie = I.from(Ie));
    for (var qe = Ie.length / 4 | 0, Te = new Array(qe), Ee = 0; Ee < qe; Ee++)
      Te[Ee] = Ie.readUInt32BE(Ee * 4);
    return Te;
  }
  function G(Ie) {
    for (var qe = 0; qe < Ie.length; Ie++)
      Ie[qe] = 0;
  }
  function J(Ie, qe, Te, Ee, Oe) {
    for (var Le = Te[0], ke = Te[1], Fe = Te[2], Ge = Te[3], et = Ie[0] ^ qe[0], Ve = Ie[1] ^ qe[1], Je = Ie[2] ^ qe[2], ut = Ie[3] ^ qe[3], rt, lt, vt, Ye, pt = 4, bt = 1; bt < Oe; bt++)
      rt = Le[et >>> 24] ^ ke[Ve >>> 16 & 255] ^ Fe[Je >>> 8 & 255] ^ Ge[ut & 255] ^ qe[pt++], lt = Le[Ve >>> 24] ^ ke[Je >>> 16 & 255] ^ Fe[ut >>> 8 & 255] ^ Ge[et & 255] ^ qe[pt++], vt = Le[Je >>> 24] ^ ke[ut >>> 16 & 255] ^ Fe[et >>> 8 & 255] ^ Ge[Ve & 255] ^ qe[pt++], Ye = Le[ut >>> 24] ^ ke[et >>> 16 & 255] ^ Fe[Ve >>> 8 & 255] ^ Ge[Je & 255] ^ qe[pt++], et = rt, Ve = lt, Je = vt, ut = Ye;
    return rt = (Ee[et >>> 24] << 24 | Ee[Ve >>> 16 & 255] << 16 | Ee[Je >>> 8 & 255] << 8 | Ee[ut & 255]) ^ qe[pt++], lt = (Ee[Ve >>> 24] << 24 | Ee[Je >>> 16 & 255] << 16 | Ee[ut >>> 8 & 255] << 8 | Ee[et & 255]) ^ qe[pt++], vt = (Ee[Je >>> 24] << 24 | Ee[ut >>> 16 & 255] << 16 | Ee[et >>> 8 & 255] << 8 | Ee[Ve & 255]) ^ qe[pt++], Ye = (Ee[ut >>> 24] << 24 | Ee[et >>> 16 & 255] << 16 | Ee[Ve >>> 8 & 255] << 8 | Ee[Je & 255]) ^ qe[pt++], rt = rt >>> 0, lt = lt >>> 0, vt = vt >>> 0, Ye = Ye >>> 0, [rt, lt, vt, Ye];
  }
  var _e = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], H = function() {
    for (var Ie = new Array(256), qe = 0; qe < 256; qe++)
      qe < 128 ? Ie[qe] = qe << 1 : Ie[qe] = qe << 1 ^ 283;
    for (var Te = [], Ee = [], Oe = [[], [], [], []], Le = [[], [], [], []], ke = 0, Fe = 0, Ge = 0; Ge < 256; ++Ge) {
      var et = Fe ^ Fe << 1 ^ Fe << 2 ^ Fe << 3 ^ Fe << 4;
      et = et >>> 8 ^ et & 255 ^ 99, Te[ke] = et, Ee[et] = ke;
      var Ve = Ie[ke], Je = Ie[Ve], ut = Ie[Je], rt = Ie[et] * 257 ^ et * 16843008;
      Oe[0][ke] = rt << 24 | rt >>> 8, Oe[1][ke] = rt << 16 | rt >>> 16, Oe[2][ke] = rt << 8 | rt >>> 24, Oe[3][ke] = rt, rt = ut * 16843009 ^ Je * 65537 ^ Ve * 257 ^ ke * 16843008, Le[0][et] = rt << 24 | rt >>> 8, Le[1][et] = rt << 16 | rt >>> 16, Le[2][et] = rt << 8 | rt >>> 24, Le[3][et] = rt, ke === 0 ? ke = Fe = 1 : (ke = Ve ^ Ie[Ie[Ie[ut ^ Ve]]], Fe ^= Ie[Ie[Fe]]);
    }
    return {
      SBOX: Te,
      INV_SBOX: Ee,
      SUB_MIX: Oe,
      INV_SUB_MIX: Le
    };
  }();
  function De(Ie) {
    this._key = A(Ie), this._reset();
  }
  return De.blockSize = 4 * 4, De.keySize = 256 / 8, De.prototype.blockSize = De.blockSize, De.prototype.keySize = De.keySize, De.prototype._reset = function() {
    for (var Ie = this._key, qe = Ie.length, Te = qe + 6, Ee = (Te + 1) * 4, Oe = [], Le = 0; Le < qe; Le++)
      Oe[Le] = Ie[Le];
    for (Le = qe; Le < Ee; Le++) {
      var ke = Oe[Le - 1];
      Le % qe === 0 ? (ke = ke << 8 | ke >>> 24, ke = H.SBOX[ke >>> 24] << 24 | H.SBOX[ke >>> 16 & 255] << 16 | H.SBOX[ke >>> 8 & 255] << 8 | H.SBOX[ke & 255], ke ^= _e[Le / qe | 0] << 24) : qe > 6 && Le % qe === 4 && (ke = H.SBOX[ke >>> 24] << 24 | H.SBOX[ke >>> 16 & 255] << 16 | H.SBOX[ke >>> 8 & 255] << 8 | H.SBOX[ke & 255]), Oe[Le] = Oe[Le - qe] ^ ke;
    }
    for (var Fe = [], Ge = 0; Ge < Ee; Ge++) {
      var et = Ee - Ge, Ve = Oe[et - (Ge % 4 ? 0 : 4)];
      Ge < 4 || et <= 4 ? Fe[Ge] = Ve : Fe[Ge] = H.INV_SUB_MIX[0][H.SBOX[Ve >>> 24]] ^ H.INV_SUB_MIX[1][H.SBOX[Ve >>> 16 & 255]] ^ H.INV_SUB_MIX[2][H.SBOX[Ve >>> 8 & 255]] ^ H.INV_SUB_MIX[3][H.SBOX[Ve & 255]];
    }
    this._nRounds = Te, this._keySchedule = Oe, this._invKeySchedule = Fe;
  }, De.prototype.encryptBlockRaw = function(Ie) {
    return Ie = A(Ie), J(Ie, this._keySchedule, H.SUB_MIX, H.SBOX, this._nRounds);
  }, De.prototype.encryptBlock = function(Ie) {
    var qe = this.encryptBlockRaw(Ie), Te = I.allocUnsafe(16);
    return Te.writeUInt32BE(qe[0], 0), Te.writeUInt32BE(qe[1], 4), Te.writeUInt32BE(qe[2], 8), Te.writeUInt32BE(qe[3], 12), Te;
  }, De.prototype.decryptBlock = function(Ie) {
    Ie = A(Ie);
    var qe = Ie[1];
    Ie[1] = Ie[3], Ie[3] = qe;
    var Te = J(Ie, this._invKeySchedule, H.INV_SUB_MIX, H.INV_SBOX, this._nRounds), Ee = I.allocUnsafe(16);
    return Ee.writeUInt32BE(Te[0], 0), Ee.writeUInt32BE(Te[3], 4), Ee.writeUInt32BE(Te[2], 8), Ee.writeUInt32BE(Te[1], 12), Ee;
  }, De.prototype.scrub = function() {
    G(this._keySchedule), G(this._invKeySchedule), G(this._key);
  }, aes.AES = De, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash) return ghash;
  hasRequiredGhash = 1;
  var I = safeBufferExports.Buffer, A = I.alloc(16, 0);
  function G(H) {
    return [
      H.readUInt32BE(0),
      H.readUInt32BE(4),
      H.readUInt32BE(8),
      H.readUInt32BE(12)
    ];
  }
  function J(H) {
    var De = I.allocUnsafe(16);
    return De.writeUInt32BE(H[0] >>> 0, 0), De.writeUInt32BE(H[1] >>> 0, 4), De.writeUInt32BE(H[2] >>> 0, 8), De.writeUInt32BE(H[3] >>> 0, 12), De;
  }
  function _e(H) {
    this.h = H, this.state = I.alloc(16, 0), this.cache = I.allocUnsafe(0);
  }
  return _e.prototype.ghash = function(H) {
    for (var De = -1; ++De < H.length; )
      this.state[De] ^= H[De];
    this._multiply();
  }, _e.prototype._multiply = function() {
    for (var H = G(this.h), De = [0, 0, 0, 0], Ie, qe, Te, Ee = -1; ++Ee < 128; ) {
      for (qe = (this.state[~~(Ee / 8)] & 1 << 7 - Ee % 8) !== 0, qe && (De[0] ^= H[0], De[1] ^= H[1], De[2] ^= H[2], De[3] ^= H[3]), Te = (H[3] & 1) !== 0, Ie = 3; Ie > 0; Ie--)
        H[Ie] = H[Ie] >>> 1 | (H[Ie - 1] & 1) << 31;
      H[0] = H[0] >>> 1, Te && (H[0] = H[0] ^ 225 << 24);
    }
    this.state = J(De);
  }, _e.prototype.update = function(H) {
    this.cache = I.concat([this.cache, H]);
    for (var De; this.cache.length >= 16; )
      De = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(De);
  }, _e.prototype.final = function(H, De) {
    return this.cache.length && this.ghash(I.concat([this.cache, A], 16)), this.ghash(J([0, H, 0, De])), this.state;
  }, ghash = _e, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher) return authCipher;
  hasRequiredAuthCipher = 1;
  var I = requireAes(), A = safeBufferExports.Buffer, G = requireCipherBase(), J = inherits_browserExports, _e = requireGhash(), H = requireBufferXor(), De = requireIncr32();
  function Ie(Ee, Oe) {
    var Le = 0;
    Ee.length !== Oe.length && Le++;
    for (var ke = Math.min(Ee.length, Oe.length), Fe = 0; Fe < ke; ++Fe)
      Le += Ee[Fe] ^ Oe[Fe];
    return Le;
  }
  function qe(Ee, Oe, Le) {
    if (Oe.length === 12)
      return Ee._finID = A.concat([Oe, A.from([0, 0, 0, 1])]), A.concat([Oe, A.from([0, 0, 0, 2])]);
    var ke = new _e(Le), Fe = Oe.length, Ge = Fe % 16;
    ke.update(Oe), Ge && (Ge = 16 - Ge, ke.update(A.alloc(Ge, 0))), ke.update(A.alloc(8, 0));
    var et = Fe * 8, Ve = A.alloc(8);
    Ve.writeUIntBE(et, 0, 8), ke.update(Ve), Ee._finID = ke.state;
    var Je = A.from(Ee._finID);
    return De(Je), Je;
  }
  function Te(Ee, Oe, Le, ke) {
    G.call(this);
    var Fe = A.alloc(4, 0);
    this._cipher = new I.AES(Oe);
    var Ge = this._cipher.encryptBlock(Fe);
    this._ghash = new _e(Ge), Le = qe(this, Le, Ge), this._prev = A.from(Le), this._cache = A.allocUnsafe(0), this._secCache = A.allocUnsafe(0), this._decrypt = ke, this._alen = 0, this._len = 0, this._mode = Ee, this._authTag = null, this._called = !1;
  }
  return J(Te, G), Te.prototype._update = function(Ee) {
    if (!this._called && this._alen) {
      var Oe = 16 - this._alen % 16;
      Oe < 16 && (Oe = A.alloc(Oe, 0), this._ghash.update(Oe));
    }
    this._called = !0;
    var Le = this._mode.encrypt(this, Ee);
    return this._decrypt ? this._ghash.update(Ee) : this._ghash.update(Le), this._len += Ee.length, Le;
  }, Te.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var Ee = H(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && Ie(Ee, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = Ee, this._cipher.scrub();
  }, Te.prototype.getAuthTag = function() {
    if (this._decrypt || !A.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, Te.prototype.setAuthTag = function(Oe) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = Oe;
  }, Te.prototype.setAAD = function(Oe) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(Oe), this._alen += Oe.length;
  }, authCipher = Te, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher) return streamCipher;
  hasRequiredStreamCipher = 1;
  var I = requireAes(), A = safeBufferExports.Buffer, G = requireCipherBase(), J = inherits_browserExports;
  function _e(H, De, Ie, qe) {
    G.call(this), this._cipher = new I.AES(De), this._prev = A.from(Ie), this._cache = A.allocUnsafe(0), this._secCache = A.allocUnsafe(0), this._decrypt = qe, this._mode = H;
  }
  return J(_e, G), _e.prototype._update = function(H) {
    return this._mode.encrypt(this, H, this._decrypt);
  }, _e.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = _e, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey) return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var I = safeBufferExports.Buffer, A = requireMd5_js();
  function G(J, _e, H, De) {
    if (I.isBuffer(J) || (J = I.from(J, "binary")), _e && (I.isBuffer(_e) || (_e = I.from(_e, "binary")), _e.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var Ie = H / 8, qe = I.alloc(Ie), Te = I.alloc(De || 0), Ee = I.alloc(0); Ie > 0 || De > 0; ) {
      var Oe = new A();
      Oe.update(Ee), Oe.update(J), _e && Oe.update(_e), Ee = Oe.digest();
      var Le = 0;
      if (Ie > 0) {
        var ke = qe.length - Ie;
        Le = Math.min(Ie, Ee.length), Ee.copy(qe, ke, 0, Le), Ie -= Le;
      }
      if (Le < Ee.length && De > 0) {
        var Fe = Te.length - De, Ge = Math.min(De, Ee.length - Le);
        Ee.copy(Te, Fe, Le, Le + Ge), De -= Ge;
      }
    }
    return Ee.fill(0), { key: qe, iv: Te };
  }
  return evp_bytestokey = G, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter) return encrypter;
  hasRequiredEncrypter = 1;
  var I = requireModes$1(), A = requireAuthCipher(), G = safeBufferExports.Buffer, J = requireStreamCipher(), _e = requireCipherBase(), H = requireAes(), De = requireEvp_bytestokey(), Ie = inherits_browserExports;
  function qe(ke, Fe, Ge) {
    _e.call(this), this._cache = new Ee(), this._cipher = new H.AES(Fe), this._prev = G.from(Ge), this._mode = ke, this._autopadding = !0;
  }
  Ie(qe, _e), qe.prototype._update = function(ke) {
    this._cache.add(ke);
    for (var Fe, Ge, et = []; Fe = this._cache.get(); )
      Ge = this._mode.encrypt(this, Fe), et.push(Ge);
    return G.concat(et);
  };
  var Te = G.alloc(16, 16);
  qe.prototype._final = function() {
    var ke = this._cache.flush();
    if (this._autopadding)
      return ke = this._mode.encrypt(this, ke), this._cipher.scrub(), ke;
    if (!ke.equals(Te))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, qe.prototype.setAutoPadding = function(ke) {
    return this._autopadding = !!ke, this;
  };
  function Ee() {
    this.cache = G.allocUnsafe(0);
  }
  Ee.prototype.add = function(ke) {
    this.cache = G.concat([this.cache, ke]);
  }, Ee.prototype.get = function() {
    if (this.cache.length > 15) {
      var ke = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), ke;
    }
    return null;
  }, Ee.prototype.flush = function() {
    for (var ke = 16 - this.cache.length, Fe = G.allocUnsafe(ke), Ge = -1; ++Ge < ke; )
      Fe.writeUInt8(ke, Ge);
    return G.concat([this.cache, Fe]);
  };
  function Oe(ke, Fe, Ge) {
    var et = I[ke.toLowerCase()];
    if (!et) throw new TypeError("invalid suite type");
    if (typeof Fe == "string" && (Fe = G.from(Fe)), Fe.length !== et.key / 8) throw new TypeError("invalid key length " + Fe.length);
    if (typeof Ge == "string" && (Ge = G.from(Ge)), et.mode !== "GCM" && Ge.length !== et.iv) throw new TypeError("invalid iv length " + Ge.length);
    return et.type === "stream" ? new J(et.module, Fe, Ge) : et.type === "auth" ? new A(et.module, Fe, Ge) : new qe(et.module, Fe, Ge);
  }
  function Le(ke, Fe) {
    var Ge = I[ke.toLowerCase()];
    if (!Ge) throw new TypeError("invalid suite type");
    var et = De(Fe, !1, Ge.key, Ge.iv);
    return Oe(ke, et.key, et.iv);
  }
  return encrypter.createCipheriv = Oe, encrypter.createCipher = Le, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter) return decrypter;
  hasRequiredDecrypter = 1;
  var I = requireAuthCipher(), A = safeBufferExports.Buffer, G = requireModes$1(), J = requireStreamCipher(), _e = requireCipherBase(), H = requireAes(), De = requireEvp_bytestokey(), Ie = inherits_browserExports;
  function qe(ke, Fe, Ge) {
    _e.call(this), this._cache = new Te(), this._last = void 0, this._cipher = new H.AES(Fe), this._prev = A.from(Ge), this._mode = ke, this._autopadding = !0;
  }
  Ie(qe, _e), qe.prototype._update = function(ke) {
    this._cache.add(ke);
    for (var Fe, Ge, et = []; Fe = this._cache.get(this._autopadding); )
      Ge = this._mode.decrypt(this, Fe), et.push(Ge);
    return A.concat(et);
  }, qe.prototype._final = function() {
    var ke = this._cache.flush();
    if (this._autopadding)
      return Ee(this._mode.decrypt(this, ke));
    if (ke)
      throw new Error("data not multiple of block length");
  }, qe.prototype.setAutoPadding = function(ke) {
    return this._autopadding = !!ke, this;
  };
  function Te() {
    this.cache = A.allocUnsafe(0);
  }
  Te.prototype.add = function(ke) {
    this.cache = A.concat([this.cache, ke]);
  }, Te.prototype.get = function(ke) {
    var Fe;
    if (ke) {
      if (this.cache.length > 16)
        return Fe = this.cache.slice(0, 16), this.cache = this.cache.slice(16), Fe;
    } else if (this.cache.length >= 16)
      return Fe = this.cache.slice(0, 16), this.cache = this.cache.slice(16), Fe;
    return null;
  }, Te.prototype.flush = function() {
    if (this.cache.length) return this.cache;
  };
  function Ee(ke) {
    var Fe = ke[15];
    if (Fe < 1 || Fe > 16)
      throw new Error("unable to decrypt data");
    for (var Ge = -1; ++Ge < Fe; )
      if (ke[Ge + (16 - Fe)] !== Fe)
        throw new Error("unable to decrypt data");
    if (Fe !== 16)
      return ke.slice(0, 16 - Fe);
  }
  function Oe(ke, Fe, Ge) {
    var et = G[ke.toLowerCase()];
    if (!et) throw new TypeError("invalid suite type");
    if (typeof Ge == "string" && (Ge = A.from(Ge)), et.mode !== "GCM" && Ge.length !== et.iv) throw new TypeError("invalid iv length " + Ge.length);
    if (typeof Fe == "string" && (Fe = A.from(Fe)), Fe.length !== et.key / 8) throw new TypeError("invalid key length " + Fe.length);
    return et.type === "stream" ? new J(et.module, Fe, Ge, !0) : et.type === "auth" ? new I(et.module, Fe, Ge, !0) : new qe(et.module, Fe, Ge);
  }
  function Le(ke, Fe) {
    var Ge = G[ke.toLowerCase()];
    if (!Ge) throw new TypeError("invalid suite type");
    var et = De(Fe, !1, Ge.key, Ge.iv);
    return Oe(ke, et.key, et.iv);
  }
  return decrypter.createDecipher = Le, decrypter.createDecipheriv = Oe, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6) return browser$6;
  hasRequiredBrowser$6 = 1;
  var I = requireEncrypter(), A = requireDecrypter(), G = require$$2;
  function J() {
    return Object.keys(G);
  }
  return browser$6.createCipher = browser$6.Cipher = I.createCipher, browser$6.createCipheriv = browser$6.Cipheriv = I.createCipheriv, browser$6.createDecipher = browser$6.Decipher = A.createDecipher, browser$6.createDecipheriv = browser$6.Decipheriv = A.createDecipheriv, browser$6.listCiphers = browser$6.getCiphers = J, browser$6;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(I) {
    I["des-ecb"] = {
      key: 8,
      iv: 0
    }, I["des-cbc"] = I.des = {
      key: 8,
      iv: 8
    }, I["des-ede3-cbc"] = I.des3 = {
      key: 24,
      iv: 8
    }, I["des-ede3"] = {
      key: 24,
      iv: 0
    }, I["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, I["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5) return browser$7;
  hasRequiredBrowser$5 = 1;
  var I = requireBrowserifyDes(), A = requireBrowser$6(), G = requireModes$1(), J = requireModes(), _e = requireEvp_bytestokey();
  function H(Ee, Oe) {
    Ee = Ee.toLowerCase();
    var Le, ke;
    if (G[Ee])
      Le = G[Ee].key, ke = G[Ee].iv;
    else if (J[Ee])
      Le = J[Ee].key * 8, ke = J[Ee].iv;
    else
      throw new TypeError("invalid suite type");
    var Fe = _e(Oe, !1, Le, ke);
    return Ie(Ee, Fe.key, Fe.iv);
  }
  function De(Ee, Oe) {
    Ee = Ee.toLowerCase();
    var Le, ke;
    if (G[Ee])
      Le = G[Ee].key, ke = G[Ee].iv;
    else if (J[Ee])
      Le = J[Ee].key * 8, ke = J[Ee].iv;
    else
      throw new TypeError("invalid suite type");
    var Fe = _e(Oe, !1, Le, ke);
    return qe(Ee, Fe.key, Fe.iv);
  }
  function Ie(Ee, Oe, Le) {
    if (Ee = Ee.toLowerCase(), G[Ee]) return A.createCipheriv(Ee, Oe, Le);
    if (J[Ee]) return new I({ key: Oe, iv: Le, mode: Ee });
    throw new TypeError("invalid suite type");
  }
  function qe(Ee, Oe, Le) {
    if (Ee = Ee.toLowerCase(), G[Ee]) return A.createDecipheriv(Ee, Oe, Le);
    if (J[Ee]) return new I({ key: Oe, iv: Le, mode: Ee, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function Te() {
    return Object.keys(J).concat(A.getCiphers());
  }
  return browser$7.createCipher = browser$7.Cipher = H, browser$7.createCipheriv = browser$7.Cipheriv = Ie, browser$7.createDecipher = browser$7.Decipher = De, browser$7.createDecipheriv = browser$7.Decipheriv = qe, browser$7.listCiphers = browser$7.getCiphers = Te, browser$7;
}
var browser$5 = {}, bn$6 = { exports: {} };
bn$6.exports;
var hasRequiredBn$5;
function requireBn$5() {
  return hasRequiredBn$5 || (hasRequiredBn$5 = 1, function(I) {
    (function(A, G) {
      function J(Se, t) {
        if (!Se) throw new Error(t || "Assertion failed");
      }
      function _e(Se, t) {
        Se.super_ = t;
        var h = function() {
        };
        h.prototype = t.prototype, Se.prototype = new h(), Se.prototype.constructor = Se;
      }
      function H(Se, t, h) {
        if (H.isBN(Se))
          return Se;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Se !== null && ((t === "le" || t === "be") && (h = t, t = 10), this._init(Se || 0, t || 10, h || "be"));
      }
      typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
      var De;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = require$$0$3.Buffer;
      } catch {
      }
      H.isBN = function(t) {
        return t instanceof H ? !0 : t !== null && typeof t == "object" && t.constructor.wordSize === H.wordSize && Array.isArray(t.words);
      }, H.max = function(t, h) {
        return t.cmp(h) > 0 ? t : h;
      }, H.min = function(t, h) {
        return t.cmp(h) < 0 ? t : h;
      }, H.prototype._init = function(t, h, B) {
        if (typeof t == "number")
          return this._initNumber(t, h, B);
        if (typeof t == "object")
          return this._initArray(t, h, B);
        h === "hex" && (h = 16), J(h === (h | 0) && h >= 2 && h <= 36), t = t.toString().replace(/\s+/g, "");
        var Z = 0;
        t[0] === "-" && (Z++, this.negative = 1), Z < t.length && (h === 16 ? this._parseHex(t, Z, B) : (this._parseBase(t, h, Z), B === "le" && this._initArray(this.toArray(), h, B)));
      }, H.prototype._initNumber = function(t, h, B) {
        t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [t & 67108863], this.length = 1) : t < 4503599627370496 ? (this.words = [
          t & 67108863,
          t / 67108864 & 67108863
        ], this.length = 2) : (J(t < 9007199254740992), this.words = [
          t & 67108863,
          t / 67108864 & 67108863,
          1
        ], this.length = 3), B === "le" && this._initArray(this.toArray(), h, B);
      }, H.prototype._initArray = function(t, h, B) {
        if (J(typeof t.length == "number"), t.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve, ge, xe = 0;
        if (B === "be")
          for (Z = t.length - 1, ve = 0; Z >= 0; Z -= 3)
            ge = t[Z] | t[Z - 1] << 8 | t[Z - 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        else if (B === "le")
          for (Z = 0, ve = 0; Z < t.length; Z += 3)
            ge = t[Z] | t[Z + 1] << 8 | t[Z + 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        return this.strip();
      };
      function Ie(Se, t) {
        var h = Se.charCodeAt(t);
        return h >= 65 && h <= 70 ? h - 55 : h >= 97 && h <= 102 ? h - 87 : h - 48 & 15;
      }
      function qe(Se, t, h) {
        var B = Ie(Se, h);
        return h - 1 >= t && (B |= Ie(Se, h - 1) << 4), B;
      }
      H.prototype._parseHex = function(t, h, B) {
        this.length = Math.ceil((t.length - h) / 6), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve = 0, ge = 0, xe;
        if (B === "be")
          for (Z = t.length - 1; Z >= h; Z -= 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        else {
          var X = t.length - h;
          for (Z = X % 2 === 0 ? h + 1 : h; Z < t.length; Z += 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        }
        this.strip();
      };
      function Te(Se, t, h, B) {
        for (var Z = 0, ve = Math.min(Se.length, h), ge = t; ge < ve; ge++) {
          var xe = Se.charCodeAt(ge) - 48;
          Z *= B, xe >= 49 ? Z += xe - 49 + 10 : xe >= 17 ? Z += xe - 17 + 10 : Z += xe;
        }
        return Z;
      }
      H.prototype._parseBase = function(t, h, B) {
        this.words = [0], this.length = 1;
        for (var Z = 0, ve = 1; ve <= 67108863; ve *= h)
          Z++;
        Z--, ve = ve / h | 0;
        for (var ge = t.length - B, xe = ge % Z, X = Math.min(ge, ge - xe) + B, a = 0, Y = B; Y < X; Y += Z)
          a = Te(t, Y, Y + Z, h), this.imuln(ve), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (xe !== 0) {
          var Ne = 1;
          for (a = Te(t, Y, t.length, h), Y = 0; Y < xe; Y++)
            Ne *= h;
          this.imuln(Ne), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, H.prototype.copy = function(t) {
        t.words = new Array(this.length);
        for (var h = 0; h < this.length; h++)
          t.words[h] = this.words[h];
        t.length = this.length, t.negative = this.negative, t.red = this.red;
      }, H.prototype.clone = function() {
        var t = new H(null);
        return this.copy(t), t;
      }, H.prototype._expand = function(t) {
        for (; this.length < t; )
          this.words[this.length++] = 0;
        return this;
      }, H.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, H.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, H.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var Ee = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Oe = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Le = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      H.prototype.toString = function(t, h) {
        t = t || 10, h = h | 0 || 1;
        var B;
        if (t === 16 || t === "hex") {
          B = "";
          for (var Z = 0, ve = 0, ge = 0; ge < this.length; ge++) {
            var xe = this.words[ge], X = ((xe << Z | ve) & 16777215).toString(16);
            ve = xe >>> 24 - Z & 16777215, ve !== 0 || ge !== this.length - 1 ? B = Ee[6 - X.length] + X + B : B = X + B, Z += 2, Z >= 26 && (Z -= 26, ge--);
          }
          for (ve !== 0 && (B = ve.toString(16) + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        if (t === (t | 0) && t >= 2 && t <= 36) {
          var a = Oe[t], Y = Le[t];
          B = "";
          var Ne = this.clone();
          for (Ne.negative = 0; !Ne.isZero(); ) {
            var Ke = Ne.modn(Y).toString(t);
            Ne = Ne.idivn(Y), Ne.isZero() ? B = Ke + B : B = Ee[a - Ke.length] + Ke + B;
          }
          for (this.isZero() && (B = "0" + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        J(!1, "Base should be between 2 and 36");
      }, H.prototype.toNumber = function() {
        var t = this.words[0];
        return this.length === 2 ? t += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? t += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -t : t;
      }, H.prototype.toJSON = function() {
        return this.toString(16);
      }, H.prototype.toBuffer = function(t, h) {
        return J(typeof De < "u"), this.toArrayLike(De, t, h);
      }, H.prototype.toArray = function(t, h) {
        return this.toArrayLike(Array, t, h);
      }, H.prototype.toArrayLike = function(t, h, B) {
        var Z = this.byteLength(), ve = B || Math.max(1, Z);
        J(Z <= ve, "byte array longer than desired length"), J(ve > 0, "Requested array length <= 0"), this.strip();
        var ge = h === "le", xe = new t(ve), X, a, Y = this.clone();
        if (ge) {
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[a] = X;
          for (; a < ve; a++)
            xe[a] = 0;
        } else {
          for (a = 0; a < ve - Z; a++)
            xe[a] = 0;
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[ve - a - 1] = X;
        }
        return xe;
      }, Math.clz32 ? H.prototype._countBits = function(t) {
        return 32 - Math.clz32(t);
      } : H.prototype._countBits = function(t) {
        var h = t, B = 0;
        return h >= 4096 && (B += 13, h >>>= 13), h >= 64 && (B += 7, h >>>= 7), h >= 8 && (B += 4, h >>>= 4), h >= 2 && (B += 2, h >>>= 2), B + h;
      }, H.prototype._zeroBits = function(t) {
        if (t === 0) return 26;
        var h = t, B = 0;
        return h & 8191 || (B += 13, h >>>= 13), h & 127 || (B += 7, h >>>= 7), h & 15 || (B += 4, h >>>= 4), h & 3 || (B += 2, h >>>= 2), h & 1 || B++, B;
      }, H.prototype.bitLength = function() {
        var t = this.words[this.length - 1], h = this._countBits(t);
        return (this.length - 1) * 26 + h;
      };
      function ke(Se) {
        for (var t = new Array(Se.bitLength()), h = 0; h < t.length; h++) {
          var B = h / 26 | 0, Z = h % 26;
          t[h] = (Se.words[B] & 1 << Z) >>> Z;
        }
        return t;
      }
      H.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var t = 0, h = 0; h < this.length; h++) {
          var B = this._zeroBits(this.words[h]);
          if (t += B, B !== 26) break;
        }
        return t;
      }, H.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, H.prototype.toTwos = function(t) {
        return this.negative !== 0 ? this.abs().inotn(t).iaddn(1) : this.clone();
      }, H.prototype.fromTwos = function(t) {
        return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
      }, H.prototype.isNeg = function() {
        return this.negative !== 0;
      }, H.prototype.neg = function() {
        return this.clone().ineg();
      }, H.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, H.prototype.iuor = function(t) {
        for (; this.length < t.length; )
          this.words[this.length++] = 0;
        for (var h = 0; h < t.length; h++)
          this.words[h] = this.words[h] | t.words[h];
        return this.strip();
      }, H.prototype.ior = function(t) {
        return J((this.negative | t.negative) === 0), this.iuor(t);
      }, H.prototype.or = function(t) {
        return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
      }, H.prototype.uor = function(t) {
        return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
      }, H.prototype.iuand = function(t) {
        var h;
        this.length > t.length ? h = t : h = this;
        for (var B = 0; B < h.length; B++)
          this.words[B] = this.words[B] & t.words[B];
        return this.length = h.length, this.strip();
      }, H.prototype.iand = function(t) {
        return J((this.negative | t.negative) === 0), this.iuand(t);
      }, H.prototype.and = function(t) {
        return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
      }, H.prototype.uand = function(t) {
        return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
      }, H.prototype.iuxor = function(t) {
        var h, B;
        this.length > t.length ? (h = this, B = t) : (h = t, B = this);
        for (var Z = 0; Z < B.length; Z++)
          this.words[Z] = h.words[Z] ^ B.words[Z];
        if (this !== h)
          for (; Z < h.length; Z++)
            this.words[Z] = h.words[Z];
        return this.length = h.length, this.strip();
      }, H.prototype.ixor = function(t) {
        return J((this.negative | t.negative) === 0), this.iuxor(t);
      }, H.prototype.xor = function(t) {
        return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
      }, H.prototype.uxor = function(t) {
        return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
      }, H.prototype.inotn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = Math.ceil(t / 26) | 0, B = t % 26;
        this._expand(h), B > 0 && h--;
        for (var Z = 0; Z < h; Z++)
          this.words[Z] = ~this.words[Z] & 67108863;
        return B > 0 && (this.words[Z] = ~this.words[Z] & 67108863 >> 26 - B), this.strip();
      }, H.prototype.notn = function(t) {
        return this.clone().inotn(t);
      }, H.prototype.setn = function(t, h) {
        J(typeof t == "number" && t >= 0);
        var B = t / 26 | 0, Z = t % 26;
        return this._expand(B + 1), h ? this.words[B] = this.words[B] | 1 << Z : this.words[B] = this.words[B] & ~(1 << Z), this.strip();
      }, H.prototype.iadd = function(t) {
        var h;
        if (this.negative !== 0 && t.negative === 0)
          return this.negative = 0, h = this.isub(t), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && t.negative !== 0)
          return t.negative = 0, h = this.isub(t), t.negative = 1, h._normSign();
        var B, Z;
        this.length > t.length ? (B = this, Z = t) : (B = t, Z = this);
        for (var ve = 0, ge = 0; ge < Z.length; ge++)
          h = (B.words[ge] | 0) + (Z.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        for (; ve !== 0 && ge < B.length; ge++)
          h = (B.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        if (this.length = B.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (B !== this)
          for (; ge < B.length; ge++)
            this.words[ge] = B.words[ge];
        return this;
      }, H.prototype.add = function(t) {
        var h;
        return t.negative !== 0 && this.negative === 0 ? (t.negative = 0, h = this.sub(t), t.negative ^= 1, h) : t.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = t.sub(this), this.negative = 1, h) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
      }, H.prototype.isub = function(t) {
        if (t.negative !== 0) {
          t.negative = 0;
          var h = this.iadd(t);
          return t.negative = 1, h._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
        var B = this.cmp(t);
        if (B === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Z, ve;
        B > 0 ? (Z = this, ve = t) : (Z = t, ve = this);
        for (var ge = 0, xe = 0; xe < ve.length; xe++)
          h = (Z.words[xe] | 0) - (ve.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        for (; ge !== 0 && xe < Z.length; xe++)
          h = (Z.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        if (ge === 0 && xe < Z.length && Z !== this)
          for (; xe < Z.length; xe++)
            this.words[xe] = Z.words[xe];
        return this.length = Math.max(this.length, xe), Z !== this && (this.negative = 1), this.strip();
      }, H.prototype.sub = function(t) {
        return this.clone().isub(t);
      };
      function Fe(Se, t, h) {
        h.negative = t.negative ^ Se.negative;
        var B = Se.length + t.length | 0;
        h.length = B, B = B - 1 | 0;
        var Z = Se.words[0] | 0, ve = t.words[0] | 0, ge = Z * ve, xe = ge & 67108863, X = ge / 67108864 | 0;
        h.words[0] = xe;
        for (var a = 1; a < B; a++) {
          for (var Y = X >>> 26, Ne = X & 67108863, Ke = Math.min(a, t.length - 1), tt = Math.max(0, a - Se.length + 1); tt <= Ke; tt++) {
            var We = a - tt | 0;
            Z = Se.words[We] | 0, ve = t.words[tt] | 0, ge = Z * ve + Ne, Y += ge / 67108864 | 0, Ne = ge & 67108863;
          }
          h.words[a] = Ne | 0, X = Y | 0;
        }
        return X !== 0 ? h.words[a] = X | 0 : h.length--, h.strip();
      }
      var Ge = function(t, h, B) {
        var Z = t.words, ve = h.words, ge = B.words, xe = 0, X, a, Y, Ne = Z[0] | 0, Ke = Ne & 8191, tt = Ne >>> 13, We = Z[1] | 0, ot = We & 8191, He = We >>> 13, Qe = Z[2] | 0, nt = Qe & 8191, je = Qe >>> 13, it = Z[3] | 0, st = it & 8191, gt = it >>> 13, It = Z[4] | 0, At = It & 8191, Et = It >>> 13, ei = Z[5] | 0, Xt = ei & 8191, _t = ei >>> 13, ni = Z[6] | 0, Ct = ni & 8191, Wt = ni >>> 13, ii = Z[7] | 0, Pt = ii & 8191, Rt = ii >>> 13, ai = Z[8] | 0, Nt = ai & 8191, qt = ai >>> 13, oi = Z[9] | 0, ct = oi & 8191, Ze = oi >>> 13, at = ve[0] | 0, dt = at & 8191, yt = at >>> 13, St = ve[1] | 0, xt = St & 8191, Vt = St >>> 13, ci = ve[2] | 0, Qt = ci & 8191, rr = ci >>> 13, ui = ve[3] | 0, Gr = ui & 8191, yr = ui >>> 13, pi = ve[4] | 0, wr = pi & 8191, _r = pi >>> 13, di = ve[5] | 0, Sr = di & 8191, Br = di >>> 13, vi = ve[6] | 0, gr = vi & 8191, $r = vi >>> 13, li = ve[7] | 0, Ir = li & 8191, Cr = li >>> 13, mi = ve[8] | 0, Pr = mi & 8191, Or = mi >>> 13, yi = ve[9] | 0, Zr = yi & 8191, Vr = yi >>> 13;
        B.negative = t.negative ^ h.negative, B.length = 19, X = Math.imul(Ke, dt), a = Math.imul(Ke, yt), a = a + Math.imul(tt, dt) | 0, Y = Math.imul(tt, yt);
        var bi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, X = Math.imul(ot, dt), a = Math.imul(ot, yt), a = a + Math.imul(He, dt) | 0, Y = Math.imul(He, yt), X = X + Math.imul(Ke, xt) | 0, a = a + Math.imul(Ke, Vt) | 0, a = a + Math.imul(tt, xt) | 0, Y = Y + Math.imul(tt, Vt) | 0;
        var Ai = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, X = Math.imul(nt, dt), a = Math.imul(nt, yt), a = a + Math.imul(je, dt) | 0, Y = Math.imul(je, yt), X = X + Math.imul(ot, xt) | 0, a = a + Math.imul(ot, Vt) | 0, a = a + Math.imul(He, xt) | 0, Y = Y + Math.imul(He, Vt) | 0, X = X + Math.imul(Ke, Qt) | 0, a = a + Math.imul(Ke, rr) | 0, a = a + Math.imul(tt, Qt) | 0, Y = Y + Math.imul(tt, rr) | 0;
        var Zi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, X = Math.imul(st, dt), a = Math.imul(st, yt), a = a + Math.imul(gt, dt) | 0, Y = Math.imul(gt, yt), X = X + Math.imul(nt, xt) | 0, a = a + Math.imul(nt, Vt) | 0, a = a + Math.imul(je, xt) | 0, Y = Y + Math.imul(je, Vt) | 0, X = X + Math.imul(ot, Qt) | 0, a = a + Math.imul(ot, rr) | 0, a = a + Math.imul(He, Qt) | 0, Y = Y + Math.imul(He, rr) | 0, X = X + Math.imul(Ke, Gr) | 0, a = a + Math.imul(Ke, yr) | 0, a = a + Math.imul(tt, Gr) | 0, Y = Y + Math.imul(tt, yr) | 0;
        var Ji = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, X = Math.imul(At, dt), a = Math.imul(At, yt), a = a + Math.imul(Et, dt) | 0, Y = Math.imul(Et, yt), X = X + Math.imul(st, xt) | 0, a = a + Math.imul(st, Vt) | 0, a = a + Math.imul(gt, xt) | 0, Y = Y + Math.imul(gt, Vt) | 0, X = X + Math.imul(nt, Qt) | 0, a = a + Math.imul(nt, rr) | 0, a = a + Math.imul(je, Qt) | 0, Y = Y + Math.imul(je, rr) | 0, X = X + Math.imul(ot, Gr) | 0, a = a + Math.imul(ot, yr) | 0, a = a + Math.imul(He, Gr) | 0, Y = Y + Math.imul(He, yr) | 0, X = X + Math.imul(Ke, wr) | 0, a = a + Math.imul(Ke, _r) | 0, a = a + Math.imul(tt, wr) | 0, Y = Y + Math.imul(tt, _r) | 0;
        var Vi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, X = Math.imul(Xt, dt), a = Math.imul(Xt, yt), a = a + Math.imul(_t, dt) | 0, Y = Math.imul(_t, yt), X = X + Math.imul(At, xt) | 0, a = a + Math.imul(At, Vt) | 0, a = a + Math.imul(Et, xt) | 0, Y = Y + Math.imul(Et, Vt) | 0, X = X + Math.imul(st, Qt) | 0, a = a + Math.imul(st, rr) | 0, a = a + Math.imul(gt, Qt) | 0, Y = Y + Math.imul(gt, rr) | 0, X = X + Math.imul(nt, Gr) | 0, a = a + Math.imul(nt, yr) | 0, a = a + Math.imul(je, Gr) | 0, Y = Y + Math.imul(je, yr) | 0, X = X + Math.imul(ot, wr) | 0, a = a + Math.imul(ot, _r) | 0, a = a + Math.imul(He, wr) | 0, Y = Y + Math.imul(He, _r) | 0, X = X + Math.imul(Ke, Sr) | 0, a = a + Math.imul(Ke, Br) | 0, a = a + Math.imul(tt, Sr) | 0, Y = Y + Math.imul(tt, Br) | 0;
        var Yi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, X = Math.imul(Ct, dt), a = Math.imul(Ct, yt), a = a + Math.imul(Wt, dt) | 0, Y = Math.imul(Wt, yt), X = X + Math.imul(Xt, xt) | 0, a = a + Math.imul(Xt, Vt) | 0, a = a + Math.imul(_t, xt) | 0, Y = Y + Math.imul(_t, Vt) | 0, X = X + Math.imul(At, Qt) | 0, a = a + Math.imul(At, rr) | 0, a = a + Math.imul(Et, Qt) | 0, Y = Y + Math.imul(Et, rr) | 0, X = X + Math.imul(st, Gr) | 0, a = a + Math.imul(st, yr) | 0, a = a + Math.imul(gt, Gr) | 0, Y = Y + Math.imul(gt, yr) | 0, X = X + Math.imul(nt, wr) | 0, a = a + Math.imul(nt, _r) | 0, a = a + Math.imul(je, wr) | 0, Y = Y + Math.imul(je, _r) | 0, X = X + Math.imul(ot, Sr) | 0, a = a + Math.imul(ot, Br) | 0, a = a + Math.imul(He, Sr) | 0, Y = Y + Math.imul(He, Br) | 0, X = X + Math.imul(Ke, gr) | 0, a = a + Math.imul(Ke, $r) | 0, a = a + Math.imul(tt, gr) | 0, Y = Y + Math.imul(tt, $r) | 0;
        var Xi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, X = Math.imul(Pt, dt), a = Math.imul(Pt, yt), a = a + Math.imul(Rt, dt) | 0, Y = Math.imul(Rt, yt), X = X + Math.imul(Ct, xt) | 0, a = a + Math.imul(Ct, Vt) | 0, a = a + Math.imul(Wt, xt) | 0, Y = Y + Math.imul(Wt, Vt) | 0, X = X + Math.imul(Xt, Qt) | 0, a = a + Math.imul(Xt, rr) | 0, a = a + Math.imul(_t, Qt) | 0, Y = Y + Math.imul(_t, rr) | 0, X = X + Math.imul(At, Gr) | 0, a = a + Math.imul(At, yr) | 0, a = a + Math.imul(Et, Gr) | 0, Y = Y + Math.imul(Et, yr) | 0, X = X + Math.imul(st, wr) | 0, a = a + Math.imul(st, _r) | 0, a = a + Math.imul(gt, wr) | 0, Y = Y + Math.imul(gt, _r) | 0, X = X + Math.imul(nt, Sr) | 0, a = a + Math.imul(nt, Br) | 0, a = a + Math.imul(je, Sr) | 0, Y = Y + Math.imul(je, Br) | 0, X = X + Math.imul(ot, gr) | 0, a = a + Math.imul(ot, $r) | 0, a = a + Math.imul(He, gr) | 0, Y = Y + Math.imul(He, $r) | 0, X = X + Math.imul(Ke, Ir) | 0, a = a + Math.imul(Ke, Cr) | 0, a = a + Math.imul(tt, Ir) | 0, Y = Y + Math.imul(tt, Cr) | 0;
        var en = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, X = Math.imul(Nt, dt), a = Math.imul(Nt, yt), a = a + Math.imul(qt, dt) | 0, Y = Math.imul(qt, yt), X = X + Math.imul(Pt, xt) | 0, a = a + Math.imul(Pt, Vt) | 0, a = a + Math.imul(Rt, xt) | 0, Y = Y + Math.imul(Rt, Vt) | 0, X = X + Math.imul(Ct, Qt) | 0, a = a + Math.imul(Ct, rr) | 0, a = a + Math.imul(Wt, Qt) | 0, Y = Y + Math.imul(Wt, rr) | 0, X = X + Math.imul(Xt, Gr) | 0, a = a + Math.imul(Xt, yr) | 0, a = a + Math.imul(_t, Gr) | 0, Y = Y + Math.imul(_t, yr) | 0, X = X + Math.imul(At, wr) | 0, a = a + Math.imul(At, _r) | 0, a = a + Math.imul(Et, wr) | 0, Y = Y + Math.imul(Et, _r) | 0, X = X + Math.imul(st, Sr) | 0, a = a + Math.imul(st, Br) | 0, a = a + Math.imul(gt, Sr) | 0, Y = Y + Math.imul(gt, Br) | 0, X = X + Math.imul(nt, gr) | 0, a = a + Math.imul(nt, $r) | 0, a = a + Math.imul(je, gr) | 0, Y = Y + Math.imul(je, $r) | 0, X = X + Math.imul(ot, Ir) | 0, a = a + Math.imul(ot, Cr) | 0, a = a + Math.imul(He, Ir) | 0, Y = Y + Math.imul(He, Cr) | 0, X = X + Math.imul(Ke, Pr) | 0, a = a + Math.imul(Ke, Or) | 0, a = a + Math.imul(tt, Pr) | 0, Y = Y + Math.imul(tt, Or) | 0;
        var hn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, X = Math.imul(ct, dt), a = Math.imul(ct, yt), a = a + Math.imul(Ze, dt) | 0, Y = Math.imul(Ze, yt), X = X + Math.imul(Nt, xt) | 0, a = a + Math.imul(Nt, Vt) | 0, a = a + Math.imul(qt, xt) | 0, Y = Y + Math.imul(qt, Vt) | 0, X = X + Math.imul(Pt, Qt) | 0, a = a + Math.imul(Pt, rr) | 0, a = a + Math.imul(Rt, Qt) | 0, Y = Y + Math.imul(Rt, rr) | 0, X = X + Math.imul(Ct, Gr) | 0, a = a + Math.imul(Ct, yr) | 0, a = a + Math.imul(Wt, Gr) | 0, Y = Y + Math.imul(Wt, yr) | 0, X = X + Math.imul(Xt, wr) | 0, a = a + Math.imul(Xt, _r) | 0, a = a + Math.imul(_t, wr) | 0, Y = Y + Math.imul(_t, _r) | 0, X = X + Math.imul(At, Sr) | 0, a = a + Math.imul(At, Br) | 0, a = a + Math.imul(Et, Sr) | 0, Y = Y + Math.imul(Et, Br) | 0, X = X + Math.imul(st, gr) | 0, a = a + Math.imul(st, $r) | 0, a = a + Math.imul(gt, gr) | 0, Y = Y + Math.imul(gt, $r) | 0, X = X + Math.imul(nt, Ir) | 0, a = a + Math.imul(nt, Cr) | 0, a = a + Math.imul(je, Ir) | 0, Y = Y + Math.imul(je, Cr) | 0, X = X + Math.imul(ot, Pr) | 0, a = a + Math.imul(ot, Or) | 0, a = a + Math.imul(He, Pr) | 0, Y = Y + Math.imul(He, Or) | 0, X = X + Math.imul(Ke, Zr) | 0, a = a + Math.imul(Ke, Vr) | 0, a = a + Math.imul(tt, Zr) | 0, Y = Y + Math.imul(tt, Vr) | 0;
        var tn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, X = Math.imul(ct, xt), a = Math.imul(ct, Vt), a = a + Math.imul(Ze, xt) | 0, Y = Math.imul(Ze, Vt), X = X + Math.imul(Nt, Qt) | 0, a = a + Math.imul(Nt, rr) | 0, a = a + Math.imul(qt, Qt) | 0, Y = Y + Math.imul(qt, rr) | 0, X = X + Math.imul(Pt, Gr) | 0, a = a + Math.imul(Pt, yr) | 0, a = a + Math.imul(Rt, Gr) | 0, Y = Y + Math.imul(Rt, yr) | 0, X = X + Math.imul(Ct, wr) | 0, a = a + Math.imul(Ct, _r) | 0, a = a + Math.imul(Wt, wr) | 0, Y = Y + Math.imul(Wt, _r) | 0, X = X + Math.imul(Xt, Sr) | 0, a = a + Math.imul(Xt, Br) | 0, a = a + Math.imul(_t, Sr) | 0, Y = Y + Math.imul(_t, Br) | 0, X = X + Math.imul(At, gr) | 0, a = a + Math.imul(At, $r) | 0, a = a + Math.imul(Et, gr) | 0, Y = Y + Math.imul(Et, $r) | 0, X = X + Math.imul(st, Ir) | 0, a = a + Math.imul(st, Cr) | 0, a = a + Math.imul(gt, Ir) | 0, Y = Y + Math.imul(gt, Cr) | 0, X = X + Math.imul(nt, Pr) | 0, a = a + Math.imul(nt, Or) | 0, a = a + Math.imul(je, Pr) | 0, Y = Y + Math.imul(je, Or) | 0, X = X + Math.imul(ot, Zr) | 0, a = a + Math.imul(ot, Vr) | 0, a = a + Math.imul(He, Zr) | 0, Y = Y + Math.imul(He, Vr) | 0;
        var un = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, X = Math.imul(ct, Qt), a = Math.imul(ct, rr), a = a + Math.imul(Ze, Qt) | 0, Y = Math.imul(Ze, rr), X = X + Math.imul(Nt, Gr) | 0, a = a + Math.imul(Nt, yr) | 0, a = a + Math.imul(qt, Gr) | 0, Y = Y + Math.imul(qt, yr) | 0, X = X + Math.imul(Pt, wr) | 0, a = a + Math.imul(Pt, _r) | 0, a = a + Math.imul(Rt, wr) | 0, Y = Y + Math.imul(Rt, _r) | 0, X = X + Math.imul(Ct, Sr) | 0, a = a + Math.imul(Ct, Br) | 0, a = a + Math.imul(Wt, Sr) | 0, Y = Y + Math.imul(Wt, Br) | 0, X = X + Math.imul(Xt, gr) | 0, a = a + Math.imul(Xt, $r) | 0, a = a + Math.imul(_t, gr) | 0, Y = Y + Math.imul(_t, $r) | 0, X = X + Math.imul(At, Ir) | 0, a = a + Math.imul(At, Cr) | 0, a = a + Math.imul(Et, Ir) | 0, Y = Y + Math.imul(Et, Cr) | 0, X = X + Math.imul(st, Pr) | 0, a = a + Math.imul(st, Or) | 0, a = a + Math.imul(gt, Pr) | 0, Y = Y + Math.imul(gt, Or) | 0, X = X + Math.imul(nt, Zr) | 0, a = a + Math.imul(nt, Vr) | 0, a = a + Math.imul(je, Zr) | 0, Y = Y + Math.imul(je, Vr) | 0;
        var cn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, X = Math.imul(ct, Gr), a = Math.imul(ct, yr), a = a + Math.imul(Ze, Gr) | 0, Y = Math.imul(Ze, yr), X = X + Math.imul(Nt, wr) | 0, a = a + Math.imul(Nt, _r) | 0, a = a + Math.imul(qt, wr) | 0, Y = Y + Math.imul(qt, _r) | 0, X = X + Math.imul(Pt, Sr) | 0, a = a + Math.imul(Pt, Br) | 0, a = a + Math.imul(Rt, Sr) | 0, Y = Y + Math.imul(Rt, Br) | 0, X = X + Math.imul(Ct, gr) | 0, a = a + Math.imul(Ct, $r) | 0, a = a + Math.imul(Wt, gr) | 0, Y = Y + Math.imul(Wt, $r) | 0, X = X + Math.imul(Xt, Ir) | 0, a = a + Math.imul(Xt, Cr) | 0, a = a + Math.imul(_t, Ir) | 0, Y = Y + Math.imul(_t, Cr) | 0, X = X + Math.imul(At, Pr) | 0, a = a + Math.imul(At, Or) | 0, a = a + Math.imul(Et, Pr) | 0, Y = Y + Math.imul(Et, Or) | 0, X = X + Math.imul(st, Zr) | 0, a = a + Math.imul(st, Vr) | 0, a = a + Math.imul(gt, Zr) | 0, Y = Y + Math.imul(gt, Vr) | 0;
        var ln = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, X = Math.imul(ct, wr), a = Math.imul(ct, _r), a = a + Math.imul(Ze, wr) | 0, Y = Math.imul(Ze, _r), X = X + Math.imul(Nt, Sr) | 0, a = a + Math.imul(Nt, Br) | 0, a = a + Math.imul(qt, Sr) | 0, Y = Y + Math.imul(qt, Br) | 0, X = X + Math.imul(Pt, gr) | 0, a = a + Math.imul(Pt, $r) | 0, a = a + Math.imul(Rt, gr) | 0, Y = Y + Math.imul(Rt, $r) | 0, X = X + Math.imul(Ct, Ir) | 0, a = a + Math.imul(Ct, Cr) | 0, a = a + Math.imul(Wt, Ir) | 0, Y = Y + Math.imul(Wt, Cr) | 0, X = X + Math.imul(Xt, Pr) | 0, a = a + Math.imul(Xt, Or) | 0, a = a + Math.imul(_t, Pr) | 0, Y = Y + Math.imul(_t, Or) | 0, X = X + Math.imul(At, Zr) | 0, a = a + Math.imul(At, Vr) | 0, a = a + Math.imul(Et, Zr) | 0, Y = Y + Math.imul(Et, Vr) | 0;
        var an = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, X = Math.imul(ct, Sr), a = Math.imul(ct, Br), a = a + Math.imul(Ze, Sr) | 0, Y = Math.imul(Ze, Br), X = X + Math.imul(Nt, gr) | 0, a = a + Math.imul(Nt, $r) | 0, a = a + Math.imul(qt, gr) | 0, Y = Y + Math.imul(qt, $r) | 0, X = X + Math.imul(Pt, Ir) | 0, a = a + Math.imul(Pt, Cr) | 0, a = a + Math.imul(Rt, Ir) | 0, Y = Y + Math.imul(Rt, Cr) | 0, X = X + Math.imul(Ct, Pr) | 0, a = a + Math.imul(Ct, Or) | 0, a = a + Math.imul(Wt, Pr) | 0, Y = Y + Math.imul(Wt, Or) | 0, X = X + Math.imul(Xt, Zr) | 0, a = a + Math.imul(Xt, Vr) | 0, a = a + Math.imul(_t, Zr) | 0, Y = Y + Math.imul(_t, Vr) | 0;
        var fn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, X = Math.imul(ct, gr), a = Math.imul(ct, $r), a = a + Math.imul(Ze, gr) | 0, Y = Math.imul(Ze, $r), X = X + Math.imul(Nt, Ir) | 0, a = a + Math.imul(Nt, Cr) | 0, a = a + Math.imul(qt, Ir) | 0, Y = Y + Math.imul(qt, Cr) | 0, X = X + Math.imul(Pt, Pr) | 0, a = a + Math.imul(Pt, Or) | 0, a = a + Math.imul(Rt, Pr) | 0, Y = Y + Math.imul(Rt, Or) | 0, X = X + Math.imul(Ct, Zr) | 0, a = a + Math.imul(Ct, Vr) | 0, a = a + Math.imul(Wt, Zr) | 0, Y = Y + Math.imul(Wt, Vr) | 0;
        var sn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, X = Math.imul(ct, Ir), a = Math.imul(ct, Cr), a = a + Math.imul(Ze, Ir) | 0, Y = Math.imul(Ze, Cr), X = X + Math.imul(Nt, Pr) | 0, a = a + Math.imul(Nt, Or) | 0, a = a + Math.imul(qt, Pr) | 0, Y = Y + Math.imul(qt, Or) | 0, X = X + Math.imul(Pt, Zr) | 0, a = a + Math.imul(Pt, Vr) | 0, a = a + Math.imul(Rt, Zr) | 0, Y = Y + Math.imul(Rt, Vr) | 0;
        var dn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, X = Math.imul(ct, Pr), a = Math.imul(ct, Or), a = a + Math.imul(Ze, Pr) | 0, Y = Math.imul(Ze, Or), X = X + Math.imul(Nt, Zr) | 0, a = a + Math.imul(Nt, Vr) | 0, a = a + Math.imul(qt, Zr) | 0, Y = Y + Math.imul(qt, Vr) | 0;
        var pn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, X = Math.imul(ct, Zr), a = Math.imul(ct, Vr), a = a + Math.imul(Ze, Zr) | 0, Y = Math.imul(Ze, Vr);
        var vn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        return xe = (Y + (a >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, ge[0] = bi, ge[1] = Ai, ge[2] = Zi, ge[3] = Ji, ge[4] = Vi, ge[5] = Yi, ge[6] = Xi, ge[7] = en, ge[8] = hn, ge[9] = tn, ge[10] = un, ge[11] = cn, ge[12] = ln, ge[13] = an, ge[14] = fn, ge[15] = sn, ge[16] = dn, ge[17] = pn, ge[18] = vn, xe !== 0 && (ge[19] = xe, B.length++), B;
      };
      Math.imul || (Ge = Fe);
      function et(Se, t, h) {
        h.negative = t.negative ^ Se.negative, h.length = Se.length + t.length;
        for (var B = 0, Z = 0, ve = 0; ve < h.length - 1; ve++) {
          var ge = Z;
          Z = 0;
          for (var xe = B & 67108863, X = Math.min(ve, t.length - 1), a = Math.max(0, ve - Se.length + 1); a <= X; a++) {
            var Y = ve - a, Ne = Se.words[Y] | 0, Ke = t.words[a] | 0, tt = Ne * Ke, We = tt & 67108863;
            ge = ge + (tt / 67108864 | 0) | 0, We = We + xe | 0, xe = We & 67108863, ge = ge + (We >>> 26) | 0, Z += ge >>> 26, ge &= 67108863;
          }
          h.words[ve] = xe, B = ge, ge = Z;
        }
        return B !== 0 ? h.words[ve] = B : h.length--, h.strip();
      }
      function Ve(Se, t, h) {
        var B = new Je();
        return B.mulp(Se, t, h);
      }
      H.prototype.mulTo = function(t, h) {
        var B, Z = this.length + t.length;
        return this.length === 10 && t.length === 10 ? B = Ge(this, t, h) : Z < 63 ? B = Fe(this, t, h) : Z < 1024 ? B = et(this, t, h) : B = Ve(this, t, h), B;
      };
      function Je(Se, t) {
        this.x = Se, this.y = t;
      }
      Je.prototype.makeRBT = function(t) {
        for (var h = new Array(t), B = H.prototype._countBits(t) - 1, Z = 0; Z < t; Z++)
          h[Z] = this.revBin(Z, B, t);
        return h;
      }, Je.prototype.revBin = function(t, h, B) {
        if (t === 0 || t === B - 1) return t;
        for (var Z = 0, ve = 0; ve < h; ve++)
          Z |= (t & 1) << h - ve - 1, t >>= 1;
        return Z;
      }, Je.prototype.permute = function(t, h, B, Z, ve, ge) {
        for (var xe = 0; xe < ge; xe++)
          Z[xe] = h[t[xe]], ve[xe] = B[t[xe]];
      }, Je.prototype.transform = function(t, h, B, Z, ve, ge) {
        this.permute(ge, t, h, B, Z, ve);
        for (var xe = 1; xe < ve; xe <<= 1)
          for (var X = xe << 1, a = Math.cos(2 * Math.PI / X), Y = Math.sin(2 * Math.PI / X), Ne = 0; Ne < ve; Ne += X)
            for (var Ke = a, tt = Y, We = 0; We < xe; We++) {
              var ot = B[Ne + We], He = Z[Ne + We], Qe = B[Ne + We + xe], nt = Z[Ne + We + xe], je = Ke * Qe - tt * nt;
              nt = Ke * nt + tt * Qe, Qe = je, B[Ne + We] = ot + Qe, Z[Ne + We] = He + nt, B[Ne + We + xe] = ot - Qe, Z[Ne + We + xe] = He - nt, We !== X && (je = a * Ke - Y * tt, tt = a * tt + Y * Ke, Ke = je);
            }
      }, Je.prototype.guessLen13b = function(t, h) {
        var B = Math.max(h, t) | 1, Z = B & 1, ve = 0;
        for (B = B / 2 | 0; B; B = B >>> 1)
          ve++;
        return 1 << ve + 1 + Z;
      }, Je.prototype.conjugate = function(t, h, B) {
        if (!(B <= 1))
          for (var Z = 0; Z < B / 2; Z++) {
            var ve = t[Z];
            t[Z] = t[B - Z - 1], t[B - Z - 1] = ve, ve = h[Z], h[Z] = -h[B - Z - 1], h[B - Z - 1] = -ve;
          }
      }, Je.prototype.normalize13b = function(t, h) {
        for (var B = 0, Z = 0; Z < h / 2; Z++) {
          var ve = Math.round(t[2 * Z + 1] / h) * 8192 + Math.round(t[2 * Z] / h) + B;
          t[Z] = ve & 67108863, ve < 67108864 ? B = 0 : B = ve / 67108864 | 0;
        }
        return t;
      }, Je.prototype.convert13b = function(t, h, B, Z) {
        for (var ve = 0, ge = 0; ge < h; ge++)
          ve = ve + (t[ge] | 0), B[2 * ge] = ve & 8191, ve = ve >>> 13, B[2 * ge + 1] = ve & 8191, ve = ve >>> 13;
        for (ge = 2 * h; ge < Z; ++ge)
          B[ge] = 0;
        J(ve === 0), J((ve & -8192) === 0);
      }, Je.prototype.stub = function(t) {
        for (var h = new Array(t), B = 0; B < t; B++)
          h[B] = 0;
        return h;
      }, Je.prototype.mulp = function(t, h, B) {
        var Z = 2 * this.guessLen13b(t.length, h.length), ve = this.makeRBT(Z), ge = this.stub(Z), xe = new Array(Z), X = new Array(Z), a = new Array(Z), Y = new Array(Z), Ne = new Array(Z), Ke = new Array(Z), tt = B.words;
        tt.length = Z, this.convert13b(t.words, t.length, xe, Z), this.convert13b(h.words, h.length, Y, Z), this.transform(xe, ge, X, a, Z, ve), this.transform(Y, ge, Ne, Ke, Z, ve);
        for (var We = 0; We < Z; We++) {
          var ot = X[We] * Ne[We] - a[We] * Ke[We];
          a[We] = X[We] * Ke[We] + a[We] * Ne[We], X[We] = ot;
        }
        return this.conjugate(X, a, Z), this.transform(X, a, tt, ge, Z, ve), this.conjugate(tt, ge, Z), this.normalize13b(tt, Z), B.negative = t.negative ^ h.negative, B.length = t.length + h.length, B.strip();
      }, H.prototype.mul = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), this.mulTo(t, h);
      }, H.prototype.mulf = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), Ve(this, t, h);
      }, H.prototype.imul = function(t) {
        return this.clone().mulTo(t, this);
      }, H.prototype.imuln = function(t) {
        J(typeof t == "number"), J(t < 67108864);
        for (var h = 0, B = 0; B < this.length; B++) {
          var Z = (this.words[B] | 0) * t, ve = (Z & 67108863) + (h & 67108863);
          h >>= 26, h += Z / 67108864 | 0, h += ve >>> 26, this.words[B] = ve & 67108863;
        }
        return h !== 0 && (this.words[B] = h, this.length++), this;
      }, H.prototype.muln = function(t) {
        return this.clone().imuln(t);
      }, H.prototype.sqr = function() {
        return this.mul(this);
      }, H.prototype.isqr = function() {
        return this.imul(this.clone());
      }, H.prototype.pow = function(t) {
        var h = ke(t);
        if (h.length === 0) return new H(1);
        for (var B = this, Z = 0; Z < h.length && h[Z] === 0; Z++, B = B.sqr())
          ;
        if (++Z < h.length)
          for (var ve = B.sqr(); Z < h.length; Z++, ve = ve.sqr())
            h[Z] !== 0 && (B = B.mul(ve));
        return B;
      }, H.prototype.iushln = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 67108863 >>> 26 - h << 26 - h, ve;
        if (h !== 0) {
          var ge = 0;
          for (ve = 0; ve < this.length; ve++) {
            var xe = this.words[ve] & Z, X = (this.words[ve] | 0) - xe << h;
            this.words[ve] = X | ge, ge = xe >>> 26 - h;
          }
          ge && (this.words[ve] = ge, this.length++);
        }
        if (B !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + B] = this.words[ve];
          for (ve = 0; ve < B; ve++)
            this.words[ve] = 0;
          this.length += B;
        }
        return this.strip();
      }, H.prototype.ishln = function(t) {
        return J(this.negative === 0), this.iushln(t);
      }, H.prototype.iushrn = function(t, h, B) {
        J(typeof t == "number" && t >= 0);
        var Z;
        h ? Z = (h - h % 26) / 26 : Z = 0;
        var ve = t % 26, ge = Math.min((t - ve) / 26, this.length), xe = 67108863 ^ 67108863 >>> ve << ve, X = B;
        if (Z -= ge, Z = Math.max(0, Z), X) {
          for (var a = 0; a < ge; a++)
            X.words[a] = this.words[a];
          X.length = ge;
        }
        if (ge !== 0) if (this.length > ge)
          for (this.length -= ge, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + ge];
        else
          this.words[0] = 0, this.length = 1;
        var Y = 0;
        for (a = this.length - 1; a >= 0 && (Y !== 0 || a >= Z); a--) {
          var Ne = this.words[a] | 0;
          this.words[a] = Y << 26 - ve | Ne >>> ve, Y = Ne & xe;
        }
        return X && Y !== 0 && (X.words[X.length++] = Y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, H.prototype.ishrn = function(t, h, B) {
        return J(this.negative === 0), this.iushrn(t, h, B);
      }, H.prototype.shln = function(t) {
        return this.clone().ishln(t);
      }, H.prototype.ushln = function(t) {
        return this.clone().iushln(t);
      }, H.prototype.shrn = function(t) {
        return this.clone().ishrn(t);
      }, H.prototype.ushrn = function(t) {
        return this.clone().iushrn(t);
      }, H.prototype.testn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B) return !1;
        var ve = this.words[B];
        return !!(ve & Z);
      }, H.prototype.imaskn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26;
        if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= B)
          return this;
        if (h !== 0 && B++, this.length = Math.min(B, this.length), h !== 0) {
          var Z = 67108863 ^ 67108863 >>> h << h;
          this.words[this.length - 1] &= Z;
        }
        return this.strip();
      }, H.prototype.maskn = function(t) {
        return this.clone().imaskn(t);
      }, H.prototype.iaddn = function(t) {
        return J(typeof t == "number"), J(t < 67108864), t < 0 ? this.isubn(-t) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < t ? (this.words[0] = t - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
      }, H.prototype._iaddn = function(t) {
        this.words[0] += t;
        for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
          this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
        return this.length = Math.max(this.length, h + 1), this;
      }, H.prototype.isubn = function(t) {
        if (J(typeof t == "number"), J(t < 67108864), t < 0) return this.iaddn(-t);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(t), this.negative = 1, this;
        if (this.words[0] -= t, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var h = 0; h < this.length && this.words[h] < 0; h++)
            this.words[h] += 67108864, this.words[h + 1] -= 1;
        return this.strip();
      }, H.prototype.addn = function(t) {
        return this.clone().iaddn(t);
      }, H.prototype.subn = function(t) {
        return this.clone().isubn(t);
      }, H.prototype.iabs = function() {
        return this.negative = 0, this;
      }, H.prototype.abs = function() {
        return this.clone().iabs();
      }, H.prototype._ishlnsubmul = function(t, h, B) {
        var Z = t.length + B, ve;
        this._expand(Z);
        var ge, xe = 0;
        for (ve = 0; ve < t.length; ve++) {
          ge = (this.words[ve + B] | 0) + xe;
          var X = (t.words[ve] | 0) * h;
          ge -= X & 67108863, xe = (ge >> 26) - (X / 67108864 | 0), this.words[ve + B] = ge & 67108863;
        }
        for (; ve < this.length - B; ve++)
          ge = (this.words[ve + B] | 0) + xe, xe = ge >> 26, this.words[ve + B] = ge & 67108863;
        if (xe === 0) return this.strip();
        for (J(xe === -1), xe = 0, ve = 0; ve < this.length; ve++)
          ge = -(this.words[ve] | 0) + xe, xe = ge >> 26, this.words[ve] = ge & 67108863;
        return this.negative = 1, this.strip();
      }, H.prototype._wordDiv = function(t, h) {
        var B = this.length - t.length, Z = this.clone(), ve = t, ge = ve.words[ve.length - 1] | 0, xe = this._countBits(ge);
        B = 26 - xe, B !== 0 && (ve = ve.ushln(B), Z.iushln(B), ge = ve.words[ve.length - 1] | 0);
        var X = Z.length - ve.length, a;
        if (h !== "mod") {
          a = new H(null), a.length = X + 1, a.words = new Array(a.length);
          for (var Y = 0; Y < a.length; Y++)
            a.words[Y] = 0;
        }
        var Ne = Z.clone()._ishlnsubmul(ve, 1, X);
        Ne.negative === 0 && (Z = Ne, a && (a.words[X] = 1));
        for (var Ke = X - 1; Ke >= 0; Ke--) {
          var tt = (Z.words[ve.length + Ke] | 0) * 67108864 + (Z.words[ve.length + Ke - 1] | 0);
          for (tt = Math.min(tt / ge | 0, 67108863), Z._ishlnsubmul(ve, tt, Ke); Z.negative !== 0; )
            tt--, Z.negative = 0, Z._ishlnsubmul(ve, 1, Ke), Z.isZero() || (Z.negative ^= 1);
          a && (a.words[Ke] = tt);
        }
        return a && a.strip(), Z.strip(), h !== "div" && B !== 0 && Z.iushrn(B), {
          div: a || null,
          mod: Z
        };
      }, H.prototype.divmod = function(t, h, B) {
        if (J(!t.isZero()), this.isZero())
          return {
            div: new H(0),
            mod: new H(0)
          };
        var Z, ve, ge;
        return this.negative !== 0 && t.negative === 0 ? (ge = this.neg().divmod(t, h), h !== "mod" && (Z = ge.div.neg()), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.iadd(t)), {
          div: Z,
          mod: ve
        }) : this.negative === 0 && t.negative !== 0 ? (ge = this.divmod(t.neg(), h), h !== "mod" && (Z = ge.div.neg()), {
          div: Z,
          mod: ge.mod
        }) : this.negative & t.negative ? (ge = this.neg().divmod(t.neg(), h), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.isub(t)), {
          div: ge.div,
          mod: ve
        }) : t.length > this.length || this.cmp(t) < 0 ? {
          div: new H(0),
          mod: this
        } : t.length === 1 ? h === "div" ? {
          div: this.divn(t.words[0]),
          mod: null
        } : h === "mod" ? {
          div: null,
          mod: new H(this.modn(t.words[0]))
        } : {
          div: this.divn(t.words[0]),
          mod: new H(this.modn(t.words[0]))
        } : this._wordDiv(t, h);
      }, H.prototype.div = function(t) {
        return this.divmod(t, "div", !1).div;
      }, H.prototype.mod = function(t) {
        return this.divmod(t, "mod", !1).mod;
      }, H.prototype.umod = function(t) {
        return this.divmod(t, "mod", !0).mod;
      }, H.prototype.divRound = function(t) {
        var h = this.divmod(t);
        if (h.mod.isZero()) return h.div;
        var B = h.div.negative !== 0 ? h.mod.isub(t) : h.mod, Z = t.ushrn(1), ve = t.andln(1), ge = B.cmp(Z);
        return ge < 0 || ve === 1 && ge === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
      }, H.prototype.modn = function(t) {
        J(t <= 67108863);
        for (var h = (1 << 26) % t, B = 0, Z = this.length - 1; Z >= 0; Z--)
          B = (h * B + (this.words[Z] | 0)) % t;
        return B;
      }, H.prototype.idivn = function(t) {
        J(t <= 67108863);
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = (this.words[B] | 0) + h * 67108864;
          this.words[B] = Z / t | 0, h = Z % t;
        }
        return this.strip();
      }, H.prototype.divn = function(t) {
        return this.clone().idivn(t);
      }, H.prototype.egcd = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = new H(0), xe = new H(1), X = 0; h.isEven() && B.isEven(); )
          h.iushrn(1), B.iushrn(1), ++X;
        for (var a = B.clone(), Y = h.clone(); !h.isZero(); ) {
          for (var Ne = 0, Ke = 1; !(h.words[0] & Ke) && Ne < 26; ++Ne, Ke <<= 1) ;
          if (Ne > 0)
            for (h.iushrn(Ne); Ne-- > 0; )
              (Z.isOdd() || ve.isOdd()) && (Z.iadd(a), ve.isub(Y)), Z.iushrn(1), ve.iushrn(1);
          for (var tt = 0, We = 1; !(B.words[0] & We) && tt < 26; ++tt, We <<= 1) ;
          if (tt > 0)
            for (B.iushrn(tt); tt-- > 0; )
              (ge.isOdd() || xe.isOdd()) && (ge.iadd(a), xe.isub(Y)), ge.iushrn(1), xe.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ge), ve.isub(xe)) : (B.isub(h), ge.isub(Z), xe.isub(ve));
        }
        return {
          a: ge,
          b: xe,
          gcd: B.iushln(X)
        };
      }, H.prototype._invmp = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = B.clone(); h.cmpn(1) > 0 && B.cmpn(1) > 0; ) {
          for (var xe = 0, X = 1; !(h.words[0] & X) && xe < 26; ++xe, X <<= 1) ;
          if (xe > 0)
            for (h.iushrn(xe); xe-- > 0; )
              Z.isOdd() && Z.iadd(ge), Z.iushrn(1);
          for (var a = 0, Y = 1; !(B.words[0] & Y) && a < 26; ++a, Y <<= 1) ;
          if (a > 0)
            for (B.iushrn(a); a-- > 0; )
              ve.isOdd() && ve.iadd(ge), ve.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ve)) : (B.isub(h), ve.isub(Z));
        }
        var Ne;
        return h.cmpn(1) === 0 ? Ne = Z : Ne = ve, Ne.cmpn(0) < 0 && Ne.iadd(t), Ne;
      }, H.prototype.gcd = function(t) {
        if (this.isZero()) return t.abs();
        if (t.isZero()) return this.abs();
        var h = this.clone(), B = t.clone();
        h.negative = 0, B.negative = 0;
        for (var Z = 0; h.isEven() && B.isEven(); Z++)
          h.iushrn(1), B.iushrn(1);
        do {
          for (; h.isEven(); )
            h.iushrn(1);
          for (; B.isEven(); )
            B.iushrn(1);
          var ve = h.cmp(B);
          if (ve < 0) {
            var ge = h;
            h = B, B = ge;
          } else if (ve === 0 || B.cmpn(1) === 0)
            break;
          h.isub(B);
        } while (!0);
        return B.iushln(Z);
      }, H.prototype.invm = function(t) {
        return this.egcd(t).a.umod(t);
      }, H.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, H.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, H.prototype.andln = function(t) {
        return this.words[0] & t;
      }, H.prototype.bincn = function(t) {
        J(typeof t == "number");
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B)
          return this._expand(B + 1), this.words[B] |= Z, this;
        for (var ve = Z, ge = B; ve !== 0 && ge < this.length; ge++) {
          var xe = this.words[ge] | 0;
          xe += ve, ve = xe >>> 26, xe &= 67108863, this.words[ge] = xe;
        }
        return ve !== 0 && (this.words[ge] = ve, this.length++), this;
      }, H.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, H.prototype.cmpn = function(t) {
        var h = t < 0;
        if (this.negative !== 0 && !h) return -1;
        if (this.negative === 0 && h) return 1;
        this.strip();
        var B;
        if (this.length > 1)
          B = 1;
        else {
          h && (t = -t), J(t <= 67108863, "Number is too big");
          var Z = this.words[0] | 0;
          B = Z === t ? 0 : Z < t ? -1 : 1;
        }
        return this.negative !== 0 ? -B | 0 : B;
      }, H.prototype.cmp = function(t) {
        if (this.negative !== 0 && t.negative === 0) return -1;
        if (this.negative === 0 && t.negative !== 0) return 1;
        var h = this.ucmp(t);
        return this.negative !== 0 ? -h | 0 : h;
      }, H.prototype.ucmp = function(t) {
        if (this.length > t.length) return 1;
        if (this.length < t.length) return -1;
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = this.words[B] | 0, ve = t.words[B] | 0;
          if (Z !== ve) {
            Z < ve ? h = -1 : Z > ve && (h = 1);
            break;
          }
        }
        return h;
      }, H.prototype.gtn = function(t) {
        return this.cmpn(t) === 1;
      }, H.prototype.gt = function(t) {
        return this.cmp(t) === 1;
      }, H.prototype.gten = function(t) {
        return this.cmpn(t) >= 0;
      }, H.prototype.gte = function(t) {
        return this.cmp(t) >= 0;
      }, H.prototype.ltn = function(t) {
        return this.cmpn(t) === -1;
      }, H.prototype.lt = function(t) {
        return this.cmp(t) === -1;
      }, H.prototype.lten = function(t) {
        return this.cmpn(t) <= 0;
      }, H.prototype.lte = function(t) {
        return this.cmp(t) <= 0;
      }, H.prototype.eqn = function(t) {
        return this.cmpn(t) === 0;
      }, H.prototype.eq = function(t) {
        return this.cmp(t) === 0;
      }, H.red = function(t) {
        return new bt(t);
      }, H.prototype.toRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), t.convertTo(this)._forceRed(t);
      }, H.prototype.fromRed = function() {
        return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, H.prototype._forceRed = function(t) {
        return this.red = t, this;
      }, H.prototype.forceRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), this._forceRed(t);
      }, H.prototype.redAdd = function(t) {
        return J(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
      }, H.prototype.redIAdd = function(t) {
        return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
      }, H.prototype.redSub = function(t) {
        return J(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
      }, H.prototype.redISub = function(t) {
        return J(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
      }, H.prototype.redShl = function(t) {
        return J(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
      }, H.prototype.redMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
      }, H.prototype.redIMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
      }, H.prototype.redSqr = function() {
        return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, H.prototype.redISqr = function() {
        return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, H.prototype.redSqrt = function() {
        return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, H.prototype.redInvm = function() {
        return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, H.prototype.redNeg = function() {
        return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, H.prototype.redPow = function(t) {
        return J(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
      };
      var ut = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function rt(Se, t) {
        this.name = Se, this.p = new H(t, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      rt.prototype._tmp = function() {
        var t = new H(null);
        return t.words = new Array(Math.ceil(this.n / 13)), t;
      }, rt.prototype.ireduce = function(t) {
        var h = t, B;
        do
          this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), B = h.bitLength();
        while (B > this.n);
        var Z = B < this.n ? -1 : h.ucmp(this.p);
        return Z === 0 ? (h.words[0] = 0, h.length = 1) : Z > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
      }, rt.prototype.split = function(t, h) {
        t.iushrn(this.n, 0, h);
      }, rt.prototype.imulK = function(t) {
        return t.imul(this.k);
      };
      function lt() {
        rt.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      _e(lt, rt), lt.prototype.split = function(t, h) {
        for (var B = 4194303, Z = Math.min(t.length, 9), ve = 0; ve < Z; ve++)
          h.words[ve] = t.words[ve];
        if (h.length = Z, t.length <= 9) {
          t.words[0] = 0, t.length = 1;
          return;
        }
        var ge = t.words[9];
        for (h.words[h.length++] = ge & B, ve = 10; ve < t.length; ve++) {
          var xe = t.words[ve] | 0;
          t.words[ve - 10] = (xe & B) << 4 | ge >>> 22, ge = xe;
        }
        ge >>>= 22, t.words[ve - 10] = ge, ge === 0 && t.length > 10 ? t.length -= 10 : t.length -= 9;
      }, lt.prototype.imulK = function(t) {
        t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = t.words[B] | 0;
          h += Z * 977, t.words[B] = h & 67108863, h = Z * 64 + (h / 67108864 | 0);
        }
        return t.words[t.length - 1] === 0 && (t.length--, t.words[t.length - 1] === 0 && t.length--), t;
      };
      function vt() {
        rt.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      _e(vt, rt);
      function Ye() {
        rt.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      _e(Ye, rt);
      function pt() {
        rt.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      _e(pt, rt), pt.prototype.imulK = function(t) {
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = (t.words[B] | 0) * 19 + h, ve = Z & 67108863;
          Z >>>= 26, t.words[B] = ve, h = Z;
        }
        return h !== 0 && (t.words[t.length++] = h), t;
      }, H._prime = function(t) {
        if (ut[t]) return ut[t];
        var h;
        if (t === "k256")
          h = new lt();
        else if (t === "p224")
          h = new vt();
        else if (t === "p192")
          h = new Ye();
        else if (t === "p25519")
          h = new pt();
        else
          throw new Error("Unknown prime " + t);
        return ut[t] = h, h;
      };
      function bt(Se) {
        if (typeof Se == "string") {
          var t = H._prime(Se);
          this.m = t.p, this.prime = t;
        } else
          J(Se.gtn(1), "modulus must be greater than 1"), this.m = Se, this.prime = null;
      }
      bt.prototype._verify1 = function(t) {
        J(t.negative === 0, "red works only with positives"), J(t.red, "red works only with red numbers");
      }, bt.prototype._verify2 = function(t, h) {
        J((t.negative | h.negative) === 0, "red works only with positives"), J(
          t.red && t.red === h.red,
          "red works only with red numbers"
        );
      }, bt.prototype.imod = function(t) {
        return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
      }, bt.prototype.neg = function(t) {
        return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
      }, bt.prototype.add = function(t, h) {
        this._verify2(t, h);
        var B = t.add(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B._forceRed(this);
      }, bt.prototype.iadd = function(t, h) {
        this._verify2(t, h);
        var B = t.iadd(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B;
      }, bt.prototype.sub = function(t, h) {
        this._verify2(t, h);
        var B = t.sub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B._forceRed(this);
      }, bt.prototype.isub = function(t, h) {
        this._verify2(t, h);
        var B = t.isub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B;
      }, bt.prototype.shl = function(t, h) {
        return this._verify1(t), this.imod(t.ushln(h));
      }, bt.prototype.imul = function(t, h) {
        return this._verify2(t, h), this.imod(t.imul(h));
      }, bt.prototype.mul = function(t, h) {
        return this._verify2(t, h), this.imod(t.mul(h));
      }, bt.prototype.isqr = function(t) {
        return this.imul(t, t.clone());
      }, bt.prototype.sqr = function(t) {
        return this.mul(t, t);
      }, bt.prototype.sqrt = function(t) {
        if (t.isZero()) return t.clone();
        var h = this.m.andln(3);
        if (J(h % 2 === 1), h === 3) {
          var B = this.m.add(new H(1)).iushrn(2);
          return this.pow(t, B);
        }
        for (var Z = this.m.subn(1), ve = 0; !Z.isZero() && Z.andln(1) === 0; )
          ve++, Z.iushrn(1);
        J(!Z.isZero());
        var ge = new H(1).toRed(this), xe = ge.redNeg(), X = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new H(2 * a * a).toRed(this); this.pow(a, X).cmp(xe) !== 0; )
          a.redIAdd(xe);
        for (var Y = this.pow(a, Z), Ne = this.pow(t, Z.addn(1).iushrn(1)), Ke = this.pow(t, Z), tt = ve; Ke.cmp(ge) !== 0; ) {
          for (var We = Ke, ot = 0; We.cmp(ge) !== 0; ot++)
            We = We.redSqr();
          J(ot < tt);
          var He = this.pow(Y, new H(1).iushln(tt - ot - 1));
          Ne = Ne.redMul(He), Y = He.redSqr(), Ke = Ke.redMul(Y), tt = ot;
        }
        return Ne;
      }, bt.prototype.invm = function(t) {
        var h = t._invmp(this.m);
        return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
      }, bt.prototype.pow = function(t, h) {
        if (h.isZero()) return new H(1).toRed(this);
        if (h.cmpn(1) === 0) return t.clone();
        var B = 4, Z = new Array(1 << B);
        Z[0] = new H(1).toRed(this), Z[1] = t;
        for (var ve = 2; ve < Z.length; ve++)
          Z[ve] = this.mul(Z[ve - 1], t);
        var ge = Z[0], xe = 0, X = 0, a = h.bitLength() % 26;
        for (a === 0 && (a = 26), ve = h.length - 1; ve >= 0; ve--) {
          for (var Y = h.words[ve], Ne = a - 1; Ne >= 0; Ne--) {
            var Ke = Y >> Ne & 1;
            if (ge !== Z[0] && (ge = this.sqr(ge)), Ke === 0 && xe === 0) {
              X = 0;
              continue;
            }
            xe <<= 1, xe |= Ke, X++, !(X !== B && (ve !== 0 || Ne !== 0)) && (ge = this.mul(ge, Z[xe]), X = 0, xe = 0);
          }
          a = 26;
        }
        return ge;
      }, bt.prototype.convertTo = function(t) {
        var h = t.umod(this.m);
        return h === t ? h.clone() : h;
      }, bt.prototype.convertFrom = function(t) {
        var h = t.clone();
        return h.red = null, h;
      }, H.mont = function(t) {
        return new Yt(t);
      };
      function Yt(Se) {
        bt.call(this, Se), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      _e(Yt, bt), Yt.prototype.convertTo = function(t) {
        return this.imod(t.ushln(this.shift));
      }, Yt.prototype.convertFrom = function(t) {
        var h = this.imod(t.mul(this.rinv));
        return h.red = null, h;
      }, Yt.prototype.imul = function(t, h) {
        if (t.isZero() || h.isZero())
          return t.words[0] = 0, t.length = 1, t;
        var B = t.imul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.mul = function(t, h) {
        if (t.isZero() || h.isZero()) return new H(0)._forceRed(this);
        var B = t.mul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.invm = function(t) {
        var h = this.imod(t._invmp(this.m).mul(this.r2));
        return h._forceRed(this);
      };
    })(I, commonjsGlobal);
  }(bn$6)), bn$6.exports;
}
var bn$5 = { exports: {} };
bn$5.exports;
var hasRequiredBn$4;
function requireBn$4() {
  return hasRequiredBn$4 || (hasRequiredBn$4 = 1, function(I) {
    (function(A, G) {
      function J(Se, t) {
        if (!Se) throw new Error(t || "Assertion failed");
      }
      function _e(Se, t) {
        Se.super_ = t;
        var h = function() {
        };
        h.prototype = t.prototype, Se.prototype = new h(), Se.prototype.constructor = Se;
      }
      function H(Se, t, h) {
        if (H.isBN(Se))
          return Se;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Se !== null && ((t === "le" || t === "be") && (h = t, t = 10), this._init(Se || 0, t || 10, h || "be"));
      }
      typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
      var De;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = require$$0$3.Buffer;
      } catch {
      }
      H.isBN = function(t) {
        return t instanceof H ? !0 : t !== null && typeof t == "object" && t.constructor.wordSize === H.wordSize && Array.isArray(t.words);
      }, H.max = function(t, h) {
        return t.cmp(h) > 0 ? t : h;
      }, H.min = function(t, h) {
        return t.cmp(h) < 0 ? t : h;
      }, H.prototype._init = function(t, h, B) {
        if (typeof t == "number")
          return this._initNumber(t, h, B);
        if (typeof t == "object")
          return this._initArray(t, h, B);
        h === "hex" && (h = 16), J(h === (h | 0) && h >= 2 && h <= 36), t = t.toString().replace(/\s+/g, "");
        var Z = 0;
        t[0] === "-" && (Z++, this.negative = 1), Z < t.length && (h === 16 ? this._parseHex(t, Z, B) : (this._parseBase(t, h, Z), B === "le" && this._initArray(this.toArray(), h, B)));
      }, H.prototype._initNumber = function(t, h, B) {
        t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [t & 67108863], this.length = 1) : t < 4503599627370496 ? (this.words = [
          t & 67108863,
          t / 67108864 & 67108863
        ], this.length = 2) : (J(t < 9007199254740992), this.words = [
          t & 67108863,
          t / 67108864 & 67108863,
          1
        ], this.length = 3), B === "le" && this._initArray(this.toArray(), h, B);
      }, H.prototype._initArray = function(t, h, B) {
        if (J(typeof t.length == "number"), t.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve, ge, xe = 0;
        if (B === "be")
          for (Z = t.length - 1, ve = 0; Z >= 0; Z -= 3)
            ge = t[Z] | t[Z - 1] << 8 | t[Z - 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        else if (B === "le")
          for (Z = 0, ve = 0; Z < t.length; Z += 3)
            ge = t[Z] | t[Z + 1] << 8 | t[Z + 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        return this.strip();
      };
      function Ie(Se, t) {
        var h = Se.charCodeAt(t);
        return h >= 65 && h <= 70 ? h - 55 : h >= 97 && h <= 102 ? h - 87 : h - 48 & 15;
      }
      function qe(Se, t, h) {
        var B = Ie(Se, h);
        return h - 1 >= t && (B |= Ie(Se, h - 1) << 4), B;
      }
      H.prototype._parseHex = function(t, h, B) {
        this.length = Math.ceil((t.length - h) / 6), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve = 0, ge = 0, xe;
        if (B === "be")
          for (Z = t.length - 1; Z >= h; Z -= 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        else {
          var X = t.length - h;
          for (Z = X % 2 === 0 ? h + 1 : h; Z < t.length; Z += 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        }
        this.strip();
      };
      function Te(Se, t, h, B) {
        for (var Z = 0, ve = Math.min(Se.length, h), ge = t; ge < ve; ge++) {
          var xe = Se.charCodeAt(ge) - 48;
          Z *= B, xe >= 49 ? Z += xe - 49 + 10 : xe >= 17 ? Z += xe - 17 + 10 : Z += xe;
        }
        return Z;
      }
      H.prototype._parseBase = function(t, h, B) {
        this.words = [0], this.length = 1;
        for (var Z = 0, ve = 1; ve <= 67108863; ve *= h)
          Z++;
        Z--, ve = ve / h | 0;
        for (var ge = t.length - B, xe = ge % Z, X = Math.min(ge, ge - xe) + B, a = 0, Y = B; Y < X; Y += Z)
          a = Te(t, Y, Y + Z, h), this.imuln(ve), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (xe !== 0) {
          var Ne = 1;
          for (a = Te(t, Y, t.length, h), Y = 0; Y < xe; Y++)
            Ne *= h;
          this.imuln(Ne), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, H.prototype.copy = function(t) {
        t.words = new Array(this.length);
        for (var h = 0; h < this.length; h++)
          t.words[h] = this.words[h];
        t.length = this.length, t.negative = this.negative, t.red = this.red;
      }, H.prototype.clone = function() {
        var t = new H(null);
        return this.copy(t), t;
      }, H.prototype._expand = function(t) {
        for (; this.length < t; )
          this.words[this.length++] = 0;
        return this;
      }, H.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, H.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, H.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var Ee = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Oe = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Le = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      H.prototype.toString = function(t, h) {
        t = t || 10, h = h | 0 || 1;
        var B;
        if (t === 16 || t === "hex") {
          B = "";
          for (var Z = 0, ve = 0, ge = 0; ge < this.length; ge++) {
            var xe = this.words[ge], X = ((xe << Z | ve) & 16777215).toString(16);
            ve = xe >>> 24 - Z & 16777215, ve !== 0 || ge !== this.length - 1 ? B = Ee[6 - X.length] + X + B : B = X + B, Z += 2, Z >= 26 && (Z -= 26, ge--);
          }
          for (ve !== 0 && (B = ve.toString(16) + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        if (t === (t | 0) && t >= 2 && t <= 36) {
          var a = Oe[t], Y = Le[t];
          B = "";
          var Ne = this.clone();
          for (Ne.negative = 0; !Ne.isZero(); ) {
            var Ke = Ne.modn(Y).toString(t);
            Ne = Ne.idivn(Y), Ne.isZero() ? B = Ke + B : B = Ee[a - Ke.length] + Ke + B;
          }
          for (this.isZero() && (B = "0" + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        J(!1, "Base should be between 2 and 36");
      }, H.prototype.toNumber = function() {
        var t = this.words[0];
        return this.length === 2 ? t += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? t += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -t : t;
      }, H.prototype.toJSON = function() {
        return this.toString(16);
      }, H.prototype.toBuffer = function(t, h) {
        return J(typeof De < "u"), this.toArrayLike(De, t, h);
      }, H.prototype.toArray = function(t, h) {
        return this.toArrayLike(Array, t, h);
      }, H.prototype.toArrayLike = function(t, h, B) {
        var Z = this.byteLength(), ve = B || Math.max(1, Z);
        J(Z <= ve, "byte array longer than desired length"), J(ve > 0, "Requested array length <= 0"), this.strip();
        var ge = h === "le", xe = new t(ve), X, a, Y = this.clone();
        if (ge) {
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[a] = X;
          for (; a < ve; a++)
            xe[a] = 0;
        } else {
          for (a = 0; a < ve - Z; a++)
            xe[a] = 0;
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[ve - a - 1] = X;
        }
        return xe;
      }, Math.clz32 ? H.prototype._countBits = function(t) {
        return 32 - Math.clz32(t);
      } : H.prototype._countBits = function(t) {
        var h = t, B = 0;
        return h >= 4096 && (B += 13, h >>>= 13), h >= 64 && (B += 7, h >>>= 7), h >= 8 && (B += 4, h >>>= 4), h >= 2 && (B += 2, h >>>= 2), B + h;
      }, H.prototype._zeroBits = function(t) {
        if (t === 0) return 26;
        var h = t, B = 0;
        return h & 8191 || (B += 13, h >>>= 13), h & 127 || (B += 7, h >>>= 7), h & 15 || (B += 4, h >>>= 4), h & 3 || (B += 2, h >>>= 2), h & 1 || B++, B;
      }, H.prototype.bitLength = function() {
        var t = this.words[this.length - 1], h = this._countBits(t);
        return (this.length - 1) * 26 + h;
      };
      function ke(Se) {
        for (var t = new Array(Se.bitLength()), h = 0; h < t.length; h++) {
          var B = h / 26 | 0, Z = h % 26;
          t[h] = (Se.words[B] & 1 << Z) >>> Z;
        }
        return t;
      }
      H.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var t = 0, h = 0; h < this.length; h++) {
          var B = this._zeroBits(this.words[h]);
          if (t += B, B !== 26) break;
        }
        return t;
      }, H.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, H.prototype.toTwos = function(t) {
        return this.negative !== 0 ? this.abs().inotn(t).iaddn(1) : this.clone();
      }, H.prototype.fromTwos = function(t) {
        return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
      }, H.prototype.isNeg = function() {
        return this.negative !== 0;
      }, H.prototype.neg = function() {
        return this.clone().ineg();
      }, H.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, H.prototype.iuor = function(t) {
        for (; this.length < t.length; )
          this.words[this.length++] = 0;
        for (var h = 0; h < t.length; h++)
          this.words[h] = this.words[h] | t.words[h];
        return this.strip();
      }, H.prototype.ior = function(t) {
        return J((this.negative | t.negative) === 0), this.iuor(t);
      }, H.prototype.or = function(t) {
        return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
      }, H.prototype.uor = function(t) {
        return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
      }, H.prototype.iuand = function(t) {
        var h;
        this.length > t.length ? h = t : h = this;
        for (var B = 0; B < h.length; B++)
          this.words[B] = this.words[B] & t.words[B];
        return this.length = h.length, this.strip();
      }, H.prototype.iand = function(t) {
        return J((this.negative | t.negative) === 0), this.iuand(t);
      }, H.prototype.and = function(t) {
        return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
      }, H.prototype.uand = function(t) {
        return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
      }, H.prototype.iuxor = function(t) {
        var h, B;
        this.length > t.length ? (h = this, B = t) : (h = t, B = this);
        for (var Z = 0; Z < B.length; Z++)
          this.words[Z] = h.words[Z] ^ B.words[Z];
        if (this !== h)
          for (; Z < h.length; Z++)
            this.words[Z] = h.words[Z];
        return this.length = h.length, this.strip();
      }, H.prototype.ixor = function(t) {
        return J((this.negative | t.negative) === 0), this.iuxor(t);
      }, H.prototype.xor = function(t) {
        return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
      }, H.prototype.uxor = function(t) {
        return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
      }, H.prototype.inotn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = Math.ceil(t / 26) | 0, B = t % 26;
        this._expand(h), B > 0 && h--;
        for (var Z = 0; Z < h; Z++)
          this.words[Z] = ~this.words[Z] & 67108863;
        return B > 0 && (this.words[Z] = ~this.words[Z] & 67108863 >> 26 - B), this.strip();
      }, H.prototype.notn = function(t) {
        return this.clone().inotn(t);
      }, H.prototype.setn = function(t, h) {
        J(typeof t == "number" && t >= 0);
        var B = t / 26 | 0, Z = t % 26;
        return this._expand(B + 1), h ? this.words[B] = this.words[B] | 1 << Z : this.words[B] = this.words[B] & ~(1 << Z), this.strip();
      }, H.prototype.iadd = function(t) {
        var h;
        if (this.negative !== 0 && t.negative === 0)
          return this.negative = 0, h = this.isub(t), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && t.negative !== 0)
          return t.negative = 0, h = this.isub(t), t.negative = 1, h._normSign();
        var B, Z;
        this.length > t.length ? (B = this, Z = t) : (B = t, Z = this);
        for (var ve = 0, ge = 0; ge < Z.length; ge++)
          h = (B.words[ge] | 0) + (Z.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        for (; ve !== 0 && ge < B.length; ge++)
          h = (B.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        if (this.length = B.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (B !== this)
          for (; ge < B.length; ge++)
            this.words[ge] = B.words[ge];
        return this;
      }, H.prototype.add = function(t) {
        var h;
        return t.negative !== 0 && this.negative === 0 ? (t.negative = 0, h = this.sub(t), t.negative ^= 1, h) : t.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = t.sub(this), this.negative = 1, h) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
      }, H.prototype.isub = function(t) {
        if (t.negative !== 0) {
          t.negative = 0;
          var h = this.iadd(t);
          return t.negative = 1, h._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
        var B = this.cmp(t);
        if (B === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Z, ve;
        B > 0 ? (Z = this, ve = t) : (Z = t, ve = this);
        for (var ge = 0, xe = 0; xe < ve.length; xe++)
          h = (Z.words[xe] | 0) - (ve.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        for (; ge !== 0 && xe < Z.length; xe++)
          h = (Z.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        if (ge === 0 && xe < Z.length && Z !== this)
          for (; xe < Z.length; xe++)
            this.words[xe] = Z.words[xe];
        return this.length = Math.max(this.length, xe), Z !== this && (this.negative = 1), this.strip();
      }, H.prototype.sub = function(t) {
        return this.clone().isub(t);
      };
      function Fe(Se, t, h) {
        h.negative = t.negative ^ Se.negative;
        var B = Se.length + t.length | 0;
        h.length = B, B = B - 1 | 0;
        var Z = Se.words[0] | 0, ve = t.words[0] | 0, ge = Z * ve, xe = ge & 67108863, X = ge / 67108864 | 0;
        h.words[0] = xe;
        for (var a = 1; a < B; a++) {
          for (var Y = X >>> 26, Ne = X & 67108863, Ke = Math.min(a, t.length - 1), tt = Math.max(0, a - Se.length + 1); tt <= Ke; tt++) {
            var We = a - tt | 0;
            Z = Se.words[We] | 0, ve = t.words[tt] | 0, ge = Z * ve + Ne, Y += ge / 67108864 | 0, Ne = ge & 67108863;
          }
          h.words[a] = Ne | 0, X = Y | 0;
        }
        return X !== 0 ? h.words[a] = X | 0 : h.length--, h.strip();
      }
      var Ge = function(t, h, B) {
        var Z = t.words, ve = h.words, ge = B.words, xe = 0, X, a, Y, Ne = Z[0] | 0, Ke = Ne & 8191, tt = Ne >>> 13, We = Z[1] | 0, ot = We & 8191, He = We >>> 13, Qe = Z[2] | 0, nt = Qe & 8191, je = Qe >>> 13, it = Z[3] | 0, st = it & 8191, gt = it >>> 13, It = Z[4] | 0, At = It & 8191, Et = It >>> 13, ei = Z[5] | 0, Xt = ei & 8191, _t = ei >>> 13, ni = Z[6] | 0, Ct = ni & 8191, Wt = ni >>> 13, ii = Z[7] | 0, Pt = ii & 8191, Rt = ii >>> 13, ai = Z[8] | 0, Nt = ai & 8191, qt = ai >>> 13, oi = Z[9] | 0, ct = oi & 8191, Ze = oi >>> 13, at = ve[0] | 0, dt = at & 8191, yt = at >>> 13, St = ve[1] | 0, xt = St & 8191, Vt = St >>> 13, ci = ve[2] | 0, Qt = ci & 8191, rr = ci >>> 13, ui = ve[3] | 0, Gr = ui & 8191, yr = ui >>> 13, pi = ve[4] | 0, wr = pi & 8191, _r = pi >>> 13, di = ve[5] | 0, Sr = di & 8191, Br = di >>> 13, vi = ve[6] | 0, gr = vi & 8191, $r = vi >>> 13, li = ve[7] | 0, Ir = li & 8191, Cr = li >>> 13, mi = ve[8] | 0, Pr = mi & 8191, Or = mi >>> 13, yi = ve[9] | 0, Zr = yi & 8191, Vr = yi >>> 13;
        B.negative = t.negative ^ h.negative, B.length = 19, X = Math.imul(Ke, dt), a = Math.imul(Ke, yt), a = a + Math.imul(tt, dt) | 0, Y = Math.imul(tt, yt);
        var bi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, X = Math.imul(ot, dt), a = Math.imul(ot, yt), a = a + Math.imul(He, dt) | 0, Y = Math.imul(He, yt), X = X + Math.imul(Ke, xt) | 0, a = a + Math.imul(Ke, Vt) | 0, a = a + Math.imul(tt, xt) | 0, Y = Y + Math.imul(tt, Vt) | 0;
        var Ai = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, X = Math.imul(nt, dt), a = Math.imul(nt, yt), a = a + Math.imul(je, dt) | 0, Y = Math.imul(je, yt), X = X + Math.imul(ot, xt) | 0, a = a + Math.imul(ot, Vt) | 0, a = a + Math.imul(He, xt) | 0, Y = Y + Math.imul(He, Vt) | 0, X = X + Math.imul(Ke, Qt) | 0, a = a + Math.imul(Ke, rr) | 0, a = a + Math.imul(tt, Qt) | 0, Y = Y + Math.imul(tt, rr) | 0;
        var Zi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, X = Math.imul(st, dt), a = Math.imul(st, yt), a = a + Math.imul(gt, dt) | 0, Y = Math.imul(gt, yt), X = X + Math.imul(nt, xt) | 0, a = a + Math.imul(nt, Vt) | 0, a = a + Math.imul(je, xt) | 0, Y = Y + Math.imul(je, Vt) | 0, X = X + Math.imul(ot, Qt) | 0, a = a + Math.imul(ot, rr) | 0, a = a + Math.imul(He, Qt) | 0, Y = Y + Math.imul(He, rr) | 0, X = X + Math.imul(Ke, Gr) | 0, a = a + Math.imul(Ke, yr) | 0, a = a + Math.imul(tt, Gr) | 0, Y = Y + Math.imul(tt, yr) | 0;
        var Ji = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, X = Math.imul(At, dt), a = Math.imul(At, yt), a = a + Math.imul(Et, dt) | 0, Y = Math.imul(Et, yt), X = X + Math.imul(st, xt) | 0, a = a + Math.imul(st, Vt) | 0, a = a + Math.imul(gt, xt) | 0, Y = Y + Math.imul(gt, Vt) | 0, X = X + Math.imul(nt, Qt) | 0, a = a + Math.imul(nt, rr) | 0, a = a + Math.imul(je, Qt) | 0, Y = Y + Math.imul(je, rr) | 0, X = X + Math.imul(ot, Gr) | 0, a = a + Math.imul(ot, yr) | 0, a = a + Math.imul(He, Gr) | 0, Y = Y + Math.imul(He, yr) | 0, X = X + Math.imul(Ke, wr) | 0, a = a + Math.imul(Ke, _r) | 0, a = a + Math.imul(tt, wr) | 0, Y = Y + Math.imul(tt, _r) | 0;
        var Vi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, X = Math.imul(Xt, dt), a = Math.imul(Xt, yt), a = a + Math.imul(_t, dt) | 0, Y = Math.imul(_t, yt), X = X + Math.imul(At, xt) | 0, a = a + Math.imul(At, Vt) | 0, a = a + Math.imul(Et, xt) | 0, Y = Y + Math.imul(Et, Vt) | 0, X = X + Math.imul(st, Qt) | 0, a = a + Math.imul(st, rr) | 0, a = a + Math.imul(gt, Qt) | 0, Y = Y + Math.imul(gt, rr) | 0, X = X + Math.imul(nt, Gr) | 0, a = a + Math.imul(nt, yr) | 0, a = a + Math.imul(je, Gr) | 0, Y = Y + Math.imul(je, yr) | 0, X = X + Math.imul(ot, wr) | 0, a = a + Math.imul(ot, _r) | 0, a = a + Math.imul(He, wr) | 0, Y = Y + Math.imul(He, _r) | 0, X = X + Math.imul(Ke, Sr) | 0, a = a + Math.imul(Ke, Br) | 0, a = a + Math.imul(tt, Sr) | 0, Y = Y + Math.imul(tt, Br) | 0;
        var Yi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, X = Math.imul(Ct, dt), a = Math.imul(Ct, yt), a = a + Math.imul(Wt, dt) | 0, Y = Math.imul(Wt, yt), X = X + Math.imul(Xt, xt) | 0, a = a + Math.imul(Xt, Vt) | 0, a = a + Math.imul(_t, xt) | 0, Y = Y + Math.imul(_t, Vt) | 0, X = X + Math.imul(At, Qt) | 0, a = a + Math.imul(At, rr) | 0, a = a + Math.imul(Et, Qt) | 0, Y = Y + Math.imul(Et, rr) | 0, X = X + Math.imul(st, Gr) | 0, a = a + Math.imul(st, yr) | 0, a = a + Math.imul(gt, Gr) | 0, Y = Y + Math.imul(gt, yr) | 0, X = X + Math.imul(nt, wr) | 0, a = a + Math.imul(nt, _r) | 0, a = a + Math.imul(je, wr) | 0, Y = Y + Math.imul(je, _r) | 0, X = X + Math.imul(ot, Sr) | 0, a = a + Math.imul(ot, Br) | 0, a = a + Math.imul(He, Sr) | 0, Y = Y + Math.imul(He, Br) | 0, X = X + Math.imul(Ke, gr) | 0, a = a + Math.imul(Ke, $r) | 0, a = a + Math.imul(tt, gr) | 0, Y = Y + Math.imul(tt, $r) | 0;
        var Xi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, X = Math.imul(Pt, dt), a = Math.imul(Pt, yt), a = a + Math.imul(Rt, dt) | 0, Y = Math.imul(Rt, yt), X = X + Math.imul(Ct, xt) | 0, a = a + Math.imul(Ct, Vt) | 0, a = a + Math.imul(Wt, xt) | 0, Y = Y + Math.imul(Wt, Vt) | 0, X = X + Math.imul(Xt, Qt) | 0, a = a + Math.imul(Xt, rr) | 0, a = a + Math.imul(_t, Qt) | 0, Y = Y + Math.imul(_t, rr) | 0, X = X + Math.imul(At, Gr) | 0, a = a + Math.imul(At, yr) | 0, a = a + Math.imul(Et, Gr) | 0, Y = Y + Math.imul(Et, yr) | 0, X = X + Math.imul(st, wr) | 0, a = a + Math.imul(st, _r) | 0, a = a + Math.imul(gt, wr) | 0, Y = Y + Math.imul(gt, _r) | 0, X = X + Math.imul(nt, Sr) | 0, a = a + Math.imul(nt, Br) | 0, a = a + Math.imul(je, Sr) | 0, Y = Y + Math.imul(je, Br) | 0, X = X + Math.imul(ot, gr) | 0, a = a + Math.imul(ot, $r) | 0, a = a + Math.imul(He, gr) | 0, Y = Y + Math.imul(He, $r) | 0, X = X + Math.imul(Ke, Ir) | 0, a = a + Math.imul(Ke, Cr) | 0, a = a + Math.imul(tt, Ir) | 0, Y = Y + Math.imul(tt, Cr) | 0;
        var en = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, X = Math.imul(Nt, dt), a = Math.imul(Nt, yt), a = a + Math.imul(qt, dt) | 0, Y = Math.imul(qt, yt), X = X + Math.imul(Pt, xt) | 0, a = a + Math.imul(Pt, Vt) | 0, a = a + Math.imul(Rt, xt) | 0, Y = Y + Math.imul(Rt, Vt) | 0, X = X + Math.imul(Ct, Qt) | 0, a = a + Math.imul(Ct, rr) | 0, a = a + Math.imul(Wt, Qt) | 0, Y = Y + Math.imul(Wt, rr) | 0, X = X + Math.imul(Xt, Gr) | 0, a = a + Math.imul(Xt, yr) | 0, a = a + Math.imul(_t, Gr) | 0, Y = Y + Math.imul(_t, yr) | 0, X = X + Math.imul(At, wr) | 0, a = a + Math.imul(At, _r) | 0, a = a + Math.imul(Et, wr) | 0, Y = Y + Math.imul(Et, _r) | 0, X = X + Math.imul(st, Sr) | 0, a = a + Math.imul(st, Br) | 0, a = a + Math.imul(gt, Sr) | 0, Y = Y + Math.imul(gt, Br) | 0, X = X + Math.imul(nt, gr) | 0, a = a + Math.imul(nt, $r) | 0, a = a + Math.imul(je, gr) | 0, Y = Y + Math.imul(je, $r) | 0, X = X + Math.imul(ot, Ir) | 0, a = a + Math.imul(ot, Cr) | 0, a = a + Math.imul(He, Ir) | 0, Y = Y + Math.imul(He, Cr) | 0, X = X + Math.imul(Ke, Pr) | 0, a = a + Math.imul(Ke, Or) | 0, a = a + Math.imul(tt, Pr) | 0, Y = Y + Math.imul(tt, Or) | 0;
        var hn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, X = Math.imul(ct, dt), a = Math.imul(ct, yt), a = a + Math.imul(Ze, dt) | 0, Y = Math.imul(Ze, yt), X = X + Math.imul(Nt, xt) | 0, a = a + Math.imul(Nt, Vt) | 0, a = a + Math.imul(qt, xt) | 0, Y = Y + Math.imul(qt, Vt) | 0, X = X + Math.imul(Pt, Qt) | 0, a = a + Math.imul(Pt, rr) | 0, a = a + Math.imul(Rt, Qt) | 0, Y = Y + Math.imul(Rt, rr) | 0, X = X + Math.imul(Ct, Gr) | 0, a = a + Math.imul(Ct, yr) | 0, a = a + Math.imul(Wt, Gr) | 0, Y = Y + Math.imul(Wt, yr) | 0, X = X + Math.imul(Xt, wr) | 0, a = a + Math.imul(Xt, _r) | 0, a = a + Math.imul(_t, wr) | 0, Y = Y + Math.imul(_t, _r) | 0, X = X + Math.imul(At, Sr) | 0, a = a + Math.imul(At, Br) | 0, a = a + Math.imul(Et, Sr) | 0, Y = Y + Math.imul(Et, Br) | 0, X = X + Math.imul(st, gr) | 0, a = a + Math.imul(st, $r) | 0, a = a + Math.imul(gt, gr) | 0, Y = Y + Math.imul(gt, $r) | 0, X = X + Math.imul(nt, Ir) | 0, a = a + Math.imul(nt, Cr) | 0, a = a + Math.imul(je, Ir) | 0, Y = Y + Math.imul(je, Cr) | 0, X = X + Math.imul(ot, Pr) | 0, a = a + Math.imul(ot, Or) | 0, a = a + Math.imul(He, Pr) | 0, Y = Y + Math.imul(He, Or) | 0, X = X + Math.imul(Ke, Zr) | 0, a = a + Math.imul(Ke, Vr) | 0, a = a + Math.imul(tt, Zr) | 0, Y = Y + Math.imul(tt, Vr) | 0;
        var tn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, X = Math.imul(ct, xt), a = Math.imul(ct, Vt), a = a + Math.imul(Ze, xt) | 0, Y = Math.imul(Ze, Vt), X = X + Math.imul(Nt, Qt) | 0, a = a + Math.imul(Nt, rr) | 0, a = a + Math.imul(qt, Qt) | 0, Y = Y + Math.imul(qt, rr) | 0, X = X + Math.imul(Pt, Gr) | 0, a = a + Math.imul(Pt, yr) | 0, a = a + Math.imul(Rt, Gr) | 0, Y = Y + Math.imul(Rt, yr) | 0, X = X + Math.imul(Ct, wr) | 0, a = a + Math.imul(Ct, _r) | 0, a = a + Math.imul(Wt, wr) | 0, Y = Y + Math.imul(Wt, _r) | 0, X = X + Math.imul(Xt, Sr) | 0, a = a + Math.imul(Xt, Br) | 0, a = a + Math.imul(_t, Sr) | 0, Y = Y + Math.imul(_t, Br) | 0, X = X + Math.imul(At, gr) | 0, a = a + Math.imul(At, $r) | 0, a = a + Math.imul(Et, gr) | 0, Y = Y + Math.imul(Et, $r) | 0, X = X + Math.imul(st, Ir) | 0, a = a + Math.imul(st, Cr) | 0, a = a + Math.imul(gt, Ir) | 0, Y = Y + Math.imul(gt, Cr) | 0, X = X + Math.imul(nt, Pr) | 0, a = a + Math.imul(nt, Or) | 0, a = a + Math.imul(je, Pr) | 0, Y = Y + Math.imul(je, Or) | 0, X = X + Math.imul(ot, Zr) | 0, a = a + Math.imul(ot, Vr) | 0, a = a + Math.imul(He, Zr) | 0, Y = Y + Math.imul(He, Vr) | 0;
        var un = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, X = Math.imul(ct, Qt), a = Math.imul(ct, rr), a = a + Math.imul(Ze, Qt) | 0, Y = Math.imul(Ze, rr), X = X + Math.imul(Nt, Gr) | 0, a = a + Math.imul(Nt, yr) | 0, a = a + Math.imul(qt, Gr) | 0, Y = Y + Math.imul(qt, yr) | 0, X = X + Math.imul(Pt, wr) | 0, a = a + Math.imul(Pt, _r) | 0, a = a + Math.imul(Rt, wr) | 0, Y = Y + Math.imul(Rt, _r) | 0, X = X + Math.imul(Ct, Sr) | 0, a = a + Math.imul(Ct, Br) | 0, a = a + Math.imul(Wt, Sr) | 0, Y = Y + Math.imul(Wt, Br) | 0, X = X + Math.imul(Xt, gr) | 0, a = a + Math.imul(Xt, $r) | 0, a = a + Math.imul(_t, gr) | 0, Y = Y + Math.imul(_t, $r) | 0, X = X + Math.imul(At, Ir) | 0, a = a + Math.imul(At, Cr) | 0, a = a + Math.imul(Et, Ir) | 0, Y = Y + Math.imul(Et, Cr) | 0, X = X + Math.imul(st, Pr) | 0, a = a + Math.imul(st, Or) | 0, a = a + Math.imul(gt, Pr) | 0, Y = Y + Math.imul(gt, Or) | 0, X = X + Math.imul(nt, Zr) | 0, a = a + Math.imul(nt, Vr) | 0, a = a + Math.imul(je, Zr) | 0, Y = Y + Math.imul(je, Vr) | 0;
        var cn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, X = Math.imul(ct, Gr), a = Math.imul(ct, yr), a = a + Math.imul(Ze, Gr) | 0, Y = Math.imul(Ze, yr), X = X + Math.imul(Nt, wr) | 0, a = a + Math.imul(Nt, _r) | 0, a = a + Math.imul(qt, wr) | 0, Y = Y + Math.imul(qt, _r) | 0, X = X + Math.imul(Pt, Sr) | 0, a = a + Math.imul(Pt, Br) | 0, a = a + Math.imul(Rt, Sr) | 0, Y = Y + Math.imul(Rt, Br) | 0, X = X + Math.imul(Ct, gr) | 0, a = a + Math.imul(Ct, $r) | 0, a = a + Math.imul(Wt, gr) | 0, Y = Y + Math.imul(Wt, $r) | 0, X = X + Math.imul(Xt, Ir) | 0, a = a + Math.imul(Xt, Cr) | 0, a = a + Math.imul(_t, Ir) | 0, Y = Y + Math.imul(_t, Cr) | 0, X = X + Math.imul(At, Pr) | 0, a = a + Math.imul(At, Or) | 0, a = a + Math.imul(Et, Pr) | 0, Y = Y + Math.imul(Et, Or) | 0, X = X + Math.imul(st, Zr) | 0, a = a + Math.imul(st, Vr) | 0, a = a + Math.imul(gt, Zr) | 0, Y = Y + Math.imul(gt, Vr) | 0;
        var ln = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, X = Math.imul(ct, wr), a = Math.imul(ct, _r), a = a + Math.imul(Ze, wr) | 0, Y = Math.imul(Ze, _r), X = X + Math.imul(Nt, Sr) | 0, a = a + Math.imul(Nt, Br) | 0, a = a + Math.imul(qt, Sr) | 0, Y = Y + Math.imul(qt, Br) | 0, X = X + Math.imul(Pt, gr) | 0, a = a + Math.imul(Pt, $r) | 0, a = a + Math.imul(Rt, gr) | 0, Y = Y + Math.imul(Rt, $r) | 0, X = X + Math.imul(Ct, Ir) | 0, a = a + Math.imul(Ct, Cr) | 0, a = a + Math.imul(Wt, Ir) | 0, Y = Y + Math.imul(Wt, Cr) | 0, X = X + Math.imul(Xt, Pr) | 0, a = a + Math.imul(Xt, Or) | 0, a = a + Math.imul(_t, Pr) | 0, Y = Y + Math.imul(_t, Or) | 0, X = X + Math.imul(At, Zr) | 0, a = a + Math.imul(At, Vr) | 0, a = a + Math.imul(Et, Zr) | 0, Y = Y + Math.imul(Et, Vr) | 0;
        var an = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, X = Math.imul(ct, Sr), a = Math.imul(ct, Br), a = a + Math.imul(Ze, Sr) | 0, Y = Math.imul(Ze, Br), X = X + Math.imul(Nt, gr) | 0, a = a + Math.imul(Nt, $r) | 0, a = a + Math.imul(qt, gr) | 0, Y = Y + Math.imul(qt, $r) | 0, X = X + Math.imul(Pt, Ir) | 0, a = a + Math.imul(Pt, Cr) | 0, a = a + Math.imul(Rt, Ir) | 0, Y = Y + Math.imul(Rt, Cr) | 0, X = X + Math.imul(Ct, Pr) | 0, a = a + Math.imul(Ct, Or) | 0, a = a + Math.imul(Wt, Pr) | 0, Y = Y + Math.imul(Wt, Or) | 0, X = X + Math.imul(Xt, Zr) | 0, a = a + Math.imul(Xt, Vr) | 0, a = a + Math.imul(_t, Zr) | 0, Y = Y + Math.imul(_t, Vr) | 0;
        var fn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, X = Math.imul(ct, gr), a = Math.imul(ct, $r), a = a + Math.imul(Ze, gr) | 0, Y = Math.imul(Ze, $r), X = X + Math.imul(Nt, Ir) | 0, a = a + Math.imul(Nt, Cr) | 0, a = a + Math.imul(qt, Ir) | 0, Y = Y + Math.imul(qt, Cr) | 0, X = X + Math.imul(Pt, Pr) | 0, a = a + Math.imul(Pt, Or) | 0, a = a + Math.imul(Rt, Pr) | 0, Y = Y + Math.imul(Rt, Or) | 0, X = X + Math.imul(Ct, Zr) | 0, a = a + Math.imul(Ct, Vr) | 0, a = a + Math.imul(Wt, Zr) | 0, Y = Y + Math.imul(Wt, Vr) | 0;
        var sn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, X = Math.imul(ct, Ir), a = Math.imul(ct, Cr), a = a + Math.imul(Ze, Ir) | 0, Y = Math.imul(Ze, Cr), X = X + Math.imul(Nt, Pr) | 0, a = a + Math.imul(Nt, Or) | 0, a = a + Math.imul(qt, Pr) | 0, Y = Y + Math.imul(qt, Or) | 0, X = X + Math.imul(Pt, Zr) | 0, a = a + Math.imul(Pt, Vr) | 0, a = a + Math.imul(Rt, Zr) | 0, Y = Y + Math.imul(Rt, Vr) | 0;
        var dn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, X = Math.imul(ct, Pr), a = Math.imul(ct, Or), a = a + Math.imul(Ze, Pr) | 0, Y = Math.imul(Ze, Or), X = X + Math.imul(Nt, Zr) | 0, a = a + Math.imul(Nt, Vr) | 0, a = a + Math.imul(qt, Zr) | 0, Y = Y + Math.imul(qt, Vr) | 0;
        var pn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, X = Math.imul(ct, Zr), a = Math.imul(ct, Vr), a = a + Math.imul(Ze, Zr) | 0, Y = Math.imul(Ze, Vr);
        var vn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        return xe = (Y + (a >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, ge[0] = bi, ge[1] = Ai, ge[2] = Zi, ge[3] = Ji, ge[4] = Vi, ge[5] = Yi, ge[6] = Xi, ge[7] = en, ge[8] = hn, ge[9] = tn, ge[10] = un, ge[11] = cn, ge[12] = ln, ge[13] = an, ge[14] = fn, ge[15] = sn, ge[16] = dn, ge[17] = pn, ge[18] = vn, xe !== 0 && (ge[19] = xe, B.length++), B;
      };
      Math.imul || (Ge = Fe);
      function et(Se, t, h) {
        h.negative = t.negative ^ Se.negative, h.length = Se.length + t.length;
        for (var B = 0, Z = 0, ve = 0; ve < h.length - 1; ve++) {
          var ge = Z;
          Z = 0;
          for (var xe = B & 67108863, X = Math.min(ve, t.length - 1), a = Math.max(0, ve - Se.length + 1); a <= X; a++) {
            var Y = ve - a, Ne = Se.words[Y] | 0, Ke = t.words[a] | 0, tt = Ne * Ke, We = tt & 67108863;
            ge = ge + (tt / 67108864 | 0) | 0, We = We + xe | 0, xe = We & 67108863, ge = ge + (We >>> 26) | 0, Z += ge >>> 26, ge &= 67108863;
          }
          h.words[ve] = xe, B = ge, ge = Z;
        }
        return B !== 0 ? h.words[ve] = B : h.length--, h.strip();
      }
      function Ve(Se, t, h) {
        var B = new Je();
        return B.mulp(Se, t, h);
      }
      H.prototype.mulTo = function(t, h) {
        var B, Z = this.length + t.length;
        return this.length === 10 && t.length === 10 ? B = Ge(this, t, h) : Z < 63 ? B = Fe(this, t, h) : Z < 1024 ? B = et(this, t, h) : B = Ve(this, t, h), B;
      };
      function Je(Se, t) {
        this.x = Se, this.y = t;
      }
      Je.prototype.makeRBT = function(t) {
        for (var h = new Array(t), B = H.prototype._countBits(t) - 1, Z = 0; Z < t; Z++)
          h[Z] = this.revBin(Z, B, t);
        return h;
      }, Je.prototype.revBin = function(t, h, B) {
        if (t === 0 || t === B - 1) return t;
        for (var Z = 0, ve = 0; ve < h; ve++)
          Z |= (t & 1) << h - ve - 1, t >>= 1;
        return Z;
      }, Je.prototype.permute = function(t, h, B, Z, ve, ge) {
        for (var xe = 0; xe < ge; xe++)
          Z[xe] = h[t[xe]], ve[xe] = B[t[xe]];
      }, Je.prototype.transform = function(t, h, B, Z, ve, ge) {
        this.permute(ge, t, h, B, Z, ve);
        for (var xe = 1; xe < ve; xe <<= 1)
          for (var X = xe << 1, a = Math.cos(2 * Math.PI / X), Y = Math.sin(2 * Math.PI / X), Ne = 0; Ne < ve; Ne += X)
            for (var Ke = a, tt = Y, We = 0; We < xe; We++) {
              var ot = B[Ne + We], He = Z[Ne + We], Qe = B[Ne + We + xe], nt = Z[Ne + We + xe], je = Ke * Qe - tt * nt;
              nt = Ke * nt + tt * Qe, Qe = je, B[Ne + We] = ot + Qe, Z[Ne + We] = He + nt, B[Ne + We + xe] = ot - Qe, Z[Ne + We + xe] = He - nt, We !== X && (je = a * Ke - Y * tt, tt = a * tt + Y * Ke, Ke = je);
            }
      }, Je.prototype.guessLen13b = function(t, h) {
        var B = Math.max(h, t) | 1, Z = B & 1, ve = 0;
        for (B = B / 2 | 0; B; B = B >>> 1)
          ve++;
        return 1 << ve + 1 + Z;
      }, Je.prototype.conjugate = function(t, h, B) {
        if (!(B <= 1))
          for (var Z = 0; Z < B / 2; Z++) {
            var ve = t[Z];
            t[Z] = t[B - Z - 1], t[B - Z - 1] = ve, ve = h[Z], h[Z] = -h[B - Z - 1], h[B - Z - 1] = -ve;
          }
      }, Je.prototype.normalize13b = function(t, h) {
        for (var B = 0, Z = 0; Z < h / 2; Z++) {
          var ve = Math.round(t[2 * Z + 1] / h) * 8192 + Math.round(t[2 * Z] / h) + B;
          t[Z] = ve & 67108863, ve < 67108864 ? B = 0 : B = ve / 67108864 | 0;
        }
        return t;
      }, Je.prototype.convert13b = function(t, h, B, Z) {
        for (var ve = 0, ge = 0; ge < h; ge++)
          ve = ve + (t[ge] | 0), B[2 * ge] = ve & 8191, ve = ve >>> 13, B[2 * ge + 1] = ve & 8191, ve = ve >>> 13;
        for (ge = 2 * h; ge < Z; ++ge)
          B[ge] = 0;
        J(ve === 0), J((ve & -8192) === 0);
      }, Je.prototype.stub = function(t) {
        for (var h = new Array(t), B = 0; B < t; B++)
          h[B] = 0;
        return h;
      }, Je.prototype.mulp = function(t, h, B) {
        var Z = 2 * this.guessLen13b(t.length, h.length), ve = this.makeRBT(Z), ge = this.stub(Z), xe = new Array(Z), X = new Array(Z), a = new Array(Z), Y = new Array(Z), Ne = new Array(Z), Ke = new Array(Z), tt = B.words;
        tt.length = Z, this.convert13b(t.words, t.length, xe, Z), this.convert13b(h.words, h.length, Y, Z), this.transform(xe, ge, X, a, Z, ve), this.transform(Y, ge, Ne, Ke, Z, ve);
        for (var We = 0; We < Z; We++) {
          var ot = X[We] * Ne[We] - a[We] * Ke[We];
          a[We] = X[We] * Ke[We] + a[We] * Ne[We], X[We] = ot;
        }
        return this.conjugate(X, a, Z), this.transform(X, a, tt, ge, Z, ve), this.conjugate(tt, ge, Z), this.normalize13b(tt, Z), B.negative = t.negative ^ h.negative, B.length = t.length + h.length, B.strip();
      }, H.prototype.mul = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), this.mulTo(t, h);
      }, H.prototype.mulf = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), Ve(this, t, h);
      }, H.prototype.imul = function(t) {
        return this.clone().mulTo(t, this);
      }, H.prototype.imuln = function(t) {
        J(typeof t == "number"), J(t < 67108864);
        for (var h = 0, B = 0; B < this.length; B++) {
          var Z = (this.words[B] | 0) * t, ve = (Z & 67108863) + (h & 67108863);
          h >>= 26, h += Z / 67108864 | 0, h += ve >>> 26, this.words[B] = ve & 67108863;
        }
        return h !== 0 && (this.words[B] = h, this.length++), this;
      }, H.prototype.muln = function(t) {
        return this.clone().imuln(t);
      }, H.prototype.sqr = function() {
        return this.mul(this);
      }, H.prototype.isqr = function() {
        return this.imul(this.clone());
      }, H.prototype.pow = function(t) {
        var h = ke(t);
        if (h.length === 0) return new H(1);
        for (var B = this, Z = 0; Z < h.length && h[Z] === 0; Z++, B = B.sqr())
          ;
        if (++Z < h.length)
          for (var ve = B.sqr(); Z < h.length; Z++, ve = ve.sqr())
            h[Z] !== 0 && (B = B.mul(ve));
        return B;
      }, H.prototype.iushln = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 67108863 >>> 26 - h << 26 - h, ve;
        if (h !== 0) {
          var ge = 0;
          for (ve = 0; ve < this.length; ve++) {
            var xe = this.words[ve] & Z, X = (this.words[ve] | 0) - xe << h;
            this.words[ve] = X | ge, ge = xe >>> 26 - h;
          }
          ge && (this.words[ve] = ge, this.length++);
        }
        if (B !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + B] = this.words[ve];
          for (ve = 0; ve < B; ve++)
            this.words[ve] = 0;
          this.length += B;
        }
        return this.strip();
      }, H.prototype.ishln = function(t) {
        return J(this.negative === 0), this.iushln(t);
      }, H.prototype.iushrn = function(t, h, B) {
        J(typeof t == "number" && t >= 0);
        var Z;
        h ? Z = (h - h % 26) / 26 : Z = 0;
        var ve = t % 26, ge = Math.min((t - ve) / 26, this.length), xe = 67108863 ^ 67108863 >>> ve << ve, X = B;
        if (Z -= ge, Z = Math.max(0, Z), X) {
          for (var a = 0; a < ge; a++)
            X.words[a] = this.words[a];
          X.length = ge;
        }
        if (ge !== 0) if (this.length > ge)
          for (this.length -= ge, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + ge];
        else
          this.words[0] = 0, this.length = 1;
        var Y = 0;
        for (a = this.length - 1; a >= 0 && (Y !== 0 || a >= Z); a--) {
          var Ne = this.words[a] | 0;
          this.words[a] = Y << 26 - ve | Ne >>> ve, Y = Ne & xe;
        }
        return X && Y !== 0 && (X.words[X.length++] = Y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, H.prototype.ishrn = function(t, h, B) {
        return J(this.negative === 0), this.iushrn(t, h, B);
      }, H.prototype.shln = function(t) {
        return this.clone().ishln(t);
      }, H.prototype.ushln = function(t) {
        return this.clone().iushln(t);
      }, H.prototype.shrn = function(t) {
        return this.clone().ishrn(t);
      }, H.prototype.ushrn = function(t) {
        return this.clone().iushrn(t);
      }, H.prototype.testn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B) return !1;
        var ve = this.words[B];
        return !!(ve & Z);
      }, H.prototype.imaskn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26;
        if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= B)
          return this;
        if (h !== 0 && B++, this.length = Math.min(B, this.length), h !== 0) {
          var Z = 67108863 ^ 67108863 >>> h << h;
          this.words[this.length - 1] &= Z;
        }
        return this.strip();
      }, H.prototype.maskn = function(t) {
        return this.clone().imaskn(t);
      }, H.prototype.iaddn = function(t) {
        return J(typeof t == "number"), J(t < 67108864), t < 0 ? this.isubn(-t) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < t ? (this.words[0] = t - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
      }, H.prototype._iaddn = function(t) {
        this.words[0] += t;
        for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
          this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
        return this.length = Math.max(this.length, h + 1), this;
      }, H.prototype.isubn = function(t) {
        if (J(typeof t == "number"), J(t < 67108864), t < 0) return this.iaddn(-t);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(t), this.negative = 1, this;
        if (this.words[0] -= t, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var h = 0; h < this.length && this.words[h] < 0; h++)
            this.words[h] += 67108864, this.words[h + 1] -= 1;
        return this.strip();
      }, H.prototype.addn = function(t) {
        return this.clone().iaddn(t);
      }, H.prototype.subn = function(t) {
        return this.clone().isubn(t);
      }, H.prototype.iabs = function() {
        return this.negative = 0, this;
      }, H.prototype.abs = function() {
        return this.clone().iabs();
      }, H.prototype._ishlnsubmul = function(t, h, B) {
        var Z = t.length + B, ve;
        this._expand(Z);
        var ge, xe = 0;
        for (ve = 0; ve < t.length; ve++) {
          ge = (this.words[ve + B] | 0) + xe;
          var X = (t.words[ve] | 0) * h;
          ge -= X & 67108863, xe = (ge >> 26) - (X / 67108864 | 0), this.words[ve + B] = ge & 67108863;
        }
        for (; ve < this.length - B; ve++)
          ge = (this.words[ve + B] | 0) + xe, xe = ge >> 26, this.words[ve + B] = ge & 67108863;
        if (xe === 0) return this.strip();
        for (J(xe === -1), xe = 0, ve = 0; ve < this.length; ve++)
          ge = -(this.words[ve] | 0) + xe, xe = ge >> 26, this.words[ve] = ge & 67108863;
        return this.negative = 1, this.strip();
      }, H.prototype._wordDiv = function(t, h) {
        var B = this.length - t.length, Z = this.clone(), ve = t, ge = ve.words[ve.length - 1] | 0, xe = this._countBits(ge);
        B = 26 - xe, B !== 0 && (ve = ve.ushln(B), Z.iushln(B), ge = ve.words[ve.length - 1] | 0);
        var X = Z.length - ve.length, a;
        if (h !== "mod") {
          a = new H(null), a.length = X + 1, a.words = new Array(a.length);
          for (var Y = 0; Y < a.length; Y++)
            a.words[Y] = 0;
        }
        var Ne = Z.clone()._ishlnsubmul(ve, 1, X);
        Ne.negative === 0 && (Z = Ne, a && (a.words[X] = 1));
        for (var Ke = X - 1; Ke >= 0; Ke--) {
          var tt = (Z.words[ve.length + Ke] | 0) * 67108864 + (Z.words[ve.length + Ke - 1] | 0);
          for (tt = Math.min(tt / ge | 0, 67108863), Z._ishlnsubmul(ve, tt, Ke); Z.negative !== 0; )
            tt--, Z.negative = 0, Z._ishlnsubmul(ve, 1, Ke), Z.isZero() || (Z.negative ^= 1);
          a && (a.words[Ke] = tt);
        }
        return a && a.strip(), Z.strip(), h !== "div" && B !== 0 && Z.iushrn(B), {
          div: a || null,
          mod: Z
        };
      }, H.prototype.divmod = function(t, h, B) {
        if (J(!t.isZero()), this.isZero())
          return {
            div: new H(0),
            mod: new H(0)
          };
        var Z, ve, ge;
        return this.negative !== 0 && t.negative === 0 ? (ge = this.neg().divmod(t, h), h !== "mod" && (Z = ge.div.neg()), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.iadd(t)), {
          div: Z,
          mod: ve
        }) : this.negative === 0 && t.negative !== 0 ? (ge = this.divmod(t.neg(), h), h !== "mod" && (Z = ge.div.neg()), {
          div: Z,
          mod: ge.mod
        }) : this.negative & t.negative ? (ge = this.neg().divmod(t.neg(), h), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.isub(t)), {
          div: ge.div,
          mod: ve
        }) : t.length > this.length || this.cmp(t) < 0 ? {
          div: new H(0),
          mod: this
        } : t.length === 1 ? h === "div" ? {
          div: this.divn(t.words[0]),
          mod: null
        } : h === "mod" ? {
          div: null,
          mod: new H(this.modn(t.words[0]))
        } : {
          div: this.divn(t.words[0]),
          mod: new H(this.modn(t.words[0]))
        } : this._wordDiv(t, h);
      }, H.prototype.div = function(t) {
        return this.divmod(t, "div", !1).div;
      }, H.prototype.mod = function(t) {
        return this.divmod(t, "mod", !1).mod;
      }, H.prototype.umod = function(t) {
        return this.divmod(t, "mod", !0).mod;
      }, H.prototype.divRound = function(t) {
        var h = this.divmod(t);
        if (h.mod.isZero()) return h.div;
        var B = h.div.negative !== 0 ? h.mod.isub(t) : h.mod, Z = t.ushrn(1), ve = t.andln(1), ge = B.cmp(Z);
        return ge < 0 || ve === 1 && ge === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
      }, H.prototype.modn = function(t) {
        J(t <= 67108863);
        for (var h = (1 << 26) % t, B = 0, Z = this.length - 1; Z >= 0; Z--)
          B = (h * B + (this.words[Z] | 0)) % t;
        return B;
      }, H.prototype.idivn = function(t) {
        J(t <= 67108863);
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = (this.words[B] | 0) + h * 67108864;
          this.words[B] = Z / t | 0, h = Z % t;
        }
        return this.strip();
      }, H.prototype.divn = function(t) {
        return this.clone().idivn(t);
      }, H.prototype.egcd = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = new H(0), xe = new H(1), X = 0; h.isEven() && B.isEven(); )
          h.iushrn(1), B.iushrn(1), ++X;
        for (var a = B.clone(), Y = h.clone(); !h.isZero(); ) {
          for (var Ne = 0, Ke = 1; !(h.words[0] & Ke) && Ne < 26; ++Ne, Ke <<= 1) ;
          if (Ne > 0)
            for (h.iushrn(Ne); Ne-- > 0; )
              (Z.isOdd() || ve.isOdd()) && (Z.iadd(a), ve.isub(Y)), Z.iushrn(1), ve.iushrn(1);
          for (var tt = 0, We = 1; !(B.words[0] & We) && tt < 26; ++tt, We <<= 1) ;
          if (tt > 0)
            for (B.iushrn(tt); tt-- > 0; )
              (ge.isOdd() || xe.isOdd()) && (ge.iadd(a), xe.isub(Y)), ge.iushrn(1), xe.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ge), ve.isub(xe)) : (B.isub(h), ge.isub(Z), xe.isub(ve));
        }
        return {
          a: ge,
          b: xe,
          gcd: B.iushln(X)
        };
      }, H.prototype._invmp = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = B.clone(); h.cmpn(1) > 0 && B.cmpn(1) > 0; ) {
          for (var xe = 0, X = 1; !(h.words[0] & X) && xe < 26; ++xe, X <<= 1) ;
          if (xe > 0)
            for (h.iushrn(xe); xe-- > 0; )
              Z.isOdd() && Z.iadd(ge), Z.iushrn(1);
          for (var a = 0, Y = 1; !(B.words[0] & Y) && a < 26; ++a, Y <<= 1) ;
          if (a > 0)
            for (B.iushrn(a); a-- > 0; )
              ve.isOdd() && ve.iadd(ge), ve.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ve)) : (B.isub(h), ve.isub(Z));
        }
        var Ne;
        return h.cmpn(1) === 0 ? Ne = Z : Ne = ve, Ne.cmpn(0) < 0 && Ne.iadd(t), Ne;
      }, H.prototype.gcd = function(t) {
        if (this.isZero()) return t.abs();
        if (t.isZero()) return this.abs();
        var h = this.clone(), B = t.clone();
        h.negative = 0, B.negative = 0;
        for (var Z = 0; h.isEven() && B.isEven(); Z++)
          h.iushrn(1), B.iushrn(1);
        do {
          for (; h.isEven(); )
            h.iushrn(1);
          for (; B.isEven(); )
            B.iushrn(1);
          var ve = h.cmp(B);
          if (ve < 0) {
            var ge = h;
            h = B, B = ge;
          } else if (ve === 0 || B.cmpn(1) === 0)
            break;
          h.isub(B);
        } while (!0);
        return B.iushln(Z);
      }, H.prototype.invm = function(t) {
        return this.egcd(t).a.umod(t);
      }, H.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, H.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, H.prototype.andln = function(t) {
        return this.words[0] & t;
      }, H.prototype.bincn = function(t) {
        J(typeof t == "number");
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B)
          return this._expand(B + 1), this.words[B] |= Z, this;
        for (var ve = Z, ge = B; ve !== 0 && ge < this.length; ge++) {
          var xe = this.words[ge] | 0;
          xe += ve, ve = xe >>> 26, xe &= 67108863, this.words[ge] = xe;
        }
        return ve !== 0 && (this.words[ge] = ve, this.length++), this;
      }, H.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, H.prototype.cmpn = function(t) {
        var h = t < 0;
        if (this.negative !== 0 && !h) return -1;
        if (this.negative === 0 && h) return 1;
        this.strip();
        var B;
        if (this.length > 1)
          B = 1;
        else {
          h && (t = -t), J(t <= 67108863, "Number is too big");
          var Z = this.words[0] | 0;
          B = Z === t ? 0 : Z < t ? -1 : 1;
        }
        return this.negative !== 0 ? -B | 0 : B;
      }, H.prototype.cmp = function(t) {
        if (this.negative !== 0 && t.negative === 0) return -1;
        if (this.negative === 0 && t.negative !== 0) return 1;
        var h = this.ucmp(t);
        return this.negative !== 0 ? -h | 0 : h;
      }, H.prototype.ucmp = function(t) {
        if (this.length > t.length) return 1;
        if (this.length < t.length) return -1;
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = this.words[B] | 0, ve = t.words[B] | 0;
          if (Z !== ve) {
            Z < ve ? h = -1 : Z > ve && (h = 1);
            break;
          }
        }
        return h;
      }, H.prototype.gtn = function(t) {
        return this.cmpn(t) === 1;
      }, H.prototype.gt = function(t) {
        return this.cmp(t) === 1;
      }, H.prototype.gten = function(t) {
        return this.cmpn(t) >= 0;
      }, H.prototype.gte = function(t) {
        return this.cmp(t) >= 0;
      }, H.prototype.ltn = function(t) {
        return this.cmpn(t) === -1;
      }, H.prototype.lt = function(t) {
        return this.cmp(t) === -1;
      }, H.prototype.lten = function(t) {
        return this.cmpn(t) <= 0;
      }, H.prototype.lte = function(t) {
        return this.cmp(t) <= 0;
      }, H.prototype.eqn = function(t) {
        return this.cmpn(t) === 0;
      }, H.prototype.eq = function(t) {
        return this.cmp(t) === 0;
      }, H.red = function(t) {
        return new bt(t);
      }, H.prototype.toRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), t.convertTo(this)._forceRed(t);
      }, H.prototype.fromRed = function() {
        return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, H.prototype._forceRed = function(t) {
        return this.red = t, this;
      }, H.prototype.forceRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), this._forceRed(t);
      }, H.prototype.redAdd = function(t) {
        return J(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
      }, H.prototype.redIAdd = function(t) {
        return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
      }, H.prototype.redSub = function(t) {
        return J(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
      }, H.prototype.redISub = function(t) {
        return J(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
      }, H.prototype.redShl = function(t) {
        return J(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
      }, H.prototype.redMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
      }, H.prototype.redIMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
      }, H.prototype.redSqr = function() {
        return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, H.prototype.redISqr = function() {
        return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, H.prototype.redSqrt = function() {
        return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, H.prototype.redInvm = function() {
        return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, H.prototype.redNeg = function() {
        return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, H.prototype.redPow = function(t) {
        return J(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
      };
      var ut = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function rt(Se, t) {
        this.name = Se, this.p = new H(t, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      rt.prototype._tmp = function() {
        var t = new H(null);
        return t.words = new Array(Math.ceil(this.n / 13)), t;
      }, rt.prototype.ireduce = function(t) {
        var h = t, B;
        do
          this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), B = h.bitLength();
        while (B > this.n);
        var Z = B < this.n ? -1 : h.ucmp(this.p);
        return Z === 0 ? (h.words[0] = 0, h.length = 1) : Z > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
      }, rt.prototype.split = function(t, h) {
        t.iushrn(this.n, 0, h);
      }, rt.prototype.imulK = function(t) {
        return t.imul(this.k);
      };
      function lt() {
        rt.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      _e(lt, rt), lt.prototype.split = function(t, h) {
        for (var B = 4194303, Z = Math.min(t.length, 9), ve = 0; ve < Z; ve++)
          h.words[ve] = t.words[ve];
        if (h.length = Z, t.length <= 9) {
          t.words[0] = 0, t.length = 1;
          return;
        }
        var ge = t.words[9];
        for (h.words[h.length++] = ge & B, ve = 10; ve < t.length; ve++) {
          var xe = t.words[ve] | 0;
          t.words[ve - 10] = (xe & B) << 4 | ge >>> 22, ge = xe;
        }
        ge >>>= 22, t.words[ve - 10] = ge, ge === 0 && t.length > 10 ? t.length -= 10 : t.length -= 9;
      }, lt.prototype.imulK = function(t) {
        t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = t.words[B] | 0;
          h += Z * 977, t.words[B] = h & 67108863, h = Z * 64 + (h / 67108864 | 0);
        }
        return t.words[t.length - 1] === 0 && (t.length--, t.words[t.length - 1] === 0 && t.length--), t;
      };
      function vt() {
        rt.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      _e(vt, rt);
      function Ye() {
        rt.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      _e(Ye, rt);
      function pt() {
        rt.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      _e(pt, rt), pt.prototype.imulK = function(t) {
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = (t.words[B] | 0) * 19 + h, ve = Z & 67108863;
          Z >>>= 26, t.words[B] = ve, h = Z;
        }
        return h !== 0 && (t.words[t.length++] = h), t;
      }, H._prime = function(t) {
        if (ut[t]) return ut[t];
        var h;
        if (t === "k256")
          h = new lt();
        else if (t === "p224")
          h = new vt();
        else if (t === "p192")
          h = new Ye();
        else if (t === "p25519")
          h = new pt();
        else
          throw new Error("Unknown prime " + t);
        return ut[t] = h, h;
      };
      function bt(Se) {
        if (typeof Se == "string") {
          var t = H._prime(Se);
          this.m = t.p, this.prime = t;
        } else
          J(Se.gtn(1), "modulus must be greater than 1"), this.m = Se, this.prime = null;
      }
      bt.prototype._verify1 = function(t) {
        J(t.negative === 0, "red works only with positives"), J(t.red, "red works only with red numbers");
      }, bt.prototype._verify2 = function(t, h) {
        J((t.negative | h.negative) === 0, "red works only with positives"), J(
          t.red && t.red === h.red,
          "red works only with red numbers"
        );
      }, bt.prototype.imod = function(t) {
        return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
      }, bt.prototype.neg = function(t) {
        return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
      }, bt.prototype.add = function(t, h) {
        this._verify2(t, h);
        var B = t.add(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B._forceRed(this);
      }, bt.prototype.iadd = function(t, h) {
        this._verify2(t, h);
        var B = t.iadd(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B;
      }, bt.prototype.sub = function(t, h) {
        this._verify2(t, h);
        var B = t.sub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B._forceRed(this);
      }, bt.prototype.isub = function(t, h) {
        this._verify2(t, h);
        var B = t.isub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B;
      }, bt.prototype.shl = function(t, h) {
        return this._verify1(t), this.imod(t.ushln(h));
      }, bt.prototype.imul = function(t, h) {
        return this._verify2(t, h), this.imod(t.imul(h));
      }, bt.prototype.mul = function(t, h) {
        return this._verify2(t, h), this.imod(t.mul(h));
      }, bt.prototype.isqr = function(t) {
        return this.imul(t, t.clone());
      }, bt.prototype.sqr = function(t) {
        return this.mul(t, t);
      }, bt.prototype.sqrt = function(t) {
        if (t.isZero()) return t.clone();
        var h = this.m.andln(3);
        if (J(h % 2 === 1), h === 3) {
          var B = this.m.add(new H(1)).iushrn(2);
          return this.pow(t, B);
        }
        for (var Z = this.m.subn(1), ve = 0; !Z.isZero() && Z.andln(1) === 0; )
          ve++, Z.iushrn(1);
        J(!Z.isZero());
        var ge = new H(1).toRed(this), xe = ge.redNeg(), X = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new H(2 * a * a).toRed(this); this.pow(a, X).cmp(xe) !== 0; )
          a.redIAdd(xe);
        for (var Y = this.pow(a, Z), Ne = this.pow(t, Z.addn(1).iushrn(1)), Ke = this.pow(t, Z), tt = ve; Ke.cmp(ge) !== 0; ) {
          for (var We = Ke, ot = 0; We.cmp(ge) !== 0; ot++)
            We = We.redSqr();
          J(ot < tt);
          var He = this.pow(Y, new H(1).iushln(tt - ot - 1));
          Ne = Ne.redMul(He), Y = He.redSqr(), Ke = Ke.redMul(Y), tt = ot;
        }
        return Ne;
      }, bt.prototype.invm = function(t) {
        var h = t._invmp(this.m);
        return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
      }, bt.prototype.pow = function(t, h) {
        if (h.isZero()) return new H(1).toRed(this);
        if (h.cmpn(1) === 0) return t.clone();
        var B = 4, Z = new Array(1 << B);
        Z[0] = new H(1).toRed(this), Z[1] = t;
        for (var ve = 2; ve < Z.length; ve++)
          Z[ve] = this.mul(Z[ve - 1], t);
        var ge = Z[0], xe = 0, X = 0, a = h.bitLength() % 26;
        for (a === 0 && (a = 26), ve = h.length - 1; ve >= 0; ve--) {
          for (var Y = h.words[ve], Ne = a - 1; Ne >= 0; Ne--) {
            var Ke = Y >> Ne & 1;
            if (ge !== Z[0] && (ge = this.sqr(ge)), Ke === 0 && xe === 0) {
              X = 0;
              continue;
            }
            xe <<= 1, xe |= Ke, X++, !(X !== B && (ve !== 0 || Ne !== 0)) && (ge = this.mul(ge, Z[xe]), X = 0, xe = 0);
          }
          a = 26;
        }
        return ge;
      }, bt.prototype.convertTo = function(t) {
        var h = t.umod(this.m);
        return h === t ? h.clone() : h;
      }, bt.prototype.convertFrom = function(t) {
        var h = t.clone();
        return h.red = null, h;
      }, H.mont = function(t) {
        return new Yt(t);
      };
      function Yt(Se) {
        bt.call(this, Se), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      _e(Yt, bt), Yt.prototype.convertTo = function(t) {
        return this.imod(t.ushln(this.shift));
      }, Yt.prototype.convertFrom = function(t) {
        var h = this.imod(t.mul(this.rinv));
        return h.red = null, h;
      }, Yt.prototype.imul = function(t, h) {
        if (t.isZero() || h.isZero())
          return t.words[0] = 0, t.length = 1, t;
        var B = t.imul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.mul = function(t, h) {
        if (t.isZero() || h.isZero()) return new H(0)._forceRed(this);
        var B = t.mul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.invm = function(t) {
        var h = this.imod(t._invmp(this.m).mul(this.r2));
        return h._forceRed(this);
      };
    })(I, commonjsGlobal);
  }(bn$5)), bn$5.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand) return brorand.exports;
  hasRequiredBrorand = 1;
  var I;
  brorand.exports = function(_e) {
    return I || (I = new A(null)), I.generate(_e);
  };
  function A(J) {
    this.rand = J;
  }
  if (brorand.exports.Rand = A, A.prototype.generate = function(_e) {
    return this._rand(_e);
  }, A.prototype._rand = function(_e) {
    if (this.rand.getBytes)
      return this.rand.getBytes(_e);
    for (var H = new Uint8Array(_e), De = 0; De < H.length; De++)
      H[De] = this.rand.getByte();
    return H;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? A.prototype._rand = function(_e) {
      var H = new Uint8Array(_e);
      return self.crypto.getRandomValues(H), H;
    } : self.msCrypto && self.msCrypto.getRandomValues ? A.prototype._rand = function(_e) {
      var H = new Uint8Array(_e);
      return self.msCrypto.getRandomValues(H), H;
    } : typeof window == "object" && (A.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var G = requireCryptoBrowserify();
      if (typeof G.randomBytes != "function")
        throw new Error("Not supported");
      A.prototype._rand = function(_e) {
        return G.randomBytes(_e);
      };
    } catch {
    }
  return brorand.exports;
}
var mr$1, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr) return mr$1;
  hasRequiredMr = 1;
  var I = requireBn$4(), A = requireBrorand();
  function G(J) {
    this.rand = J || new A.Rand();
  }
  return mr$1 = G, G.create = function(_e) {
    return new G(_e);
  }, G.prototype._randbelow = function(_e) {
    var H = _e.bitLength(), De = Math.ceil(H / 8);
    do
      var Ie = new I(this.rand.generate(De));
    while (Ie.cmp(_e) >= 0);
    return Ie;
  }, G.prototype._randrange = function(_e, H) {
    var De = H.sub(_e);
    return _e.add(this._randbelow(De));
  }, G.prototype.test = function(_e, H, De) {
    var Ie = _e.bitLength(), qe = I.mont(_e), Te = new I(1).toRed(qe);
    H || (H = Math.max(1, Ie / 48 | 0));
    for (var Ee = _e.subn(1), Oe = 0; !Ee.testn(Oe); Oe++)
      ;
    for (var Le = _e.shrn(Oe), ke = Ee.toRed(qe), Fe = !0; H > 0; H--) {
      var Ge = this._randrange(new I(2), Ee);
      De && De(Ge);
      var et = Ge.toRed(qe).redPow(Le);
      if (!(et.cmp(Te) === 0 || et.cmp(ke) === 0)) {
        for (var Ve = 1; Ve < Oe; Ve++) {
          if (et = et.redSqr(), et.cmp(Te) === 0)
            return !1;
          if (et.cmp(ke) === 0)
            break;
        }
        if (Ve === Oe)
          return !1;
      }
    }
    return Fe;
  }, G.prototype.getDivisor = function(_e, H) {
    var De = _e.bitLength(), Ie = I.mont(_e), qe = new I(1).toRed(Ie);
    H || (H = Math.max(1, De / 48 | 0));
    for (var Te = _e.subn(1), Ee = 0; !Te.testn(Ee); Ee++)
      ;
    for (var Oe = _e.shrn(Ee), Le = Te.toRed(Ie); H > 0; H--) {
      var ke = this._randrange(new I(2), Te), Fe = _e.gcd(ke);
      if (Fe.cmpn(1) !== 0)
        return Fe;
      var Ge = ke.toRed(Ie).redPow(Oe);
      if (!(Ge.cmp(qe) === 0 || Ge.cmp(Le) === 0)) {
        for (var et = 1; et < Ee; et++) {
          if (Ge = Ge.redSqr(), Ge.cmp(qe) === 0)
            return Ge.fromRed().subn(1).gcd(_e);
          if (Ge.cmp(Le) === 0)
            break;
        }
        if (et === Ee)
          return Ge = Ge.redSqr(), Ge.fromRed().subn(1).gcd(_e);
      }
    }
    return !1;
  }, mr$1;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime) return generatePrime;
  hasRequiredGeneratePrime = 1;
  var I = requireBrowser$a();
  generatePrime = et, et.simpleSieve = Fe, et.fermatTest = Ge;
  var A = requireBn$5(), G = new A(24), J = requireMr(), _e = new J(), H = new A(1), De = new A(2), Ie = new A(5);
  new A(16), new A(8);
  var qe = new A(10), Te = new A(3);
  new A(7);
  var Ee = new A(11), Oe = new A(4);
  new A(12);
  var Le = null;
  function ke() {
    if (Le !== null)
      return Le;
    var Ve = 1048576, Je = [];
    Je[0] = 2;
    for (var ut = 1, rt = 3; rt < Ve; rt += 2) {
      for (var lt = Math.ceil(Math.sqrt(rt)), vt = 0; vt < ut && Je[vt] <= lt && rt % Je[vt] !== 0; vt++)
        ;
      ut !== vt && Je[vt] <= lt || (Je[ut++] = rt);
    }
    return Le = Je, Je;
  }
  function Fe(Ve) {
    for (var Je = ke(), ut = 0; ut < Je.length; ut++)
      if (Ve.modn(Je[ut]) === 0)
        return Ve.cmpn(Je[ut]) === 0;
    return !0;
  }
  function Ge(Ve) {
    var Je = A.mont(Ve);
    return De.toRed(Je).redPow(Ve.subn(1)).fromRed().cmpn(1) === 0;
  }
  function et(Ve, Je) {
    if (Ve < 16)
      return Je === 2 || Je === 5 ? new A([140, 123]) : new A([140, 39]);
    Je = new A(Je);
    for (var ut, rt; ; ) {
      for (ut = new A(I(Math.ceil(Ve / 8))); ut.bitLength() > Ve; )
        ut.ishrn(1);
      if (ut.isEven() && ut.iadd(H), ut.testn(1) || ut.iadd(De), Je.cmp(De)) {
        if (!Je.cmp(Ie))
          for (; ut.mod(qe).cmp(Te); )
            ut.iadd(Oe);
      } else for (; ut.mod(G).cmp(Ee); )
        ut.iadd(Oe);
      if (rt = ut.shrn(1), Fe(rt) && Fe(ut) && Ge(rt) && Ge(ut) && _e.test(rt) && _e.test(ut))
        return ut;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "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"
}, require$$1$1 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh) return dh;
  hasRequiredDh = 1;
  var I = requireBn$5(), A = requireMr(), G = new A(), J = new I(24), _e = new I(11), H = new I(10), De = new I(3), Ie = new I(7), qe = requireGeneratePrime(), Te = requireBrowser$a();
  dh = Fe;
  function Ee(et, Ve) {
    return Ve = Ve || "utf8", Buffer$7.isBuffer(et) || (et = new Buffer$7(et, Ve)), this._pub = new I(et), this;
  }
  function Oe(et, Ve) {
    return Ve = Ve || "utf8", Buffer$7.isBuffer(et) || (et = new Buffer$7(et, Ve)), this._priv = new I(et), this;
  }
  var Le = {};
  function ke(et, Ve) {
    var Je = Ve.toString("hex"), ut = [Je, et.toString(16)].join("_");
    if (ut in Le)
      return Le[ut];
    var rt = 0;
    if (et.isEven() || !qe.simpleSieve || !qe.fermatTest(et) || !G.test(et))
      return rt += 1, Je === "02" || Je === "05" ? rt += 8 : rt += 4, Le[ut] = rt, rt;
    G.test(et.shrn(1)) || (rt += 2);
    var lt;
    switch (Je) {
      case "02":
        et.mod(J).cmp(_e) && (rt += 8);
        break;
      case "05":
        lt = et.mod(H), lt.cmp(De) && lt.cmp(Ie) && (rt += 8);
        break;
      default:
        rt += 4;
    }
    return Le[ut] = rt, rt;
  }
  function Fe(et, Ve, Je) {
    this.setGenerator(Ve), this.__prime = new I(et), this._prime = I.mont(this.__prime), this._primeLen = et.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, Je ? (this.setPublicKey = Ee, this.setPrivateKey = Oe) : this._primeCode = 8;
  }
  Object.defineProperty(Fe.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = ke(this.__prime, this.__gen)), this._primeCode;
    }
  }), Fe.prototype.generateKeys = function() {
    return this._priv || (this._priv = new I(Te(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, Fe.prototype.computeSecret = function(et) {
    et = new I(et), et = et.toRed(this._prime);
    var Ve = et.redPow(this._priv).fromRed(), Je = new Buffer$7(Ve.toArray()), ut = this.getPrime();
    if (Je.length < ut.length) {
      var rt = new Buffer$7(ut.length - Je.length);
      rt.fill(0), Je = Buffer$7.concat([rt, Je]);
    }
    return Je;
  }, Fe.prototype.getPublicKey = function(Ve) {
    return Ge(this._pub, Ve);
  }, Fe.prototype.getPrivateKey = function(Ve) {
    return Ge(this._priv, Ve);
  }, Fe.prototype.getPrime = function(et) {
    return Ge(this.__prime, et);
  }, Fe.prototype.getGenerator = function(et) {
    return Ge(this._gen, et);
  }, Fe.prototype.setGenerator = function(et, Ve) {
    return Ve = Ve || "utf8", Buffer$7.isBuffer(et) || (et = new Buffer$7(et, Ve)), this.__gen = et, this._gen = new I(et), this;
  };
  function Ge(et, Ve) {
    var Je = new Buffer$7(et.toArray());
    return Ve ? Je.toString(Ve) : Je;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4) return browser$5;
  hasRequiredBrowser$4 = 1;
  var I = requireGeneratePrime(), A = require$$1$1, G = requireDh();
  function J(De) {
    var Ie = new Buffer$7(A[De].prime, "hex"), qe = new Buffer$7(A[De].gen, "hex");
    return new G(Ie, qe);
  }
  var _e = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function H(De, Ie, qe, Te) {
    return Buffer$7.isBuffer(Ie) || _e[Ie] === void 0 ? H(De, "binary", Ie, qe) : (Ie = Ie || "binary", Te = Te || "binary", qe = qe || new Buffer$7([2]), Buffer$7.isBuffer(qe) || (qe = new Buffer$7(qe, Te)), typeof De == "number" ? new G(I(De, qe), qe, !0) : (Buffer$7.isBuffer(De) || (De = new Buffer$7(De, Ie)), new G(De, qe, !0)));
  }
  return browser$5.DiffieHellmanGroup = browser$5.createDiffieHellmanGroup = browser$5.getDiffieHellman = J, browser$5.createDiffieHellman = browser$5.DiffieHellman = H, browser$5;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} }, hasRequiredProcessNextickArgs;
function requireProcessNextickArgs() {
  if (hasRequiredProcessNextickArgs) return processNextickArgs.exports;
  hasRequiredProcessNextickArgs = 1, typeof process$1 > "u" || !process$1.version || process$1.version.indexOf("v0.") === 0 || process$1.version.indexOf("v1.") === 0 && process$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: I } : processNextickArgs.exports = process$1;
  function I(A, G, J, _e) {
    if (typeof A != "function")
      throw new TypeError('"callback" argument must be a function');
    var H = arguments.length, De, Ie;
    switch (H) {
      case 0:
      case 1:
        return process$1.nextTick(A);
      case 2:
        return process$1.nextTick(function() {
          A.call(null, G);
        });
      case 3:
        return process$1.nextTick(function() {
          A.call(null, G, J);
        });
      case 4:
        return process$1.nextTick(function() {
          A.call(null, G, J, _e);
        });
      default:
        for (De = new Array(H - 1), Ie = 0; Ie < De.length; )
          De[Ie++] = arguments[Ie];
        return process$1.nextTick(function() {
          A.apply(null, De);
        });
    }
  }
  return processNextickArgs.exports;
}
var isarray, hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray) return isarray;
  hasRequiredIsarray = 1;
  var I = {}.toString;
  return isarray = Array.isArray || function(A) {
    return I.call(A) == "[object Array]";
  }, isarray;
}
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = eventsExports.EventEmitter), streamBrowser;
}
var safeBuffer = { exports: {} }, hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(I, A) {
    var G = require$$0$3, J = G.Buffer;
    function _e(De, Ie) {
      for (var qe in De)
        Ie[qe] = De[qe];
    }
    J.from && J.alloc && J.allocUnsafe && J.allocUnsafeSlow ? I.exports = G : (_e(G, A), A.Buffer = H);
    function H(De, Ie, qe) {
      return J(De, Ie, qe);
    }
    _e(J, H), H.from = function(De, Ie, qe) {
      if (typeof De == "number")
        throw new TypeError("Argument must not be a number");
      return J(De, Ie, qe);
    }, H.alloc = function(De, Ie, qe) {
      if (typeof De != "number")
        throw new TypeError("Argument must be a number");
      var Te = J(De);
      return Ie !== void 0 ? typeof qe == "string" ? Te.fill(Ie, qe) : Te.fill(Ie) : Te.fill(0), Te;
    }, H.allocUnsafe = function(De) {
      if (typeof De != "number")
        throw new TypeError("Argument must be a number");
      return J(De);
    }, H.allocUnsafeSlow = function(De) {
      if (typeof De != "number")
        throw new TypeError("Argument must be a number");
      return G.SlowBuffer(De);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var util = {}, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util;
  hasRequiredUtil = 1;
  function I(Ge) {
    return Array.isArray ? Array.isArray(Ge) : Fe(Ge) === "[object Array]";
  }
  util.isArray = I;
  function A(Ge) {
    return typeof Ge == "boolean";
  }
  util.isBoolean = A;
  function G(Ge) {
    return Ge === null;
  }
  util.isNull = G;
  function J(Ge) {
    return Ge == null;
  }
  util.isNullOrUndefined = J;
  function _e(Ge) {
    return typeof Ge == "number";
  }
  util.isNumber = _e;
  function H(Ge) {
    return typeof Ge == "string";
  }
  util.isString = H;
  function De(Ge) {
    return typeof Ge == "symbol";
  }
  util.isSymbol = De;
  function Ie(Ge) {
    return Ge === void 0;
  }
  util.isUndefined = Ie;
  function qe(Ge) {
    return Fe(Ge) === "[object RegExp]";
  }
  util.isRegExp = qe;
  function Te(Ge) {
    return typeof Ge == "object" && Ge !== null;
  }
  util.isObject = Te;
  function Ee(Ge) {
    return Fe(Ge) === "[object Date]";
  }
  util.isDate = Ee;
  function Oe(Ge) {
    return Fe(Ge) === "[object Error]" || Ge instanceof Error;
  }
  util.isError = Oe;
  function Le(Ge) {
    return typeof Ge == "function";
  }
  util.isFunction = Le;
  function ke(Ge) {
    return Ge === null || typeof Ge == "boolean" || typeof Ge == "number" || typeof Ge == "string" || typeof Ge == "symbol" || // ES6 symbol
    typeof Ge > "u";
  }
  util.isPrimitive = ke, util.isBuffer = require$$0$3.Buffer.isBuffer;
  function Fe(Ge) {
    return Object.prototype.toString.call(Ge);
  }
  return util;
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(I) {
    function A(H, De) {
      if (!(H instanceof De))
        throw new TypeError("Cannot call a class as a function");
    }
    var G = requireSafeBuffer().Buffer, J = util$1;
    function _e(H, De, Ie) {
      H.copy(De, Ie);
    }
    I.exports = function() {
      function H() {
        A(this, H), this.head = null, this.tail = null, this.length = 0;
      }
      return H.prototype.push = function(Ie) {
        var qe = { data: Ie, next: null };
        this.length > 0 ? this.tail.next = qe : this.head = qe, this.tail = qe, ++this.length;
      }, H.prototype.unshift = function(Ie) {
        var qe = { data: Ie, next: this.head };
        this.length === 0 && (this.tail = qe), this.head = qe, ++this.length;
      }, H.prototype.shift = function() {
        if (this.length !== 0) {
          var Ie = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, Ie;
        }
      }, H.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, H.prototype.join = function(Ie) {
        if (this.length === 0) return "";
        for (var qe = this.head, Te = "" + qe.data; qe = qe.next; )
          Te += Ie + qe.data;
        return Te;
      }, H.prototype.concat = function(Ie) {
        if (this.length === 0) return G.alloc(0);
        for (var qe = G.allocUnsafe(Ie >>> 0), Te = this.head, Ee = 0; Te; )
          _e(Te.data, qe, Ee), Ee += Te.data.length, Te = Te.next;
        return qe;
      }, H;
    }(), J && J.inspect && J.inspect.custom && (I.exports.prototype[J.inspect.custom] = function() {
      var H = J.inspect({ length: this.length });
      return this.constructor.name + " " + H;
    });
  }(BufferList)), BufferList.exports;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy) return destroy_1;
  hasRequiredDestroy = 1;
  var I = requireProcessNextickArgs();
  function A(_e, H) {
    var De = this, Ie = this._readableState && this._readableState.destroyed, qe = this._writableState && this._writableState.destroyed;
    return Ie || qe ? (H ? H(_e) : _e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, I.nextTick(J, this, _e)) : I.nextTick(J, this, _e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(_e || null, function(Te) {
      !H && Te ? De._writableState ? De._writableState.errorEmitted || (De._writableState.errorEmitted = !0, I.nextTick(J, De, Te)) : I.nextTick(J, De, Te) : H && H(Te);
    }), this);
  }
  function G() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function J(_e, H) {
    _e.emit("error", H);
  }
  return destroy_1 = {
    destroy: A,
    undestroy: G
  }, destroy_1;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable) return _stream_writable;
  hasRequired_stream_writable = 1;
  var I = requireProcessNextickArgs();
  _stream_writable = Ge;
  function A(ge) {
    var xe = this;
    this.next = null, this.entry = null, this.finish = function() {
      ve(xe, ge);
    };
  }
  var G = !process$1.browser && ["v0.10", "v0.9."].indexOf(process$1.version.slice(0, 5)) > -1 ? setImmediate : I.nextTick, J;
  Ge.WritableState = ke;
  var _e = Object.create(requireUtil());
  _e.inherits = inherits_browserExports;
  var H = {
    deprecate: browser$d
  }, De = requireStreamBrowser(), Ie = requireSafeBuffer().Buffer, qe = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function Te(ge) {
    return Ie.from(ge);
  }
  function Ee(ge) {
    return Ie.isBuffer(ge) || ge instanceof qe;
  }
  var Oe = requireDestroy();
  _e.inherits(Ge, De);
  function Le() {
  }
  function ke(ge, xe) {
    J = J || require_stream_duplex(), ge = ge || {};
    var X = xe instanceof J;
    this.objectMode = !!ge.objectMode, X && (this.objectMode = this.objectMode || !!ge.writableObjectMode);
    var a = ge.highWaterMark, Y = ge.writableHighWaterMark, Ne = this.objectMode ? 16 : 16 * 1024;
    a || a === 0 ? this.highWaterMark = a : X && (Y || Y === 0) ? this.highWaterMark = Y : this.highWaterMark = Ne, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Ke = ge.decodeStrings === !1;
    this.decodeStrings = !Ke, this.defaultEncoding = ge.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(tt) {
      Ye(xe, tt);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new A(this);
  }
  ke.prototype.getBuffer = function() {
    for (var xe = this.bufferedRequest, X = []; xe; )
      X.push(xe), xe = xe.next;
    return X;
  }, function() {
    try {
      Object.defineProperty(ke.prototype, "buffer", {
        get: H.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Fe;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Fe = Function.prototype[Symbol.hasInstance], Object.defineProperty(Ge, Symbol.hasInstance, {
    value: function(ge) {
      return Fe.call(this, ge) ? !0 : this !== Ge ? !1 : ge && ge._writableState instanceof ke;
    }
  })) : Fe = function(ge) {
    return ge instanceof this;
  };
  function Ge(ge) {
    if (J = J || require_stream_duplex(), !Fe.call(Ge, this) && !(this instanceof J))
      return new Ge(ge);
    this._writableState = new ke(ge, this), this.writable = !0, ge && (typeof ge.write == "function" && (this._write = ge.write), typeof ge.writev == "function" && (this._writev = ge.writev), typeof ge.destroy == "function" && (this._destroy = ge.destroy), typeof ge.final == "function" && (this._final = ge.final)), De.call(this);
  }
  Ge.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function et(ge, xe) {
    var X = new Error("write after end");
    ge.emit("error", X), I.nextTick(xe, X);
  }
  function Ve(ge, xe, X, a) {
    var Y = !0, Ne = !1;
    return X === null ? Ne = new TypeError("May not write null values to stream") : typeof X != "string" && X !== void 0 && !xe.objectMode && (Ne = new TypeError("Invalid non-string/buffer chunk")), Ne && (ge.emit("error", Ne), I.nextTick(a, Ne), Y = !1), Y;
  }
  Ge.prototype.write = function(ge, xe, X) {
    var a = this._writableState, Y = !1, Ne = !a.objectMode && Ee(ge);
    return Ne && !Ie.isBuffer(ge) && (ge = Te(ge)), typeof xe == "function" && (X = xe, xe = null), Ne ? xe = "buffer" : xe || (xe = a.defaultEncoding), typeof X != "function" && (X = Le), a.ended ? et(this, X) : (Ne || Ve(this, a, ge, X)) && (a.pendingcb++, Y = ut(this, a, Ne, ge, xe, X)), Y;
  }, Ge.prototype.cork = function() {
    var ge = this._writableState;
    ge.corked++;
  }, Ge.prototype.uncork = function() {
    var ge = this._writableState;
    ge.corked && (ge.corked--, !ge.writing && !ge.corked && !ge.bufferProcessing && ge.bufferedRequest && Yt(this, ge));
  }, Ge.prototype.setDefaultEncoding = function(xe) {
    if (typeof xe == "string" && (xe = xe.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((xe + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + xe);
    return this._writableState.defaultEncoding = xe, this;
  };
  function Je(ge, xe, X) {
    return !ge.objectMode && ge.decodeStrings !== !1 && typeof xe == "string" && (xe = Ie.from(xe, X)), xe;
  }
  Object.defineProperty(Ge.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function ut(ge, xe, X, a, Y, Ne) {
    if (!X) {
      var Ke = Je(xe, a, Y);
      a !== Ke && (X = !0, Y = "buffer", a = Ke);
    }
    var tt = xe.objectMode ? 1 : a.length;
    xe.length += tt;
    var We = xe.length < xe.highWaterMark;
    if (We || (xe.needDrain = !0), xe.writing || xe.corked) {
      var ot = xe.lastBufferedRequest;
      xe.lastBufferedRequest = {
        chunk: a,
        encoding: Y,
        isBuf: X,
        callback: Ne,
        next: null
      }, ot ? ot.next = xe.lastBufferedRequest : xe.bufferedRequest = xe.lastBufferedRequest, xe.bufferedRequestCount += 1;
    } else
      rt(ge, xe, !1, tt, a, Y, Ne);
    return We;
  }
  function rt(ge, xe, X, a, Y, Ne, Ke) {
    xe.writelen = a, xe.writecb = Ke, xe.writing = !0, xe.sync = !0, X ? ge._writev(Y, xe.onwrite) : ge._write(Y, Ne, xe.onwrite), xe.sync = !1;
  }
  function lt(ge, xe, X, a, Y) {
    --xe.pendingcb, X ? (I.nextTick(Y, a), I.nextTick(B, ge, xe), ge._writableState.errorEmitted = !0, ge.emit("error", a)) : (Y(a), ge._writableState.errorEmitted = !0, ge.emit("error", a), B(ge, xe));
  }
  function vt(ge) {
    ge.writing = !1, ge.writecb = null, ge.length -= ge.writelen, ge.writelen = 0;
  }
  function Ye(ge, xe) {
    var X = ge._writableState, a = X.sync, Y = X.writecb;
    if (vt(X), xe) lt(ge, X, a, xe, Y);
    else {
      var Ne = Se(X);
      !Ne && !X.corked && !X.bufferProcessing && X.bufferedRequest && Yt(ge, X), a ? G(pt, ge, X, Ne, Y) : pt(ge, X, Ne, Y);
    }
  }
  function pt(ge, xe, X, a) {
    X || bt(ge, xe), xe.pendingcb--, a(), B(ge, xe);
  }
  function bt(ge, xe) {
    xe.length === 0 && xe.needDrain && (xe.needDrain = !1, ge.emit("drain"));
  }
  function Yt(ge, xe) {
    xe.bufferProcessing = !0;
    var X = xe.bufferedRequest;
    if (ge._writev && X && X.next) {
      var a = xe.bufferedRequestCount, Y = new Array(a), Ne = xe.corkedRequestsFree;
      Ne.entry = X;
      for (var Ke = 0, tt = !0; X; )
        Y[Ke] = X, X.isBuf || (tt = !1), X = X.next, Ke += 1;
      Y.allBuffers = tt, rt(ge, xe, !0, xe.length, Y, "", Ne.finish), xe.pendingcb++, xe.lastBufferedRequest = null, Ne.next ? (xe.corkedRequestsFree = Ne.next, Ne.next = null) : xe.corkedRequestsFree = new A(xe), xe.bufferedRequestCount = 0;
    } else {
      for (; X; ) {
        var We = X.chunk, ot = X.encoding, He = X.callback, Qe = xe.objectMode ? 1 : We.length;
        if (rt(ge, xe, !1, Qe, We, ot, He), X = X.next, xe.bufferedRequestCount--, xe.writing)
          break;
      }
      X === null && (xe.lastBufferedRequest = null);
    }
    xe.bufferedRequest = X, xe.bufferProcessing = !1;
  }
  Ge.prototype._write = function(ge, xe, X) {
    X(new Error("_write() is not implemented"));
  }, Ge.prototype._writev = null, Ge.prototype.end = function(ge, xe, X) {
    var a = this._writableState;
    typeof ge == "function" ? (X = ge, ge = null, xe = null) : typeof xe == "function" && (X = xe, xe = null), ge != null && this.write(ge, xe), a.corked && (a.corked = 1, this.uncork()), a.ending || Z(this, a, X);
  };
  function Se(ge) {
    return ge.ending && ge.length === 0 && ge.bufferedRequest === null && !ge.finished && !ge.writing;
  }
  function t(ge, xe) {
    ge._final(function(X) {
      xe.pendingcb--, X && ge.emit("error", X), xe.prefinished = !0, ge.emit("prefinish"), B(ge, xe);
    });
  }
  function h(ge, xe) {
    !xe.prefinished && !xe.finalCalled && (typeof ge._final == "function" ? (xe.pendingcb++, xe.finalCalled = !0, I.nextTick(t, ge, xe)) : (xe.prefinished = !0, ge.emit("prefinish")));
  }
  function B(ge, xe) {
    var X = Se(xe);
    return X && (h(ge, xe), xe.pendingcb === 0 && (xe.finished = !0, ge.emit("finish"))), X;
  }
  function Z(ge, xe, X) {
    xe.ending = !0, B(ge, xe), X && (xe.finished ? I.nextTick(X) : ge.once("finish", X)), xe.ended = !0, ge.writable = !1;
  }
  function ve(ge, xe, X) {
    var a = ge.entry;
    for (ge.entry = null; a; ) {
      var Y = a.callback;
      xe.pendingcb--, Y(X), a = a.next;
    }
    xe.corkedRequestsFree.next = ge;
  }
  return Object.defineProperty(Ge.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(ge) {
      this._writableState && (this._writableState.destroyed = ge);
    }
  }), Ge.prototype.destroy = Oe.destroy, Ge.prototype._undestroy = Oe.undestroy, Ge.prototype._destroy = function(ge, xe) {
    this.end(), xe(ge);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex) return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var I = requireProcessNextickArgs(), A = Object.keys || function(Oe) {
    var Le = [];
    for (var ke in Oe)
      Le.push(ke);
    return Le;
  };
  _stream_duplex = qe;
  var G = Object.create(requireUtil());
  G.inherits = inherits_browserExports;
  var J = require_stream_readable(), _e = require_stream_writable();
  G.inherits(qe, J);
  for (var H = A(_e.prototype), De = 0; De < H.length; De++) {
    var Ie = H[De];
    qe.prototype[Ie] || (qe.prototype[Ie] = _e.prototype[Ie]);
  }
  function qe(Oe) {
    if (!(this instanceof qe)) return new qe(Oe);
    J.call(this, Oe), _e.call(this, Oe), Oe && Oe.readable === !1 && (this.readable = !1), Oe && Oe.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, Oe && Oe.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", Te);
  }
  Object.defineProperty(qe.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Te() {
    this.allowHalfOpen || this._writableState.ended || I.nextTick(Ee, this);
  }
  function Ee(Oe) {
    Oe.end();
  }
  return Object.defineProperty(qe.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(Oe) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = Oe, this._writableState.destroyed = Oe);
    }
  }), qe.prototype._destroy = function(Oe, Le) {
    this.push(null), this.end(), I.nextTick(Le, Oe);
  }, _stream_duplex;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable) return _stream_readable;
  hasRequired_stream_readable = 1;
  var I = requireProcessNextickArgs();
  _stream_readable = Je;
  var A = requireIsarray(), G;
  Je.ReadableState = Ve, eventsExports.EventEmitter;
  var J = function(He, Qe) {
    return He.listeners(Qe).length;
  }, _e = requireStreamBrowser(), H = requireSafeBuffer().Buffer, De = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function Ie(He) {
    return H.from(He);
  }
  function qe(He) {
    return H.isBuffer(He) || He instanceof De;
  }
  var Te = Object.create(requireUtil());
  Te.inherits = inherits_browserExports;
  var Ee = util$1, Oe = void 0;
  Ee && Ee.debuglog ? Oe = Ee.debuglog("stream") : Oe = function() {
  };
  var Le = requireBufferList(), ke = requireDestroy(), Fe;
  Te.inherits(Je, _e);
  var Ge = ["error", "close", "destroy", "pause", "resume"];
  function et(He, Qe, nt) {
    if (typeof He.prependListener == "function") return He.prependListener(Qe, nt);
    !He._events || !He._events[Qe] ? He.on(Qe, nt) : A(He._events[Qe]) ? He._events[Qe].unshift(nt) : He._events[Qe] = [nt, He._events[Qe]];
  }
  function Ve(He, Qe) {
    G = G || require_stream_duplex(), He = He || {};
    var nt = Qe instanceof G;
    this.objectMode = !!He.objectMode, nt && (this.objectMode = this.objectMode || !!He.readableObjectMode);
    var je = He.highWaterMark, it = He.readableHighWaterMark, st = this.objectMode ? 16 : 16 * 1024;
    je || je === 0 ? this.highWaterMark = je : nt && (it || it === 0) ? this.highWaterMark = it : this.highWaterMark = st, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new Le(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = He.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, He.encoding && (Fe || (Fe = requireString_decoder().StringDecoder), this.decoder = new Fe(He.encoding), this.encoding = He.encoding);
  }
  function Je(He) {
    if (G = G || require_stream_duplex(), !(this instanceof Je)) return new Je(He);
    this._readableState = new Ve(He, this), this.readable = !0, He && (typeof He.read == "function" && (this._read = He.read), typeof He.destroy == "function" && (this._destroy = He.destroy)), _e.call(this);
  }
  Object.defineProperty(Je.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(He) {
      this._readableState && (this._readableState.destroyed = He);
    }
  }), Je.prototype.destroy = ke.destroy, Je.prototype._undestroy = ke.undestroy, Je.prototype._destroy = function(He, Qe) {
    this.push(null), Qe(He);
  }, Je.prototype.push = function(He, Qe) {
    var nt = this._readableState, je;
    return nt.objectMode ? je = !0 : typeof He == "string" && (Qe = Qe || nt.defaultEncoding, Qe !== nt.encoding && (He = H.from(He, Qe), Qe = ""), je = !0), ut(this, He, Qe, !1, je);
  }, Je.prototype.unshift = function(He) {
    return ut(this, He, null, !0, !1);
  };
  function ut(He, Qe, nt, je, it) {
    var st = He._readableState;
    if (Qe === null)
      st.reading = !1, Yt(He, st);
    else {
      var gt;
      it || (gt = lt(st, Qe)), gt ? He.emit("error", gt) : st.objectMode || Qe && Qe.length > 0 ? (typeof Qe != "string" && !st.objectMode && Object.getPrototypeOf(Qe) !== H.prototype && (Qe = Ie(Qe)), je ? st.endEmitted ? He.emit("error", new Error("stream.unshift() after end event")) : rt(He, st, Qe, !0) : st.ended ? He.emit("error", new Error("stream.push() after EOF")) : (st.reading = !1, st.decoder && !nt ? (Qe = st.decoder.write(Qe), st.objectMode || Qe.length !== 0 ? rt(He, st, Qe, !1) : h(He, st)) : rt(He, st, Qe, !1))) : je || (st.reading = !1);
    }
    return vt(st);
  }
  function rt(He, Qe, nt, je) {
    Qe.flowing && Qe.length === 0 && !Qe.sync ? (He.emit("data", nt), He.read(0)) : (Qe.length += Qe.objectMode ? 1 : nt.length, je ? Qe.buffer.unshift(nt) : Qe.buffer.push(nt), Qe.needReadable && Se(He)), h(He, Qe);
  }
  function lt(He, Qe) {
    var nt;
    return !qe(Qe) && typeof Qe != "string" && Qe !== void 0 && !He.objectMode && (nt = new TypeError("Invalid non-string/buffer chunk")), nt;
  }
  function vt(He) {
    return !He.ended && (He.needReadable || He.length < He.highWaterMark || He.length === 0);
  }
  Je.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Je.prototype.setEncoding = function(He) {
    return Fe || (Fe = requireString_decoder().StringDecoder), this._readableState.decoder = new Fe(He), this._readableState.encoding = He, this;
  };
  var Ye = 8388608;
  function pt(He) {
    return He >= Ye ? He = Ye : (He--, He |= He >>> 1, He |= He >>> 2, He |= He >>> 4, He |= He >>> 8, He |= He >>> 16, He++), He;
  }
  function bt(He, Qe) {
    return He <= 0 || Qe.length === 0 && Qe.ended ? 0 : Qe.objectMode ? 1 : He !== He ? Qe.flowing && Qe.length ? Qe.buffer.head.data.length : Qe.length : (He > Qe.highWaterMark && (Qe.highWaterMark = pt(He)), He <= Qe.length ? He : Qe.ended ? Qe.length : (Qe.needReadable = !0, 0));
  }
  Je.prototype.read = function(He) {
    Oe("read", He), He = parseInt(He, 10);
    var Qe = this._readableState, nt = He;
    if (He !== 0 && (Qe.emittedReadable = !1), He === 0 && Qe.needReadable && (Qe.length >= Qe.highWaterMark || Qe.ended))
      return Oe("read: emitReadable", Qe.length, Qe.ended), Qe.length === 0 && Qe.ended ? tt(this) : Se(this), null;
    if (He = bt(He, Qe), He === 0 && Qe.ended)
      return Qe.length === 0 && tt(this), null;
    var je = Qe.needReadable;
    Oe("need readable", je), (Qe.length === 0 || Qe.length - He < Qe.highWaterMark) && (je = !0, Oe("length less than watermark", je)), Qe.ended || Qe.reading ? (je = !1, Oe("reading or ended", je)) : je && (Oe("do read"), Qe.reading = !0, Qe.sync = !0, Qe.length === 0 && (Qe.needReadable = !0), this._read(Qe.highWaterMark), Qe.sync = !1, Qe.reading || (He = bt(nt, Qe)));
    var it;
    return He > 0 ? it = a(He, Qe) : it = null, it === null ? (Qe.needReadable = !0, He = 0) : Qe.length -= He, Qe.length === 0 && (Qe.ended || (Qe.needReadable = !0), nt !== He && Qe.ended && tt(this)), it !== null && this.emit("data", it), it;
  };
  function Yt(He, Qe) {
    if (!Qe.ended) {
      if (Qe.decoder) {
        var nt = Qe.decoder.end();
        nt && nt.length && (Qe.buffer.push(nt), Qe.length += Qe.objectMode ? 1 : nt.length);
      }
      Qe.ended = !0, Se(He);
    }
  }
  function Se(He) {
    var Qe = He._readableState;
    Qe.needReadable = !1, Qe.emittedReadable || (Oe("emitReadable", Qe.flowing), Qe.emittedReadable = !0, Qe.sync ? I.nextTick(t, He) : t(He));
  }
  function t(He) {
    Oe("emit readable"), He.emit("readable"), X(He);
  }
  function h(He, Qe) {
    Qe.readingMore || (Qe.readingMore = !0, I.nextTick(B, He, Qe));
  }
  function B(He, Qe) {
    for (var nt = Qe.length; !Qe.reading && !Qe.flowing && !Qe.ended && Qe.length < Qe.highWaterMark && (Oe("maybeReadMore read 0"), He.read(0), nt !== Qe.length); )
      nt = Qe.length;
    Qe.readingMore = !1;
  }
  Je.prototype._read = function(He) {
    this.emit("error", new Error("_read() is not implemented"));
  }, Je.prototype.pipe = function(He, Qe) {
    var nt = this, je = this._readableState;
    switch (je.pipesCount) {
      case 0:
        je.pipes = He;
        break;
      case 1:
        je.pipes = [je.pipes, He];
        break;
      default:
        je.pipes.push(He);
        break;
    }
    je.pipesCount += 1, Oe("pipe count=%d opts=%j", je.pipesCount, Qe);
    var it = (!Qe || Qe.end !== !1) && He !== process$1.stdout && He !== process$1.stderr, st = it ? It : ii;
    je.endEmitted ? I.nextTick(st) : nt.once("end", st), He.on("unpipe", gt);
    function gt(Pt, Rt) {
      Oe("onunpipe"), Pt === nt && Rt && Rt.hasUnpiped === !1 && (Rt.hasUnpiped = !0, ei());
    }
    function It() {
      Oe("onend"), He.end();
    }
    var At = Z(nt);
    He.on("drain", At);
    var Et = !1;
    function ei() {
      Oe("cleanup"), He.removeListener("close", Ct), He.removeListener("finish", Wt), He.removeListener("drain", At), He.removeListener("error", ni), He.removeListener("unpipe", gt), nt.removeListener("end", It), nt.removeListener("end", ii), nt.removeListener("data", _t), Et = !0, je.awaitDrain && (!He._writableState || He._writableState.needDrain) && At();
    }
    var Xt = !1;
    nt.on("data", _t);
    function _t(Pt) {
      Oe("ondata"), Xt = !1;
      var Rt = He.write(Pt);
      Rt === !1 && !Xt && ((je.pipesCount === 1 && je.pipes === He || je.pipesCount > 1 && ot(je.pipes, He) !== -1) && !Et && (Oe("false write response, pause", je.awaitDrain), je.awaitDrain++, Xt = !0), nt.pause());
    }
    function ni(Pt) {
      Oe("onerror", Pt), ii(), He.removeListener("error", ni), J(He, "error") === 0 && He.emit("error", Pt);
    }
    et(He, "error", ni);
    function Ct() {
      He.removeListener("finish", Wt), ii();
    }
    He.once("close", Ct);
    function Wt() {
      Oe("onfinish"), He.removeListener("close", Ct), ii();
    }
    He.once("finish", Wt);
    function ii() {
      Oe("unpipe"), nt.unpipe(He);
    }
    return He.emit("pipe", nt), je.flowing || (Oe("pipe resume"), nt.resume()), He;
  };
  function Z(He) {
    return function() {
      var Qe = He._readableState;
      Oe("pipeOnDrain", Qe.awaitDrain), Qe.awaitDrain && Qe.awaitDrain--, Qe.awaitDrain === 0 && J(He, "data") && (Qe.flowing = !0, X(He));
    };
  }
  Je.prototype.unpipe = function(He) {
    var Qe = this._readableState, nt = { hasUnpiped: !1 };
    if (Qe.pipesCount === 0) return this;
    if (Qe.pipesCount === 1)
      return He && He !== Qe.pipes ? this : (He || (He = Qe.pipes), Qe.pipes = null, Qe.pipesCount = 0, Qe.flowing = !1, He && He.emit("unpipe", this, nt), this);
    if (!He) {
      var je = Qe.pipes, it = Qe.pipesCount;
      Qe.pipes = null, Qe.pipesCount = 0, Qe.flowing = !1;
      for (var st = 0; st < it; st++)
        je[st].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var gt = ot(Qe.pipes, He);
    return gt === -1 ? this : (Qe.pipes.splice(gt, 1), Qe.pipesCount -= 1, Qe.pipesCount === 1 && (Qe.pipes = Qe.pipes[0]), He.emit("unpipe", this, nt), this);
  }, Je.prototype.on = function(He, Qe) {
    var nt = _e.prototype.on.call(this, He, Qe);
    if (He === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (He === "readable") {
      var je = this._readableState;
      !je.endEmitted && !je.readableListening && (je.readableListening = je.needReadable = !0, je.emittedReadable = !1, je.reading ? je.length && Se(this) : I.nextTick(ve, this));
    }
    return nt;
  }, Je.prototype.addListener = Je.prototype.on;
  function ve(He) {
    Oe("readable nexttick read 0"), He.read(0);
  }
  Je.prototype.resume = function() {
    var He = this._readableState;
    return He.flowing || (Oe("resume"), He.flowing = !0, ge(this, He)), this;
  };
  function ge(He, Qe) {
    Qe.resumeScheduled || (Qe.resumeScheduled = !0, I.nextTick(xe, He, Qe));
  }
  function xe(He, Qe) {
    Qe.reading || (Oe("resume read 0"), He.read(0)), Qe.resumeScheduled = !1, Qe.awaitDrain = 0, He.emit("resume"), X(He), Qe.flowing && !Qe.reading && He.read(0);
  }
  Je.prototype.pause = function() {
    return Oe("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (Oe("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function X(He) {
    var Qe = He._readableState;
    for (Oe("flow", Qe.flowing); Qe.flowing && He.read() !== null; )
      ;
  }
  Je.prototype.wrap = function(He) {
    var Qe = this, nt = this._readableState, je = !1;
    He.on("end", function() {
      if (Oe("wrapped end"), nt.decoder && !nt.ended) {
        var gt = nt.decoder.end();
        gt && gt.length && Qe.push(gt);
      }
      Qe.push(null);
    }), He.on("data", function(gt) {
      if (Oe("wrapped data"), nt.decoder && (gt = nt.decoder.write(gt)), !(nt.objectMode && gt == null) && !(!nt.objectMode && (!gt || !gt.length))) {
        var It = Qe.push(gt);
        It || (je = !0, He.pause());
      }
    });
    for (var it in He)
      this[it] === void 0 && typeof He[it] == "function" && (this[it] = /* @__PURE__ */ function(gt) {
        return function() {
          return He[gt].apply(He, arguments);
        };
      }(it));
    for (var st = 0; st < Ge.length; st++)
      He.on(Ge[st], this.emit.bind(this, Ge[st]));
    return this._read = function(gt) {
      Oe("wrapped _read", gt), je && (je = !1, He.resume());
    }, this;
  }, Object.defineProperty(Je.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Je._fromList = a;
  function a(He, Qe) {
    if (Qe.length === 0) return null;
    var nt;
    return Qe.objectMode ? nt = Qe.buffer.shift() : !He || He >= Qe.length ? (Qe.decoder ? nt = Qe.buffer.join("") : Qe.buffer.length === 1 ? nt = Qe.buffer.head.data : nt = Qe.buffer.concat(Qe.length), Qe.buffer.clear()) : nt = Y(He, Qe.buffer, Qe.decoder), nt;
  }
  function Y(He, Qe, nt) {
    var je;
    return He < Qe.head.data.length ? (je = Qe.head.data.slice(0, He), Qe.head.data = Qe.head.data.slice(He)) : He === Qe.head.data.length ? je = Qe.shift() : je = nt ? Ne(He, Qe) : Ke(He, Qe), je;
  }
  function Ne(He, Qe) {
    var nt = Qe.head, je = 1, it = nt.data;
    for (He -= it.length; nt = nt.next; ) {
      var st = nt.data, gt = He > st.length ? st.length : He;
      if (gt === st.length ? it += st : it += st.slice(0, He), He -= gt, He === 0) {
        gt === st.length ? (++je, nt.next ? Qe.head = nt.next : Qe.head = Qe.tail = null) : (Qe.head = nt, nt.data = st.slice(gt));
        break;
      }
      ++je;
    }
    return Qe.length -= je, it;
  }
  function Ke(He, Qe) {
    var nt = H.allocUnsafe(He), je = Qe.head, it = 1;
    for (je.data.copy(nt), He -= je.data.length; je = je.next; ) {
      var st = je.data, gt = He > st.length ? st.length : He;
      if (st.copy(nt, nt.length - He, 0, gt), He -= gt, He === 0) {
        gt === st.length ? (++it, je.next ? Qe.head = je.next : Qe.head = Qe.tail = null) : (Qe.head = je, je.data = st.slice(gt));
        break;
      }
      ++it;
    }
    return Qe.length -= it, nt;
  }
  function tt(He) {
    var Qe = He._readableState;
    if (Qe.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    Qe.endEmitted || (Qe.ended = !0, I.nextTick(We, Qe, He));
  }
  function We(He, Qe) {
    !He.endEmitted && He.length === 0 && (He.endEmitted = !0, Qe.readable = !1, Qe.emit("end"));
  }
  function ot(He, Qe) {
    for (var nt = 0, je = He.length; nt < je; nt++)
      if (He[nt] === Qe) return nt;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform) return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = J;
  var I = require_stream_duplex(), A = Object.create(requireUtil());
  A.inherits = inherits_browserExports, A.inherits(J, I);
  function G(De, Ie) {
    var qe = this._transformState;
    qe.transforming = !1;
    var Te = qe.writecb;
    if (!Te)
      return this.emit("error", new Error("write callback called multiple times"));
    qe.writechunk = null, qe.writecb = null, Ie != null && this.push(Ie), Te(De);
    var Ee = this._readableState;
    Ee.reading = !1, (Ee.needReadable || Ee.length < Ee.highWaterMark) && this._read(Ee.highWaterMark);
  }
  function J(De) {
    if (!(this instanceof J)) return new J(De);
    I.call(this, De), this._transformState = {
      afterTransform: G.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, De && (typeof De.transform == "function" && (this._transform = De.transform), typeof De.flush == "function" && (this._flush = De.flush)), this.on("prefinish", _e);
  }
  function _e() {
    var De = this;
    typeof this._flush == "function" ? this._flush(function(Ie, qe) {
      H(De, Ie, qe);
    }) : H(this, null, null);
  }
  J.prototype.push = function(De, Ie) {
    return this._transformState.needTransform = !1, I.prototype.push.call(this, De, Ie);
  }, J.prototype._transform = function(De, Ie, qe) {
    throw new Error("_transform() is not implemented");
  }, J.prototype._write = function(De, Ie, qe) {
    var Te = this._transformState;
    if (Te.writecb = qe, Te.writechunk = De, Te.writeencoding = Ie, !Te.transforming) {
      var Ee = this._readableState;
      (Te.needTransform || Ee.needReadable || Ee.length < Ee.highWaterMark) && this._read(Ee.highWaterMark);
    }
  }, J.prototype._read = function(De) {
    var Ie = this._transformState;
    Ie.writechunk !== null && Ie.writecb && !Ie.transforming ? (Ie.transforming = !0, this._transform(Ie.writechunk, Ie.writeencoding, Ie.afterTransform)) : Ie.needTransform = !0;
  }, J.prototype._destroy = function(De, Ie) {
    var qe = this;
    I.prototype._destroy.call(this, De, function(Te) {
      Ie(Te), qe.emit("close");
    });
  };
  function H(De, Ie, qe) {
    if (Ie) return De.emit("error", Ie);
    if (qe != null && De.push(qe), De._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (De._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return De.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough) return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = G;
  var I = require_stream_transform(), A = Object.create(requireUtil());
  A.inherits = inherits_browserExports, A.inherits(G, I);
  function G(J) {
    if (!(this instanceof G)) return new G(J);
    I.call(this, J);
  }
  return G.prototype._transform = function(J, _e, H) {
    H(null, J);
  }, _stream_passthrough;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(I, A) {
    A = I.exports = require_stream_readable(), A.Stream = A, A.Readable = A, A.Writable = require_stream_writable(), A.Duplex = require_stream_duplex(), A.Transform = require_stream_transform(), A.PassThrough = require_stream_passthrough();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var sign = { exports: {} }, browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa) return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var I = bnExports$1, A = requireBrowser$a();
  function G(H) {
    var De = J(H), Ie = De.toRed(I.mont(H.modulus)).redPow(new I(H.publicExponent)).fromRed();
    return { blinder: Ie, unblinder: De.invm(H.modulus) };
  }
  function J(H) {
    var De = H.modulus.byteLength(), Ie;
    do
      Ie = new I(A(De));
    while (Ie.cmp(H.modulus) >= 0 || !Ie.umod(H.prime1) || !Ie.umod(H.prime2));
    return Ie;
  }
  function _e(H, De) {
    var Ie = G(De), qe = De.modulus.byteLength(), Te = new I(H).mul(Ie.blinder).umod(De.modulus), Ee = Te.toRed(I.mont(De.prime1)), Oe = Te.toRed(I.mont(De.prime2)), Le = De.coefficient, ke = De.prime1, Fe = De.prime2, Ge = Ee.redPow(De.exponent1).fromRed(), et = Oe.redPow(De.exponent2).fromRed(), Ve = Ge.isub(et).imul(Le).umod(ke).imul(Fe);
    return et.iadd(Ve).imul(Ie.unblinder).umod(De.modulus).toArrayLike(Buffer$7, "be", qe);
  }
  return _e.getr = J, browserifyRsa = _e, browserifyRsa;
}
var elliptic$1 = {};
const name$1 = "elliptic", version$1 = "6.5.5", description$1 = "EC cryptography", main$1 = "lib/elliptic.js", files$1 = [
  "lib"
], scripts$1 = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository$1 = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords$1 = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author$1 = "Fedor Indutny <fedor@indutny.com>", license$1 = "MIT", bugs$1 = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage$1 = "https://github.com/indutny/elliptic", devDependencies$1 = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies$1 = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$1 = {
  name: name$1,
  version: version$1,
  description: description$1,
  main: main$1,
  files: files$1,
  scripts: scripts$1,
  repository: repository$1,
  keywords: keywords$1,
  author: author$1,
  license: license$1,
  bugs: bugs$1,
  homepage: homepage$1,
  devDependencies: devDependencies$1,
  dependencies: dependencies$1
};
var utils$n = {}, bn$4 = { exports: {} };
bn$4.exports;
var hasRequiredBn$3;
function requireBn$3() {
  return hasRequiredBn$3 || (hasRequiredBn$3 = 1, function(I) {
    (function(A, G) {
      function J(Se, t) {
        if (!Se) throw new Error(t || "Assertion failed");
      }
      function _e(Se, t) {
        Se.super_ = t;
        var h = function() {
        };
        h.prototype = t.prototype, Se.prototype = new h(), Se.prototype.constructor = Se;
      }
      function H(Se, t, h) {
        if (H.isBN(Se))
          return Se;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Se !== null && ((t === "le" || t === "be") && (h = t, t = 10), this._init(Se || 0, t || 10, h || "be"));
      }
      typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
      var De;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = require$$0$3.Buffer;
      } catch {
      }
      H.isBN = function(t) {
        return t instanceof H ? !0 : t !== null && typeof t == "object" && t.constructor.wordSize === H.wordSize && Array.isArray(t.words);
      }, H.max = function(t, h) {
        return t.cmp(h) > 0 ? t : h;
      }, H.min = function(t, h) {
        return t.cmp(h) < 0 ? t : h;
      }, H.prototype._init = function(t, h, B) {
        if (typeof t == "number")
          return this._initNumber(t, h, B);
        if (typeof t == "object")
          return this._initArray(t, h, B);
        h === "hex" && (h = 16), J(h === (h | 0) && h >= 2 && h <= 36), t = t.toString().replace(/\s+/g, "");
        var Z = 0;
        t[0] === "-" && (Z++, this.negative = 1), Z < t.length && (h === 16 ? this._parseHex(t, Z, B) : (this._parseBase(t, h, Z), B === "le" && this._initArray(this.toArray(), h, B)));
      }, H.prototype._initNumber = function(t, h, B) {
        t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [t & 67108863], this.length = 1) : t < 4503599627370496 ? (this.words = [
          t & 67108863,
          t / 67108864 & 67108863
        ], this.length = 2) : (J(t < 9007199254740992), this.words = [
          t & 67108863,
          t / 67108864 & 67108863,
          1
        ], this.length = 3), B === "le" && this._initArray(this.toArray(), h, B);
      }, H.prototype._initArray = function(t, h, B) {
        if (J(typeof t.length == "number"), t.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve, ge, xe = 0;
        if (B === "be")
          for (Z = t.length - 1, ve = 0; Z >= 0; Z -= 3)
            ge = t[Z] | t[Z - 1] << 8 | t[Z - 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        else if (B === "le")
          for (Z = 0, ve = 0; Z < t.length; Z += 3)
            ge = t[Z] | t[Z + 1] << 8 | t[Z + 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        return this.strip();
      };
      function Ie(Se, t) {
        var h = Se.charCodeAt(t);
        return h >= 65 && h <= 70 ? h - 55 : h >= 97 && h <= 102 ? h - 87 : h - 48 & 15;
      }
      function qe(Se, t, h) {
        var B = Ie(Se, h);
        return h - 1 >= t && (B |= Ie(Se, h - 1) << 4), B;
      }
      H.prototype._parseHex = function(t, h, B) {
        this.length = Math.ceil((t.length - h) / 6), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve = 0, ge = 0, xe;
        if (B === "be")
          for (Z = t.length - 1; Z >= h; Z -= 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        else {
          var X = t.length - h;
          for (Z = X % 2 === 0 ? h + 1 : h; Z < t.length; Z += 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        }
        this.strip();
      };
      function Te(Se, t, h, B) {
        for (var Z = 0, ve = Math.min(Se.length, h), ge = t; ge < ve; ge++) {
          var xe = Se.charCodeAt(ge) - 48;
          Z *= B, xe >= 49 ? Z += xe - 49 + 10 : xe >= 17 ? Z += xe - 17 + 10 : Z += xe;
        }
        return Z;
      }
      H.prototype._parseBase = function(t, h, B) {
        this.words = [0], this.length = 1;
        for (var Z = 0, ve = 1; ve <= 67108863; ve *= h)
          Z++;
        Z--, ve = ve / h | 0;
        for (var ge = t.length - B, xe = ge % Z, X = Math.min(ge, ge - xe) + B, a = 0, Y = B; Y < X; Y += Z)
          a = Te(t, Y, Y + Z, h), this.imuln(ve), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (xe !== 0) {
          var Ne = 1;
          for (a = Te(t, Y, t.length, h), Y = 0; Y < xe; Y++)
            Ne *= h;
          this.imuln(Ne), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, H.prototype.copy = function(t) {
        t.words = new Array(this.length);
        for (var h = 0; h < this.length; h++)
          t.words[h] = this.words[h];
        t.length = this.length, t.negative = this.negative, t.red = this.red;
      }, H.prototype.clone = function() {
        var t = new H(null);
        return this.copy(t), t;
      }, H.prototype._expand = function(t) {
        for (; this.length < t; )
          this.words[this.length++] = 0;
        return this;
      }, H.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, H.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, H.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var Ee = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Oe = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Le = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      H.prototype.toString = function(t, h) {
        t = t || 10, h = h | 0 || 1;
        var B;
        if (t === 16 || t === "hex") {
          B = "";
          for (var Z = 0, ve = 0, ge = 0; ge < this.length; ge++) {
            var xe = this.words[ge], X = ((xe << Z | ve) & 16777215).toString(16);
            ve = xe >>> 24 - Z & 16777215, ve !== 0 || ge !== this.length - 1 ? B = Ee[6 - X.length] + X + B : B = X + B, Z += 2, Z >= 26 && (Z -= 26, ge--);
          }
          for (ve !== 0 && (B = ve.toString(16) + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        if (t === (t | 0) && t >= 2 && t <= 36) {
          var a = Oe[t], Y = Le[t];
          B = "";
          var Ne = this.clone();
          for (Ne.negative = 0; !Ne.isZero(); ) {
            var Ke = Ne.modn(Y).toString(t);
            Ne = Ne.idivn(Y), Ne.isZero() ? B = Ke + B : B = Ee[a - Ke.length] + Ke + B;
          }
          for (this.isZero() && (B = "0" + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        J(!1, "Base should be between 2 and 36");
      }, H.prototype.toNumber = function() {
        var t = this.words[0];
        return this.length === 2 ? t += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? t += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -t : t;
      }, H.prototype.toJSON = function() {
        return this.toString(16);
      }, H.prototype.toBuffer = function(t, h) {
        return J(typeof De < "u"), this.toArrayLike(De, t, h);
      }, H.prototype.toArray = function(t, h) {
        return this.toArrayLike(Array, t, h);
      }, H.prototype.toArrayLike = function(t, h, B) {
        var Z = this.byteLength(), ve = B || Math.max(1, Z);
        J(Z <= ve, "byte array longer than desired length"), J(ve > 0, "Requested array length <= 0"), this.strip();
        var ge = h === "le", xe = new t(ve), X, a, Y = this.clone();
        if (ge) {
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[a] = X;
          for (; a < ve; a++)
            xe[a] = 0;
        } else {
          for (a = 0; a < ve - Z; a++)
            xe[a] = 0;
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[ve - a - 1] = X;
        }
        return xe;
      }, Math.clz32 ? H.prototype._countBits = function(t) {
        return 32 - Math.clz32(t);
      } : H.prototype._countBits = function(t) {
        var h = t, B = 0;
        return h >= 4096 && (B += 13, h >>>= 13), h >= 64 && (B += 7, h >>>= 7), h >= 8 && (B += 4, h >>>= 4), h >= 2 && (B += 2, h >>>= 2), B + h;
      }, H.prototype._zeroBits = function(t) {
        if (t === 0) return 26;
        var h = t, B = 0;
        return h & 8191 || (B += 13, h >>>= 13), h & 127 || (B += 7, h >>>= 7), h & 15 || (B += 4, h >>>= 4), h & 3 || (B += 2, h >>>= 2), h & 1 || B++, B;
      }, H.prototype.bitLength = function() {
        var t = this.words[this.length - 1], h = this._countBits(t);
        return (this.length - 1) * 26 + h;
      };
      function ke(Se) {
        for (var t = new Array(Se.bitLength()), h = 0; h < t.length; h++) {
          var B = h / 26 | 0, Z = h % 26;
          t[h] = (Se.words[B] & 1 << Z) >>> Z;
        }
        return t;
      }
      H.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var t = 0, h = 0; h < this.length; h++) {
          var B = this._zeroBits(this.words[h]);
          if (t += B, B !== 26) break;
        }
        return t;
      }, H.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, H.prototype.toTwos = function(t) {
        return this.negative !== 0 ? this.abs().inotn(t).iaddn(1) : this.clone();
      }, H.prototype.fromTwos = function(t) {
        return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
      }, H.prototype.isNeg = function() {
        return this.negative !== 0;
      }, H.prototype.neg = function() {
        return this.clone().ineg();
      }, H.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, H.prototype.iuor = function(t) {
        for (; this.length < t.length; )
          this.words[this.length++] = 0;
        for (var h = 0; h < t.length; h++)
          this.words[h] = this.words[h] | t.words[h];
        return this.strip();
      }, H.prototype.ior = function(t) {
        return J((this.negative | t.negative) === 0), this.iuor(t);
      }, H.prototype.or = function(t) {
        return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
      }, H.prototype.uor = function(t) {
        return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
      }, H.prototype.iuand = function(t) {
        var h;
        this.length > t.length ? h = t : h = this;
        for (var B = 0; B < h.length; B++)
          this.words[B] = this.words[B] & t.words[B];
        return this.length = h.length, this.strip();
      }, H.prototype.iand = function(t) {
        return J((this.negative | t.negative) === 0), this.iuand(t);
      }, H.prototype.and = function(t) {
        return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
      }, H.prototype.uand = function(t) {
        return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
      }, H.prototype.iuxor = function(t) {
        var h, B;
        this.length > t.length ? (h = this, B = t) : (h = t, B = this);
        for (var Z = 0; Z < B.length; Z++)
          this.words[Z] = h.words[Z] ^ B.words[Z];
        if (this !== h)
          for (; Z < h.length; Z++)
            this.words[Z] = h.words[Z];
        return this.length = h.length, this.strip();
      }, H.prototype.ixor = function(t) {
        return J((this.negative | t.negative) === 0), this.iuxor(t);
      }, H.prototype.xor = function(t) {
        return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
      }, H.prototype.uxor = function(t) {
        return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
      }, H.prototype.inotn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = Math.ceil(t / 26) | 0, B = t % 26;
        this._expand(h), B > 0 && h--;
        for (var Z = 0; Z < h; Z++)
          this.words[Z] = ~this.words[Z] & 67108863;
        return B > 0 && (this.words[Z] = ~this.words[Z] & 67108863 >> 26 - B), this.strip();
      }, H.prototype.notn = function(t) {
        return this.clone().inotn(t);
      }, H.prototype.setn = function(t, h) {
        J(typeof t == "number" && t >= 0);
        var B = t / 26 | 0, Z = t % 26;
        return this._expand(B + 1), h ? this.words[B] = this.words[B] | 1 << Z : this.words[B] = this.words[B] & ~(1 << Z), this.strip();
      }, H.prototype.iadd = function(t) {
        var h;
        if (this.negative !== 0 && t.negative === 0)
          return this.negative = 0, h = this.isub(t), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && t.negative !== 0)
          return t.negative = 0, h = this.isub(t), t.negative = 1, h._normSign();
        var B, Z;
        this.length > t.length ? (B = this, Z = t) : (B = t, Z = this);
        for (var ve = 0, ge = 0; ge < Z.length; ge++)
          h = (B.words[ge] | 0) + (Z.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        for (; ve !== 0 && ge < B.length; ge++)
          h = (B.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        if (this.length = B.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (B !== this)
          for (; ge < B.length; ge++)
            this.words[ge] = B.words[ge];
        return this;
      }, H.prototype.add = function(t) {
        var h;
        return t.negative !== 0 && this.negative === 0 ? (t.negative = 0, h = this.sub(t), t.negative ^= 1, h) : t.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = t.sub(this), this.negative = 1, h) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
      }, H.prototype.isub = function(t) {
        if (t.negative !== 0) {
          t.negative = 0;
          var h = this.iadd(t);
          return t.negative = 1, h._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
        var B = this.cmp(t);
        if (B === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Z, ve;
        B > 0 ? (Z = this, ve = t) : (Z = t, ve = this);
        for (var ge = 0, xe = 0; xe < ve.length; xe++)
          h = (Z.words[xe] | 0) - (ve.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        for (; ge !== 0 && xe < Z.length; xe++)
          h = (Z.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        if (ge === 0 && xe < Z.length && Z !== this)
          for (; xe < Z.length; xe++)
            this.words[xe] = Z.words[xe];
        return this.length = Math.max(this.length, xe), Z !== this && (this.negative = 1), this.strip();
      }, H.prototype.sub = function(t) {
        return this.clone().isub(t);
      };
      function Fe(Se, t, h) {
        h.negative = t.negative ^ Se.negative;
        var B = Se.length + t.length | 0;
        h.length = B, B = B - 1 | 0;
        var Z = Se.words[0] | 0, ve = t.words[0] | 0, ge = Z * ve, xe = ge & 67108863, X = ge / 67108864 | 0;
        h.words[0] = xe;
        for (var a = 1; a < B; a++) {
          for (var Y = X >>> 26, Ne = X & 67108863, Ke = Math.min(a, t.length - 1), tt = Math.max(0, a - Se.length + 1); tt <= Ke; tt++) {
            var We = a - tt | 0;
            Z = Se.words[We] | 0, ve = t.words[tt] | 0, ge = Z * ve + Ne, Y += ge / 67108864 | 0, Ne = ge & 67108863;
          }
          h.words[a] = Ne | 0, X = Y | 0;
        }
        return X !== 0 ? h.words[a] = X | 0 : h.length--, h.strip();
      }
      var Ge = function(t, h, B) {
        var Z = t.words, ve = h.words, ge = B.words, xe = 0, X, a, Y, Ne = Z[0] | 0, Ke = Ne & 8191, tt = Ne >>> 13, We = Z[1] | 0, ot = We & 8191, He = We >>> 13, Qe = Z[2] | 0, nt = Qe & 8191, je = Qe >>> 13, it = Z[3] | 0, st = it & 8191, gt = it >>> 13, It = Z[4] | 0, At = It & 8191, Et = It >>> 13, ei = Z[5] | 0, Xt = ei & 8191, _t = ei >>> 13, ni = Z[6] | 0, Ct = ni & 8191, Wt = ni >>> 13, ii = Z[7] | 0, Pt = ii & 8191, Rt = ii >>> 13, ai = Z[8] | 0, Nt = ai & 8191, qt = ai >>> 13, oi = Z[9] | 0, ct = oi & 8191, Ze = oi >>> 13, at = ve[0] | 0, dt = at & 8191, yt = at >>> 13, St = ve[1] | 0, xt = St & 8191, Vt = St >>> 13, ci = ve[2] | 0, Qt = ci & 8191, rr = ci >>> 13, ui = ve[3] | 0, Gr = ui & 8191, yr = ui >>> 13, pi = ve[4] | 0, wr = pi & 8191, _r = pi >>> 13, di = ve[5] | 0, Sr = di & 8191, Br = di >>> 13, vi = ve[6] | 0, gr = vi & 8191, $r = vi >>> 13, li = ve[7] | 0, Ir = li & 8191, Cr = li >>> 13, mi = ve[8] | 0, Pr = mi & 8191, Or = mi >>> 13, yi = ve[9] | 0, Zr = yi & 8191, Vr = yi >>> 13;
        B.negative = t.negative ^ h.negative, B.length = 19, X = Math.imul(Ke, dt), a = Math.imul(Ke, yt), a = a + Math.imul(tt, dt) | 0, Y = Math.imul(tt, yt);
        var bi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, X = Math.imul(ot, dt), a = Math.imul(ot, yt), a = a + Math.imul(He, dt) | 0, Y = Math.imul(He, yt), X = X + Math.imul(Ke, xt) | 0, a = a + Math.imul(Ke, Vt) | 0, a = a + Math.imul(tt, xt) | 0, Y = Y + Math.imul(tt, Vt) | 0;
        var Ai = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, X = Math.imul(nt, dt), a = Math.imul(nt, yt), a = a + Math.imul(je, dt) | 0, Y = Math.imul(je, yt), X = X + Math.imul(ot, xt) | 0, a = a + Math.imul(ot, Vt) | 0, a = a + Math.imul(He, xt) | 0, Y = Y + Math.imul(He, Vt) | 0, X = X + Math.imul(Ke, Qt) | 0, a = a + Math.imul(Ke, rr) | 0, a = a + Math.imul(tt, Qt) | 0, Y = Y + Math.imul(tt, rr) | 0;
        var Zi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, X = Math.imul(st, dt), a = Math.imul(st, yt), a = a + Math.imul(gt, dt) | 0, Y = Math.imul(gt, yt), X = X + Math.imul(nt, xt) | 0, a = a + Math.imul(nt, Vt) | 0, a = a + Math.imul(je, xt) | 0, Y = Y + Math.imul(je, Vt) | 0, X = X + Math.imul(ot, Qt) | 0, a = a + Math.imul(ot, rr) | 0, a = a + Math.imul(He, Qt) | 0, Y = Y + Math.imul(He, rr) | 0, X = X + Math.imul(Ke, Gr) | 0, a = a + Math.imul(Ke, yr) | 0, a = a + Math.imul(tt, Gr) | 0, Y = Y + Math.imul(tt, yr) | 0;
        var Ji = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, X = Math.imul(At, dt), a = Math.imul(At, yt), a = a + Math.imul(Et, dt) | 0, Y = Math.imul(Et, yt), X = X + Math.imul(st, xt) | 0, a = a + Math.imul(st, Vt) | 0, a = a + Math.imul(gt, xt) | 0, Y = Y + Math.imul(gt, Vt) | 0, X = X + Math.imul(nt, Qt) | 0, a = a + Math.imul(nt, rr) | 0, a = a + Math.imul(je, Qt) | 0, Y = Y + Math.imul(je, rr) | 0, X = X + Math.imul(ot, Gr) | 0, a = a + Math.imul(ot, yr) | 0, a = a + Math.imul(He, Gr) | 0, Y = Y + Math.imul(He, yr) | 0, X = X + Math.imul(Ke, wr) | 0, a = a + Math.imul(Ke, _r) | 0, a = a + Math.imul(tt, wr) | 0, Y = Y + Math.imul(tt, _r) | 0;
        var Vi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, X = Math.imul(Xt, dt), a = Math.imul(Xt, yt), a = a + Math.imul(_t, dt) | 0, Y = Math.imul(_t, yt), X = X + Math.imul(At, xt) | 0, a = a + Math.imul(At, Vt) | 0, a = a + Math.imul(Et, xt) | 0, Y = Y + Math.imul(Et, Vt) | 0, X = X + Math.imul(st, Qt) | 0, a = a + Math.imul(st, rr) | 0, a = a + Math.imul(gt, Qt) | 0, Y = Y + Math.imul(gt, rr) | 0, X = X + Math.imul(nt, Gr) | 0, a = a + Math.imul(nt, yr) | 0, a = a + Math.imul(je, Gr) | 0, Y = Y + Math.imul(je, yr) | 0, X = X + Math.imul(ot, wr) | 0, a = a + Math.imul(ot, _r) | 0, a = a + Math.imul(He, wr) | 0, Y = Y + Math.imul(He, _r) | 0, X = X + Math.imul(Ke, Sr) | 0, a = a + Math.imul(Ke, Br) | 0, a = a + Math.imul(tt, Sr) | 0, Y = Y + Math.imul(tt, Br) | 0;
        var Yi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, X = Math.imul(Ct, dt), a = Math.imul(Ct, yt), a = a + Math.imul(Wt, dt) | 0, Y = Math.imul(Wt, yt), X = X + Math.imul(Xt, xt) | 0, a = a + Math.imul(Xt, Vt) | 0, a = a + Math.imul(_t, xt) | 0, Y = Y + Math.imul(_t, Vt) | 0, X = X + Math.imul(At, Qt) | 0, a = a + Math.imul(At, rr) | 0, a = a + Math.imul(Et, Qt) | 0, Y = Y + Math.imul(Et, rr) | 0, X = X + Math.imul(st, Gr) | 0, a = a + Math.imul(st, yr) | 0, a = a + Math.imul(gt, Gr) | 0, Y = Y + Math.imul(gt, yr) | 0, X = X + Math.imul(nt, wr) | 0, a = a + Math.imul(nt, _r) | 0, a = a + Math.imul(je, wr) | 0, Y = Y + Math.imul(je, _r) | 0, X = X + Math.imul(ot, Sr) | 0, a = a + Math.imul(ot, Br) | 0, a = a + Math.imul(He, Sr) | 0, Y = Y + Math.imul(He, Br) | 0, X = X + Math.imul(Ke, gr) | 0, a = a + Math.imul(Ke, $r) | 0, a = a + Math.imul(tt, gr) | 0, Y = Y + Math.imul(tt, $r) | 0;
        var Xi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, X = Math.imul(Pt, dt), a = Math.imul(Pt, yt), a = a + Math.imul(Rt, dt) | 0, Y = Math.imul(Rt, yt), X = X + Math.imul(Ct, xt) | 0, a = a + Math.imul(Ct, Vt) | 0, a = a + Math.imul(Wt, xt) | 0, Y = Y + Math.imul(Wt, Vt) | 0, X = X + Math.imul(Xt, Qt) | 0, a = a + Math.imul(Xt, rr) | 0, a = a + Math.imul(_t, Qt) | 0, Y = Y + Math.imul(_t, rr) | 0, X = X + Math.imul(At, Gr) | 0, a = a + Math.imul(At, yr) | 0, a = a + Math.imul(Et, Gr) | 0, Y = Y + Math.imul(Et, yr) | 0, X = X + Math.imul(st, wr) | 0, a = a + Math.imul(st, _r) | 0, a = a + Math.imul(gt, wr) | 0, Y = Y + Math.imul(gt, _r) | 0, X = X + Math.imul(nt, Sr) | 0, a = a + Math.imul(nt, Br) | 0, a = a + Math.imul(je, Sr) | 0, Y = Y + Math.imul(je, Br) | 0, X = X + Math.imul(ot, gr) | 0, a = a + Math.imul(ot, $r) | 0, a = a + Math.imul(He, gr) | 0, Y = Y + Math.imul(He, $r) | 0, X = X + Math.imul(Ke, Ir) | 0, a = a + Math.imul(Ke, Cr) | 0, a = a + Math.imul(tt, Ir) | 0, Y = Y + Math.imul(tt, Cr) | 0;
        var en = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, X = Math.imul(Nt, dt), a = Math.imul(Nt, yt), a = a + Math.imul(qt, dt) | 0, Y = Math.imul(qt, yt), X = X + Math.imul(Pt, xt) | 0, a = a + Math.imul(Pt, Vt) | 0, a = a + Math.imul(Rt, xt) | 0, Y = Y + Math.imul(Rt, Vt) | 0, X = X + Math.imul(Ct, Qt) | 0, a = a + Math.imul(Ct, rr) | 0, a = a + Math.imul(Wt, Qt) | 0, Y = Y + Math.imul(Wt, rr) | 0, X = X + Math.imul(Xt, Gr) | 0, a = a + Math.imul(Xt, yr) | 0, a = a + Math.imul(_t, Gr) | 0, Y = Y + Math.imul(_t, yr) | 0, X = X + Math.imul(At, wr) | 0, a = a + Math.imul(At, _r) | 0, a = a + Math.imul(Et, wr) | 0, Y = Y + Math.imul(Et, _r) | 0, X = X + Math.imul(st, Sr) | 0, a = a + Math.imul(st, Br) | 0, a = a + Math.imul(gt, Sr) | 0, Y = Y + Math.imul(gt, Br) | 0, X = X + Math.imul(nt, gr) | 0, a = a + Math.imul(nt, $r) | 0, a = a + Math.imul(je, gr) | 0, Y = Y + Math.imul(je, $r) | 0, X = X + Math.imul(ot, Ir) | 0, a = a + Math.imul(ot, Cr) | 0, a = a + Math.imul(He, Ir) | 0, Y = Y + Math.imul(He, Cr) | 0, X = X + Math.imul(Ke, Pr) | 0, a = a + Math.imul(Ke, Or) | 0, a = a + Math.imul(tt, Pr) | 0, Y = Y + Math.imul(tt, Or) | 0;
        var hn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, X = Math.imul(ct, dt), a = Math.imul(ct, yt), a = a + Math.imul(Ze, dt) | 0, Y = Math.imul(Ze, yt), X = X + Math.imul(Nt, xt) | 0, a = a + Math.imul(Nt, Vt) | 0, a = a + Math.imul(qt, xt) | 0, Y = Y + Math.imul(qt, Vt) | 0, X = X + Math.imul(Pt, Qt) | 0, a = a + Math.imul(Pt, rr) | 0, a = a + Math.imul(Rt, Qt) | 0, Y = Y + Math.imul(Rt, rr) | 0, X = X + Math.imul(Ct, Gr) | 0, a = a + Math.imul(Ct, yr) | 0, a = a + Math.imul(Wt, Gr) | 0, Y = Y + Math.imul(Wt, yr) | 0, X = X + Math.imul(Xt, wr) | 0, a = a + Math.imul(Xt, _r) | 0, a = a + Math.imul(_t, wr) | 0, Y = Y + Math.imul(_t, _r) | 0, X = X + Math.imul(At, Sr) | 0, a = a + Math.imul(At, Br) | 0, a = a + Math.imul(Et, Sr) | 0, Y = Y + Math.imul(Et, Br) | 0, X = X + Math.imul(st, gr) | 0, a = a + Math.imul(st, $r) | 0, a = a + Math.imul(gt, gr) | 0, Y = Y + Math.imul(gt, $r) | 0, X = X + Math.imul(nt, Ir) | 0, a = a + Math.imul(nt, Cr) | 0, a = a + Math.imul(je, Ir) | 0, Y = Y + Math.imul(je, Cr) | 0, X = X + Math.imul(ot, Pr) | 0, a = a + Math.imul(ot, Or) | 0, a = a + Math.imul(He, Pr) | 0, Y = Y + Math.imul(He, Or) | 0, X = X + Math.imul(Ke, Zr) | 0, a = a + Math.imul(Ke, Vr) | 0, a = a + Math.imul(tt, Zr) | 0, Y = Y + Math.imul(tt, Vr) | 0;
        var tn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, X = Math.imul(ct, xt), a = Math.imul(ct, Vt), a = a + Math.imul(Ze, xt) | 0, Y = Math.imul(Ze, Vt), X = X + Math.imul(Nt, Qt) | 0, a = a + Math.imul(Nt, rr) | 0, a = a + Math.imul(qt, Qt) | 0, Y = Y + Math.imul(qt, rr) | 0, X = X + Math.imul(Pt, Gr) | 0, a = a + Math.imul(Pt, yr) | 0, a = a + Math.imul(Rt, Gr) | 0, Y = Y + Math.imul(Rt, yr) | 0, X = X + Math.imul(Ct, wr) | 0, a = a + Math.imul(Ct, _r) | 0, a = a + Math.imul(Wt, wr) | 0, Y = Y + Math.imul(Wt, _r) | 0, X = X + Math.imul(Xt, Sr) | 0, a = a + Math.imul(Xt, Br) | 0, a = a + Math.imul(_t, Sr) | 0, Y = Y + Math.imul(_t, Br) | 0, X = X + Math.imul(At, gr) | 0, a = a + Math.imul(At, $r) | 0, a = a + Math.imul(Et, gr) | 0, Y = Y + Math.imul(Et, $r) | 0, X = X + Math.imul(st, Ir) | 0, a = a + Math.imul(st, Cr) | 0, a = a + Math.imul(gt, Ir) | 0, Y = Y + Math.imul(gt, Cr) | 0, X = X + Math.imul(nt, Pr) | 0, a = a + Math.imul(nt, Or) | 0, a = a + Math.imul(je, Pr) | 0, Y = Y + Math.imul(je, Or) | 0, X = X + Math.imul(ot, Zr) | 0, a = a + Math.imul(ot, Vr) | 0, a = a + Math.imul(He, Zr) | 0, Y = Y + Math.imul(He, Vr) | 0;
        var un = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, X = Math.imul(ct, Qt), a = Math.imul(ct, rr), a = a + Math.imul(Ze, Qt) | 0, Y = Math.imul(Ze, rr), X = X + Math.imul(Nt, Gr) | 0, a = a + Math.imul(Nt, yr) | 0, a = a + Math.imul(qt, Gr) | 0, Y = Y + Math.imul(qt, yr) | 0, X = X + Math.imul(Pt, wr) | 0, a = a + Math.imul(Pt, _r) | 0, a = a + Math.imul(Rt, wr) | 0, Y = Y + Math.imul(Rt, _r) | 0, X = X + Math.imul(Ct, Sr) | 0, a = a + Math.imul(Ct, Br) | 0, a = a + Math.imul(Wt, Sr) | 0, Y = Y + Math.imul(Wt, Br) | 0, X = X + Math.imul(Xt, gr) | 0, a = a + Math.imul(Xt, $r) | 0, a = a + Math.imul(_t, gr) | 0, Y = Y + Math.imul(_t, $r) | 0, X = X + Math.imul(At, Ir) | 0, a = a + Math.imul(At, Cr) | 0, a = a + Math.imul(Et, Ir) | 0, Y = Y + Math.imul(Et, Cr) | 0, X = X + Math.imul(st, Pr) | 0, a = a + Math.imul(st, Or) | 0, a = a + Math.imul(gt, Pr) | 0, Y = Y + Math.imul(gt, Or) | 0, X = X + Math.imul(nt, Zr) | 0, a = a + Math.imul(nt, Vr) | 0, a = a + Math.imul(je, Zr) | 0, Y = Y + Math.imul(je, Vr) | 0;
        var cn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, X = Math.imul(ct, Gr), a = Math.imul(ct, yr), a = a + Math.imul(Ze, Gr) | 0, Y = Math.imul(Ze, yr), X = X + Math.imul(Nt, wr) | 0, a = a + Math.imul(Nt, _r) | 0, a = a + Math.imul(qt, wr) | 0, Y = Y + Math.imul(qt, _r) | 0, X = X + Math.imul(Pt, Sr) | 0, a = a + Math.imul(Pt, Br) | 0, a = a + Math.imul(Rt, Sr) | 0, Y = Y + Math.imul(Rt, Br) | 0, X = X + Math.imul(Ct, gr) | 0, a = a + Math.imul(Ct, $r) | 0, a = a + Math.imul(Wt, gr) | 0, Y = Y + Math.imul(Wt, $r) | 0, X = X + Math.imul(Xt, Ir) | 0, a = a + Math.imul(Xt, Cr) | 0, a = a + Math.imul(_t, Ir) | 0, Y = Y + Math.imul(_t, Cr) | 0, X = X + Math.imul(At, Pr) | 0, a = a + Math.imul(At, Or) | 0, a = a + Math.imul(Et, Pr) | 0, Y = Y + Math.imul(Et, Or) | 0, X = X + Math.imul(st, Zr) | 0, a = a + Math.imul(st, Vr) | 0, a = a + Math.imul(gt, Zr) | 0, Y = Y + Math.imul(gt, Vr) | 0;
        var ln = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, X = Math.imul(ct, wr), a = Math.imul(ct, _r), a = a + Math.imul(Ze, wr) | 0, Y = Math.imul(Ze, _r), X = X + Math.imul(Nt, Sr) | 0, a = a + Math.imul(Nt, Br) | 0, a = a + Math.imul(qt, Sr) | 0, Y = Y + Math.imul(qt, Br) | 0, X = X + Math.imul(Pt, gr) | 0, a = a + Math.imul(Pt, $r) | 0, a = a + Math.imul(Rt, gr) | 0, Y = Y + Math.imul(Rt, $r) | 0, X = X + Math.imul(Ct, Ir) | 0, a = a + Math.imul(Ct, Cr) | 0, a = a + Math.imul(Wt, Ir) | 0, Y = Y + Math.imul(Wt, Cr) | 0, X = X + Math.imul(Xt, Pr) | 0, a = a + Math.imul(Xt, Or) | 0, a = a + Math.imul(_t, Pr) | 0, Y = Y + Math.imul(_t, Or) | 0, X = X + Math.imul(At, Zr) | 0, a = a + Math.imul(At, Vr) | 0, a = a + Math.imul(Et, Zr) | 0, Y = Y + Math.imul(Et, Vr) | 0;
        var an = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, X = Math.imul(ct, Sr), a = Math.imul(ct, Br), a = a + Math.imul(Ze, Sr) | 0, Y = Math.imul(Ze, Br), X = X + Math.imul(Nt, gr) | 0, a = a + Math.imul(Nt, $r) | 0, a = a + Math.imul(qt, gr) | 0, Y = Y + Math.imul(qt, $r) | 0, X = X + Math.imul(Pt, Ir) | 0, a = a + Math.imul(Pt, Cr) | 0, a = a + Math.imul(Rt, Ir) | 0, Y = Y + Math.imul(Rt, Cr) | 0, X = X + Math.imul(Ct, Pr) | 0, a = a + Math.imul(Ct, Or) | 0, a = a + Math.imul(Wt, Pr) | 0, Y = Y + Math.imul(Wt, Or) | 0, X = X + Math.imul(Xt, Zr) | 0, a = a + Math.imul(Xt, Vr) | 0, a = a + Math.imul(_t, Zr) | 0, Y = Y + Math.imul(_t, Vr) | 0;
        var fn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, X = Math.imul(ct, gr), a = Math.imul(ct, $r), a = a + Math.imul(Ze, gr) | 0, Y = Math.imul(Ze, $r), X = X + Math.imul(Nt, Ir) | 0, a = a + Math.imul(Nt, Cr) | 0, a = a + Math.imul(qt, Ir) | 0, Y = Y + Math.imul(qt, Cr) | 0, X = X + Math.imul(Pt, Pr) | 0, a = a + Math.imul(Pt, Or) | 0, a = a + Math.imul(Rt, Pr) | 0, Y = Y + Math.imul(Rt, Or) | 0, X = X + Math.imul(Ct, Zr) | 0, a = a + Math.imul(Ct, Vr) | 0, a = a + Math.imul(Wt, Zr) | 0, Y = Y + Math.imul(Wt, Vr) | 0;
        var sn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, X = Math.imul(ct, Ir), a = Math.imul(ct, Cr), a = a + Math.imul(Ze, Ir) | 0, Y = Math.imul(Ze, Cr), X = X + Math.imul(Nt, Pr) | 0, a = a + Math.imul(Nt, Or) | 0, a = a + Math.imul(qt, Pr) | 0, Y = Y + Math.imul(qt, Or) | 0, X = X + Math.imul(Pt, Zr) | 0, a = a + Math.imul(Pt, Vr) | 0, a = a + Math.imul(Rt, Zr) | 0, Y = Y + Math.imul(Rt, Vr) | 0;
        var dn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, X = Math.imul(ct, Pr), a = Math.imul(ct, Or), a = a + Math.imul(Ze, Pr) | 0, Y = Math.imul(Ze, Or), X = X + Math.imul(Nt, Zr) | 0, a = a + Math.imul(Nt, Vr) | 0, a = a + Math.imul(qt, Zr) | 0, Y = Y + Math.imul(qt, Vr) | 0;
        var pn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, X = Math.imul(ct, Zr), a = Math.imul(ct, Vr), a = a + Math.imul(Ze, Zr) | 0, Y = Math.imul(Ze, Vr);
        var vn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        return xe = (Y + (a >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, ge[0] = bi, ge[1] = Ai, ge[2] = Zi, ge[3] = Ji, ge[4] = Vi, ge[5] = Yi, ge[6] = Xi, ge[7] = en, ge[8] = hn, ge[9] = tn, ge[10] = un, ge[11] = cn, ge[12] = ln, ge[13] = an, ge[14] = fn, ge[15] = sn, ge[16] = dn, ge[17] = pn, ge[18] = vn, xe !== 0 && (ge[19] = xe, B.length++), B;
      };
      Math.imul || (Ge = Fe);
      function et(Se, t, h) {
        h.negative = t.negative ^ Se.negative, h.length = Se.length + t.length;
        for (var B = 0, Z = 0, ve = 0; ve < h.length - 1; ve++) {
          var ge = Z;
          Z = 0;
          for (var xe = B & 67108863, X = Math.min(ve, t.length - 1), a = Math.max(0, ve - Se.length + 1); a <= X; a++) {
            var Y = ve - a, Ne = Se.words[Y] | 0, Ke = t.words[a] | 0, tt = Ne * Ke, We = tt & 67108863;
            ge = ge + (tt / 67108864 | 0) | 0, We = We + xe | 0, xe = We & 67108863, ge = ge + (We >>> 26) | 0, Z += ge >>> 26, ge &= 67108863;
          }
          h.words[ve] = xe, B = ge, ge = Z;
        }
        return B !== 0 ? h.words[ve] = B : h.length--, h.strip();
      }
      function Ve(Se, t, h) {
        var B = new Je();
        return B.mulp(Se, t, h);
      }
      H.prototype.mulTo = function(t, h) {
        var B, Z = this.length + t.length;
        return this.length === 10 && t.length === 10 ? B = Ge(this, t, h) : Z < 63 ? B = Fe(this, t, h) : Z < 1024 ? B = et(this, t, h) : B = Ve(this, t, h), B;
      };
      function Je(Se, t) {
        this.x = Se, this.y = t;
      }
      Je.prototype.makeRBT = function(t) {
        for (var h = new Array(t), B = H.prototype._countBits(t) - 1, Z = 0; Z < t; Z++)
          h[Z] = this.revBin(Z, B, t);
        return h;
      }, Je.prototype.revBin = function(t, h, B) {
        if (t === 0 || t === B - 1) return t;
        for (var Z = 0, ve = 0; ve < h; ve++)
          Z |= (t & 1) << h - ve - 1, t >>= 1;
        return Z;
      }, Je.prototype.permute = function(t, h, B, Z, ve, ge) {
        for (var xe = 0; xe < ge; xe++)
          Z[xe] = h[t[xe]], ve[xe] = B[t[xe]];
      }, Je.prototype.transform = function(t, h, B, Z, ve, ge) {
        this.permute(ge, t, h, B, Z, ve);
        for (var xe = 1; xe < ve; xe <<= 1)
          for (var X = xe << 1, a = Math.cos(2 * Math.PI / X), Y = Math.sin(2 * Math.PI / X), Ne = 0; Ne < ve; Ne += X)
            for (var Ke = a, tt = Y, We = 0; We < xe; We++) {
              var ot = B[Ne + We], He = Z[Ne + We], Qe = B[Ne + We + xe], nt = Z[Ne + We + xe], je = Ke * Qe - tt * nt;
              nt = Ke * nt + tt * Qe, Qe = je, B[Ne + We] = ot + Qe, Z[Ne + We] = He + nt, B[Ne + We + xe] = ot - Qe, Z[Ne + We + xe] = He - nt, We !== X && (je = a * Ke - Y * tt, tt = a * tt + Y * Ke, Ke = je);
            }
      }, Je.prototype.guessLen13b = function(t, h) {
        var B = Math.max(h, t) | 1, Z = B & 1, ve = 0;
        for (B = B / 2 | 0; B; B = B >>> 1)
          ve++;
        return 1 << ve + 1 + Z;
      }, Je.prototype.conjugate = function(t, h, B) {
        if (!(B <= 1))
          for (var Z = 0; Z < B / 2; Z++) {
            var ve = t[Z];
            t[Z] = t[B - Z - 1], t[B - Z - 1] = ve, ve = h[Z], h[Z] = -h[B - Z - 1], h[B - Z - 1] = -ve;
          }
      }, Je.prototype.normalize13b = function(t, h) {
        for (var B = 0, Z = 0; Z < h / 2; Z++) {
          var ve = Math.round(t[2 * Z + 1] / h) * 8192 + Math.round(t[2 * Z] / h) + B;
          t[Z] = ve & 67108863, ve < 67108864 ? B = 0 : B = ve / 67108864 | 0;
        }
        return t;
      }, Je.prototype.convert13b = function(t, h, B, Z) {
        for (var ve = 0, ge = 0; ge < h; ge++)
          ve = ve + (t[ge] | 0), B[2 * ge] = ve & 8191, ve = ve >>> 13, B[2 * ge + 1] = ve & 8191, ve = ve >>> 13;
        for (ge = 2 * h; ge < Z; ++ge)
          B[ge] = 0;
        J(ve === 0), J((ve & -8192) === 0);
      }, Je.prototype.stub = function(t) {
        for (var h = new Array(t), B = 0; B < t; B++)
          h[B] = 0;
        return h;
      }, Je.prototype.mulp = function(t, h, B) {
        var Z = 2 * this.guessLen13b(t.length, h.length), ve = this.makeRBT(Z), ge = this.stub(Z), xe = new Array(Z), X = new Array(Z), a = new Array(Z), Y = new Array(Z), Ne = new Array(Z), Ke = new Array(Z), tt = B.words;
        tt.length = Z, this.convert13b(t.words, t.length, xe, Z), this.convert13b(h.words, h.length, Y, Z), this.transform(xe, ge, X, a, Z, ve), this.transform(Y, ge, Ne, Ke, Z, ve);
        for (var We = 0; We < Z; We++) {
          var ot = X[We] * Ne[We] - a[We] * Ke[We];
          a[We] = X[We] * Ke[We] + a[We] * Ne[We], X[We] = ot;
        }
        return this.conjugate(X, a, Z), this.transform(X, a, tt, ge, Z, ve), this.conjugate(tt, ge, Z), this.normalize13b(tt, Z), B.negative = t.negative ^ h.negative, B.length = t.length + h.length, B.strip();
      }, H.prototype.mul = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), this.mulTo(t, h);
      }, H.prototype.mulf = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), Ve(this, t, h);
      }, H.prototype.imul = function(t) {
        return this.clone().mulTo(t, this);
      }, H.prototype.imuln = function(t) {
        J(typeof t == "number"), J(t < 67108864);
        for (var h = 0, B = 0; B < this.length; B++) {
          var Z = (this.words[B] | 0) * t, ve = (Z & 67108863) + (h & 67108863);
          h >>= 26, h += Z / 67108864 | 0, h += ve >>> 26, this.words[B] = ve & 67108863;
        }
        return h !== 0 && (this.words[B] = h, this.length++), this;
      }, H.prototype.muln = function(t) {
        return this.clone().imuln(t);
      }, H.prototype.sqr = function() {
        return this.mul(this);
      }, H.prototype.isqr = function() {
        return this.imul(this.clone());
      }, H.prototype.pow = function(t) {
        var h = ke(t);
        if (h.length === 0) return new H(1);
        for (var B = this, Z = 0; Z < h.length && h[Z] === 0; Z++, B = B.sqr())
          ;
        if (++Z < h.length)
          for (var ve = B.sqr(); Z < h.length; Z++, ve = ve.sqr())
            h[Z] !== 0 && (B = B.mul(ve));
        return B;
      }, H.prototype.iushln = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 67108863 >>> 26 - h << 26 - h, ve;
        if (h !== 0) {
          var ge = 0;
          for (ve = 0; ve < this.length; ve++) {
            var xe = this.words[ve] & Z, X = (this.words[ve] | 0) - xe << h;
            this.words[ve] = X | ge, ge = xe >>> 26 - h;
          }
          ge && (this.words[ve] = ge, this.length++);
        }
        if (B !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + B] = this.words[ve];
          for (ve = 0; ve < B; ve++)
            this.words[ve] = 0;
          this.length += B;
        }
        return this.strip();
      }, H.prototype.ishln = function(t) {
        return J(this.negative === 0), this.iushln(t);
      }, H.prototype.iushrn = function(t, h, B) {
        J(typeof t == "number" && t >= 0);
        var Z;
        h ? Z = (h - h % 26) / 26 : Z = 0;
        var ve = t % 26, ge = Math.min((t - ve) / 26, this.length), xe = 67108863 ^ 67108863 >>> ve << ve, X = B;
        if (Z -= ge, Z = Math.max(0, Z), X) {
          for (var a = 0; a < ge; a++)
            X.words[a] = this.words[a];
          X.length = ge;
        }
        if (ge !== 0) if (this.length > ge)
          for (this.length -= ge, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + ge];
        else
          this.words[0] = 0, this.length = 1;
        var Y = 0;
        for (a = this.length - 1; a >= 0 && (Y !== 0 || a >= Z); a--) {
          var Ne = this.words[a] | 0;
          this.words[a] = Y << 26 - ve | Ne >>> ve, Y = Ne & xe;
        }
        return X && Y !== 0 && (X.words[X.length++] = Y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, H.prototype.ishrn = function(t, h, B) {
        return J(this.negative === 0), this.iushrn(t, h, B);
      }, H.prototype.shln = function(t) {
        return this.clone().ishln(t);
      }, H.prototype.ushln = function(t) {
        return this.clone().iushln(t);
      }, H.prototype.shrn = function(t) {
        return this.clone().ishrn(t);
      }, H.prototype.ushrn = function(t) {
        return this.clone().iushrn(t);
      }, H.prototype.testn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B) return !1;
        var ve = this.words[B];
        return !!(ve & Z);
      }, H.prototype.imaskn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26;
        if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= B)
          return this;
        if (h !== 0 && B++, this.length = Math.min(B, this.length), h !== 0) {
          var Z = 67108863 ^ 67108863 >>> h << h;
          this.words[this.length - 1] &= Z;
        }
        return this.strip();
      }, H.prototype.maskn = function(t) {
        return this.clone().imaskn(t);
      }, H.prototype.iaddn = function(t) {
        return J(typeof t == "number"), J(t < 67108864), t < 0 ? this.isubn(-t) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < t ? (this.words[0] = t - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
      }, H.prototype._iaddn = function(t) {
        this.words[0] += t;
        for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
          this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
        return this.length = Math.max(this.length, h + 1), this;
      }, H.prototype.isubn = function(t) {
        if (J(typeof t == "number"), J(t < 67108864), t < 0) return this.iaddn(-t);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(t), this.negative = 1, this;
        if (this.words[0] -= t, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var h = 0; h < this.length && this.words[h] < 0; h++)
            this.words[h] += 67108864, this.words[h + 1] -= 1;
        return this.strip();
      }, H.prototype.addn = function(t) {
        return this.clone().iaddn(t);
      }, H.prototype.subn = function(t) {
        return this.clone().isubn(t);
      }, H.prototype.iabs = function() {
        return this.negative = 0, this;
      }, H.prototype.abs = function() {
        return this.clone().iabs();
      }, H.prototype._ishlnsubmul = function(t, h, B) {
        var Z = t.length + B, ve;
        this._expand(Z);
        var ge, xe = 0;
        for (ve = 0; ve < t.length; ve++) {
          ge = (this.words[ve + B] | 0) + xe;
          var X = (t.words[ve] | 0) * h;
          ge -= X & 67108863, xe = (ge >> 26) - (X / 67108864 | 0), this.words[ve + B] = ge & 67108863;
        }
        for (; ve < this.length - B; ve++)
          ge = (this.words[ve + B] | 0) + xe, xe = ge >> 26, this.words[ve + B] = ge & 67108863;
        if (xe === 0) return this.strip();
        for (J(xe === -1), xe = 0, ve = 0; ve < this.length; ve++)
          ge = -(this.words[ve] | 0) + xe, xe = ge >> 26, this.words[ve] = ge & 67108863;
        return this.negative = 1, this.strip();
      }, H.prototype._wordDiv = function(t, h) {
        var B = this.length - t.length, Z = this.clone(), ve = t, ge = ve.words[ve.length - 1] | 0, xe = this._countBits(ge);
        B = 26 - xe, B !== 0 && (ve = ve.ushln(B), Z.iushln(B), ge = ve.words[ve.length - 1] | 0);
        var X = Z.length - ve.length, a;
        if (h !== "mod") {
          a = new H(null), a.length = X + 1, a.words = new Array(a.length);
          for (var Y = 0; Y < a.length; Y++)
            a.words[Y] = 0;
        }
        var Ne = Z.clone()._ishlnsubmul(ve, 1, X);
        Ne.negative === 0 && (Z = Ne, a && (a.words[X] = 1));
        for (var Ke = X - 1; Ke >= 0; Ke--) {
          var tt = (Z.words[ve.length + Ke] | 0) * 67108864 + (Z.words[ve.length + Ke - 1] | 0);
          for (tt = Math.min(tt / ge | 0, 67108863), Z._ishlnsubmul(ve, tt, Ke); Z.negative !== 0; )
            tt--, Z.negative = 0, Z._ishlnsubmul(ve, 1, Ke), Z.isZero() || (Z.negative ^= 1);
          a && (a.words[Ke] = tt);
        }
        return a && a.strip(), Z.strip(), h !== "div" && B !== 0 && Z.iushrn(B), {
          div: a || null,
          mod: Z
        };
      }, H.prototype.divmod = function(t, h, B) {
        if (J(!t.isZero()), this.isZero())
          return {
            div: new H(0),
            mod: new H(0)
          };
        var Z, ve, ge;
        return this.negative !== 0 && t.negative === 0 ? (ge = this.neg().divmod(t, h), h !== "mod" && (Z = ge.div.neg()), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.iadd(t)), {
          div: Z,
          mod: ve
        }) : this.negative === 0 && t.negative !== 0 ? (ge = this.divmod(t.neg(), h), h !== "mod" && (Z = ge.div.neg()), {
          div: Z,
          mod: ge.mod
        }) : this.negative & t.negative ? (ge = this.neg().divmod(t.neg(), h), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.isub(t)), {
          div: ge.div,
          mod: ve
        }) : t.length > this.length || this.cmp(t) < 0 ? {
          div: new H(0),
          mod: this
        } : t.length === 1 ? h === "div" ? {
          div: this.divn(t.words[0]),
          mod: null
        } : h === "mod" ? {
          div: null,
          mod: new H(this.modn(t.words[0]))
        } : {
          div: this.divn(t.words[0]),
          mod: new H(this.modn(t.words[0]))
        } : this._wordDiv(t, h);
      }, H.prototype.div = function(t) {
        return this.divmod(t, "div", !1).div;
      }, H.prototype.mod = function(t) {
        return this.divmod(t, "mod", !1).mod;
      }, H.prototype.umod = function(t) {
        return this.divmod(t, "mod", !0).mod;
      }, H.prototype.divRound = function(t) {
        var h = this.divmod(t);
        if (h.mod.isZero()) return h.div;
        var B = h.div.negative !== 0 ? h.mod.isub(t) : h.mod, Z = t.ushrn(1), ve = t.andln(1), ge = B.cmp(Z);
        return ge < 0 || ve === 1 && ge === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
      }, H.prototype.modn = function(t) {
        J(t <= 67108863);
        for (var h = (1 << 26) % t, B = 0, Z = this.length - 1; Z >= 0; Z--)
          B = (h * B + (this.words[Z] | 0)) % t;
        return B;
      }, H.prototype.idivn = function(t) {
        J(t <= 67108863);
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = (this.words[B] | 0) + h * 67108864;
          this.words[B] = Z / t | 0, h = Z % t;
        }
        return this.strip();
      }, H.prototype.divn = function(t) {
        return this.clone().idivn(t);
      }, H.prototype.egcd = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = new H(0), xe = new H(1), X = 0; h.isEven() && B.isEven(); )
          h.iushrn(1), B.iushrn(1), ++X;
        for (var a = B.clone(), Y = h.clone(); !h.isZero(); ) {
          for (var Ne = 0, Ke = 1; !(h.words[0] & Ke) && Ne < 26; ++Ne, Ke <<= 1) ;
          if (Ne > 0)
            for (h.iushrn(Ne); Ne-- > 0; )
              (Z.isOdd() || ve.isOdd()) && (Z.iadd(a), ve.isub(Y)), Z.iushrn(1), ve.iushrn(1);
          for (var tt = 0, We = 1; !(B.words[0] & We) && tt < 26; ++tt, We <<= 1) ;
          if (tt > 0)
            for (B.iushrn(tt); tt-- > 0; )
              (ge.isOdd() || xe.isOdd()) && (ge.iadd(a), xe.isub(Y)), ge.iushrn(1), xe.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ge), ve.isub(xe)) : (B.isub(h), ge.isub(Z), xe.isub(ve));
        }
        return {
          a: ge,
          b: xe,
          gcd: B.iushln(X)
        };
      }, H.prototype._invmp = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = B.clone(); h.cmpn(1) > 0 && B.cmpn(1) > 0; ) {
          for (var xe = 0, X = 1; !(h.words[0] & X) && xe < 26; ++xe, X <<= 1) ;
          if (xe > 0)
            for (h.iushrn(xe); xe-- > 0; )
              Z.isOdd() && Z.iadd(ge), Z.iushrn(1);
          for (var a = 0, Y = 1; !(B.words[0] & Y) && a < 26; ++a, Y <<= 1) ;
          if (a > 0)
            for (B.iushrn(a); a-- > 0; )
              ve.isOdd() && ve.iadd(ge), ve.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ve)) : (B.isub(h), ve.isub(Z));
        }
        var Ne;
        return h.cmpn(1) === 0 ? Ne = Z : Ne = ve, Ne.cmpn(0) < 0 && Ne.iadd(t), Ne;
      }, H.prototype.gcd = function(t) {
        if (this.isZero()) return t.abs();
        if (t.isZero()) return this.abs();
        var h = this.clone(), B = t.clone();
        h.negative = 0, B.negative = 0;
        for (var Z = 0; h.isEven() && B.isEven(); Z++)
          h.iushrn(1), B.iushrn(1);
        do {
          for (; h.isEven(); )
            h.iushrn(1);
          for (; B.isEven(); )
            B.iushrn(1);
          var ve = h.cmp(B);
          if (ve < 0) {
            var ge = h;
            h = B, B = ge;
          } else if (ve === 0 || B.cmpn(1) === 0)
            break;
          h.isub(B);
        } while (!0);
        return B.iushln(Z);
      }, H.prototype.invm = function(t) {
        return this.egcd(t).a.umod(t);
      }, H.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, H.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, H.prototype.andln = function(t) {
        return this.words[0] & t;
      }, H.prototype.bincn = function(t) {
        J(typeof t == "number");
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B)
          return this._expand(B + 1), this.words[B] |= Z, this;
        for (var ve = Z, ge = B; ve !== 0 && ge < this.length; ge++) {
          var xe = this.words[ge] | 0;
          xe += ve, ve = xe >>> 26, xe &= 67108863, this.words[ge] = xe;
        }
        return ve !== 0 && (this.words[ge] = ve, this.length++), this;
      }, H.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, H.prototype.cmpn = function(t) {
        var h = t < 0;
        if (this.negative !== 0 && !h) return -1;
        if (this.negative === 0 && h) return 1;
        this.strip();
        var B;
        if (this.length > 1)
          B = 1;
        else {
          h && (t = -t), J(t <= 67108863, "Number is too big");
          var Z = this.words[0] | 0;
          B = Z === t ? 0 : Z < t ? -1 : 1;
        }
        return this.negative !== 0 ? -B | 0 : B;
      }, H.prototype.cmp = function(t) {
        if (this.negative !== 0 && t.negative === 0) return -1;
        if (this.negative === 0 && t.negative !== 0) return 1;
        var h = this.ucmp(t);
        return this.negative !== 0 ? -h | 0 : h;
      }, H.prototype.ucmp = function(t) {
        if (this.length > t.length) return 1;
        if (this.length < t.length) return -1;
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = this.words[B] | 0, ve = t.words[B] | 0;
          if (Z !== ve) {
            Z < ve ? h = -1 : Z > ve && (h = 1);
            break;
          }
        }
        return h;
      }, H.prototype.gtn = function(t) {
        return this.cmpn(t) === 1;
      }, H.prototype.gt = function(t) {
        return this.cmp(t) === 1;
      }, H.prototype.gten = function(t) {
        return this.cmpn(t) >= 0;
      }, H.prototype.gte = function(t) {
        return this.cmp(t) >= 0;
      }, H.prototype.ltn = function(t) {
        return this.cmpn(t) === -1;
      }, H.prototype.lt = function(t) {
        return this.cmp(t) === -1;
      }, H.prototype.lten = function(t) {
        return this.cmpn(t) <= 0;
      }, H.prototype.lte = function(t) {
        return this.cmp(t) <= 0;
      }, H.prototype.eqn = function(t) {
        return this.cmpn(t) === 0;
      }, H.prototype.eq = function(t) {
        return this.cmp(t) === 0;
      }, H.red = function(t) {
        return new bt(t);
      }, H.prototype.toRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), t.convertTo(this)._forceRed(t);
      }, H.prototype.fromRed = function() {
        return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, H.prototype._forceRed = function(t) {
        return this.red = t, this;
      }, H.prototype.forceRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), this._forceRed(t);
      }, H.prototype.redAdd = function(t) {
        return J(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
      }, H.prototype.redIAdd = function(t) {
        return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
      }, H.prototype.redSub = function(t) {
        return J(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
      }, H.prototype.redISub = function(t) {
        return J(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
      }, H.prototype.redShl = function(t) {
        return J(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
      }, H.prototype.redMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
      }, H.prototype.redIMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
      }, H.prototype.redSqr = function() {
        return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, H.prototype.redISqr = function() {
        return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, H.prototype.redSqrt = function() {
        return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, H.prototype.redInvm = function() {
        return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, H.prototype.redNeg = function() {
        return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, H.prototype.redPow = function(t) {
        return J(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
      };
      var ut = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function rt(Se, t) {
        this.name = Se, this.p = new H(t, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      rt.prototype._tmp = function() {
        var t = new H(null);
        return t.words = new Array(Math.ceil(this.n / 13)), t;
      }, rt.prototype.ireduce = function(t) {
        var h = t, B;
        do
          this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), B = h.bitLength();
        while (B > this.n);
        var Z = B < this.n ? -1 : h.ucmp(this.p);
        return Z === 0 ? (h.words[0] = 0, h.length = 1) : Z > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
      }, rt.prototype.split = function(t, h) {
        t.iushrn(this.n, 0, h);
      }, rt.prototype.imulK = function(t) {
        return t.imul(this.k);
      };
      function lt() {
        rt.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      _e(lt, rt), lt.prototype.split = function(t, h) {
        for (var B = 4194303, Z = Math.min(t.length, 9), ve = 0; ve < Z; ve++)
          h.words[ve] = t.words[ve];
        if (h.length = Z, t.length <= 9) {
          t.words[0] = 0, t.length = 1;
          return;
        }
        var ge = t.words[9];
        for (h.words[h.length++] = ge & B, ve = 10; ve < t.length; ve++) {
          var xe = t.words[ve] | 0;
          t.words[ve - 10] = (xe & B) << 4 | ge >>> 22, ge = xe;
        }
        ge >>>= 22, t.words[ve - 10] = ge, ge === 0 && t.length > 10 ? t.length -= 10 : t.length -= 9;
      }, lt.prototype.imulK = function(t) {
        t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = t.words[B] | 0;
          h += Z * 977, t.words[B] = h & 67108863, h = Z * 64 + (h / 67108864 | 0);
        }
        return t.words[t.length - 1] === 0 && (t.length--, t.words[t.length - 1] === 0 && t.length--), t;
      };
      function vt() {
        rt.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      _e(vt, rt);
      function Ye() {
        rt.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      _e(Ye, rt);
      function pt() {
        rt.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      _e(pt, rt), pt.prototype.imulK = function(t) {
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = (t.words[B] | 0) * 19 + h, ve = Z & 67108863;
          Z >>>= 26, t.words[B] = ve, h = Z;
        }
        return h !== 0 && (t.words[t.length++] = h), t;
      }, H._prime = function(t) {
        if (ut[t]) return ut[t];
        var h;
        if (t === "k256")
          h = new lt();
        else if (t === "p224")
          h = new vt();
        else if (t === "p192")
          h = new Ye();
        else if (t === "p25519")
          h = new pt();
        else
          throw new Error("Unknown prime " + t);
        return ut[t] = h, h;
      };
      function bt(Se) {
        if (typeof Se == "string") {
          var t = H._prime(Se);
          this.m = t.p, this.prime = t;
        } else
          J(Se.gtn(1), "modulus must be greater than 1"), this.m = Se, this.prime = null;
      }
      bt.prototype._verify1 = function(t) {
        J(t.negative === 0, "red works only with positives"), J(t.red, "red works only with red numbers");
      }, bt.prototype._verify2 = function(t, h) {
        J((t.negative | h.negative) === 0, "red works only with positives"), J(
          t.red && t.red === h.red,
          "red works only with red numbers"
        );
      }, bt.prototype.imod = function(t) {
        return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
      }, bt.prototype.neg = function(t) {
        return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
      }, bt.prototype.add = function(t, h) {
        this._verify2(t, h);
        var B = t.add(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B._forceRed(this);
      }, bt.prototype.iadd = function(t, h) {
        this._verify2(t, h);
        var B = t.iadd(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B;
      }, bt.prototype.sub = function(t, h) {
        this._verify2(t, h);
        var B = t.sub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B._forceRed(this);
      }, bt.prototype.isub = function(t, h) {
        this._verify2(t, h);
        var B = t.isub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B;
      }, bt.prototype.shl = function(t, h) {
        return this._verify1(t), this.imod(t.ushln(h));
      }, bt.prototype.imul = function(t, h) {
        return this._verify2(t, h), this.imod(t.imul(h));
      }, bt.prototype.mul = function(t, h) {
        return this._verify2(t, h), this.imod(t.mul(h));
      }, bt.prototype.isqr = function(t) {
        return this.imul(t, t.clone());
      }, bt.prototype.sqr = function(t) {
        return this.mul(t, t);
      }, bt.prototype.sqrt = function(t) {
        if (t.isZero()) return t.clone();
        var h = this.m.andln(3);
        if (J(h % 2 === 1), h === 3) {
          var B = this.m.add(new H(1)).iushrn(2);
          return this.pow(t, B);
        }
        for (var Z = this.m.subn(1), ve = 0; !Z.isZero() && Z.andln(1) === 0; )
          ve++, Z.iushrn(1);
        J(!Z.isZero());
        var ge = new H(1).toRed(this), xe = ge.redNeg(), X = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new H(2 * a * a).toRed(this); this.pow(a, X).cmp(xe) !== 0; )
          a.redIAdd(xe);
        for (var Y = this.pow(a, Z), Ne = this.pow(t, Z.addn(1).iushrn(1)), Ke = this.pow(t, Z), tt = ve; Ke.cmp(ge) !== 0; ) {
          for (var We = Ke, ot = 0; We.cmp(ge) !== 0; ot++)
            We = We.redSqr();
          J(ot < tt);
          var He = this.pow(Y, new H(1).iushln(tt - ot - 1));
          Ne = Ne.redMul(He), Y = He.redSqr(), Ke = Ke.redMul(Y), tt = ot;
        }
        return Ne;
      }, bt.prototype.invm = function(t) {
        var h = t._invmp(this.m);
        return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
      }, bt.prototype.pow = function(t, h) {
        if (h.isZero()) return new H(1).toRed(this);
        if (h.cmpn(1) === 0) return t.clone();
        var B = 4, Z = new Array(1 << B);
        Z[0] = new H(1).toRed(this), Z[1] = t;
        for (var ve = 2; ve < Z.length; ve++)
          Z[ve] = this.mul(Z[ve - 1], t);
        var ge = Z[0], xe = 0, X = 0, a = h.bitLength() % 26;
        for (a === 0 && (a = 26), ve = h.length - 1; ve >= 0; ve--) {
          for (var Y = h.words[ve], Ne = a - 1; Ne >= 0; Ne--) {
            var Ke = Y >> Ne & 1;
            if (ge !== Z[0] && (ge = this.sqr(ge)), Ke === 0 && xe === 0) {
              X = 0;
              continue;
            }
            xe <<= 1, xe |= Ke, X++, !(X !== B && (ve !== 0 || Ne !== 0)) && (ge = this.mul(ge, Z[xe]), X = 0, xe = 0);
          }
          a = 26;
        }
        return ge;
      }, bt.prototype.convertTo = function(t) {
        var h = t.umod(this.m);
        return h === t ? h.clone() : h;
      }, bt.prototype.convertFrom = function(t) {
        var h = t.clone();
        return h.red = null, h;
      }, H.mont = function(t) {
        return new Yt(t);
      };
      function Yt(Se) {
        bt.call(this, Se), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      _e(Yt, bt), Yt.prototype.convertTo = function(t) {
        return this.imod(t.ushln(this.shift));
      }, Yt.prototype.convertFrom = function(t) {
        var h = this.imod(t.mul(this.rinv));
        return h.red = null, h;
      }, Yt.prototype.imul = function(t, h) {
        if (t.isZero() || h.isZero())
          return t.words[0] = 0, t.length = 1, t;
        var B = t.imul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.mul = function(t, h) {
        if (t.isZero() || h.isZero()) return new H(0)._forceRed(this);
        var B = t.mul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.invm = function(t) {
        var h = this.imod(t._invmp(this.m).mul(this.r2));
        return h._forceRed(this);
      };
    })(I, commonjsGlobal);
  }(bn$4)), bn$4.exports;
}
var utils$m = {};
(function(I) {
  var A = I;
  function G(H, De) {
    if (Array.isArray(H))
      return H.slice();
    if (!H)
      return [];
    var Ie = [];
    if (typeof H != "string") {
      for (var qe = 0; qe < H.length; qe++)
        Ie[qe] = H[qe] | 0;
      return Ie;
    }
    if (De === "hex") {
      H = H.replace(/[^a-z0-9]+/ig, ""), H.length % 2 !== 0 && (H = "0" + H);
      for (var qe = 0; qe < H.length; qe += 2)
        Ie.push(parseInt(H[qe] + H[qe + 1], 16));
    } else
      for (var qe = 0; qe < H.length; qe++) {
        var Te = H.charCodeAt(qe), Ee = Te >> 8, Oe = Te & 255;
        Ee ? Ie.push(Ee, Oe) : Ie.push(Oe);
      }
    return Ie;
  }
  A.toArray = G;
  function J(H) {
    return H.length === 1 ? "0" + H : H;
  }
  A.zero2 = J;
  function _e(H) {
    for (var De = "", Ie = 0; Ie < H.length; Ie++)
      De += J(H[Ie].toString(16));
    return De;
  }
  A.toHex = _e, A.encode = function(De, Ie) {
    return Ie === "hex" ? _e(De) : De;
  };
})(utils$m);
var hasRequiredUtils;
function requireUtils() {
  return hasRequiredUtils || (hasRequiredUtils = 1, function(I) {
    var A = I, G = requireBn$3(), J = minimalisticAssert, _e = utils$m;
    A.assert = J, A.toArray = _e.toArray, A.zero2 = _e.zero2, A.toHex = _e.toHex, A.encode = _e.encode;
    function H(Ee, Oe, Le) {
      var ke = new Array(Math.max(Ee.bitLength(), Le) + 1), Fe;
      for (Fe = 0; Fe < ke.length; Fe += 1)
        ke[Fe] = 0;
      var Ge = 1 << Oe + 1, et = Ee.clone();
      for (Fe = 0; Fe < ke.length; Fe++) {
        var Ve, Je = et.andln(Ge - 1);
        et.isOdd() ? (Je > (Ge >> 1) - 1 ? Ve = (Ge >> 1) - Je : Ve = Je, et.isubn(Ve)) : Ve = 0, ke[Fe] = Ve, et.iushrn(1);
      }
      return ke;
    }
    A.getNAF = H;
    function De(Ee, Oe) {
      var Le = [
        [],
        []
      ];
      Ee = Ee.clone(), Oe = Oe.clone();
      for (var ke = 0, Fe = 0, Ge; Ee.cmpn(-ke) > 0 || Oe.cmpn(-Fe) > 0; ) {
        var et = Ee.andln(3) + ke & 3, Ve = Oe.andln(3) + Fe & 3;
        et === 3 && (et = -1), Ve === 3 && (Ve = -1);
        var Je;
        et & 1 ? (Ge = Ee.andln(7) + ke & 7, (Ge === 3 || Ge === 5) && Ve === 2 ? Je = -et : Je = et) : Je = 0, Le[0].push(Je);
        var ut;
        Ve & 1 ? (Ge = Oe.andln(7) + Fe & 7, (Ge === 3 || Ge === 5) && et === 2 ? ut = -Ve : ut = Ve) : ut = 0, Le[1].push(ut), 2 * ke === Je + 1 && (ke = 1 - ke), 2 * Fe === ut + 1 && (Fe = 1 - Fe), Ee.iushrn(1), Oe.iushrn(1);
      }
      return Le;
    }
    A.getJSF = De;
    function Ie(Ee, Oe, Le) {
      var ke = "_" + Oe;
      Ee.prototype[Oe] = function() {
        return this[ke] !== void 0 ? this[ke] : this[ke] = Le.call(this);
      };
    }
    A.cachedProperty = Ie;
    function qe(Ee) {
      return typeof Ee == "string" ? A.toArray(Ee, "hex") : Ee;
    }
    A.parseBytes = qe;
    function Te(Ee) {
      return new G(Ee, "hex", "le");
    }
    A.intFromLE = Te;
  }(utils$n)), utils$n;
}
var curve$1 = {}, base$3, hasRequiredBase$1;
function requireBase$1() {
  if (hasRequiredBase$1) return base$3;
  hasRequiredBase$1 = 1;
  var I = requireBn$3(), A = requireUtils(), G = A.getNAF, J = A.getJSF, _e = A.assert;
  function H(Ie, qe) {
    this.type = Ie, this.p = new I(qe.p, 16), this.red = qe.prime ? I.red(qe.prime) : I.mont(this.p), this.zero = new I(0).toRed(this.red), this.one = new I(1).toRed(this.red), this.two = new I(2).toRed(this.red), this.n = qe.n && new I(qe.n, 16), this.g = qe.g && this.pointFromJSON(qe.g, qe.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var Te = this.n && this.p.div(this.n);
    !Te || Te.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  base$3 = H, H.prototype.point = function() {
    throw new Error("Not implemented");
  }, H.prototype.validate = function() {
    throw new Error("Not implemented");
  }, H.prototype._fixedNafMul = function(qe, Te) {
    _e(qe.precomputed);
    var Ee = qe._getDoubles(), Oe = G(Te, 1, this._bitLength), Le = (1 << Ee.step + 1) - (Ee.step % 2 === 0 ? 2 : 1);
    Le /= 3;
    var ke = [], Fe, Ge;
    for (Fe = 0; Fe < Oe.length; Fe += Ee.step) {
      Ge = 0;
      for (var et = Fe + Ee.step - 1; et >= Fe; et--)
        Ge = (Ge << 1) + Oe[et];
      ke.push(Ge);
    }
    for (var Ve = this.jpoint(null, null, null), Je = this.jpoint(null, null, null), ut = Le; ut > 0; ut--) {
      for (Fe = 0; Fe < ke.length; Fe++)
        Ge = ke[Fe], Ge === ut ? Je = Je.mixedAdd(Ee.points[Fe]) : Ge === -ut && (Je = Je.mixedAdd(Ee.points[Fe].neg()));
      Ve = Ve.add(Je);
    }
    return Ve.toP();
  }, H.prototype._wnafMul = function(qe, Te) {
    var Ee = 4, Oe = qe._getNAFPoints(Ee);
    Ee = Oe.wnd;
    for (var Le = Oe.points, ke = G(Te, Ee, this._bitLength), Fe = this.jpoint(null, null, null), Ge = ke.length - 1; Ge >= 0; Ge--) {
      for (var et = 0; Ge >= 0 && ke[Ge] === 0; Ge--)
        et++;
      if (Ge >= 0 && et++, Fe = Fe.dblp(et), Ge < 0)
        break;
      var Ve = ke[Ge];
      _e(Ve !== 0), qe.type === "affine" ? Ve > 0 ? Fe = Fe.mixedAdd(Le[Ve - 1 >> 1]) : Fe = Fe.mixedAdd(Le[-Ve - 1 >> 1].neg()) : Ve > 0 ? Fe = Fe.add(Le[Ve - 1 >> 1]) : Fe = Fe.add(Le[-Ve - 1 >> 1].neg());
    }
    return qe.type === "affine" ? Fe.toP() : Fe;
  }, H.prototype._wnafMulAdd = function(qe, Te, Ee, Oe, Le) {
    var ke = this._wnafT1, Fe = this._wnafT2, Ge = this._wnafT3, et = 0, Ve, Je, ut;
    for (Ve = 0; Ve < Oe; Ve++) {
      ut = Te[Ve];
      var rt = ut._getNAFPoints(qe);
      ke[Ve] = rt.wnd, Fe[Ve] = rt.points;
    }
    for (Ve = Oe - 1; Ve >= 1; Ve -= 2) {
      var lt = Ve - 1, vt = Ve;
      if (ke[lt] !== 1 || ke[vt] !== 1) {
        Ge[lt] = G(Ee[lt], ke[lt], this._bitLength), Ge[vt] = G(Ee[vt], ke[vt], this._bitLength), et = Math.max(Ge[lt].length, et), et = Math.max(Ge[vt].length, et);
        continue;
      }
      var Ye = [
        Te[lt],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        Te[vt]
        /* 7 */
      ];
      Te[lt].y.cmp(Te[vt].y) === 0 ? (Ye[1] = Te[lt].add(Te[vt]), Ye[2] = Te[lt].toJ().mixedAdd(Te[vt].neg())) : Te[lt].y.cmp(Te[vt].y.redNeg()) === 0 ? (Ye[1] = Te[lt].toJ().mixedAdd(Te[vt]), Ye[2] = Te[lt].add(Te[vt].neg())) : (Ye[1] = Te[lt].toJ().mixedAdd(Te[vt]), Ye[2] = Te[lt].toJ().mixedAdd(Te[vt].neg()));
      var pt = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], bt = J(Ee[lt], Ee[vt]);
      for (et = Math.max(bt[0].length, et), Ge[lt] = new Array(et), Ge[vt] = new Array(et), Je = 0; Je < et; Je++) {
        var Yt = bt[0][Je] | 0, Se = bt[1][Je] | 0;
        Ge[lt][Je] = pt[(Yt + 1) * 3 + (Se + 1)], Ge[vt][Je] = 0, Fe[lt] = Ye;
      }
    }
    var t = this.jpoint(null, null, null), h = this._wnafT4;
    for (Ve = et; Ve >= 0; Ve--) {
      for (var B = 0; Ve >= 0; ) {
        var Z = !0;
        for (Je = 0; Je < Oe; Je++)
          h[Je] = Ge[Je][Ve] | 0, h[Je] !== 0 && (Z = !1);
        if (!Z)
          break;
        B++, Ve--;
      }
      if (Ve >= 0 && B++, t = t.dblp(B), Ve < 0)
        break;
      for (Je = 0; Je < Oe; Je++) {
        var ve = h[Je];
        ve !== 0 && (ve > 0 ? ut = Fe[Je][ve - 1 >> 1] : ve < 0 && (ut = Fe[Je][-ve - 1 >> 1].neg()), ut.type === "affine" ? t = t.mixedAdd(ut) : t = t.add(ut));
      }
    }
    for (Ve = 0; Ve < Oe; Ve++)
      Fe[Ve] = null;
    return Le ? t : t.toP();
  };
  function De(Ie, qe) {
    this.curve = Ie, this.type = qe, this.precomputed = null;
  }
  return H.BasePoint = De, De.prototype.eq = function() {
    throw new Error("Not implemented");
  }, De.prototype.validate = function() {
    return this.curve.validate(this);
  }, H.prototype.decodePoint = function(qe, Te) {
    qe = A.toArray(qe, Te);
    var Ee = this.p.byteLength();
    if ((qe[0] === 4 || qe[0] === 6 || qe[0] === 7) && qe.length - 1 === 2 * Ee) {
      qe[0] === 6 ? _e(qe[qe.length - 1] % 2 === 0) : qe[0] === 7 && _e(qe[qe.length - 1] % 2 === 1);
      var Oe = this.point(
        qe.slice(1, 1 + Ee),
        qe.slice(1 + Ee, 1 + 2 * Ee)
      );
      return Oe;
    } else if ((qe[0] === 2 || qe[0] === 3) && qe.length - 1 === Ee)
      return this.pointFromX(qe.slice(1, 1 + Ee), qe[0] === 3);
    throw new Error("Unknown point format");
  }, De.prototype.encodeCompressed = function(qe) {
    return this.encode(qe, !0);
  }, De.prototype._encode = function(qe) {
    var Te = this.curve.p.byteLength(), Ee = this.getX().toArray("be", Te);
    return qe ? [this.getY().isEven() ? 2 : 3].concat(Ee) : [4].concat(Ee, this.getY().toArray("be", Te));
  }, De.prototype.encode = function(qe, Te) {
    return A.encode(this._encode(Te), qe);
  }, De.prototype.precompute = function(qe) {
    if (this.precomputed)
      return this;
    var Te = {
      doubles: null,
      naf: null,
      beta: null
    };
    return Te.naf = this._getNAFPoints(8), Te.doubles = this._getDoubles(4, qe), Te.beta = this._getBeta(), this.precomputed = Te, this;
  }, De.prototype._hasDoubles = function(qe) {
    if (!this.precomputed)
      return !1;
    var Te = this.precomputed.doubles;
    return Te ? Te.points.length >= Math.ceil((qe.bitLength() + 1) / Te.step) : !1;
  }, De.prototype._getDoubles = function(qe, Te) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var Ee = [this], Oe = this, Le = 0; Le < Te; Le += qe) {
      for (var ke = 0; ke < qe; ke++)
        Oe = Oe.dbl();
      Ee.push(Oe);
    }
    return {
      step: qe,
      points: Ee
    };
  }, De.prototype._getNAFPoints = function(qe) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var Te = [this], Ee = (1 << qe) - 1, Oe = Ee === 1 ? null : this.dbl(), Le = 1; Le < Ee; Le++)
      Te[Le] = Te[Le - 1].add(Oe);
    return {
      wnd: qe,
      points: Te
    };
  }, De.prototype._getBeta = function() {
    return null;
  }, De.prototype.dblp = function(qe) {
    for (var Te = this, Ee = 0; Ee < qe; Ee++)
      Te = Te.dbl();
    return Te;
  }, base$3;
}
var short$1, hasRequiredShort;
function requireShort() {
  if (hasRequiredShort) return short$1;
  hasRequiredShort = 1;
  var I = requireUtils(), A = requireBn$3(), G = inherits_browserExports, J = requireBase$1(), _e = I.assert;
  function H(qe) {
    J.call(this, "short", qe), this.a = new A(qe.a, 16).toRed(this.red), this.b = new A(qe.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(qe), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  G(H, J), short$1 = H, H.prototype._getEndomorphism = function(Te) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var Ee, Oe;
      if (Te.beta)
        Ee = new A(Te.beta, 16).toRed(this.red);
      else {
        var Le = this._getEndoRoots(this.p);
        Ee = Le[0].cmp(Le[1]) < 0 ? Le[0] : Le[1], Ee = Ee.toRed(this.red);
      }
      if (Te.lambda)
        Oe = new A(Te.lambda, 16);
      else {
        var ke = this._getEndoRoots(this.n);
        this.g.mul(ke[0]).x.cmp(this.g.x.redMul(Ee)) === 0 ? Oe = ke[0] : (Oe = ke[1], _e(this.g.mul(Oe).x.cmp(this.g.x.redMul(Ee)) === 0));
      }
      var Fe;
      return Te.basis ? Fe = Te.basis.map(function(Ge) {
        return {
          a: new A(Ge.a, 16),
          b: new A(Ge.b, 16)
        };
      }) : Fe = this._getEndoBasis(Oe), {
        beta: Ee,
        lambda: Oe,
        basis: Fe
      };
    }
  }, H.prototype._getEndoRoots = function(Te) {
    var Ee = Te === this.p ? this.red : A.mont(Te), Oe = new A(2).toRed(Ee).redInvm(), Le = Oe.redNeg(), ke = new A(3).toRed(Ee).redNeg().redSqrt().redMul(Oe), Fe = Le.redAdd(ke).fromRed(), Ge = Le.redSub(ke).fromRed();
    return [Fe, Ge];
  }, H.prototype._getEndoBasis = function(Te) {
    for (var Ee = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), Oe = Te, Le = this.n.clone(), ke = new A(1), Fe = new A(0), Ge = new A(0), et = new A(1), Ve, Je, ut, rt, lt, vt, Ye, pt = 0, bt, Yt; Oe.cmpn(0) !== 0; ) {
      var Se = Le.div(Oe);
      bt = Le.sub(Se.mul(Oe)), Yt = Ge.sub(Se.mul(ke));
      var t = et.sub(Se.mul(Fe));
      if (!ut && bt.cmp(Ee) < 0)
        Ve = Ye.neg(), Je = ke, ut = bt.neg(), rt = Yt;
      else if (ut && ++pt === 2)
        break;
      Ye = bt, Le = Oe, Oe = bt, Ge = ke, ke = Yt, et = Fe, Fe = t;
    }
    lt = bt.neg(), vt = Yt;
    var h = ut.sqr().add(rt.sqr()), B = lt.sqr().add(vt.sqr());
    return B.cmp(h) >= 0 && (lt = Ve, vt = Je), ut.negative && (ut = ut.neg(), rt = rt.neg()), lt.negative && (lt = lt.neg(), vt = vt.neg()), [
      { a: ut, b: rt },
      { a: lt, b: vt }
    ];
  }, H.prototype._endoSplit = function(Te) {
    var Ee = this.endo.basis, Oe = Ee[0], Le = Ee[1], ke = Le.b.mul(Te).divRound(this.n), Fe = Oe.b.neg().mul(Te).divRound(this.n), Ge = ke.mul(Oe.a), et = Fe.mul(Le.a), Ve = ke.mul(Oe.b), Je = Fe.mul(Le.b), ut = Te.sub(Ge).sub(et), rt = Ve.add(Je).neg();
    return { k1: ut, k2: rt };
  }, H.prototype.pointFromX = function(Te, Ee) {
    Te = new A(Te, 16), Te.red || (Te = Te.toRed(this.red));
    var Oe = Te.redSqr().redMul(Te).redIAdd(Te.redMul(this.a)).redIAdd(this.b), Le = Oe.redSqrt();
    if (Le.redSqr().redSub(Oe).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var ke = Le.fromRed().isOdd();
    return (Ee && !ke || !Ee && ke) && (Le = Le.redNeg()), this.point(Te, Le);
  }, H.prototype.validate = function(Te) {
    if (Te.inf)
      return !0;
    var Ee = Te.x, Oe = Te.y, Le = this.a.redMul(Ee), ke = Ee.redSqr().redMul(Ee).redIAdd(Le).redIAdd(this.b);
    return Oe.redSqr().redISub(ke).cmpn(0) === 0;
  }, H.prototype._endoWnafMulAdd = function(Te, Ee, Oe) {
    for (var Le = this._endoWnafT1, ke = this._endoWnafT2, Fe = 0; Fe < Te.length; Fe++) {
      var Ge = this._endoSplit(Ee[Fe]), et = Te[Fe], Ve = et._getBeta();
      Ge.k1.negative && (Ge.k1.ineg(), et = et.neg(!0)), Ge.k2.negative && (Ge.k2.ineg(), Ve = Ve.neg(!0)), Le[Fe * 2] = et, Le[Fe * 2 + 1] = Ve, ke[Fe * 2] = Ge.k1, ke[Fe * 2 + 1] = Ge.k2;
    }
    for (var Je = this._wnafMulAdd(1, Le, ke, Fe * 2, Oe), ut = 0; ut < Fe * 2; ut++)
      Le[ut] = null, ke[ut] = null;
    return Je;
  };
  function De(qe, Te, Ee, Oe) {
    J.BasePoint.call(this, qe, "affine"), Te === null && Ee === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new A(Te, 16), this.y = new A(Ee, 16), Oe && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  G(De, J.BasePoint), H.prototype.point = function(Te, Ee, Oe) {
    return new De(this, Te, Ee, Oe);
  }, H.prototype.pointFromJSON = function(Te, Ee) {
    return De.fromJSON(this, Te, Ee);
  }, De.prototype._getBeta = function() {
    if (this.curve.endo) {
      var Te = this.precomputed;
      if (Te && Te.beta)
        return Te.beta;
      var Ee = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (Te) {
        var Oe = this.curve, Le = function(ke) {
          return Oe.point(ke.x.redMul(Oe.endo.beta), ke.y);
        };
        Te.beta = Ee, Ee.precomputed = {
          beta: null,
          naf: Te.naf && {
            wnd: Te.naf.wnd,
            points: Te.naf.points.map(Le)
          },
          doubles: Te.doubles && {
            step: Te.doubles.step,
            points: Te.doubles.points.map(Le)
          }
        };
      }
      return Ee;
    }
  }, De.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, De.fromJSON = function(Te, Ee, Oe) {
    typeof Ee == "string" && (Ee = JSON.parse(Ee));
    var Le = Te.point(Ee[0], Ee[1], Oe);
    if (!Ee[2])
      return Le;
    function ke(Ge) {
      return Te.point(Ge[0], Ge[1], Oe);
    }
    var Fe = Ee[2];
    return Le.precomputed = {
      beta: null,
      doubles: Fe.doubles && {
        step: Fe.doubles.step,
        points: [Le].concat(Fe.doubles.points.map(ke))
      },
      naf: Fe.naf && {
        wnd: Fe.naf.wnd,
        points: [Le].concat(Fe.naf.points.map(ke))
      }
    }, Le;
  }, De.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, De.prototype.isInfinity = function() {
    return this.inf;
  }, De.prototype.add = function(Te) {
    if (this.inf)
      return Te;
    if (Te.inf)
      return this;
    if (this.eq(Te))
      return this.dbl();
    if (this.neg().eq(Te))
      return this.curve.point(null, null);
    if (this.x.cmp(Te.x) === 0)
      return this.curve.point(null, null);
    var Ee = this.y.redSub(Te.y);
    Ee.cmpn(0) !== 0 && (Ee = Ee.redMul(this.x.redSub(Te.x).redInvm()));
    var Oe = Ee.redSqr().redISub(this.x).redISub(Te.x), Le = Ee.redMul(this.x.redSub(Oe)).redISub(this.y);
    return this.curve.point(Oe, Le);
  }, De.prototype.dbl = function() {
    if (this.inf)
      return this;
    var Te = this.y.redAdd(this.y);
    if (Te.cmpn(0) === 0)
      return this.curve.point(null, null);
    var Ee = this.curve.a, Oe = this.x.redSqr(), Le = Te.redInvm(), ke = Oe.redAdd(Oe).redIAdd(Oe).redIAdd(Ee).redMul(Le), Fe = ke.redSqr().redISub(this.x.redAdd(this.x)), Ge = ke.redMul(this.x.redSub(Fe)).redISub(this.y);
    return this.curve.point(Fe, Ge);
  }, De.prototype.getX = function() {
    return this.x.fromRed();
  }, De.prototype.getY = function() {
    return this.y.fromRed();
  }, De.prototype.mul = function(Te) {
    return Te = new A(Te, 16), this.isInfinity() ? this : this._hasDoubles(Te) ? this.curve._fixedNafMul(this, Te) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [Te]) : this.curve._wnafMul(this, Te);
  }, De.prototype.mulAdd = function(Te, Ee, Oe) {
    var Le = [this, Ee], ke = [Te, Oe];
    return this.curve.endo ? this.curve._endoWnafMulAdd(Le, ke) : this.curve._wnafMulAdd(1, Le, ke, 2);
  }, De.prototype.jmulAdd = function(Te, Ee, Oe) {
    var Le = [this, Ee], ke = [Te, Oe];
    return this.curve.endo ? this.curve._endoWnafMulAdd(Le, ke, !0) : this.curve._wnafMulAdd(1, Le, ke, 2, !0);
  }, De.prototype.eq = function(Te) {
    return this === Te || this.inf === Te.inf && (this.inf || this.x.cmp(Te.x) === 0 && this.y.cmp(Te.y) === 0);
  }, De.prototype.neg = function(Te) {
    if (this.inf)
      return this;
    var Ee = this.curve.point(this.x, this.y.redNeg());
    if (Te && this.precomputed) {
      var Oe = this.precomputed, Le = function(ke) {
        return ke.neg();
      };
      Ee.precomputed = {
        naf: Oe.naf && {
          wnd: Oe.naf.wnd,
          points: Oe.naf.points.map(Le)
        },
        doubles: Oe.doubles && {
          step: Oe.doubles.step,
          points: Oe.doubles.points.map(Le)
        }
      };
    }
    return Ee;
  }, De.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var Te = this.curve.jpoint(this.x, this.y, this.curve.one);
    return Te;
  };
  function Ie(qe, Te, Ee, Oe) {
    J.BasePoint.call(this, qe, "jacobian"), Te === null && Ee === null && Oe === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new A(0)) : (this.x = new A(Te, 16), this.y = new A(Ee, 16), this.z = new A(Oe, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return G(Ie, J.BasePoint), H.prototype.jpoint = function(Te, Ee, Oe) {
    return new Ie(this, Te, Ee, Oe);
  }, Ie.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var Te = this.z.redInvm(), Ee = Te.redSqr(), Oe = this.x.redMul(Ee), Le = this.y.redMul(Ee).redMul(Te);
    return this.curve.point(Oe, Le);
  }, Ie.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, Ie.prototype.add = function(Te) {
    if (this.isInfinity())
      return Te;
    if (Te.isInfinity())
      return this;
    var Ee = Te.z.redSqr(), Oe = this.z.redSqr(), Le = this.x.redMul(Ee), ke = Te.x.redMul(Oe), Fe = this.y.redMul(Ee.redMul(Te.z)), Ge = Te.y.redMul(Oe.redMul(this.z)), et = Le.redSub(ke), Ve = Fe.redSub(Ge);
    if (et.cmpn(0) === 0)
      return Ve.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var Je = et.redSqr(), ut = Je.redMul(et), rt = Le.redMul(Je), lt = Ve.redSqr().redIAdd(ut).redISub(rt).redISub(rt), vt = Ve.redMul(rt.redISub(lt)).redISub(Fe.redMul(ut)), Ye = this.z.redMul(Te.z).redMul(et);
    return this.curve.jpoint(lt, vt, Ye);
  }, Ie.prototype.mixedAdd = function(Te) {
    if (this.isInfinity())
      return Te.toJ();
    if (Te.isInfinity())
      return this;
    var Ee = this.z.redSqr(), Oe = this.x, Le = Te.x.redMul(Ee), ke = this.y, Fe = Te.y.redMul(Ee).redMul(this.z), Ge = Oe.redSub(Le), et = ke.redSub(Fe);
    if (Ge.cmpn(0) === 0)
      return et.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var Ve = Ge.redSqr(), Je = Ve.redMul(Ge), ut = Oe.redMul(Ve), rt = et.redSqr().redIAdd(Je).redISub(ut).redISub(ut), lt = et.redMul(ut.redISub(rt)).redISub(ke.redMul(Je)), vt = this.z.redMul(Ge);
    return this.curve.jpoint(rt, lt, vt);
  }, Ie.prototype.dblp = function(Te) {
    if (Te === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!Te)
      return this.dbl();
    var Ee;
    if (this.curve.zeroA || this.curve.threeA) {
      var Oe = this;
      for (Ee = 0; Ee < Te; Ee++)
        Oe = Oe.dbl();
      return Oe;
    }
    var Le = this.curve.a, ke = this.curve.tinv, Fe = this.x, Ge = this.y, et = this.z, Ve = et.redSqr().redSqr(), Je = Ge.redAdd(Ge);
    for (Ee = 0; Ee < Te; Ee++) {
      var ut = Fe.redSqr(), rt = Je.redSqr(), lt = rt.redSqr(), vt = ut.redAdd(ut).redIAdd(ut).redIAdd(Le.redMul(Ve)), Ye = Fe.redMul(rt), pt = vt.redSqr().redISub(Ye.redAdd(Ye)), bt = Ye.redISub(pt), Yt = vt.redMul(bt);
      Yt = Yt.redIAdd(Yt).redISub(lt);
      var Se = Je.redMul(et);
      Ee + 1 < Te && (Ve = Ve.redMul(lt)), Fe = pt, et = Se, Je = Yt;
    }
    return this.curve.jpoint(Fe, Je.redMul(ke), et);
  }, Ie.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, Ie.prototype._zeroDbl = function() {
    var Te, Ee, Oe;
    if (this.zOne) {
      var Le = this.x.redSqr(), ke = this.y.redSqr(), Fe = ke.redSqr(), Ge = this.x.redAdd(ke).redSqr().redISub(Le).redISub(Fe);
      Ge = Ge.redIAdd(Ge);
      var et = Le.redAdd(Le).redIAdd(Le), Ve = et.redSqr().redISub(Ge).redISub(Ge), Je = Fe.redIAdd(Fe);
      Je = Je.redIAdd(Je), Je = Je.redIAdd(Je), Te = Ve, Ee = et.redMul(Ge.redISub(Ve)).redISub(Je), Oe = this.y.redAdd(this.y);
    } else {
      var ut = this.x.redSqr(), rt = this.y.redSqr(), lt = rt.redSqr(), vt = this.x.redAdd(rt).redSqr().redISub(ut).redISub(lt);
      vt = vt.redIAdd(vt);
      var Ye = ut.redAdd(ut).redIAdd(ut), pt = Ye.redSqr(), bt = lt.redIAdd(lt);
      bt = bt.redIAdd(bt), bt = bt.redIAdd(bt), Te = pt.redISub(vt).redISub(vt), Ee = Ye.redMul(vt.redISub(Te)).redISub(bt), Oe = this.y.redMul(this.z), Oe = Oe.redIAdd(Oe);
    }
    return this.curve.jpoint(Te, Ee, Oe);
  }, Ie.prototype._threeDbl = function() {
    var Te, Ee, Oe;
    if (this.zOne) {
      var Le = this.x.redSqr(), ke = this.y.redSqr(), Fe = ke.redSqr(), Ge = this.x.redAdd(ke).redSqr().redISub(Le).redISub(Fe);
      Ge = Ge.redIAdd(Ge);
      var et = Le.redAdd(Le).redIAdd(Le).redIAdd(this.curve.a), Ve = et.redSqr().redISub(Ge).redISub(Ge);
      Te = Ve;
      var Je = Fe.redIAdd(Fe);
      Je = Je.redIAdd(Je), Je = Je.redIAdd(Je), Ee = et.redMul(Ge.redISub(Ve)).redISub(Je), Oe = this.y.redAdd(this.y);
    } else {
      var ut = this.z.redSqr(), rt = this.y.redSqr(), lt = this.x.redMul(rt), vt = this.x.redSub(ut).redMul(this.x.redAdd(ut));
      vt = vt.redAdd(vt).redIAdd(vt);
      var Ye = lt.redIAdd(lt);
      Ye = Ye.redIAdd(Ye);
      var pt = Ye.redAdd(Ye);
      Te = vt.redSqr().redISub(pt), Oe = this.y.redAdd(this.z).redSqr().redISub(rt).redISub(ut);
      var bt = rt.redSqr();
      bt = bt.redIAdd(bt), bt = bt.redIAdd(bt), bt = bt.redIAdd(bt), Ee = vt.redMul(Ye.redISub(Te)).redISub(bt);
    }
    return this.curve.jpoint(Te, Ee, Oe);
  }, Ie.prototype._dbl = function() {
    var Te = this.curve.a, Ee = this.x, Oe = this.y, Le = this.z, ke = Le.redSqr().redSqr(), Fe = Ee.redSqr(), Ge = Oe.redSqr(), et = Fe.redAdd(Fe).redIAdd(Fe).redIAdd(Te.redMul(ke)), Ve = Ee.redAdd(Ee);
    Ve = Ve.redIAdd(Ve);
    var Je = Ve.redMul(Ge), ut = et.redSqr().redISub(Je.redAdd(Je)), rt = Je.redISub(ut), lt = Ge.redSqr();
    lt = lt.redIAdd(lt), lt = lt.redIAdd(lt), lt = lt.redIAdd(lt);
    var vt = et.redMul(rt).redISub(lt), Ye = Oe.redAdd(Oe).redMul(Le);
    return this.curve.jpoint(ut, vt, Ye);
  }, Ie.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var Te = this.x.redSqr(), Ee = this.y.redSqr(), Oe = this.z.redSqr(), Le = Ee.redSqr(), ke = Te.redAdd(Te).redIAdd(Te), Fe = ke.redSqr(), Ge = this.x.redAdd(Ee).redSqr().redISub(Te).redISub(Le);
    Ge = Ge.redIAdd(Ge), Ge = Ge.redAdd(Ge).redIAdd(Ge), Ge = Ge.redISub(Fe);
    var et = Ge.redSqr(), Ve = Le.redIAdd(Le);
    Ve = Ve.redIAdd(Ve), Ve = Ve.redIAdd(Ve), Ve = Ve.redIAdd(Ve);
    var Je = ke.redIAdd(Ge).redSqr().redISub(Fe).redISub(et).redISub(Ve), ut = Ee.redMul(Je);
    ut = ut.redIAdd(ut), ut = ut.redIAdd(ut);
    var rt = this.x.redMul(et).redISub(ut);
    rt = rt.redIAdd(rt), rt = rt.redIAdd(rt);
    var lt = this.y.redMul(Je.redMul(Ve.redISub(Je)).redISub(Ge.redMul(et)));
    lt = lt.redIAdd(lt), lt = lt.redIAdd(lt), lt = lt.redIAdd(lt);
    var vt = this.z.redAdd(Ge).redSqr().redISub(Oe).redISub(et);
    return this.curve.jpoint(rt, lt, vt);
  }, Ie.prototype.mul = function(Te, Ee) {
    return Te = new A(Te, Ee), this.curve._wnafMul(this, Te);
  }, Ie.prototype.eq = function(Te) {
    if (Te.type === "affine")
      return this.eq(Te.toJ());
    if (this === Te)
      return !0;
    var Ee = this.z.redSqr(), Oe = Te.z.redSqr();
    if (this.x.redMul(Oe).redISub(Te.x.redMul(Ee)).cmpn(0) !== 0)
      return !1;
    var Le = Ee.redMul(this.z), ke = Oe.redMul(Te.z);
    return this.y.redMul(ke).redISub(Te.y.redMul(Le)).cmpn(0) === 0;
  }, Ie.prototype.eqXToP = function(Te) {
    var Ee = this.z.redSqr(), Oe = Te.toRed(this.curve.red).redMul(Ee);
    if (this.x.cmp(Oe) === 0)
      return !0;
    for (var Le = Te.clone(), ke = this.curve.redN.redMul(Ee); ; ) {
      if (Le.iadd(this.curve.n), Le.cmp(this.curve.p) >= 0)
        return !1;
      if (Oe.redIAdd(ke), this.x.cmp(Oe) === 0)
        return !0;
    }
  }, Ie.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, Ie.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, short$1;
}
var mont$1, hasRequiredMont;
function requireMont() {
  if (hasRequiredMont) return mont$1;
  hasRequiredMont = 1;
  var I = requireBn$3(), A = inherits_browserExports, G = requireBase$1(), J = requireUtils();
  function _e(De) {
    G.call(this, "mont", De), this.a = new I(De.a, 16).toRed(this.red), this.b = new I(De.b, 16).toRed(this.red), this.i4 = new I(4).toRed(this.red).redInvm(), this.two = new I(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  A(_e, G), mont$1 = _e, _e.prototype.validate = function(Ie) {
    var qe = Ie.normalize().x, Te = qe.redSqr(), Ee = Te.redMul(qe).redAdd(Te.redMul(this.a)).redAdd(qe), Oe = Ee.redSqrt();
    return Oe.redSqr().cmp(Ee) === 0;
  };
  function H(De, Ie, qe) {
    G.BasePoint.call(this, De, "projective"), Ie === null && qe === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new I(Ie, 16), this.z = new I(qe, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return A(H, G.BasePoint), _e.prototype.decodePoint = function(Ie, qe) {
    return this.point(J.toArray(Ie, qe), 1);
  }, _e.prototype.point = function(Ie, qe) {
    return new H(this, Ie, qe);
  }, _e.prototype.pointFromJSON = function(Ie) {
    return H.fromJSON(this, Ie);
  }, H.prototype.precompute = function() {
  }, H.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, H.fromJSON = function(Ie, qe) {
    return new H(Ie, qe[0], qe[1] || Ie.one);
  }, H.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, H.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, H.prototype.dbl = function() {
    var Ie = this.x.redAdd(this.z), qe = Ie.redSqr(), Te = this.x.redSub(this.z), Ee = Te.redSqr(), Oe = qe.redSub(Ee), Le = qe.redMul(Ee), ke = Oe.redMul(Ee.redAdd(this.curve.a24.redMul(Oe)));
    return this.curve.point(Le, ke);
  }, H.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, H.prototype.diffAdd = function(Ie, qe) {
    var Te = this.x.redAdd(this.z), Ee = this.x.redSub(this.z), Oe = Ie.x.redAdd(Ie.z), Le = Ie.x.redSub(Ie.z), ke = Le.redMul(Te), Fe = Oe.redMul(Ee), Ge = qe.z.redMul(ke.redAdd(Fe).redSqr()), et = qe.x.redMul(ke.redISub(Fe).redSqr());
    return this.curve.point(Ge, et);
  }, H.prototype.mul = function(Ie) {
    for (var qe = Ie.clone(), Te = this, Ee = this.curve.point(null, null), Oe = this, Le = []; qe.cmpn(0) !== 0; qe.iushrn(1))
      Le.push(qe.andln(1));
    for (var ke = Le.length - 1; ke >= 0; ke--)
      Le[ke] === 0 ? (Te = Te.diffAdd(Ee, Oe), Ee = Ee.dbl()) : (Ee = Te.diffAdd(Ee, Oe), Te = Te.dbl());
    return Ee;
  }, H.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, H.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, H.prototype.eq = function(Ie) {
    return this.getX().cmp(Ie.getX()) === 0;
  }, H.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, H.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, mont$1;
}
var edwards$1, hasRequiredEdwards;
function requireEdwards() {
  if (hasRequiredEdwards) return edwards$1;
  hasRequiredEdwards = 1;
  var I = requireUtils(), A = requireBn$3(), G = inherits_browserExports, J = requireBase$1(), _e = I.assert;
  function H(Ie) {
    this.twisted = (Ie.a | 0) !== 1, this.mOneA = this.twisted && (Ie.a | 0) === -1, this.extended = this.mOneA, J.call(this, "edwards", Ie), this.a = new A(Ie.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new A(Ie.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new A(Ie.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), _e(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (Ie.c | 0) === 1;
  }
  G(H, J), edwards$1 = H, H.prototype._mulA = function(qe) {
    return this.mOneA ? qe.redNeg() : this.a.redMul(qe);
  }, H.prototype._mulC = function(qe) {
    return this.oneC ? qe : this.c.redMul(qe);
  }, H.prototype.jpoint = function(qe, Te, Ee, Oe) {
    return this.point(qe, Te, Ee, Oe);
  }, H.prototype.pointFromX = function(qe, Te) {
    qe = new A(qe, 16), qe.red || (qe = qe.toRed(this.red));
    var Ee = qe.redSqr(), Oe = this.c2.redSub(this.a.redMul(Ee)), Le = this.one.redSub(this.c2.redMul(this.d).redMul(Ee)), ke = Oe.redMul(Le.redInvm()), Fe = ke.redSqrt();
    if (Fe.redSqr().redSub(ke).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var Ge = Fe.fromRed().isOdd();
    return (Te && !Ge || !Te && Ge) && (Fe = Fe.redNeg()), this.point(qe, Fe);
  }, H.prototype.pointFromY = function(qe, Te) {
    qe = new A(qe, 16), qe.red || (qe = qe.toRed(this.red));
    var Ee = qe.redSqr(), Oe = Ee.redSub(this.c2), Le = Ee.redMul(this.d).redMul(this.c2).redSub(this.a), ke = Oe.redMul(Le.redInvm());
    if (ke.cmp(this.zero) === 0) {
      if (Te)
        throw new Error("invalid point");
      return this.point(this.zero, qe);
    }
    var Fe = ke.redSqrt();
    if (Fe.redSqr().redSub(ke).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return Fe.fromRed().isOdd() !== Te && (Fe = Fe.redNeg()), this.point(Fe, qe);
  }, H.prototype.validate = function(qe) {
    if (qe.isInfinity())
      return !0;
    qe.normalize();
    var Te = qe.x.redSqr(), Ee = qe.y.redSqr(), Oe = Te.redMul(this.a).redAdd(Ee), Le = this.c2.redMul(this.one.redAdd(this.d.redMul(Te).redMul(Ee)));
    return Oe.cmp(Le) === 0;
  };
  function De(Ie, qe, Te, Ee, Oe) {
    J.BasePoint.call(this, Ie, "projective"), qe === null && Te === null && Ee === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new A(qe, 16), this.y = new A(Te, 16), this.z = Ee ? new A(Ee, 16) : this.curve.one, this.t = Oe && new A(Oe, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return G(De, J.BasePoint), H.prototype.pointFromJSON = function(qe) {
    return De.fromJSON(this, qe);
  }, H.prototype.point = function(qe, Te, Ee, Oe) {
    return new De(this, qe, Te, Ee, Oe);
  }, De.fromJSON = function(qe, Te) {
    return new De(qe, Te[0], Te[1], Te[2]);
  }, De.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, De.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, De.prototype._extDbl = function() {
    var qe = this.x.redSqr(), Te = this.y.redSqr(), Ee = this.z.redSqr();
    Ee = Ee.redIAdd(Ee);
    var Oe = this.curve._mulA(qe), Le = this.x.redAdd(this.y).redSqr().redISub(qe).redISub(Te), ke = Oe.redAdd(Te), Fe = ke.redSub(Ee), Ge = Oe.redSub(Te), et = Le.redMul(Fe), Ve = ke.redMul(Ge), Je = Le.redMul(Ge), ut = Fe.redMul(ke);
    return this.curve.point(et, Ve, ut, Je);
  }, De.prototype._projDbl = function() {
    var qe = this.x.redAdd(this.y).redSqr(), Te = this.x.redSqr(), Ee = this.y.redSqr(), Oe, Le, ke, Fe, Ge, et;
    if (this.curve.twisted) {
      Fe = this.curve._mulA(Te);
      var Ve = Fe.redAdd(Ee);
      this.zOne ? (Oe = qe.redSub(Te).redSub(Ee).redMul(Ve.redSub(this.curve.two)), Le = Ve.redMul(Fe.redSub(Ee)), ke = Ve.redSqr().redSub(Ve).redSub(Ve)) : (Ge = this.z.redSqr(), et = Ve.redSub(Ge).redISub(Ge), Oe = qe.redSub(Te).redISub(Ee).redMul(et), Le = Ve.redMul(Fe.redSub(Ee)), ke = Ve.redMul(et));
    } else
      Fe = Te.redAdd(Ee), Ge = this.curve._mulC(this.z).redSqr(), et = Fe.redSub(Ge).redSub(Ge), Oe = this.curve._mulC(qe.redISub(Fe)).redMul(et), Le = this.curve._mulC(Fe).redMul(Te.redISub(Ee)), ke = Fe.redMul(et);
    return this.curve.point(Oe, Le, ke);
  }, De.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, De.prototype._extAdd = function(qe) {
    var Te = this.y.redSub(this.x).redMul(qe.y.redSub(qe.x)), Ee = this.y.redAdd(this.x).redMul(qe.y.redAdd(qe.x)), Oe = this.t.redMul(this.curve.dd).redMul(qe.t), Le = this.z.redMul(qe.z.redAdd(qe.z)), ke = Ee.redSub(Te), Fe = Le.redSub(Oe), Ge = Le.redAdd(Oe), et = Ee.redAdd(Te), Ve = ke.redMul(Fe), Je = Ge.redMul(et), ut = ke.redMul(et), rt = Fe.redMul(Ge);
    return this.curve.point(Ve, Je, rt, ut);
  }, De.prototype._projAdd = function(qe) {
    var Te = this.z.redMul(qe.z), Ee = Te.redSqr(), Oe = this.x.redMul(qe.x), Le = this.y.redMul(qe.y), ke = this.curve.d.redMul(Oe).redMul(Le), Fe = Ee.redSub(ke), Ge = Ee.redAdd(ke), et = this.x.redAdd(this.y).redMul(qe.x.redAdd(qe.y)).redISub(Oe).redISub(Le), Ve = Te.redMul(Fe).redMul(et), Je, ut;
    return this.curve.twisted ? (Je = Te.redMul(Ge).redMul(Le.redSub(this.curve._mulA(Oe))), ut = Fe.redMul(Ge)) : (Je = Te.redMul(Ge).redMul(Le.redSub(Oe)), ut = this.curve._mulC(Fe).redMul(Ge)), this.curve.point(Ve, Je, ut);
  }, De.prototype.add = function(qe) {
    return this.isInfinity() ? qe : qe.isInfinity() ? this : this.curve.extended ? this._extAdd(qe) : this._projAdd(qe);
  }, De.prototype.mul = function(qe) {
    return this._hasDoubles(qe) ? this.curve._fixedNafMul(this, qe) : this.curve._wnafMul(this, qe);
  }, De.prototype.mulAdd = function(qe, Te, Ee) {
    return this.curve._wnafMulAdd(1, [this, Te], [qe, Ee], 2, !1);
  }, De.prototype.jmulAdd = function(qe, Te, Ee) {
    return this.curve._wnafMulAdd(1, [this, Te], [qe, Ee], 2, !0);
  }, De.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var qe = this.z.redInvm();
    return this.x = this.x.redMul(qe), this.y = this.y.redMul(qe), this.t && (this.t = this.t.redMul(qe)), this.z = this.curve.one, this.zOne = !0, this;
  }, De.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, De.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, De.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, De.prototype.eq = function(qe) {
    return this === qe || this.getX().cmp(qe.getX()) === 0 && this.getY().cmp(qe.getY()) === 0;
  }, De.prototype.eqXToP = function(qe) {
    var Te = qe.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(Te) === 0)
      return !0;
    for (var Ee = qe.clone(), Oe = this.curve.redN.redMul(this.z); ; ) {
      if (Ee.iadd(this.curve.n), Ee.cmp(this.curve.p) >= 0)
        return !1;
      if (Te.redIAdd(Oe), this.x.cmp(Te) === 0)
        return !0;
    }
  }, De.prototype.toP = De.prototype.normalize, De.prototype.mixedAdd = De.prototype.add, edwards$1;
}
var hasRequiredCurve;
function requireCurve() {
  return hasRequiredCurve || (hasRequiredCurve = 1, function(I) {
    var A = I;
    A.base = requireBase$1(), A.short = requireShort(), A.mont = requireMont(), A.edwards = requireEdwards();
  }(curve$1)), curve$1;
}
var curves$3 = {}, hash$2 = {}, utils$l = {}, assert$e = minimalisticAssert, inherits$3 = inherits_browserExports;
utils$l.inherits = inherits$3;
function isSurrogatePair(I, A) {
  return (I.charCodeAt(A) & 64512) !== 55296 || A < 0 || A + 1 >= I.length ? !1 : (I.charCodeAt(A + 1) & 64512) === 56320;
}
function toArray(I, A) {
  if (Array.isArray(I))
    return I.slice();
  if (!I)
    return [];
  var G = [];
  if (typeof I == "string")
    if (A) {
      if (A === "hex")
        for (I = I.replace(/[^a-z0-9]+/ig, ""), I.length % 2 !== 0 && (I = "0" + I), _e = 0; _e < I.length; _e += 2)
          G.push(parseInt(I[_e] + I[_e + 1], 16));
    } else for (var J = 0, _e = 0; _e < I.length; _e++) {
      var H = I.charCodeAt(_e);
      H < 128 ? G[J++] = H : H < 2048 ? (G[J++] = H >> 6 | 192, G[J++] = H & 63 | 128) : isSurrogatePair(I, _e) ? (H = 65536 + ((H & 1023) << 10) + (I.charCodeAt(++_e) & 1023), G[J++] = H >> 18 | 240, G[J++] = H >> 12 & 63 | 128, G[J++] = H >> 6 & 63 | 128, G[J++] = H & 63 | 128) : (G[J++] = H >> 12 | 224, G[J++] = H >> 6 & 63 | 128, G[J++] = H & 63 | 128);
    }
  else
    for (_e = 0; _e < I.length; _e++)
      G[_e] = I[_e] | 0;
  return G;
}
utils$l.toArray = toArray;
function toHex(I) {
  for (var A = "", G = 0; G < I.length; G++)
    A += zero2(I[G].toString(16));
  return A;
}
utils$l.toHex = toHex;
function htonl(I) {
  var A = I >>> 24 | I >>> 8 & 65280 | I << 8 & 16711680 | (I & 255) << 24;
  return A >>> 0;
}
utils$l.htonl = htonl;
function toHex32(I, A) {
  for (var G = "", J = 0; J < I.length; J++) {
    var _e = I[J];
    A === "little" && (_e = htonl(_e)), G += zero8(_e.toString(16));
  }
  return G;
}
utils$l.toHex32 = toHex32;
function zero2(I) {
  return I.length === 1 ? "0" + I : I;
}
utils$l.zero2 = zero2;
function zero8(I) {
  return I.length === 7 ? "0" + I : I.length === 6 ? "00" + I : I.length === 5 ? "000" + I : I.length === 4 ? "0000" + I : I.length === 3 ? "00000" + I : I.length === 2 ? "000000" + I : I.length === 1 ? "0000000" + I : I;
}
utils$l.zero8 = zero8;
function join32(I, A, G, J) {
  var _e = G - A;
  assert$e(_e % 4 === 0);
  for (var H = new Array(_e / 4), De = 0, Ie = A; De < H.length; De++, Ie += 4) {
    var qe;
    J === "big" ? qe = I[Ie] << 24 | I[Ie + 1] << 16 | I[Ie + 2] << 8 | I[Ie + 3] : qe = I[Ie + 3] << 24 | I[Ie + 2] << 16 | I[Ie + 1] << 8 | I[Ie], H[De] = qe >>> 0;
  }
  return H;
}
utils$l.join32 = join32;
function split32(I, A) {
  for (var G = new Array(I.length * 4), J = 0, _e = 0; J < I.length; J++, _e += 4) {
    var H = I[J];
    A === "big" ? (G[_e] = H >>> 24, G[_e + 1] = H >>> 16 & 255, G[_e + 2] = H >>> 8 & 255, G[_e + 3] = H & 255) : (G[_e + 3] = H >>> 24, G[_e + 2] = H >>> 16 & 255, G[_e + 1] = H >>> 8 & 255, G[_e] = H & 255);
  }
  return G;
}
utils$l.split32 = split32;
function rotr32$1(I, A) {
  return I >>> A | I << 32 - A;
}
utils$l.rotr32 = rotr32$1;
function rotl32$2(I, A) {
  return I << A | I >>> 32 - A;
}
utils$l.rotl32 = rotl32$2;
function sum32$3(I, A) {
  return I + A >>> 0;
}
utils$l.sum32 = sum32$3;
function sum32_3$1(I, A, G) {
  return I + A + G >>> 0;
}
utils$l.sum32_3 = sum32_3$1;
function sum32_4$2(I, A, G, J) {
  return I + A + G + J >>> 0;
}
utils$l.sum32_4 = sum32_4$2;
function sum32_5$2(I, A, G, J, _e) {
  return I + A + G + J + _e >>> 0;
}
utils$l.sum32_5 = sum32_5$2;
function sum64$1(I, A, G, J) {
  var _e = I[A], H = I[A + 1], De = J + H >>> 0, Ie = (De < J ? 1 : 0) + G + _e;
  I[A] = Ie >>> 0, I[A + 1] = De;
}
utils$l.sum64 = sum64$1;
function sum64_hi$1(I, A, G, J) {
  var _e = A + J >>> 0, H = (_e < A ? 1 : 0) + I + G;
  return H >>> 0;
}
utils$l.sum64_hi = sum64_hi$1;
function sum64_lo$1(I, A, G, J) {
  var _e = A + J;
  return _e >>> 0;
}
utils$l.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(I, A, G, J, _e, H, De, Ie) {
  var qe = 0, Te = A;
  Te = Te + J >>> 0, qe += Te < A ? 1 : 0, Te = Te + H >>> 0, qe += Te < H ? 1 : 0, Te = Te + Ie >>> 0, qe += Te < Ie ? 1 : 0;
  var Ee = I + G + _e + De + qe;
  return Ee >>> 0;
}
utils$l.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(I, A, G, J, _e, H, De, Ie) {
  var qe = A + J + H + Ie;
  return qe >>> 0;
}
utils$l.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(I, A, G, J, _e, H, De, Ie, qe, Te) {
  var Ee = 0, Oe = A;
  Oe = Oe + J >>> 0, Ee += Oe < A ? 1 : 0, Oe = Oe + H >>> 0, Ee += Oe < H ? 1 : 0, Oe = Oe + Ie >>> 0, Ee += Oe < Ie ? 1 : 0, Oe = Oe + Te >>> 0, Ee += Oe < Te ? 1 : 0;
  var Le = I + G + _e + De + qe + Ee;
  return Le >>> 0;
}
utils$l.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(I, A, G, J, _e, H, De, Ie, qe, Te) {
  var Ee = A + J + H + Ie + Te;
  return Ee >>> 0;
}
utils$l.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(I, A, G) {
  var J = A << 32 - G | I >>> G;
  return J >>> 0;
}
utils$l.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(I, A, G) {
  var J = I << 32 - G | A >>> G;
  return J >>> 0;
}
utils$l.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(I, A, G) {
  return I >>> G;
}
utils$l.shr64_hi = shr64_hi$1;
function shr64_lo$1(I, A, G) {
  var J = I << 32 - G | A >>> G;
  return J >>> 0;
}
utils$l.shr64_lo = shr64_lo$1;
var common$5 = {}, utils$k = utils$l, assert$d = minimalisticAssert;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$5.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function(A, G) {
  if (A = utils$k.toArray(A, G), this.pending ? this.pending = this.pending.concat(A) : this.pending = A, this.pendingTotal += A.length, this.pending.length >= this._delta8) {
    A = this.pending;
    var J = A.length % this._delta8;
    this.pending = A.slice(A.length - J, A.length), this.pending.length === 0 && (this.pending = null), A = utils$k.join32(A, 0, A.length - J, this.endian);
    for (var _e = 0; _e < A.length; _e += this._delta32)
      this._update(A, _e, _e + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function(A) {
  return this.update(this._pad()), assert$d(this.pending === null), this._digest(A);
};
BlockHash$4.prototype._pad = function() {
  var A = this.pendingTotal, G = this._delta8, J = G - (A + this.padLength) % G, _e = new Array(J + this.padLength);
  _e[0] = 128;
  for (var H = 1; H < J; H++)
    _e[H] = 0;
  if (A <<= 3, this.endian === "big") {
    for (var De = 8; De < this.padLength; De++)
      _e[H++] = 0;
    _e[H++] = 0, _e[H++] = 0, _e[H++] = 0, _e[H++] = 0, _e[H++] = A >>> 24 & 255, _e[H++] = A >>> 16 & 255, _e[H++] = A >>> 8 & 255, _e[H++] = A & 255;
  } else
    for (_e[H++] = A & 255, _e[H++] = A >>> 8 & 255, _e[H++] = A >>> 16 & 255, _e[H++] = A >>> 24 & 255, _e[H++] = 0, _e[H++] = 0, _e[H++] = 0, _e[H++] = 0, De = 8; De < this.padLength; De++)
      _e[H++] = 0;
  return _e;
};
var sha = {}, common$4 = {}, utils$j = utils$l, rotr32 = utils$j.rotr32;
function ft_1$1(I, A, G, J) {
  if (I === 0)
    return ch32$1(A, G, J);
  if (I === 1 || I === 3)
    return p32(A, G, J);
  if (I === 2)
    return maj32$1(A, G, J);
}
common$4.ft_1 = ft_1$1;
function ch32$1(I, A, G) {
  return I & A ^ ~I & G;
}
common$4.ch32 = ch32$1;
function maj32$1(I, A, G) {
  return I & A ^ I & G ^ A & G;
}
common$4.maj32 = maj32$1;
function p32(I, A, G) {
  return I ^ A ^ G;
}
common$4.p32 = p32;
function s0_256$1(I) {
  return rotr32(I, 2) ^ rotr32(I, 13) ^ rotr32(I, 22);
}
common$4.s0_256 = s0_256$1;
function s1_256$1(I) {
  return rotr32(I, 6) ^ rotr32(I, 11) ^ rotr32(I, 25);
}
common$4.s1_256 = s1_256$1;
function g0_256$1(I) {
  return rotr32(I, 7) ^ rotr32(I, 18) ^ I >>> 3;
}
common$4.g0_256 = g0_256$1;
function g1_256$1(I) {
  return rotr32(I, 17) ^ rotr32(I, 19) ^ I >>> 10;
}
common$4.g1_256 = g1_256$1;
var utils$i = utils$l, common$3 = common$5, shaCommon$1 = common$4, rotl32$1 = utils$i.rotl32, sum32$2 = utils$i.sum32, sum32_5$1 = utils$i.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$3.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$i.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function(A, G) {
  for (var J = this.W, _e = 0; _e < 16; _e++)
    J[_e] = A[G + _e];
  for (; _e < J.length; _e++)
    J[_e] = rotl32$1(J[_e - 3] ^ J[_e - 8] ^ J[_e - 14] ^ J[_e - 16], 1);
  var H = this.h[0], De = this.h[1], Ie = this.h[2], qe = this.h[3], Te = this.h[4];
  for (_e = 0; _e < J.length; _e++) {
    var Ee = ~~(_e / 20), Oe = sum32_5$1(rotl32$1(H, 5), ft_1(Ee, De, Ie, qe), Te, J[_e], sha1_K[Ee]);
    Te = qe, qe = Ie, Ie = rotl32$1(De, 30), De = H, H = Oe;
  }
  this.h[0] = sum32$2(this.h[0], H), this.h[1] = sum32$2(this.h[1], De), this.h[2] = sum32$2(this.h[2], Ie), this.h[3] = sum32$2(this.h[3], qe), this.h[4] = sum32$2(this.h[4], Te);
};
SHA1.prototype._digest = function(A) {
  return A === "hex" ? utils$i.toHex32(this.h, "big") : utils$i.split32(this.h, "big");
};
var utils$h = utils$l, common$2 = common$5, shaCommon = common$4, assert$c = minimalisticAssert, sum32$1 = utils$h.sum32, sum32_4$1 = utils$h.sum32_4, sum32_5 = utils$h.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$2.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$1() {
  if (!(this instanceof SHA256$1))
    return new SHA256$1();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$h.inherits(SHA256$1, BlockHash$2);
var _256 = SHA256$1;
SHA256$1.blockSize = 512;
SHA256$1.outSize = 256;
SHA256$1.hmacStrength = 192;
SHA256$1.padLength = 64;
SHA256$1.prototype._update = function(A, G) {
  for (var J = this.W, _e = 0; _e < 16; _e++)
    J[_e] = A[G + _e];
  for (; _e < J.length; _e++)
    J[_e] = sum32_4$1(g1_256(J[_e - 2]), J[_e - 7], g0_256(J[_e - 15]), J[_e - 16]);
  var H = this.h[0], De = this.h[1], Ie = this.h[2], qe = this.h[3], Te = this.h[4], Ee = this.h[5], Oe = this.h[6], Le = this.h[7];
  for (assert$c(this.k.length === J.length), _e = 0; _e < J.length; _e++) {
    var ke = sum32_5(Le, s1_256(Te), ch32(Te, Ee, Oe), this.k[_e], J[_e]), Fe = sum32$1(s0_256(H), maj32(H, De, Ie));
    Le = Oe, Oe = Ee, Ee = Te, Te = sum32$1(qe, ke), qe = Ie, Ie = De, De = H, H = sum32$1(ke, Fe);
  }
  this.h[0] = sum32$1(this.h[0], H), this.h[1] = sum32$1(this.h[1], De), this.h[2] = sum32$1(this.h[2], Ie), this.h[3] = sum32$1(this.h[3], qe), this.h[4] = sum32$1(this.h[4], Te), this.h[5] = sum32$1(this.h[5], Ee), this.h[6] = sum32$1(this.h[6], Oe), this.h[7] = sum32$1(this.h[7], Le);
};
SHA256$1.prototype._digest = function(A) {
  return A === "hex" ? utils$h.toHex32(this.h, "big") : utils$h.split32(this.h, "big");
};
var utils$g = utils$l, SHA256 = _256;
function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();
  SHA256.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$g.inherits(SHA224, SHA256);
var _224 = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function(A) {
  return A === "hex" ? utils$g.toHex32(this.h.slice(0, 7), "big") : utils$g.split32(this.h.slice(0, 7), "big");
};
var utils$f = utils$l, common$1 = common$5, assert$b = minimalisticAssert, rotr64_hi = utils$f.rotr64_hi, rotr64_lo = utils$f.rotr64_lo, shr64_hi = utils$f.shr64_hi, shr64_lo = utils$f.shr64_lo, sum64 = utils$f.sum64, sum64_hi = utils$f.sum64_hi, sum64_lo = utils$f.sum64_lo, sum64_4_hi = utils$f.sum64_4_hi, sum64_4_lo = utils$f.sum64_4_lo, sum64_5_hi = utils$f.sum64_5_hi, sum64_5_lo = utils$f.sum64_5_lo, BlockHash$1 = common$1.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$1() {
  if (!(this instanceof SHA512$1))
    return new SHA512$1();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$f.inherits(SHA512$1, BlockHash$1);
var _512 = SHA512$1;
SHA512$1.blockSize = 1024;
SHA512$1.outSize = 512;
SHA512$1.hmacStrength = 192;
SHA512$1.padLength = 128;
SHA512$1.prototype._prepareBlock = function(A, G) {
  for (var J = this.W, _e = 0; _e < 32; _e++)
    J[_e] = A[G + _e];
  for (; _e < J.length; _e += 2) {
    var H = g1_512_hi(J[_e - 4], J[_e - 3]), De = g1_512_lo(J[_e - 4], J[_e - 3]), Ie = J[_e - 14], qe = J[_e - 13], Te = g0_512_hi(J[_e - 30], J[_e - 29]), Ee = g0_512_lo(J[_e - 30], J[_e - 29]), Oe = J[_e - 32], Le = J[_e - 31];
    J[_e] = sum64_4_hi(
      H,
      De,
      Ie,
      qe,
      Te,
      Ee,
      Oe,
      Le
    ), J[_e + 1] = sum64_4_lo(
      H,
      De,
      Ie,
      qe,
      Te,
      Ee,
      Oe,
      Le
    );
  }
};
SHA512$1.prototype._update = function(A, G) {
  this._prepareBlock(A, G);
  var J = this.W, _e = this.h[0], H = this.h[1], De = this.h[2], Ie = this.h[3], qe = this.h[4], Te = this.h[5], Ee = this.h[6], Oe = this.h[7], Le = this.h[8], ke = this.h[9], Fe = this.h[10], Ge = this.h[11], et = this.h[12], Ve = this.h[13], Je = this.h[14], ut = this.h[15];
  assert$b(this.k.length === J.length);
  for (var rt = 0; rt < J.length; rt += 2) {
    var lt = Je, vt = ut, Ye = s1_512_hi(Le, ke), pt = s1_512_lo(Le, ke), bt = ch64_hi(Le, ke, Fe, Ge, et), Yt = ch64_lo(Le, ke, Fe, Ge, et, Ve), Se = this.k[rt], t = this.k[rt + 1], h = J[rt], B = J[rt + 1], Z = sum64_5_hi(
      lt,
      vt,
      Ye,
      pt,
      bt,
      Yt,
      Se,
      t,
      h,
      B
    ), ve = sum64_5_lo(
      lt,
      vt,
      Ye,
      pt,
      bt,
      Yt,
      Se,
      t,
      h,
      B
    );
    lt = s0_512_hi(_e, H), vt = s0_512_lo(_e, H), Ye = maj64_hi(_e, H, De, Ie, qe), pt = maj64_lo(_e, H, De, Ie, qe, Te);
    var ge = sum64_hi(lt, vt, Ye, pt), xe = sum64_lo(lt, vt, Ye, pt);
    Je = et, ut = Ve, et = Fe, Ve = Ge, Fe = Le, Ge = ke, Le = sum64_hi(Ee, Oe, Z, ve), ke = sum64_lo(Oe, Oe, Z, ve), Ee = qe, Oe = Te, qe = De, Te = Ie, De = _e, Ie = H, _e = sum64_hi(Z, ve, ge, xe), H = sum64_lo(Z, ve, ge, xe);
  }
  sum64(this.h, 0, _e, H), sum64(this.h, 2, De, Ie), sum64(this.h, 4, qe, Te), sum64(this.h, 6, Ee, Oe), sum64(this.h, 8, Le, ke), sum64(this.h, 10, Fe, Ge), sum64(this.h, 12, et, Ve), sum64(this.h, 14, Je, ut);
};
SHA512$1.prototype._digest = function(A) {
  return A === "hex" ? utils$f.toHex32(this.h, "big") : utils$f.split32(this.h, "big");
};
function ch64_hi(I, A, G, J, _e) {
  var H = I & G ^ ~I & _e;
  return H < 0 && (H += 4294967296), H;
}
function ch64_lo(I, A, G, J, _e, H) {
  var De = A & J ^ ~A & H;
  return De < 0 && (De += 4294967296), De;
}
function maj64_hi(I, A, G, J, _e) {
  var H = I & G ^ I & _e ^ G & _e;
  return H < 0 && (H += 4294967296), H;
}
function maj64_lo(I, A, G, J, _e, H) {
  var De = A & J ^ A & H ^ J & H;
  return De < 0 && (De += 4294967296), De;
}
function s0_512_hi(I, A) {
  var G = rotr64_hi(I, A, 28), J = rotr64_hi(A, I, 2), _e = rotr64_hi(A, I, 7), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function s0_512_lo(I, A) {
  var G = rotr64_lo(I, A, 28), J = rotr64_lo(A, I, 2), _e = rotr64_lo(A, I, 7), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function s1_512_hi(I, A) {
  var G = rotr64_hi(I, A, 14), J = rotr64_hi(I, A, 18), _e = rotr64_hi(A, I, 9), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function s1_512_lo(I, A) {
  var G = rotr64_lo(I, A, 14), J = rotr64_lo(I, A, 18), _e = rotr64_lo(A, I, 9), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function g0_512_hi(I, A) {
  var G = rotr64_hi(I, A, 1), J = rotr64_hi(I, A, 8), _e = shr64_hi(I, A, 7), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function g0_512_lo(I, A) {
  var G = rotr64_lo(I, A, 1), J = rotr64_lo(I, A, 8), _e = shr64_lo(I, A, 7), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function g1_512_hi(I, A) {
  var G = rotr64_hi(I, A, 19), J = rotr64_hi(A, I, 29), _e = shr64_hi(I, A, 6), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function g1_512_lo(I, A) {
  var G = rotr64_lo(I, A, 19), J = rotr64_lo(A, I, 29), _e = shr64_lo(I, A, 6), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
var utils$e = utils$l, SHA512 = _512;
function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();
  SHA512.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$e.inherits(SHA384, SHA512);
var _384 = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function(A) {
  return A === "hex" ? utils$e.toHex32(this.h.slice(0, 12), "big") : utils$e.split32(this.h.slice(0, 12), "big");
};
sha.sha1 = _1;
sha.sha224 = _224;
sha.sha256 = _256;
sha.sha384 = _384;
sha.sha512 = _512;
var ripemd = {}, utils$d = utils$l, common = common$5, rotl32 = utils$d.rotl32, sum32 = utils$d.sum32, sum32_3 = utils$d.sum32_3, sum32_4 = utils$d.sum32_4, BlockHash = common.BlockHash;
function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$d.inherits(RIPEMD160, BlockHash);
ripemd.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function(A, G) {
  for (var J = this.h[0], _e = this.h[1], H = this.h[2], De = this.h[3], Ie = this.h[4], qe = J, Te = _e, Ee = H, Oe = De, Le = Ie, ke = 0; ke < 80; ke++) {
    var Fe = sum32(
      rotl32(
        sum32_4(J, f$2(ke, _e, H, De), A[r$1[ke] + G], K$1(ke)),
        s[ke]
      ),
      Ie
    );
    J = Ie, Ie = De, De = rotl32(H, 10), H = _e, _e = Fe, Fe = sum32(
      rotl32(
        sum32_4(qe, f$2(79 - ke, Te, Ee, Oe), A[rh[ke] + G], Kh(ke)),
        sh[ke]
      ),
      Le
    ), qe = Le, Le = Oe, Oe = rotl32(Ee, 10), Ee = Te, Te = Fe;
  }
  Fe = sum32_3(this.h[1], H, Oe), this.h[1] = sum32_3(this.h[2], De, Le), this.h[2] = sum32_3(this.h[3], Ie, qe), this.h[3] = sum32_3(this.h[4], J, Te), this.h[4] = sum32_3(this.h[0], _e, Ee), this.h[0] = Fe;
};
RIPEMD160.prototype._digest = function(A) {
  return A === "hex" ? utils$d.toHex32(this.h, "little") : utils$d.split32(this.h, "little");
};
function f$2(I, A, G, J) {
  return I <= 15 ? A ^ G ^ J : I <= 31 ? A & G | ~A & J : I <= 47 ? (A | ~G) ^ J : I <= 63 ? A & J | G & ~J : A ^ (G | ~J);
}
function K$1(I) {
  return I <= 15 ? 0 : I <= 31 ? 1518500249 : I <= 47 ? 1859775393 : I <= 63 ? 2400959708 : 2840853838;
}
function Kh(I) {
  return I <= 15 ? 1352829926 : I <= 31 ? 1548603684 : I <= 47 ? 1836072691 : I <= 63 ? 2053994217 : 0;
}
var r$1 = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$c = utils$l, assert$a = minimalisticAssert;
function Hmac(I, A, G) {
  if (!(this instanceof Hmac))
    return new Hmac(I, A, G);
  this.Hash = I, this.blockSize = I.blockSize / 8, this.outSize = I.outSize / 8, this.inner = null, this.outer = null, this._init(utils$c.toArray(A, G));
}
var hmac = Hmac;
Hmac.prototype._init = function(A) {
  A.length > this.blockSize && (A = new this.Hash().update(A).digest()), assert$a(A.length <= this.blockSize);
  for (var G = A.length; G < this.blockSize; G++)
    A.push(0);
  for (G = 0; G < A.length; G++)
    A[G] ^= 54;
  for (this.inner = new this.Hash().update(A), G = 0; G < A.length; G++)
    A[G] ^= 106;
  this.outer = new this.Hash().update(A);
};
Hmac.prototype.update = function(A, G) {
  return this.inner.update(A, G), this;
};
Hmac.prototype.digest = function(A) {
  return this.outer.update(this.inner.digest()), this.outer.digest(A);
};
(function(I) {
  var A = I;
  A.utils = utils$l, A.common = common$5, A.sha = sha, A.ripemd = ripemd, A.hmac = hmac, A.sha1 = A.sha.sha1, A.sha256 = A.sha.sha256, A.sha224 = A.sha.sha224, A.sha384 = A.sha.sha384, A.sha512 = A.sha.sha512, A.ripemd160 = A.ripemd.ripemd160;
})(hash$2);
var secp256k1$1, hasRequiredSecp256k1$1;
function requireSecp256k1$1() {
  return hasRequiredSecp256k1$1 || (hasRequiredSecp256k1$1 = 1, secp256k1$1 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$1;
}
var hasRequiredCurves;
function requireCurves() {
  return hasRequiredCurves || (hasRequiredCurves = 1, function(I) {
    var A = I, G = hash$2, J = requireCurve(), _e = requireUtils(), H = _e.assert;
    function De(Te) {
      Te.type === "short" ? this.curve = new J.short(Te) : Te.type === "edwards" ? this.curve = new J.edwards(Te) : this.curve = new J.mont(Te), this.g = this.curve.g, this.n = this.curve.n, this.hash = Te.hash, H(this.g.validate(), "Invalid curve"), H(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    A.PresetCurve = De;
    function Ie(Te, Ee) {
      Object.defineProperty(A, Te, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var Oe = new De(Ee);
          return Object.defineProperty(A, Te, {
            configurable: !0,
            enumerable: !0,
            value: Oe
          }), Oe;
        }
      });
    }
    Ie("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: G.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), Ie("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: G.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), Ie("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: G.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), Ie("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: G.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), Ie("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: G.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), Ie("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: G.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), Ie("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: G.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var qe;
    try {
      qe = requireSecp256k1$1();
    } catch {
      qe = void 0;
    }
    Ie("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: G.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        qe
      ]
    });
  }(curves$3)), curves$3;
}
var hash$1 = hash$2, utils$b = utils$m, assert$9 = minimalisticAssert;
function HmacDRBG$1(I) {
  if (!(this instanceof HmacDRBG$1))
    return new HmacDRBG$1(I);
  this.hash = I.hash, this.predResist = !!I.predResist, this.outLen = this.hash.outSize, this.minEntropy = I.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var A = utils$b.toArray(I.entropy, I.entropyEnc || "hex"), G = utils$b.toArray(I.nonce, I.nonceEnc || "hex"), J = utils$b.toArray(I.pers, I.persEnc || "hex");
  assert$9(
    A.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(A, G, J);
}
var hmacDrbg = HmacDRBG$1;
HmacDRBG$1.prototype._init = function(A, G, J) {
  var _e = A.concat(G).concat(J);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var H = 0; H < this.V.length; H++)
    this.K[H] = 0, this.V[H] = 1;
  this._update(_e), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG$1.prototype._hmac = function() {
  return new hash$1.hmac(this.hash, this.K);
};
HmacDRBG$1.prototype._update = function(A) {
  var G = this._hmac().update(this.V).update([0]);
  A && (G = G.update(A)), this.K = G.digest(), this.V = this._hmac().update(this.V).digest(), A && (this.K = this._hmac().update(this.V).update([1]).update(A).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG$1.prototype.reseed = function(A, G, J, _e) {
  typeof G != "string" && (_e = J, J = G, G = null), A = utils$b.toArray(A, G), J = utils$b.toArray(J, _e), assert$9(
    A.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(A.concat(J || [])), this._reseed = 1;
};
HmacDRBG$1.prototype.generate = function(A, G, J, _e) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof G != "string" && (_e = J, J = G, G = null), J && (J = utils$b.toArray(J, _e || "hex"), this._update(J));
  for (var H = []; H.length < A; )
    this.V = this._hmac().update(this.V).digest(), H = H.concat(this.V);
  var De = H.slice(0, A);
  return this._update(J), this._reseed++, utils$b.encode(De, G);
};
var key$3, hasRequiredKey$1;
function requireKey$1() {
  if (hasRequiredKey$1) return key$3;
  hasRequiredKey$1 = 1;
  var I = requireBn$3(), A = requireUtils(), G = A.assert;
  function J(_e, H) {
    this.ec = _e, this.priv = null, this.pub = null, H.priv && this._importPrivate(H.priv, H.privEnc), H.pub && this._importPublic(H.pub, H.pubEnc);
  }
  return key$3 = J, J.fromPublic = function(H, De, Ie) {
    return De instanceof J ? De : new J(H, {
      pub: De,
      pubEnc: Ie
    });
  }, J.fromPrivate = function(H, De, Ie) {
    return De instanceof J ? De : new J(H, {
      priv: De,
      privEnc: Ie
    });
  }, J.prototype.validate = function() {
    var H = this.getPublic();
    return H.isInfinity() ? { result: !1, reason: "Invalid public key" } : H.validate() ? H.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, J.prototype.getPublic = function(H, De) {
    return typeof H == "string" && (De = H, H = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), De ? this.pub.encode(De, H) : this.pub;
  }, J.prototype.getPrivate = function(H) {
    return H === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, J.prototype._importPrivate = function(H, De) {
    this.priv = new I(H, De || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, J.prototype._importPublic = function(H, De) {
    if (H.x || H.y) {
      this.ec.curve.type === "mont" ? G(H.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && G(H.x && H.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(H.x, H.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(H, De);
  }, J.prototype.derive = function(H) {
    return H.validate() || G(H.validate(), "public point not validated"), H.mul(this.priv).getX();
  }, J.prototype.sign = function(H, De, Ie) {
    return this.ec.sign(H, this, De, Ie);
  }, J.prototype.verify = function(H, De) {
    return this.ec.verify(H, De, this);
  }, J.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, key$3;
}
var signature$3, hasRequiredSignature$1;
function requireSignature$1() {
  if (hasRequiredSignature$1) return signature$3;
  hasRequiredSignature$1 = 1;
  var I = requireBn$3(), A = requireUtils(), G = A.assert;
  function J(qe, Te) {
    if (qe instanceof J)
      return qe;
    this._importDER(qe, Te) || (G(qe.r && qe.s, "Signature without r or s"), this.r = new I(qe.r, 16), this.s = new I(qe.s, 16), qe.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = qe.recoveryParam);
  }
  signature$3 = J;
  function _e() {
    this.place = 0;
  }
  function H(qe, Te) {
    var Ee = qe[Te.place++];
    if (!(Ee & 128))
      return Ee;
    var Oe = Ee & 15;
    if (Oe === 0 || Oe > 4)
      return !1;
    for (var Le = 0, ke = 0, Fe = Te.place; ke < Oe; ke++, Fe++)
      Le <<= 8, Le |= qe[Fe], Le >>>= 0;
    return Le <= 127 ? !1 : (Te.place = Fe, Le);
  }
  function De(qe) {
    for (var Te = 0, Ee = qe.length - 1; !qe[Te] && !(qe[Te + 1] & 128) && Te < Ee; )
      Te++;
    return Te === 0 ? qe : qe.slice(Te);
  }
  J.prototype._importDER = function(Te, Ee) {
    Te = A.toArray(Te, Ee);
    var Oe = new _e();
    if (Te[Oe.place++] !== 48)
      return !1;
    var Le = H(Te, Oe);
    if (Le === !1 || Le + Oe.place !== Te.length || Te[Oe.place++] !== 2)
      return !1;
    var ke = H(Te, Oe);
    if (ke === !1)
      return !1;
    var Fe = Te.slice(Oe.place, ke + Oe.place);
    if (Oe.place += ke, Te[Oe.place++] !== 2)
      return !1;
    var Ge = H(Te, Oe);
    if (Ge === !1 || Te.length !== Ge + Oe.place)
      return !1;
    var et = Te.slice(Oe.place, Ge + Oe.place);
    if (Fe[0] === 0)
      if (Fe[1] & 128)
        Fe = Fe.slice(1);
      else
        return !1;
    if (et[0] === 0)
      if (et[1] & 128)
        et = et.slice(1);
      else
        return !1;
    return this.r = new I(Fe), this.s = new I(et), this.recoveryParam = null, !0;
  };
  function Ie(qe, Te) {
    if (Te < 128) {
      qe.push(Te);
      return;
    }
    var Ee = 1 + (Math.log(Te) / Math.LN2 >>> 3);
    for (qe.push(Ee | 128); --Ee; )
      qe.push(Te >>> (Ee << 3) & 255);
    qe.push(Te);
  }
  return J.prototype.toDER = function(Te) {
    var Ee = this.r.toArray(), Oe = this.s.toArray();
    for (Ee[0] & 128 && (Ee = [0].concat(Ee)), Oe[0] & 128 && (Oe = [0].concat(Oe)), Ee = De(Ee), Oe = De(Oe); !Oe[0] && !(Oe[1] & 128); )
      Oe = Oe.slice(1);
    var Le = [2];
    Ie(Le, Ee.length), Le = Le.concat(Ee), Le.push(2), Ie(Le, Oe.length);
    var ke = Le.concat(Oe), Fe = [48];
    return Ie(Fe, ke.length), Fe = Fe.concat(ke), A.encode(Fe, Te);
  }, signature$3;
}
var ec$1, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc) return ec$1;
  hasRequiredEc = 1;
  var I = requireBn$3(), A = hmacDrbg, G = requireUtils(), J = requireCurves(), _e = requireBrorand(), H = G.assert, De = requireKey$1(), Ie = requireSignature$1();
  function qe(Te) {
    if (!(this instanceof qe))
      return new qe(Te);
    typeof Te == "string" && (H(
      Object.prototype.hasOwnProperty.call(J, Te),
      "Unknown curve " + Te
    ), Te = J[Te]), Te instanceof J.PresetCurve && (Te = { curve: Te }), this.curve = Te.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = Te.curve.g, this.g.precompute(Te.curve.n.bitLength() + 1), this.hash = Te.hash || Te.curve.hash;
  }
  return ec$1 = qe, qe.prototype.keyPair = function(Ee) {
    return new De(this, Ee);
  }, qe.prototype.keyFromPrivate = function(Ee, Oe) {
    return De.fromPrivate(this, Ee, Oe);
  }, qe.prototype.keyFromPublic = function(Ee, Oe) {
    return De.fromPublic(this, Ee, Oe);
  }, qe.prototype.genKeyPair = function(Ee) {
    Ee || (Ee = {});
    for (var Oe = new A({
      hash: this.hash,
      pers: Ee.pers,
      persEnc: Ee.persEnc || "utf8",
      entropy: Ee.entropy || _e(this.hash.hmacStrength),
      entropyEnc: Ee.entropy && Ee.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), Le = this.n.byteLength(), ke = this.n.sub(new I(2)); ; ) {
      var Fe = new I(Oe.generate(Le));
      if (!(Fe.cmp(ke) > 0))
        return Fe.iaddn(1), this.keyFromPrivate(Fe);
    }
  }, qe.prototype._truncateToN = function(Ee, Oe) {
    var Le = Ee.byteLength() * 8 - this.n.bitLength();
    return Le > 0 && (Ee = Ee.ushrn(Le)), !Oe && Ee.cmp(this.n) >= 0 ? Ee.sub(this.n) : Ee;
  }, qe.prototype.sign = function(Ee, Oe, Le, ke) {
    typeof Le == "object" && (ke = Le, Le = null), ke || (ke = {}), Oe = this.keyFromPrivate(Oe, Le), Ee = this._truncateToN(new I(Ee, 16));
    for (var Fe = this.n.byteLength(), Ge = Oe.getPrivate().toArray("be", Fe), et = Ee.toArray("be", Fe), Ve = new A({
      hash: this.hash,
      entropy: Ge,
      nonce: et,
      pers: ke.pers,
      persEnc: ke.persEnc || "utf8"
    }), Je = this.n.sub(new I(1)), ut = 0; ; ut++) {
      var rt = ke.k ? ke.k(ut) : new I(Ve.generate(this.n.byteLength()));
      if (rt = this._truncateToN(rt, !0), !(rt.cmpn(1) <= 0 || rt.cmp(Je) >= 0)) {
        var lt = this.g.mul(rt);
        if (!lt.isInfinity()) {
          var vt = lt.getX(), Ye = vt.umod(this.n);
          if (Ye.cmpn(0) !== 0) {
            var pt = rt.invm(this.n).mul(Ye.mul(Oe.getPrivate()).iadd(Ee));
            if (pt = pt.umod(this.n), pt.cmpn(0) !== 0) {
              var bt = (lt.getY().isOdd() ? 1 : 0) | (vt.cmp(Ye) !== 0 ? 2 : 0);
              return ke.canonical && pt.cmp(this.nh) > 0 && (pt = this.n.sub(pt), bt ^= 1), new Ie({ r: Ye, s: pt, recoveryParam: bt });
            }
          }
        }
      }
    }
  }, qe.prototype.verify = function(Ee, Oe, Le, ke) {
    Ee = this._truncateToN(new I(Ee, 16)), Le = this.keyFromPublic(Le, ke), Oe = new Ie(Oe, "hex");
    var Fe = Oe.r, Ge = Oe.s;
    if (Fe.cmpn(1) < 0 || Fe.cmp(this.n) >= 0 || Ge.cmpn(1) < 0 || Ge.cmp(this.n) >= 0)
      return !1;
    var et = Ge.invm(this.n), Ve = et.mul(Ee).umod(this.n), Je = et.mul(Fe).umod(this.n), ut;
    return this.curve._maxwellTrick ? (ut = this.g.jmulAdd(Ve, Le.getPublic(), Je), ut.isInfinity() ? !1 : ut.eqXToP(Fe)) : (ut = this.g.mulAdd(Ve, Le.getPublic(), Je), ut.isInfinity() ? !1 : ut.getX().umod(this.n).cmp(Fe) === 0);
  }, qe.prototype.recoverPubKey = function(Te, Ee, Oe, Le) {
    H((3 & Oe) === Oe, "The recovery param is more than two bits"), Ee = new Ie(Ee, Le);
    var ke = this.n, Fe = new I(Te), Ge = Ee.r, et = Ee.s, Ve = Oe & 1, Je = Oe >> 1;
    if (Ge.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Je)
      throw new Error("Unable to find sencond key candinate");
    Je ? Ge = this.curve.pointFromX(Ge.add(this.curve.n), Ve) : Ge = this.curve.pointFromX(Ge, Ve);
    var ut = Ee.r.invm(ke), rt = ke.sub(Fe).mul(ut).umod(ke), lt = et.mul(ut).umod(ke);
    return this.g.mulAdd(rt, Ge, lt);
  }, qe.prototype.getKeyRecoveryParam = function(Te, Ee, Oe, Le) {
    if (Ee = new Ie(Ee, Le), Ee.recoveryParam !== null)
      return Ee.recoveryParam;
    for (var ke = 0; ke < 4; ke++) {
      var Fe;
      try {
        Fe = this.recoverPubKey(Te, Ee, ke);
      } catch {
        continue;
      }
      if (Fe.eq(Oe))
        return ke;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec$1;
}
var key$2, hasRequiredKey;
function requireKey() {
  if (hasRequiredKey) return key$2;
  hasRequiredKey = 1;
  var I = requireUtils(), A = I.assert, G = I.parseBytes, J = I.cachedProperty;
  function _e(H, De) {
    this.eddsa = H, this._secret = G(De.secret), H.isPoint(De.pub) ? this._pub = De.pub : this._pubBytes = G(De.pub);
  }
  return _e.fromPublic = function(De, Ie) {
    return Ie instanceof _e ? Ie : new _e(De, { pub: Ie });
  }, _e.fromSecret = function(De, Ie) {
    return Ie instanceof _e ? Ie : new _e(De, { secret: Ie });
  }, _e.prototype.secret = function() {
    return this._secret;
  }, J(_e, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), J(_e, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), J(_e, "privBytes", function() {
    var De = this.eddsa, Ie = this.hash(), qe = De.encodingLength - 1, Te = Ie.slice(0, De.encodingLength);
    return Te[0] &= 248, Te[qe] &= 127, Te[qe] |= 64, Te;
  }), J(_e, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), J(_e, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), J(_e, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), _e.prototype.sign = function(De) {
    return A(this._secret, "KeyPair can only verify"), this.eddsa.sign(De, this);
  }, _e.prototype.verify = function(De, Ie) {
    return this.eddsa.verify(De, Ie, this);
  }, _e.prototype.getSecret = function(De) {
    return A(this._secret, "KeyPair is public only"), I.encode(this.secret(), De);
  }, _e.prototype.getPublic = function(De) {
    return I.encode(this.pubBytes(), De);
  }, key$2 = _e, key$2;
}
var signature$2, hasRequiredSignature;
function requireSignature() {
  if (hasRequiredSignature) return signature$2;
  hasRequiredSignature = 1;
  var I = requireBn$3(), A = requireUtils(), G = A.assert, J = A.cachedProperty, _e = A.parseBytes;
  function H(De, Ie) {
    this.eddsa = De, typeof Ie != "object" && (Ie = _e(Ie)), Array.isArray(Ie) && (Ie = {
      R: Ie.slice(0, De.encodingLength),
      S: Ie.slice(De.encodingLength)
    }), G(Ie.R && Ie.S, "Signature without R or S"), De.isPoint(Ie.R) && (this._R = Ie.R), Ie.S instanceof I && (this._S = Ie.S), this._Rencoded = Array.isArray(Ie.R) ? Ie.R : Ie.Rencoded, this._Sencoded = Array.isArray(Ie.S) ? Ie.S : Ie.Sencoded;
  }
  return J(H, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), J(H, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), J(H, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), J(H, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), H.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, H.prototype.toHex = function() {
    return A.encode(this.toBytes(), "hex").toUpperCase();
  }, signature$2 = H, signature$2;
}
var eddsa$1, hasRequiredEddsa;
function requireEddsa() {
  if (hasRequiredEddsa) return eddsa$1;
  hasRequiredEddsa = 1;
  var I = hash$2, A = requireCurves(), G = requireUtils(), J = G.assert, _e = G.parseBytes, H = requireKey(), De = requireSignature();
  function Ie(qe) {
    if (J(qe === "ed25519", "only tested with ed25519 so far"), !(this instanceof Ie))
      return new Ie(qe);
    qe = A[qe].curve, this.curve = qe, this.g = qe.g, this.g.precompute(qe.n.bitLength() + 1), this.pointClass = qe.point().constructor, this.encodingLength = Math.ceil(qe.n.bitLength() / 8), this.hash = I.sha512;
  }
  return eddsa$1 = Ie, Ie.prototype.sign = function(Te, Ee) {
    Te = _e(Te);
    var Oe = this.keyFromSecret(Ee), Le = this.hashInt(Oe.messagePrefix(), Te), ke = this.g.mul(Le), Fe = this.encodePoint(ke), Ge = this.hashInt(Fe, Oe.pubBytes(), Te).mul(Oe.priv()), et = Le.add(Ge).umod(this.curve.n);
    return this.makeSignature({ R: ke, S: et, Rencoded: Fe });
  }, Ie.prototype.verify = function(Te, Ee, Oe) {
    Te = _e(Te), Ee = this.makeSignature(Ee);
    var Le = this.keyFromPublic(Oe), ke = this.hashInt(Ee.Rencoded(), Le.pubBytes(), Te), Fe = this.g.mul(Ee.S()), Ge = Ee.R().add(Le.pub().mul(ke));
    return Ge.eq(Fe);
  }, Ie.prototype.hashInt = function() {
    for (var Te = this.hash(), Ee = 0; Ee < arguments.length; Ee++)
      Te.update(arguments[Ee]);
    return G.intFromLE(Te.digest()).umod(this.curve.n);
  }, Ie.prototype.keyFromPublic = function(Te) {
    return H.fromPublic(this, Te);
  }, Ie.prototype.keyFromSecret = function(Te) {
    return H.fromSecret(this, Te);
  }, Ie.prototype.makeSignature = function(Te) {
    return Te instanceof De ? Te : new De(this, Te);
  }, Ie.prototype.encodePoint = function(Te) {
    var Ee = Te.getY().toArray("le", this.encodingLength);
    return Ee[this.encodingLength - 1] |= Te.getX().isOdd() ? 128 : 0, Ee;
  }, Ie.prototype.decodePoint = function(Te) {
    Te = G.parseBytes(Te);
    var Ee = Te.length - 1, Oe = Te.slice(0, Ee).concat(Te[Ee] & -129), Le = (Te[Ee] & 128) !== 0, ke = G.intFromLE(Oe);
    return this.curve.pointFromY(ke, Le);
  }, Ie.prototype.encodeInt = function(Te) {
    return Te.toArray("le", this.encodingLength);
  }, Ie.prototype.decodeInt = function(Te) {
    return G.intFromLE(Te);
  }, Ie.prototype.isPoint = function(Te) {
    return Te instanceof this.pointClass;
  }, eddsa$1;
}
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(I) {
    var A = I;
    A.version = require$$0$1.version, A.utils = requireUtils(), A.rand = requireBrorand(), A.curve = requireCurve(), A.curves = requireCurves(), A.ec = requireEc(), A.eddsa = requireEddsa();
  }(elliptic$1)), elliptic$1;
}
var asn1$1 = {}, asn1 = {}, bn$3 = { exports: {} };
bn$3.exports;
var hasRequiredBn$2;
function requireBn$2() {
  return hasRequiredBn$2 || (hasRequiredBn$2 = 1, function(I) {
    (function(A, G) {
      function J(Se, t) {
        if (!Se) throw new Error(t || "Assertion failed");
      }
      function _e(Se, t) {
        Se.super_ = t;
        var h = function() {
        };
        h.prototype = t.prototype, Se.prototype = new h(), Se.prototype.constructor = Se;
      }
      function H(Se, t, h) {
        if (H.isBN(Se))
          return Se;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Se !== null && ((t === "le" || t === "be") && (h = t, t = 10), this._init(Se || 0, t || 10, h || "be"));
      }
      typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
      var De;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = require$$0$3.Buffer;
      } catch {
      }
      H.isBN = function(t) {
        return t instanceof H ? !0 : t !== null && typeof t == "object" && t.constructor.wordSize === H.wordSize && Array.isArray(t.words);
      }, H.max = function(t, h) {
        return t.cmp(h) > 0 ? t : h;
      }, H.min = function(t, h) {
        return t.cmp(h) < 0 ? t : h;
      }, H.prototype._init = function(t, h, B) {
        if (typeof t == "number")
          return this._initNumber(t, h, B);
        if (typeof t == "object")
          return this._initArray(t, h, B);
        h === "hex" && (h = 16), J(h === (h | 0) && h >= 2 && h <= 36), t = t.toString().replace(/\s+/g, "");
        var Z = 0;
        t[0] === "-" && (Z++, this.negative = 1), Z < t.length && (h === 16 ? this._parseHex(t, Z, B) : (this._parseBase(t, h, Z), B === "le" && this._initArray(this.toArray(), h, B)));
      }, H.prototype._initNumber = function(t, h, B) {
        t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [t & 67108863], this.length = 1) : t < 4503599627370496 ? (this.words = [
          t & 67108863,
          t / 67108864 & 67108863
        ], this.length = 2) : (J(t < 9007199254740992), this.words = [
          t & 67108863,
          t / 67108864 & 67108863,
          1
        ], this.length = 3), B === "le" && this._initArray(this.toArray(), h, B);
      }, H.prototype._initArray = function(t, h, B) {
        if (J(typeof t.length == "number"), t.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve, ge, xe = 0;
        if (B === "be")
          for (Z = t.length - 1, ve = 0; Z >= 0; Z -= 3)
            ge = t[Z] | t[Z - 1] << 8 | t[Z - 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        else if (B === "le")
          for (Z = 0, ve = 0; Z < t.length; Z += 3)
            ge = t[Z] | t[Z + 1] << 8 | t[Z + 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        return this.strip();
      };
      function Ie(Se, t) {
        var h = Se.charCodeAt(t);
        return h >= 65 && h <= 70 ? h - 55 : h >= 97 && h <= 102 ? h - 87 : h - 48 & 15;
      }
      function qe(Se, t, h) {
        var B = Ie(Se, h);
        return h - 1 >= t && (B |= Ie(Se, h - 1) << 4), B;
      }
      H.prototype._parseHex = function(t, h, B) {
        this.length = Math.ceil((t.length - h) / 6), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve = 0, ge = 0, xe;
        if (B === "be")
          for (Z = t.length - 1; Z >= h; Z -= 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        else {
          var X = t.length - h;
          for (Z = X % 2 === 0 ? h + 1 : h; Z < t.length; Z += 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        }
        this.strip();
      };
      function Te(Se, t, h, B) {
        for (var Z = 0, ve = Math.min(Se.length, h), ge = t; ge < ve; ge++) {
          var xe = Se.charCodeAt(ge) - 48;
          Z *= B, xe >= 49 ? Z += xe - 49 + 10 : xe >= 17 ? Z += xe - 17 + 10 : Z += xe;
        }
        return Z;
      }
      H.prototype._parseBase = function(t, h, B) {
        this.words = [0], this.length = 1;
        for (var Z = 0, ve = 1; ve <= 67108863; ve *= h)
          Z++;
        Z--, ve = ve / h | 0;
        for (var ge = t.length - B, xe = ge % Z, X = Math.min(ge, ge - xe) + B, a = 0, Y = B; Y < X; Y += Z)
          a = Te(t, Y, Y + Z, h), this.imuln(ve), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (xe !== 0) {
          var Ne = 1;
          for (a = Te(t, Y, t.length, h), Y = 0; Y < xe; Y++)
            Ne *= h;
          this.imuln(Ne), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, H.prototype.copy = function(t) {
        t.words = new Array(this.length);
        for (var h = 0; h < this.length; h++)
          t.words[h] = this.words[h];
        t.length = this.length, t.negative = this.negative, t.red = this.red;
      }, H.prototype.clone = function() {
        var t = new H(null);
        return this.copy(t), t;
      }, H.prototype._expand = function(t) {
        for (; this.length < t; )
          this.words[this.length++] = 0;
        return this;
      }, H.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, H.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, H.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var Ee = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Oe = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Le = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      H.prototype.toString = function(t, h) {
        t = t || 10, h = h | 0 || 1;
        var B;
        if (t === 16 || t === "hex") {
          B = "";
          for (var Z = 0, ve = 0, ge = 0; ge < this.length; ge++) {
            var xe = this.words[ge], X = ((xe << Z | ve) & 16777215).toString(16);
            ve = xe >>> 24 - Z & 16777215, ve !== 0 || ge !== this.length - 1 ? B = Ee[6 - X.length] + X + B : B = X + B, Z += 2, Z >= 26 && (Z -= 26, ge--);
          }
          for (ve !== 0 && (B = ve.toString(16) + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        if (t === (t | 0) && t >= 2 && t <= 36) {
          var a = Oe[t], Y = Le[t];
          B = "";
          var Ne = this.clone();
          for (Ne.negative = 0; !Ne.isZero(); ) {
            var Ke = Ne.modn(Y).toString(t);
            Ne = Ne.idivn(Y), Ne.isZero() ? B = Ke + B : B = Ee[a - Ke.length] + Ke + B;
          }
          for (this.isZero() && (B = "0" + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        J(!1, "Base should be between 2 and 36");
      }, H.prototype.toNumber = function() {
        var t = this.words[0];
        return this.length === 2 ? t += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? t += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -t : t;
      }, H.prototype.toJSON = function() {
        return this.toString(16);
      }, H.prototype.toBuffer = function(t, h) {
        return J(typeof De < "u"), this.toArrayLike(De, t, h);
      }, H.prototype.toArray = function(t, h) {
        return this.toArrayLike(Array, t, h);
      }, H.prototype.toArrayLike = function(t, h, B) {
        var Z = this.byteLength(), ve = B || Math.max(1, Z);
        J(Z <= ve, "byte array longer than desired length"), J(ve > 0, "Requested array length <= 0"), this.strip();
        var ge = h === "le", xe = new t(ve), X, a, Y = this.clone();
        if (ge) {
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[a] = X;
          for (; a < ve; a++)
            xe[a] = 0;
        } else {
          for (a = 0; a < ve - Z; a++)
            xe[a] = 0;
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[ve - a - 1] = X;
        }
        return xe;
      }, Math.clz32 ? H.prototype._countBits = function(t) {
        return 32 - Math.clz32(t);
      } : H.prototype._countBits = function(t) {
        var h = t, B = 0;
        return h >= 4096 && (B += 13, h >>>= 13), h >= 64 && (B += 7, h >>>= 7), h >= 8 && (B += 4, h >>>= 4), h >= 2 && (B += 2, h >>>= 2), B + h;
      }, H.prototype._zeroBits = function(t) {
        if (t === 0) return 26;
        var h = t, B = 0;
        return h & 8191 || (B += 13, h >>>= 13), h & 127 || (B += 7, h >>>= 7), h & 15 || (B += 4, h >>>= 4), h & 3 || (B += 2, h >>>= 2), h & 1 || B++, B;
      }, H.prototype.bitLength = function() {
        var t = this.words[this.length - 1], h = this._countBits(t);
        return (this.length - 1) * 26 + h;
      };
      function ke(Se) {
        for (var t = new Array(Se.bitLength()), h = 0; h < t.length; h++) {
          var B = h / 26 | 0, Z = h % 26;
          t[h] = (Se.words[B] & 1 << Z) >>> Z;
        }
        return t;
      }
      H.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var t = 0, h = 0; h < this.length; h++) {
          var B = this._zeroBits(this.words[h]);
          if (t += B, B !== 26) break;
        }
        return t;
      }, H.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, H.prototype.toTwos = function(t) {
        return this.negative !== 0 ? this.abs().inotn(t).iaddn(1) : this.clone();
      }, H.prototype.fromTwos = function(t) {
        return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
      }, H.prototype.isNeg = function() {
        return this.negative !== 0;
      }, H.prototype.neg = function() {
        return this.clone().ineg();
      }, H.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, H.prototype.iuor = function(t) {
        for (; this.length < t.length; )
          this.words[this.length++] = 0;
        for (var h = 0; h < t.length; h++)
          this.words[h] = this.words[h] | t.words[h];
        return this.strip();
      }, H.prototype.ior = function(t) {
        return J((this.negative | t.negative) === 0), this.iuor(t);
      }, H.prototype.or = function(t) {
        return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
      }, H.prototype.uor = function(t) {
        return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
      }, H.prototype.iuand = function(t) {
        var h;
        this.length > t.length ? h = t : h = this;
        for (var B = 0; B < h.length; B++)
          this.words[B] = this.words[B] & t.words[B];
        return this.length = h.length, this.strip();
      }, H.prototype.iand = function(t) {
        return J((this.negative | t.negative) === 0), this.iuand(t);
      }, H.prototype.and = function(t) {
        return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
      }, H.prototype.uand = function(t) {
        return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
      }, H.prototype.iuxor = function(t) {
        var h, B;
        this.length > t.length ? (h = this, B = t) : (h = t, B = this);
        for (var Z = 0; Z < B.length; Z++)
          this.words[Z] = h.words[Z] ^ B.words[Z];
        if (this !== h)
          for (; Z < h.length; Z++)
            this.words[Z] = h.words[Z];
        return this.length = h.length, this.strip();
      }, H.prototype.ixor = function(t) {
        return J((this.negative | t.negative) === 0), this.iuxor(t);
      }, H.prototype.xor = function(t) {
        return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
      }, H.prototype.uxor = function(t) {
        return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
      }, H.prototype.inotn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = Math.ceil(t / 26) | 0, B = t % 26;
        this._expand(h), B > 0 && h--;
        for (var Z = 0; Z < h; Z++)
          this.words[Z] = ~this.words[Z] & 67108863;
        return B > 0 && (this.words[Z] = ~this.words[Z] & 67108863 >> 26 - B), this.strip();
      }, H.prototype.notn = function(t) {
        return this.clone().inotn(t);
      }, H.prototype.setn = function(t, h) {
        J(typeof t == "number" && t >= 0);
        var B = t / 26 | 0, Z = t % 26;
        return this._expand(B + 1), h ? this.words[B] = this.words[B] | 1 << Z : this.words[B] = this.words[B] & ~(1 << Z), this.strip();
      }, H.prototype.iadd = function(t) {
        var h;
        if (this.negative !== 0 && t.negative === 0)
          return this.negative = 0, h = this.isub(t), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && t.negative !== 0)
          return t.negative = 0, h = this.isub(t), t.negative = 1, h._normSign();
        var B, Z;
        this.length > t.length ? (B = this, Z = t) : (B = t, Z = this);
        for (var ve = 0, ge = 0; ge < Z.length; ge++)
          h = (B.words[ge] | 0) + (Z.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        for (; ve !== 0 && ge < B.length; ge++)
          h = (B.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        if (this.length = B.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (B !== this)
          for (; ge < B.length; ge++)
            this.words[ge] = B.words[ge];
        return this;
      }, H.prototype.add = function(t) {
        var h;
        return t.negative !== 0 && this.negative === 0 ? (t.negative = 0, h = this.sub(t), t.negative ^= 1, h) : t.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = t.sub(this), this.negative = 1, h) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
      }, H.prototype.isub = function(t) {
        if (t.negative !== 0) {
          t.negative = 0;
          var h = this.iadd(t);
          return t.negative = 1, h._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
        var B = this.cmp(t);
        if (B === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Z, ve;
        B > 0 ? (Z = this, ve = t) : (Z = t, ve = this);
        for (var ge = 0, xe = 0; xe < ve.length; xe++)
          h = (Z.words[xe] | 0) - (ve.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        for (; ge !== 0 && xe < Z.length; xe++)
          h = (Z.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        if (ge === 0 && xe < Z.length && Z !== this)
          for (; xe < Z.length; xe++)
            this.words[xe] = Z.words[xe];
        return this.length = Math.max(this.length, xe), Z !== this && (this.negative = 1), this.strip();
      }, H.prototype.sub = function(t) {
        return this.clone().isub(t);
      };
      function Fe(Se, t, h) {
        h.negative = t.negative ^ Se.negative;
        var B = Se.length + t.length | 0;
        h.length = B, B = B - 1 | 0;
        var Z = Se.words[0] | 0, ve = t.words[0] | 0, ge = Z * ve, xe = ge & 67108863, X = ge / 67108864 | 0;
        h.words[0] = xe;
        for (var a = 1; a < B; a++) {
          for (var Y = X >>> 26, Ne = X & 67108863, Ke = Math.min(a, t.length - 1), tt = Math.max(0, a - Se.length + 1); tt <= Ke; tt++) {
            var We = a - tt | 0;
            Z = Se.words[We] | 0, ve = t.words[tt] | 0, ge = Z * ve + Ne, Y += ge / 67108864 | 0, Ne = ge & 67108863;
          }
          h.words[a] = Ne | 0, X = Y | 0;
        }
        return X !== 0 ? h.words[a] = X | 0 : h.length--, h.strip();
      }
      var Ge = function(t, h, B) {
        var Z = t.words, ve = h.words, ge = B.words, xe = 0, X, a, Y, Ne = Z[0] | 0, Ke = Ne & 8191, tt = Ne >>> 13, We = Z[1] | 0, ot = We & 8191, He = We >>> 13, Qe = Z[2] | 0, nt = Qe & 8191, je = Qe >>> 13, it = Z[3] | 0, st = it & 8191, gt = it >>> 13, It = Z[4] | 0, At = It & 8191, Et = It >>> 13, ei = Z[5] | 0, Xt = ei & 8191, _t = ei >>> 13, ni = Z[6] | 0, Ct = ni & 8191, Wt = ni >>> 13, ii = Z[7] | 0, Pt = ii & 8191, Rt = ii >>> 13, ai = Z[8] | 0, Nt = ai & 8191, qt = ai >>> 13, oi = Z[9] | 0, ct = oi & 8191, Ze = oi >>> 13, at = ve[0] | 0, dt = at & 8191, yt = at >>> 13, St = ve[1] | 0, xt = St & 8191, Vt = St >>> 13, ci = ve[2] | 0, Qt = ci & 8191, rr = ci >>> 13, ui = ve[3] | 0, Gr = ui & 8191, yr = ui >>> 13, pi = ve[4] | 0, wr = pi & 8191, _r = pi >>> 13, di = ve[5] | 0, Sr = di & 8191, Br = di >>> 13, vi = ve[6] | 0, gr = vi & 8191, $r = vi >>> 13, li = ve[7] | 0, Ir = li & 8191, Cr = li >>> 13, mi = ve[8] | 0, Pr = mi & 8191, Or = mi >>> 13, yi = ve[9] | 0, Zr = yi & 8191, Vr = yi >>> 13;
        B.negative = t.negative ^ h.negative, B.length = 19, X = Math.imul(Ke, dt), a = Math.imul(Ke, yt), a = a + Math.imul(tt, dt) | 0, Y = Math.imul(tt, yt);
        var bi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, X = Math.imul(ot, dt), a = Math.imul(ot, yt), a = a + Math.imul(He, dt) | 0, Y = Math.imul(He, yt), X = X + Math.imul(Ke, xt) | 0, a = a + Math.imul(Ke, Vt) | 0, a = a + Math.imul(tt, xt) | 0, Y = Y + Math.imul(tt, Vt) | 0;
        var Ai = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, X = Math.imul(nt, dt), a = Math.imul(nt, yt), a = a + Math.imul(je, dt) | 0, Y = Math.imul(je, yt), X = X + Math.imul(ot, xt) | 0, a = a + Math.imul(ot, Vt) | 0, a = a + Math.imul(He, xt) | 0, Y = Y + Math.imul(He, Vt) | 0, X = X + Math.imul(Ke, Qt) | 0, a = a + Math.imul(Ke, rr) | 0, a = a + Math.imul(tt, Qt) | 0, Y = Y + Math.imul(tt, rr) | 0;
        var Zi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, X = Math.imul(st, dt), a = Math.imul(st, yt), a = a + Math.imul(gt, dt) | 0, Y = Math.imul(gt, yt), X = X + Math.imul(nt, xt) | 0, a = a + Math.imul(nt, Vt) | 0, a = a + Math.imul(je, xt) | 0, Y = Y + Math.imul(je, Vt) | 0, X = X + Math.imul(ot, Qt) | 0, a = a + Math.imul(ot, rr) | 0, a = a + Math.imul(He, Qt) | 0, Y = Y + Math.imul(He, rr) | 0, X = X + Math.imul(Ke, Gr) | 0, a = a + Math.imul(Ke, yr) | 0, a = a + Math.imul(tt, Gr) | 0, Y = Y + Math.imul(tt, yr) | 0;
        var Ji = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, X = Math.imul(At, dt), a = Math.imul(At, yt), a = a + Math.imul(Et, dt) | 0, Y = Math.imul(Et, yt), X = X + Math.imul(st, xt) | 0, a = a + Math.imul(st, Vt) | 0, a = a + Math.imul(gt, xt) | 0, Y = Y + Math.imul(gt, Vt) | 0, X = X + Math.imul(nt, Qt) | 0, a = a + Math.imul(nt, rr) | 0, a = a + Math.imul(je, Qt) | 0, Y = Y + Math.imul(je, rr) | 0, X = X + Math.imul(ot, Gr) | 0, a = a + Math.imul(ot, yr) | 0, a = a + Math.imul(He, Gr) | 0, Y = Y + Math.imul(He, yr) | 0, X = X + Math.imul(Ke, wr) | 0, a = a + Math.imul(Ke, _r) | 0, a = a + Math.imul(tt, wr) | 0, Y = Y + Math.imul(tt, _r) | 0;
        var Vi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, X = Math.imul(Xt, dt), a = Math.imul(Xt, yt), a = a + Math.imul(_t, dt) | 0, Y = Math.imul(_t, yt), X = X + Math.imul(At, xt) | 0, a = a + Math.imul(At, Vt) | 0, a = a + Math.imul(Et, xt) | 0, Y = Y + Math.imul(Et, Vt) | 0, X = X + Math.imul(st, Qt) | 0, a = a + Math.imul(st, rr) | 0, a = a + Math.imul(gt, Qt) | 0, Y = Y + Math.imul(gt, rr) | 0, X = X + Math.imul(nt, Gr) | 0, a = a + Math.imul(nt, yr) | 0, a = a + Math.imul(je, Gr) | 0, Y = Y + Math.imul(je, yr) | 0, X = X + Math.imul(ot, wr) | 0, a = a + Math.imul(ot, _r) | 0, a = a + Math.imul(He, wr) | 0, Y = Y + Math.imul(He, _r) | 0, X = X + Math.imul(Ke, Sr) | 0, a = a + Math.imul(Ke, Br) | 0, a = a + Math.imul(tt, Sr) | 0, Y = Y + Math.imul(tt, Br) | 0;
        var Yi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, X = Math.imul(Ct, dt), a = Math.imul(Ct, yt), a = a + Math.imul(Wt, dt) | 0, Y = Math.imul(Wt, yt), X = X + Math.imul(Xt, xt) | 0, a = a + Math.imul(Xt, Vt) | 0, a = a + Math.imul(_t, xt) | 0, Y = Y + Math.imul(_t, Vt) | 0, X = X + Math.imul(At, Qt) | 0, a = a + Math.imul(At, rr) | 0, a = a + Math.imul(Et, Qt) | 0, Y = Y + Math.imul(Et, rr) | 0, X = X + Math.imul(st, Gr) | 0, a = a + Math.imul(st, yr) | 0, a = a + Math.imul(gt, Gr) | 0, Y = Y + Math.imul(gt, yr) | 0, X = X + Math.imul(nt, wr) | 0, a = a + Math.imul(nt, _r) | 0, a = a + Math.imul(je, wr) | 0, Y = Y + Math.imul(je, _r) | 0, X = X + Math.imul(ot, Sr) | 0, a = a + Math.imul(ot, Br) | 0, a = a + Math.imul(He, Sr) | 0, Y = Y + Math.imul(He, Br) | 0, X = X + Math.imul(Ke, gr) | 0, a = a + Math.imul(Ke, $r) | 0, a = a + Math.imul(tt, gr) | 0, Y = Y + Math.imul(tt, $r) | 0;
        var Xi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, X = Math.imul(Pt, dt), a = Math.imul(Pt, yt), a = a + Math.imul(Rt, dt) | 0, Y = Math.imul(Rt, yt), X = X + Math.imul(Ct, xt) | 0, a = a + Math.imul(Ct, Vt) | 0, a = a + Math.imul(Wt, xt) | 0, Y = Y + Math.imul(Wt, Vt) | 0, X = X + Math.imul(Xt, Qt) | 0, a = a + Math.imul(Xt, rr) | 0, a = a + Math.imul(_t, Qt) | 0, Y = Y + Math.imul(_t, rr) | 0, X = X + Math.imul(At, Gr) | 0, a = a + Math.imul(At, yr) | 0, a = a + Math.imul(Et, Gr) | 0, Y = Y + Math.imul(Et, yr) | 0, X = X + Math.imul(st, wr) | 0, a = a + Math.imul(st, _r) | 0, a = a + Math.imul(gt, wr) | 0, Y = Y + Math.imul(gt, _r) | 0, X = X + Math.imul(nt, Sr) | 0, a = a + Math.imul(nt, Br) | 0, a = a + Math.imul(je, Sr) | 0, Y = Y + Math.imul(je, Br) | 0, X = X + Math.imul(ot, gr) | 0, a = a + Math.imul(ot, $r) | 0, a = a + Math.imul(He, gr) | 0, Y = Y + Math.imul(He, $r) | 0, X = X + Math.imul(Ke, Ir) | 0, a = a + Math.imul(Ke, Cr) | 0, a = a + Math.imul(tt, Ir) | 0, Y = Y + Math.imul(tt, Cr) | 0;
        var en = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, X = Math.imul(Nt, dt), a = Math.imul(Nt, yt), a = a + Math.imul(qt, dt) | 0, Y = Math.imul(qt, yt), X = X + Math.imul(Pt, xt) | 0, a = a + Math.imul(Pt, Vt) | 0, a = a + Math.imul(Rt, xt) | 0, Y = Y + Math.imul(Rt, Vt) | 0, X = X + Math.imul(Ct, Qt) | 0, a = a + Math.imul(Ct, rr) | 0, a = a + Math.imul(Wt, Qt) | 0, Y = Y + Math.imul(Wt, rr) | 0, X = X + Math.imul(Xt, Gr) | 0, a = a + Math.imul(Xt, yr) | 0, a = a + Math.imul(_t, Gr) | 0, Y = Y + Math.imul(_t, yr) | 0, X = X + Math.imul(At, wr) | 0, a = a + Math.imul(At, _r) | 0, a = a + Math.imul(Et, wr) | 0, Y = Y + Math.imul(Et, _r) | 0, X = X + Math.imul(st, Sr) | 0, a = a + Math.imul(st, Br) | 0, a = a + Math.imul(gt, Sr) | 0, Y = Y + Math.imul(gt, Br) | 0, X = X + Math.imul(nt, gr) | 0, a = a + Math.imul(nt, $r) | 0, a = a + Math.imul(je, gr) | 0, Y = Y + Math.imul(je, $r) | 0, X = X + Math.imul(ot, Ir) | 0, a = a + Math.imul(ot, Cr) | 0, a = a + Math.imul(He, Ir) | 0, Y = Y + Math.imul(He, Cr) | 0, X = X + Math.imul(Ke, Pr) | 0, a = a + Math.imul(Ke, Or) | 0, a = a + Math.imul(tt, Pr) | 0, Y = Y + Math.imul(tt, Or) | 0;
        var hn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, X = Math.imul(ct, dt), a = Math.imul(ct, yt), a = a + Math.imul(Ze, dt) | 0, Y = Math.imul(Ze, yt), X = X + Math.imul(Nt, xt) | 0, a = a + Math.imul(Nt, Vt) | 0, a = a + Math.imul(qt, xt) | 0, Y = Y + Math.imul(qt, Vt) | 0, X = X + Math.imul(Pt, Qt) | 0, a = a + Math.imul(Pt, rr) | 0, a = a + Math.imul(Rt, Qt) | 0, Y = Y + Math.imul(Rt, rr) | 0, X = X + Math.imul(Ct, Gr) | 0, a = a + Math.imul(Ct, yr) | 0, a = a + Math.imul(Wt, Gr) | 0, Y = Y + Math.imul(Wt, yr) | 0, X = X + Math.imul(Xt, wr) | 0, a = a + Math.imul(Xt, _r) | 0, a = a + Math.imul(_t, wr) | 0, Y = Y + Math.imul(_t, _r) | 0, X = X + Math.imul(At, Sr) | 0, a = a + Math.imul(At, Br) | 0, a = a + Math.imul(Et, Sr) | 0, Y = Y + Math.imul(Et, Br) | 0, X = X + Math.imul(st, gr) | 0, a = a + Math.imul(st, $r) | 0, a = a + Math.imul(gt, gr) | 0, Y = Y + Math.imul(gt, $r) | 0, X = X + Math.imul(nt, Ir) | 0, a = a + Math.imul(nt, Cr) | 0, a = a + Math.imul(je, Ir) | 0, Y = Y + Math.imul(je, Cr) | 0, X = X + Math.imul(ot, Pr) | 0, a = a + Math.imul(ot, Or) | 0, a = a + Math.imul(He, Pr) | 0, Y = Y + Math.imul(He, Or) | 0, X = X + Math.imul(Ke, Zr) | 0, a = a + Math.imul(Ke, Vr) | 0, a = a + Math.imul(tt, Zr) | 0, Y = Y + Math.imul(tt, Vr) | 0;
        var tn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, X = Math.imul(ct, xt), a = Math.imul(ct, Vt), a = a + Math.imul(Ze, xt) | 0, Y = Math.imul(Ze, Vt), X = X + Math.imul(Nt, Qt) | 0, a = a + Math.imul(Nt, rr) | 0, a = a + Math.imul(qt, Qt) | 0, Y = Y + Math.imul(qt, rr) | 0, X = X + Math.imul(Pt, Gr) | 0, a = a + Math.imul(Pt, yr) | 0, a = a + Math.imul(Rt, Gr) | 0, Y = Y + Math.imul(Rt, yr) | 0, X = X + Math.imul(Ct, wr) | 0, a = a + Math.imul(Ct, _r) | 0, a = a + Math.imul(Wt, wr) | 0, Y = Y + Math.imul(Wt, _r) | 0, X = X + Math.imul(Xt, Sr) | 0, a = a + Math.imul(Xt, Br) | 0, a = a + Math.imul(_t, Sr) | 0, Y = Y + Math.imul(_t, Br) | 0, X = X + Math.imul(At, gr) | 0, a = a + Math.imul(At, $r) | 0, a = a + Math.imul(Et, gr) | 0, Y = Y + Math.imul(Et, $r) | 0, X = X + Math.imul(st, Ir) | 0, a = a + Math.imul(st, Cr) | 0, a = a + Math.imul(gt, Ir) | 0, Y = Y + Math.imul(gt, Cr) | 0, X = X + Math.imul(nt, Pr) | 0, a = a + Math.imul(nt, Or) | 0, a = a + Math.imul(je, Pr) | 0, Y = Y + Math.imul(je, Or) | 0, X = X + Math.imul(ot, Zr) | 0, a = a + Math.imul(ot, Vr) | 0, a = a + Math.imul(He, Zr) | 0, Y = Y + Math.imul(He, Vr) | 0;
        var un = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, X = Math.imul(ct, Qt), a = Math.imul(ct, rr), a = a + Math.imul(Ze, Qt) | 0, Y = Math.imul(Ze, rr), X = X + Math.imul(Nt, Gr) | 0, a = a + Math.imul(Nt, yr) | 0, a = a + Math.imul(qt, Gr) | 0, Y = Y + Math.imul(qt, yr) | 0, X = X + Math.imul(Pt, wr) | 0, a = a + Math.imul(Pt, _r) | 0, a = a + Math.imul(Rt, wr) | 0, Y = Y + Math.imul(Rt, _r) | 0, X = X + Math.imul(Ct, Sr) | 0, a = a + Math.imul(Ct, Br) | 0, a = a + Math.imul(Wt, Sr) | 0, Y = Y + Math.imul(Wt, Br) | 0, X = X + Math.imul(Xt, gr) | 0, a = a + Math.imul(Xt, $r) | 0, a = a + Math.imul(_t, gr) | 0, Y = Y + Math.imul(_t, $r) | 0, X = X + Math.imul(At, Ir) | 0, a = a + Math.imul(At, Cr) | 0, a = a + Math.imul(Et, Ir) | 0, Y = Y + Math.imul(Et, Cr) | 0, X = X + Math.imul(st, Pr) | 0, a = a + Math.imul(st, Or) | 0, a = a + Math.imul(gt, Pr) | 0, Y = Y + Math.imul(gt, Or) | 0, X = X + Math.imul(nt, Zr) | 0, a = a + Math.imul(nt, Vr) | 0, a = a + Math.imul(je, Zr) | 0, Y = Y + Math.imul(je, Vr) | 0;
        var cn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, X = Math.imul(ct, Gr), a = Math.imul(ct, yr), a = a + Math.imul(Ze, Gr) | 0, Y = Math.imul(Ze, yr), X = X + Math.imul(Nt, wr) | 0, a = a + Math.imul(Nt, _r) | 0, a = a + Math.imul(qt, wr) | 0, Y = Y + Math.imul(qt, _r) | 0, X = X + Math.imul(Pt, Sr) | 0, a = a + Math.imul(Pt, Br) | 0, a = a + Math.imul(Rt, Sr) | 0, Y = Y + Math.imul(Rt, Br) | 0, X = X + Math.imul(Ct, gr) | 0, a = a + Math.imul(Ct, $r) | 0, a = a + Math.imul(Wt, gr) | 0, Y = Y + Math.imul(Wt, $r) | 0, X = X + Math.imul(Xt, Ir) | 0, a = a + Math.imul(Xt, Cr) | 0, a = a + Math.imul(_t, Ir) | 0, Y = Y + Math.imul(_t, Cr) | 0, X = X + Math.imul(At, Pr) | 0, a = a + Math.imul(At, Or) | 0, a = a + Math.imul(Et, Pr) | 0, Y = Y + Math.imul(Et, Or) | 0, X = X + Math.imul(st, Zr) | 0, a = a + Math.imul(st, Vr) | 0, a = a + Math.imul(gt, Zr) | 0, Y = Y + Math.imul(gt, Vr) | 0;
        var ln = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, X = Math.imul(ct, wr), a = Math.imul(ct, _r), a = a + Math.imul(Ze, wr) | 0, Y = Math.imul(Ze, _r), X = X + Math.imul(Nt, Sr) | 0, a = a + Math.imul(Nt, Br) | 0, a = a + Math.imul(qt, Sr) | 0, Y = Y + Math.imul(qt, Br) | 0, X = X + Math.imul(Pt, gr) | 0, a = a + Math.imul(Pt, $r) | 0, a = a + Math.imul(Rt, gr) | 0, Y = Y + Math.imul(Rt, $r) | 0, X = X + Math.imul(Ct, Ir) | 0, a = a + Math.imul(Ct, Cr) | 0, a = a + Math.imul(Wt, Ir) | 0, Y = Y + Math.imul(Wt, Cr) | 0, X = X + Math.imul(Xt, Pr) | 0, a = a + Math.imul(Xt, Or) | 0, a = a + Math.imul(_t, Pr) | 0, Y = Y + Math.imul(_t, Or) | 0, X = X + Math.imul(At, Zr) | 0, a = a + Math.imul(At, Vr) | 0, a = a + Math.imul(Et, Zr) | 0, Y = Y + Math.imul(Et, Vr) | 0;
        var an = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, X = Math.imul(ct, Sr), a = Math.imul(ct, Br), a = a + Math.imul(Ze, Sr) | 0, Y = Math.imul(Ze, Br), X = X + Math.imul(Nt, gr) | 0, a = a + Math.imul(Nt, $r) | 0, a = a + Math.imul(qt, gr) | 0, Y = Y + Math.imul(qt, $r) | 0, X = X + Math.imul(Pt, Ir) | 0, a = a + Math.imul(Pt, Cr) | 0, a = a + Math.imul(Rt, Ir) | 0, Y = Y + Math.imul(Rt, Cr) | 0, X = X + Math.imul(Ct, Pr) | 0, a = a + Math.imul(Ct, Or) | 0, a = a + Math.imul(Wt, Pr) | 0, Y = Y + Math.imul(Wt, Or) | 0, X = X + Math.imul(Xt, Zr) | 0, a = a + Math.imul(Xt, Vr) | 0, a = a + Math.imul(_t, Zr) | 0, Y = Y + Math.imul(_t, Vr) | 0;
        var fn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, X = Math.imul(ct, gr), a = Math.imul(ct, $r), a = a + Math.imul(Ze, gr) | 0, Y = Math.imul(Ze, $r), X = X + Math.imul(Nt, Ir) | 0, a = a + Math.imul(Nt, Cr) | 0, a = a + Math.imul(qt, Ir) | 0, Y = Y + Math.imul(qt, Cr) | 0, X = X + Math.imul(Pt, Pr) | 0, a = a + Math.imul(Pt, Or) | 0, a = a + Math.imul(Rt, Pr) | 0, Y = Y + Math.imul(Rt, Or) | 0, X = X + Math.imul(Ct, Zr) | 0, a = a + Math.imul(Ct, Vr) | 0, a = a + Math.imul(Wt, Zr) | 0, Y = Y + Math.imul(Wt, Vr) | 0;
        var sn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, X = Math.imul(ct, Ir), a = Math.imul(ct, Cr), a = a + Math.imul(Ze, Ir) | 0, Y = Math.imul(Ze, Cr), X = X + Math.imul(Nt, Pr) | 0, a = a + Math.imul(Nt, Or) | 0, a = a + Math.imul(qt, Pr) | 0, Y = Y + Math.imul(qt, Or) | 0, X = X + Math.imul(Pt, Zr) | 0, a = a + Math.imul(Pt, Vr) | 0, a = a + Math.imul(Rt, Zr) | 0, Y = Y + Math.imul(Rt, Vr) | 0;
        var dn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, X = Math.imul(ct, Pr), a = Math.imul(ct, Or), a = a + Math.imul(Ze, Pr) | 0, Y = Math.imul(Ze, Or), X = X + Math.imul(Nt, Zr) | 0, a = a + Math.imul(Nt, Vr) | 0, a = a + Math.imul(qt, Zr) | 0, Y = Y + Math.imul(qt, Vr) | 0;
        var pn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, X = Math.imul(ct, Zr), a = Math.imul(ct, Vr), a = a + Math.imul(Ze, Zr) | 0, Y = Math.imul(Ze, Vr);
        var vn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        return xe = (Y + (a >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, ge[0] = bi, ge[1] = Ai, ge[2] = Zi, ge[3] = Ji, ge[4] = Vi, ge[5] = Yi, ge[6] = Xi, ge[7] = en, ge[8] = hn, ge[9] = tn, ge[10] = un, ge[11] = cn, ge[12] = ln, ge[13] = an, ge[14] = fn, ge[15] = sn, ge[16] = dn, ge[17] = pn, ge[18] = vn, xe !== 0 && (ge[19] = xe, B.length++), B;
      };
      Math.imul || (Ge = Fe);
      function et(Se, t, h) {
        h.negative = t.negative ^ Se.negative, h.length = Se.length + t.length;
        for (var B = 0, Z = 0, ve = 0; ve < h.length - 1; ve++) {
          var ge = Z;
          Z = 0;
          for (var xe = B & 67108863, X = Math.min(ve, t.length - 1), a = Math.max(0, ve - Se.length + 1); a <= X; a++) {
            var Y = ve - a, Ne = Se.words[Y] | 0, Ke = t.words[a] | 0, tt = Ne * Ke, We = tt & 67108863;
            ge = ge + (tt / 67108864 | 0) | 0, We = We + xe | 0, xe = We & 67108863, ge = ge + (We >>> 26) | 0, Z += ge >>> 26, ge &= 67108863;
          }
          h.words[ve] = xe, B = ge, ge = Z;
        }
        return B !== 0 ? h.words[ve] = B : h.length--, h.strip();
      }
      function Ve(Se, t, h) {
        var B = new Je();
        return B.mulp(Se, t, h);
      }
      H.prototype.mulTo = function(t, h) {
        var B, Z = this.length + t.length;
        return this.length === 10 && t.length === 10 ? B = Ge(this, t, h) : Z < 63 ? B = Fe(this, t, h) : Z < 1024 ? B = et(this, t, h) : B = Ve(this, t, h), B;
      };
      function Je(Se, t) {
        this.x = Se, this.y = t;
      }
      Je.prototype.makeRBT = function(t) {
        for (var h = new Array(t), B = H.prototype._countBits(t) - 1, Z = 0; Z < t; Z++)
          h[Z] = this.revBin(Z, B, t);
        return h;
      }, Je.prototype.revBin = function(t, h, B) {
        if (t === 0 || t === B - 1) return t;
        for (var Z = 0, ve = 0; ve < h; ve++)
          Z |= (t & 1) << h - ve - 1, t >>= 1;
        return Z;
      }, Je.prototype.permute = function(t, h, B, Z, ve, ge) {
        for (var xe = 0; xe < ge; xe++)
          Z[xe] = h[t[xe]], ve[xe] = B[t[xe]];
      }, Je.prototype.transform = function(t, h, B, Z, ve, ge) {
        this.permute(ge, t, h, B, Z, ve);
        for (var xe = 1; xe < ve; xe <<= 1)
          for (var X = xe << 1, a = Math.cos(2 * Math.PI / X), Y = Math.sin(2 * Math.PI / X), Ne = 0; Ne < ve; Ne += X)
            for (var Ke = a, tt = Y, We = 0; We < xe; We++) {
              var ot = B[Ne + We], He = Z[Ne + We], Qe = B[Ne + We + xe], nt = Z[Ne + We + xe], je = Ke * Qe - tt * nt;
              nt = Ke * nt + tt * Qe, Qe = je, B[Ne + We] = ot + Qe, Z[Ne + We] = He + nt, B[Ne + We + xe] = ot - Qe, Z[Ne + We + xe] = He - nt, We !== X && (je = a * Ke - Y * tt, tt = a * tt + Y * Ke, Ke = je);
            }
      }, Je.prototype.guessLen13b = function(t, h) {
        var B = Math.max(h, t) | 1, Z = B & 1, ve = 0;
        for (B = B / 2 | 0; B; B = B >>> 1)
          ve++;
        return 1 << ve + 1 + Z;
      }, Je.prototype.conjugate = function(t, h, B) {
        if (!(B <= 1))
          for (var Z = 0; Z < B / 2; Z++) {
            var ve = t[Z];
            t[Z] = t[B - Z - 1], t[B - Z - 1] = ve, ve = h[Z], h[Z] = -h[B - Z - 1], h[B - Z - 1] = -ve;
          }
      }, Je.prototype.normalize13b = function(t, h) {
        for (var B = 0, Z = 0; Z < h / 2; Z++) {
          var ve = Math.round(t[2 * Z + 1] / h) * 8192 + Math.round(t[2 * Z] / h) + B;
          t[Z] = ve & 67108863, ve < 67108864 ? B = 0 : B = ve / 67108864 | 0;
        }
        return t;
      }, Je.prototype.convert13b = function(t, h, B, Z) {
        for (var ve = 0, ge = 0; ge < h; ge++)
          ve = ve + (t[ge] | 0), B[2 * ge] = ve & 8191, ve = ve >>> 13, B[2 * ge + 1] = ve & 8191, ve = ve >>> 13;
        for (ge = 2 * h; ge < Z; ++ge)
          B[ge] = 0;
        J(ve === 0), J((ve & -8192) === 0);
      }, Je.prototype.stub = function(t) {
        for (var h = new Array(t), B = 0; B < t; B++)
          h[B] = 0;
        return h;
      }, Je.prototype.mulp = function(t, h, B) {
        var Z = 2 * this.guessLen13b(t.length, h.length), ve = this.makeRBT(Z), ge = this.stub(Z), xe = new Array(Z), X = new Array(Z), a = new Array(Z), Y = new Array(Z), Ne = new Array(Z), Ke = new Array(Z), tt = B.words;
        tt.length = Z, this.convert13b(t.words, t.length, xe, Z), this.convert13b(h.words, h.length, Y, Z), this.transform(xe, ge, X, a, Z, ve), this.transform(Y, ge, Ne, Ke, Z, ve);
        for (var We = 0; We < Z; We++) {
          var ot = X[We] * Ne[We] - a[We] * Ke[We];
          a[We] = X[We] * Ke[We] + a[We] * Ne[We], X[We] = ot;
        }
        return this.conjugate(X, a, Z), this.transform(X, a, tt, ge, Z, ve), this.conjugate(tt, ge, Z), this.normalize13b(tt, Z), B.negative = t.negative ^ h.negative, B.length = t.length + h.length, B.strip();
      }, H.prototype.mul = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), this.mulTo(t, h);
      }, H.prototype.mulf = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), Ve(this, t, h);
      }, H.prototype.imul = function(t) {
        return this.clone().mulTo(t, this);
      }, H.prototype.imuln = function(t) {
        J(typeof t == "number"), J(t < 67108864);
        for (var h = 0, B = 0; B < this.length; B++) {
          var Z = (this.words[B] | 0) * t, ve = (Z & 67108863) + (h & 67108863);
          h >>= 26, h += Z / 67108864 | 0, h += ve >>> 26, this.words[B] = ve & 67108863;
        }
        return h !== 0 && (this.words[B] = h, this.length++), this;
      }, H.prototype.muln = function(t) {
        return this.clone().imuln(t);
      }, H.prototype.sqr = function() {
        return this.mul(this);
      }, H.prototype.isqr = function() {
        return this.imul(this.clone());
      }, H.prototype.pow = function(t) {
        var h = ke(t);
        if (h.length === 0) return new H(1);
        for (var B = this, Z = 0; Z < h.length && h[Z] === 0; Z++, B = B.sqr())
          ;
        if (++Z < h.length)
          for (var ve = B.sqr(); Z < h.length; Z++, ve = ve.sqr())
            h[Z] !== 0 && (B = B.mul(ve));
        return B;
      }, H.prototype.iushln = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 67108863 >>> 26 - h << 26 - h, ve;
        if (h !== 0) {
          var ge = 0;
          for (ve = 0; ve < this.length; ve++) {
            var xe = this.words[ve] & Z, X = (this.words[ve] | 0) - xe << h;
            this.words[ve] = X | ge, ge = xe >>> 26 - h;
          }
          ge && (this.words[ve] = ge, this.length++);
        }
        if (B !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + B] = this.words[ve];
          for (ve = 0; ve < B; ve++)
            this.words[ve] = 0;
          this.length += B;
        }
        return this.strip();
      }, H.prototype.ishln = function(t) {
        return J(this.negative === 0), this.iushln(t);
      }, H.prototype.iushrn = function(t, h, B) {
        J(typeof t == "number" && t >= 0);
        var Z;
        h ? Z = (h - h % 26) / 26 : Z = 0;
        var ve = t % 26, ge = Math.min((t - ve) / 26, this.length), xe = 67108863 ^ 67108863 >>> ve << ve, X = B;
        if (Z -= ge, Z = Math.max(0, Z), X) {
          for (var a = 0; a < ge; a++)
            X.words[a] = this.words[a];
          X.length = ge;
        }
        if (ge !== 0) if (this.length > ge)
          for (this.length -= ge, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + ge];
        else
          this.words[0] = 0, this.length = 1;
        var Y = 0;
        for (a = this.length - 1; a >= 0 && (Y !== 0 || a >= Z); a--) {
          var Ne = this.words[a] | 0;
          this.words[a] = Y << 26 - ve | Ne >>> ve, Y = Ne & xe;
        }
        return X && Y !== 0 && (X.words[X.length++] = Y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, H.prototype.ishrn = function(t, h, B) {
        return J(this.negative === 0), this.iushrn(t, h, B);
      }, H.prototype.shln = function(t) {
        return this.clone().ishln(t);
      }, H.prototype.ushln = function(t) {
        return this.clone().iushln(t);
      }, H.prototype.shrn = function(t) {
        return this.clone().ishrn(t);
      }, H.prototype.ushrn = function(t) {
        return this.clone().iushrn(t);
      }, H.prototype.testn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B) return !1;
        var ve = this.words[B];
        return !!(ve & Z);
      }, H.prototype.imaskn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26;
        if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= B)
          return this;
        if (h !== 0 && B++, this.length = Math.min(B, this.length), h !== 0) {
          var Z = 67108863 ^ 67108863 >>> h << h;
          this.words[this.length - 1] &= Z;
        }
        return this.strip();
      }, H.prototype.maskn = function(t) {
        return this.clone().imaskn(t);
      }, H.prototype.iaddn = function(t) {
        return J(typeof t == "number"), J(t < 67108864), t < 0 ? this.isubn(-t) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < t ? (this.words[0] = t - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
      }, H.prototype._iaddn = function(t) {
        this.words[0] += t;
        for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
          this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
        return this.length = Math.max(this.length, h + 1), this;
      }, H.prototype.isubn = function(t) {
        if (J(typeof t == "number"), J(t < 67108864), t < 0) return this.iaddn(-t);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(t), this.negative = 1, this;
        if (this.words[0] -= t, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var h = 0; h < this.length && this.words[h] < 0; h++)
            this.words[h] += 67108864, this.words[h + 1] -= 1;
        return this.strip();
      }, H.prototype.addn = function(t) {
        return this.clone().iaddn(t);
      }, H.prototype.subn = function(t) {
        return this.clone().isubn(t);
      }, H.prototype.iabs = function() {
        return this.negative = 0, this;
      }, H.prototype.abs = function() {
        return this.clone().iabs();
      }, H.prototype._ishlnsubmul = function(t, h, B) {
        var Z = t.length + B, ve;
        this._expand(Z);
        var ge, xe = 0;
        for (ve = 0; ve < t.length; ve++) {
          ge = (this.words[ve + B] | 0) + xe;
          var X = (t.words[ve] | 0) * h;
          ge -= X & 67108863, xe = (ge >> 26) - (X / 67108864 | 0), this.words[ve + B] = ge & 67108863;
        }
        for (; ve < this.length - B; ve++)
          ge = (this.words[ve + B] | 0) + xe, xe = ge >> 26, this.words[ve + B] = ge & 67108863;
        if (xe === 0) return this.strip();
        for (J(xe === -1), xe = 0, ve = 0; ve < this.length; ve++)
          ge = -(this.words[ve] | 0) + xe, xe = ge >> 26, this.words[ve] = ge & 67108863;
        return this.negative = 1, this.strip();
      }, H.prototype._wordDiv = function(t, h) {
        var B = this.length - t.length, Z = this.clone(), ve = t, ge = ve.words[ve.length - 1] | 0, xe = this._countBits(ge);
        B = 26 - xe, B !== 0 && (ve = ve.ushln(B), Z.iushln(B), ge = ve.words[ve.length - 1] | 0);
        var X = Z.length - ve.length, a;
        if (h !== "mod") {
          a = new H(null), a.length = X + 1, a.words = new Array(a.length);
          for (var Y = 0; Y < a.length; Y++)
            a.words[Y] = 0;
        }
        var Ne = Z.clone()._ishlnsubmul(ve, 1, X);
        Ne.negative === 0 && (Z = Ne, a && (a.words[X] = 1));
        for (var Ke = X - 1; Ke >= 0; Ke--) {
          var tt = (Z.words[ve.length + Ke] | 0) * 67108864 + (Z.words[ve.length + Ke - 1] | 0);
          for (tt = Math.min(tt / ge | 0, 67108863), Z._ishlnsubmul(ve, tt, Ke); Z.negative !== 0; )
            tt--, Z.negative = 0, Z._ishlnsubmul(ve, 1, Ke), Z.isZero() || (Z.negative ^= 1);
          a && (a.words[Ke] = tt);
        }
        return a && a.strip(), Z.strip(), h !== "div" && B !== 0 && Z.iushrn(B), {
          div: a || null,
          mod: Z
        };
      }, H.prototype.divmod = function(t, h, B) {
        if (J(!t.isZero()), this.isZero())
          return {
            div: new H(0),
            mod: new H(0)
          };
        var Z, ve, ge;
        return this.negative !== 0 && t.negative === 0 ? (ge = this.neg().divmod(t, h), h !== "mod" && (Z = ge.div.neg()), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.iadd(t)), {
          div: Z,
          mod: ve
        }) : this.negative === 0 && t.negative !== 0 ? (ge = this.divmod(t.neg(), h), h !== "mod" && (Z = ge.div.neg()), {
          div: Z,
          mod: ge.mod
        }) : this.negative & t.negative ? (ge = this.neg().divmod(t.neg(), h), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.isub(t)), {
          div: ge.div,
          mod: ve
        }) : t.length > this.length || this.cmp(t) < 0 ? {
          div: new H(0),
          mod: this
        } : t.length === 1 ? h === "div" ? {
          div: this.divn(t.words[0]),
          mod: null
        } : h === "mod" ? {
          div: null,
          mod: new H(this.modn(t.words[0]))
        } : {
          div: this.divn(t.words[0]),
          mod: new H(this.modn(t.words[0]))
        } : this._wordDiv(t, h);
      }, H.prototype.div = function(t) {
        return this.divmod(t, "div", !1).div;
      }, H.prototype.mod = function(t) {
        return this.divmod(t, "mod", !1).mod;
      }, H.prototype.umod = function(t) {
        return this.divmod(t, "mod", !0).mod;
      }, H.prototype.divRound = function(t) {
        var h = this.divmod(t);
        if (h.mod.isZero()) return h.div;
        var B = h.div.negative !== 0 ? h.mod.isub(t) : h.mod, Z = t.ushrn(1), ve = t.andln(1), ge = B.cmp(Z);
        return ge < 0 || ve === 1 && ge === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
      }, H.prototype.modn = function(t) {
        J(t <= 67108863);
        for (var h = (1 << 26) % t, B = 0, Z = this.length - 1; Z >= 0; Z--)
          B = (h * B + (this.words[Z] | 0)) % t;
        return B;
      }, H.prototype.idivn = function(t) {
        J(t <= 67108863);
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = (this.words[B] | 0) + h * 67108864;
          this.words[B] = Z / t | 0, h = Z % t;
        }
        return this.strip();
      }, H.prototype.divn = function(t) {
        return this.clone().idivn(t);
      }, H.prototype.egcd = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = new H(0), xe = new H(1), X = 0; h.isEven() && B.isEven(); )
          h.iushrn(1), B.iushrn(1), ++X;
        for (var a = B.clone(), Y = h.clone(); !h.isZero(); ) {
          for (var Ne = 0, Ke = 1; !(h.words[0] & Ke) && Ne < 26; ++Ne, Ke <<= 1) ;
          if (Ne > 0)
            for (h.iushrn(Ne); Ne-- > 0; )
              (Z.isOdd() || ve.isOdd()) && (Z.iadd(a), ve.isub(Y)), Z.iushrn(1), ve.iushrn(1);
          for (var tt = 0, We = 1; !(B.words[0] & We) && tt < 26; ++tt, We <<= 1) ;
          if (tt > 0)
            for (B.iushrn(tt); tt-- > 0; )
              (ge.isOdd() || xe.isOdd()) && (ge.iadd(a), xe.isub(Y)), ge.iushrn(1), xe.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ge), ve.isub(xe)) : (B.isub(h), ge.isub(Z), xe.isub(ve));
        }
        return {
          a: ge,
          b: xe,
          gcd: B.iushln(X)
        };
      }, H.prototype._invmp = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = B.clone(); h.cmpn(1) > 0 && B.cmpn(1) > 0; ) {
          for (var xe = 0, X = 1; !(h.words[0] & X) && xe < 26; ++xe, X <<= 1) ;
          if (xe > 0)
            for (h.iushrn(xe); xe-- > 0; )
              Z.isOdd() && Z.iadd(ge), Z.iushrn(1);
          for (var a = 0, Y = 1; !(B.words[0] & Y) && a < 26; ++a, Y <<= 1) ;
          if (a > 0)
            for (B.iushrn(a); a-- > 0; )
              ve.isOdd() && ve.iadd(ge), ve.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ve)) : (B.isub(h), ve.isub(Z));
        }
        var Ne;
        return h.cmpn(1) === 0 ? Ne = Z : Ne = ve, Ne.cmpn(0) < 0 && Ne.iadd(t), Ne;
      }, H.prototype.gcd = function(t) {
        if (this.isZero()) return t.abs();
        if (t.isZero()) return this.abs();
        var h = this.clone(), B = t.clone();
        h.negative = 0, B.negative = 0;
        for (var Z = 0; h.isEven() && B.isEven(); Z++)
          h.iushrn(1), B.iushrn(1);
        do {
          for (; h.isEven(); )
            h.iushrn(1);
          for (; B.isEven(); )
            B.iushrn(1);
          var ve = h.cmp(B);
          if (ve < 0) {
            var ge = h;
            h = B, B = ge;
          } else if (ve === 0 || B.cmpn(1) === 0)
            break;
          h.isub(B);
        } while (!0);
        return B.iushln(Z);
      }, H.prototype.invm = function(t) {
        return this.egcd(t).a.umod(t);
      }, H.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, H.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, H.prototype.andln = function(t) {
        return this.words[0] & t;
      }, H.prototype.bincn = function(t) {
        J(typeof t == "number");
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B)
          return this._expand(B + 1), this.words[B] |= Z, this;
        for (var ve = Z, ge = B; ve !== 0 && ge < this.length; ge++) {
          var xe = this.words[ge] | 0;
          xe += ve, ve = xe >>> 26, xe &= 67108863, this.words[ge] = xe;
        }
        return ve !== 0 && (this.words[ge] = ve, this.length++), this;
      }, H.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, H.prototype.cmpn = function(t) {
        var h = t < 0;
        if (this.negative !== 0 && !h) return -1;
        if (this.negative === 0 && h) return 1;
        this.strip();
        var B;
        if (this.length > 1)
          B = 1;
        else {
          h && (t = -t), J(t <= 67108863, "Number is too big");
          var Z = this.words[0] | 0;
          B = Z === t ? 0 : Z < t ? -1 : 1;
        }
        return this.negative !== 0 ? -B | 0 : B;
      }, H.prototype.cmp = function(t) {
        if (this.negative !== 0 && t.negative === 0) return -1;
        if (this.negative === 0 && t.negative !== 0) return 1;
        var h = this.ucmp(t);
        return this.negative !== 0 ? -h | 0 : h;
      }, H.prototype.ucmp = function(t) {
        if (this.length > t.length) return 1;
        if (this.length < t.length) return -1;
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = this.words[B] | 0, ve = t.words[B] | 0;
          if (Z !== ve) {
            Z < ve ? h = -1 : Z > ve && (h = 1);
            break;
          }
        }
        return h;
      }, H.prototype.gtn = function(t) {
        return this.cmpn(t) === 1;
      }, H.prototype.gt = function(t) {
        return this.cmp(t) === 1;
      }, H.prototype.gten = function(t) {
        return this.cmpn(t) >= 0;
      }, H.prototype.gte = function(t) {
        return this.cmp(t) >= 0;
      }, H.prototype.ltn = function(t) {
        return this.cmpn(t) === -1;
      }, H.prototype.lt = function(t) {
        return this.cmp(t) === -1;
      }, H.prototype.lten = function(t) {
        return this.cmpn(t) <= 0;
      }, H.prototype.lte = function(t) {
        return this.cmp(t) <= 0;
      }, H.prototype.eqn = function(t) {
        return this.cmpn(t) === 0;
      }, H.prototype.eq = function(t) {
        return this.cmp(t) === 0;
      }, H.red = function(t) {
        return new bt(t);
      }, H.prototype.toRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), t.convertTo(this)._forceRed(t);
      }, H.prototype.fromRed = function() {
        return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, H.prototype._forceRed = function(t) {
        return this.red = t, this;
      }, H.prototype.forceRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), this._forceRed(t);
      }, H.prototype.redAdd = function(t) {
        return J(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
      }, H.prototype.redIAdd = function(t) {
        return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
      }, H.prototype.redSub = function(t) {
        return J(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
      }, H.prototype.redISub = function(t) {
        return J(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
      }, H.prototype.redShl = function(t) {
        return J(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
      }, H.prototype.redMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
      }, H.prototype.redIMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
      }, H.prototype.redSqr = function() {
        return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, H.prototype.redISqr = function() {
        return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, H.prototype.redSqrt = function() {
        return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, H.prototype.redInvm = function() {
        return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, H.prototype.redNeg = function() {
        return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, H.prototype.redPow = function(t) {
        return J(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
      };
      var ut = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function rt(Se, t) {
        this.name = Se, this.p = new H(t, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      rt.prototype._tmp = function() {
        var t = new H(null);
        return t.words = new Array(Math.ceil(this.n / 13)), t;
      }, rt.prototype.ireduce = function(t) {
        var h = t, B;
        do
          this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), B = h.bitLength();
        while (B > this.n);
        var Z = B < this.n ? -1 : h.ucmp(this.p);
        return Z === 0 ? (h.words[0] = 0, h.length = 1) : Z > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
      }, rt.prototype.split = function(t, h) {
        t.iushrn(this.n, 0, h);
      }, rt.prototype.imulK = function(t) {
        return t.imul(this.k);
      };
      function lt() {
        rt.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      _e(lt, rt), lt.prototype.split = function(t, h) {
        for (var B = 4194303, Z = Math.min(t.length, 9), ve = 0; ve < Z; ve++)
          h.words[ve] = t.words[ve];
        if (h.length = Z, t.length <= 9) {
          t.words[0] = 0, t.length = 1;
          return;
        }
        var ge = t.words[9];
        for (h.words[h.length++] = ge & B, ve = 10; ve < t.length; ve++) {
          var xe = t.words[ve] | 0;
          t.words[ve - 10] = (xe & B) << 4 | ge >>> 22, ge = xe;
        }
        ge >>>= 22, t.words[ve - 10] = ge, ge === 0 && t.length > 10 ? t.length -= 10 : t.length -= 9;
      }, lt.prototype.imulK = function(t) {
        t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = t.words[B] | 0;
          h += Z * 977, t.words[B] = h & 67108863, h = Z * 64 + (h / 67108864 | 0);
        }
        return t.words[t.length - 1] === 0 && (t.length--, t.words[t.length - 1] === 0 && t.length--), t;
      };
      function vt() {
        rt.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      _e(vt, rt);
      function Ye() {
        rt.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      _e(Ye, rt);
      function pt() {
        rt.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      _e(pt, rt), pt.prototype.imulK = function(t) {
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = (t.words[B] | 0) * 19 + h, ve = Z & 67108863;
          Z >>>= 26, t.words[B] = ve, h = Z;
        }
        return h !== 0 && (t.words[t.length++] = h), t;
      }, H._prime = function(t) {
        if (ut[t]) return ut[t];
        var h;
        if (t === "k256")
          h = new lt();
        else if (t === "p224")
          h = new vt();
        else if (t === "p192")
          h = new Ye();
        else if (t === "p25519")
          h = new pt();
        else
          throw new Error("Unknown prime " + t);
        return ut[t] = h, h;
      };
      function bt(Se) {
        if (typeof Se == "string") {
          var t = H._prime(Se);
          this.m = t.p, this.prime = t;
        } else
          J(Se.gtn(1), "modulus must be greater than 1"), this.m = Se, this.prime = null;
      }
      bt.prototype._verify1 = function(t) {
        J(t.negative === 0, "red works only with positives"), J(t.red, "red works only with red numbers");
      }, bt.prototype._verify2 = function(t, h) {
        J((t.negative | h.negative) === 0, "red works only with positives"), J(
          t.red && t.red === h.red,
          "red works only with red numbers"
        );
      }, bt.prototype.imod = function(t) {
        return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
      }, bt.prototype.neg = function(t) {
        return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
      }, bt.prototype.add = function(t, h) {
        this._verify2(t, h);
        var B = t.add(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B._forceRed(this);
      }, bt.prototype.iadd = function(t, h) {
        this._verify2(t, h);
        var B = t.iadd(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B;
      }, bt.prototype.sub = function(t, h) {
        this._verify2(t, h);
        var B = t.sub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B._forceRed(this);
      }, bt.prototype.isub = function(t, h) {
        this._verify2(t, h);
        var B = t.isub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B;
      }, bt.prototype.shl = function(t, h) {
        return this._verify1(t), this.imod(t.ushln(h));
      }, bt.prototype.imul = function(t, h) {
        return this._verify2(t, h), this.imod(t.imul(h));
      }, bt.prototype.mul = function(t, h) {
        return this._verify2(t, h), this.imod(t.mul(h));
      }, bt.prototype.isqr = function(t) {
        return this.imul(t, t.clone());
      }, bt.prototype.sqr = function(t) {
        return this.mul(t, t);
      }, bt.prototype.sqrt = function(t) {
        if (t.isZero()) return t.clone();
        var h = this.m.andln(3);
        if (J(h % 2 === 1), h === 3) {
          var B = this.m.add(new H(1)).iushrn(2);
          return this.pow(t, B);
        }
        for (var Z = this.m.subn(1), ve = 0; !Z.isZero() && Z.andln(1) === 0; )
          ve++, Z.iushrn(1);
        J(!Z.isZero());
        var ge = new H(1).toRed(this), xe = ge.redNeg(), X = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new H(2 * a * a).toRed(this); this.pow(a, X).cmp(xe) !== 0; )
          a.redIAdd(xe);
        for (var Y = this.pow(a, Z), Ne = this.pow(t, Z.addn(1).iushrn(1)), Ke = this.pow(t, Z), tt = ve; Ke.cmp(ge) !== 0; ) {
          for (var We = Ke, ot = 0; We.cmp(ge) !== 0; ot++)
            We = We.redSqr();
          J(ot < tt);
          var He = this.pow(Y, new H(1).iushln(tt - ot - 1));
          Ne = Ne.redMul(He), Y = He.redSqr(), Ke = Ke.redMul(Y), tt = ot;
        }
        return Ne;
      }, bt.prototype.invm = function(t) {
        var h = t._invmp(this.m);
        return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
      }, bt.prototype.pow = function(t, h) {
        if (h.isZero()) return new H(1).toRed(this);
        if (h.cmpn(1) === 0) return t.clone();
        var B = 4, Z = new Array(1 << B);
        Z[0] = new H(1).toRed(this), Z[1] = t;
        for (var ve = 2; ve < Z.length; ve++)
          Z[ve] = this.mul(Z[ve - 1], t);
        var ge = Z[0], xe = 0, X = 0, a = h.bitLength() % 26;
        for (a === 0 && (a = 26), ve = h.length - 1; ve >= 0; ve--) {
          for (var Y = h.words[ve], Ne = a - 1; Ne >= 0; Ne--) {
            var Ke = Y >> Ne & 1;
            if (ge !== Z[0] && (ge = this.sqr(ge)), Ke === 0 && xe === 0) {
              X = 0;
              continue;
            }
            xe <<= 1, xe |= Ke, X++, !(X !== B && (ve !== 0 || Ne !== 0)) && (ge = this.mul(ge, Z[xe]), X = 0, xe = 0);
          }
          a = 26;
        }
        return ge;
      }, bt.prototype.convertTo = function(t) {
        var h = t.umod(this.m);
        return h === t ? h.clone() : h;
      }, bt.prototype.convertFrom = function(t) {
        var h = t.clone();
        return h.red = null, h;
      }, H.mont = function(t) {
        return new Yt(t);
      };
      function Yt(Se) {
        bt.call(this, Se), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      _e(Yt, bt), Yt.prototype.convertTo = function(t) {
        return this.imod(t.ushln(this.shift));
      }, Yt.prototype.convertFrom = function(t) {
        var h = this.imod(t.mul(this.rinv));
        return h.red = null, h;
      }, Yt.prototype.imul = function(t, h) {
        if (t.isZero() || h.isZero())
          return t.words[0] = 0, t.length = 1, t;
        var B = t.imul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.mul = function(t, h) {
        if (t.isZero() || h.isZero()) return new H(0)._forceRed(this);
        var B = t.mul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.invm = function(t) {
        var h = this.imod(t._invmp(this.m).mul(this.r2));
        return h._forceRed(this);
      };
    })(I, commonjsGlobal);
  }(bn$3)), bn$3.exports;
}
var api = {}, vmBrowserify = {}, hasRequiredVmBrowserify;
function requireVmBrowserify() {
  return hasRequiredVmBrowserify || (hasRequiredVmBrowserify = 1, function(exports) {
    var indexOf = function(I, A) {
      if (I.indexOf) return I.indexOf(A);
      for (var G = 0; G < I.length; G++)
        if (I[G] === A) return G;
      return -1;
    }, Object_keys = function(I) {
      if (Object.keys) return Object.keys(I);
      var A = [];
      for (var G in I) A.push(G);
      return A;
    }, forEach = function(I, A) {
      if (I.forEach) return I.forEach(A);
      for (var G = 0; G < I.length; G++)
        A(I[G], G, I);
    }, defineProp = function() {
      try {
        return Object.defineProperty({}, "_", {}), function(I, A, G) {
          Object.defineProperty(I, A, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: G
          });
        };
      } catch {
        return function(A, G, J) {
          A[G] = J;
        };
      }
    }(), globals = [
      "Array",
      "Boolean",
      "Date",
      "Error",
      "EvalError",
      "Function",
      "Infinity",
      "JSON",
      "Math",
      "NaN",
      "Number",
      "Object",
      "RangeError",
      "ReferenceError",
      "RegExp",
      "String",
      "SyntaxError",
      "TypeError",
      "URIError",
      "decodeURI",
      "decodeURIComponent",
      "encodeURI",
      "encodeURIComponent",
      "escape",
      "eval",
      "isFinite",
      "isNaN",
      "parseFloat",
      "parseInt",
      "undefined",
      "unescape"
    ];
    function Context() {
    }
    Context.prototype = {};
    var Script = exports.Script = function(A) {
      if (!(this instanceof Script)) return new Script(A);
      this.code = A;
    };
    Script.prototype.runInContext = function(I) {
      if (!(I instanceof Context))
        throw new TypeError("needs a 'context' argument.");
      var A = document.createElement("iframe");
      A.style || (A.style = {}), A.style.display = "none", document.body.appendChild(A);
      var G = A.contentWindow, J = G.eval, _e = G.execScript;
      !J && _e && (_e.call(G, "null"), J = G.eval), forEach(Object_keys(I), function(Ie) {
        G[Ie] = I[Ie];
      }), forEach(globals, function(Ie) {
        I[Ie] && (G[Ie] = I[Ie]);
      });
      var H = Object_keys(G), De = J.call(G, this.code);
      return forEach(Object_keys(G), function(Ie) {
        (Ie in I || indexOf(H, Ie) === -1) && (I[Ie] = G[Ie]);
      }), forEach(globals, function(Ie) {
        Ie in I || defineProp(I, Ie, G[Ie]);
      }), document.body.removeChild(A), De;
    }, Script.prototype.runInThisContext = function() {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function(I) {
      var A = Script.createContext(I), G = this.runInContext(A);
      return I && forEach(Object_keys(A), function(J) {
        I[J] = A[J];
      }), G;
    }, forEach(Object_keys(Script.prototype), function(I) {
      exports[I] = Script[I] = function(A) {
        var G = Script(A);
        return G[I].apply(G, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function(I) {
      return I instanceof Context;
    }, exports.createScript = function(I) {
      return exports.Script(I);
    }, exports.createContext = Script.createContext = function(I) {
      var A = new Context();
      return typeof I == "object" && forEach(Object_keys(I), function(G) {
        A[G] = I[G];
      }), A;
    };
  }(vmBrowserify)), vmBrowserify;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(I) {
    var A = requireAsn1$1(), G = inherits_browserExports, J = I;
    J.define = function(De, Ie) {
      return new _e(De, Ie);
    };
    function _e(H, De) {
      this.name = H, this.body = De, this.decoders = {}, this.encoders = {};
    }
    _e.prototype._createNamed = function(De) {
      var Ie;
      try {
        Ie = requireVmBrowserify().runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        Ie = function(Te) {
          this._initNamed(Te);
        };
      }
      return G(Ie, De), Ie.prototype._initNamed = function(Te) {
        De.call(this, Te);
      }, new Ie(this);
    }, _e.prototype._getDecoder = function(De) {
      return De = De || "der", this.decoders.hasOwnProperty(De) || (this.decoders[De] = this._createNamed(A.decoders[De])), this.decoders[De];
    }, _e.prototype.decode = function(De, Ie, qe) {
      return this._getDecoder(Ie).decode(De, qe);
    }, _e.prototype._getEncoder = function(De) {
      return De = De || "der", this.encoders.hasOwnProperty(De) || (this.encoders[De] = this._createNamed(A.encoders[De])), this.encoders[De];
    }, _e.prototype.encode = function(De, Ie, qe) {
      return this._getEncoder(Ie).encode(De, qe);
    };
  }(api)), api;
}
var base$2 = {}, reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter) return reporter;
  hasRequiredReporter = 1;
  var I = inherits_browserExports;
  function A(J) {
    this._reporterState = {
      obj: null,
      path: [],
      options: J || {},
      errors: []
    };
  }
  reporter.Reporter = A, A.prototype.isError = function(_e) {
    return _e instanceof G;
  }, A.prototype.save = function() {
    var _e = this._reporterState;
    return { obj: _e.obj, pathLen: _e.path.length };
  }, A.prototype.restore = function(_e) {
    var H = this._reporterState;
    H.obj = _e.obj, H.path = H.path.slice(0, _e.pathLen);
  }, A.prototype.enterKey = function(_e) {
    return this._reporterState.path.push(_e);
  }, A.prototype.exitKey = function(_e) {
    var H = this._reporterState;
    H.path = H.path.slice(0, _e - 1);
  }, A.prototype.leaveKey = function(_e, H, De) {
    var Ie = this._reporterState;
    this.exitKey(_e), Ie.obj !== null && (Ie.obj[H] = De);
  }, A.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, A.prototype.enterObject = function() {
    var _e = this._reporterState, H = _e.obj;
    return _e.obj = {}, H;
  }, A.prototype.leaveObject = function(_e) {
    var H = this._reporterState, De = H.obj;
    return H.obj = _e, De;
  }, A.prototype.error = function(_e) {
    var H, De = this._reporterState, Ie = _e instanceof G;
    if (Ie ? H = _e : H = new G(De.path.map(function(qe) {
      return "[" + JSON.stringify(qe) + "]";
    }).join(""), _e.message || _e, _e.stack), !De.options.partial)
      throw H;
    return Ie || De.errors.push(H), H;
  }, A.prototype.wrapResult = function(_e) {
    var H = this._reporterState;
    return H.options.partial ? {
      result: this.isError(_e) ? null : _e,
      errors: H.errors
    } : _e;
  };
  function G(J, _e) {
    this.path = J, this.rethrow(_e);
  }
  return I(G, Error), G.prototype.rethrow = function(_e) {
    if (this.message = _e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, G), !this.stack)
      try {
        throw new Error(this.message);
      } catch (H) {
        this.stack = H.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer) return buffer;
  hasRequiredBuffer = 1;
  var I = inherits_browserExports, A = requireBase().Reporter, G = require$$0$3.Buffer;
  function J(H, De) {
    if (A.call(this, De), !G.isBuffer(H)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = H, this.offset = 0, this.length = H.length;
  }
  I(J, A), buffer.DecoderBuffer = J, J.prototype.save = function() {
    return { offset: this.offset, reporter: A.prototype.save.call(this) };
  }, J.prototype.restore = function(De) {
    var Ie = new J(this.base);
    return Ie.offset = De.offset, Ie.length = this.offset, this.offset = De.offset, A.prototype.restore.call(this, De.reporter), Ie;
  }, J.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, J.prototype.readUInt8 = function(De) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(De || "DecoderBuffer overrun");
  }, J.prototype.skip = function(De, Ie) {
    if (!(this.offset + De <= this.length))
      return this.error(Ie || "DecoderBuffer overrun");
    var qe = new J(this.base);
    return qe._reporterState = this._reporterState, qe.offset = this.offset, qe.length = this.offset + De, this.offset += De, qe;
  }, J.prototype.raw = function(De) {
    return this.base.slice(De ? De.offset : this.offset, this.length);
  };
  function _e(H, De) {
    if (Array.isArray(H))
      this.length = 0, this.value = H.map(function(Ie) {
        return Ie instanceof _e || (Ie = new _e(Ie, De)), this.length += Ie.length, Ie;
      }, this);
    else if (typeof H == "number") {
      if (!(0 <= H && H <= 255))
        return De.error("non-byte EncoderBuffer value");
      this.value = H, this.length = 1;
    } else if (typeof H == "string")
      this.value = H, this.length = G.byteLength(H);
    else if (G.isBuffer(H))
      this.value = H, this.length = H.length;
    else
      return De.error("Unsupported type: " + typeof H);
  }
  return buffer.EncoderBuffer = _e, _e.prototype.join = function(De, Ie) {
    return De || (De = new G(this.length)), Ie || (Ie = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(qe) {
      qe.join(De, Ie), Ie += qe.length;
    }) : (typeof this.value == "number" ? De[Ie] = this.value : typeof this.value == "string" ? De.write(this.value, Ie) : G.isBuffer(this.value) && this.value.copy(De, Ie), Ie += this.length)), De;
  }, buffer;
}
var node, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  var I = requireBase().Reporter, A = requireBase().EncoderBuffer, G = requireBase().DecoderBuffer, J = minimalisticAssert, _e = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], H = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(_e), De = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function Ie(Te, Ee) {
    var Oe = {};
    this._baseState = Oe, Oe.enc = Te, Oe.parent = Ee || null, Oe.children = null, Oe.tag = null, Oe.args = null, Oe.reverseArgs = null, Oe.choice = null, Oe.optional = !1, Oe.any = !1, Oe.obj = !1, Oe.use = null, Oe.useDecoder = null, Oe.key = null, Oe.default = null, Oe.explicit = null, Oe.implicit = null, Oe.contains = null, Oe.parent || (Oe.children = [], this._wrap());
  }
  node = Ie;
  var qe = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return Ie.prototype.clone = function() {
    var Ee = this._baseState, Oe = {};
    qe.forEach(function(ke) {
      Oe[ke] = Ee[ke];
    });
    var Le = new this.constructor(Oe.parent);
    return Le._baseState = Oe, Le;
  }, Ie.prototype._wrap = function() {
    var Ee = this._baseState;
    H.forEach(function(Oe) {
      this[Oe] = function() {
        var ke = new this.constructor(this);
        return Ee.children.push(ke), ke[Oe].apply(ke, arguments);
      };
    }, this);
  }, Ie.prototype._init = function(Ee) {
    var Oe = this._baseState;
    J(Oe.parent === null), Ee.call(this), Oe.children = Oe.children.filter(function(Le) {
      return Le._baseState.parent === this;
    }, this), J.equal(Oe.children.length, 1, "Root node can have only one child");
  }, Ie.prototype._useArgs = function(Ee) {
    var Oe = this._baseState, Le = Ee.filter(function(ke) {
      return ke instanceof this.constructor;
    }, this);
    Ee = Ee.filter(function(ke) {
      return !(ke instanceof this.constructor);
    }, this), Le.length !== 0 && (J(Oe.children === null), Oe.children = Le, Le.forEach(function(ke) {
      ke._baseState.parent = this;
    }, this)), Ee.length !== 0 && (J(Oe.args === null), Oe.args = Ee, Oe.reverseArgs = Ee.map(function(ke) {
      if (typeof ke != "object" || ke.constructor !== Object)
        return ke;
      var Fe = {};
      return Object.keys(ke).forEach(function(Ge) {
        Ge == (Ge | 0) && (Ge |= 0);
        var et = ke[Ge];
        Fe[et] = Ge;
      }), Fe;
    }));
  }, De.forEach(function(Te) {
    Ie.prototype[Te] = function() {
      var Oe = this._baseState;
      throw new Error(Te + " not implemented for encoding: " + Oe.enc);
    };
  }), _e.forEach(function(Te) {
    Ie.prototype[Te] = function() {
      var Oe = this._baseState, Le = Array.prototype.slice.call(arguments);
      return J(Oe.tag === null), Oe.tag = Te, this._useArgs(Le), this;
    };
  }), Ie.prototype.use = function(Ee) {
    J(Ee);
    var Oe = this._baseState;
    return J(Oe.use === null), Oe.use = Ee, this;
  }, Ie.prototype.optional = function() {
    var Ee = this._baseState;
    return Ee.optional = !0, this;
  }, Ie.prototype.def = function(Ee) {
    var Oe = this._baseState;
    return J(Oe.default === null), Oe.default = Ee, Oe.optional = !0, this;
  }, Ie.prototype.explicit = function(Ee) {
    var Oe = this._baseState;
    return J(Oe.explicit === null && Oe.implicit === null), Oe.explicit = Ee, this;
  }, Ie.prototype.implicit = function(Ee) {
    var Oe = this._baseState;
    return J(Oe.explicit === null && Oe.implicit === null), Oe.implicit = Ee, this;
  }, Ie.prototype.obj = function() {
    var Ee = this._baseState, Oe = Array.prototype.slice.call(arguments);
    return Ee.obj = !0, Oe.length !== 0 && this._useArgs(Oe), this;
  }, Ie.prototype.key = function(Ee) {
    var Oe = this._baseState;
    return J(Oe.key === null), Oe.key = Ee, this;
  }, Ie.prototype.any = function() {
    var Ee = this._baseState;
    return Ee.any = !0, this;
  }, Ie.prototype.choice = function(Ee) {
    var Oe = this._baseState;
    return J(Oe.choice === null), Oe.choice = Ee, this._useArgs(Object.keys(Ee).map(function(Le) {
      return Ee[Le];
    })), this;
  }, Ie.prototype.contains = function(Ee) {
    var Oe = this._baseState;
    return J(Oe.use === null), Oe.contains = Ee, this;
  }, Ie.prototype._decode = function(Ee, Oe) {
    var Le = this._baseState;
    if (Le.parent === null)
      return Ee.wrapResult(Le.children[0]._decode(Ee, Oe));
    var ke = Le.default, Fe = !0, Ge = null;
    if (Le.key !== null && (Ge = Ee.enterKey(Le.key)), Le.optional) {
      var et = null;
      if (Le.explicit !== null ? et = Le.explicit : Le.implicit !== null ? et = Le.implicit : Le.tag !== null && (et = Le.tag), et === null && !Le.any) {
        var Ve = Ee.save();
        try {
          Le.choice === null ? this._decodeGeneric(Le.tag, Ee, Oe) : this._decodeChoice(Ee, Oe), Fe = !0;
        } catch {
          Fe = !1;
        }
        Ee.restore(Ve);
      } else if (Fe = this._peekTag(Ee, et, Le.any), Ee.isError(Fe))
        return Fe;
    }
    var Je;
    if (Le.obj && Fe && (Je = Ee.enterObject()), Fe) {
      if (Le.explicit !== null) {
        var ut = this._decodeTag(Ee, Le.explicit);
        if (Ee.isError(ut))
          return ut;
        Ee = ut;
      }
      var rt = Ee.offset;
      if (Le.use === null && Le.choice === null) {
        if (Le.any)
          var Ve = Ee.save();
        var lt = this._decodeTag(
          Ee,
          Le.implicit !== null ? Le.implicit : Le.tag,
          Le.any
        );
        if (Ee.isError(lt))
          return lt;
        Le.any ? ke = Ee.raw(Ve) : Ee = lt;
      }
      if (Oe && Oe.track && Le.tag !== null && Oe.track(Ee.path(), rt, Ee.length, "tagged"), Oe && Oe.track && Le.tag !== null && Oe.track(Ee.path(), Ee.offset, Ee.length, "content"), Le.any ? ke = ke : Le.choice === null ? ke = this._decodeGeneric(Le.tag, Ee, Oe) : ke = this._decodeChoice(Ee, Oe), Ee.isError(ke))
        return ke;
      if (!Le.any && Le.choice === null && Le.children !== null && Le.children.forEach(function(pt) {
        pt._decode(Ee, Oe);
      }), Le.contains && (Le.tag === "octstr" || Le.tag === "bitstr")) {
        var vt = new G(ke);
        ke = this._getUse(Le.contains, Ee._reporterState.obj)._decode(vt, Oe);
      }
    }
    return Le.obj && Fe && (ke = Ee.leaveObject(Je)), Le.key !== null && (ke !== null || Fe === !0) ? Ee.leaveKey(Ge, Le.key, ke) : Ge !== null && Ee.exitKey(Ge), ke;
  }, Ie.prototype._decodeGeneric = function(Ee, Oe, Le) {
    var ke = this._baseState;
    return Ee === "seq" || Ee === "set" ? null : Ee === "seqof" || Ee === "setof" ? this._decodeList(Oe, Ee, ke.args[0], Le) : /str$/.test(Ee) ? this._decodeStr(Oe, Ee, Le) : Ee === "objid" && ke.args ? this._decodeObjid(Oe, ke.args[0], ke.args[1], Le) : Ee === "objid" ? this._decodeObjid(Oe, null, null, Le) : Ee === "gentime" || Ee === "utctime" ? this._decodeTime(Oe, Ee, Le) : Ee === "null_" ? this._decodeNull(Oe, Le) : Ee === "bool" ? this._decodeBool(Oe, Le) : Ee === "objDesc" ? this._decodeStr(Oe, Ee, Le) : Ee === "int" || Ee === "enum" ? this._decodeInt(Oe, ke.args && ke.args[0], Le) : ke.use !== null ? this._getUse(ke.use, Oe._reporterState.obj)._decode(Oe, Le) : Oe.error("unknown tag: " + Ee);
  }, Ie.prototype._getUse = function(Ee, Oe) {
    var Le = this._baseState;
    return Le.useDecoder = this._use(Ee, Oe), J(Le.useDecoder._baseState.parent === null), Le.useDecoder = Le.useDecoder._baseState.children[0], Le.implicit !== Le.useDecoder._baseState.implicit && (Le.useDecoder = Le.useDecoder.clone(), Le.useDecoder._baseState.implicit = Le.implicit), Le.useDecoder;
  }, Ie.prototype._decodeChoice = function(Ee, Oe) {
    var Le = this._baseState, ke = null, Fe = !1;
    return Object.keys(Le.choice).some(function(Ge) {
      var et = Ee.save(), Ve = Le.choice[Ge];
      try {
        var Je = Ve._decode(Ee, Oe);
        if (Ee.isError(Je))
          return !1;
        ke = { type: Ge, value: Je }, Fe = !0;
      } catch {
        return Ee.restore(et), !1;
      }
      return !0;
    }, this), Fe ? ke : Ee.error("Choice not matched");
  }, Ie.prototype._createEncoderBuffer = function(Ee) {
    return new A(Ee, this.reporter);
  }, Ie.prototype._encode = function(Ee, Oe, Le) {
    var ke = this._baseState;
    if (!(ke.default !== null && ke.default === Ee)) {
      var Fe = this._encodeValue(Ee, Oe, Le);
      if (Fe !== void 0 && !this._skipDefault(Fe, Oe, Le))
        return Fe;
    }
  }, Ie.prototype._encodeValue = function(Ee, Oe, Le) {
    var ke = this._baseState;
    if (ke.parent === null)
      return ke.children[0]._encode(Ee, Oe || new I());
    var Ve = null;
    if (this.reporter = Oe, ke.optional && Ee === void 0)
      if (ke.default !== null)
        Ee = ke.default;
      else
        return;
    var Fe = null, Ge = !1;
    if (ke.any)
      Ve = this._createEncoderBuffer(Ee);
    else if (ke.choice)
      Ve = this._encodeChoice(Ee, Oe);
    else if (ke.contains)
      Fe = this._getUse(ke.contains, Le)._encode(Ee, Oe), Ge = !0;
    else if (ke.children)
      Fe = ke.children.map(function(rt) {
        if (rt._baseState.tag === "null_")
          return rt._encode(null, Oe, Ee);
        if (rt._baseState.key === null)
          return Oe.error("Child should have a key");
        var lt = Oe.enterKey(rt._baseState.key);
        if (typeof Ee != "object")
          return Oe.error("Child expected, but input is not object");
        var vt = rt._encode(Ee[rt._baseState.key], Oe, Ee);
        return Oe.leaveKey(lt), vt;
      }, this).filter(function(rt) {
        return rt;
      }), Fe = this._createEncoderBuffer(Fe);
    else if (ke.tag === "seqof" || ke.tag === "setof") {
      if (!(ke.args && ke.args.length === 1))
        return Oe.error("Too many args for : " + ke.tag);
      if (!Array.isArray(Ee))
        return Oe.error("seqof/setof, but data is not Array");
      var et = this.clone();
      et._baseState.implicit = null, Fe = this._createEncoderBuffer(Ee.map(function(rt) {
        var lt = this._baseState;
        return this._getUse(lt.args[0], Ee)._encode(rt, Oe);
      }, et));
    } else ke.use !== null ? Ve = this._getUse(ke.use, Le)._encode(Ee, Oe) : (Fe = this._encodePrimitive(ke.tag, Ee), Ge = !0);
    var Ve;
    if (!ke.any && ke.choice === null) {
      var Je = ke.implicit !== null ? ke.implicit : ke.tag, ut = ke.implicit === null ? "universal" : "context";
      Je === null ? ke.use === null && Oe.error("Tag could be omitted only for .use()") : ke.use === null && (Ve = this._encodeComposite(Je, Ge, ut, Fe));
    }
    return ke.explicit !== null && (Ve = this._encodeComposite(ke.explicit, !1, "context", Ve)), Ve;
  }, Ie.prototype._encodeChoice = function(Ee, Oe) {
    var Le = this._baseState, ke = Le.choice[Ee.type];
    return ke || J(
      !1,
      Ee.type + " not found in " + JSON.stringify(Object.keys(Le.choice))
    ), ke._encode(Ee.value, Oe);
  }, Ie.prototype._encodePrimitive = function(Ee, Oe) {
    var Le = this._baseState;
    if (/str$/.test(Ee))
      return this._encodeStr(Oe, Ee);
    if (Ee === "objid" && Le.args)
      return this._encodeObjid(Oe, Le.reverseArgs[0], Le.args[1]);
    if (Ee === "objid")
      return this._encodeObjid(Oe, null, null);
    if (Ee === "gentime" || Ee === "utctime")
      return this._encodeTime(Oe, Ee);
    if (Ee === "null_")
      return this._encodeNull();
    if (Ee === "int" || Ee === "enum")
      return this._encodeInt(Oe, Le.args && Le.reverseArgs[0]);
    if (Ee === "bool")
      return this._encodeBool(Oe);
    if (Ee === "objDesc")
      return this._encodeStr(Oe, Ee);
    throw new Error("Unsupported tag: " + Ee);
  }, Ie.prototype._isNumstr = function(Ee) {
    return /^[0-9 ]*$/.test(Ee);
  }, Ie.prototype._isPrintstr = function(Ee) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(Ee);
  }, node;
}
var hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(I) {
    var A = I;
    A.Reporter = requireReporter().Reporter, A.DecoderBuffer = requireBuffer().DecoderBuffer, A.EncoderBuffer = requireBuffer().EncoderBuffer, A.Node = requireNode();
  }(base$2)), base$2;
}
var constants = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(I) {
    var A = requireConstants();
    I.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, I.tagClassByName = A._reverse(I.tagClass), I.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, I.tagByName = A._reverse(I.tag);
  }(der)), der;
}
var hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(I) {
    var A = I;
    A._reverse = function(J) {
      var _e = {};
      return Object.keys(J).forEach(function(H) {
        (H | 0) == H && (H = H | 0);
        var De = J[H];
        _e[De] = H;
      }), _e;
    }, A.der = requireDer$2();
  }(constants)), constants;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1) return der_1$1;
  hasRequiredDer$1 = 1;
  var I = inherits_browserExports, A = requireAsn1$1(), G = A.base, J = A.bignum, _e = A.constants.der;
  function H(Te) {
    this.enc = "der", this.name = Te.name, this.entity = Te, this.tree = new De(), this.tree._init(Te.body);
  }
  der_1$1 = H, H.prototype.decode = function(Ee, Oe) {
    return Ee instanceof G.DecoderBuffer || (Ee = new G.DecoderBuffer(Ee, Oe)), this.tree._decode(Ee, Oe);
  };
  function De(Te) {
    G.Node.call(this, "der", Te);
  }
  I(De, G.Node), De.prototype._peekTag = function(Ee, Oe, Le) {
    if (Ee.isEmpty())
      return !1;
    var ke = Ee.save(), Fe = Ie(Ee, 'Failed to peek tag: "' + Oe + '"');
    return Ee.isError(Fe) ? Fe : (Ee.restore(ke), Fe.tag === Oe || Fe.tagStr === Oe || Fe.tagStr + "of" === Oe || Le);
  }, De.prototype._decodeTag = function(Ee, Oe, Le) {
    var ke = Ie(
      Ee,
      'Failed to decode tag of "' + Oe + '"'
    );
    if (Ee.isError(ke))
      return ke;
    var Fe = qe(
      Ee,
      ke.primitive,
      'Failed to get length of "' + Oe + '"'
    );
    if (Ee.isError(Fe))
      return Fe;
    if (!Le && ke.tag !== Oe && ke.tagStr !== Oe && ke.tagStr + "of" !== Oe)
      return Ee.error('Failed to match tag: "' + Oe + '"');
    if (ke.primitive || Fe !== null)
      return Ee.skip(Fe, 'Failed to match body of: "' + Oe + '"');
    var Ge = Ee.save(), et = this._skipUntilEnd(
      Ee,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return Ee.isError(et) ? et : (Fe = Ee.offset - Ge.offset, Ee.restore(Ge), Ee.skip(Fe, 'Failed to match body of: "' + Oe + '"'));
  }, De.prototype._skipUntilEnd = function(Ee, Oe) {
    for (; ; ) {
      var Le = Ie(Ee, Oe);
      if (Ee.isError(Le))
        return Le;
      var ke = qe(Ee, Le.primitive, Oe);
      if (Ee.isError(ke))
        return ke;
      var Fe;
      if (Le.primitive || ke !== null ? Fe = Ee.skip(ke) : Fe = this._skipUntilEnd(Ee, Oe), Ee.isError(Fe))
        return Fe;
      if (Le.tagStr === "end")
        break;
    }
  }, De.prototype._decodeList = function(Ee, Oe, Le, ke) {
    for (var Fe = []; !Ee.isEmpty(); ) {
      var Ge = this._peekTag(Ee, "end");
      if (Ee.isError(Ge))
        return Ge;
      var et = Le.decode(Ee, "der", ke);
      if (Ee.isError(et) && Ge)
        break;
      Fe.push(et);
    }
    return Fe;
  }, De.prototype._decodeStr = function(Ee, Oe) {
    if (Oe === "bitstr") {
      var Le = Ee.readUInt8();
      return Ee.isError(Le) ? Le : { unused: Le, data: Ee.raw() };
    } else if (Oe === "bmpstr") {
      var ke = Ee.raw();
      if (ke.length % 2 === 1)
        return Ee.error("Decoding of string type: bmpstr length mismatch");
      for (var Fe = "", Ge = 0; Ge < ke.length / 2; Ge++)
        Fe += String.fromCharCode(ke.readUInt16BE(Ge * 2));
      return Fe;
    } else if (Oe === "numstr") {
      var et = Ee.raw().toString("ascii");
      return this._isNumstr(et) ? et : Ee.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (Oe === "octstr")
        return Ee.raw();
      if (Oe === "objDesc")
        return Ee.raw();
      if (Oe === "printstr") {
        var Ve = Ee.raw().toString("ascii");
        return this._isPrintstr(Ve) ? Ve : Ee.error("Decoding of string type: printstr unsupported characters");
      } else return /str$/.test(Oe) ? Ee.raw().toString() : Ee.error("Decoding of string type: " + Oe + " unsupported");
    }
  }, De.prototype._decodeObjid = function(Ee, Oe, Le) {
    for (var ke, Fe = [], Ge = 0; !Ee.isEmpty(); ) {
      var et = Ee.readUInt8();
      Ge <<= 7, Ge |= et & 127, et & 128 || (Fe.push(Ge), Ge = 0);
    }
    et & 128 && Fe.push(Ge);
    var Ve = Fe[0] / 40 | 0, Je = Fe[0] % 40;
    if (Le ? ke = Fe : ke = [Ve, Je].concat(Fe.slice(1)), Oe) {
      var ut = Oe[ke.join(" ")];
      ut === void 0 && (ut = Oe[ke.join(".")]), ut !== void 0 && (ke = ut);
    }
    return ke;
  }, De.prototype._decodeTime = function(Ee, Oe) {
    var Le = Ee.raw().toString();
    if (Oe === "gentime")
      var ke = Le.slice(0, 4) | 0, Fe = Le.slice(4, 6) | 0, Ge = Le.slice(6, 8) | 0, et = Le.slice(8, 10) | 0, Ve = Le.slice(10, 12) | 0, Je = Le.slice(12, 14) | 0;
    else if (Oe === "utctime") {
      var ke = Le.slice(0, 2) | 0, Fe = Le.slice(2, 4) | 0, Ge = Le.slice(4, 6) | 0, et = Le.slice(6, 8) | 0, Ve = Le.slice(8, 10) | 0, Je = Le.slice(10, 12) | 0;
      ke < 70 ? ke = 2e3 + ke : ke = 1900 + ke;
    } else
      return Ee.error("Decoding " + Oe + " time is not supported yet");
    return Date.UTC(ke, Fe - 1, Ge, et, Ve, Je, 0);
  }, De.prototype._decodeNull = function(Ee) {
    return null;
  }, De.prototype._decodeBool = function(Ee) {
    var Oe = Ee.readUInt8();
    return Ee.isError(Oe) ? Oe : Oe !== 0;
  }, De.prototype._decodeInt = function(Ee, Oe) {
    var Le = Ee.raw(), ke = new J(Le);
    return Oe && (ke = Oe[ke.toString(10)] || ke), ke;
  }, De.prototype._use = function(Ee, Oe) {
    return typeof Ee == "function" && (Ee = Ee(Oe)), Ee._getDecoder("der").tree;
  };
  function Ie(Te, Ee) {
    var Oe = Te.readUInt8(Ee);
    if (Te.isError(Oe))
      return Oe;
    var Le = _e.tagClass[Oe >> 6], ke = (Oe & 32) === 0;
    if ((Oe & 31) === 31) {
      var Fe = Oe;
      for (Oe = 0; (Fe & 128) === 128; ) {
        if (Fe = Te.readUInt8(Ee), Te.isError(Fe))
          return Fe;
        Oe <<= 7, Oe |= Fe & 127;
      }
    } else
      Oe &= 31;
    var Ge = _e.tag[Oe];
    return {
      cls: Le,
      primitive: ke,
      tag: Oe,
      tagStr: Ge
    };
  }
  function qe(Te, Ee, Oe) {
    var Le = Te.readUInt8(Oe);
    if (Te.isError(Le))
      return Le;
    if (!Ee && Le === 128)
      return null;
    if (!(Le & 128))
      return Le;
    var ke = Le & 127;
    if (ke > 4)
      return Te.error("length octect is too long");
    Le = 0;
    for (var Fe = 0; Fe < ke; Fe++) {
      Le <<= 8;
      var Ge = Te.readUInt8(Oe);
      if (Te.isError(Ge))
        return Ge;
      Le |= Ge;
    }
    return Le;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1) return pem$1;
  hasRequiredPem$1 = 1;
  var I = inherits_browserExports, A = require$$0$3.Buffer, G = requireDer$1();
  function J(_e) {
    G.call(this, _e), this.enc = "pem";
  }
  return I(J, G), pem$1 = J, J.prototype.decode = function(H, De) {
    for (var Ie = H.toString().split(/[\r\n]+/g), qe = De.label.toUpperCase(), Te = /^-----(BEGIN|END) ([^-]+)-----$/, Ee = -1, Oe = -1, Le = 0; Le < Ie.length; Le++) {
      var ke = Ie[Le].match(Te);
      if (ke !== null && ke[2] === qe)
        if (Ee === -1) {
          if (ke[1] !== "BEGIN")
            break;
          Ee = Le;
        } else {
          if (ke[1] !== "END")
            break;
          Oe = Le;
          break;
        }
    }
    if (Ee === -1 || Oe === -1)
      throw new Error("PEM section not found for: " + qe);
    var Fe = Ie.slice(Ee + 1, Oe).join("");
    Fe.replace(/[^a-z0-9\+\/=]+/gi, "");
    var Ge = new A(Fe, "base64");
    return G.prototype.decode.call(this, Ge, De);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(I) {
    var A = I;
    A.der = requireDer$1(), A.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer) return der_1;
  hasRequiredDer = 1;
  var I = inherits_browserExports, A = require$$0$3.Buffer, G = requireAsn1$1(), J = G.base, _e = G.constants.der;
  function H(Te) {
    this.enc = "der", this.name = Te.name, this.entity = Te, this.tree = new De(), this.tree._init(Te.body);
  }
  der_1 = H, H.prototype.encode = function(Ee, Oe) {
    return this.tree._encode(Ee, Oe).join();
  };
  function De(Te) {
    J.Node.call(this, "der", Te);
  }
  I(De, J.Node), De.prototype._encodeComposite = function(Ee, Oe, Le, ke) {
    var Fe = qe(Ee, Oe, Le, this.reporter);
    if (ke.length < 128) {
      var Ve = new A(2);
      return Ve[0] = Fe, Ve[1] = ke.length, this._createEncoderBuffer([Ve, ke]);
    }
    for (var Ge = 1, et = ke.length; et >= 256; et >>= 8)
      Ge++;
    var Ve = new A(2 + Ge);
    Ve[0] = Fe, Ve[1] = 128 | Ge;
    for (var et = 1 + Ge, Je = ke.length; Je > 0; et--, Je >>= 8)
      Ve[et] = Je & 255;
    return this._createEncoderBuffer([Ve, ke]);
  }, De.prototype._encodeStr = function(Ee, Oe) {
    if (Oe === "bitstr")
      return this._createEncoderBuffer([Ee.unused | 0, Ee.data]);
    if (Oe === "bmpstr") {
      for (var Le = new A(Ee.length * 2), ke = 0; ke < Ee.length; ke++)
        Le.writeUInt16BE(Ee.charCodeAt(ke), ke * 2);
      return this._createEncoderBuffer(Le);
    } else return Oe === "numstr" ? this._isNumstr(Ee) ? this._createEncoderBuffer(Ee) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : Oe === "printstr" ? this._isPrintstr(Ee) ? this._createEncoderBuffer(Ee) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(Oe) ? this._createEncoderBuffer(Ee) : Oe === "objDesc" ? this._createEncoderBuffer(Ee) : this.reporter.error("Encoding of string type: " + Oe + " unsupported");
  }, De.prototype._encodeObjid = function(Ee, Oe, Le) {
    if (typeof Ee == "string") {
      if (!Oe)
        return this.reporter.error("string objid given, but no values map found");
      if (!Oe.hasOwnProperty(Ee))
        return this.reporter.error("objid not found in values map");
      Ee = Oe[Ee].split(/[\s\.]+/g);
      for (var ke = 0; ke < Ee.length; ke++)
        Ee[ke] |= 0;
    } else if (Array.isArray(Ee)) {
      Ee = Ee.slice();
      for (var ke = 0; ke < Ee.length; ke++)
        Ee[ke] |= 0;
    }
    if (!Array.isArray(Ee))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(Ee));
    if (!Le) {
      if (Ee[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      Ee.splice(0, 2, Ee[0] * 40 + Ee[1]);
    }
    for (var Fe = 0, ke = 0; ke < Ee.length; ke++) {
      var Ge = Ee[ke];
      for (Fe++; Ge >= 128; Ge >>= 7)
        Fe++;
    }
    for (var et = new A(Fe), Ve = et.length - 1, ke = Ee.length - 1; ke >= 0; ke--) {
      var Ge = Ee[ke];
      for (et[Ve--] = Ge & 127; (Ge >>= 7) > 0; )
        et[Ve--] = 128 | Ge & 127;
    }
    return this._createEncoderBuffer(et);
  };
  function Ie(Te) {
    return Te < 10 ? "0" + Te : Te;
  }
  De.prototype._encodeTime = function(Ee, Oe) {
    var Le, ke = new Date(Ee);
    return Oe === "gentime" ? Le = [
      Ie(ke.getFullYear()),
      Ie(ke.getUTCMonth() + 1),
      Ie(ke.getUTCDate()),
      Ie(ke.getUTCHours()),
      Ie(ke.getUTCMinutes()),
      Ie(ke.getUTCSeconds()),
      "Z"
    ].join("") : Oe === "utctime" ? Le = [
      Ie(ke.getFullYear() % 100),
      Ie(ke.getUTCMonth() + 1),
      Ie(ke.getUTCDate()),
      Ie(ke.getUTCHours()),
      Ie(ke.getUTCMinutes()),
      Ie(ke.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + Oe + " time is not supported yet"), this._encodeStr(Le, "octstr");
  }, De.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, De.prototype._encodeInt = function(Ee, Oe) {
    if (typeof Ee == "string") {
      if (!Oe)
        return this.reporter.error("String int or enum given, but no values map");
      if (!Oe.hasOwnProperty(Ee))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(Ee));
      Ee = Oe[Ee];
    }
    if (typeof Ee != "number" && !A.isBuffer(Ee)) {
      var Le = Ee.toArray();
      !Ee.sign && Le[0] & 128 && Le.unshift(0), Ee = new A(Le);
    }
    if (A.isBuffer(Ee)) {
      var ke = Ee.length;
      Ee.length === 0 && ke++;
      var Ge = new A(ke);
      return Ee.copy(Ge), Ee.length === 0 && (Ge[0] = 0), this._createEncoderBuffer(Ge);
    }
    if (Ee < 128)
      return this._createEncoderBuffer(Ee);
    if (Ee < 256)
      return this._createEncoderBuffer([0, Ee]);
    for (var ke = 1, Fe = Ee; Fe >= 256; Fe >>= 8)
      ke++;
    for (var Ge = new Array(ke), Fe = Ge.length - 1; Fe >= 0; Fe--)
      Ge[Fe] = Ee & 255, Ee >>= 8;
    return Ge[0] & 128 && Ge.unshift(0), this._createEncoderBuffer(new A(Ge));
  }, De.prototype._encodeBool = function(Ee) {
    return this._createEncoderBuffer(Ee ? 255 : 0);
  }, De.prototype._use = function(Ee, Oe) {
    return typeof Ee == "function" && (Ee = Ee(Oe)), Ee._getEncoder("der").tree;
  }, De.prototype._skipDefault = function(Ee, Oe, Le) {
    var ke = this._baseState, Fe;
    if (ke.default === null)
      return !1;
    var Ge = Ee.join();
    if (ke.defaultBuffer === void 0 && (ke.defaultBuffer = this._encodeValue(ke.default, Oe, Le).join()), Ge.length !== ke.defaultBuffer.length)
      return !1;
    for (Fe = 0; Fe < Ge.length; Fe++)
      if (Ge[Fe] !== ke.defaultBuffer[Fe])
        return !1;
    return !0;
  };
  function qe(Te, Ee, Oe, Le) {
    var ke;
    if (Te === "seqof" ? Te = "seq" : Te === "setof" && (Te = "set"), _e.tagByName.hasOwnProperty(Te))
      ke = _e.tagByName[Te];
    else if (typeof Te == "number" && (Te | 0) === Te)
      ke = Te;
    else
      return Le.error("Unknown tag: " + Te);
    return ke >= 31 ? Le.error("Multi-octet tag encoding unsupported") : (Ee || (ke |= 32), ke |= _e.tagClassByName[Oe || "universal"] << 6, ke);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem) return pem;
  hasRequiredPem = 1;
  var I = inherits_browserExports, A = requireDer();
  function G(J) {
    A.call(this, J), this.enc = "pem";
  }
  return I(G, A), pem = G, G.prototype.encode = function(_e, H) {
    for (var De = A.prototype.encode.call(this, _e), Ie = De.toString("base64"), qe = ["-----BEGIN " + H.label + "-----"], Te = 0; Te < Ie.length; Te += 64)
      qe.push(Ie.slice(Te, Te + 64));
    return qe.push("-----END " + H.label + "-----"), qe.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(I) {
    var A = I;
    A.der = requireDer(), A.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(I) {
    var A = I;
    A.bignum = requireBn$2(), A.define = requireApi().define, A.base = requireBase(), A.constants = requireConstants(), A.decoders = requireDecoders(), A.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate) return certificate;
  hasRequiredCertificate = 1;
  var I = requireAsn1$1(), A = I.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), G = I.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), J = I.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), _e = I.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(J),
      this.key("subjectPublicKey").bitstr()
    );
  }), H = I.define("RelativeDistinguishedName", function() {
    this.setof(G);
  }), De = I.define("RDNSequence", function() {
    this.seqof(H);
  }), Ie = I.define("Name", function() {
    this.choice({
      rdnSequence: this.use(De)
    });
  }), qe = I.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(A),
      this.key("notAfter").use(A)
    );
  }), Te = I.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), Ee = I.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(J),
      this.key("issuer").use(Ie),
      this.key("validity").use(qe),
      this.key("subject").use(Ie),
      this.key("subjectPublicKeyInfo").use(_e),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(Te).optional()
    );
  }), Oe = I.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(Ee),
      this.key("signatureAlgorithm").use(J),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = Oe, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1) return asn1$1;
  hasRequiredAsn1 = 1;
  var I = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var A = I.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = A;
  var G = I.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = G;
  var J = I.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), _e = I.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(J),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = _e;
  var H = I.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(J),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = H;
  var De = I.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = De;
  var Ie = I.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = Ie, asn1$1.DSAparam = I.define("DSAparam", function() {
    this.int();
  });
  var qe = I.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), Te = I.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(qe),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return asn1$1.ECPrivateKey = Te, asn1$1.signature = I.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc) return fixProc;
  hasRequiredFixProc = 1;
  var I = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, A = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, G = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, J = requireEvp_bytestokey(), _e = requireBrowser$6(), H = safeBufferExports.Buffer;
  return fixProc = function(De, Ie) {
    var qe = De.toString(), Te = qe.match(I), Ee;
    if (Te) {
      var Le = "aes" + Te[1], ke = H.from(Te[2], "hex"), Fe = H.from(Te[3].replace(/[\r\n]/g, ""), "base64"), Ge = J(Ie, ke.slice(0, 8), parseInt(Te[1], 10)).key, et = [], Ve = _e.createDecipheriv(Le, Ge, ke);
      et.push(Ve.update(Fe)), et.push(Ve.final()), Ee = H.concat(et);
    } else {
      var Oe = qe.match(G);
      Ee = H.from(Oe[2].replace(/[\r\n]/g, ""), "base64");
    }
    var Je = qe.match(A)[1];
    return {
      tag: Je,
      data: Ee
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1) return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var I = requireAsn1(), A = require$$1, G = requireFixProc(), J = requireBrowser$6(), _e = requireBrowser$7(), H = safeBufferExports.Buffer;
  function De(qe, Te) {
    var Ee = qe.algorithm.decrypt.kde.kdeparams.salt, Oe = parseInt(qe.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), Le = A[qe.algorithm.decrypt.cipher.algo.join(".")], ke = qe.algorithm.decrypt.cipher.iv, Fe = qe.subjectPrivateKey, Ge = parseInt(Le.split("-")[1], 10) / 8, et = _e.pbkdf2Sync(Te, Ee, Oe, Ge, "sha1"), Ve = J.createDecipheriv(Le, et, ke), Je = [];
    return Je.push(Ve.update(Fe)), Je.push(Ve.final()), H.concat(Je);
  }
  function Ie(qe) {
    var Te;
    typeof qe == "object" && !H.isBuffer(qe) && (Te = qe.passphrase, qe = qe.key), typeof qe == "string" && (qe = H.from(qe));
    var Ee = G(qe, Te), Oe = Ee.tag, Le = Ee.data, ke, Fe;
    switch (Oe) {
      case "CERTIFICATE":
        Fe = I.certificate.decode(Le, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (Fe || (Fe = I.PublicKey.decode(Le, "der")), ke = Fe.algorithm.algorithm.join("."), ke) {
          case "1.2.840.113549.1.1.1":
            return I.RSAPublicKey.decode(Fe.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return Fe.subjectPrivateKey = Fe.subjectPublicKey, {
              type: "ec",
              data: Fe
            };
          case "1.2.840.10040.4.1":
            return Fe.algorithm.params.pub_key = I.DSAparam.decode(Fe.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: Fe.algorithm.params
            };
          default:
            throw new Error("unknown key id " + ke);
        }
      case "ENCRYPTED PRIVATE KEY":
        Le = I.EncryptedPrivateKey.decode(Le, "der"), Le = De(Le, Te);
      case "PRIVATE KEY":
        switch (Fe = I.PrivateKey.decode(Le, "der"), ke = Fe.algorithm.algorithm.join("."), ke) {
          case "1.2.840.113549.1.1.1":
            return I.RSAPrivateKey.decode(Fe.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: Fe.algorithm.curve,
              privateKey: I.ECPrivateKey.decode(Fe.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return Fe.algorithm.params.priv_key = I.DSAparam.decode(Fe.subjectPrivateKey, "der"), {
              type: "dsa",
              params: Fe.algorithm.params
            };
          default:
            throw new Error("unknown key id " + ke);
        }
      case "RSA PUBLIC KEY":
        return I.RSAPublicKey.decode(Le, "der");
      case "RSA PRIVATE KEY":
        return I.RSAPrivateKey.decode(Le, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: I.DSAPrivateKey.decode(Le, "der")
        };
      case "EC PRIVATE KEY":
        return Le = I.ECPrivateKey.decode(Le, "der"), {
          curve: Le.parameters.value,
          privateKey: Le.privateKey
        };
      default:
        throw new Error("unknown key type " + Oe);
    }
  }
  return Ie.signature = I.signature, parseAsn1 = Ie, parseAsn1;
}
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign) return sign.exports;
  hasRequiredSign = 1;
  var I = safeBufferExports.Buffer, A = requireBrowser$8(), G = requireBrowserifyRsa(), J = requireElliptic().ec, _e = bnExports$1, H = requireParseAsn1(), De = require$$4, Ie = 1;
  function qe(Ve, Je, ut, rt, lt) {
    var vt = H(Je);
    if (vt.curve) {
      if (rt !== "ecdsa" && rt !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return Te(Ve, vt);
    } else if (vt.type === "dsa") {
      if (rt !== "dsa")
        throw new Error("wrong private key type");
      return Ee(Ve, vt, ut);
    }
    if (rt !== "rsa" && rt !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (Je.padding !== void 0 && Je.padding !== Ie)
      throw new Error("illegal or unsupported padding mode");
    Ve = I.concat([lt, Ve]);
    for (var Ye = vt.modulus.byteLength(), pt = [0, 1]; Ve.length + pt.length + 1 < Ye; )
      pt.push(255);
    pt.push(0);
    for (var bt = -1; ++bt < Ve.length; )
      pt.push(Ve[bt]);
    var Yt = G(pt, vt);
    return Yt;
  }
  function Te(Ve, Je) {
    var ut = De[Je.curve.join(".")];
    if (!ut)
      throw new Error("unknown curve " + Je.curve.join("."));
    var rt = new J(ut), lt = rt.keyFromPrivate(Je.privateKey), vt = lt.sign(Ve);
    return I.from(vt.toDER());
  }
  function Ee(Ve, Je, ut) {
    for (var rt = Je.params.priv_key, lt = Je.params.p, vt = Je.params.q, Ye = Je.params.g, pt = new _e(0), bt, Yt = ke(Ve, vt).mod(vt), Se = !1, t = Le(rt, vt, Ve, ut); Se === !1; )
      bt = Ge(vt, t, ut), pt = et(Ye, bt, lt, vt), Se = bt.invm(vt).imul(Yt.add(rt.mul(pt))).mod(vt), Se.cmpn(0) === 0 && (Se = !1, pt = new _e(0));
    return Oe(pt, Se);
  }
  function Oe(Ve, Je) {
    Ve = Ve.toArray(), Je = Je.toArray(), Ve[0] & 128 && (Ve = [0].concat(Ve)), Je[0] & 128 && (Je = [0].concat(Je));
    var ut = Ve.length + Je.length + 4, rt = [
      48,
      ut,
      2,
      Ve.length
    ];
    return rt = rt.concat(Ve, [2, Je.length], Je), I.from(rt);
  }
  function Le(Ve, Je, ut, rt) {
    if (Ve = I.from(Ve.toArray()), Ve.length < Je.byteLength()) {
      var lt = I.alloc(Je.byteLength() - Ve.length);
      Ve = I.concat([lt, Ve]);
    }
    var vt = ut.length, Ye = Fe(ut, Je), pt = I.alloc(vt);
    pt.fill(1);
    var bt = I.alloc(vt);
    return bt = A(rt, bt).update(pt).update(I.from([0])).update(Ve).update(Ye).digest(), pt = A(rt, bt).update(pt).digest(), bt = A(rt, bt).update(pt).update(I.from([1])).update(Ve).update(Ye).digest(), pt = A(rt, bt).update(pt).digest(), { k: bt, v: pt };
  }
  function ke(Ve, Je) {
    var ut = new _e(Ve), rt = (Ve.length << 3) - Je.bitLength();
    return rt > 0 && ut.ishrn(rt), ut;
  }
  function Fe(Ve, Je) {
    Ve = ke(Ve, Je), Ve = Ve.mod(Je);
    var ut = I.from(Ve.toArray());
    if (ut.length < Je.byteLength()) {
      var rt = I.alloc(Je.byteLength() - ut.length);
      ut = I.concat([rt, ut]);
    }
    return ut;
  }
  function Ge(Ve, Je, ut) {
    var rt, lt;
    do {
      for (rt = I.alloc(0); rt.length * 8 < Ve.bitLength(); )
        Je.v = A(ut, Je.k).update(Je.v).digest(), rt = I.concat([rt, Je.v]);
      lt = ke(rt, Ve), Je.k = A(ut, Je.k).update(Je.v).update(I.from([0])).digest(), Je.v = A(ut, Je.k).update(Je.v).digest();
    } while (lt.cmp(Ve) !== -1);
    return lt;
  }
  function et(Ve, Je, ut, rt) {
    return Ve.toRed(_e.mont(ut)).redPow(Je).fromRed().mod(rt);
  }
  return sign.exports = qe, sign.exports.getKey = Le, sign.exports.makeKey = Ge, sign.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify) return verify_1;
  hasRequiredVerify = 1;
  var I = safeBufferExports.Buffer, A = bnExports$1, G = requireElliptic().ec, J = requireParseAsn1(), _e = require$$4;
  function H(Te, Ee, Oe, Le, ke) {
    var Fe = J(Oe);
    if (Fe.type === "ec") {
      if (Le !== "ecdsa" && Le !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return De(Te, Ee, Fe);
    } else if (Fe.type === "dsa") {
      if (Le !== "dsa")
        throw new Error("wrong public key type");
      return Ie(Te, Ee, Fe);
    }
    if (Le !== "rsa" && Le !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    Ee = I.concat([ke, Ee]);
    for (var Ge = Fe.modulus.byteLength(), et = [1], Ve = 0; Ee.length + et.length + 2 < Ge; )
      et.push(255), Ve += 1;
    et.push(0);
    for (var Je = -1; ++Je < Ee.length; )
      et.push(Ee[Je]);
    et = I.from(et);
    var ut = A.mont(Fe.modulus);
    Te = new A(Te).toRed(ut), Te = Te.redPow(new A(Fe.publicExponent)), Te = I.from(Te.fromRed().toArray());
    var rt = Ve < 8 ? 1 : 0;
    for (Ge = Math.min(Te.length, et.length), Te.length !== et.length && (rt = 1), Je = -1; ++Je < Ge; )
      rt |= Te[Je] ^ et[Je];
    return rt === 0;
  }
  function De(Te, Ee, Oe) {
    var Le = _e[Oe.data.algorithm.curve.join(".")];
    if (!Le)
      throw new Error("unknown curve " + Oe.data.algorithm.curve.join("."));
    var ke = new G(Le), Fe = Oe.data.subjectPrivateKey.data;
    return ke.verify(Ee, Te, Fe);
  }
  function Ie(Te, Ee, Oe) {
    var Le = Oe.data.p, ke = Oe.data.q, Fe = Oe.data.g, Ge = Oe.data.pub_key, et = J.signature.decode(Te, "der"), Ve = et.s, Je = et.r;
    qe(Ve, ke), qe(Je, ke);
    var ut = A.mont(Le), rt = Ve.invm(ke), lt = Fe.toRed(ut).redPow(new A(Ee).mul(rt).mod(ke)).fromRed().mul(Ge.toRed(ut).redPow(Je.mul(rt).mod(ke)).fromRed()).mod(Le).mod(ke);
    return lt.cmp(Je) === 0;
  }
  function qe(Te, Ee) {
    if (Te.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (Te.cmp(Ee) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = H, verify_1;
}
var browser$4, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3) return browser$4;
  hasRequiredBrowser$3 = 1;
  var I = safeBufferExports.Buffer, A = requireBrowser$9(), G = requireReadableBrowser(), J = inherits_browserExports, _e = requireSign(), H = requireVerify(), De = require$$6;
  Object.keys(De).forEach(function(Oe) {
    De[Oe].id = I.from(De[Oe].id, "hex"), De[Oe.toLowerCase()] = De[Oe];
  });
  function Ie(Oe) {
    G.Writable.call(this);
    var Le = De[Oe];
    if (!Le)
      throw new Error("Unknown message digest");
    this._hashType = Le.hash, this._hash = A(Le.hash), this._tag = Le.id, this._signType = Le.sign;
  }
  J(Ie, G.Writable), Ie.prototype._write = function(Le, ke, Fe) {
    this._hash.update(Le), Fe();
  }, Ie.prototype.update = function(Le, ke) {
    return this._hash.update(typeof Le == "string" ? I.from(Le, ke) : Le), this;
  }, Ie.prototype.sign = function(Le, ke) {
    this.end();
    var Fe = this._hash.digest(), Ge = _e(Fe, Le, this._hashType, this._signType, this._tag);
    return ke ? Ge.toString(ke) : Ge;
  };
  function qe(Oe) {
    G.Writable.call(this);
    var Le = De[Oe];
    if (!Le)
      throw new Error("Unknown message digest");
    this._hash = A(Le.hash), this._tag = Le.id, this._signType = Le.sign;
  }
  J(qe, G.Writable), qe.prototype._write = function(Le, ke, Fe) {
    this._hash.update(Le), Fe();
  }, qe.prototype.update = function(Le, ke) {
    return this._hash.update(typeof Le == "string" ? I.from(Le, ke) : Le), this;
  }, qe.prototype.verify = function(Le, ke, Fe) {
    var Ge = typeof ke == "string" ? I.from(ke, Fe) : ke;
    this.end();
    var et = this._hash.digest();
    return H(Ge, et, Le, this._signType, this._tag);
  };
  function Te(Oe) {
    return new Ie(Oe);
  }
  function Ee(Oe) {
    return new qe(Oe);
  }
  return browser$4 = {
    Sign: Te,
    Verify: Ee,
    createSign: Te,
    createVerify: Ee
  }, browser$4;
}
var bn$2 = { exports: {} };
bn$2.exports;
var hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(I) {
    (function(A, G) {
      function J(Se, t) {
        if (!Se) throw new Error(t || "Assertion failed");
      }
      function _e(Se, t) {
        Se.super_ = t;
        var h = function() {
        };
        h.prototype = t.prototype, Se.prototype = new h(), Se.prototype.constructor = Se;
      }
      function H(Se, t, h) {
        if (H.isBN(Se))
          return Se;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Se !== null && ((t === "le" || t === "be") && (h = t, t = 10), this._init(Se || 0, t || 10, h || "be"));
      }
      typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
      var De;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = require$$0$3.Buffer;
      } catch {
      }
      H.isBN = function(t) {
        return t instanceof H ? !0 : t !== null && typeof t == "object" && t.constructor.wordSize === H.wordSize && Array.isArray(t.words);
      }, H.max = function(t, h) {
        return t.cmp(h) > 0 ? t : h;
      }, H.min = function(t, h) {
        return t.cmp(h) < 0 ? t : h;
      }, H.prototype._init = function(t, h, B) {
        if (typeof t == "number")
          return this._initNumber(t, h, B);
        if (typeof t == "object")
          return this._initArray(t, h, B);
        h === "hex" && (h = 16), J(h === (h | 0) && h >= 2 && h <= 36), t = t.toString().replace(/\s+/g, "");
        var Z = 0;
        t[0] === "-" && (Z++, this.negative = 1), Z < t.length && (h === 16 ? this._parseHex(t, Z, B) : (this._parseBase(t, h, Z), B === "le" && this._initArray(this.toArray(), h, B)));
      }, H.prototype._initNumber = function(t, h, B) {
        t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [t & 67108863], this.length = 1) : t < 4503599627370496 ? (this.words = [
          t & 67108863,
          t / 67108864 & 67108863
        ], this.length = 2) : (J(t < 9007199254740992), this.words = [
          t & 67108863,
          t / 67108864 & 67108863,
          1
        ], this.length = 3), B === "le" && this._initArray(this.toArray(), h, B);
      }, H.prototype._initArray = function(t, h, B) {
        if (J(typeof t.length == "number"), t.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve, ge, xe = 0;
        if (B === "be")
          for (Z = t.length - 1, ve = 0; Z >= 0; Z -= 3)
            ge = t[Z] | t[Z - 1] << 8 | t[Z - 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        else if (B === "le")
          for (Z = 0, ve = 0; Z < t.length; Z += 3)
            ge = t[Z] | t[Z + 1] << 8 | t[Z + 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        return this.strip();
      };
      function Ie(Se, t) {
        var h = Se.charCodeAt(t);
        return h >= 65 && h <= 70 ? h - 55 : h >= 97 && h <= 102 ? h - 87 : h - 48 & 15;
      }
      function qe(Se, t, h) {
        var B = Ie(Se, h);
        return h - 1 >= t && (B |= Ie(Se, h - 1) << 4), B;
      }
      H.prototype._parseHex = function(t, h, B) {
        this.length = Math.ceil((t.length - h) / 6), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve = 0, ge = 0, xe;
        if (B === "be")
          for (Z = t.length - 1; Z >= h; Z -= 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        else {
          var X = t.length - h;
          for (Z = X % 2 === 0 ? h + 1 : h; Z < t.length; Z += 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        }
        this.strip();
      };
      function Te(Se, t, h, B) {
        for (var Z = 0, ve = Math.min(Se.length, h), ge = t; ge < ve; ge++) {
          var xe = Se.charCodeAt(ge) - 48;
          Z *= B, xe >= 49 ? Z += xe - 49 + 10 : xe >= 17 ? Z += xe - 17 + 10 : Z += xe;
        }
        return Z;
      }
      H.prototype._parseBase = function(t, h, B) {
        this.words = [0], this.length = 1;
        for (var Z = 0, ve = 1; ve <= 67108863; ve *= h)
          Z++;
        Z--, ve = ve / h | 0;
        for (var ge = t.length - B, xe = ge % Z, X = Math.min(ge, ge - xe) + B, a = 0, Y = B; Y < X; Y += Z)
          a = Te(t, Y, Y + Z, h), this.imuln(ve), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (xe !== 0) {
          var Ne = 1;
          for (a = Te(t, Y, t.length, h), Y = 0; Y < xe; Y++)
            Ne *= h;
          this.imuln(Ne), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, H.prototype.copy = function(t) {
        t.words = new Array(this.length);
        for (var h = 0; h < this.length; h++)
          t.words[h] = this.words[h];
        t.length = this.length, t.negative = this.negative, t.red = this.red;
      }, H.prototype.clone = function() {
        var t = new H(null);
        return this.copy(t), t;
      }, H.prototype._expand = function(t) {
        for (; this.length < t; )
          this.words[this.length++] = 0;
        return this;
      }, H.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, H.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, H.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var Ee = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Oe = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Le = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      H.prototype.toString = function(t, h) {
        t = t || 10, h = h | 0 || 1;
        var B;
        if (t === 16 || t === "hex") {
          B = "";
          for (var Z = 0, ve = 0, ge = 0; ge < this.length; ge++) {
            var xe = this.words[ge], X = ((xe << Z | ve) & 16777215).toString(16);
            ve = xe >>> 24 - Z & 16777215, ve !== 0 || ge !== this.length - 1 ? B = Ee[6 - X.length] + X + B : B = X + B, Z += 2, Z >= 26 && (Z -= 26, ge--);
          }
          for (ve !== 0 && (B = ve.toString(16) + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        if (t === (t | 0) && t >= 2 && t <= 36) {
          var a = Oe[t], Y = Le[t];
          B = "";
          var Ne = this.clone();
          for (Ne.negative = 0; !Ne.isZero(); ) {
            var Ke = Ne.modn(Y).toString(t);
            Ne = Ne.idivn(Y), Ne.isZero() ? B = Ke + B : B = Ee[a - Ke.length] + Ke + B;
          }
          for (this.isZero() && (B = "0" + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        J(!1, "Base should be between 2 and 36");
      }, H.prototype.toNumber = function() {
        var t = this.words[0];
        return this.length === 2 ? t += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? t += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -t : t;
      }, H.prototype.toJSON = function() {
        return this.toString(16);
      }, H.prototype.toBuffer = function(t, h) {
        return J(typeof De < "u"), this.toArrayLike(De, t, h);
      }, H.prototype.toArray = function(t, h) {
        return this.toArrayLike(Array, t, h);
      }, H.prototype.toArrayLike = function(t, h, B) {
        var Z = this.byteLength(), ve = B || Math.max(1, Z);
        J(Z <= ve, "byte array longer than desired length"), J(ve > 0, "Requested array length <= 0"), this.strip();
        var ge = h === "le", xe = new t(ve), X, a, Y = this.clone();
        if (ge) {
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[a] = X;
          for (; a < ve; a++)
            xe[a] = 0;
        } else {
          for (a = 0; a < ve - Z; a++)
            xe[a] = 0;
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[ve - a - 1] = X;
        }
        return xe;
      }, Math.clz32 ? H.prototype._countBits = function(t) {
        return 32 - Math.clz32(t);
      } : H.prototype._countBits = function(t) {
        var h = t, B = 0;
        return h >= 4096 && (B += 13, h >>>= 13), h >= 64 && (B += 7, h >>>= 7), h >= 8 && (B += 4, h >>>= 4), h >= 2 && (B += 2, h >>>= 2), B + h;
      }, H.prototype._zeroBits = function(t) {
        if (t === 0) return 26;
        var h = t, B = 0;
        return h & 8191 || (B += 13, h >>>= 13), h & 127 || (B += 7, h >>>= 7), h & 15 || (B += 4, h >>>= 4), h & 3 || (B += 2, h >>>= 2), h & 1 || B++, B;
      }, H.prototype.bitLength = function() {
        var t = this.words[this.length - 1], h = this._countBits(t);
        return (this.length - 1) * 26 + h;
      };
      function ke(Se) {
        for (var t = new Array(Se.bitLength()), h = 0; h < t.length; h++) {
          var B = h / 26 | 0, Z = h % 26;
          t[h] = (Se.words[B] & 1 << Z) >>> Z;
        }
        return t;
      }
      H.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var t = 0, h = 0; h < this.length; h++) {
          var B = this._zeroBits(this.words[h]);
          if (t += B, B !== 26) break;
        }
        return t;
      }, H.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, H.prototype.toTwos = function(t) {
        return this.negative !== 0 ? this.abs().inotn(t).iaddn(1) : this.clone();
      }, H.prototype.fromTwos = function(t) {
        return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
      }, H.prototype.isNeg = function() {
        return this.negative !== 0;
      }, H.prototype.neg = function() {
        return this.clone().ineg();
      }, H.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, H.prototype.iuor = function(t) {
        for (; this.length < t.length; )
          this.words[this.length++] = 0;
        for (var h = 0; h < t.length; h++)
          this.words[h] = this.words[h] | t.words[h];
        return this.strip();
      }, H.prototype.ior = function(t) {
        return J((this.negative | t.negative) === 0), this.iuor(t);
      }, H.prototype.or = function(t) {
        return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
      }, H.prototype.uor = function(t) {
        return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
      }, H.prototype.iuand = function(t) {
        var h;
        this.length > t.length ? h = t : h = this;
        for (var B = 0; B < h.length; B++)
          this.words[B] = this.words[B] & t.words[B];
        return this.length = h.length, this.strip();
      }, H.prototype.iand = function(t) {
        return J((this.negative | t.negative) === 0), this.iuand(t);
      }, H.prototype.and = function(t) {
        return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
      }, H.prototype.uand = function(t) {
        return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
      }, H.prototype.iuxor = function(t) {
        var h, B;
        this.length > t.length ? (h = this, B = t) : (h = t, B = this);
        for (var Z = 0; Z < B.length; Z++)
          this.words[Z] = h.words[Z] ^ B.words[Z];
        if (this !== h)
          for (; Z < h.length; Z++)
            this.words[Z] = h.words[Z];
        return this.length = h.length, this.strip();
      }, H.prototype.ixor = function(t) {
        return J((this.negative | t.negative) === 0), this.iuxor(t);
      }, H.prototype.xor = function(t) {
        return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
      }, H.prototype.uxor = function(t) {
        return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
      }, H.prototype.inotn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = Math.ceil(t / 26) | 0, B = t % 26;
        this._expand(h), B > 0 && h--;
        for (var Z = 0; Z < h; Z++)
          this.words[Z] = ~this.words[Z] & 67108863;
        return B > 0 && (this.words[Z] = ~this.words[Z] & 67108863 >> 26 - B), this.strip();
      }, H.prototype.notn = function(t) {
        return this.clone().inotn(t);
      }, H.prototype.setn = function(t, h) {
        J(typeof t == "number" && t >= 0);
        var B = t / 26 | 0, Z = t % 26;
        return this._expand(B + 1), h ? this.words[B] = this.words[B] | 1 << Z : this.words[B] = this.words[B] & ~(1 << Z), this.strip();
      }, H.prototype.iadd = function(t) {
        var h;
        if (this.negative !== 0 && t.negative === 0)
          return this.negative = 0, h = this.isub(t), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && t.negative !== 0)
          return t.negative = 0, h = this.isub(t), t.negative = 1, h._normSign();
        var B, Z;
        this.length > t.length ? (B = this, Z = t) : (B = t, Z = this);
        for (var ve = 0, ge = 0; ge < Z.length; ge++)
          h = (B.words[ge] | 0) + (Z.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        for (; ve !== 0 && ge < B.length; ge++)
          h = (B.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        if (this.length = B.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (B !== this)
          for (; ge < B.length; ge++)
            this.words[ge] = B.words[ge];
        return this;
      }, H.prototype.add = function(t) {
        var h;
        return t.negative !== 0 && this.negative === 0 ? (t.negative = 0, h = this.sub(t), t.negative ^= 1, h) : t.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = t.sub(this), this.negative = 1, h) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
      }, H.prototype.isub = function(t) {
        if (t.negative !== 0) {
          t.negative = 0;
          var h = this.iadd(t);
          return t.negative = 1, h._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
        var B = this.cmp(t);
        if (B === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Z, ve;
        B > 0 ? (Z = this, ve = t) : (Z = t, ve = this);
        for (var ge = 0, xe = 0; xe < ve.length; xe++)
          h = (Z.words[xe] | 0) - (ve.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        for (; ge !== 0 && xe < Z.length; xe++)
          h = (Z.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        if (ge === 0 && xe < Z.length && Z !== this)
          for (; xe < Z.length; xe++)
            this.words[xe] = Z.words[xe];
        return this.length = Math.max(this.length, xe), Z !== this && (this.negative = 1), this.strip();
      }, H.prototype.sub = function(t) {
        return this.clone().isub(t);
      };
      function Fe(Se, t, h) {
        h.negative = t.negative ^ Se.negative;
        var B = Se.length + t.length | 0;
        h.length = B, B = B - 1 | 0;
        var Z = Se.words[0] | 0, ve = t.words[0] | 0, ge = Z * ve, xe = ge & 67108863, X = ge / 67108864 | 0;
        h.words[0] = xe;
        for (var a = 1; a < B; a++) {
          for (var Y = X >>> 26, Ne = X & 67108863, Ke = Math.min(a, t.length - 1), tt = Math.max(0, a - Se.length + 1); tt <= Ke; tt++) {
            var We = a - tt | 0;
            Z = Se.words[We] | 0, ve = t.words[tt] | 0, ge = Z * ve + Ne, Y += ge / 67108864 | 0, Ne = ge & 67108863;
          }
          h.words[a] = Ne | 0, X = Y | 0;
        }
        return X !== 0 ? h.words[a] = X | 0 : h.length--, h.strip();
      }
      var Ge = function(t, h, B) {
        var Z = t.words, ve = h.words, ge = B.words, xe = 0, X, a, Y, Ne = Z[0] | 0, Ke = Ne & 8191, tt = Ne >>> 13, We = Z[1] | 0, ot = We & 8191, He = We >>> 13, Qe = Z[2] | 0, nt = Qe & 8191, je = Qe >>> 13, it = Z[3] | 0, st = it & 8191, gt = it >>> 13, It = Z[4] | 0, At = It & 8191, Et = It >>> 13, ei = Z[5] | 0, Xt = ei & 8191, _t = ei >>> 13, ni = Z[6] | 0, Ct = ni & 8191, Wt = ni >>> 13, ii = Z[7] | 0, Pt = ii & 8191, Rt = ii >>> 13, ai = Z[8] | 0, Nt = ai & 8191, qt = ai >>> 13, oi = Z[9] | 0, ct = oi & 8191, Ze = oi >>> 13, at = ve[0] | 0, dt = at & 8191, yt = at >>> 13, St = ve[1] | 0, xt = St & 8191, Vt = St >>> 13, ci = ve[2] | 0, Qt = ci & 8191, rr = ci >>> 13, ui = ve[3] | 0, Gr = ui & 8191, yr = ui >>> 13, pi = ve[4] | 0, wr = pi & 8191, _r = pi >>> 13, di = ve[5] | 0, Sr = di & 8191, Br = di >>> 13, vi = ve[6] | 0, gr = vi & 8191, $r = vi >>> 13, li = ve[7] | 0, Ir = li & 8191, Cr = li >>> 13, mi = ve[8] | 0, Pr = mi & 8191, Or = mi >>> 13, yi = ve[9] | 0, Zr = yi & 8191, Vr = yi >>> 13;
        B.negative = t.negative ^ h.negative, B.length = 19, X = Math.imul(Ke, dt), a = Math.imul(Ke, yt), a = a + Math.imul(tt, dt) | 0, Y = Math.imul(tt, yt);
        var bi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, X = Math.imul(ot, dt), a = Math.imul(ot, yt), a = a + Math.imul(He, dt) | 0, Y = Math.imul(He, yt), X = X + Math.imul(Ke, xt) | 0, a = a + Math.imul(Ke, Vt) | 0, a = a + Math.imul(tt, xt) | 0, Y = Y + Math.imul(tt, Vt) | 0;
        var Ai = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, X = Math.imul(nt, dt), a = Math.imul(nt, yt), a = a + Math.imul(je, dt) | 0, Y = Math.imul(je, yt), X = X + Math.imul(ot, xt) | 0, a = a + Math.imul(ot, Vt) | 0, a = a + Math.imul(He, xt) | 0, Y = Y + Math.imul(He, Vt) | 0, X = X + Math.imul(Ke, Qt) | 0, a = a + Math.imul(Ke, rr) | 0, a = a + Math.imul(tt, Qt) | 0, Y = Y + Math.imul(tt, rr) | 0;
        var Zi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, X = Math.imul(st, dt), a = Math.imul(st, yt), a = a + Math.imul(gt, dt) | 0, Y = Math.imul(gt, yt), X = X + Math.imul(nt, xt) | 0, a = a + Math.imul(nt, Vt) | 0, a = a + Math.imul(je, xt) | 0, Y = Y + Math.imul(je, Vt) | 0, X = X + Math.imul(ot, Qt) | 0, a = a + Math.imul(ot, rr) | 0, a = a + Math.imul(He, Qt) | 0, Y = Y + Math.imul(He, rr) | 0, X = X + Math.imul(Ke, Gr) | 0, a = a + Math.imul(Ke, yr) | 0, a = a + Math.imul(tt, Gr) | 0, Y = Y + Math.imul(tt, yr) | 0;
        var Ji = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, X = Math.imul(At, dt), a = Math.imul(At, yt), a = a + Math.imul(Et, dt) | 0, Y = Math.imul(Et, yt), X = X + Math.imul(st, xt) | 0, a = a + Math.imul(st, Vt) | 0, a = a + Math.imul(gt, xt) | 0, Y = Y + Math.imul(gt, Vt) | 0, X = X + Math.imul(nt, Qt) | 0, a = a + Math.imul(nt, rr) | 0, a = a + Math.imul(je, Qt) | 0, Y = Y + Math.imul(je, rr) | 0, X = X + Math.imul(ot, Gr) | 0, a = a + Math.imul(ot, yr) | 0, a = a + Math.imul(He, Gr) | 0, Y = Y + Math.imul(He, yr) | 0, X = X + Math.imul(Ke, wr) | 0, a = a + Math.imul(Ke, _r) | 0, a = a + Math.imul(tt, wr) | 0, Y = Y + Math.imul(tt, _r) | 0;
        var Vi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, X = Math.imul(Xt, dt), a = Math.imul(Xt, yt), a = a + Math.imul(_t, dt) | 0, Y = Math.imul(_t, yt), X = X + Math.imul(At, xt) | 0, a = a + Math.imul(At, Vt) | 0, a = a + Math.imul(Et, xt) | 0, Y = Y + Math.imul(Et, Vt) | 0, X = X + Math.imul(st, Qt) | 0, a = a + Math.imul(st, rr) | 0, a = a + Math.imul(gt, Qt) | 0, Y = Y + Math.imul(gt, rr) | 0, X = X + Math.imul(nt, Gr) | 0, a = a + Math.imul(nt, yr) | 0, a = a + Math.imul(je, Gr) | 0, Y = Y + Math.imul(je, yr) | 0, X = X + Math.imul(ot, wr) | 0, a = a + Math.imul(ot, _r) | 0, a = a + Math.imul(He, wr) | 0, Y = Y + Math.imul(He, _r) | 0, X = X + Math.imul(Ke, Sr) | 0, a = a + Math.imul(Ke, Br) | 0, a = a + Math.imul(tt, Sr) | 0, Y = Y + Math.imul(tt, Br) | 0;
        var Yi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, X = Math.imul(Ct, dt), a = Math.imul(Ct, yt), a = a + Math.imul(Wt, dt) | 0, Y = Math.imul(Wt, yt), X = X + Math.imul(Xt, xt) | 0, a = a + Math.imul(Xt, Vt) | 0, a = a + Math.imul(_t, xt) | 0, Y = Y + Math.imul(_t, Vt) | 0, X = X + Math.imul(At, Qt) | 0, a = a + Math.imul(At, rr) | 0, a = a + Math.imul(Et, Qt) | 0, Y = Y + Math.imul(Et, rr) | 0, X = X + Math.imul(st, Gr) | 0, a = a + Math.imul(st, yr) | 0, a = a + Math.imul(gt, Gr) | 0, Y = Y + Math.imul(gt, yr) | 0, X = X + Math.imul(nt, wr) | 0, a = a + Math.imul(nt, _r) | 0, a = a + Math.imul(je, wr) | 0, Y = Y + Math.imul(je, _r) | 0, X = X + Math.imul(ot, Sr) | 0, a = a + Math.imul(ot, Br) | 0, a = a + Math.imul(He, Sr) | 0, Y = Y + Math.imul(He, Br) | 0, X = X + Math.imul(Ke, gr) | 0, a = a + Math.imul(Ke, $r) | 0, a = a + Math.imul(tt, gr) | 0, Y = Y + Math.imul(tt, $r) | 0;
        var Xi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, X = Math.imul(Pt, dt), a = Math.imul(Pt, yt), a = a + Math.imul(Rt, dt) | 0, Y = Math.imul(Rt, yt), X = X + Math.imul(Ct, xt) | 0, a = a + Math.imul(Ct, Vt) | 0, a = a + Math.imul(Wt, xt) | 0, Y = Y + Math.imul(Wt, Vt) | 0, X = X + Math.imul(Xt, Qt) | 0, a = a + Math.imul(Xt, rr) | 0, a = a + Math.imul(_t, Qt) | 0, Y = Y + Math.imul(_t, rr) | 0, X = X + Math.imul(At, Gr) | 0, a = a + Math.imul(At, yr) | 0, a = a + Math.imul(Et, Gr) | 0, Y = Y + Math.imul(Et, yr) | 0, X = X + Math.imul(st, wr) | 0, a = a + Math.imul(st, _r) | 0, a = a + Math.imul(gt, wr) | 0, Y = Y + Math.imul(gt, _r) | 0, X = X + Math.imul(nt, Sr) | 0, a = a + Math.imul(nt, Br) | 0, a = a + Math.imul(je, Sr) | 0, Y = Y + Math.imul(je, Br) | 0, X = X + Math.imul(ot, gr) | 0, a = a + Math.imul(ot, $r) | 0, a = a + Math.imul(He, gr) | 0, Y = Y + Math.imul(He, $r) | 0, X = X + Math.imul(Ke, Ir) | 0, a = a + Math.imul(Ke, Cr) | 0, a = a + Math.imul(tt, Ir) | 0, Y = Y + Math.imul(tt, Cr) | 0;
        var en = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, X = Math.imul(Nt, dt), a = Math.imul(Nt, yt), a = a + Math.imul(qt, dt) | 0, Y = Math.imul(qt, yt), X = X + Math.imul(Pt, xt) | 0, a = a + Math.imul(Pt, Vt) | 0, a = a + Math.imul(Rt, xt) | 0, Y = Y + Math.imul(Rt, Vt) | 0, X = X + Math.imul(Ct, Qt) | 0, a = a + Math.imul(Ct, rr) | 0, a = a + Math.imul(Wt, Qt) | 0, Y = Y + Math.imul(Wt, rr) | 0, X = X + Math.imul(Xt, Gr) | 0, a = a + Math.imul(Xt, yr) | 0, a = a + Math.imul(_t, Gr) | 0, Y = Y + Math.imul(_t, yr) | 0, X = X + Math.imul(At, wr) | 0, a = a + Math.imul(At, _r) | 0, a = a + Math.imul(Et, wr) | 0, Y = Y + Math.imul(Et, _r) | 0, X = X + Math.imul(st, Sr) | 0, a = a + Math.imul(st, Br) | 0, a = a + Math.imul(gt, Sr) | 0, Y = Y + Math.imul(gt, Br) | 0, X = X + Math.imul(nt, gr) | 0, a = a + Math.imul(nt, $r) | 0, a = a + Math.imul(je, gr) | 0, Y = Y + Math.imul(je, $r) | 0, X = X + Math.imul(ot, Ir) | 0, a = a + Math.imul(ot, Cr) | 0, a = a + Math.imul(He, Ir) | 0, Y = Y + Math.imul(He, Cr) | 0, X = X + Math.imul(Ke, Pr) | 0, a = a + Math.imul(Ke, Or) | 0, a = a + Math.imul(tt, Pr) | 0, Y = Y + Math.imul(tt, Or) | 0;
        var hn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, X = Math.imul(ct, dt), a = Math.imul(ct, yt), a = a + Math.imul(Ze, dt) | 0, Y = Math.imul(Ze, yt), X = X + Math.imul(Nt, xt) | 0, a = a + Math.imul(Nt, Vt) | 0, a = a + Math.imul(qt, xt) | 0, Y = Y + Math.imul(qt, Vt) | 0, X = X + Math.imul(Pt, Qt) | 0, a = a + Math.imul(Pt, rr) | 0, a = a + Math.imul(Rt, Qt) | 0, Y = Y + Math.imul(Rt, rr) | 0, X = X + Math.imul(Ct, Gr) | 0, a = a + Math.imul(Ct, yr) | 0, a = a + Math.imul(Wt, Gr) | 0, Y = Y + Math.imul(Wt, yr) | 0, X = X + Math.imul(Xt, wr) | 0, a = a + Math.imul(Xt, _r) | 0, a = a + Math.imul(_t, wr) | 0, Y = Y + Math.imul(_t, _r) | 0, X = X + Math.imul(At, Sr) | 0, a = a + Math.imul(At, Br) | 0, a = a + Math.imul(Et, Sr) | 0, Y = Y + Math.imul(Et, Br) | 0, X = X + Math.imul(st, gr) | 0, a = a + Math.imul(st, $r) | 0, a = a + Math.imul(gt, gr) | 0, Y = Y + Math.imul(gt, $r) | 0, X = X + Math.imul(nt, Ir) | 0, a = a + Math.imul(nt, Cr) | 0, a = a + Math.imul(je, Ir) | 0, Y = Y + Math.imul(je, Cr) | 0, X = X + Math.imul(ot, Pr) | 0, a = a + Math.imul(ot, Or) | 0, a = a + Math.imul(He, Pr) | 0, Y = Y + Math.imul(He, Or) | 0, X = X + Math.imul(Ke, Zr) | 0, a = a + Math.imul(Ke, Vr) | 0, a = a + Math.imul(tt, Zr) | 0, Y = Y + Math.imul(tt, Vr) | 0;
        var tn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, X = Math.imul(ct, xt), a = Math.imul(ct, Vt), a = a + Math.imul(Ze, xt) | 0, Y = Math.imul(Ze, Vt), X = X + Math.imul(Nt, Qt) | 0, a = a + Math.imul(Nt, rr) | 0, a = a + Math.imul(qt, Qt) | 0, Y = Y + Math.imul(qt, rr) | 0, X = X + Math.imul(Pt, Gr) | 0, a = a + Math.imul(Pt, yr) | 0, a = a + Math.imul(Rt, Gr) | 0, Y = Y + Math.imul(Rt, yr) | 0, X = X + Math.imul(Ct, wr) | 0, a = a + Math.imul(Ct, _r) | 0, a = a + Math.imul(Wt, wr) | 0, Y = Y + Math.imul(Wt, _r) | 0, X = X + Math.imul(Xt, Sr) | 0, a = a + Math.imul(Xt, Br) | 0, a = a + Math.imul(_t, Sr) | 0, Y = Y + Math.imul(_t, Br) | 0, X = X + Math.imul(At, gr) | 0, a = a + Math.imul(At, $r) | 0, a = a + Math.imul(Et, gr) | 0, Y = Y + Math.imul(Et, $r) | 0, X = X + Math.imul(st, Ir) | 0, a = a + Math.imul(st, Cr) | 0, a = a + Math.imul(gt, Ir) | 0, Y = Y + Math.imul(gt, Cr) | 0, X = X + Math.imul(nt, Pr) | 0, a = a + Math.imul(nt, Or) | 0, a = a + Math.imul(je, Pr) | 0, Y = Y + Math.imul(je, Or) | 0, X = X + Math.imul(ot, Zr) | 0, a = a + Math.imul(ot, Vr) | 0, a = a + Math.imul(He, Zr) | 0, Y = Y + Math.imul(He, Vr) | 0;
        var un = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, X = Math.imul(ct, Qt), a = Math.imul(ct, rr), a = a + Math.imul(Ze, Qt) | 0, Y = Math.imul(Ze, rr), X = X + Math.imul(Nt, Gr) | 0, a = a + Math.imul(Nt, yr) | 0, a = a + Math.imul(qt, Gr) | 0, Y = Y + Math.imul(qt, yr) | 0, X = X + Math.imul(Pt, wr) | 0, a = a + Math.imul(Pt, _r) | 0, a = a + Math.imul(Rt, wr) | 0, Y = Y + Math.imul(Rt, _r) | 0, X = X + Math.imul(Ct, Sr) | 0, a = a + Math.imul(Ct, Br) | 0, a = a + Math.imul(Wt, Sr) | 0, Y = Y + Math.imul(Wt, Br) | 0, X = X + Math.imul(Xt, gr) | 0, a = a + Math.imul(Xt, $r) | 0, a = a + Math.imul(_t, gr) | 0, Y = Y + Math.imul(_t, $r) | 0, X = X + Math.imul(At, Ir) | 0, a = a + Math.imul(At, Cr) | 0, a = a + Math.imul(Et, Ir) | 0, Y = Y + Math.imul(Et, Cr) | 0, X = X + Math.imul(st, Pr) | 0, a = a + Math.imul(st, Or) | 0, a = a + Math.imul(gt, Pr) | 0, Y = Y + Math.imul(gt, Or) | 0, X = X + Math.imul(nt, Zr) | 0, a = a + Math.imul(nt, Vr) | 0, a = a + Math.imul(je, Zr) | 0, Y = Y + Math.imul(je, Vr) | 0;
        var cn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, X = Math.imul(ct, Gr), a = Math.imul(ct, yr), a = a + Math.imul(Ze, Gr) | 0, Y = Math.imul(Ze, yr), X = X + Math.imul(Nt, wr) | 0, a = a + Math.imul(Nt, _r) | 0, a = a + Math.imul(qt, wr) | 0, Y = Y + Math.imul(qt, _r) | 0, X = X + Math.imul(Pt, Sr) | 0, a = a + Math.imul(Pt, Br) | 0, a = a + Math.imul(Rt, Sr) | 0, Y = Y + Math.imul(Rt, Br) | 0, X = X + Math.imul(Ct, gr) | 0, a = a + Math.imul(Ct, $r) | 0, a = a + Math.imul(Wt, gr) | 0, Y = Y + Math.imul(Wt, $r) | 0, X = X + Math.imul(Xt, Ir) | 0, a = a + Math.imul(Xt, Cr) | 0, a = a + Math.imul(_t, Ir) | 0, Y = Y + Math.imul(_t, Cr) | 0, X = X + Math.imul(At, Pr) | 0, a = a + Math.imul(At, Or) | 0, a = a + Math.imul(Et, Pr) | 0, Y = Y + Math.imul(Et, Or) | 0, X = X + Math.imul(st, Zr) | 0, a = a + Math.imul(st, Vr) | 0, a = a + Math.imul(gt, Zr) | 0, Y = Y + Math.imul(gt, Vr) | 0;
        var ln = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, X = Math.imul(ct, wr), a = Math.imul(ct, _r), a = a + Math.imul(Ze, wr) | 0, Y = Math.imul(Ze, _r), X = X + Math.imul(Nt, Sr) | 0, a = a + Math.imul(Nt, Br) | 0, a = a + Math.imul(qt, Sr) | 0, Y = Y + Math.imul(qt, Br) | 0, X = X + Math.imul(Pt, gr) | 0, a = a + Math.imul(Pt, $r) | 0, a = a + Math.imul(Rt, gr) | 0, Y = Y + Math.imul(Rt, $r) | 0, X = X + Math.imul(Ct, Ir) | 0, a = a + Math.imul(Ct, Cr) | 0, a = a + Math.imul(Wt, Ir) | 0, Y = Y + Math.imul(Wt, Cr) | 0, X = X + Math.imul(Xt, Pr) | 0, a = a + Math.imul(Xt, Or) | 0, a = a + Math.imul(_t, Pr) | 0, Y = Y + Math.imul(_t, Or) | 0, X = X + Math.imul(At, Zr) | 0, a = a + Math.imul(At, Vr) | 0, a = a + Math.imul(Et, Zr) | 0, Y = Y + Math.imul(Et, Vr) | 0;
        var an = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, X = Math.imul(ct, Sr), a = Math.imul(ct, Br), a = a + Math.imul(Ze, Sr) | 0, Y = Math.imul(Ze, Br), X = X + Math.imul(Nt, gr) | 0, a = a + Math.imul(Nt, $r) | 0, a = a + Math.imul(qt, gr) | 0, Y = Y + Math.imul(qt, $r) | 0, X = X + Math.imul(Pt, Ir) | 0, a = a + Math.imul(Pt, Cr) | 0, a = a + Math.imul(Rt, Ir) | 0, Y = Y + Math.imul(Rt, Cr) | 0, X = X + Math.imul(Ct, Pr) | 0, a = a + Math.imul(Ct, Or) | 0, a = a + Math.imul(Wt, Pr) | 0, Y = Y + Math.imul(Wt, Or) | 0, X = X + Math.imul(Xt, Zr) | 0, a = a + Math.imul(Xt, Vr) | 0, a = a + Math.imul(_t, Zr) | 0, Y = Y + Math.imul(_t, Vr) | 0;
        var fn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, X = Math.imul(ct, gr), a = Math.imul(ct, $r), a = a + Math.imul(Ze, gr) | 0, Y = Math.imul(Ze, $r), X = X + Math.imul(Nt, Ir) | 0, a = a + Math.imul(Nt, Cr) | 0, a = a + Math.imul(qt, Ir) | 0, Y = Y + Math.imul(qt, Cr) | 0, X = X + Math.imul(Pt, Pr) | 0, a = a + Math.imul(Pt, Or) | 0, a = a + Math.imul(Rt, Pr) | 0, Y = Y + Math.imul(Rt, Or) | 0, X = X + Math.imul(Ct, Zr) | 0, a = a + Math.imul(Ct, Vr) | 0, a = a + Math.imul(Wt, Zr) | 0, Y = Y + Math.imul(Wt, Vr) | 0;
        var sn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, X = Math.imul(ct, Ir), a = Math.imul(ct, Cr), a = a + Math.imul(Ze, Ir) | 0, Y = Math.imul(Ze, Cr), X = X + Math.imul(Nt, Pr) | 0, a = a + Math.imul(Nt, Or) | 0, a = a + Math.imul(qt, Pr) | 0, Y = Y + Math.imul(qt, Or) | 0, X = X + Math.imul(Pt, Zr) | 0, a = a + Math.imul(Pt, Vr) | 0, a = a + Math.imul(Rt, Zr) | 0, Y = Y + Math.imul(Rt, Vr) | 0;
        var dn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, X = Math.imul(ct, Pr), a = Math.imul(ct, Or), a = a + Math.imul(Ze, Pr) | 0, Y = Math.imul(Ze, Or), X = X + Math.imul(Nt, Zr) | 0, a = a + Math.imul(Nt, Vr) | 0, a = a + Math.imul(qt, Zr) | 0, Y = Y + Math.imul(qt, Vr) | 0;
        var pn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, X = Math.imul(ct, Zr), a = Math.imul(ct, Vr), a = a + Math.imul(Ze, Zr) | 0, Y = Math.imul(Ze, Vr);
        var vn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        return xe = (Y + (a >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, ge[0] = bi, ge[1] = Ai, ge[2] = Zi, ge[3] = Ji, ge[4] = Vi, ge[5] = Yi, ge[6] = Xi, ge[7] = en, ge[8] = hn, ge[9] = tn, ge[10] = un, ge[11] = cn, ge[12] = ln, ge[13] = an, ge[14] = fn, ge[15] = sn, ge[16] = dn, ge[17] = pn, ge[18] = vn, xe !== 0 && (ge[19] = xe, B.length++), B;
      };
      Math.imul || (Ge = Fe);
      function et(Se, t, h) {
        h.negative = t.negative ^ Se.negative, h.length = Se.length + t.length;
        for (var B = 0, Z = 0, ve = 0; ve < h.length - 1; ve++) {
          var ge = Z;
          Z = 0;
          for (var xe = B & 67108863, X = Math.min(ve, t.length - 1), a = Math.max(0, ve - Se.length + 1); a <= X; a++) {
            var Y = ve - a, Ne = Se.words[Y] | 0, Ke = t.words[a] | 0, tt = Ne * Ke, We = tt & 67108863;
            ge = ge + (tt / 67108864 | 0) | 0, We = We + xe | 0, xe = We & 67108863, ge = ge + (We >>> 26) | 0, Z += ge >>> 26, ge &= 67108863;
          }
          h.words[ve] = xe, B = ge, ge = Z;
        }
        return B !== 0 ? h.words[ve] = B : h.length--, h.strip();
      }
      function Ve(Se, t, h) {
        var B = new Je();
        return B.mulp(Se, t, h);
      }
      H.prototype.mulTo = function(t, h) {
        var B, Z = this.length + t.length;
        return this.length === 10 && t.length === 10 ? B = Ge(this, t, h) : Z < 63 ? B = Fe(this, t, h) : Z < 1024 ? B = et(this, t, h) : B = Ve(this, t, h), B;
      };
      function Je(Se, t) {
        this.x = Se, this.y = t;
      }
      Je.prototype.makeRBT = function(t) {
        for (var h = new Array(t), B = H.prototype._countBits(t) - 1, Z = 0; Z < t; Z++)
          h[Z] = this.revBin(Z, B, t);
        return h;
      }, Je.prototype.revBin = function(t, h, B) {
        if (t === 0 || t === B - 1) return t;
        for (var Z = 0, ve = 0; ve < h; ve++)
          Z |= (t & 1) << h - ve - 1, t >>= 1;
        return Z;
      }, Je.prototype.permute = function(t, h, B, Z, ve, ge) {
        for (var xe = 0; xe < ge; xe++)
          Z[xe] = h[t[xe]], ve[xe] = B[t[xe]];
      }, Je.prototype.transform = function(t, h, B, Z, ve, ge) {
        this.permute(ge, t, h, B, Z, ve);
        for (var xe = 1; xe < ve; xe <<= 1)
          for (var X = xe << 1, a = Math.cos(2 * Math.PI / X), Y = Math.sin(2 * Math.PI / X), Ne = 0; Ne < ve; Ne += X)
            for (var Ke = a, tt = Y, We = 0; We < xe; We++) {
              var ot = B[Ne + We], He = Z[Ne + We], Qe = B[Ne + We + xe], nt = Z[Ne + We + xe], je = Ke * Qe - tt * nt;
              nt = Ke * nt + tt * Qe, Qe = je, B[Ne + We] = ot + Qe, Z[Ne + We] = He + nt, B[Ne + We + xe] = ot - Qe, Z[Ne + We + xe] = He - nt, We !== X && (je = a * Ke - Y * tt, tt = a * tt + Y * Ke, Ke = je);
            }
      }, Je.prototype.guessLen13b = function(t, h) {
        var B = Math.max(h, t) | 1, Z = B & 1, ve = 0;
        for (B = B / 2 | 0; B; B = B >>> 1)
          ve++;
        return 1 << ve + 1 + Z;
      }, Je.prototype.conjugate = function(t, h, B) {
        if (!(B <= 1))
          for (var Z = 0; Z < B / 2; Z++) {
            var ve = t[Z];
            t[Z] = t[B - Z - 1], t[B - Z - 1] = ve, ve = h[Z], h[Z] = -h[B - Z - 1], h[B - Z - 1] = -ve;
          }
      }, Je.prototype.normalize13b = function(t, h) {
        for (var B = 0, Z = 0; Z < h / 2; Z++) {
          var ve = Math.round(t[2 * Z + 1] / h) * 8192 + Math.round(t[2 * Z] / h) + B;
          t[Z] = ve & 67108863, ve < 67108864 ? B = 0 : B = ve / 67108864 | 0;
        }
        return t;
      }, Je.prototype.convert13b = function(t, h, B, Z) {
        for (var ve = 0, ge = 0; ge < h; ge++)
          ve = ve + (t[ge] | 0), B[2 * ge] = ve & 8191, ve = ve >>> 13, B[2 * ge + 1] = ve & 8191, ve = ve >>> 13;
        for (ge = 2 * h; ge < Z; ++ge)
          B[ge] = 0;
        J(ve === 0), J((ve & -8192) === 0);
      }, Je.prototype.stub = function(t) {
        for (var h = new Array(t), B = 0; B < t; B++)
          h[B] = 0;
        return h;
      }, Je.prototype.mulp = function(t, h, B) {
        var Z = 2 * this.guessLen13b(t.length, h.length), ve = this.makeRBT(Z), ge = this.stub(Z), xe = new Array(Z), X = new Array(Z), a = new Array(Z), Y = new Array(Z), Ne = new Array(Z), Ke = new Array(Z), tt = B.words;
        tt.length = Z, this.convert13b(t.words, t.length, xe, Z), this.convert13b(h.words, h.length, Y, Z), this.transform(xe, ge, X, a, Z, ve), this.transform(Y, ge, Ne, Ke, Z, ve);
        for (var We = 0; We < Z; We++) {
          var ot = X[We] * Ne[We] - a[We] * Ke[We];
          a[We] = X[We] * Ke[We] + a[We] * Ne[We], X[We] = ot;
        }
        return this.conjugate(X, a, Z), this.transform(X, a, tt, ge, Z, ve), this.conjugate(tt, ge, Z), this.normalize13b(tt, Z), B.negative = t.negative ^ h.negative, B.length = t.length + h.length, B.strip();
      }, H.prototype.mul = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), this.mulTo(t, h);
      }, H.prototype.mulf = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), Ve(this, t, h);
      }, H.prototype.imul = function(t) {
        return this.clone().mulTo(t, this);
      }, H.prototype.imuln = function(t) {
        J(typeof t == "number"), J(t < 67108864);
        for (var h = 0, B = 0; B < this.length; B++) {
          var Z = (this.words[B] | 0) * t, ve = (Z & 67108863) + (h & 67108863);
          h >>= 26, h += Z / 67108864 | 0, h += ve >>> 26, this.words[B] = ve & 67108863;
        }
        return h !== 0 && (this.words[B] = h, this.length++), this;
      }, H.prototype.muln = function(t) {
        return this.clone().imuln(t);
      }, H.prototype.sqr = function() {
        return this.mul(this);
      }, H.prototype.isqr = function() {
        return this.imul(this.clone());
      }, H.prototype.pow = function(t) {
        var h = ke(t);
        if (h.length === 0) return new H(1);
        for (var B = this, Z = 0; Z < h.length && h[Z] === 0; Z++, B = B.sqr())
          ;
        if (++Z < h.length)
          for (var ve = B.sqr(); Z < h.length; Z++, ve = ve.sqr())
            h[Z] !== 0 && (B = B.mul(ve));
        return B;
      }, H.prototype.iushln = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 67108863 >>> 26 - h << 26 - h, ve;
        if (h !== 0) {
          var ge = 0;
          for (ve = 0; ve < this.length; ve++) {
            var xe = this.words[ve] & Z, X = (this.words[ve] | 0) - xe << h;
            this.words[ve] = X | ge, ge = xe >>> 26 - h;
          }
          ge && (this.words[ve] = ge, this.length++);
        }
        if (B !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + B] = this.words[ve];
          for (ve = 0; ve < B; ve++)
            this.words[ve] = 0;
          this.length += B;
        }
        return this.strip();
      }, H.prototype.ishln = function(t) {
        return J(this.negative === 0), this.iushln(t);
      }, H.prototype.iushrn = function(t, h, B) {
        J(typeof t == "number" && t >= 0);
        var Z;
        h ? Z = (h - h % 26) / 26 : Z = 0;
        var ve = t % 26, ge = Math.min((t - ve) / 26, this.length), xe = 67108863 ^ 67108863 >>> ve << ve, X = B;
        if (Z -= ge, Z = Math.max(0, Z), X) {
          for (var a = 0; a < ge; a++)
            X.words[a] = this.words[a];
          X.length = ge;
        }
        if (ge !== 0) if (this.length > ge)
          for (this.length -= ge, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + ge];
        else
          this.words[0] = 0, this.length = 1;
        var Y = 0;
        for (a = this.length - 1; a >= 0 && (Y !== 0 || a >= Z); a--) {
          var Ne = this.words[a] | 0;
          this.words[a] = Y << 26 - ve | Ne >>> ve, Y = Ne & xe;
        }
        return X && Y !== 0 && (X.words[X.length++] = Y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, H.prototype.ishrn = function(t, h, B) {
        return J(this.negative === 0), this.iushrn(t, h, B);
      }, H.prototype.shln = function(t) {
        return this.clone().ishln(t);
      }, H.prototype.ushln = function(t) {
        return this.clone().iushln(t);
      }, H.prototype.shrn = function(t) {
        return this.clone().ishrn(t);
      }, H.prototype.ushrn = function(t) {
        return this.clone().iushrn(t);
      }, H.prototype.testn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B) return !1;
        var ve = this.words[B];
        return !!(ve & Z);
      }, H.prototype.imaskn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26;
        if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= B)
          return this;
        if (h !== 0 && B++, this.length = Math.min(B, this.length), h !== 0) {
          var Z = 67108863 ^ 67108863 >>> h << h;
          this.words[this.length - 1] &= Z;
        }
        return this.strip();
      }, H.prototype.maskn = function(t) {
        return this.clone().imaskn(t);
      }, H.prototype.iaddn = function(t) {
        return J(typeof t == "number"), J(t < 67108864), t < 0 ? this.isubn(-t) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < t ? (this.words[0] = t - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
      }, H.prototype._iaddn = function(t) {
        this.words[0] += t;
        for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
          this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
        return this.length = Math.max(this.length, h + 1), this;
      }, H.prototype.isubn = function(t) {
        if (J(typeof t == "number"), J(t < 67108864), t < 0) return this.iaddn(-t);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(t), this.negative = 1, this;
        if (this.words[0] -= t, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var h = 0; h < this.length && this.words[h] < 0; h++)
            this.words[h] += 67108864, this.words[h + 1] -= 1;
        return this.strip();
      }, H.prototype.addn = function(t) {
        return this.clone().iaddn(t);
      }, H.prototype.subn = function(t) {
        return this.clone().isubn(t);
      }, H.prototype.iabs = function() {
        return this.negative = 0, this;
      }, H.prototype.abs = function() {
        return this.clone().iabs();
      }, H.prototype._ishlnsubmul = function(t, h, B) {
        var Z = t.length + B, ve;
        this._expand(Z);
        var ge, xe = 0;
        for (ve = 0; ve < t.length; ve++) {
          ge = (this.words[ve + B] | 0) + xe;
          var X = (t.words[ve] | 0) * h;
          ge -= X & 67108863, xe = (ge >> 26) - (X / 67108864 | 0), this.words[ve + B] = ge & 67108863;
        }
        for (; ve < this.length - B; ve++)
          ge = (this.words[ve + B] | 0) + xe, xe = ge >> 26, this.words[ve + B] = ge & 67108863;
        if (xe === 0) return this.strip();
        for (J(xe === -1), xe = 0, ve = 0; ve < this.length; ve++)
          ge = -(this.words[ve] | 0) + xe, xe = ge >> 26, this.words[ve] = ge & 67108863;
        return this.negative = 1, this.strip();
      }, H.prototype._wordDiv = function(t, h) {
        var B = this.length - t.length, Z = this.clone(), ve = t, ge = ve.words[ve.length - 1] | 0, xe = this._countBits(ge);
        B = 26 - xe, B !== 0 && (ve = ve.ushln(B), Z.iushln(B), ge = ve.words[ve.length - 1] | 0);
        var X = Z.length - ve.length, a;
        if (h !== "mod") {
          a = new H(null), a.length = X + 1, a.words = new Array(a.length);
          for (var Y = 0; Y < a.length; Y++)
            a.words[Y] = 0;
        }
        var Ne = Z.clone()._ishlnsubmul(ve, 1, X);
        Ne.negative === 0 && (Z = Ne, a && (a.words[X] = 1));
        for (var Ke = X - 1; Ke >= 0; Ke--) {
          var tt = (Z.words[ve.length + Ke] | 0) * 67108864 + (Z.words[ve.length + Ke - 1] | 0);
          for (tt = Math.min(tt / ge | 0, 67108863), Z._ishlnsubmul(ve, tt, Ke); Z.negative !== 0; )
            tt--, Z.negative = 0, Z._ishlnsubmul(ve, 1, Ke), Z.isZero() || (Z.negative ^= 1);
          a && (a.words[Ke] = tt);
        }
        return a && a.strip(), Z.strip(), h !== "div" && B !== 0 && Z.iushrn(B), {
          div: a || null,
          mod: Z
        };
      }, H.prototype.divmod = function(t, h, B) {
        if (J(!t.isZero()), this.isZero())
          return {
            div: new H(0),
            mod: new H(0)
          };
        var Z, ve, ge;
        return this.negative !== 0 && t.negative === 0 ? (ge = this.neg().divmod(t, h), h !== "mod" && (Z = ge.div.neg()), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.iadd(t)), {
          div: Z,
          mod: ve
        }) : this.negative === 0 && t.negative !== 0 ? (ge = this.divmod(t.neg(), h), h !== "mod" && (Z = ge.div.neg()), {
          div: Z,
          mod: ge.mod
        }) : this.negative & t.negative ? (ge = this.neg().divmod(t.neg(), h), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.isub(t)), {
          div: ge.div,
          mod: ve
        }) : t.length > this.length || this.cmp(t) < 0 ? {
          div: new H(0),
          mod: this
        } : t.length === 1 ? h === "div" ? {
          div: this.divn(t.words[0]),
          mod: null
        } : h === "mod" ? {
          div: null,
          mod: new H(this.modn(t.words[0]))
        } : {
          div: this.divn(t.words[0]),
          mod: new H(this.modn(t.words[0]))
        } : this._wordDiv(t, h);
      }, H.prototype.div = function(t) {
        return this.divmod(t, "div", !1).div;
      }, H.prototype.mod = function(t) {
        return this.divmod(t, "mod", !1).mod;
      }, H.prototype.umod = function(t) {
        return this.divmod(t, "mod", !0).mod;
      }, H.prototype.divRound = function(t) {
        var h = this.divmod(t);
        if (h.mod.isZero()) return h.div;
        var B = h.div.negative !== 0 ? h.mod.isub(t) : h.mod, Z = t.ushrn(1), ve = t.andln(1), ge = B.cmp(Z);
        return ge < 0 || ve === 1 && ge === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
      }, H.prototype.modn = function(t) {
        J(t <= 67108863);
        for (var h = (1 << 26) % t, B = 0, Z = this.length - 1; Z >= 0; Z--)
          B = (h * B + (this.words[Z] | 0)) % t;
        return B;
      }, H.prototype.idivn = function(t) {
        J(t <= 67108863);
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = (this.words[B] | 0) + h * 67108864;
          this.words[B] = Z / t | 0, h = Z % t;
        }
        return this.strip();
      }, H.prototype.divn = function(t) {
        return this.clone().idivn(t);
      }, H.prototype.egcd = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = new H(0), xe = new H(1), X = 0; h.isEven() && B.isEven(); )
          h.iushrn(1), B.iushrn(1), ++X;
        for (var a = B.clone(), Y = h.clone(); !h.isZero(); ) {
          for (var Ne = 0, Ke = 1; !(h.words[0] & Ke) && Ne < 26; ++Ne, Ke <<= 1) ;
          if (Ne > 0)
            for (h.iushrn(Ne); Ne-- > 0; )
              (Z.isOdd() || ve.isOdd()) && (Z.iadd(a), ve.isub(Y)), Z.iushrn(1), ve.iushrn(1);
          for (var tt = 0, We = 1; !(B.words[0] & We) && tt < 26; ++tt, We <<= 1) ;
          if (tt > 0)
            for (B.iushrn(tt); tt-- > 0; )
              (ge.isOdd() || xe.isOdd()) && (ge.iadd(a), xe.isub(Y)), ge.iushrn(1), xe.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ge), ve.isub(xe)) : (B.isub(h), ge.isub(Z), xe.isub(ve));
        }
        return {
          a: ge,
          b: xe,
          gcd: B.iushln(X)
        };
      }, H.prototype._invmp = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = B.clone(); h.cmpn(1) > 0 && B.cmpn(1) > 0; ) {
          for (var xe = 0, X = 1; !(h.words[0] & X) && xe < 26; ++xe, X <<= 1) ;
          if (xe > 0)
            for (h.iushrn(xe); xe-- > 0; )
              Z.isOdd() && Z.iadd(ge), Z.iushrn(1);
          for (var a = 0, Y = 1; !(B.words[0] & Y) && a < 26; ++a, Y <<= 1) ;
          if (a > 0)
            for (B.iushrn(a); a-- > 0; )
              ve.isOdd() && ve.iadd(ge), ve.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ve)) : (B.isub(h), ve.isub(Z));
        }
        var Ne;
        return h.cmpn(1) === 0 ? Ne = Z : Ne = ve, Ne.cmpn(0) < 0 && Ne.iadd(t), Ne;
      }, H.prototype.gcd = function(t) {
        if (this.isZero()) return t.abs();
        if (t.isZero()) return this.abs();
        var h = this.clone(), B = t.clone();
        h.negative = 0, B.negative = 0;
        for (var Z = 0; h.isEven() && B.isEven(); Z++)
          h.iushrn(1), B.iushrn(1);
        do {
          for (; h.isEven(); )
            h.iushrn(1);
          for (; B.isEven(); )
            B.iushrn(1);
          var ve = h.cmp(B);
          if (ve < 0) {
            var ge = h;
            h = B, B = ge;
          } else if (ve === 0 || B.cmpn(1) === 0)
            break;
          h.isub(B);
        } while (!0);
        return B.iushln(Z);
      }, H.prototype.invm = function(t) {
        return this.egcd(t).a.umod(t);
      }, H.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, H.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, H.prototype.andln = function(t) {
        return this.words[0] & t;
      }, H.prototype.bincn = function(t) {
        J(typeof t == "number");
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B)
          return this._expand(B + 1), this.words[B] |= Z, this;
        for (var ve = Z, ge = B; ve !== 0 && ge < this.length; ge++) {
          var xe = this.words[ge] | 0;
          xe += ve, ve = xe >>> 26, xe &= 67108863, this.words[ge] = xe;
        }
        return ve !== 0 && (this.words[ge] = ve, this.length++), this;
      }, H.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, H.prototype.cmpn = function(t) {
        var h = t < 0;
        if (this.negative !== 0 && !h) return -1;
        if (this.negative === 0 && h) return 1;
        this.strip();
        var B;
        if (this.length > 1)
          B = 1;
        else {
          h && (t = -t), J(t <= 67108863, "Number is too big");
          var Z = this.words[0] | 0;
          B = Z === t ? 0 : Z < t ? -1 : 1;
        }
        return this.negative !== 0 ? -B | 0 : B;
      }, H.prototype.cmp = function(t) {
        if (this.negative !== 0 && t.negative === 0) return -1;
        if (this.negative === 0 && t.negative !== 0) return 1;
        var h = this.ucmp(t);
        return this.negative !== 0 ? -h | 0 : h;
      }, H.prototype.ucmp = function(t) {
        if (this.length > t.length) return 1;
        if (this.length < t.length) return -1;
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = this.words[B] | 0, ve = t.words[B] | 0;
          if (Z !== ve) {
            Z < ve ? h = -1 : Z > ve && (h = 1);
            break;
          }
        }
        return h;
      }, H.prototype.gtn = function(t) {
        return this.cmpn(t) === 1;
      }, H.prototype.gt = function(t) {
        return this.cmp(t) === 1;
      }, H.prototype.gten = function(t) {
        return this.cmpn(t) >= 0;
      }, H.prototype.gte = function(t) {
        return this.cmp(t) >= 0;
      }, H.prototype.ltn = function(t) {
        return this.cmpn(t) === -1;
      }, H.prototype.lt = function(t) {
        return this.cmp(t) === -1;
      }, H.prototype.lten = function(t) {
        return this.cmpn(t) <= 0;
      }, H.prototype.lte = function(t) {
        return this.cmp(t) <= 0;
      }, H.prototype.eqn = function(t) {
        return this.cmpn(t) === 0;
      }, H.prototype.eq = function(t) {
        return this.cmp(t) === 0;
      }, H.red = function(t) {
        return new bt(t);
      }, H.prototype.toRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), t.convertTo(this)._forceRed(t);
      }, H.prototype.fromRed = function() {
        return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, H.prototype._forceRed = function(t) {
        return this.red = t, this;
      }, H.prototype.forceRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), this._forceRed(t);
      }, H.prototype.redAdd = function(t) {
        return J(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
      }, H.prototype.redIAdd = function(t) {
        return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
      }, H.prototype.redSub = function(t) {
        return J(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
      }, H.prototype.redISub = function(t) {
        return J(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
      }, H.prototype.redShl = function(t) {
        return J(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
      }, H.prototype.redMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
      }, H.prototype.redIMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
      }, H.prototype.redSqr = function() {
        return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, H.prototype.redISqr = function() {
        return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, H.prototype.redSqrt = function() {
        return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, H.prototype.redInvm = function() {
        return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, H.prototype.redNeg = function() {
        return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, H.prototype.redPow = function(t) {
        return J(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
      };
      var ut = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function rt(Se, t) {
        this.name = Se, this.p = new H(t, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      rt.prototype._tmp = function() {
        var t = new H(null);
        return t.words = new Array(Math.ceil(this.n / 13)), t;
      }, rt.prototype.ireduce = function(t) {
        var h = t, B;
        do
          this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), B = h.bitLength();
        while (B > this.n);
        var Z = B < this.n ? -1 : h.ucmp(this.p);
        return Z === 0 ? (h.words[0] = 0, h.length = 1) : Z > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
      }, rt.prototype.split = function(t, h) {
        t.iushrn(this.n, 0, h);
      }, rt.prototype.imulK = function(t) {
        return t.imul(this.k);
      };
      function lt() {
        rt.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      _e(lt, rt), lt.prototype.split = function(t, h) {
        for (var B = 4194303, Z = Math.min(t.length, 9), ve = 0; ve < Z; ve++)
          h.words[ve] = t.words[ve];
        if (h.length = Z, t.length <= 9) {
          t.words[0] = 0, t.length = 1;
          return;
        }
        var ge = t.words[9];
        for (h.words[h.length++] = ge & B, ve = 10; ve < t.length; ve++) {
          var xe = t.words[ve] | 0;
          t.words[ve - 10] = (xe & B) << 4 | ge >>> 22, ge = xe;
        }
        ge >>>= 22, t.words[ve - 10] = ge, ge === 0 && t.length > 10 ? t.length -= 10 : t.length -= 9;
      }, lt.prototype.imulK = function(t) {
        t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = t.words[B] | 0;
          h += Z * 977, t.words[B] = h & 67108863, h = Z * 64 + (h / 67108864 | 0);
        }
        return t.words[t.length - 1] === 0 && (t.length--, t.words[t.length - 1] === 0 && t.length--), t;
      };
      function vt() {
        rt.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      _e(vt, rt);
      function Ye() {
        rt.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      _e(Ye, rt);
      function pt() {
        rt.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      _e(pt, rt), pt.prototype.imulK = function(t) {
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = (t.words[B] | 0) * 19 + h, ve = Z & 67108863;
          Z >>>= 26, t.words[B] = ve, h = Z;
        }
        return h !== 0 && (t.words[t.length++] = h), t;
      }, H._prime = function(t) {
        if (ut[t]) return ut[t];
        var h;
        if (t === "k256")
          h = new lt();
        else if (t === "p224")
          h = new vt();
        else if (t === "p192")
          h = new Ye();
        else if (t === "p25519")
          h = new pt();
        else
          throw new Error("Unknown prime " + t);
        return ut[t] = h, h;
      };
      function bt(Se) {
        if (typeof Se == "string") {
          var t = H._prime(Se);
          this.m = t.p, this.prime = t;
        } else
          J(Se.gtn(1), "modulus must be greater than 1"), this.m = Se, this.prime = null;
      }
      bt.prototype._verify1 = function(t) {
        J(t.negative === 0, "red works only with positives"), J(t.red, "red works only with red numbers");
      }, bt.prototype._verify2 = function(t, h) {
        J((t.negative | h.negative) === 0, "red works only with positives"), J(
          t.red && t.red === h.red,
          "red works only with red numbers"
        );
      }, bt.prototype.imod = function(t) {
        return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
      }, bt.prototype.neg = function(t) {
        return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
      }, bt.prototype.add = function(t, h) {
        this._verify2(t, h);
        var B = t.add(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B._forceRed(this);
      }, bt.prototype.iadd = function(t, h) {
        this._verify2(t, h);
        var B = t.iadd(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B;
      }, bt.prototype.sub = function(t, h) {
        this._verify2(t, h);
        var B = t.sub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B._forceRed(this);
      }, bt.prototype.isub = function(t, h) {
        this._verify2(t, h);
        var B = t.isub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B;
      }, bt.prototype.shl = function(t, h) {
        return this._verify1(t), this.imod(t.ushln(h));
      }, bt.prototype.imul = function(t, h) {
        return this._verify2(t, h), this.imod(t.imul(h));
      }, bt.prototype.mul = function(t, h) {
        return this._verify2(t, h), this.imod(t.mul(h));
      }, bt.prototype.isqr = function(t) {
        return this.imul(t, t.clone());
      }, bt.prototype.sqr = function(t) {
        return this.mul(t, t);
      }, bt.prototype.sqrt = function(t) {
        if (t.isZero()) return t.clone();
        var h = this.m.andln(3);
        if (J(h % 2 === 1), h === 3) {
          var B = this.m.add(new H(1)).iushrn(2);
          return this.pow(t, B);
        }
        for (var Z = this.m.subn(1), ve = 0; !Z.isZero() && Z.andln(1) === 0; )
          ve++, Z.iushrn(1);
        J(!Z.isZero());
        var ge = new H(1).toRed(this), xe = ge.redNeg(), X = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new H(2 * a * a).toRed(this); this.pow(a, X).cmp(xe) !== 0; )
          a.redIAdd(xe);
        for (var Y = this.pow(a, Z), Ne = this.pow(t, Z.addn(1).iushrn(1)), Ke = this.pow(t, Z), tt = ve; Ke.cmp(ge) !== 0; ) {
          for (var We = Ke, ot = 0; We.cmp(ge) !== 0; ot++)
            We = We.redSqr();
          J(ot < tt);
          var He = this.pow(Y, new H(1).iushln(tt - ot - 1));
          Ne = Ne.redMul(He), Y = He.redSqr(), Ke = Ke.redMul(Y), tt = ot;
        }
        return Ne;
      }, bt.prototype.invm = function(t) {
        var h = t._invmp(this.m);
        return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
      }, bt.prototype.pow = function(t, h) {
        if (h.isZero()) return new H(1).toRed(this);
        if (h.cmpn(1) === 0) return t.clone();
        var B = 4, Z = new Array(1 << B);
        Z[0] = new H(1).toRed(this), Z[1] = t;
        for (var ve = 2; ve < Z.length; ve++)
          Z[ve] = this.mul(Z[ve - 1], t);
        var ge = Z[0], xe = 0, X = 0, a = h.bitLength() % 26;
        for (a === 0 && (a = 26), ve = h.length - 1; ve >= 0; ve--) {
          for (var Y = h.words[ve], Ne = a - 1; Ne >= 0; Ne--) {
            var Ke = Y >> Ne & 1;
            if (ge !== Z[0] && (ge = this.sqr(ge)), Ke === 0 && xe === 0) {
              X = 0;
              continue;
            }
            xe <<= 1, xe |= Ke, X++, !(X !== B && (ve !== 0 || Ne !== 0)) && (ge = this.mul(ge, Z[xe]), X = 0, xe = 0);
          }
          a = 26;
        }
        return ge;
      }, bt.prototype.convertTo = function(t) {
        var h = t.umod(this.m);
        return h === t ? h.clone() : h;
      }, bt.prototype.convertFrom = function(t) {
        var h = t.clone();
        return h.red = null, h;
      }, H.mont = function(t) {
        return new Yt(t);
      };
      function Yt(Se) {
        bt.call(this, Se), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      _e(Yt, bt), Yt.prototype.convertTo = function(t) {
        return this.imod(t.ushln(this.shift));
      }, Yt.prototype.convertFrom = function(t) {
        var h = this.imod(t.mul(this.rinv));
        return h.red = null, h;
      }, Yt.prototype.imul = function(t, h) {
        if (t.isZero() || h.isZero())
          return t.words[0] = 0, t.length = 1, t;
        var B = t.imul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.mul = function(t, h) {
        if (t.isZero() || h.isZero()) return new H(0)._forceRed(this);
        var B = t.mul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.invm = function(t) {
        var h = this.imod(t._invmp(this.m).mul(this.r2));
        return h._forceRed(this);
      };
    })(I, commonjsGlobal);
  }(bn$2)), bn$2.exports;
}
var browser$3, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2) return browser$3;
  hasRequiredBrowser$2 = 1;
  var I = requireElliptic(), A = requireBn$1();
  browser$3 = function(De) {
    return new J(De);
  };
  var G = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  G.p224 = G.secp224r1, G.p256 = G.secp256r1 = G.prime256v1, G.p192 = G.secp192r1 = G.prime192v1, G.p384 = G.secp384r1, G.p521 = G.secp521r1;
  function J(H) {
    this.curveType = G[H], this.curveType || (this.curveType = {
      name: H
    }), this.curve = new I.ec(this.curveType.name), this.keys = void 0;
  }
  J.prototype.generateKeys = function(H, De) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(H, De);
  }, J.prototype.computeSecret = function(H, De, Ie) {
    De = De || "utf8", Buffer$7.isBuffer(H) || (H = new Buffer$7(H, De));
    var qe = this.curve.keyFromPublic(H).getPublic(), Te = qe.mul(this.keys.getPrivate()).getX();
    return _e(Te, Ie, this.curveType.byteLength);
  }, J.prototype.getPublicKey = function(H, De) {
    var Ie = this.keys.getPublic(De === "compressed", !0);
    return De === "hybrid" && (Ie[Ie.length - 1] % 2 ? Ie[0] = 7 : Ie[0] = 6), _e(Ie, H);
  }, J.prototype.getPrivateKey = function(H) {
    return _e(this.keys.getPrivate(), H);
  }, J.prototype.setPublicKey = function(H, De) {
    return De = De || "utf8", Buffer$7.isBuffer(H) || (H = new Buffer$7(H, De)), this.keys._importPublic(H), this;
  }, J.prototype.setPrivateKey = function(H, De) {
    De = De || "utf8", Buffer$7.isBuffer(H) || (H = new Buffer$7(H, De));
    var Ie = new A(H);
    return Ie = Ie.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(Ie), this;
  };
  function _e(H, De, Ie) {
    Array.isArray(H) || (H = H.toArray());
    var qe = new Buffer$7(H);
    if (Ie && qe.length < Ie) {
      var Te = new Buffer$7(Ie - qe.length);
      Te.fill(0), qe = Buffer$7.concat([Te, qe]);
    }
    return De ? qe.toString(De) : qe;
  }
  return browser$3;
}
var browser$2 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf) return mgf;
  hasRequiredMgf = 1;
  var I = requireBrowser$9(), A = safeBufferExports.Buffer;
  mgf = function(J, _e) {
    for (var H = A.alloc(0), De = 0, Ie; H.length < _e; )
      Ie = G(De++), H = A.concat([H, I("sha1").update(J).update(Ie).digest()]);
    return H.slice(0, _e);
  };
  function G(J) {
    var _e = A.allocUnsafe(4);
    return _e.writeUInt32BE(J, 0), _e;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(A, G) {
    for (var J = A.length, _e = -1; ++_e < J; )
      A[_e] ^= G[_e];
    return A;
  }), xor;
}
var bn$1 = { exports: {} };
bn$1.exports;
var hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(I) {
    (function(A, G) {
      function J(Se, t) {
        if (!Se) throw new Error(t || "Assertion failed");
      }
      function _e(Se, t) {
        Se.super_ = t;
        var h = function() {
        };
        h.prototype = t.prototype, Se.prototype = new h(), Se.prototype.constructor = Se;
      }
      function H(Se, t, h) {
        if (H.isBN(Se))
          return Se;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, Se !== null && ((t === "le" || t === "be") && (h = t, t = 10), this._init(Se || 0, t || 10, h || "be"));
      }
      typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
      var De;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = require$$0$3.Buffer;
      } catch {
      }
      H.isBN = function(t) {
        return t instanceof H ? !0 : t !== null && typeof t == "object" && t.constructor.wordSize === H.wordSize && Array.isArray(t.words);
      }, H.max = function(t, h) {
        return t.cmp(h) > 0 ? t : h;
      }, H.min = function(t, h) {
        return t.cmp(h) < 0 ? t : h;
      }, H.prototype._init = function(t, h, B) {
        if (typeof t == "number")
          return this._initNumber(t, h, B);
        if (typeof t == "object")
          return this._initArray(t, h, B);
        h === "hex" && (h = 16), J(h === (h | 0) && h >= 2 && h <= 36), t = t.toString().replace(/\s+/g, "");
        var Z = 0;
        t[0] === "-" && (Z++, this.negative = 1), Z < t.length && (h === 16 ? this._parseHex(t, Z, B) : (this._parseBase(t, h, Z), B === "le" && this._initArray(this.toArray(), h, B)));
      }, H.prototype._initNumber = function(t, h, B) {
        t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [t & 67108863], this.length = 1) : t < 4503599627370496 ? (this.words = [
          t & 67108863,
          t / 67108864 & 67108863
        ], this.length = 2) : (J(t < 9007199254740992), this.words = [
          t & 67108863,
          t / 67108864 & 67108863,
          1
        ], this.length = 3), B === "le" && this._initArray(this.toArray(), h, B);
      }, H.prototype._initArray = function(t, h, B) {
        if (J(typeof t.length == "number"), t.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve, ge, xe = 0;
        if (B === "be")
          for (Z = t.length - 1, ve = 0; Z >= 0; Z -= 3)
            ge = t[Z] | t[Z - 1] << 8 | t[Z - 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        else if (B === "le")
          for (Z = 0, ve = 0; Z < t.length; Z += 3)
            ge = t[Z] | t[Z + 1] << 8 | t[Z + 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
        return this.strip();
      };
      function Ie(Se, t) {
        var h = Se.charCodeAt(t);
        return h >= 65 && h <= 70 ? h - 55 : h >= 97 && h <= 102 ? h - 87 : h - 48 & 15;
      }
      function qe(Se, t, h) {
        var B = Ie(Se, h);
        return h - 1 >= t && (B |= Ie(Se, h - 1) << 4), B;
      }
      H.prototype._parseHex = function(t, h, B) {
        this.length = Math.ceil((t.length - h) / 6), this.words = new Array(this.length);
        for (var Z = 0; Z < this.length; Z++)
          this.words[Z] = 0;
        var ve = 0, ge = 0, xe;
        if (B === "be")
          for (Z = t.length - 1; Z >= h; Z -= 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        else {
          var X = t.length - h;
          for (Z = X % 2 === 0 ? h + 1 : h; Z < t.length; Z += 2)
            xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
        }
        this.strip();
      };
      function Te(Se, t, h, B) {
        for (var Z = 0, ve = Math.min(Se.length, h), ge = t; ge < ve; ge++) {
          var xe = Se.charCodeAt(ge) - 48;
          Z *= B, xe >= 49 ? Z += xe - 49 + 10 : xe >= 17 ? Z += xe - 17 + 10 : Z += xe;
        }
        return Z;
      }
      H.prototype._parseBase = function(t, h, B) {
        this.words = [0], this.length = 1;
        for (var Z = 0, ve = 1; ve <= 67108863; ve *= h)
          Z++;
        Z--, ve = ve / h | 0;
        for (var ge = t.length - B, xe = ge % Z, X = Math.min(ge, ge - xe) + B, a = 0, Y = B; Y < X; Y += Z)
          a = Te(t, Y, Y + Z, h), this.imuln(ve), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (xe !== 0) {
          var Ne = 1;
          for (a = Te(t, Y, t.length, h), Y = 0; Y < xe; Y++)
            Ne *= h;
          this.imuln(Ne), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, H.prototype.copy = function(t) {
        t.words = new Array(this.length);
        for (var h = 0; h < this.length; h++)
          t.words[h] = this.words[h];
        t.length = this.length, t.negative = this.negative, t.red = this.red;
      }, H.prototype.clone = function() {
        var t = new H(null);
        return this.copy(t), t;
      }, H.prototype._expand = function(t) {
        for (; this.length < t; )
          this.words[this.length++] = 0;
        return this;
      }, H.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, H.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, H.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var Ee = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], Oe = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Le = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      H.prototype.toString = function(t, h) {
        t = t || 10, h = h | 0 || 1;
        var B;
        if (t === 16 || t === "hex") {
          B = "";
          for (var Z = 0, ve = 0, ge = 0; ge < this.length; ge++) {
            var xe = this.words[ge], X = ((xe << Z | ve) & 16777215).toString(16);
            ve = xe >>> 24 - Z & 16777215, ve !== 0 || ge !== this.length - 1 ? B = Ee[6 - X.length] + X + B : B = X + B, Z += 2, Z >= 26 && (Z -= 26, ge--);
          }
          for (ve !== 0 && (B = ve.toString(16) + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        if (t === (t | 0) && t >= 2 && t <= 36) {
          var a = Oe[t], Y = Le[t];
          B = "";
          var Ne = this.clone();
          for (Ne.negative = 0; !Ne.isZero(); ) {
            var Ke = Ne.modn(Y).toString(t);
            Ne = Ne.idivn(Y), Ne.isZero() ? B = Ke + B : B = Ee[a - Ke.length] + Ke + B;
          }
          for (this.isZero() && (B = "0" + B); B.length % h !== 0; )
            B = "0" + B;
          return this.negative !== 0 && (B = "-" + B), B;
        }
        J(!1, "Base should be between 2 and 36");
      }, H.prototype.toNumber = function() {
        var t = this.words[0];
        return this.length === 2 ? t += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? t += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -t : t;
      }, H.prototype.toJSON = function() {
        return this.toString(16);
      }, H.prototype.toBuffer = function(t, h) {
        return J(typeof De < "u"), this.toArrayLike(De, t, h);
      }, H.prototype.toArray = function(t, h) {
        return this.toArrayLike(Array, t, h);
      }, H.prototype.toArrayLike = function(t, h, B) {
        var Z = this.byteLength(), ve = B || Math.max(1, Z);
        J(Z <= ve, "byte array longer than desired length"), J(ve > 0, "Requested array length <= 0"), this.strip();
        var ge = h === "le", xe = new t(ve), X, a, Y = this.clone();
        if (ge) {
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[a] = X;
          for (; a < ve; a++)
            xe[a] = 0;
        } else {
          for (a = 0; a < ve - Z; a++)
            xe[a] = 0;
          for (a = 0; !Y.isZero(); a++)
            X = Y.andln(255), Y.iushrn(8), xe[ve - a - 1] = X;
        }
        return xe;
      }, Math.clz32 ? H.prototype._countBits = function(t) {
        return 32 - Math.clz32(t);
      } : H.prototype._countBits = function(t) {
        var h = t, B = 0;
        return h >= 4096 && (B += 13, h >>>= 13), h >= 64 && (B += 7, h >>>= 7), h >= 8 && (B += 4, h >>>= 4), h >= 2 && (B += 2, h >>>= 2), B + h;
      }, H.prototype._zeroBits = function(t) {
        if (t === 0) return 26;
        var h = t, B = 0;
        return h & 8191 || (B += 13, h >>>= 13), h & 127 || (B += 7, h >>>= 7), h & 15 || (B += 4, h >>>= 4), h & 3 || (B += 2, h >>>= 2), h & 1 || B++, B;
      }, H.prototype.bitLength = function() {
        var t = this.words[this.length - 1], h = this._countBits(t);
        return (this.length - 1) * 26 + h;
      };
      function ke(Se) {
        for (var t = new Array(Se.bitLength()), h = 0; h < t.length; h++) {
          var B = h / 26 | 0, Z = h % 26;
          t[h] = (Se.words[B] & 1 << Z) >>> Z;
        }
        return t;
      }
      H.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var t = 0, h = 0; h < this.length; h++) {
          var B = this._zeroBits(this.words[h]);
          if (t += B, B !== 26) break;
        }
        return t;
      }, H.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, H.prototype.toTwos = function(t) {
        return this.negative !== 0 ? this.abs().inotn(t).iaddn(1) : this.clone();
      }, H.prototype.fromTwos = function(t) {
        return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
      }, H.prototype.isNeg = function() {
        return this.negative !== 0;
      }, H.prototype.neg = function() {
        return this.clone().ineg();
      }, H.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, H.prototype.iuor = function(t) {
        for (; this.length < t.length; )
          this.words[this.length++] = 0;
        for (var h = 0; h < t.length; h++)
          this.words[h] = this.words[h] | t.words[h];
        return this.strip();
      }, H.prototype.ior = function(t) {
        return J((this.negative | t.negative) === 0), this.iuor(t);
      }, H.prototype.or = function(t) {
        return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
      }, H.prototype.uor = function(t) {
        return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
      }, H.prototype.iuand = function(t) {
        var h;
        this.length > t.length ? h = t : h = this;
        for (var B = 0; B < h.length; B++)
          this.words[B] = this.words[B] & t.words[B];
        return this.length = h.length, this.strip();
      }, H.prototype.iand = function(t) {
        return J((this.negative | t.negative) === 0), this.iuand(t);
      }, H.prototype.and = function(t) {
        return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
      }, H.prototype.uand = function(t) {
        return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
      }, H.prototype.iuxor = function(t) {
        var h, B;
        this.length > t.length ? (h = this, B = t) : (h = t, B = this);
        for (var Z = 0; Z < B.length; Z++)
          this.words[Z] = h.words[Z] ^ B.words[Z];
        if (this !== h)
          for (; Z < h.length; Z++)
            this.words[Z] = h.words[Z];
        return this.length = h.length, this.strip();
      }, H.prototype.ixor = function(t) {
        return J((this.negative | t.negative) === 0), this.iuxor(t);
      }, H.prototype.xor = function(t) {
        return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
      }, H.prototype.uxor = function(t) {
        return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
      }, H.prototype.inotn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = Math.ceil(t / 26) | 0, B = t % 26;
        this._expand(h), B > 0 && h--;
        for (var Z = 0; Z < h; Z++)
          this.words[Z] = ~this.words[Z] & 67108863;
        return B > 0 && (this.words[Z] = ~this.words[Z] & 67108863 >> 26 - B), this.strip();
      }, H.prototype.notn = function(t) {
        return this.clone().inotn(t);
      }, H.prototype.setn = function(t, h) {
        J(typeof t == "number" && t >= 0);
        var B = t / 26 | 0, Z = t % 26;
        return this._expand(B + 1), h ? this.words[B] = this.words[B] | 1 << Z : this.words[B] = this.words[B] & ~(1 << Z), this.strip();
      }, H.prototype.iadd = function(t) {
        var h;
        if (this.negative !== 0 && t.negative === 0)
          return this.negative = 0, h = this.isub(t), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && t.negative !== 0)
          return t.negative = 0, h = this.isub(t), t.negative = 1, h._normSign();
        var B, Z;
        this.length > t.length ? (B = this, Z = t) : (B = t, Z = this);
        for (var ve = 0, ge = 0; ge < Z.length; ge++)
          h = (B.words[ge] | 0) + (Z.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        for (; ve !== 0 && ge < B.length; ge++)
          h = (B.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
        if (this.length = B.length, ve !== 0)
          this.words[this.length] = ve, this.length++;
        else if (B !== this)
          for (; ge < B.length; ge++)
            this.words[ge] = B.words[ge];
        return this;
      }, H.prototype.add = function(t) {
        var h;
        return t.negative !== 0 && this.negative === 0 ? (t.negative = 0, h = this.sub(t), t.negative ^= 1, h) : t.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = t.sub(this), this.negative = 1, h) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
      }, H.prototype.isub = function(t) {
        if (t.negative !== 0) {
          t.negative = 0;
          var h = this.iadd(t);
          return t.negative = 1, h._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
        var B = this.cmp(t);
        if (B === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Z, ve;
        B > 0 ? (Z = this, ve = t) : (Z = t, ve = this);
        for (var ge = 0, xe = 0; xe < ve.length; xe++)
          h = (Z.words[xe] | 0) - (ve.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        for (; ge !== 0 && xe < Z.length; xe++)
          h = (Z.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
        if (ge === 0 && xe < Z.length && Z !== this)
          for (; xe < Z.length; xe++)
            this.words[xe] = Z.words[xe];
        return this.length = Math.max(this.length, xe), Z !== this && (this.negative = 1), this.strip();
      }, H.prototype.sub = function(t) {
        return this.clone().isub(t);
      };
      function Fe(Se, t, h) {
        h.negative = t.negative ^ Se.negative;
        var B = Se.length + t.length | 0;
        h.length = B, B = B - 1 | 0;
        var Z = Se.words[0] | 0, ve = t.words[0] | 0, ge = Z * ve, xe = ge & 67108863, X = ge / 67108864 | 0;
        h.words[0] = xe;
        for (var a = 1; a < B; a++) {
          for (var Y = X >>> 26, Ne = X & 67108863, Ke = Math.min(a, t.length - 1), tt = Math.max(0, a - Se.length + 1); tt <= Ke; tt++) {
            var We = a - tt | 0;
            Z = Se.words[We] | 0, ve = t.words[tt] | 0, ge = Z * ve + Ne, Y += ge / 67108864 | 0, Ne = ge & 67108863;
          }
          h.words[a] = Ne | 0, X = Y | 0;
        }
        return X !== 0 ? h.words[a] = X | 0 : h.length--, h.strip();
      }
      var Ge = function(t, h, B) {
        var Z = t.words, ve = h.words, ge = B.words, xe = 0, X, a, Y, Ne = Z[0] | 0, Ke = Ne & 8191, tt = Ne >>> 13, We = Z[1] | 0, ot = We & 8191, He = We >>> 13, Qe = Z[2] | 0, nt = Qe & 8191, je = Qe >>> 13, it = Z[3] | 0, st = it & 8191, gt = it >>> 13, It = Z[4] | 0, At = It & 8191, Et = It >>> 13, ei = Z[5] | 0, Xt = ei & 8191, _t = ei >>> 13, ni = Z[6] | 0, Ct = ni & 8191, Wt = ni >>> 13, ii = Z[7] | 0, Pt = ii & 8191, Rt = ii >>> 13, ai = Z[8] | 0, Nt = ai & 8191, qt = ai >>> 13, oi = Z[9] | 0, ct = oi & 8191, Ze = oi >>> 13, at = ve[0] | 0, dt = at & 8191, yt = at >>> 13, St = ve[1] | 0, xt = St & 8191, Vt = St >>> 13, ci = ve[2] | 0, Qt = ci & 8191, rr = ci >>> 13, ui = ve[3] | 0, Gr = ui & 8191, yr = ui >>> 13, pi = ve[4] | 0, wr = pi & 8191, _r = pi >>> 13, di = ve[5] | 0, Sr = di & 8191, Br = di >>> 13, vi = ve[6] | 0, gr = vi & 8191, $r = vi >>> 13, li = ve[7] | 0, Ir = li & 8191, Cr = li >>> 13, mi = ve[8] | 0, Pr = mi & 8191, Or = mi >>> 13, yi = ve[9] | 0, Zr = yi & 8191, Vr = yi >>> 13;
        B.negative = t.negative ^ h.negative, B.length = 19, X = Math.imul(Ke, dt), a = Math.imul(Ke, yt), a = a + Math.imul(tt, dt) | 0, Y = Math.imul(tt, yt);
        var bi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, X = Math.imul(ot, dt), a = Math.imul(ot, yt), a = a + Math.imul(He, dt) | 0, Y = Math.imul(He, yt), X = X + Math.imul(Ke, xt) | 0, a = a + Math.imul(Ke, Vt) | 0, a = a + Math.imul(tt, xt) | 0, Y = Y + Math.imul(tt, Vt) | 0;
        var Ai = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, X = Math.imul(nt, dt), a = Math.imul(nt, yt), a = a + Math.imul(je, dt) | 0, Y = Math.imul(je, yt), X = X + Math.imul(ot, xt) | 0, a = a + Math.imul(ot, Vt) | 0, a = a + Math.imul(He, xt) | 0, Y = Y + Math.imul(He, Vt) | 0, X = X + Math.imul(Ke, Qt) | 0, a = a + Math.imul(Ke, rr) | 0, a = a + Math.imul(tt, Qt) | 0, Y = Y + Math.imul(tt, rr) | 0;
        var Zi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, X = Math.imul(st, dt), a = Math.imul(st, yt), a = a + Math.imul(gt, dt) | 0, Y = Math.imul(gt, yt), X = X + Math.imul(nt, xt) | 0, a = a + Math.imul(nt, Vt) | 0, a = a + Math.imul(je, xt) | 0, Y = Y + Math.imul(je, Vt) | 0, X = X + Math.imul(ot, Qt) | 0, a = a + Math.imul(ot, rr) | 0, a = a + Math.imul(He, Qt) | 0, Y = Y + Math.imul(He, rr) | 0, X = X + Math.imul(Ke, Gr) | 0, a = a + Math.imul(Ke, yr) | 0, a = a + Math.imul(tt, Gr) | 0, Y = Y + Math.imul(tt, yr) | 0;
        var Ji = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, X = Math.imul(At, dt), a = Math.imul(At, yt), a = a + Math.imul(Et, dt) | 0, Y = Math.imul(Et, yt), X = X + Math.imul(st, xt) | 0, a = a + Math.imul(st, Vt) | 0, a = a + Math.imul(gt, xt) | 0, Y = Y + Math.imul(gt, Vt) | 0, X = X + Math.imul(nt, Qt) | 0, a = a + Math.imul(nt, rr) | 0, a = a + Math.imul(je, Qt) | 0, Y = Y + Math.imul(je, rr) | 0, X = X + Math.imul(ot, Gr) | 0, a = a + Math.imul(ot, yr) | 0, a = a + Math.imul(He, Gr) | 0, Y = Y + Math.imul(He, yr) | 0, X = X + Math.imul(Ke, wr) | 0, a = a + Math.imul(Ke, _r) | 0, a = a + Math.imul(tt, wr) | 0, Y = Y + Math.imul(tt, _r) | 0;
        var Vi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, X = Math.imul(Xt, dt), a = Math.imul(Xt, yt), a = a + Math.imul(_t, dt) | 0, Y = Math.imul(_t, yt), X = X + Math.imul(At, xt) | 0, a = a + Math.imul(At, Vt) | 0, a = a + Math.imul(Et, xt) | 0, Y = Y + Math.imul(Et, Vt) | 0, X = X + Math.imul(st, Qt) | 0, a = a + Math.imul(st, rr) | 0, a = a + Math.imul(gt, Qt) | 0, Y = Y + Math.imul(gt, rr) | 0, X = X + Math.imul(nt, Gr) | 0, a = a + Math.imul(nt, yr) | 0, a = a + Math.imul(je, Gr) | 0, Y = Y + Math.imul(je, yr) | 0, X = X + Math.imul(ot, wr) | 0, a = a + Math.imul(ot, _r) | 0, a = a + Math.imul(He, wr) | 0, Y = Y + Math.imul(He, _r) | 0, X = X + Math.imul(Ke, Sr) | 0, a = a + Math.imul(Ke, Br) | 0, a = a + Math.imul(tt, Sr) | 0, Y = Y + Math.imul(tt, Br) | 0;
        var Yi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, X = Math.imul(Ct, dt), a = Math.imul(Ct, yt), a = a + Math.imul(Wt, dt) | 0, Y = Math.imul(Wt, yt), X = X + Math.imul(Xt, xt) | 0, a = a + Math.imul(Xt, Vt) | 0, a = a + Math.imul(_t, xt) | 0, Y = Y + Math.imul(_t, Vt) | 0, X = X + Math.imul(At, Qt) | 0, a = a + Math.imul(At, rr) | 0, a = a + Math.imul(Et, Qt) | 0, Y = Y + Math.imul(Et, rr) | 0, X = X + Math.imul(st, Gr) | 0, a = a + Math.imul(st, yr) | 0, a = a + Math.imul(gt, Gr) | 0, Y = Y + Math.imul(gt, yr) | 0, X = X + Math.imul(nt, wr) | 0, a = a + Math.imul(nt, _r) | 0, a = a + Math.imul(je, wr) | 0, Y = Y + Math.imul(je, _r) | 0, X = X + Math.imul(ot, Sr) | 0, a = a + Math.imul(ot, Br) | 0, a = a + Math.imul(He, Sr) | 0, Y = Y + Math.imul(He, Br) | 0, X = X + Math.imul(Ke, gr) | 0, a = a + Math.imul(Ke, $r) | 0, a = a + Math.imul(tt, gr) | 0, Y = Y + Math.imul(tt, $r) | 0;
        var Xi = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, X = Math.imul(Pt, dt), a = Math.imul(Pt, yt), a = a + Math.imul(Rt, dt) | 0, Y = Math.imul(Rt, yt), X = X + Math.imul(Ct, xt) | 0, a = a + Math.imul(Ct, Vt) | 0, a = a + Math.imul(Wt, xt) | 0, Y = Y + Math.imul(Wt, Vt) | 0, X = X + Math.imul(Xt, Qt) | 0, a = a + Math.imul(Xt, rr) | 0, a = a + Math.imul(_t, Qt) | 0, Y = Y + Math.imul(_t, rr) | 0, X = X + Math.imul(At, Gr) | 0, a = a + Math.imul(At, yr) | 0, a = a + Math.imul(Et, Gr) | 0, Y = Y + Math.imul(Et, yr) | 0, X = X + Math.imul(st, wr) | 0, a = a + Math.imul(st, _r) | 0, a = a + Math.imul(gt, wr) | 0, Y = Y + Math.imul(gt, _r) | 0, X = X + Math.imul(nt, Sr) | 0, a = a + Math.imul(nt, Br) | 0, a = a + Math.imul(je, Sr) | 0, Y = Y + Math.imul(je, Br) | 0, X = X + Math.imul(ot, gr) | 0, a = a + Math.imul(ot, $r) | 0, a = a + Math.imul(He, gr) | 0, Y = Y + Math.imul(He, $r) | 0, X = X + Math.imul(Ke, Ir) | 0, a = a + Math.imul(Ke, Cr) | 0, a = a + Math.imul(tt, Ir) | 0, Y = Y + Math.imul(tt, Cr) | 0;
        var en = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, X = Math.imul(Nt, dt), a = Math.imul(Nt, yt), a = a + Math.imul(qt, dt) | 0, Y = Math.imul(qt, yt), X = X + Math.imul(Pt, xt) | 0, a = a + Math.imul(Pt, Vt) | 0, a = a + Math.imul(Rt, xt) | 0, Y = Y + Math.imul(Rt, Vt) | 0, X = X + Math.imul(Ct, Qt) | 0, a = a + Math.imul(Ct, rr) | 0, a = a + Math.imul(Wt, Qt) | 0, Y = Y + Math.imul(Wt, rr) | 0, X = X + Math.imul(Xt, Gr) | 0, a = a + Math.imul(Xt, yr) | 0, a = a + Math.imul(_t, Gr) | 0, Y = Y + Math.imul(_t, yr) | 0, X = X + Math.imul(At, wr) | 0, a = a + Math.imul(At, _r) | 0, a = a + Math.imul(Et, wr) | 0, Y = Y + Math.imul(Et, _r) | 0, X = X + Math.imul(st, Sr) | 0, a = a + Math.imul(st, Br) | 0, a = a + Math.imul(gt, Sr) | 0, Y = Y + Math.imul(gt, Br) | 0, X = X + Math.imul(nt, gr) | 0, a = a + Math.imul(nt, $r) | 0, a = a + Math.imul(je, gr) | 0, Y = Y + Math.imul(je, $r) | 0, X = X + Math.imul(ot, Ir) | 0, a = a + Math.imul(ot, Cr) | 0, a = a + Math.imul(He, Ir) | 0, Y = Y + Math.imul(He, Cr) | 0, X = X + Math.imul(Ke, Pr) | 0, a = a + Math.imul(Ke, Or) | 0, a = a + Math.imul(tt, Pr) | 0, Y = Y + Math.imul(tt, Or) | 0;
        var hn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, X = Math.imul(ct, dt), a = Math.imul(ct, yt), a = a + Math.imul(Ze, dt) | 0, Y = Math.imul(Ze, yt), X = X + Math.imul(Nt, xt) | 0, a = a + Math.imul(Nt, Vt) | 0, a = a + Math.imul(qt, xt) | 0, Y = Y + Math.imul(qt, Vt) | 0, X = X + Math.imul(Pt, Qt) | 0, a = a + Math.imul(Pt, rr) | 0, a = a + Math.imul(Rt, Qt) | 0, Y = Y + Math.imul(Rt, rr) | 0, X = X + Math.imul(Ct, Gr) | 0, a = a + Math.imul(Ct, yr) | 0, a = a + Math.imul(Wt, Gr) | 0, Y = Y + Math.imul(Wt, yr) | 0, X = X + Math.imul(Xt, wr) | 0, a = a + Math.imul(Xt, _r) | 0, a = a + Math.imul(_t, wr) | 0, Y = Y + Math.imul(_t, _r) | 0, X = X + Math.imul(At, Sr) | 0, a = a + Math.imul(At, Br) | 0, a = a + Math.imul(Et, Sr) | 0, Y = Y + Math.imul(Et, Br) | 0, X = X + Math.imul(st, gr) | 0, a = a + Math.imul(st, $r) | 0, a = a + Math.imul(gt, gr) | 0, Y = Y + Math.imul(gt, $r) | 0, X = X + Math.imul(nt, Ir) | 0, a = a + Math.imul(nt, Cr) | 0, a = a + Math.imul(je, Ir) | 0, Y = Y + Math.imul(je, Cr) | 0, X = X + Math.imul(ot, Pr) | 0, a = a + Math.imul(ot, Or) | 0, a = a + Math.imul(He, Pr) | 0, Y = Y + Math.imul(He, Or) | 0, X = X + Math.imul(Ke, Zr) | 0, a = a + Math.imul(Ke, Vr) | 0, a = a + Math.imul(tt, Zr) | 0, Y = Y + Math.imul(tt, Vr) | 0;
        var tn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, X = Math.imul(ct, xt), a = Math.imul(ct, Vt), a = a + Math.imul(Ze, xt) | 0, Y = Math.imul(Ze, Vt), X = X + Math.imul(Nt, Qt) | 0, a = a + Math.imul(Nt, rr) | 0, a = a + Math.imul(qt, Qt) | 0, Y = Y + Math.imul(qt, rr) | 0, X = X + Math.imul(Pt, Gr) | 0, a = a + Math.imul(Pt, yr) | 0, a = a + Math.imul(Rt, Gr) | 0, Y = Y + Math.imul(Rt, yr) | 0, X = X + Math.imul(Ct, wr) | 0, a = a + Math.imul(Ct, _r) | 0, a = a + Math.imul(Wt, wr) | 0, Y = Y + Math.imul(Wt, _r) | 0, X = X + Math.imul(Xt, Sr) | 0, a = a + Math.imul(Xt, Br) | 0, a = a + Math.imul(_t, Sr) | 0, Y = Y + Math.imul(_t, Br) | 0, X = X + Math.imul(At, gr) | 0, a = a + Math.imul(At, $r) | 0, a = a + Math.imul(Et, gr) | 0, Y = Y + Math.imul(Et, $r) | 0, X = X + Math.imul(st, Ir) | 0, a = a + Math.imul(st, Cr) | 0, a = a + Math.imul(gt, Ir) | 0, Y = Y + Math.imul(gt, Cr) | 0, X = X + Math.imul(nt, Pr) | 0, a = a + Math.imul(nt, Or) | 0, a = a + Math.imul(je, Pr) | 0, Y = Y + Math.imul(je, Or) | 0, X = X + Math.imul(ot, Zr) | 0, a = a + Math.imul(ot, Vr) | 0, a = a + Math.imul(He, Zr) | 0, Y = Y + Math.imul(He, Vr) | 0;
        var un = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, X = Math.imul(ct, Qt), a = Math.imul(ct, rr), a = a + Math.imul(Ze, Qt) | 0, Y = Math.imul(Ze, rr), X = X + Math.imul(Nt, Gr) | 0, a = a + Math.imul(Nt, yr) | 0, a = a + Math.imul(qt, Gr) | 0, Y = Y + Math.imul(qt, yr) | 0, X = X + Math.imul(Pt, wr) | 0, a = a + Math.imul(Pt, _r) | 0, a = a + Math.imul(Rt, wr) | 0, Y = Y + Math.imul(Rt, _r) | 0, X = X + Math.imul(Ct, Sr) | 0, a = a + Math.imul(Ct, Br) | 0, a = a + Math.imul(Wt, Sr) | 0, Y = Y + Math.imul(Wt, Br) | 0, X = X + Math.imul(Xt, gr) | 0, a = a + Math.imul(Xt, $r) | 0, a = a + Math.imul(_t, gr) | 0, Y = Y + Math.imul(_t, $r) | 0, X = X + Math.imul(At, Ir) | 0, a = a + Math.imul(At, Cr) | 0, a = a + Math.imul(Et, Ir) | 0, Y = Y + Math.imul(Et, Cr) | 0, X = X + Math.imul(st, Pr) | 0, a = a + Math.imul(st, Or) | 0, a = a + Math.imul(gt, Pr) | 0, Y = Y + Math.imul(gt, Or) | 0, X = X + Math.imul(nt, Zr) | 0, a = a + Math.imul(nt, Vr) | 0, a = a + Math.imul(je, Zr) | 0, Y = Y + Math.imul(je, Vr) | 0;
        var cn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, X = Math.imul(ct, Gr), a = Math.imul(ct, yr), a = a + Math.imul(Ze, Gr) | 0, Y = Math.imul(Ze, yr), X = X + Math.imul(Nt, wr) | 0, a = a + Math.imul(Nt, _r) | 0, a = a + Math.imul(qt, wr) | 0, Y = Y + Math.imul(qt, _r) | 0, X = X + Math.imul(Pt, Sr) | 0, a = a + Math.imul(Pt, Br) | 0, a = a + Math.imul(Rt, Sr) | 0, Y = Y + Math.imul(Rt, Br) | 0, X = X + Math.imul(Ct, gr) | 0, a = a + Math.imul(Ct, $r) | 0, a = a + Math.imul(Wt, gr) | 0, Y = Y + Math.imul(Wt, $r) | 0, X = X + Math.imul(Xt, Ir) | 0, a = a + Math.imul(Xt, Cr) | 0, a = a + Math.imul(_t, Ir) | 0, Y = Y + Math.imul(_t, Cr) | 0, X = X + Math.imul(At, Pr) | 0, a = a + Math.imul(At, Or) | 0, a = a + Math.imul(Et, Pr) | 0, Y = Y + Math.imul(Et, Or) | 0, X = X + Math.imul(st, Zr) | 0, a = a + Math.imul(st, Vr) | 0, a = a + Math.imul(gt, Zr) | 0, Y = Y + Math.imul(gt, Vr) | 0;
        var ln = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, X = Math.imul(ct, wr), a = Math.imul(ct, _r), a = a + Math.imul(Ze, wr) | 0, Y = Math.imul(Ze, _r), X = X + Math.imul(Nt, Sr) | 0, a = a + Math.imul(Nt, Br) | 0, a = a + Math.imul(qt, Sr) | 0, Y = Y + Math.imul(qt, Br) | 0, X = X + Math.imul(Pt, gr) | 0, a = a + Math.imul(Pt, $r) | 0, a = a + Math.imul(Rt, gr) | 0, Y = Y + Math.imul(Rt, $r) | 0, X = X + Math.imul(Ct, Ir) | 0, a = a + Math.imul(Ct, Cr) | 0, a = a + Math.imul(Wt, Ir) | 0, Y = Y + Math.imul(Wt, Cr) | 0, X = X + Math.imul(Xt, Pr) | 0, a = a + Math.imul(Xt, Or) | 0, a = a + Math.imul(_t, Pr) | 0, Y = Y + Math.imul(_t, Or) | 0, X = X + Math.imul(At, Zr) | 0, a = a + Math.imul(At, Vr) | 0, a = a + Math.imul(Et, Zr) | 0, Y = Y + Math.imul(Et, Vr) | 0;
        var an = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, X = Math.imul(ct, Sr), a = Math.imul(ct, Br), a = a + Math.imul(Ze, Sr) | 0, Y = Math.imul(Ze, Br), X = X + Math.imul(Nt, gr) | 0, a = a + Math.imul(Nt, $r) | 0, a = a + Math.imul(qt, gr) | 0, Y = Y + Math.imul(qt, $r) | 0, X = X + Math.imul(Pt, Ir) | 0, a = a + Math.imul(Pt, Cr) | 0, a = a + Math.imul(Rt, Ir) | 0, Y = Y + Math.imul(Rt, Cr) | 0, X = X + Math.imul(Ct, Pr) | 0, a = a + Math.imul(Ct, Or) | 0, a = a + Math.imul(Wt, Pr) | 0, Y = Y + Math.imul(Wt, Or) | 0, X = X + Math.imul(Xt, Zr) | 0, a = a + Math.imul(Xt, Vr) | 0, a = a + Math.imul(_t, Zr) | 0, Y = Y + Math.imul(_t, Vr) | 0;
        var fn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, X = Math.imul(ct, gr), a = Math.imul(ct, $r), a = a + Math.imul(Ze, gr) | 0, Y = Math.imul(Ze, $r), X = X + Math.imul(Nt, Ir) | 0, a = a + Math.imul(Nt, Cr) | 0, a = a + Math.imul(qt, Ir) | 0, Y = Y + Math.imul(qt, Cr) | 0, X = X + Math.imul(Pt, Pr) | 0, a = a + Math.imul(Pt, Or) | 0, a = a + Math.imul(Rt, Pr) | 0, Y = Y + Math.imul(Rt, Or) | 0, X = X + Math.imul(Ct, Zr) | 0, a = a + Math.imul(Ct, Vr) | 0, a = a + Math.imul(Wt, Zr) | 0, Y = Y + Math.imul(Wt, Vr) | 0;
        var sn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, X = Math.imul(ct, Ir), a = Math.imul(ct, Cr), a = a + Math.imul(Ze, Ir) | 0, Y = Math.imul(Ze, Cr), X = X + Math.imul(Nt, Pr) | 0, a = a + Math.imul(Nt, Or) | 0, a = a + Math.imul(qt, Pr) | 0, Y = Y + Math.imul(qt, Or) | 0, X = X + Math.imul(Pt, Zr) | 0, a = a + Math.imul(Pt, Vr) | 0, a = a + Math.imul(Rt, Zr) | 0, Y = Y + Math.imul(Rt, Vr) | 0;
        var dn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, X = Math.imul(ct, Pr), a = Math.imul(ct, Or), a = a + Math.imul(Ze, Pr) | 0, Y = Math.imul(Ze, Or), X = X + Math.imul(Nt, Zr) | 0, a = a + Math.imul(Nt, Vr) | 0, a = a + Math.imul(qt, Zr) | 0, Y = Y + Math.imul(qt, Vr) | 0;
        var pn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        xe = (Y + (a >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, X = Math.imul(ct, Zr), a = Math.imul(ct, Vr), a = a + Math.imul(Ze, Zr) | 0, Y = Math.imul(Ze, Vr);
        var vn = (xe + X | 0) + ((a & 8191) << 13) | 0;
        return xe = (Y + (a >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, ge[0] = bi, ge[1] = Ai, ge[2] = Zi, ge[3] = Ji, ge[4] = Vi, ge[5] = Yi, ge[6] = Xi, ge[7] = en, ge[8] = hn, ge[9] = tn, ge[10] = un, ge[11] = cn, ge[12] = ln, ge[13] = an, ge[14] = fn, ge[15] = sn, ge[16] = dn, ge[17] = pn, ge[18] = vn, xe !== 0 && (ge[19] = xe, B.length++), B;
      };
      Math.imul || (Ge = Fe);
      function et(Se, t, h) {
        h.negative = t.negative ^ Se.negative, h.length = Se.length + t.length;
        for (var B = 0, Z = 0, ve = 0; ve < h.length - 1; ve++) {
          var ge = Z;
          Z = 0;
          for (var xe = B & 67108863, X = Math.min(ve, t.length - 1), a = Math.max(0, ve - Se.length + 1); a <= X; a++) {
            var Y = ve - a, Ne = Se.words[Y] | 0, Ke = t.words[a] | 0, tt = Ne * Ke, We = tt & 67108863;
            ge = ge + (tt / 67108864 | 0) | 0, We = We + xe | 0, xe = We & 67108863, ge = ge + (We >>> 26) | 0, Z += ge >>> 26, ge &= 67108863;
          }
          h.words[ve] = xe, B = ge, ge = Z;
        }
        return B !== 0 ? h.words[ve] = B : h.length--, h.strip();
      }
      function Ve(Se, t, h) {
        var B = new Je();
        return B.mulp(Se, t, h);
      }
      H.prototype.mulTo = function(t, h) {
        var B, Z = this.length + t.length;
        return this.length === 10 && t.length === 10 ? B = Ge(this, t, h) : Z < 63 ? B = Fe(this, t, h) : Z < 1024 ? B = et(this, t, h) : B = Ve(this, t, h), B;
      };
      function Je(Se, t) {
        this.x = Se, this.y = t;
      }
      Je.prototype.makeRBT = function(t) {
        for (var h = new Array(t), B = H.prototype._countBits(t) - 1, Z = 0; Z < t; Z++)
          h[Z] = this.revBin(Z, B, t);
        return h;
      }, Je.prototype.revBin = function(t, h, B) {
        if (t === 0 || t === B - 1) return t;
        for (var Z = 0, ve = 0; ve < h; ve++)
          Z |= (t & 1) << h - ve - 1, t >>= 1;
        return Z;
      }, Je.prototype.permute = function(t, h, B, Z, ve, ge) {
        for (var xe = 0; xe < ge; xe++)
          Z[xe] = h[t[xe]], ve[xe] = B[t[xe]];
      }, Je.prototype.transform = function(t, h, B, Z, ve, ge) {
        this.permute(ge, t, h, B, Z, ve);
        for (var xe = 1; xe < ve; xe <<= 1)
          for (var X = xe << 1, a = Math.cos(2 * Math.PI / X), Y = Math.sin(2 * Math.PI / X), Ne = 0; Ne < ve; Ne += X)
            for (var Ke = a, tt = Y, We = 0; We < xe; We++) {
              var ot = B[Ne + We], He = Z[Ne + We], Qe = B[Ne + We + xe], nt = Z[Ne + We + xe], je = Ke * Qe - tt * nt;
              nt = Ke * nt + tt * Qe, Qe = je, B[Ne + We] = ot + Qe, Z[Ne + We] = He + nt, B[Ne + We + xe] = ot - Qe, Z[Ne + We + xe] = He - nt, We !== X && (je = a * Ke - Y * tt, tt = a * tt + Y * Ke, Ke = je);
            }
      }, Je.prototype.guessLen13b = function(t, h) {
        var B = Math.max(h, t) | 1, Z = B & 1, ve = 0;
        for (B = B / 2 | 0; B; B = B >>> 1)
          ve++;
        return 1 << ve + 1 + Z;
      }, Je.prototype.conjugate = function(t, h, B) {
        if (!(B <= 1))
          for (var Z = 0; Z < B / 2; Z++) {
            var ve = t[Z];
            t[Z] = t[B - Z - 1], t[B - Z - 1] = ve, ve = h[Z], h[Z] = -h[B - Z - 1], h[B - Z - 1] = -ve;
          }
      }, Je.prototype.normalize13b = function(t, h) {
        for (var B = 0, Z = 0; Z < h / 2; Z++) {
          var ve = Math.round(t[2 * Z + 1] / h) * 8192 + Math.round(t[2 * Z] / h) + B;
          t[Z] = ve & 67108863, ve < 67108864 ? B = 0 : B = ve / 67108864 | 0;
        }
        return t;
      }, Je.prototype.convert13b = function(t, h, B, Z) {
        for (var ve = 0, ge = 0; ge < h; ge++)
          ve = ve + (t[ge] | 0), B[2 * ge] = ve & 8191, ve = ve >>> 13, B[2 * ge + 1] = ve & 8191, ve = ve >>> 13;
        for (ge = 2 * h; ge < Z; ++ge)
          B[ge] = 0;
        J(ve === 0), J((ve & -8192) === 0);
      }, Je.prototype.stub = function(t) {
        for (var h = new Array(t), B = 0; B < t; B++)
          h[B] = 0;
        return h;
      }, Je.prototype.mulp = function(t, h, B) {
        var Z = 2 * this.guessLen13b(t.length, h.length), ve = this.makeRBT(Z), ge = this.stub(Z), xe = new Array(Z), X = new Array(Z), a = new Array(Z), Y = new Array(Z), Ne = new Array(Z), Ke = new Array(Z), tt = B.words;
        tt.length = Z, this.convert13b(t.words, t.length, xe, Z), this.convert13b(h.words, h.length, Y, Z), this.transform(xe, ge, X, a, Z, ve), this.transform(Y, ge, Ne, Ke, Z, ve);
        for (var We = 0; We < Z; We++) {
          var ot = X[We] * Ne[We] - a[We] * Ke[We];
          a[We] = X[We] * Ke[We] + a[We] * Ne[We], X[We] = ot;
        }
        return this.conjugate(X, a, Z), this.transform(X, a, tt, ge, Z, ve), this.conjugate(tt, ge, Z), this.normalize13b(tt, Z), B.negative = t.negative ^ h.negative, B.length = t.length + h.length, B.strip();
      }, H.prototype.mul = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), this.mulTo(t, h);
      }, H.prototype.mulf = function(t) {
        var h = new H(null);
        return h.words = new Array(this.length + t.length), Ve(this, t, h);
      }, H.prototype.imul = function(t) {
        return this.clone().mulTo(t, this);
      }, H.prototype.imuln = function(t) {
        J(typeof t == "number"), J(t < 67108864);
        for (var h = 0, B = 0; B < this.length; B++) {
          var Z = (this.words[B] | 0) * t, ve = (Z & 67108863) + (h & 67108863);
          h >>= 26, h += Z / 67108864 | 0, h += ve >>> 26, this.words[B] = ve & 67108863;
        }
        return h !== 0 && (this.words[B] = h, this.length++), this;
      }, H.prototype.muln = function(t) {
        return this.clone().imuln(t);
      }, H.prototype.sqr = function() {
        return this.mul(this);
      }, H.prototype.isqr = function() {
        return this.imul(this.clone());
      }, H.prototype.pow = function(t) {
        var h = ke(t);
        if (h.length === 0) return new H(1);
        for (var B = this, Z = 0; Z < h.length && h[Z] === 0; Z++, B = B.sqr())
          ;
        if (++Z < h.length)
          for (var ve = B.sqr(); Z < h.length; Z++, ve = ve.sqr())
            h[Z] !== 0 && (B = B.mul(ve));
        return B;
      }, H.prototype.iushln = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 67108863 >>> 26 - h << 26 - h, ve;
        if (h !== 0) {
          var ge = 0;
          for (ve = 0; ve < this.length; ve++) {
            var xe = this.words[ve] & Z, X = (this.words[ve] | 0) - xe << h;
            this.words[ve] = X | ge, ge = xe >>> 26 - h;
          }
          ge && (this.words[ve] = ge, this.length++);
        }
        if (B !== 0) {
          for (ve = this.length - 1; ve >= 0; ve--)
            this.words[ve + B] = this.words[ve];
          for (ve = 0; ve < B; ve++)
            this.words[ve] = 0;
          this.length += B;
        }
        return this.strip();
      }, H.prototype.ishln = function(t) {
        return J(this.negative === 0), this.iushln(t);
      }, H.prototype.iushrn = function(t, h, B) {
        J(typeof t == "number" && t >= 0);
        var Z;
        h ? Z = (h - h % 26) / 26 : Z = 0;
        var ve = t % 26, ge = Math.min((t - ve) / 26, this.length), xe = 67108863 ^ 67108863 >>> ve << ve, X = B;
        if (Z -= ge, Z = Math.max(0, Z), X) {
          for (var a = 0; a < ge; a++)
            X.words[a] = this.words[a];
          X.length = ge;
        }
        if (ge !== 0) if (this.length > ge)
          for (this.length -= ge, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + ge];
        else
          this.words[0] = 0, this.length = 1;
        var Y = 0;
        for (a = this.length - 1; a >= 0 && (Y !== 0 || a >= Z); a--) {
          var Ne = this.words[a] | 0;
          this.words[a] = Y << 26 - ve | Ne >>> ve, Y = Ne & xe;
        }
        return X && Y !== 0 && (X.words[X.length++] = Y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, H.prototype.ishrn = function(t, h, B) {
        return J(this.negative === 0), this.iushrn(t, h, B);
      }, H.prototype.shln = function(t) {
        return this.clone().ishln(t);
      }, H.prototype.ushln = function(t) {
        return this.clone().iushln(t);
      }, H.prototype.shrn = function(t) {
        return this.clone().ishrn(t);
      }, H.prototype.ushrn = function(t) {
        return this.clone().iushrn(t);
      }, H.prototype.testn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B) return !1;
        var ve = this.words[B];
        return !!(ve & Z);
      }, H.prototype.imaskn = function(t) {
        J(typeof t == "number" && t >= 0);
        var h = t % 26, B = (t - h) / 26;
        if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= B)
          return this;
        if (h !== 0 && B++, this.length = Math.min(B, this.length), h !== 0) {
          var Z = 67108863 ^ 67108863 >>> h << h;
          this.words[this.length - 1] &= Z;
        }
        return this.strip();
      }, H.prototype.maskn = function(t) {
        return this.clone().imaskn(t);
      }, H.prototype.iaddn = function(t) {
        return J(typeof t == "number"), J(t < 67108864), t < 0 ? this.isubn(-t) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < t ? (this.words[0] = t - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
      }, H.prototype._iaddn = function(t) {
        this.words[0] += t;
        for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
          this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
        return this.length = Math.max(this.length, h + 1), this;
      }, H.prototype.isubn = function(t) {
        if (J(typeof t == "number"), J(t < 67108864), t < 0) return this.iaddn(-t);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(t), this.negative = 1, this;
        if (this.words[0] -= t, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var h = 0; h < this.length && this.words[h] < 0; h++)
            this.words[h] += 67108864, this.words[h + 1] -= 1;
        return this.strip();
      }, H.prototype.addn = function(t) {
        return this.clone().iaddn(t);
      }, H.prototype.subn = function(t) {
        return this.clone().isubn(t);
      }, H.prototype.iabs = function() {
        return this.negative = 0, this;
      }, H.prototype.abs = function() {
        return this.clone().iabs();
      }, H.prototype._ishlnsubmul = function(t, h, B) {
        var Z = t.length + B, ve;
        this._expand(Z);
        var ge, xe = 0;
        for (ve = 0; ve < t.length; ve++) {
          ge = (this.words[ve + B] | 0) + xe;
          var X = (t.words[ve] | 0) * h;
          ge -= X & 67108863, xe = (ge >> 26) - (X / 67108864 | 0), this.words[ve + B] = ge & 67108863;
        }
        for (; ve < this.length - B; ve++)
          ge = (this.words[ve + B] | 0) + xe, xe = ge >> 26, this.words[ve + B] = ge & 67108863;
        if (xe === 0) return this.strip();
        for (J(xe === -1), xe = 0, ve = 0; ve < this.length; ve++)
          ge = -(this.words[ve] | 0) + xe, xe = ge >> 26, this.words[ve] = ge & 67108863;
        return this.negative = 1, this.strip();
      }, H.prototype._wordDiv = function(t, h) {
        var B = this.length - t.length, Z = this.clone(), ve = t, ge = ve.words[ve.length - 1] | 0, xe = this._countBits(ge);
        B = 26 - xe, B !== 0 && (ve = ve.ushln(B), Z.iushln(B), ge = ve.words[ve.length - 1] | 0);
        var X = Z.length - ve.length, a;
        if (h !== "mod") {
          a = new H(null), a.length = X + 1, a.words = new Array(a.length);
          for (var Y = 0; Y < a.length; Y++)
            a.words[Y] = 0;
        }
        var Ne = Z.clone()._ishlnsubmul(ve, 1, X);
        Ne.negative === 0 && (Z = Ne, a && (a.words[X] = 1));
        for (var Ke = X - 1; Ke >= 0; Ke--) {
          var tt = (Z.words[ve.length + Ke] | 0) * 67108864 + (Z.words[ve.length + Ke - 1] | 0);
          for (tt = Math.min(tt / ge | 0, 67108863), Z._ishlnsubmul(ve, tt, Ke); Z.negative !== 0; )
            tt--, Z.negative = 0, Z._ishlnsubmul(ve, 1, Ke), Z.isZero() || (Z.negative ^= 1);
          a && (a.words[Ke] = tt);
        }
        return a && a.strip(), Z.strip(), h !== "div" && B !== 0 && Z.iushrn(B), {
          div: a || null,
          mod: Z
        };
      }, H.prototype.divmod = function(t, h, B) {
        if (J(!t.isZero()), this.isZero())
          return {
            div: new H(0),
            mod: new H(0)
          };
        var Z, ve, ge;
        return this.negative !== 0 && t.negative === 0 ? (ge = this.neg().divmod(t, h), h !== "mod" && (Z = ge.div.neg()), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.iadd(t)), {
          div: Z,
          mod: ve
        }) : this.negative === 0 && t.negative !== 0 ? (ge = this.divmod(t.neg(), h), h !== "mod" && (Z = ge.div.neg()), {
          div: Z,
          mod: ge.mod
        }) : this.negative & t.negative ? (ge = this.neg().divmod(t.neg(), h), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.isub(t)), {
          div: ge.div,
          mod: ve
        }) : t.length > this.length || this.cmp(t) < 0 ? {
          div: new H(0),
          mod: this
        } : t.length === 1 ? h === "div" ? {
          div: this.divn(t.words[0]),
          mod: null
        } : h === "mod" ? {
          div: null,
          mod: new H(this.modn(t.words[0]))
        } : {
          div: this.divn(t.words[0]),
          mod: new H(this.modn(t.words[0]))
        } : this._wordDiv(t, h);
      }, H.prototype.div = function(t) {
        return this.divmod(t, "div", !1).div;
      }, H.prototype.mod = function(t) {
        return this.divmod(t, "mod", !1).mod;
      }, H.prototype.umod = function(t) {
        return this.divmod(t, "mod", !0).mod;
      }, H.prototype.divRound = function(t) {
        var h = this.divmod(t);
        if (h.mod.isZero()) return h.div;
        var B = h.div.negative !== 0 ? h.mod.isub(t) : h.mod, Z = t.ushrn(1), ve = t.andln(1), ge = B.cmp(Z);
        return ge < 0 || ve === 1 && ge === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
      }, H.prototype.modn = function(t) {
        J(t <= 67108863);
        for (var h = (1 << 26) % t, B = 0, Z = this.length - 1; Z >= 0; Z--)
          B = (h * B + (this.words[Z] | 0)) % t;
        return B;
      }, H.prototype.idivn = function(t) {
        J(t <= 67108863);
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = (this.words[B] | 0) + h * 67108864;
          this.words[B] = Z / t | 0, h = Z % t;
        }
        return this.strip();
      }, H.prototype.divn = function(t) {
        return this.clone().idivn(t);
      }, H.prototype.egcd = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = new H(0), xe = new H(1), X = 0; h.isEven() && B.isEven(); )
          h.iushrn(1), B.iushrn(1), ++X;
        for (var a = B.clone(), Y = h.clone(); !h.isZero(); ) {
          for (var Ne = 0, Ke = 1; !(h.words[0] & Ke) && Ne < 26; ++Ne, Ke <<= 1) ;
          if (Ne > 0)
            for (h.iushrn(Ne); Ne-- > 0; )
              (Z.isOdd() || ve.isOdd()) && (Z.iadd(a), ve.isub(Y)), Z.iushrn(1), ve.iushrn(1);
          for (var tt = 0, We = 1; !(B.words[0] & We) && tt < 26; ++tt, We <<= 1) ;
          if (tt > 0)
            for (B.iushrn(tt); tt-- > 0; )
              (ge.isOdd() || xe.isOdd()) && (ge.iadd(a), xe.isub(Y)), ge.iushrn(1), xe.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ge), ve.isub(xe)) : (B.isub(h), ge.isub(Z), xe.isub(ve));
        }
        return {
          a: ge,
          b: xe,
          gcd: B.iushln(X)
        };
      }, H.prototype._invmp = function(t) {
        J(t.negative === 0), J(!t.isZero());
        var h = this, B = t.clone();
        h.negative !== 0 ? h = h.umod(t) : h = h.clone();
        for (var Z = new H(1), ve = new H(0), ge = B.clone(); h.cmpn(1) > 0 && B.cmpn(1) > 0; ) {
          for (var xe = 0, X = 1; !(h.words[0] & X) && xe < 26; ++xe, X <<= 1) ;
          if (xe > 0)
            for (h.iushrn(xe); xe-- > 0; )
              Z.isOdd() && Z.iadd(ge), Z.iushrn(1);
          for (var a = 0, Y = 1; !(B.words[0] & Y) && a < 26; ++a, Y <<= 1) ;
          if (a > 0)
            for (B.iushrn(a); a-- > 0; )
              ve.isOdd() && ve.iadd(ge), ve.iushrn(1);
          h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ve)) : (B.isub(h), ve.isub(Z));
        }
        var Ne;
        return h.cmpn(1) === 0 ? Ne = Z : Ne = ve, Ne.cmpn(0) < 0 && Ne.iadd(t), Ne;
      }, H.prototype.gcd = function(t) {
        if (this.isZero()) return t.abs();
        if (t.isZero()) return this.abs();
        var h = this.clone(), B = t.clone();
        h.negative = 0, B.negative = 0;
        for (var Z = 0; h.isEven() && B.isEven(); Z++)
          h.iushrn(1), B.iushrn(1);
        do {
          for (; h.isEven(); )
            h.iushrn(1);
          for (; B.isEven(); )
            B.iushrn(1);
          var ve = h.cmp(B);
          if (ve < 0) {
            var ge = h;
            h = B, B = ge;
          } else if (ve === 0 || B.cmpn(1) === 0)
            break;
          h.isub(B);
        } while (!0);
        return B.iushln(Z);
      }, H.prototype.invm = function(t) {
        return this.egcd(t).a.umod(t);
      }, H.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, H.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, H.prototype.andln = function(t) {
        return this.words[0] & t;
      }, H.prototype.bincn = function(t) {
        J(typeof t == "number");
        var h = t % 26, B = (t - h) / 26, Z = 1 << h;
        if (this.length <= B)
          return this._expand(B + 1), this.words[B] |= Z, this;
        for (var ve = Z, ge = B; ve !== 0 && ge < this.length; ge++) {
          var xe = this.words[ge] | 0;
          xe += ve, ve = xe >>> 26, xe &= 67108863, this.words[ge] = xe;
        }
        return ve !== 0 && (this.words[ge] = ve, this.length++), this;
      }, H.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, H.prototype.cmpn = function(t) {
        var h = t < 0;
        if (this.negative !== 0 && !h) return -1;
        if (this.negative === 0 && h) return 1;
        this.strip();
        var B;
        if (this.length > 1)
          B = 1;
        else {
          h && (t = -t), J(t <= 67108863, "Number is too big");
          var Z = this.words[0] | 0;
          B = Z === t ? 0 : Z < t ? -1 : 1;
        }
        return this.negative !== 0 ? -B | 0 : B;
      }, H.prototype.cmp = function(t) {
        if (this.negative !== 0 && t.negative === 0) return -1;
        if (this.negative === 0 && t.negative !== 0) return 1;
        var h = this.ucmp(t);
        return this.negative !== 0 ? -h | 0 : h;
      }, H.prototype.ucmp = function(t) {
        if (this.length > t.length) return 1;
        if (this.length < t.length) return -1;
        for (var h = 0, B = this.length - 1; B >= 0; B--) {
          var Z = this.words[B] | 0, ve = t.words[B] | 0;
          if (Z !== ve) {
            Z < ve ? h = -1 : Z > ve && (h = 1);
            break;
          }
        }
        return h;
      }, H.prototype.gtn = function(t) {
        return this.cmpn(t) === 1;
      }, H.prototype.gt = function(t) {
        return this.cmp(t) === 1;
      }, H.prototype.gten = function(t) {
        return this.cmpn(t) >= 0;
      }, H.prototype.gte = function(t) {
        return this.cmp(t) >= 0;
      }, H.prototype.ltn = function(t) {
        return this.cmpn(t) === -1;
      }, H.prototype.lt = function(t) {
        return this.cmp(t) === -1;
      }, H.prototype.lten = function(t) {
        return this.cmpn(t) <= 0;
      }, H.prototype.lte = function(t) {
        return this.cmp(t) <= 0;
      }, H.prototype.eqn = function(t) {
        return this.cmpn(t) === 0;
      }, H.prototype.eq = function(t) {
        return this.cmp(t) === 0;
      }, H.red = function(t) {
        return new bt(t);
      }, H.prototype.toRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), t.convertTo(this)._forceRed(t);
      }, H.prototype.fromRed = function() {
        return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, H.prototype._forceRed = function(t) {
        return this.red = t, this;
      }, H.prototype.forceRed = function(t) {
        return J(!this.red, "Already a number in reduction context"), this._forceRed(t);
      }, H.prototype.redAdd = function(t) {
        return J(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
      }, H.prototype.redIAdd = function(t) {
        return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
      }, H.prototype.redSub = function(t) {
        return J(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
      }, H.prototype.redISub = function(t) {
        return J(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
      }, H.prototype.redShl = function(t) {
        return J(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
      }, H.prototype.redMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
      }, H.prototype.redIMul = function(t) {
        return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
      }, H.prototype.redSqr = function() {
        return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, H.prototype.redISqr = function() {
        return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, H.prototype.redSqrt = function() {
        return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, H.prototype.redInvm = function() {
        return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, H.prototype.redNeg = function() {
        return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, H.prototype.redPow = function(t) {
        return J(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
      };
      var ut = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function rt(Se, t) {
        this.name = Se, this.p = new H(t, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      rt.prototype._tmp = function() {
        var t = new H(null);
        return t.words = new Array(Math.ceil(this.n / 13)), t;
      }, rt.prototype.ireduce = function(t) {
        var h = t, B;
        do
          this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), B = h.bitLength();
        while (B > this.n);
        var Z = B < this.n ? -1 : h.ucmp(this.p);
        return Z === 0 ? (h.words[0] = 0, h.length = 1) : Z > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
      }, rt.prototype.split = function(t, h) {
        t.iushrn(this.n, 0, h);
      }, rt.prototype.imulK = function(t) {
        return t.imul(this.k);
      };
      function lt() {
        rt.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      _e(lt, rt), lt.prototype.split = function(t, h) {
        for (var B = 4194303, Z = Math.min(t.length, 9), ve = 0; ve < Z; ve++)
          h.words[ve] = t.words[ve];
        if (h.length = Z, t.length <= 9) {
          t.words[0] = 0, t.length = 1;
          return;
        }
        var ge = t.words[9];
        for (h.words[h.length++] = ge & B, ve = 10; ve < t.length; ve++) {
          var xe = t.words[ve] | 0;
          t.words[ve - 10] = (xe & B) << 4 | ge >>> 22, ge = xe;
        }
        ge >>>= 22, t.words[ve - 10] = ge, ge === 0 && t.length > 10 ? t.length -= 10 : t.length -= 9;
      }, lt.prototype.imulK = function(t) {
        t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = t.words[B] | 0;
          h += Z * 977, t.words[B] = h & 67108863, h = Z * 64 + (h / 67108864 | 0);
        }
        return t.words[t.length - 1] === 0 && (t.length--, t.words[t.length - 1] === 0 && t.length--), t;
      };
      function vt() {
        rt.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      _e(vt, rt);
      function Ye() {
        rt.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      _e(Ye, rt);
      function pt() {
        rt.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      _e(pt, rt), pt.prototype.imulK = function(t) {
        for (var h = 0, B = 0; B < t.length; B++) {
          var Z = (t.words[B] | 0) * 19 + h, ve = Z & 67108863;
          Z >>>= 26, t.words[B] = ve, h = Z;
        }
        return h !== 0 && (t.words[t.length++] = h), t;
      }, H._prime = function(t) {
        if (ut[t]) return ut[t];
        var h;
        if (t === "k256")
          h = new lt();
        else if (t === "p224")
          h = new vt();
        else if (t === "p192")
          h = new Ye();
        else if (t === "p25519")
          h = new pt();
        else
          throw new Error("Unknown prime " + t);
        return ut[t] = h, h;
      };
      function bt(Se) {
        if (typeof Se == "string") {
          var t = H._prime(Se);
          this.m = t.p, this.prime = t;
        } else
          J(Se.gtn(1), "modulus must be greater than 1"), this.m = Se, this.prime = null;
      }
      bt.prototype._verify1 = function(t) {
        J(t.negative === 0, "red works only with positives"), J(t.red, "red works only with red numbers");
      }, bt.prototype._verify2 = function(t, h) {
        J((t.negative | h.negative) === 0, "red works only with positives"), J(
          t.red && t.red === h.red,
          "red works only with red numbers"
        );
      }, bt.prototype.imod = function(t) {
        return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
      }, bt.prototype.neg = function(t) {
        return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
      }, bt.prototype.add = function(t, h) {
        this._verify2(t, h);
        var B = t.add(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B._forceRed(this);
      }, bt.prototype.iadd = function(t, h) {
        this._verify2(t, h);
        var B = t.iadd(h);
        return B.cmp(this.m) >= 0 && B.isub(this.m), B;
      }, bt.prototype.sub = function(t, h) {
        this._verify2(t, h);
        var B = t.sub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B._forceRed(this);
      }, bt.prototype.isub = function(t, h) {
        this._verify2(t, h);
        var B = t.isub(h);
        return B.cmpn(0) < 0 && B.iadd(this.m), B;
      }, bt.prototype.shl = function(t, h) {
        return this._verify1(t), this.imod(t.ushln(h));
      }, bt.prototype.imul = function(t, h) {
        return this._verify2(t, h), this.imod(t.imul(h));
      }, bt.prototype.mul = function(t, h) {
        return this._verify2(t, h), this.imod(t.mul(h));
      }, bt.prototype.isqr = function(t) {
        return this.imul(t, t.clone());
      }, bt.prototype.sqr = function(t) {
        return this.mul(t, t);
      }, bt.prototype.sqrt = function(t) {
        if (t.isZero()) return t.clone();
        var h = this.m.andln(3);
        if (J(h % 2 === 1), h === 3) {
          var B = this.m.add(new H(1)).iushrn(2);
          return this.pow(t, B);
        }
        for (var Z = this.m.subn(1), ve = 0; !Z.isZero() && Z.andln(1) === 0; )
          ve++, Z.iushrn(1);
        J(!Z.isZero());
        var ge = new H(1).toRed(this), xe = ge.redNeg(), X = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new H(2 * a * a).toRed(this); this.pow(a, X).cmp(xe) !== 0; )
          a.redIAdd(xe);
        for (var Y = this.pow(a, Z), Ne = this.pow(t, Z.addn(1).iushrn(1)), Ke = this.pow(t, Z), tt = ve; Ke.cmp(ge) !== 0; ) {
          for (var We = Ke, ot = 0; We.cmp(ge) !== 0; ot++)
            We = We.redSqr();
          J(ot < tt);
          var He = this.pow(Y, new H(1).iushln(tt - ot - 1));
          Ne = Ne.redMul(He), Y = He.redSqr(), Ke = Ke.redMul(Y), tt = ot;
        }
        return Ne;
      }, bt.prototype.invm = function(t) {
        var h = t._invmp(this.m);
        return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
      }, bt.prototype.pow = function(t, h) {
        if (h.isZero()) return new H(1).toRed(this);
        if (h.cmpn(1) === 0) return t.clone();
        var B = 4, Z = new Array(1 << B);
        Z[0] = new H(1).toRed(this), Z[1] = t;
        for (var ve = 2; ve < Z.length; ve++)
          Z[ve] = this.mul(Z[ve - 1], t);
        var ge = Z[0], xe = 0, X = 0, a = h.bitLength() % 26;
        for (a === 0 && (a = 26), ve = h.length - 1; ve >= 0; ve--) {
          for (var Y = h.words[ve], Ne = a - 1; Ne >= 0; Ne--) {
            var Ke = Y >> Ne & 1;
            if (ge !== Z[0] && (ge = this.sqr(ge)), Ke === 0 && xe === 0) {
              X = 0;
              continue;
            }
            xe <<= 1, xe |= Ke, X++, !(X !== B && (ve !== 0 || Ne !== 0)) && (ge = this.mul(ge, Z[xe]), X = 0, xe = 0);
          }
          a = 26;
        }
        return ge;
      }, bt.prototype.convertTo = function(t) {
        var h = t.umod(this.m);
        return h === t ? h.clone() : h;
      }, bt.prototype.convertFrom = function(t) {
        var h = t.clone();
        return h.red = null, h;
      }, H.mont = function(t) {
        return new Yt(t);
      };
      function Yt(Se) {
        bt.call(this, Se), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      _e(Yt, bt), Yt.prototype.convertTo = function(t) {
        return this.imod(t.ushln(this.shift));
      }, Yt.prototype.convertFrom = function(t) {
        var h = this.imod(t.mul(this.rinv));
        return h.red = null, h;
      }, Yt.prototype.imul = function(t, h) {
        if (t.isZero() || h.isZero())
          return t.words[0] = 0, t.length = 1, t;
        var B = t.imul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.mul = function(t, h) {
        if (t.isZero() || h.isZero()) return new H(0)._forceRed(this);
        var B = t.mul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
        return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
      }, Yt.prototype.invm = function(t) {
        var h = this.imod(t._invmp(this.m).mul(this.r2));
        return h._forceRed(this);
      };
    })(I, commonjsGlobal);
  }(bn$1)), bn$1.exports;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic) return withPublic_1;
  hasRequiredWithPublic = 1;
  var I = requireBn(), A = safeBufferExports.Buffer;
  function G(J, _e) {
    return A.from(J.toRed(I.mont(_e.modulus)).redPow(new I(_e.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = G, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt) return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var I = requireParseAsn1(), A = requireBrowser$a(), G = requireBrowser$9(), J = requireMgf(), _e = requireXor(), H = requireBn(), De = requireWithPublic(), Ie = requireBrowserifyRsa(), qe = safeBufferExports.Buffer;
  publicEncrypt = function(ke, Fe, Ge) {
    var et;
    ke.padding ? et = ke.padding : Ge ? et = 1 : et = 4;
    var Ve = I(ke), Je;
    if (et === 4)
      Je = Te(Ve, Fe);
    else if (et === 1)
      Je = Ee(Ve, Fe, Ge);
    else if (et === 3) {
      if (Je = new H(Fe), Je.cmp(Ve.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return Ge ? Ie(Je, Ve) : De(Je, Ve);
  };
  function Te(Le, ke) {
    var Fe = Le.modulus.byteLength(), Ge = ke.length, et = G("sha1").update(qe.alloc(0)).digest(), Ve = et.length, Je = 2 * Ve;
    if (Ge > Fe - Je - 2)
      throw new Error("message too long");
    var ut = qe.alloc(Fe - Ge - Je - 2), rt = Fe - Ve - 1, lt = A(Ve), vt = _e(qe.concat([et, ut, qe.alloc(1, 1), ke], rt), J(lt, rt)), Ye = _e(lt, J(vt, Ve));
    return new H(qe.concat([qe.alloc(1), Ye, vt], Fe));
  }
  function Ee(Le, ke, Fe) {
    var Ge = ke.length, et = Le.modulus.byteLength();
    if (Ge > et - 11)
      throw new Error("message too long");
    var Ve;
    return Fe ? Ve = qe.alloc(et - Ge - 3, 255) : Ve = Oe(et - Ge - 3), new H(qe.concat([qe.from([0, Fe ? 1 : 2]), Ve, qe.alloc(1), ke], et));
  }
  function Oe(Le) {
    for (var ke = qe.allocUnsafe(Le), Fe = 0, Ge = A(Le * 2), et = 0, Ve; Fe < Le; )
      et === Ge.length && (Ge = A(Le * 2), et = 0), Ve = Ge[et++], Ve && (ke[Fe++] = Ve);
    return ke;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt) return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var I = requireParseAsn1(), A = requireMgf(), G = requireXor(), J = requireBn(), _e = requireBrowserifyRsa(), H = requireBrowser$9(), De = requireWithPublic(), Ie = safeBufferExports.Buffer;
  privateDecrypt = function(Le, ke, Fe) {
    var Ge;
    Le.padding ? Ge = Le.padding : Fe ? Ge = 1 : Ge = 4;
    var et = I(Le), Ve = et.modulus.byteLength();
    if (ke.length > Ve || new J(ke).cmp(et.modulus) >= 0)
      throw new Error("decryption error");
    var Je;
    Fe ? Je = De(new J(ke), et) : Je = _e(ke, et);
    var ut = Ie.alloc(Ve - Je.length);
    if (Je = Ie.concat([ut, Je], Ve), Ge === 4)
      return qe(et, Je);
    if (Ge === 1)
      return Te(et, Je, Fe);
    if (Ge === 3)
      return Je;
    throw new Error("unknown padding");
  };
  function qe(Oe, Le) {
    var ke = Oe.modulus.byteLength(), Fe = H("sha1").update(Ie.alloc(0)).digest(), Ge = Fe.length;
    if (Le[0] !== 0)
      throw new Error("decryption error");
    var et = Le.slice(1, Ge + 1), Ve = Le.slice(Ge + 1), Je = G(et, A(Ve, Ge)), ut = G(Ve, A(Je, ke - Ge - 1));
    if (Ee(Fe, ut.slice(0, Ge)))
      throw new Error("decryption error");
    for (var rt = Ge; ut[rt] === 0; )
      rt++;
    if (ut[rt++] !== 1)
      throw new Error("decryption error");
    return ut.slice(rt);
  }
  function Te(Oe, Le, ke) {
    for (var Fe = Le.slice(0, 2), Ge = 2, et = 0; Le[Ge++] !== 0; )
      if (Ge >= Le.length) {
        et++;
        break;
      }
    var Ve = Le.slice(2, Ge - 1);
    if ((Fe.toString("hex") !== "0002" && !ke || Fe.toString("hex") !== "0001" && ke) && et++, Ve.length < 8 && et++, et)
      throw new Error("decryption error");
    return Le.slice(Ge);
  }
  function Ee(Oe, Le) {
    Oe = Ie.from(Oe), Le = Ie.from(Le);
    var ke = 0, Fe = Oe.length;
    Oe.length !== Le.length && (ke++, Fe = Math.min(Oe.length, Le.length));
    for (var Ge = -1; ++Ge < Fe; )
      ke += Oe[Ge] ^ Le[Ge];
    return ke;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(I) {
    I.publicEncrypt = requirePublicEncrypt(), I.privateDecrypt = requirePrivateDecrypt(), I.privateEncrypt = function(G, J) {
      return I.publicEncrypt(G, J, !0);
    }, I.publicDecrypt = function(G, J) {
      return I.privateDecrypt(G, J, !0);
    };
  }(browser$2)), browser$2;
}
var browser$1 = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser$1;
  hasRequiredBrowser = 1;
  function I() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var A = safeBufferExports, G = requireBrowser$a(), J = A.Buffer, _e = A.kMaxLength, H = commonjsGlobal.crypto || commonjsGlobal.msCrypto, De = Math.pow(2, 32) - 1;
  function Ie(Le, ke) {
    if (typeof Le != "number" || Le !== Le)
      throw new TypeError("offset must be a number");
    if (Le > De || Le < 0)
      throw new TypeError("offset must be a uint32");
    if (Le > _e || Le > ke)
      throw new RangeError("offset out of range");
  }
  function qe(Le, ke, Fe) {
    if (typeof Le != "number" || Le !== Le)
      throw new TypeError("size must be a number");
    if (Le > De || Le < 0)
      throw new TypeError("size must be a uint32");
    if (Le + ke > Fe || Le > _e)
      throw new RangeError("buffer too small");
  }
  H && H.getRandomValues || !process$1.browser ? (browser$1.randomFill = Te, browser$1.randomFillSync = Oe) : (browser$1.randomFill = I, browser$1.randomFillSync = I);
  function Te(Le, ke, Fe, Ge) {
    if (!J.isBuffer(Le) && !(Le instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof ke == "function")
      Ge = ke, ke = 0, Fe = Le.length;
    else if (typeof Fe == "function")
      Ge = Fe, Fe = Le.length - ke;
    else if (typeof Ge != "function")
      throw new TypeError('"cb" argument must be a function');
    return Ie(ke, Le.length), qe(Fe, ke, Le.length), Ee(Le, ke, Fe, Ge);
  }
  function Ee(Le, ke, Fe, Ge) {
    if (process$1.browser) {
      var et = Le.buffer, Ve = new Uint8Array(et, ke, Fe);
      if (H.getRandomValues(Ve), Ge) {
        process$1.nextTick(function() {
          Ge(null, Le);
        });
        return;
      }
      return Le;
    }
    if (Ge) {
      G(Fe, function(ut, rt) {
        if (ut)
          return Ge(ut);
        rt.copy(Le, ke), Ge(null, Le);
      });
      return;
    }
    var Je = G(Fe);
    return Je.copy(Le, ke), Le;
  }
  function Oe(Le, ke, Fe) {
    if (typeof ke > "u" && (ke = 0), !J.isBuffer(Le) && !(Le instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return Ie(ke, Le.length), Fe === void 0 && (Fe = Le.length - ke), qe(Fe, ke, Le.length), Ee(Le, ke, Fe);
  }
  return browser$1;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify) return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$a(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$9(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var I = requireAlgos(), A = Object.keys(I), G = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(A);
  cryptoBrowserify.getHashes = function() {
    return G;
  };
  var J = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = J.pbkdf2, cryptoBrowserify.pbkdf2Sync = J.pbkdf2Sync;
  var _e = requireBrowser$5();
  cryptoBrowserify.Cipher = _e.Cipher, cryptoBrowserify.createCipher = _e.createCipher, cryptoBrowserify.Cipheriv = _e.Cipheriv, cryptoBrowserify.createCipheriv = _e.createCipheriv, cryptoBrowserify.Decipher = _e.Decipher, cryptoBrowserify.createDecipher = _e.createDecipher, cryptoBrowserify.Decipheriv = _e.Decipheriv, cryptoBrowserify.createDecipheriv = _e.createDecipheriv, cryptoBrowserify.getCiphers = _e.getCiphers, cryptoBrowserify.listCiphers = _e.listCiphers;
  var H = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = H.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = H.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = H.getDiffieHellman, cryptoBrowserify.createDiffieHellman = H.createDiffieHellman, cryptoBrowserify.DiffieHellman = H.DiffieHellman;
  var De = requireBrowser$3();
  cryptoBrowserify.createSign = De.createSign, cryptoBrowserify.Sign = De.Sign, cryptoBrowserify.createVerify = De.createVerify, cryptoBrowserify.Verify = De.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var Ie = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = Ie.publicEncrypt, cryptoBrowserify.privateEncrypt = Ie.privateEncrypt, cryptoBrowserify.publicDecrypt = Ie.publicDecrypt, cryptoBrowserify.privateDecrypt = Ie.privateDecrypt;
  var qe = requireBrowser();
  return cryptoBrowserify.randomFill = qe.randomFill, cryptoBrowserify.randomFillSync = qe.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
Object.defineProperty(node$1, "__esModule", { value: !0 });
node$1.NodeRandomSource = void 0;
const wipe_1 = wipe$1;
class NodeRandomSource {
  constructor() {
    if (this.isAvailable = !1, this.isInstantiated = !1, typeof commonjsRequire < "u") {
      const A = requireCryptoBrowserify();
      A && A.randomBytes && (this._crypto = A, this.isAvailable = !0, this.isInstantiated = !0);
    }
  }
  randomBytes(A) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Node.js random byte generator is not available.");
    let G = this._crypto.randomBytes(A);
    if (G.length !== A)
      throw new Error("NodeRandomSource: got fewer bytes than requested");
    const J = new Uint8Array(A);
    for (let _e = 0; _e < J.length; _e++)
      J[_e] = G[_e];
    return (0, wipe_1.wipe)(G), J;
  }
}
node$1.NodeRandomSource = NodeRandomSource;
Object.defineProperty(system, "__esModule", { value: !0 });
system.SystemRandomSource = void 0;
const browser_1 = browser$c, node_1 = node$1;
class SystemRandomSource {
  constructor() {
    if (this.isAvailable = !1, this.name = "", this._source = new browser_1.BrowserRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Browser";
      return;
    }
    if (this._source = new node_1.NodeRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Node";
      return;
    }
  }
  randomBytes(A) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    return this._source.randomBytes(A);
  }
}
system.SystemRandomSource = SystemRandomSource;
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 }), I.randomStringForEntropy = I.randomString = I.randomUint32 = I.randomBytes = I.defaultRandomSource = void 0;
  const A = system, G = binary, J = wipe$1;
  I.defaultRandomSource = new A.SystemRandomSource();
  function _e(Te, Ee = I.defaultRandomSource) {
    return Ee.randomBytes(Te);
  }
  I.randomBytes = _e;
  function H(Te = I.defaultRandomSource) {
    const Ee = _e(4, Te), Oe = (0, G.readUint32LE)(Ee);
    return (0, J.wipe)(Ee), Oe;
  }
  I.randomUint32 = H;
  const De = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  function Ie(Te, Ee = De, Oe = I.defaultRandomSource) {
    if (Ee.length < 2)
      throw new Error("randomString charset is too short");
    if (Ee.length > 256)
      throw new Error("randomString charset is too long");
    let Le = "";
    const ke = Ee.length, Fe = 256 - 256 % ke;
    for (; Te > 0; ) {
      const Ge = _e(Math.ceil(Te * 256 / Fe), Oe);
      for (let et = 0; et < Ge.length && Te > 0; et++) {
        const Ve = Ge[et];
        Ve < Fe && (Le += Ee.charAt(Ve % ke), Te--);
      }
      (0, J.wipe)(Ge);
    }
    return Le;
  }
  I.randomString = Ie;
  function qe(Te, Ee = De, Oe = I.defaultRandomSource) {
    const Le = Math.ceil(Te / (Math.log(Ee.length) / Math.LN2));
    return Ie(Le, Ee, Oe);
  }
  I.randomStringForEntropy = qe;
})(random);
var sha256 = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var A = binary, G = wipe$1;
  I.DIGEST_LENGTH = 32, I.BLOCK_SIZE = 64;
  var J = (
    /** @class */
    function() {
      function Ie() {
        this.digestLength = I.DIGEST_LENGTH, this.blockSize = I.BLOCK_SIZE, this._state = new Int32Array(8), this._temp = new Int32Array(64), this._buffer = new Uint8Array(128), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
      }
      return Ie.prototype._initState = function() {
        this._state[0] = 1779033703, this._state[1] = 3144134277, this._state[2] = 1013904242, this._state[3] = 2773480762, this._state[4] = 1359893119, this._state[5] = 2600822924, this._state[6] = 528734635, this._state[7] = 1541459225;
      }, Ie.prototype.reset = function() {
        return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
      }, Ie.prototype.clean = function() {
        G.wipe(this._buffer), G.wipe(this._temp), this.reset();
      }, Ie.prototype.update = function(qe, Te) {
        if (Te === void 0 && (Te = qe.length), this._finished)
          throw new Error("SHA256: can't update because hash was finished.");
        var Ee = 0;
        if (this._bytesHashed += Te, this._bufferLength > 0) {
          for (; this._bufferLength < this.blockSize && Te > 0; )
            this._buffer[this._bufferLength++] = qe[Ee++], Te--;
          this._bufferLength === this.blockSize && (H(this._temp, this._state, this._buffer, 0, this.blockSize), this._bufferLength = 0);
        }
        for (Te >= this.blockSize && (Ee = H(this._temp, this._state, qe, Ee, Te), Te %= this.blockSize); Te > 0; )
          this._buffer[this._bufferLength++] = qe[Ee++], Te--;
        return this;
      }, Ie.prototype.finish = function(qe) {
        if (!this._finished) {
          var Te = this._bytesHashed, Ee = this._bufferLength, Oe = Te / 536870912 | 0, Le = Te << 3, ke = Te % 64 < 56 ? 64 : 128;
          this._buffer[Ee] = 128;
          for (var Fe = Ee + 1; Fe < ke - 8; Fe++)
            this._buffer[Fe] = 0;
          A.writeUint32BE(Oe, this._buffer, ke - 8), A.writeUint32BE(Le, this._buffer, ke - 4), H(this._temp, this._state, this._buffer, 0, ke), this._finished = !0;
        }
        for (var Fe = 0; Fe < this.digestLength / 4; Fe++)
          A.writeUint32BE(this._state[Fe], qe, Fe * 4);
        return this;
      }, Ie.prototype.digest = function() {
        var qe = new Uint8Array(this.digestLength);
        return this.finish(qe), qe;
      }, Ie.prototype.saveState = function() {
        if (this._finished)
          throw new Error("SHA256: cannot save finished state");
        return {
          state: new Int32Array(this._state),
          buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
          bufferLength: this._bufferLength,
          bytesHashed: this._bytesHashed
        };
      }, Ie.prototype.restoreState = function(qe) {
        return this._state.set(qe.state), this._bufferLength = qe.bufferLength, qe.buffer && this._buffer.set(qe.buffer), this._bytesHashed = qe.bytesHashed, this._finished = !1, this;
      }, Ie.prototype.cleanSavedState = function(qe) {
        G.wipe(qe.state), qe.buffer && G.wipe(qe.buffer), qe.bufferLength = 0, qe.bytesHashed = 0;
      }, Ie;
    }()
  );
  I.SHA256 = J;
  var _e = new Int32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]);
  function H(Ie, qe, Te, Ee, Oe) {
    for (; Oe >= 64; ) {
      for (var Le = qe[0], ke = qe[1], Fe = qe[2], Ge = qe[3], et = qe[4], Ve = qe[5], Je = qe[6], ut = qe[7], rt = 0; rt < 16; rt++) {
        var lt = Ee + rt * 4;
        Ie[rt] = A.readUint32BE(Te, lt);
      }
      for (var rt = 16; rt < 64; rt++) {
        var vt = Ie[rt - 2], Ye = (vt >>> 17 | vt << 15) ^ (vt >>> 19 | vt << 13) ^ vt >>> 10;
        vt = Ie[rt - 15];
        var pt = (vt >>> 7 | vt << 25) ^ (vt >>> 18 | vt << 14) ^ vt >>> 3;
        Ie[rt] = (Ye + Ie[rt - 7] | 0) + (pt + Ie[rt - 16] | 0);
      }
      for (var rt = 0; rt < 64; rt++) {
        var Ye = (((et >>> 6 | et << 26) ^ (et >>> 11 | et << 21) ^ (et >>> 25 | et << 7)) + (et & Ve ^ ~et & Je) | 0) + (ut + (_e[rt] + Ie[rt] | 0) | 0) | 0, pt = ((Le >>> 2 | Le << 30) ^ (Le >>> 13 | Le << 19) ^ (Le >>> 22 | Le << 10)) + (Le & ke ^ Le & Fe ^ ke & Fe) | 0;
        ut = Je, Je = Ve, Ve = et, et = Ge + Ye | 0, Ge = Fe, Fe = ke, ke = Le, Le = Ye + pt | 0;
      }
      qe[0] += Le, qe[1] += ke, qe[2] += Fe, qe[3] += Ge, qe[4] += et, qe[5] += Ve, qe[6] += Je, qe[7] += ut, Ee += 64, Oe -= 64;
    }
    return Ee;
  }
  function De(Ie) {
    var qe = new J();
    qe.update(Ie);
    var Te = qe.digest();
    return qe.clean(), Te;
  }
  I.hash = De;
})(sha256);
var x25519 = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 }), I.sharedKey = I.generateKeyPair = I.generateKeyPairFromSeed = I.scalarMultBase = I.scalarMult = I.SHARED_KEY_LENGTH = I.SECRET_KEY_LENGTH = I.PUBLIC_KEY_LENGTH = void 0;
  const A = random, G = wipe$1;
  I.PUBLIC_KEY_LENGTH = 32, I.SECRET_KEY_LENGTH = 32, I.SHARED_KEY_LENGTH = 32;
  function J(rt) {
    const lt = new Float64Array(16);
    if (rt)
      for (let vt = 0; vt < rt.length; vt++)
        lt[vt] = rt[vt];
    return lt;
  }
  const _e = new Uint8Array(32);
  _e[0] = 9;
  const H = J([56129, 1]);
  function De(rt) {
    let lt = 1;
    for (let vt = 0; vt < 16; vt++) {
      let Ye = rt[vt] + lt + 65535;
      lt = Math.floor(Ye / 65536), rt[vt] = Ye - lt * 65536;
    }
    rt[0] += lt - 1 + 37 * (lt - 1);
  }
  function Ie(rt, lt, vt) {
    const Ye = ~(vt - 1);
    for (let pt = 0; pt < 16; pt++) {
      const bt = Ye & (rt[pt] ^ lt[pt]);
      rt[pt] ^= bt, lt[pt] ^= bt;
    }
  }
  function qe(rt, lt) {
    const vt = J(), Ye = J();
    for (let pt = 0; pt < 16; pt++)
      Ye[pt] = lt[pt];
    De(Ye), De(Ye), De(Ye);
    for (let pt = 0; pt < 2; pt++) {
      vt[0] = Ye[0] - 65517;
      for (let Yt = 1; Yt < 15; Yt++)
        vt[Yt] = Ye[Yt] - 65535 - (vt[Yt - 1] >> 16 & 1), vt[Yt - 1] &= 65535;
      vt[15] = Ye[15] - 32767 - (vt[14] >> 16 & 1);
      const bt = vt[15] >> 16 & 1;
      vt[14] &= 65535, Ie(Ye, vt, 1 - bt);
    }
    for (let pt = 0; pt < 16; pt++)
      rt[2 * pt] = Ye[pt] & 255, rt[2 * pt + 1] = Ye[pt] >> 8;
  }
  function Te(rt, lt) {
    for (let vt = 0; vt < 16; vt++)
      rt[vt] = lt[2 * vt] + (lt[2 * vt + 1] << 8);
    rt[15] &= 32767;
  }
  function Ee(rt, lt, vt) {
    for (let Ye = 0; Ye < 16; Ye++)
      rt[Ye] = lt[Ye] + vt[Ye];
  }
  function Oe(rt, lt, vt) {
    for (let Ye = 0; Ye < 16; Ye++)
      rt[Ye] = lt[Ye] - vt[Ye];
  }
  function Le(rt, lt, vt) {
    let Ye, pt, bt = 0, Yt = 0, Se = 0, t = 0, h = 0, B = 0, Z = 0, ve = 0, ge = 0, xe = 0, X = 0, a = 0, Y = 0, Ne = 0, Ke = 0, tt = 0, We = 0, ot = 0, He = 0, Qe = 0, nt = 0, je = 0, it = 0, st = 0, gt = 0, It = 0, At = 0, Et = 0, ei = 0, Xt = 0, _t = 0, ni = vt[0], Ct = vt[1], Wt = vt[2], ii = vt[3], Pt = vt[4], Rt = vt[5], ai = vt[6], Nt = vt[7], qt = vt[8], oi = vt[9], ct = vt[10], Ze = vt[11], at = vt[12], dt = vt[13], yt = vt[14], St = vt[15];
    Ye = lt[0], bt += Ye * ni, Yt += Ye * Ct, Se += Ye * Wt, t += Ye * ii, h += Ye * Pt, B += Ye * Rt, Z += Ye * ai, ve += Ye * Nt, ge += Ye * qt, xe += Ye * oi, X += Ye * ct, a += Ye * Ze, Y += Ye * at, Ne += Ye * dt, Ke += Ye * yt, tt += Ye * St, Ye = lt[1], Yt += Ye * ni, Se += Ye * Ct, t += Ye * Wt, h += Ye * ii, B += Ye * Pt, Z += Ye * Rt, ve += Ye * ai, ge += Ye * Nt, xe += Ye * qt, X += Ye * oi, a += Ye * ct, Y += Ye * Ze, Ne += Ye * at, Ke += Ye * dt, tt += Ye * yt, We += Ye * St, Ye = lt[2], Se += Ye * ni, t += Ye * Ct, h += Ye * Wt, B += Ye * ii, Z += Ye * Pt, ve += Ye * Rt, ge += Ye * ai, xe += Ye * Nt, X += Ye * qt, a += Ye * oi, Y += Ye * ct, Ne += Ye * Ze, Ke += Ye * at, tt += Ye * dt, We += Ye * yt, ot += Ye * St, Ye = lt[3], t += Ye * ni, h += Ye * Ct, B += Ye * Wt, Z += Ye * ii, ve += Ye * Pt, ge += Ye * Rt, xe += Ye * ai, X += Ye * Nt, a += Ye * qt, Y += Ye * oi, Ne += Ye * ct, Ke += Ye * Ze, tt += Ye * at, We += Ye * dt, ot += Ye * yt, He += Ye * St, Ye = lt[4], h += Ye * ni, B += Ye * Ct, Z += Ye * Wt, ve += Ye * ii, ge += Ye * Pt, xe += Ye * Rt, X += Ye * ai, a += Ye * Nt, Y += Ye * qt, Ne += Ye * oi, Ke += Ye * ct, tt += Ye * Ze, We += Ye * at, ot += Ye * dt, He += Ye * yt, Qe += Ye * St, Ye = lt[5], B += Ye * ni, Z += Ye * Ct, ve += Ye * Wt, ge += Ye * ii, xe += Ye * Pt, X += Ye * Rt, a += Ye * ai, Y += Ye * Nt, Ne += Ye * qt, Ke += Ye * oi, tt += Ye * ct, We += Ye * Ze, ot += Ye * at, He += Ye * dt, Qe += Ye * yt, nt += Ye * St, Ye = lt[6], Z += Ye * ni, ve += Ye * Ct, ge += Ye * Wt, xe += Ye * ii, X += Ye * Pt, a += Ye * Rt, Y += Ye * ai, Ne += Ye * Nt, Ke += Ye * qt, tt += Ye * oi, We += Ye * ct, ot += Ye * Ze, He += Ye * at, Qe += Ye * dt, nt += Ye * yt, je += Ye * St, Ye = lt[7], ve += Ye * ni, ge += Ye * Ct, xe += Ye * Wt, X += Ye * ii, a += Ye * Pt, Y += Ye * Rt, Ne += Ye * ai, Ke += Ye * Nt, tt += Ye * qt, We += Ye * oi, ot += Ye * ct, He += Ye * Ze, Qe += Ye * at, nt += Ye * dt, je += Ye * yt, it += Ye * St, Ye = lt[8], ge += Ye * ni, xe += Ye * Ct, X += Ye * Wt, a += Ye * ii, Y += Ye * Pt, Ne += Ye * Rt, Ke += Ye * ai, tt += Ye * Nt, We += Ye * qt, ot += Ye * oi, He += Ye * ct, Qe += Ye * Ze, nt += Ye * at, je += Ye * dt, it += Ye * yt, st += Ye * St, Ye = lt[9], xe += Ye * ni, X += Ye * Ct, a += Ye * Wt, Y += Ye * ii, Ne += Ye * Pt, Ke += Ye * Rt, tt += Ye * ai, We += Ye * Nt, ot += Ye * qt, He += Ye * oi, Qe += Ye * ct, nt += Ye * Ze, je += Ye * at, it += Ye * dt, st += Ye * yt, gt += Ye * St, Ye = lt[10], X += Ye * ni, a += Ye * Ct, Y += Ye * Wt, Ne += Ye * ii, Ke += Ye * Pt, tt += Ye * Rt, We += Ye * ai, ot += Ye * Nt, He += Ye * qt, Qe += Ye * oi, nt += Ye * ct, je += Ye * Ze, it += Ye * at, st += Ye * dt, gt += Ye * yt, It += Ye * St, Ye = lt[11], a += Ye * ni, Y += Ye * Ct, Ne += Ye * Wt, Ke += Ye * ii, tt += Ye * Pt, We += Ye * Rt, ot += Ye * ai, He += Ye * Nt, Qe += Ye * qt, nt += Ye * oi, je += Ye * ct, it += Ye * Ze, st += Ye * at, gt += Ye * dt, It += Ye * yt, At += Ye * St, Ye = lt[12], Y += Ye * ni, Ne += Ye * Ct, Ke += Ye * Wt, tt += Ye * ii, We += Ye * Pt, ot += Ye * Rt, He += Ye * ai, Qe += Ye * Nt, nt += Ye * qt, je += Ye * oi, it += Ye * ct, st += Ye * Ze, gt += Ye * at, It += Ye * dt, At += Ye * yt, Et += Ye * St, Ye = lt[13], Ne += Ye * ni, Ke += Ye * Ct, tt += Ye * Wt, We += Ye * ii, ot += Ye * Pt, He += Ye * Rt, Qe += Ye * ai, nt += Ye * Nt, je += Ye * qt, it += Ye * oi, st += Ye * ct, gt += Ye * Ze, It += Ye * at, At += Ye * dt, Et += Ye * yt, ei += Ye * St, Ye = lt[14], Ke += Ye * ni, tt += Ye * Ct, We += Ye * Wt, ot += Ye * ii, He += Ye * Pt, Qe += Ye * Rt, nt += Ye * ai, je += Ye * Nt, it += Ye * qt, st += Ye * oi, gt += Ye * ct, It += Ye * Ze, At += Ye * at, Et += Ye * dt, ei += Ye * yt, Xt += Ye * St, Ye = lt[15], tt += Ye * ni, We += Ye * Ct, ot += Ye * Wt, He += Ye * ii, Qe += Ye * Pt, nt += Ye * Rt, je += Ye * ai, it += Ye * Nt, st += Ye * qt, gt += Ye * oi, It += Ye * ct, At += Ye * Ze, Et += Ye * at, ei += Ye * dt, Xt += Ye * yt, _t += Ye * St, bt += 38 * We, Yt += 38 * ot, Se += 38 * He, t += 38 * Qe, h += 38 * nt, B += 38 * je, Z += 38 * it, ve += 38 * st, ge += 38 * gt, xe += 38 * It, X += 38 * At, a += 38 * Et, Y += 38 * ei, Ne += 38 * Xt, Ke += 38 * _t, pt = 1, Ye = bt + pt + 65535, pt = Math.floor(Ye / 65536), bt = Ye - pt * 65536, Ye = Yt + pt + 65535, pt = Math.floor(Ye / 65536), Yt = Ye - pt * 65536, Ye = Se + pt + 65535, pt = Math.floor(Ye / 65536), Se = Ye - pt * 65536, Ye = t + pt + 65535, pt = Math.floor(Ye / 65536), t = Ye - pt * 65536, Ye = h + pt + 65535, pt = Math.floor(Ye / 65536), h = Ye - pt * 65536, Ye = B + pt + 65535, pt = Math.floor(Ye / 65536), B = Ye - pt * 65536, Ye = Z + pt + 65535, pt = Math.floor(Ye / 65536), Z = Ye - pt * 65536, Ye = ve + pt + 65535, pt = Math.floor(Ye / 65536), ve = Ye - pt * 65536, Ye = ge + pt + 65535, pt = Math.floor(Ye / 65536), ge = Ye - pt * 65536, Ye = xe + pt + 65535, pt = Math.floor(Ye / 65536), xe = Ye - pt * 65536, Ye = X + pt + 65535, pt = Math.floor(Ye / 65536), X = Ye - pt * 65536, Ye = a + pt + 65535, pt = Math.floor(Ye / 65536), a = Ye - pt * 65536, Ye = Y + pt + 65535, pt = Math.floor(Ye / 65536), Y = Ye - pt * 65536, Ye = Ne + pt + 65535, pt = Math.floor(Ye / 65536), Ne = Ye - pt * 65536, Ye = Ke + pt + 65535, pt = Math.floor(Ye / 65536), Ke = Ye - pt * 65536, Ye = tt + pt + 65535, pt = Math.floor(Ye / 65536), tt = Ye - pt * 65536, bt += pt - 1 + 37 * (pt - 1), pt = 1, Ye = bt + pt + 65535, pt = Math.floor(Ye / 65536), bt = Ye - pt * 65536, Ye = Yt + pt + 65535, pt = Math.floor(Ye / 65536), Yt = Ye - pt * 65536, Ye = Se + pt + 65535, pt = Math.floor(Ye / 65536), Se = Ye - pt * 65536, Ye = t + pt + 65535, pt = Math.floor(Ye / 65536), t = Ye - pt * 65536, Ye = h + pt + 65535, pt = Math.floor(Ye / 65536), h = Ye - pt * 65536, Ye = B + pt + 65535, pt = Math.floor(Ye / 65536), B = Ye - pt * 65536, Ye = Z + pt + 65535, pt = Math.floor(Ye / 65536), Z = Ye - pt * 65536, Ye = ve + pt + 65535, pt = Math.floor(Ye / 65536), ve = Ye - pt * 65536, Ye = ge + pt + 65535, pt = Math.floor(Ye / 65536), ge = Ye - pt * 65536, Ye = xe + pt + 65535, pt = Math.floor(Ye / 65536), xe = Ye - pt * 65536, Ye = X + pt + 65535, pt = Math.floor(Ye / 65536), X = Ye - pt * 65536, Ye = a + pt + 65535, pt = Math.floor(Ye / 65536), a = Ye - pt * 65536, Ye = Y + pt + 65535, pt = Math.floor(Ye / 65536), Y = Ye - pt * 65536, Ye = Ne + pt + 65535, pt = Math.floor(Ye / 65536), Ne = Ye - pt * 65536, Ye = Ke + pt + 65535, pt = Math.floor(Ye / 65536), Ke = Ye - pt * 65536, Ye = tt + pt + 65535, pt = Math.floor(Ye / 65536), tt = Ye - pt * 65536, bt += pt - 1 + 37 * (pt - 1), rt[0] = bt, rt[1] = Yt, rt[2] = Se, rt[3] = t, rt[4] = h, rt[5] = B, rt[6] = Z, rt[7] = ve, rt[8] = ge, rt[9] = xe, rt[10] = X, rt[11] = a, rt[12] = Y, rt[13] = Ne, rt[14] = Ke, rt[15] = tt;
  }
  function ke(rt, lt) {
    Le(rt, lt, lt);
  }
  function Fe(rt, lt) {
    const vt = J();
    for (let Ye = 0; Ye < 16; Ye++)
      vt[Ye] = lt[Ye];
    for (let Ye = 253; Ye >= 0; Ye--)
      ke(vt, vt), Ye !== 2 && Ye !== 4 && Le(vt, vt, lt);
    for (let Ye = 0; Ye < 16; Ye++)
      rt[Ye] = vt[Ye];
  }
  function Ge(rt, lt) {
    const vt = new Uint8Array(32), Ye = new Float64Array(80), pt = J(), bt = J(), Yt = J(), Se = J(), t = J(), h = J();
    for (let ge = 0; ge < 31; ge++)
      vt[ge] = rt[ge];
    vt[31] = rt[31] & 127 | 64, vt[0] &= 248, Te(Ye, lt);
    for (let ge = 0; ge < 16; ge++)
      bt[ge] = Ye[ge];
    pt[0] = Se[0] = 1;
    for (let ge = 254; ge >= 0; --ge) {
      const xe = vt[ge >>> 3] >>> (ge & 7) & 1;
      Ie(pt, bt, xe), Ie(Yt, Se, xe), Ee(t, pt, Yt), Oe(pt, pt, Yt), Ee(Yt, bt, Se), Oe(bt, bt, Se), ke(Se, t), ke(h, pt), Le(pt, Yt, pt), Le(Yt, bt, t), Ee(t, pt, Yt), Oe(pt, pt, Yt), ke(bt, pt), Oe(Yt, Se, h), Le(pt, Yt, H), Ee(pt, pt, Se), Le(Yt, Yt, pt), Le(pt, Se, h), Le(Se, bt, Ye), ke(bt, t), Ie(pt, bt, xe), Ie(Yt, Se, xe);
    }
    for (let ge = 0; ge < 16; ge++)
      Ye[ge + 16] = pt[ge], Ye[ge + 32] = Yt[ge], Ye[ge + 48] = bt[ge], Ye[ge + 64] = Se[ge];
    const B = Ye.subarray(32), Z = Ye.subarray(16);
    Fe(B, B), Le(Z, Z, B);
    const ve = new Uint8Array(32);
    return qe(ve, Z), ve;
  }
  I.scalarMult = Ge;
  function et(rt) {
    return Ge(rt, _e);
  }
  I.scalarMultBase = et;
  function Ve(rt) {
    if (rt.length !== I.SECRET_KEY_LENGTH)
      throw new Error(`x25519: seed must be ${I.SECRET_KEY_LENGTH} bytes`);
    const lt = new Uint8Array(rt);
    return {
      publicKey: et(lt),
      secretKey: lt
    };
  }
  I.generateKeyPairFromSeed = Ve;
  function Je(rt) {
    const lt = (0, A.randomBytes)(32, rt), vt = Ve(lt);
    return (0, G.wipe)(lt), vt;
  }
  I.generateKeyPair = Je;
  function ut(rt, lt, vt = !1) {
    if (rt.length !== I.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect secret key length");
    if (lt.length !== I.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect public key length");
    const Ye = Ge(rt, lt);
    if (vt) {
      let pt = 0;
      for (let bt = 0; bt < Ye.length; bt++)
        pt |= Ye[bt];
      if (pt === 0)
        throw new Error("X25519: invalid shared key");
    }
    return Ye;
  }
  I.sharedKey = ut;
})(x25519);
function base$1(I, A) {
  if (I.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var G = new Uint8Array(256), J = 0; J < G.length; J++)
    G[J] = 255;
  for (var _e = 0; _e < I.length; _e++) {
    var H = I.charAt(_e), De = H.charCodeAt(0);
    if (G[De] !== 255)
      throw new TypeError(H + " is ambiguous");
    G[De] = _e;
  }
  var Ie = I.length, qe = I.charAt(0), Te = Math.log(Ie) / Math.log(256), Ee = Math.log(256) / Math.log(Ie);
  function Oe(Fe) {
    if (Fe instanceof Uint8Array || (ArrayBuffer.isView(Fe) ? Fe = new Uint8Array(Fe.buffer, Fe.byteOffset, Fe.byteLength) : Array.isArray(Fe) && (Fe = Uint8Array.from(Fe))), !(Fe instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (Fe.length === 0)
      return "";
    for (var Ge = 0, et = 0, Ve = 0, Je = Fe.length; Ve !== Je && Fe[Ve] === 0; )
      Ve++, Ge++;
    for (var ut = (Je - Ve) * Ee + 1 >>> 0, rt = new Uint8Array(ut); Ve !== Je; ) {
      for (var lt = Fe[Ve], vt = 0, Ye = ut - 1; (lt !== 0 || vt < et) && Ye !== -1; Ye--, vt++)
        lt += 256 * rt[Ye] >>> 0, rt[Ye] = lt % Ie >>> 0, lt = lt / Ie >>> 0;
      if (lt !== 0)
        throw new Error("Non-zero carry");
      et = vt, Ve++;
    }
    for (var pt = ut - et; pt !== ut && rt[pt] === 0; )
      pt++;
    for (var bt = qe.repeat(Ge); pt < ut; ++pt)
      bt += I.charAt(rt[pt]);
    return bt;
  }
  function Le(Fe) {
    if (typeof Fe != "string")
      throw new TypeError("Expected String");
    if (Fe.length === 0)
      return new Uint8Array();
    var Ge = 0;
    if (Fe[Ge] !== " ") {
      for (var et = 0, Ve = 0; Fe[Ge] === qe; )
        et++, Ge++;
      for (var Je = (Fe.length - Ge) * Te + 1 >>> 0, ut = new Uint8Array(Je); Fe[Ge]; ) {
        var rt = G[Fe.charCodeAt(Ge)];
        if (rt === 255)
          return;
        for (var lt = 0, vt = Je - 1; (rt !== 0 || lt < Ve) && vt !== -1; vt--, lt++)
          rt += Ie * ut[vt] >>> 0, ut[vt] = rt % 256 >>> 0, rt = rt / 256 >>> 0;
        if (rt !== 0)
          throw new Error("Non-zero carry");
        Ve = lt, Ge++;
      }
      if (Fe[Ge] !== " ") {
        for (var Ye = Je - Ve; Ye !== Je && ut[Ye] === 0; )
          Ye++;
        for (var pt = new Uint8Array(et + (Je - Ye)), bt = et; Ye !== Je; )
          pt[bt++] = ut[Ye++];
        return pt;
      }
    }
  }
  function ke(Fe) {
    var Ge = Le(Fe);
    if (Ge)
      return Ge;
    throw new Error(`Non-${A} character`);
  }
  return {
    encode: Oe,
    decodeUnsafe: Le,
    decode: ke
  };
}
var src = base$1, _brrp__multiformats_scope_baseX = src;
const coerce = (I) => {
  if (I instanceof Uint8Array && I.constructor.name === "Uint8Array")
    return I;
  if (I instanceof ArrayBuffer)
    return new Uint8Array(I);
  if (ArrayBuffer.isView(I))
    return new Uint8Array(I.buffer, I.byteOffset, I.byteLength);
  throw new Error("Unknown type, must be binary type");
}, fromString = (I) => new TextEncoder().encode(I), toString = (I) => new TextDecoder().decode(I);
class Encoder {
  constructor(A, G, J) {
    this.name = A, this.prefix = G, this.baseEncode = J;
  }
  encode(A) {
    if (A instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(A)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class Decoder {
  constructor(A, G, J) {
    if (this.name = A, this.prefix = G, G.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = G.codePointAt(0), this.baseDecode = J;
  }
  decode(A) {
    if (typeof A == "string") {
      if (A.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(A)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(A.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(A) {
    return or$1(this, A);
  }
}
class ComposedDecoder {
  constructor(A) {
    this.decoders = A;
  }
  or(A) {
    return or$1(this, A);
  }
  decode(A) {
    const G = A[0], J = this.decoders[G];
    if (J)
      return J.decode(A);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(A)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const or$1 = (I, A) => new ComposedDecoder({
  ...I.decoders || { [I.prefix]: I },
  ...A.decoders || { [A.prefix]: A }
});
class Codec {
  constructor(A, G, J, _e) {
    this.name = A, this.prefix = G, this.baseEncode = J, this.baseDecode = _e, this.encoder = new Encoder(A, G, J), this.decoder = new Decoder(A, G, _e);
  }
  encode(A) {
    return this.encoder.encode(A);
  }
  decode(A) {
    return this.decoder.decode(A);
  }
}
const from = ({ name: I, prefix: A, encode: G, decode: J }) => new Codec(I, A, G, J), baseX = ({ prefix: I, name: A, alphabet: G }) => {
  const { encode: J, decode: _e } = _brrp__multiformats_scope_baseX(G, A);
  return from({
    prefix: I,
    name: A,
    encode: J,
    decode: (H) => coerce(_e(H))
  });
}, decode$1 = (I, A, G, J) => {
  const _e = {};
  for (let Ee = 0; Ee < A.length; ++Ee)
    _e[A[Ee]] = Ee;
  let H = I.length;
  for (; I[H - 1] === "="; )
    --H;
  const De = new Uint8Array(H * G / 8 | 0);
  let Ie = 0, qe = 0, Te = 0;
  for (let Ee = 0; Ee < H; ++Ee) {
    const Oe = _e[I[Ee]];
    if (Oe === void 0)
      throw new SyntaxError(`Non-${J} character`);
    qe = qe << G | Oe, Ie += G, Ie >= 8 && (Ie -= 8, De[Te++] = 255 & qe >> Ie);
  }
  if (Ie >= G || 255 & qe << 8 - Ie)
    throw new SyntaxError("Unexpected end of data");
  return De;
}, encode$1 = (I, A, G) => {
  const J = A[A.length - 1] === "=", _e = (1 << G) - 1;
  let H = "", De = 0, Ie = 0;
  for (let qe = 0; qe < I.length; ++qe)
    for (Ie = Ie << 8 | I[qe], De += 8; De > G; )
      De -= G, H += A[_e & Ie >> De];
  if (De && (H += A[_e & Ie << G - De]), J)
    for (; H.length * G & 7; )
      H += "=";
  return H;
}, rfc4648 = ({ name: I, prefix: A, bitsPerChar: G, alphabet: J }) => from({
  prefix: A,
  name: I,
  encode(_e) {
    return encode$1(_e, J, G);
  },
  decode(_e) {
    return decode$1(_e, J, G, I);
  }
});
from({
  prefix: "\0",
  name: "identity",
  encode: (I) => toString(I),
  decode: (I) => fromString(I)
});
rfc4648({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
});
rfc4648({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
});
baseX({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
});
rfc4648({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
});
rfc4648({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
});
rfc4648({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
});
rfc4648({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
});
rfc4648({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
});
rfc4648({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
});
rfc4648({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
});
rfc4648({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
});
rfc4648({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
});
rfc4648({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
});
rfc4648({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
});
baseX({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
baseX({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
baseX({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
baseX({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
rfc4648({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
});
rfc4648({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
});
rfc4648({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
});
rfc4648({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
});
const alphabet = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), alphabetBytesToChars = alphabet.reduce((I, A, G) => (I[G] = A, I), []), alphabetCharsToBytes = alphabet.reduce((I, A, G) => (I[A.codePointAt(0)] = G, I), []);
function encode(I) {
  return I.reduce((A, G) => (A += alphabetBytesToChars[G], A), "");
}
function decode(I) {
  const A = [];
  for (const G of I) {
    const J = alphabetCharsToBytes[G.codePointAt(0)];
    if (J === void 0)
      throw new Error(`Non-base256emoji character: ${G}`);
    A.push(J);
  }
  return new Uint8Array(A);
}
from({
  prefix: "🚀",
  name: "base256emoji",
  encode,
  decode
});
new TextEncoder();
new TextDecoder();
var elliptic = {};
const name = "elliptic", version = "6.6.1", description = "EC cryptography", main = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0 = {
  name,
  version,
  description,
  main,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$a = {}, bn = { exports: {} };
bn.exports;
(function(I) {
  (function(A, G) {
    function J(Se, t) {
      if (!Se) throw new Error(t || "Assertion failed");
    }
    function _e(Se, t) {
      Se.super_ = t;
      var h = function() {
      };
      h.prototype = t.prototype, Se.prototype = new h(), Se.prototype.constructor = Se;
    }
    function H(Se, t, h) {
      if (H.isBN(Se))
        return Se;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, Se !== null && ((t === "le" || t === "be") && (h = t, t = 10), this._init(Se || 0, t || 10, h || "be"));
    }
    typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
    var De;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = require$$0$3.Buffer;
    } catch {
    }
    H.isBN = function(t) {
      return t instanceof H ? !0 : t !== null && typeof t == "object" && t.constructor.wordSize === H.wordSize && Array.isArray(t.words);
    }, H.max = function(t, h) {
      return t.cmp(h) > 0 ? t : h;
    }, H.min = function(t, h) {
      return t.cmp(h) < 0 ? t : h;
    }, H.prototype._init = function(t, h, B) {
      if (typeof t == "number")
        return this._initNumber(t, h, B);
      if (typeof t == "object")
        return this._initArray(t, h, B);
      h === "hex" && (h = 16), J(h === (h | 0) && h >= 2 && h <= 36), t = t.toString().replace(/\s+/g, "");
      var Z = 0;
      t[0] === "-" && (Z++, this.negative = 1), Z < t.length && (h === 16 ? this._parseHex(t, Z, B) : (this._parseBase(t, h, Z), B === "le" && this._initArray(this.toArray(), h, B)));
    }, H.prototype._initNumber = function(t, h, B) {
      t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [t & 67108863], this.length = 1) : t < 4503599627370496 ? (this.words = [
        t & 67108863,
        t / 67108864 & 67108863
      ], this.length = 2) : (J(t < 9007199254740992), this.words = [
        t & 67108863,
        t / 67108864 & 67108863,
        1
      ], this.length = 3), B === "le" && this._initArray(this.toArray(), h, B);
    }, H.prototype._initArray = function(t, h, B) {
      if (J(typeof t.length == "number"), t.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);
      for (var Z = 0; Z < this.length; Z++)
        this.words[Z] = 0;
      var ve, ge, xe = 0;
      if (B === "be")
        for (Z = t.length - 1, ve = 0; Z >= 0; Z -= 3)
          ge = t[Z] | t[Z - 1] << 8 | t[Z - 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
      else if (B === "le")
        for (Z = 0, ve = 0; Z < t.length; Z += 3)
          ge = t[Z] | t[Z + 1] << 8 | t[Z + 2] << 16, this.words[ve] |= ge << xe & 67108863, this.words[ve + 1] = ge >>> 26 - xe & 67108863, xe += 24, xe >= 26 && (xe -= 26, ve++);
      return this.strip();
    };
    function Ie(Se, t) {
      var h = Se.charCodeAt(t);
      return h >= 65 && h <= 70 ? h - 55 : h >= 97 && h <= 102 ? h - 87 : h - 48 & 15;
    }
    function qe(Se, t, h) {
      var B = Ie(Se, h);
      return h - 1 >= t && (B |= Ie(Se, h - 1) << 4), B;
    }
    H.prototype._parseHex = function(t, h, B) {
      this.length = Math.ceil((t.length - h) / 6), this.words = new Array(this.length);
      for (var Z = 0; Z < this.length; Z++)
        this.words[Z] = 0;
      var ve = 0, ge = 0, xe;
      if (B === "be")
        for (Z = t.length - 1; Z >= h; Z -= 2)
          xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
      else {
        var X = t.length - h;
        for (Z = X % 2 === 0 ? h + 1 : h; Z < t.length; Z += 2)
          xe = qe(t, h, Z) << ve, this.words[ge] |= xe & 67108863, ve >= 18 ? (ve -= 18, ge += 1, this.words[ge] |= xe >>> 26) : ve += 8;
      }
      this.strip();
    };
    function Te(Se, t, h, B) {
      for (var Z = 0, ve = Math.min(Se.length, h), ge = t; ge < ve; ge++) {
        var xe = Se.charCodeAt(ge) - 48;
        Z *= B, xe >= 49 ? Z += xe - 49 + 10 : xe >= 17 ? Z += xe - 17 + 10 : Z += xe;
      }
      return Z;
    }
    H.prototype._parseBase = function(t, h, B) {
      this.words = [0], this.length = 1;
      for (var Z = 0, ve = 1; ve <= 67108863; ve *= h)
        Z++;
      Z--, ve = ve / h | 0;
      for (var ge = t.length - B, xe = ge % Z, X = Math.min(ge, ge - xe) + B, a = 0, Y = B; Y < X; Y += Z)
        a = Te(t, Y, Y + Z, h), this.imuln(ve), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
      if (xe !== 0) {
        var Ne = 1;
        for (a = Te(t, Y, t.length, h), Y = 0; Y < xe; Y++)
          Ne *= h;
        this.imuln(Ne), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
      }
      this.strip();
    }, H.prototype.copy = function(t) {
      t.words = new Array(this.length);
      for (var h = 0; h < this.length; h++)
        t.words[h] = this.words[h];
      t.length = this.length, t.negative = this.negative, t.red = this.red;
    }, H.prototype.clone = function() {
      var t = new H(null);
      return this.copy(t), t;
    }, H.prototype._expand = function(t) {
      for (; this.length < t; )
        this.words[this.length++] = 0;
      return this;
    }, H.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, H.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, H.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var Ee = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], Oe = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Le = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    H.prototype.toString = function(t, h) {
      t = t || 10, h = h | 0 || 1;
      var B;
      if (t === 16 || t === "hex") {
        B = "";
        for (var Z = 0, ve = 0, ge = 0; ge < this.length; ge++) {
          var xe = this.words[ge], X = ((xe << Z | ve) & 16777215).toString(16);
          ve = xe >>> 24 - Z & 16777215, ve !== 0 || ge !== this.length - 1 ? B = Ee[6 - X.length] + X + B : B = X + B, Z += 2, Z >= 26 && (Z -= 26, ge--);
        }
        for (ve !== 0 && (B = ve.toString(16) + B); B.length % h !== 0; )
          B = "0" + B;
        return this.negative !== 0 && (B = "-" + B), B;
      }
      if (t === (t | 0) && t >= 2 && t <= 36) {
        var a = Oe[t], Y = Le[t];
        B = "";
        var Ne = this.clone();
        for (Ne.negative = 0; !Ne.isZero(); ) {
          var Ke = Ne.modn(Y).toString(t);
          Ne = Ne.idivn(Y), Ne.isZero() ? B = Ke + B : B = Ee[a - Ke.length] + Ke + B;
        }
        for (this.isZero() && (B = "0" + B); B.length % h !== 0; )
          B = "0" + B;
        return this.negative !== 0 && (B = "-" + B), B;
      }
      J(!1, "Base should be between 2 and 36");
    }, H.prototype.toNumber = function() {
      var t = this.words[0];
      return this.length === 2 ? t += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? t += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -t : t;
    }, H.prototype.toJSON = function() {
      return this.toString(16);
    }, H.prototype.toBuffer = function(t, h) {
      return J(typeof De < "u"), this.toArrayLike(De, t, h);
    }, H.prototype.toArray = function(t, h) {
      return this.toArrayLike(Array, t, h);
    }, H.prototype.toArrayLike = function(t, h, B) {
      var Z = this.byteLength(), ve = B || Math.max(1, Z);
      J(Z <= ve, "byte array longer than desired length"), J(ve > 0, "Requested array length <= 0"), this.strip();
      var ge = h === "le", xe = new t(ve), X, a, Y = this.clone();
      if (ge) {
        for (a = 0; !Y.isZero(); a++)
          X = Y.andln(255), Y.iushrn(8), xe[a] = X;
        for (; a < ve; a++)
          xe[a] = 0;
      } else {
        for (a = 0; a < ve - Z; a++)
          xe[a] = 0;
        for (a = 0; !Y.isZero(); a++)
          X = Y.andln(255), Y.iushrn(8), xe[ve - a - 1] = X;
      }
      return xe;
    }, Math.clz32 ? H.prototype._countBits = function(t) {
      return 32 - Math.clz32(t);
    } : H.prototype._countBits = function(t) {
      var h = t, B = 0;
      return h >= 4096 && (B += 13, h >>>= 13), h >= 64 && (B += 7, h >>>= 7), h >= 8 && (B += 4, h >>>= 4), h >= 2 && (B += 2, h >>>= 2), B + h;
    }, H.prototype._zeroBits = function(t) {
      if (t === 0) return 26;
      var h = t, B = 0;
      return h & 8191 || (B += 13, h >>>= 13), h & 127 || (B += 7, h >>>= 7), h & 15 || (B += 4, h >>>= 4), h & 3 || (B += 2, h >>>= 2), h & 1 || B++, B;
    }, H.prototype.bitLength = function() {
      var t = this.words[this.length - 1], h = this._countBits(t);
      return (this.length - 1) * 26 + h;
    };
    function ke(Se) {
      for (var t = new Array(Se.bitLength()), h = 0; h < t.length; h++) {
        var B = h / 26 | 0, Z = h % 26;
        t[h] = (Se.words[B] & 1 << Z) >>> Z;
      }
      return t;
    }
    H.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var t = 0, h = 0; h < this.length; h++) {
        var B = this._zeroBits(this.words[h]);
        if (t += B, B !== 26) break;
      }
      return t;
    }, H.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, H.prototype.toTwos = function(t) {
      return this.negative !== 0 ? this.abs().inotn(t).iaddn(1) : this.clone();
    }, H.prototype.fromTwos = function(t) {
      return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
    }, H.prototype.isNeg = function() {
      return this.negative !== 0;
    }, H.prototype.neg = function() {
      return this.clone().ineg();
    }, H.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, H.prototype.iuor = function(t) {
      for (; this.length < t.length; )
        this.words[this.length++] = 0;
      for (var h = 0; h < t.length; h++)
        this.words[h] = this.words[h] | t.words[h];
      return this.strip();
    }, H.prototype.ior = function(t) {
      return J((this.negative | t.negative) === 0), this.iuor(t);
    }, H.prototype.or = function(t) {
      return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
    }, H.prototype.uor = function(t) {
      return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
    }, H.prototype.iuand = function(t) {
      var h;
      this.length > t.length ? h = t : h = this;
      for (var B = 0; B < h.length; B++)
        this.words[B] = this.words[B] & t.words[B];
      return this.length = h.length, this.strip();
    }, H.prototype.iand = function(t) {
      return J((this.negative | t.negative) === 0), this.iuand(t);
    }, H.prototype.and = function(t) {
      return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
    }, H.prototype.uand = function(t) {
      return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
    }, H.prototype.iuxor = function(t) {
      var h, B;
      this.length > t.length ? (h = this, B = t) : (h = t, B = this);
      for (var Z = 0; Z < B.length; Z++)
        this.words[Z] = h.words[Z] ^ B.words[Z];
      if (this !== h)
        for (; Z < h.length; Z++)
          this.words[Z] = h.words[Z];
      return this.length = h.length, this.strip();
    }, H.prototype.ixor = function(t) {
      return J((this.negative | t.negative) === 0), this.iuxor(t);
    }, H.prototype.xor = function(t) {
      return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
    }, H.prototype.uxor = function(t) {
      return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
    }, H.prototype.inotn = function(t) {
      J(typeof t == "number" && t >= 0);
      var h = Math.ceil(t / 26) | 0, B = t % 26;
      this._expand(h), B > 0 && h--;
      for (var Z = 0; Z < h; Z++)
        this.words[Z] = ~this.words[Z] & 67108863;
      return B > 0 && (this.words[Z] = ~this.words[Z] & 67108863 >> 26 - B), this.strip();
    }, H.prototype.notn = function(t) {
      return this.clone().inotn(t);
    }, H.prototype.setn = function(t, h) {
      J(typeof t == "number" && t >= 0);
      var B = t / 26 | 0, Z = t % 26;
      return this._expand(B + 1), h ? this.words[B] = this.words[B] | 1 << Z : this.words[B] = this.words[B] & ~(1 << Z), this.strip();
    }, H.prototype.iadd = function(t) {
      var h;
      if (this.negative !== 0 && t.negative === 0)
        return this.negative = 0, h = this.isub(t), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && t.negative !== 0)
        return t.negative = 0, h = this.isub(t), t.negative = 1, h._normSign();
      var B, Z;
      this.length > t.length ? (B = this, Z = t) : (B = t, Z = this);
      for (var ve = 0, ge = 0; ge < Z.length; ge++)
        h = (B.words[ge] | 0) + (Z.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
      for (; ve !== 0 && ge < B.length; ge++)
        h = (B.words[ge] | 0) + ve, this.words[ge] = h & 67108863, ve = h >>> 26;
      if (this.length = B.length, ve !== 0)
        this.words[this.length] = ve, this.length++;
      else if (B !== this)
        for (; ge < B.length; ge++)
          this.words[ge] = B.words[ge];
      return this;
    }, H.prototype.add = function(t) {
      var h;
      return t.negative !== 0 && this.negative === 0 ? (t.negative = 0, h = this.sub(t), t.negative ^= 1, h) : t.negative === 0 && this.negative !== 0 ? (this.negative = 0, h = t.sub(this), this.negative = 1, h) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
    }, H.prototype.isub = function(t) {
      if (t.negative !== 0) {
        t.negative = 0;
        var h = this.iadd(t);
        return t.negative = 1, h._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
      var B = this.cmp(t);
      if (B === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var Z, ve;
      B > 0 ? (Z = this, ve = t) : (Z = t, ve = this);
      for (var ge = 0, xe = 0; xe < ve.length; xe++)
        h = (Z.words[xe] | 0) - (ve.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
      for (; ge !== 0 && xe < Z.length; xe++)
        h = (Z.words[xe] | 0) + ge, ge = h >> 26, this.words[xe] = h & 67108863;
      if (ge === 0 && xe < Z.length && Z !== this)
        for (; xe < Z.length; xe++)
          this.words[xe] = Z.words[xe];
      return this.length = Math.max(this.length, xe), Z !== this && (this.negative = 1), this.strip();
    }, H.prototype.sub = function(t) {
      return this.clone().isub(t);
    };
    function Fe(Se, t, h) {
      h.negative = t.negative ^ Se.negative;
      var B = Se.length + t.length | 0;
      h.length = B, B = B - 1 | 0;
      var Z = Se.words[0] | 0, ve = t.words[0] | 0, ge = Z * ve, xe = ge & 67108863, X = ge / 67108864 | 0;
      h.words[0] = xe;
      for (var a = 1; a < B; a++) {
        for (var Y = X >>> 26, Ne = X & 67108863, Ke = Math.min(a, t.length - 1), tt = Math.max(0, a - Se.length + 1); tt <= Ke; tt++) {
          var We = a - tt | 0;
          Z = Se.words[We] | 0, ve = t.words[tt] | 0, ge = Z * ve + Ne, Y += ge / 67108864 | 0, Ne = ge & 67108863;
        }
        h.words[a] = Ne | 0, X = Y | 0;
      }
      return X !== 0 ? h.words[a] = X | 0 : h.length--, h.strip();
    }
    var Ge = function(t, h, B) {
      var Z = t.words, ve = h.words, ge = B.words, xe = 0, X, a, Y, Ne = Z[0] | 0, Ke = Ne & 8191, tt = Ne >>> 13, We = Z[1] | 0, ot = We & 8191, He = We >>> 13, Qe = Z[2] | 0, nt = Qe & 8191, je = Qe >>> 13, it = Z[3] | 0, st = it & 8191, gt = it >>> 13, It = Z[4] | 0, At = It & 8191, Et = It >>> 13, ei = Z[5] | 0, Xt = ei & 8191, _t = ei >>> 13, ni = Z[6] | 0, Ct = ni & 8191, Wt = ni >>> 13, ii = Z[7] | 0, Pt = ii & 8191, Rt = ii >>> 13, ai = Z[8] | 0, Nt = ai & 8191, qt = ai >>> 13, oi = Z[9] | 0, ct = oi & 8191, Ze = oi >>> 13, at = ve[0] | 0, dt = at & 8191, yt = at >>> 13, St = ve[1] | 0, xt = St & 8191, Vt = St >>> 13, ci = ve[2] | 0, Qt = ci & 8191, rr = ci >>> 13, ui = ve[3] | 0, Gr = ui & 8191, yr = ui >>> 13, pi = ve[4] | 0, wr = pi & 8191, _r = pi >>> 13, di = ve[5] | 0, Sr = di & 8191, Br = di >>> 13, vi = ve[6] | 0, gr = vi & 8191, $r = vi >>> 13, li = ve[7] | 0, Ir = li & 8191, Cr = li >>> 13, mi = ve[8] | 0, Pr = mi & 8191, Or = mi >>> 13, yi = ve[9] | 0, Zr = yi & 8191, Vr = yi >>> 13;
      B.negative = t.negative ^ h.negative, B.length = 19, X = Math.imul(Ke, dt), a = Math.imul(Ke, yt), a = a + Math.imul(tt, dt) | 0, Y = Math.imul(tt, yt);
      var bi = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (bi >>> 26) | 0, bi &= 67108863, X = Math.imul(ot, dt), a = Math.imul(ot, yt), a = a + Math.imul(He, dt) | 0, Y = Math.imul(He, yt), X = X + Math.imul(Ke, xt) | 0, a = a + Math.imul(Ke, Vt) | 0, a = a + Math.imul(tt, xt) | 0, Y = Y + Math.imul(tt, Vt) | 0;
      var Ai = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, X = Math.imul(nt, dt), a = Math.imul(nt, yt), a = a + Math.imul(je, dt) | 0, Y = Math.imul(je, yt), X = X + Math.imul(ot, xt) | 0, a = a + Math.imul(ot, Vt) | 0, a = a + Math.imul(He, xt) | 0, Y = Y + Math.imul(He, Vt) | 0, X = X + Math.imul(Ke, Qt) | 0, a = a + Math.imul(Ke, rr) | 0, a = a + Math.imul(tt, Qt) | 0, Y = Y + Math.imul(tt, rr) | 0;
      var Zi = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, X = Math.imul(st, dt), a = Math.imul(st, yt), a = a + Math.imul(gt, dt) | 0, Y = Math.imul(gt, yt), X = X + Math.imul(nt, xt) | 0, a = a + Math.imul(nt, Vt) | 0, a = a + Math.imul(je, xt) | 0, Y = Y + Math.imul(je, Vt) | 0, X = X + Math.imul(ot, Qt) | 0, a = a + Math.imul(ot, rr) | 0, a = a + Math.imul(He, Qt) | 0, Y = Y + Math.imul(He, rr) | 0, X = X + Math.imul(Ke, Gr) | 0, a = a + Math.imul(Ke, yr) | 0, a = a + Math.imul(tt, Gr) | 0, Y = Y + Math.imul(tt, yr) | 0;
      var Ji = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, X = Math.imul(At, dt), a = Math.imul(At, yt), a = a + Math.imul(Et, dt) | 0, Y = Math.imul(Et, yt), X = X + Math.imul(st, xt) | 0, a = a + Math.imul(st, Vt) | 0, a = a + Math.imul(gt, xt) | 0, Y = Y + Math.imul(gt, Vt) | 0, X = X + Math.imul(nt, Qt) | 0, a = a + Math.imul(nt, rr) | 0, a = a + Math.imul(je, Qt) | 0, Y = Y + Math.imul(je, rr) | 0, X = X + Math.imul(ot, Gr) | 0, a = a + Math.imul(ot, yr) | 0, a = a + Math.imul(He, Gr) | 0, Y = Y + Math.imul(He, yr) | 0, X = X + Math.imul(Ke, wr) | 0, a = a + Math.imul(Ke, _r) | 0, a = a + Math.imul(tt, wr) | 0, Y = Y + Math.imul(tt, _r) | 0;
      var Vi = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, X = Math.imul(Xt, dt), a = Math.imul(Xt, yt), a = a + Math.imul(_t, dt) | 0, Y = Math.imul(_t, yt), X = X + Math.imul(At, xt) | 0, a = a + Math.imul(At, Vt) | 0, a = a + Math.imul(Et, xt) | 0, Y = Y + Math.imul(Et, Vt) | 0, X = X + Math.imul(st, Qt) | 0, a = a + Math.imul(st, rr) | 0, a = a + Math.imul(gt, Qt) | 0, Y = Y + Math.imul(gt, rr) | 0, X = X + Math.imul(nt, Gr) | 0, a = a + Math.imul(nt, yr) | 0, a = a + Math.imul(je, Gr) | 0, Y = Y + Math.imul(je, yr) | 0, X = X + Math.imul(ot, wr) | 0, a = a + Math.imul(ot, _r) | 0, a = a + Math.imul(He, wr) | 0, Y = Y + Math.imul(He, _r) | 0, X = X + Math.imul(Ke, Sr) | 0, a = a + Math.imul(Ke, Br) | 0, a = a + Math.imul(tt, Sr) | 0, Y = Y + Math.imul(tt, Br) | 0;
      var Yi = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, X = Math.imul(Ct, dt), a = Math.imul(Ct, yt), a = a + Math.imul(Wt, dt) | 0, Y = Math.imul(Wt, yt), X = X + Math.imul(Xt, xt) | 0, a = a + Math.imul(Xt, Vt) | 0, a = a + Math.imul(_t, xt) | 0, Y = Y + Math.imul(_t, Vt) | 0, X = X + Math.imul(At, Qt) | 0, a = a + Math.imul(At, rr) | 0, a = a + Math.imul(Et, Qt) | 0, Y = Y + Math.imul(Et, rr) | 0, X = X + Math.imul(st, Gr) | 0, a = a + Math.imul(st, yr) | 0, a = a + Math.imul(gt, Gr) | 0, Y = Y + Math.imul(gt, yr) | 0, X = X + Math.imul(nt, wr) | 0, a = a + Math.imul(nt, _r) | 0, a = a + Math.imul(je, wr) | 0, Y = Y + Math.imul(je, _r) | 0, X = X + Math.imul(ot, Sr) | 0, a = a + Math.imul(ot, Br) | 0, a = a + Math.imul(He, Sr) | 0, Y = Y + Math.imul(He, Br) | 0, X = X + Math.imul(Ke, gr) | 0, a = a + Math.imul(Ke, $r) | 0, a = a + Math.imul(tt, gr) | 0, Y = Y + Math.imul(tt, $r) | 0;
      var Xi = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, X = Math.imul(Pt, dt), a = Math.imul(Pt, yt), a = a + Math.imul(Rt, dt) | 0, Y = Math.imul(Rt, yt), X = X + Math.imul(Ct, xt) | 0, a = a + Math.imul(Ct, Vt) | 0, a = a + Math.imul(Wt, xt) | 0, Y = Y + Math.imul(Wt, Vt) | 0, X = X + Math.imul(Xt, Qt) | 0, a = a + Math.imul(Xt, rr) | 0, a = a + Math.imul(_t, Qt) | 0, Y = Y + Math.imul(_t, rr) | 0, X = X + Math.imul(At, Gr) | 0, a = a + Math.imul(At, yr) | 0, a = a + Math.imul(Et, Gr) | 0, Y = Y + Math.imul(Et, yr) | 0, X = X + Math.imul(st, wr) | 0, a = a + Math.imul(st, _r) | 0, a = a + Math.imul(gt, wr) | 0, Y = Y + Math.imul(gt, _r) | 0, X = X + Math.imul(nt, Sr) | 0, a = a + Math.imul(nt, Br) | 0, a = a + Math.imul(je, Sr) | 0, Y = Y + Math.imul(je, Br) | 0, X = X + Math.imul(ot, gr) | 0, a = a + Math.imul(ot, $r) | 0, a = a + Math.imul(He, gr) | 0, Y = Y + Math.imul(He, $r) | 0, X = X + Math.imul(Ke, Ir) | 0, a = a + Math.imul(Ke, Cr) | 0, a = a + Math.imul(tt, Ir) | 0, Y = Y + Math.imul(tt, Cr) | 0;
      var en = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, X = Math.imul(Nt, dt), a = Math.imul(Nt, yt), a = a + Math.imul(qt, dt) | 0, Y = Math.imul(qt, yt), X = X + Math.imul(Pt, xt) | 0, a = a + Math.imul(Pt, Vt) | 0, a = a + Math.imul(Rt, xt) | 0, Y = Y + Math.imul(Rt, Vt) | 0, X = X + Math.imul(Ct, Qt) | 0, a = a + Math.imul(Ct, rr) | 0, a = a + Math.imul(Wt, Qt) | 0, Y = Y + Math.imul(Wt, rr) | 0, X = X + Math.imul(Xt, Gr) | 0, a = a + Math.imul(Xt, yr) | 0, a = a + Math.imul(_t, Gr) | 0, Y = Y + Math.imul(_t, yr) | 0, X = X + Math.imul(At, wr) | 0, a = a + Math.imul(At, _r) | 0, a = a + Math.imul(Et, wr) | 0, Y = Y + Math.imul(Et, _r) | 0, X = X + Math.imul(st, Sr) | 0, a = a + Math.imul(st, Br) | 0, a = a + Math.imul(gt, Sr) | 0, Y = Y + Math.imul(gt, Br) | 0, X = X + Math.imul(nt, gr) | 0, a = a + Math.imul(nt, $r) | 0, a = a + Math.imul(je, gr) | 0, Y = Y + Math.imul(je, $r) | 0, X = X + Math.imul(ot, Ir) | 0, a = a + Math.imul(ot, Cr) | 0, a = a + Math.imul(He, Ir) | 0, Y = Y + Math.imul(He, Cr) | 0, X = X + Math.imul(Ke, Pr) | 0, a = a + Math.imul(Ke, Or) | 0, a = a + Math.imul(tt, Pr) | 0, Y = Y + Math.imul(tt, Or) | 0;
      var hn = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, X = Math.imul(ct, dt), a = Math.imul(ct, yt), a = a + Math.imul(Ze, dt) | 0, Y = Math.imul(Ze, yt), X = X + Math.imul(Nt, xt) | 0, a = a + Math.imul(Nt, Vt) | 0, a = a + Math.imul(qt, xt) | 0, Y = Y + Math.imul(qt, Vt) | 0, X = X + Math.imul(Pt, Qt) | 0, a = a + Math.imul(Pt, rr) | 0, a = a + Math.imul(Rt, Qt) | 0, Y = Y + Math.imul(Rt, rr) | 0, X = X + Math.imul(Ct, Gr) | 0, a = a + Math.imul(Ct, yr) | 0, a = a + Math.imul(Wt, Gr) | 0, Y = Y + Math.imul(Wt, yr) | 0, X = X + Math.imul(Xt, wr) | 0, a = a + Math.imul(Xt, _r) | 0, a = a + Math.imul(_t, wr) | 0, Y = Y + Math.imul(_t, _r) | 0, X = X + Math.imul(At, Sr) | 0, a = a + Math.imul(At, Br) | 0, a = a + Math.imul(Et, Sr) | 0, Y = Y + Math.imul(Et, Br) | 0, X = X + Math.imul(st, gr) | 0, a = a + Math.imul(st, $r) | 0, a = a + Math.imul(gt, gr) | 0, Y = Y + Math.imul(gt, $r) | 0, X = X + Math.imul(nt, Ir) | 0, a = a + Math.imul(nt, Cr) | 0, a = a + Math.imul(je, Ir) | 0, Y = Y + Math.imul(je, Cr) | 0, X = X + Math.imul(ot, Pr) | 0, a = a + Math.imul(ot, Or) | 0, a = a + Math.imul(He, Pr) | 0, Y = Y + Math.imul(He, Or) | 0, X = X + Math.imul(Ke, Zr) | 0, a = a + Math.imul(Ke, Vr) | 0, a = a + Math.imul(tt, Zr) | 0, Y = Y + Math.imul(tt, Vr) | 0;
      var tn = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, X = Math.imul(ct, xt), a = Math.imul(ct, Vt), a = a + Math.imul(Ze, xt) | 0, Y = Math.imul(Ze, Vt), X = X + Math.imul(Nt, Qt) | 0, a = a + Math.imul(Nt, rr) | 0, a = a + Math.imul(qt, Qt) | 0, Y = Y + Math.imul(qt, rr) | 0, X = X + Math.imul(Pt, Gr) | 0, a = a + Math.imul(Pt, yr) | 0, a = a + Math.imul(Rt, Gr) | 0, Y = Y + Math.imul(Rt, yr) | 0, X = X + Math.imul(Ct, wr) | 0, a = a + Math.imul(Ct, _r) | 0, a = a + Math.imul(Wt, wr) | 0, Y = Y + Math.imul(Wt, _r) | 0, X = X + Math.imul(Xt, Sr) | 0, a = a + Math.imul(Xt, Br) | 0, a = a + Math.imul(_t, Sr) | 0, Y = Y + Math.imul(_t, Br) | 0, X = X + Math.imul(At, gr) | 0, a = a + Math.imul(At, $r) | 0, a = a + Math.imul(Et, gr) | 0, Y = Y + Math.imul(Et, $r) | 0, X = X + Math.imul(st, Ir) | 0, a = a + Math.imul(st, Cr) | 0, a = a + Math.imul(gt, Ir) | 0, Y = Y + Math.imul(gt, Cr) | 0, X = X + Math.imul(nt, Pr) | 0, a = a + Math.imul(nt, Or) | 0, a = a + Math.imul(je, Pr) | 0, Y = Y + Math.imul(je, Or) | 0, X = X + Math.imul(ot, Zr) | 0, a = a + Math.imul(ot, Vr) | 0, a = a + Math.imul(He, Zr) | 0, Y = Y + Math.imul(He, Vr) | 0;
      var un = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, X = Math.imul(ct, Qt), a = Math.imul(ct, rr), a = a + Math.imul(Ze, Qt) | 0, Y = Math.imul(Ze, rr), X = X + Math.imul(Nt, Gr) | 0, a = a + Math.imul(Nt, yr) | 0, a = a + Math.imul(qt, Gr) | 0, Y = Y + Math.imul(qt, yr) | 0, X = X + Math.imul(Pt, wr) | 0, a = a + Math.imul(Pt, _r) | 0, a = a + Math.imul(Rt, wr) | 0, Y = Y + Math.imul(Rt, _r) | 0, X = X + Math.imul(Ct, Sr) | 0, a = a + Math.imul(Ct, Br) | 0, a = a + Math.imul(Wt, Sr) | 0, Y = Y + Math.imul(Wt, Br) | 0, X = X + Math.imul(Xt, gr) | 0, a = a + Math.imul(Xt, $r) | 0, a = a + Math.imul(_t, gr) | 0, Y = Y + Math.imul(_t, $r) | 0, X = X + Math.imul(At, Ir) | 0, a = a + Math.imul(At, Cr) | 0, a = a + Math.imul(Et, Ir) | 0, Y = Y + Math.imul(Et, Cr) | 0, X = X + Math.imul(st, Pr) | 0, a = a + Math.imul(st, Or) | 0, a = a + Math.imul(gt, Pr) | 0, Y = Y + Math.imul(gt, Or) | 0, X = X + Math.imul(nt, Zr) | 0, a = a + Math.imul(nt, Vr) | 0, a = a + Math.imul(je, Zr) | 0, Y = Y + Math.imul(je, Vr) | 0;
      var cn = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, X = Math.imul(ct, Gr), a = Math.imul(ct, yr), a = a + Math.imul(Ze, Gr) | 0, Y = Math.imul(Ze, yr), X = X + Math.imul(Nt, wr) | 0, a = a + Math.imul(Nt, _r) | 0, a = a + Math.imul(qt, wr) | 0, Y = Y + Math.imul(qt, _r) | 0, X = X + Math.imul(Pt, Sr) | 0, a = a + Math.imul(Pt, Br) | 0, a = a + Math.imul(Rt, Sr) | 0, Y = Y + Math.imul(Rt, Br) | 0, X = X + Math.imul(Ct, gr) | 0, a = a + Math.imul(Ct, $r) | 0, a = a + Math.imul(Wt, gr) | 0, Y = Y + Math.imul(Wt, $r) | 0, X = X + Math.imul(Xt, Ir) | 0, a = a + Math.imul(Xt, Cr) | 0, a = a + Math.imul(_t, Ir) | 0, Y = Y + Math.imul(_t, Cr) | 0, X = X + Math.imul(At, Pr) | 0, a = a + Math.imul(At, Or) | 0, a = a + Math.imul(Et, Pr) | 0, Y = Y + Math.imul(Et, Or) | 0, X = X + Math.imul(st, Zr) | 0, a = a + Math.imul(st, Vr) | 0, a = a + Math.imul(gt, Zr) | 0, Y = Y + Math.imul(gt, Vr) | 0;
      var ln = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, X = Math.imul(ct, wr), a = Math.imul(ct, _r), a = a + Math.imul(Ze, wr) | 0, Y = Math.imul(Ze, _r), X = X + Math.imul(Nt, Sr) | 0, a = a + Math.imul(Nt, Br) | 0, a = a + Math.imul(qt, Sr) | 0, Y = Y + Math.imul(qt, Br) | 0, X = X + Math.imul(Pt, gr) | 0, a = a + Math.imul(Pt, $r) | 0, a = a + Math.imul(Rt, gr) | 0, Y = Y + Math.imul(Rt, $r) | 0, X = X + Math.imul(Ct, Ir) | 0, a = a + Math.imul(Ct, Cr) | 0, a = a + Math.imul(Wt, Ir) | 0, Y = Y + Math.imul(Wt, Cr) | 0, X = X + Math.imul(Xt, Pr) | 0, a = a + Math.imul(Xt, Or) | 0, a = a + Math.imul(_t, Pr) | 0, Y = Y + Math.imul(_t, Or) | 0, X = X + Math.imul(At, Zr) | 0, a = a + Math.imul(At, Vr) | 0, a = a + Math.imul(Et, Zr) | 0, Y = Y + Math.imul(Et, Vr) | 0;
      var an = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, X = Math.imul(ct, Sr), a = Math.imul(ct, Br), a = a + Math.imul(Ze, Sr) | 0, Y = Math.imul(Ze, Br), X = X + Math.imul(Nt, gr) | 0, a = a + Math.imul(Nt, $r) | 0, a = a + Math.imul(qt, gr) | 0, Y = Y + Math.imul(qt, $r) | 0, X = X + Math.imul(Pt, Ir) | 0, a = a + Math.imul(Pt, Cr) | 0, a = a + Math.imul(Rt, Ir) | 0, Y = Y + Math.imul(Rt, Cr) | 0, X = X + Math.imul(Ct, Pr) | 0, a = a + Math.imul(Ct, Or) | 0, a = a + Math.imul(Wt, Pr) | 0, Y = Y + Math.imul(Wt, Or) | 0, X = X + Math.imul(Xt, Zr) | 0, a = a + Math.imul(Xt, Vr) | 0, a = a + Math.imul(_t, Zr) | 0, Y = Y + Math.imul(_t, Vr) | 0;
      var fn = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, X = Math.imul(ct, gr), a = Math.imul(ct, $r), a = a + Math.imul(Ze, gr) | 0, Y = Math.imul(Ze, $r), X = X + Math.imul(Nt, Ir) | 0, a = a + Math.imul(Nt, Cr) | 0, a = a + Math.imul(qt, Ir) | 0, Y = Y + Math.imul(qt, Cr) | 0, X = X + Math.imul(Pt, Pr) | 0, a = a + Math.imul(Pt, Or) | 0, a = a + Math.imul(Rt, Pr) | 0, Y = Y + Math.imul(Rt, Or) | 0, X = X + Math.imul(Ct, Zr) | 0, a = a + Math.imul(Ct, Vr) | 0, a = a + Math.imul(Wt, Zr) | 0, Y = Y + Math.imul(Wt, Vr) | 0;
      var sn = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, X = Math.imul(ct, Ir), a = Math.imul(ct, Cr), a = a + Math.imul(Ze, Ir) | 0, Y = Math.imul(Ze, Cr), X = X + Math.imul(Nt, Pr) | 0, a = a + Math.imul(Nt, Or) | 0, a = a + Math.imul(qt, Pr) | 0, Y = Y + Math.imul(qt, Or) | 0, X = X + Math.imul(Pt, Zr) | 0, a = a + Math.imul(Pt, Vr) | 0, a = a + Math.imul(Rt, Zr) | 0, Y = Y + Math.imul(Rt, Vr) | 0;
      var dn = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, X = Math.imul(ct, Pr), a = Math.imul(ct, Or), a = a + Math.imul(Ze, Pr) | 0, Y = Math.imul(Ze, Or), X = X + Math.imul(Nt, Zr) | 0, a = a + Math.imul(Nt, Vr) | 0, a = a + Math.imul(qt, Zr) | 0, Y = Y + Math.imul(qt, Vr) | 0;
      var pn = (xe + X | 0) + ((a & 8191) << 13) | 0;
      xe = (Y + (a >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, X = Math.imul(ct, Zr), a = Math.imul(ct, Vr), a = a + Math.imul(Ze, Zr) | 0, Y = Math.imul(Ze, Vr);
      var vn = (xe + X | 0) + ((a & 8191) << 13) | 0;
      return xe = (Y + (a >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, ge[0] = bi, ge[1] = Ai, ge[2] = Zi, ge[3] = Ji, ge[4] = Vi, ge[5] = Yi, ge[6] = Xi, ge[7] = en, ge[8] = hn, ge[9] = tn, ge[10] = un, ge[11] = cn, ge[12] = ln, ge[13] = an, ge[14] = fn, ge[15] = sn, ge[16] = dn, ge[17] = pn, ge[18] = vn, xe !== 0 && (ge[19] = xe, B.length++), B;
    };
    Math.imul || (Ge = Fe);
    function et(Se, t, h) {
      h.negative = t.negative ^ Se.negative, h.length = Se.length + t.length;
      for (var B = 0, Z = 0, ve = 0; ve < h.length - 1; ve++) {
        var ge = Z;
        Z = 0;
        for (var xe = B & 67108863, X = Math.min(ve, t.length - 1), a = Math.max(0, ve - Se.length + 1); a <= X; a++) {
          var Y = ve - a, Ne = Se.words[Y] | 0, Ke = t.words[a] | 0, tt = Ne * Ke, We = tt & 67108863;
          ge = ge + (tt / 67108864 | 0) | 0, We = We + xe | 0, xe = We & 67108863, ge = ge + (We >>> 26) | 0, Z += ge >>> 26, ge &= 67108863;
        }
        h.words[ve] = xe, B = ge, ge = Z;
      }
      return B !== 0 ? h.words[ve] = B : h.length--, h.strip();
    }
    function Ve(Se, t, h) {
      var B = new Je();
      return B.mulp(Se, t, h);
    }
    H.prototype.mulTo = function(t, h) {
      var B, Z = this.length + t.length;
      return this.length === 10 && t.length === 10 ? B = Ge(this, t, h) : Z < 63 ? B = Fe(this, t, h) : Z < 1024 ? B = et(this, t, h) : B = Ve(this, t, h), B;
    };
    function Je(Se, t) {
      this.x = Se, this.y = t;
    }
    Je.prototype.makeRBT = function(t) {
      for (var h = new Array(t), B = H.prototype._countBits(t) - 1, Z = 0; Z < t; Z++)
        h[Z] = this.revBin(Z, B, t);
      return h;
    }, Je.prototype.revBin = function(t, h, B) {
      if (t === 0 || t === B - 1) return t;
      for (var Z = 0, ve = 0; ve < h; ve++)
        Z |= (t & 1) << h - ve - 1, t >>= 1;
      return Z;
    }, Je.prototype.permute = function(t, h, B, Z, ve, ge) {
      for (var xe = 0; xe < ge; xe++)
        Z[xe] = h[t[xe]], ve[xe] = B[t[xe]];
    }, Je.prototype.transform = function(t, h, B, Z, ve, ge) {
      this.permute(ge, t, h, B, Z, ve);
      for (var xe = 1; xe < ve; xe <<= 1)
        for (var X = xe << 1, a = Math.cos(2 * Math.PI / X), Y = Math.sin(2 * Math.PI / X), Ne = 0; Ne < ve; Ne += X)
          for (var Ke = a, tt = Y, We = 0; We < xe; We++) {
            var ot = B[Ne + We], He = Z[Ne + We], Qe = B[Ne + We + xe], nt = Z[Ne + We + xe], je = Ke * Qe - tt * nt;
            nt = Ke * nt + tt * Qe, Qe = je, B[Ne + We] = ot + Qe, Z[Ne + We] = He + nt, B[Ne + We + xe] = ot - Qe, Z[Ne + We + xe] = He - nt, We !== X && (je = a * Ke - Y * tt, tt = a * tt + Y * Ke, Ke = je);
          }
    }, Je.prototype.guessLen13b = function(t, h) {
      var B = Math.max(h, t) | 1, Z = B & 1, ve = 0;
      for (B = B / 2 | 0; B; B = B >>> 1)
        ve++;
      return 1 << ve + 1 + Z;
    }, Je.prototype.conjugate = function(t, h, B) {
      if (!(B <= 1))
        for (var Z = 0; Z < B / 2; Z++) {
          var ve = t[Z];
          t[Z] = t[B - Z - 1], t[B - Z - 1] = ve, ve = h[Z], h[Z] = -h[B - Z - 1], h[B - Z - 1] = -ve;
        }
    }, Je.prototype.normalize13b = function(t, h) {
      for (var B = 0, Z = 0; Z < h / 2; Z++) {
        var ve = Math.round(t[2 * Z + 1] / h) * 8192 + Math.round(t[2 * Z] / h) + B;
        t[Z] = ve & 67108863, ve < 67108864 ? B = 0 : B = ve / 67108864 | 0;
      }
      return t;
    }, Je.prototype.convert13b = function(t, h, B, Z) {
      for (var ve = 0, ge = 0; ge < h; ge++)
        ve = ve + (t[ge] | 0), B[2 * ge] = ve & 8191, ve = ve >>> 13, B[2 * ge + 1] = ve & 8191, ve = ve >>> 13;
      for (ge = 2 * h; ge < Z; ++ge)
        B[ge] = 0;
      J(ve === 0), J((ve & -8192) === 0);
    }, Je.prototype.stub = function(t) {
      for (var h = new Array(t), B = 0; B < t; B++)
        h[B] = 0;
      return h;
    }, Je.prototype.mulp = function(t, h, B) {
      var Z = 2 * this.guessLen13b(t.length, h.length), ve = this.makeRBT(Z), ge = this.stub(Z), xe = new Array(Z), X = new Array(Z), a = new Array(Z), Y = new Array(Z), Ne = new Array(Z), Ke = new Array(Z), tt = B.words;
      tt.length = Z, this.convert13b(t.words, t.length, xe, Z), this.convert13b(h.words, h.length, Y, Z), this.transform(xe, ge, X, a, Z, ve), this.transform(Y, ge, Ne, Ke, Z, ve);
      for (var We = 0; We < Z; We++) {
        var ot = X[We] * Ne[We] - a[We] * Ke[We];
        a[We] = X[We] * Ke[We] + a[We] * Ne[We], X[We] = ot;
      }
      return this.conjugate(X, a, Z), this.transform(X, a, tt, ge, Z, ve), this.conjugate(tt, ge, Z), this.normalize13b(tt, Z), B.negative = t.negative ^ h.negative, B.length = t.length + h.length, B.strip();
    }, H.prototype.mul = function(t) {
      var h = new H(null);
      return h.words = new Array(this.length + t.length), this.mulTo(t, h);
    }, H.prototype.mulf = function(t) {
      var h = new H(null);
      return h.words = new Array(this.length + t.length), Ve(this, t, h);
    }, H.prototype.imul = function(t) {
      return this.clone().mulTo(t, this);
    }, H.prototype.imuln = function(t) {
      J(typeof t == "number"), J(t < 67108864);
      for (var h = 0, B = 0; B < this.length; B++) {
        var Z = (this.words[B] | 0) * t, ve = (Z & 67108863) + (h & 67108863);
        h >>= 26, h += Z / 67108864 | 0, h += ve >>> 26, this.words[B] = ve & 67108863;
      }
      return h !== 0 && (this.words[B] = h, this.length++), this;
    }, H.prototype.muln = function(t) {
      return this.clone().imuln(t);
    }, H.prototype.sqr = function() {
      return this.mul(this);
    }, H.prototype.isqr = function() {
      return this.imul(this.clone());
    }, H.prototype.pow = function(t) {
      var h = ke(t);
      if (h.length === 0) return new H(1);
      for (var B = this, Z = 0; Z < h.length && h[Z] === 0; Z++, B = B.sqr())
        ;
      if (++Z < h.length)
        for (var ve = B.sqr(); Z < h.length; Z++, ve = ve.sqr())
          h[Z] !== 0 && (B = B.mul(ve));
      return B;
    }, H.prototype.iushln = function(t) {
      J(typeof t == "number" && t >= 0);
      var h = t % 26, B = (t - h) / 26, Z = 67108863 >>> 26 - h << 26 - h, ve;
      if (h !== 0) {
        var ge = 0;
        for (ve = 0; ve < this.length; ve++) {
          var xe = this.words[ve] & Z, X = (this.words[ve] | 0) - xe << h;
          this.words[ve] = X | ge, ge = xe >>> 26 - h;
        }
        ge && (this.words[ve] = ge, this.length++);
      }
      if (B !== 0) {
        for (ve = this.length - 1; ve >= 0; ve--)
          this.words[ve + B] = this.words[ve];
        for (ve = 0; ve < B; ve++)
          this.words[ve] = 0;
        this.length += B;
      }
      return this.strip();
    }, H.prototype.ishln = function(t) {
      return J(this.negative === 0), this.iushln(t);
    }, H.prototype.iushrn = function(t, h, B) {
      J(typeof t == "number" && t >= 0);
      var Z;
      h ? Z = (h - h % 26) / 26 : Z = 0;
      var ve = t % 26, ge = Math.min((t - ve) / 26, this.length), xe = 67108863 ^ 67108863 >>> ve << ve, X = B;
      if (Z -= ge, Z = Math.max(0, Z), X) {
        for (var a = 0; a < ge; a++)
          X.words[a] = this.words[a];
        X.length = ge;
      }
      if (ge !== 0) if (this.length > ge)
        for (this.length -= ge, a = 0; a < this.length; a++)
          this.words[a] = this.words[a + ge];
      else
        this.words[0] = 0, this.length = 1;
      var Y = 0;
      for (a = this.length - 1; a >= 0 && (Y !== 0 || a >= Z); a--) {
        var Ne = this.words[a] | 0;
        this.words[a] = Y << 26 - ve | Ne >>> ve, Y = Ne & xe;
      }
      return X && Y !== 0 && (X.words[X.length++] = Y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, H.prototype.ishrn = function(t, h, B) {
      return J(this.negative === 0), this.iushrn(t, h, B);
    }, H.prototype.shln = function(t) {
      return this.clone().ishln(t);
    }, H.prototype.ushln = function(t) {
      return this.clone().iushln(t);
    }, H.prototype.shrn = function(t) {
      return this.clone().ishrn(t);
    }, H.prototype.ushrn = function(t) {
      return this.clone().iushrn(t);
    }, H.prototype.testn = function(t) {
      J(typeof t == "number" && t >= 0);
      var h = t % 26, B = (t - h) / 26, Z = 1 << h;
      if (this.length <= B) return !1;
      var ve = this.words[B];
      return !!(ve & Z);
    }, H.prototype.imaskn = function(t) {
      J(typeof t == "number" && t >= 0);
      var h = t % 26, B = (t - h) / 26;
      if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= B)
        return this;
      if (h !== 0 && B++, this.length = Math.min(B, this.length), h !== 0) {
        var Z = 67108863 ^ 67108863 >>> h << h;
        this.words[this.length - 1] &= Z;
      }
      return this.strip();
    }, H.prototype.maskn = function(t) {
      return this.clone().imaskn(t);
    }, H.prototype.iaddn = function(t) {
      return J(typeof t == "number"), J(t < 67108864), t < 0 ? this.isubn(-t) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < t ? (this.words[0] = t - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
    }, H.prototype._iaddn = function(t) {
      this.words[0] += t;
      for (var h = 0; h < this.length && this.words[h] >= 67108864; h++)
        this.words[h] -= 67108864, h === this.length - 1 ? this.words[h + 1] = 1 : this.words[h + 1]++;
      return this.length = Math.max(this.length, h + 1), this;
    }, H.prototype.isubn = function(t) {
      if (J(typeof t == "number"), J(t < 67108864), t < 0) return this.iaddn(-t);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(t), this.negative = 1, this;
      if (this.words[0] -= t, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var h = 0; h < this.length && this.words[h] < 0; h++)
          this.words[h] += 67108864, this.words[h + 1] -= 1;
      return this.strip();
    }, H.prototype.addn = function(t) {
      return this.clone().iaddn(t);
    }, H.prototype.subn = function(t) {
      return this.clone().isubn(t);
    }, H.prototype.iabs = function() {
      return this.negative = 0, this;
    }, H.prototype.abs = function() {
      return this.clone().iabs();
    }, H.prototype._ishlnsubmul = function(t, h, B) {
      var Z = t.length + B, ve;
      this._expand(Z);
      var ge, xe = 0;
      for (ve = 0; ve < t.length; ve++) {
        ge = (this.words[ve + B] | 0) + xe;
        var X = (t.words[ve] | 0) * h;
        ge -= X & 67108863, xe = (ge >> 26) - (X / 67108864 | 0), this.words[ve + B] = ge & 67108863;
      }
      for (; ve < this.length - B; ve++)
        ge = (this.words[ve + B] | 0) + xe, xe = ge >> 26, this.words[ve + B] = ge & 67108863;
      if (xe === 0) return this.strip();
      for (J(xe === -1), xe = 0, ve = 0; ve < this.length; ve++)
        ge = -(this.words[ve] | 0) + xe, xe = ge >> 26, this.words[ve] = ge & 67108863;
      return this.negative = 1, this.strip();
    }, H.prototype._wordDiv = function(t, h) {
      var B = this.length - t.length, Z = this.clone(), ve = t, ge = ve.words[ve.length - 1] | 0, xe = this._countBits(ge);
      B = 26 - xe, B !== 0 && (ve = ve.ushln(B), Z.iushln(B), ge = ve.words[ve.length - 1] | 0);
      var X = Z.length - ve.length, a;
      if (h !== "mod") {
        a = new H(null), a.length = X + 1, a.words = new Array(a.length);
        for (var Y = 0; Y < a.length; Y++)
          a.words[Y] = 0;
      }
      var Ne = Z.clone()._ishlnsubmul(ve, 1, X);
      Ne.negative === 0 && (Z = Ne, a && (a.words[X] = 1));
      for (var Ke = X - 1; Ke >= 0; Ke--) {
        var tt = (Z.words[ve.length + Ke] | 0) * 67108864 + (Z.words[ve.length + Ke - 1] | 0);
        for (tt = Math.min(tt / ge | 0, 67108863), Z._ishlnsubmul(ve, tt, Ke); Z.negative !== 0; )
          tt--, Z.negative = 0, Z._ishlnsubmul(ve, 1, Ke), Z.isZero() || (Z.negative ^= 1);
        a && (a.words[Ke] = tt);
      }
      return a && a.strip(), Z.strip(), h !== "div" && B !== 0 && Z.iushrn(B), {
        div: a || null,
        mod: Z
      };
    }, H.prototype.divmod = function(t, h, B) {
      if (J(!t.isZero()), this.isZero())
        return {
          div: new H(0),
          mod: new H(0)
        };
      var Z, ve, ge;
      return this.negative !== 0 && t.negative === 0 ? (ge = this.neg().divmod(t, h), h !== "mod" && (Z = ge.div.neg()), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.iadd(t)), {
        div: Z,
        mod: ve
      }) : this.negative === 0 && t.negative !== 0 ? (ge = this.divmod(t.neg(), h), h !== "mod" && (Z = ge.div.neg()), {
        div: Z,
        mod: ge.mod
      }) : this.negative & t.negative ? (ge = this.neg().divmod(t.neg(), h), h !== "div" && (ve = ge.mod.neg(), B && ve.negative !== 0 && ve.isub(t)), {
        div: ge.div,
        mod: ve
      }) : t.length > this.length || this.cmp(t) < 0 ? {
        div: new H(0),
        mod: this
      } : t.length === 1 ? h === "div" ? {
        div: this.divn(t.words[0]),
        mod: null
      } : h === "mod" ? {
        div: null,
        mod: new H(this.modn(t.words[0]))
      } : {
        div: this.divn(t.words[0]),
        mod: new H(this.modn(t.words[0]))
      } : this._wordDiv(t, h);
    }, H.prototype.div = function(t) {
      return this.divmod(t, "div", !1).div;
    }, H.prototype.mod = function(t) {
      return this.divmod(t, "mod", !1).mod;
    }, H.prototype.umod = function(t) {
      return this.divmod(t, "mod", !0).mod;
    }, H.prototype.divRound = function(t) {
      var h = this.divmod(t);
      if (h.mod.isZero()) return h.div;
      var B = h.div.negative !== 0 ? h.mod.isub(t) : h.mod, Z = t.ushrn(1), ve = t.andln(1), ge = B.cmp(Z);
      return ge < 0 || ve === 1 && ge === 0 ? h.div : h.div.negative !== 0 ? h.div.isubn(1) : h.div.iaddn(1);
    }, H.prototype.modn = function(t) {
      J(t <= 67108863);
      for (var h = (1 << 26) % t, B = 0, Z = this.length - 1; Z >= 0; Z--)
        B = (h * B + (this.words[Z] | 0)) % t;
      return B;
    }, H.prototype.idivn = function(t) {
      J(t <= 67108863);
      for (var h = 0, B = this.length - 1; B >= 0; B--) {
        var Z = (this.words[B] | 0) + h * 67108864;
        this.words[B] = Z / t | 0, h = Z % t;
      }
      return this.strip();
    }, H.prototype.divn = function(t) {
      return this.clone().idivn(t);
    }, H.prototype.egcd = function(t) {
      J(t.negative === 0), J(!t.isZero());
      var h = this, B = t.clone();
      h.negative !== 0 ? h = h.umod(t) : h = h.clone();
      for (var Z = new H(1), ve = new H(0), ge = new H(0), xe = new H(1), X = 0; h.isEven() && B.isEven(); )
        h.iushrn(1), B.iushrn(1), ++X;
      for (var a = B.clone(), Y = h.clone(); !h.isZero(); ) {
        for (var Ne = 0, Ke = 1; !(h.words[0] & Ke) && Ne < 26; ++Ne, Ke <<= 1) ;
        if (Ne > 0)
          for (h.iushrn(Ne); Ne-- > 0; )
            (Z.isOdd() || ve.isOdd()) && (Z.iadd(a), ve.isub(Y)), Z.iushrn(1), ve.iushrn(1);
        for (var tt = 0, We = 1; !(B.words[0] & We) && tt < 26; ++tt, We <<= 1) ;
        if (tt > 0)
          for (B.iushrn(tt); tt-- > 0; )
            (ge.isOdd() || xe.isOdd()) && (ge.iadd(a), xe.isub(Y)), ge.iushrn(1), xe.iushrn(1);
        h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ge), ve.isub(xe)) : (B.isub(h), ge.isub(Z), xe.isub(ve));
      }
      return {
        a: ge,
        b: xe,
        gcd: B.iushln(X)
      };
    }, H.prototype._invmp = function(t) {
      J(t.negative === 0), J(!t.isZero());
      var h = this, B = t.clone();
      h.negative !== 0 ? h = h.umod(t) : h = h.clone();
      for (var Z = new H(1), ve = new H(0), ge = B.clone(); h.cmpn(1) > 0 && B.cmpn(1) > 0; ) {
        for (var xe = 0, X = 1; !(h.words[0] & X) && xe < 26; ++xe, X <<= 1) ;
        if (xe > 0)
          for (h.iushrn(xe); xe-- > 0; )
            Z.isOdd() && Z.iadd(ge), Z.iushrn(1);
        for (var a = 0, Y = 1; !(B.words[0] & Y) && a < 26; ++a, Y <<= 1) ;
        if (a > 0)
          for (B.iushrn(a); a-- > 0; )
            ve.isOdd() && ve.iadd(ge), ve.iushrn(1);
        h.cmp(B) >= 0 ? (h.isub(B), Z.isub(ve)) : (B.isub(h), ve.isub(Z));
      }
      var Ne;
      return h.cmpn(1) === 0 ? Ne = Z : Ne = ve, Ne.cmpn(0) < 0 && Ne.iadd(t), Ne;
    }, H.prototype.gcd = function(t) {
      if (this.isZero()) return t.abs();
      if (t.isZero()) return this.abs();
      var h = this.clone(), B = t.clone();
      h.negative = 0, B.negative = 0;
      for (var Z = 0; h.isEven() && B.isEven(); Z++)
        h.iushrn(1), B.iushrn(1);
      do {
        for (; h.isEven(); )
          h.iushrn(1);
        for (; B.isEven(); )
          B.iushrn(1);
        var ve = h.cmp(B);
        if (ve < 0) {
          var ge = h;
          h = B, B = ge;
        } else if (ve === 0 || B.cmpn(1) === 0)
          break;
        h.isub(B);
      } while (!0);
      return B.iushln(Z);
    }, H.prototype.invm = function(t) {
      return this.egcd(t).a.umod(t);
    }, H.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, H.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, H.prototype.andln = function(t) {
      return this.words[0] & t;
    }, H.prototype.bincn = function(t) {
      J(typeof t == "number");
      var h = t % 26, B = (t - h) / 26, Z = 1 << h;
      if (this.length <= B)
        return this._expand(B + 1), this.words[B] |= Z, this;
      for (var ve = Z, ge = B; ve !== 0 && ge < this.length; ge++) {
        var xe = this.words[ge] | 0;
        xe += ve, ve = xe >>> 26, xe &= 67108863, this.words[ge] = xe;
      }
      return ve !== 0 && (this.words[ge] = ve, this.length++), this;
    }, H.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, H.prototype.cmpn = function(t) {
      var h = t < 0;
      if (this.negative !== 0 && !h) return -1;
      if (this.negative === 0 && h) return 1;
      this.strip();
      var B;
      if (this.length > 1)
        B = 1;
      else {
        h && (t = -t), J(t <= 67108863, "Number is too big");
        var Z = this.words[0] | 0;
        B = Z === t ? 0 : Z < t ? -1 : 1;
      }
      return this.negative !== 0 ? -B | 0 : B;
    }, H.prototype.cmp = function(t) {
      if (this.negative !== 0 && t.negative === 0) return -1;
      if (this.negative === 0 && t.negative !== 0) return 1;
      var h = this.ucmp(t);
      return this.negative !== 0 ? -h | 0 : h;
    }, H.prototype.ucmp = function(t) {
      if (this.length > t.length) return 1;
      if (this.length < t.length) return -1;
      for (var h = 0, B = this.length - 1; B >= 0; B--) {
        var Z = this.words[B] | 0, ve = t.words[B] | 0;
        if (Z !== ve) {
          Z < ve ? h = -1 : Z > ve && (h = 1);
          break;
        }
      }
      return h;
    }, H.prototype.gtn = function(t) {
      return this.cmpn(t) === 1;
    }, H.prototype.gt = function(t) {
      return this.cmp(t) === 1;
    }, H.prototype.gten = function(t) {
      return this.cmpn(t) >= 0;
    }, H.prototype.gte = function(t) {
      return this.cmp(t) >= 0;
    }, H.prototype.ltn = function(t) {
      return this.cmpn(t) === -1;
    }, H.prototype.lt = function(t) {
      return this.cmp(t) === -1;
    }, H.prototype.lten = function(t) {
      return this.cmpn(t) <= 0;
    }, H.prototype.lte = function(t) {
      return this.cmp(t) <= 0;
    }, H.prototype.eqn = function(t) {
      return this.cmpn(t) === 0;
    }, H.prototype.eq = function(t) {
      return this.cmp(t) === 0;
    }, H.red = function(t) {
      return new bt(t);
    }, H.prototype.toRed = function(t) {
      return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), t.convertTo(this)._forceRed(t);
    }, H.prototype.fromRed = function() {
      return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, H.prototype._forceRed = function(t) {
      return this.red = t, this;
    }, H.prototype.forceRed = function(t) {
      return J(!this.red, "Already a number in reduction context"), this._forceRed(t);
    }, H.prototype.redAdd = function(t) {
      return J(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
    }, H.prototype.redIAdd = function(t) {
      return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
    }, H.prototype.redSub = function(t) {
      return J(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
    }, H.prototype.redISub = function(t) {
      return J(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
    }, H.prototype.redShl = function(t) {
      return J(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
    }, H.prototype.redMul = function(t) {
      return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
    }, H.prototype.redIMul = function(t) {
      return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
    }, H.prototype.redSqr = function() {
      return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, H.prototype.redISqr = function() {
      return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, H.prototype.redSqrt = function() {
      return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, H.prototype.redInvm = function() {
      return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, H.prototype.redNeg = function() {
      return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, H.prototype.redPow = function(t) {
      return J(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
    };
    var ut = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function rt(Se, t) {
      this.name = Se, this.p = new H(t, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    rt.prototype._tmp = function() {
      var t = new H(null);
      return t.words = new Array(Math.ceil(this.n / 13)), t;
    }, rt.prototype.ireduce = function(t) {
      var h = t, B;
      do
        this.split(h, this.tmp), h = this.imulK(h), h = h.iadd(this.tmp), B = h.bitLength();
      while (B > this.n);
      var Z = B < this.n ? -1 : h.ucmp(this.p);
      return Z === 0 ? (h.words[0] = 0, h.length = 1) : Z > 0 ? h.isub(this.p) : h.strip !== void 0 ? h.strip() : h._strip(), h;
    }, rt.prototype.split = function(t, h) {
      t.iushrn(this.n, 0, h);
    }, rt.prototype.imulK = function(t) {
      return t.imul(this.k);
    };
    function lt() {
      rt.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    _e(lt, rt), lt.prototype.split = function(t, h) {
      for (var B = 4194303, Z = Math.min(t.length, 9), ve = 0; ve < Z; ve++)
        h.words[ve] = t.words[ve];
      if (h.length = Z, t.length <= 9) {
        t.words[0] = 0, t.length = 1;
        return;
      }
      var ge = t.words[9];
      for (h.words[h.length++] = ge & B, ve = 10; ve < t.length; ve++) {
        var xe = t.words[ve] | 0;
        t.words[ve - 10] = (xe & B) << 4 | ge >>> 22, ge = xe;
      }
      ge >>>= 22, t.words[ve - 10] = ge, ge === 0 && t.length > 10 ? t.length -= 10 : t.length -= 9;
    }, lt.prototype.imulK = function(t) {
      t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;
      for (var h = 0, B = 0; B < t.length; B++) {
        var Z = t.words[B] | 0;
        h += Z * 977, t.words[B] = h & 67108863, h = Z * 64 + (h / 67108864 | 0);
      }
      return t.words[t.length - 1] === 0 && (t.length--, t.words[t.length - 1] === 0 && t.length--), t;
    };
    function vt() {
      rt.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    _e(vt, rt);
    function Ye() {
      rt.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    _e(Ye, rt);
    function pt() {
      rt.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    _e(pt, rt), pt.prototype.imulK = function(t) {
      for (var h = 0, B = 0; B < t.length; B++) {
        var Z = (t.words[B] | 0) * 19 + h, ve = Z & 67108863;
        Z >>>= 26, t.words[B] = ve, h = Z;
      }
      return h !== 0 && (t.words[t.length++] = h), t;
    }, H._prime = function(t) {
      if (ut[t]) return ut[t];
      var h;
      if (t === "k256")
        h = new lt();
      else if (t === "p224")
        h = new vt();
      else if (t === "p192")
        h = new Ye();
      else if (t === "p25519")
        h = new pt();
      else
        throw new Error("Unknown prime " + t);
      return ut[t] = h, h;
    };
    function bt(Se) {
      if (typeof Se == "string") {
        var t = H._prime(Se);
        this.m = t.p, this.prime = t;
      } else
        J(Se.gtn(1), "modulus must be greater than 1"), this.m = Se, this.prime = null;
    }
    bt.prototype._verify1 = function(t) {
      J(t.negative === 0, "red works only with positives"), J(t.red, "red works only with red numbers");
    }, bt.prototype._verify2 = function(t, h) {
      J((t.negative | h.negative) === 0, "red works only with positives"), J(
        t.red && t.red === h.red,
        "red works only with red numbers"
      );
    }, bt.prototype.imod = function(t) {
      return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
    }, bt.prototype.neg = function(t) {
      return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
    }, bt.prototype.add = function(t, h) {
      this._verify2(t, h);
      var B = t.add(h);
      return B.cmp(this.m) >= 0 && B.isub(this.m), B._forceRed(this);
    }, bt.prototype.iadd = function(t, h) {
      this._verify2(t, h);
      var B = t.iadd(h);
      return B.cmp(this.m) >= 0 && B.isub(this.m), B;
    }, bt.prototype.sub = function(t, h) {
      this._verify2(t, h);
      var B = t.sub(h);
      return B.cmpn(0) < 0 && B.iadd(this.m), B._forceRed(this);
    }, bt.prototype.isub = function(t, h) {
      this._verify2(t, h);
      var B = t.isub(h);
      return B.cmpn(0) < 0 && B.iadd(this.m), B;
    }, bt.prototype.shl = function(t, h) {
      return this._verify1(t), this.imod(t.ushln(h));
    }, bt.prototype.imul = function(t, h) {
      return this._verify2(t, h), this.imod(t.imul(h));
    }, bt.prototype.mul = function(t, h) {
      return this._verify2(t, h), this.imod(t.mul(h));
    }, bt.prototype.isqr = function(t) {
      return this.imul(t, t.clone());
    }, bt.prototype.sqr = function(t) {
      return this.mul(t, t);
    }, bt.prototype.sqrt = function(t) {
      if (t.isZero()) return t.clone();
      var h = this.m.andln(3);
      if (J(h % 2 === 1), h === 3) {
        var B = this.m.add(new H(1)).iushrn(2);
        return this.pow(t, B);
      }
      for (var Z = this.m.subn(1), ve = 0; !Z.isZero() && Z.andln(1) === 0; )
        ve++, Z.iushrn(1);
      J(!Z.isZero());
      var ge = new H(1).toRed(this), xe = ge.redNeg(), X = this.m.subn(1).iushrn(1), a = this.m.bitLength();
      for (a = new H(2 * a * a).toRed(this); this.pow(a, X).cmp(xe) !== 0; )
        a.redIAdd(xe);
      for (var Y = this.pow(a, Z), Ne = this.pow(t, Z.addn(1).iushrn(1)), Ke = this.pow(t, Z), tt = ve; Ke.cmp(ge) !== 0; ) {
        for (var We = Ke, ot = 0; We.cmp(ge) !== 0; ot++)
          We = We.redSqr();
        J(ot < tt);
        var He = this.pow(Y, new H(1).iushln(tt - ot - 1));
        Ne = Ne.redMul(He), Y = He.redSqr(), Ke = Ke.redMul(Y), tt = ot;
      }
      return Ne;
    }, bt.prototype.invm = function(t) {
      var h = t._invmp(this.m);
      return h.negative !== 0 ? (h.negative = 0, this.imod(h).redNeg()) : this.imod(h);
    }, bt.prototype.pow = function(t, h) {
      if (h.isZero()) return new H(1).toRed(this);
      if (h.cmpn(1) === 0) return t.clone();
      var B = 4, Z = new Array(1 << B);
      Z[0] = new H(1).toRed(this), Z[1] = t;
      for (var ve = 2; ve < Z.length; ve++)
        Z[ve] = this.mul(Z[ve - 1], t);
      var ge = Z[0], xe = 0, X = 0, a = h.bitLength() % 26;
      for (a === 0 && (a = 26), ve = h.length - 1; ve >= 0; ve--) {
        for (var Y = h.words[ve], Ne = a - 1; Ne >= 0; Ne--) {
          var Ke = Y >> Ne & 1;
          if (ge !== Z[0] && (ge = this.sqr(ge)), Ke === 0 && xe === 0) {
            X = 0;
            continue;
          }
          xe <<= 1, xe |= Ke, X++, !(X !== B && (ve !== 0 || Ne !== 0)) && (ge = this.mul(ge, Z[xe]), X = 0, xe = 0);
        }
        a = 26;
      }
      return ge;
    }, bt.prototype.convertTo = function(t) {
      var h = t.umod(this.m);
      return h === t ? h.clone() : h;
    }, bt.prototype.convertFrom = function(t) {
      var h = t.clone();
      return h.red = null, h;
    }, H.mont = function(t) {
      return new Yt(t);
    };
    function Yt(Se) {
      bt.call(this, Se), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    _e(Yt, bt), Yt.prototype.convertTo = function(t) {
      return this.imod(t.ushln(this.shift));
    }, Yt.prototype.convertFrom = function(t) {
      var h = this.imod(t.mul(this.rinv));
      return h.red = null, h;
    }, Yt.prototype.imul = function(t, h) {
      if (t.isZero() || h.isZero())
        return t.words[0] = 0, t.length = 1, t;
      var B = t.imul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
      return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
    }, Yt.prototype.mul = function(t, h) {
      if (t.isZero() || h.isZero()) return new H(0)._forceRed(this);
      var B = t.mul(h), Z = B.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ve = B.isub(Z).iushrn(this.shift), ge = ve;
      return ve.cmp(this.m) >= 0 ? ge = ve.isub(this.m) : ve.cmpn(0) < 0 && (ge = ve.iadd(this.m)), ge._forceRed(this);
    }, Yt.prototype.invm = function(t) {
      var h = this.imod(t._invmp(this.m).mul(this.r2));
      return h._forceRed(this);
    };
  })(I, commonjsGlobal);
})(bn);
var bnExports = bn.exports;
(function(I) {
  var A = I, G = bnExports, J = minimalisticAssert, _e = utils$m;
  A.assert = J, A.toArray = _e.toArray, A.zero2 = _e.zero2, A.toHex = _e.toHex, A.encode = _e.encode;
  function H(Ee, Oe, Le) {
    var ke = new Array(Math.max(Ee.bitLength(), Le) + 1), Fe;
    for (Fe = 0; Fe < ke.length; Fe += 1)
      ke[Fe] = 0;
    var Ge = 1 << Oe + 1, et = Ee.clone();
    for (Fe = 0; Fe < ke.length; Fe++) {
      var Ve, Je = et.andln(Ge - 1);
      et.isOdd() ? (Je > (Ge >> 1) - 1 ? Ve = (Ge >> 1) - Je : Ve = Je, et.isubn(Ve)) : Ve = 0, ke[Fe] = Ve, et.iushrn(1);
    }
    return ke;
  }
  A.getNAF = H;
  function De(Ee, Oe) {
    var Le = [
      [],
      []
    ];
    Ee = Ee.clone(), Oe = Oe.clone();
    for (var ke = 0, Fe = 0, Ge; Ee.cmpn(-ke) > 0 || Oe.cmpn(-Fe) > 0; ) {
      var et = Ee.andln(3) + ke & 3, Ve = Oe.andln(3) + Fe & 3;
      et === 3 && (et = -1), Ve === 3 && (Ve = -1);
      var Je;
      et & 1 ? (Ge = Ee.andln(7) + ke & 7, (Ge === 3 || Ge === 5) && Ve === 2 ? Je = -et : Je = et) : Je = 0, Le[0].push(Je);
      var ut;
      Ve & 1 ? (Ge = Oe.andln(7) + Fe & 7, (Ge === 3 || Ge === 5) && et === 2 ? ut = -Ve : ut = Ve) : ut = 0, Le[1].push(ut), 2 * ke === Je + 1 && (ke = 1 - ke), 2 * Fe === ut + 1 && (Fe = 1 - Fe), Ee.iushrn(1), Oe.iushrn(1);
    }
    return Le;
  }
  A.getJSF = De;
  function Ie(Ee, Oe, Le) {
    var ke = "_" + Oe;
    Ee.prototype[Oe] = function() {
      return this[ke] !== void 0 ? this[ke] : this[ke] = Le.call(this);
    };
  }
  A.cachedProperty = Ie;
  function qe(Ee) {
    return typeof Ee == "string" ? A.toArray(Ee, "hex") : Ee;
  }
  A.parseBytes = qe;
  function Te(Ee) {
    return new G(Ee, "hex", "le");
  }
  A.intFromLE = Te;
})(utils$a);
var curve = {}, BN$7 = bnExports, utils$9 = utils$a, getNAF = utils$9.getNAF, getJSF = utils$9.getJSF, assert$8 = utils$9.assert;
function BaseCurve(I, A) {
  this.type = I, this.p = new BN$7(A.p, 16), this.red = A.prime ? BN$7.red(A.prime) : BN$7.mont(this.p), this.zero = new BN$7(0).toRed(this.red), this.one = new BN$7(1).toRed(this.red), this.two = new BN$7(2).toRed(this.red), this.n = A.n && new BN$7(A.n, 16), this.g = A.g && this.pointFromJSON(A.g, A.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var G = this.n && this.p.div(this.n);
  !G || G.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base = BaseCurve;
BaseCurve.prototype.point = function I() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function I() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function I(A, G) {
  assert$8(A.precomputed);
  var J = A._getDoubles(), _e = getNAF(G, 1, this._bitLength), H = (1 << J.step + 1) - (J.step % 2 === 0 ? 2 : 1);
  H /= 3;
  var De = [], Ie, qe;
  for (Ie = 0; Ie < _e.length; Ie += J.step) {
    qe = 0;
    for (var Te = Ie + J.step - 1; Te >= Ie; Te--)
      qe = (qe << 1) + _e[Te];
    De.push(qe);
  }
  for (var Ee = this.jpoint(null, null, null), Oe = this.jpoint(null, null, null), Le = H; Le > 0; Le--) {
    for (Ie = 0; Ie < De.length; Ie++)
      qe = De[Ie], qe === Le ? Oe = Oe.mixedAdd(J.points[Ie]) : qe === -Le && (Oe = Oe.mixedAdd(J.points[Ie].neg()));
    Ee = Ee.add(Oe);
  }
  return Ee.toP();
};
BaseCurve.prototype._wnafMul = function I(A, G) {
  var J = 4, _e = A._getNAFPoints(J);
  J = _e.wnd;
  for (var H = _e.points, De = getNAF(G, J, this._bitLength), Ie = this.jpoint(null, null, null), qe = De.length - 1; qe >= 0; qe--) {
    for (var Te = 0; qe >= 0 && De[qe] === 0; qe--)
      Te++;
    if (qe >= 0 && Te++, Ie = Ie.dblp(Te), qe < 0)
      break;
    var Ee = De[qe];
    assert$8(Ee !== 0), A.type === "affine" ? Ee > 0 ? Ie = Ie.mixedAdd(H[Ee - 1 >> 1]) : Ie = Ie.mixedAdd(H[-Ee - 1 >> 1].neg()) : Ee > 0 ? Ie = Ie.add(H[Ee - 1 >> 1]) : Ie = Ie.add(H[-Ee - 1 >> 1].neg());
  }
  return A.type === "affine" ? Ie.toP() : Ie;
};
BaseCurve.prototype._wnafMulAdd = function I(A, G, J, _e, H) {
  var De = this._wnafT1, Ie = this._wnafT2, qe = this._wnafT3, Te = 0, Ee, Oe, Le;
  for (Ee = 0; Ee < _e; Ee++) {
    Le = G[Ee];
    var ke = Le._getNAFPoints(A);
    De[Ee] = ke.wnd, Ie[Ee] = ke.points;
  }
  for (Ee = _e - 1; Ee >= 1; Ee -= 2) {
    var Fe = Ee - 1, Ge = Ee;
    if (De[Fe] !== 1 || De[Ge] !== 1) {
      qe[Fe] = getNAF(J[Fe], De[Fe], this._bitLength), qe[Ge] = getNAF(J[Ge], De[Ge], this._bitLength), Te = Math.max(qe[Fe].length, Te), Te = Math.max(qe[Ge].length, Te);
      continue;
    }
    var et = [
      G[Fe],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      G[Ge]
      /* 7 */
    ];
    G[Fe].y.cmp(G[Ge].y) === 0 ? (et[1] = G[Fe].add(G[Ge]), et[2] = G[Fe].toJ().mixedAdd(G[Ge].neg())) : G[Fe].y.cmp(G[Ge].y.redNeg()) === 0 ? (et[1] = G[Fe].toJ().mixedAdd(G[Ge]), et[2] = G[Fe].add(G[Ge].neg())) : (et[1] = G[Fe].toJ().mixedAdd(G[Ge]), et[2] = G[Fe].toJ().mixedAdd(G[Ge].neg()));
    var Ve = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], Je = getJSF(J[Fe], J[Ge]);
    for (Te = Math.max(Je[0].length, Te), qe[Fe] = new Array(Te), qe[Ge] = new Array(Te), Oe = 0; Oe < Te; Oe++) {
      var ut = Je[0][Oe] | 0, rt = Je[1][Oe] | 0;
      qe[Fe][Oe] = Ve[(ut + 1) * 3 + (rt + 1)], qe[Ge][Oe] = 0, Ie[Fe] = et;
    }
  }
  var lt = this.jpoint(null, null, null), vt = this._wnafT4;
  for (Ee = Te; Ee >= 0; Ee--) {
    for (var Ye = 0; Ee >= 0; ) {
      var pt = !0;
      for (Oe = 0; Oe < _e; Oe++)
        vt[Oe] = qe[Oe][Ee] | 0, vt[Oe] !== 0 && (pt = !1);
      if (!pt)
        break;
      Ye++, Ee--;
    }
    if (Ee >= 0 && Ye++, lt = lt.dblp(Ye), Ee < 0)
      break;
    for (Oe = 0; Oe < _e; Oe++) {
      var bt = vt[Oe];
      bt !== 0 && (bt > 0 ? Le = Ie[Oe][bt - 1 >> 1] : bt < 0 && (Le = Ie[Oe][-bt - 1 >> 1].neg()), Le.type === "affine" ? lt = lt.mixedAdd(Le) : lt = lt.add(Le));
    }
  }
  for (Ee = 0; Ee < _e; Ee++)
    Ie[Ee] = null;
  return H ? lt : lt.toP();
};
function BasePoint(I, A) {
  this.curve = I, this.type = A, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function I() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function I() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function I(A, G) {
  A = utils$9.toArray(A, G);
  var J = this.p.byteLength();
  if ((A[0] === 4 || A[0] === 6 || A[0] === 7) && A.length - 1 === 2 * J) {
    A[0] === 6 ? assert$8(A[A.length - 1] % 2 === 0) : A[0] === 7 && assert$8(A[A.length - 1] % 2 === 1);
    var _e = this.point(
      A.slice(1, 1 + J),
      A.slice(1 + J, 1 + 2 * J)
    );
    return _e;
  } else if ((A[0] === 2 || A[0] === 3) && A.length - 1 === J)
    return this.pointFromX(A.slice(1, 1 + J), A[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function I(A) {
  return this.encode(A, !0);
};
BasePoint.prototype._encode = function I(A) {
  var G = this.curve.p.byteLength(), J = this.getX().toArray("be", G);
  return A ? [this.getY().isEven() ? 2 : 3].concat(J) : [4].concat(J, this.getY().toArray("be", G));
};
BasePoint.prototype.encode = function I(A, G) {
  return utils$9.encode(this._encode(G), A);
};
BasePoint.prototype.precompute = function I(A) {
  if (this.precomputed)
    return this;
  var G = {
    doubles: null,
    naf: null,
    beta: null
  };
  return G.naf = this._getNAFPoints(8), G.doubles = this._getDoubles(4, A), G.beta = this._getBeta(), this.precomputed = G, this;
};
BasePoint.prototype._hasDoubles = function I(A) {
  if (!this.precomputed)
    return !1;
  var G = this.precomputed.doubles;
  return G ? G.points.length >= Math.ceil((A.bitLength() + 1) / G.step) : !1;
};
BasePoint.prototype._getDoubles = function I(A, G) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var J = [this], _e = this, H = 0; H < G; H += A) {
    for (var De = 0; De < A; De++)
      _e = _e.dbl();
    J.push(_e);
  }
  return {
    step: A,
    points: J
  };
};
BasePoint.prototype._getNAFPoints = function I(A) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var G = [this], J = (1 << A) - 1, _e = J === 1 ? null : this.dbl(), H = 1; H < J; H++)
    G[H] = G[H - 1].add(_e);
  return {
    wnd: A,
    points: G
  };
};
BasePoint.prototype._getBeta = function I() {
  return null;
};
BasePoint.prototype.dblp = function I(A) {
  for (var G = this, J = 0; J < A; J++)
    G = G.dbl();
  return G;
};
var utils$8 = utils$a, BN$6 = bnExports, inherits$2 = inherits_browserExports, Base$2 = base, assert$7 = utils$8.assert;
function ShortCurve(I) {
  Base$2.call(this, "short", I), this.a = new BN$6(I.a, 16).toRed(this.red), this.b = new BN$6(I.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(I), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$2(ShortCurve, Base$2);
var short = ShortCurve;
ShortCurve.prototype._getEndomorphism = function I(A) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var G, J;
    if (A.beta)
      G = new BN$6(A.beta, 16).toRed(this.red);
    else {
      var _e = this._getEndoRoots(this.p);
      G = _e[0].cmp(_e[1]) < 0 ? _e[0] : _e[1], G = G.toRed(this.red);
    }
    if (A.lambda)
      J = new BN$6(A.lambda, 16);
    else {
      var H = this._getEndoRoots(this.n);
      this.g.mul(H[0]).x.cmp(this.g.x.redMul(G)) === 0 ? J = H[0] : (J = H[1], assert$7(this.g.mul(J).x.cmp(this.g.x.redMul(G)) === 0));
    }
    var De;
    return A.basis ? De = A.basis.map(function(Ie) {
      return {
        a: new BN$6(Ie.a, 16),
        b: new BN$6(Ie.b, 16)
      };
    }) : De = this._getEndoBasis(J), {
      beta: G,
      lambda: J,
      basis: De
    };
  }
};
ShortCurve.prototype._getEndoRoots = function I(A) {
  var G = A === this.p ? this.red : BN$6.mont(A), J = new BN$6(2).toRed(G).redInvm(), _e = J.redNeg(), H = new BN$6(3).toRed(G).redNeg().redSqrt().redMul(J), De = _e.redAdd(H).fromRed(), Ie = _e.redSub(H).fromRed();
  return [De, Ie];
};
ShortCurve.prototype._getEndoBasis = function I(A) {
  for (var G = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), J = A, _e = this.n.clone(), H = new BN$6(1), De = new BN$6(0), Ie = new BN$6(0), qe = new BN$6(1), Te, Ee, Oe, Le, ke, Fe, Ge, et = 0, Ve, Je; J.cmpn(0) !== 0; ) {
    var ut = _e.div(J);
    Ve = _e.sub(ut.mul(J)), Je = Ie.sub(ut.mul(H));
    var rt = qe.sub(ut.mul(De));
    if (!Oe && Ve.cmp(G) < 0)
      Te = Ge.neg(), Ee = H, Oe = Ve.neg(), Le = Je;
    else if (Oe && ++et === 2)
      break;
    Ge = Ve, _e = J, J = Ve, Ie = H, H = Je, qe = De, De = rt;
  }
  ke = Ve.neg(), Fe = Je;
  var lt = Oe.sqr().add(Le.sqr()), vt = ke.sqr().add(Fe.sqr());
  return vt.cmp(lt) >= 0 && (ke = Te, Fe = Ee), Oe.negative && (Oe = Oe.neg(), Le = Le.neg()), ke.negative && (ke = ke.neg(), Fe = Fe.neg()), [
    { a: Oe, b: Le },
    { a: ke, b: Fe }
  ];
};
ShortCurve.prototype._endoSplit = function I(A) {
  var G = this.endo.basis, J = G[0], _e = G[1], H = _e.b.mul(A).divRound(this.n), De = J.b.neg().mul(A).divRound(this.n), Ie = H.mul(J.a), qe = De.mul(_e.a), Te = H.mul(J.b), Ee = De.mul(_e.b), Oe = A.sub(Ie).sub(qe), Le = Te.add(Ee).neg();
  return { k1: Oe, k2: Le };
};
ShortCurve.prototype.pointFromX = function I(A, G) {
  A = new BN$6(A, 16), A.red || (A = A.toRed(this.red));
  var J = A.redSqr().redMul(A).redIAdd(A.redMul(this.a)).redIAdd(this.b), _e = J.redSqrt();
  if (_e.redSqr().redSub(J).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var H = _e.fromRed().isOdd();
  return (G && !H || !G && H) && (_e = _e.redNeg()), this.point(A, _e);
};
ShortCurve.prototype.validate = function I(A) {
  if (A.inf)
    return !0;
  var G = A.x, J = A.y, _e = this.a.redMul(G), H = G.redSqr().redMul(G).redIAdd(_e).redIAdd(this.b);
  return J.redSqr().redISub(H).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function I(A, G, J) {
  for (var _e = this._endoWnafT1, H = this._endoWnafT2, De = 0; De < A.length; De++) {
    var Ie = this._endoSplit(G[De]), qe = A[De], Te = qe._getBeta();
    Ie.k1.negative && (Ie.k1.ineg(), qe = qe.neg(!0)), Ie.k2.negative && (Ie.k2.ineg(), Te = Te.neg(!0)), _e[De * 2] = qe, _e[De * 2 + 1] = Te, H[De * 2] = Ie.k1, H[De * 2 + 1] = Ie.k2;
  }
  for (var Ee = this._wnafMulAdd(1, _e, H, De * 2, J), Oe = 0; Oe < De * 2; Oe++)
    _e[Oe] = null, H[Oe] = null;
  return Ee;
};
function Point$2(I, A, G, J) {
  Base$2.BasePoint.call(this, I, "affine"), A === null && G === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$6(A, 16), this.y = new BN$6(G, 16), J && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$2(Point$2, Base$2.BasePoint);
ShortCurve.prototype.point = function I(A, G, J) {
  return new Point$2(this, A, G, J);
};
ShortCurve.prototype.pointFromJSON = function I(A, G) {
  return Point$2.fromJSON(this, A, G);
};
Point$2.prototype._getBeta = function I() {
  if (this.curve.endo) {
    var A = this.precomputed;
    if (A && A.beta)
      return A.beta;
    var G = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (A) {
      var J = this.curve, _e = function(H) {
        return J.point(H.x.redMul(J.endo.beta), H.y);
      };
      A.beta = G, G.precomputed = {
        beta: null,
        naf: A.naf && {
          wnd: A.naf.wnd,
          points: A.naf.points.map(_e)
        },
        doubles: A.doubles && {
          step: A.doubles.step,
          points: A.doubles.points.map(_e)
        }
      };
    }
    return G;
  }
};
Point$2.prototype.toJSON = function I() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$2.fromJSON = function I(A, G, J) {
  typeof G == "string" && (G = JSON.parse(G));
  var _e = A.point(G[0], G[1], J);
  if (!G[2])
    return _e;
  function H(Ie) {
    return A.point(Ie[0], Ie[1], J);
  }
  var De = G[2];
  return _e.precomputed = {
    beta: null,
    doubles: De.doubles && {
      step: De.doubles.step,
      points: [_e].concat(De.doubles.points.map(H))
    },
    naf: De.naf && {
      wnd: De.naf.wnd,
      points: [_e].concat(De.naf.points.map(H))
    }
  }, _e;
};
Point$2.prototype.inspect = function I() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function I() {
  return this.inf;
};
Point$2.prototype.add = function I(A) {
  if (this.inf)
    return A;
  if (A.inf)
    return this;
  if (this.eq(A))
    return this.dbl();
  if (this.neg().eq(A))
    return this.curve.point(null, null);
  if (this.x.cmp(A.x) === 0)
    return this.curve.point(null, null);
  var G = this.y.redSub(A.y);
  G.cmpn(0) !== 0 && (G = G.redMul(this.x.redSub(A.x).redInvm()));
  var J = G.redSqr().redISub(this.x).redISub(A.x), _e = G.redMul(this.x.redSub(J)).redISub(this.y);
  return this.curve.point(J, _e);
};
Point$2.prototype.dbl = function I() {
  if (this.inf)
    return this;
  var A = this.y.redAdd(this.y);
  if (A.cmpn(0) === 0)
    return this.curve.point(null, null);
  var G = this.curve.a, J = this.x.redSqr(), _e = A.redInvm(), H = J.redAdd(J).redIAdd(J).redIAdd(G).redMul(_e), De = H.redSqr().redISub(this.x.redAdd(this.x)), Ie = H.redMul(this.x.redSub(De)).redISub(this.y);
  return this.curve.point(De, Ie);
};
Point$2.prototype.getX = function I() {
  return this.x.fromRed();
};
Point$2.prototype.getY = function I() {
  return this.y.fromRed();
};
Point$2.prototype.mul = function I(A) {
  return A = new BN$6(A, 16), this.isInfinity() ? this : this._hasDoubles(A) ? this.curve._fixedNafMul(this, A) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [A]) : this.curve._wnafMul(this, A);
};
Point$2.prototype.mulAdd = function I(A, G, J) {
  var _e = [this, G], H = [A, J];
  return this.curve.endo ? this.curve._endoWnafMulAdd(_e, H) : this.curve._wnafMulAdd(1, _e, H, 2);
};
Point$2.prototype.jmulAdd = function I(A, G, J) {
  var _e = [this, G], H = [A, J];
  return this.curve.endo ? this.curve._endoWnafMulAdd(_e, H, !0) : this.curve._wnafMulAdd(1, _e, H, 2, !0);
};
Point$2.prototype.eq = function I(A) {
  return this === A || this.inf === A.inf && (this.inf || this.x.cmp(A.x) === 0 && this.y.cmp(A.y) === 0);
};
Point$2.prototype.neg = function I(A) {
  if (this.inf)
    return this;
  var G = this.curve.point(this.x, this.y.redNeg());
  if (A && this.precomputed) {
    var J = this.precomputed, _e = function(H) {
      return H.neg();
    };
    G.precomputed = {
      naf: J.naf && {
        wnd: J.naf.wnd,
        points: J.naf.points.map(_e)
      },
      doubles: J.doubles && {
        step: J.doubles.step,
        points: J.doubles.points.map(_e)
      }
    };
  }
  return G;
};
Point$2.prototype.toJ = function I() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var A = this.curve.jpoint(this.x, this.y, this.curve.one);
  return A;
};
function JPoint(I, A, G, J) {
  Base$2.BasePoint.call(this, I, "jacobian"), A === null && G === null && J === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$6(0)) : (this.x = new BN$6(A, 16), this.y = new BN$6(G, 16), this.z = new BN$6(J, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$2(JPoint, Base$2.BasePoint);
ShortCurve.prototype.jpoint = function I(A, G, J) {
  return new JPoint(this, A, G, J);
};
JPoint.prototype.toP = function I() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var A = this.z.redInvm(), G = A.redSqr(), J = this.x.redMul(G), _e = this.y.redMul(G).redMul(A);
  return this.curve.point(J, _e);
};
JPoint.prototype.neg = function I() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function I(A) {
  if (this.isInfinity())
    return A;
  if (A.isInfinity())
    return this;
  var G = A.z.redSqr(), J = this.z.redSqr(), _e = this.x.redMul(G), H = A.x.redMul(J), De = this.y.redMul(G.redMul(A.z)), Ie = A.y.redMul(J.redMul(this.z)), qe = _e.redSub(H), Te = De.redSub(Ie);
  if (qe.cmpn(0) === 0)
    return Te.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var Ee = qe.redSqr(), Oe = Ee.redMul(qe), Le = _e.redMul(Ee), ke = Te.redSqr().redIAdd(Oe).redISub(Le).redISub(Le), Fe = Te.redMul(Le.redISub(ke)).redISub(De.redMul(Oe)), Ge = this.z.redMul(A.z).redMul(qe);
  return this.curve.jpoint(ke, Fe, Ge);
};
JPoint.prototype.mixedAdd = function I(A) {
  if (this.isInfinity())
    return A.toJ();
  if (A.isInfinity())
    return this;
  var G = this.z.redSqr(), J = this.x, _e = A.x.redMul(G), H = this.y, De = A.y.redMul(G).redMul(this.z), Ie = J.redSub(_e), qe = H.redSub(De);
  if (Ie.cmpn(0) === 0)
    return qe.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var Te = Ie.redSqr(), Ee = Te.redMul(Ie), Oe = J.redMul(Te), Le = qe.redSqr().redIAdd(Ee).redISub(Oe).redISub(Oe), ke = qe.redMul(Oe.redISub(Le)).redISub(H.redMul(Ee)), Fe = this.z.redMul(Ie);
  return this.curve.jpoint(Le, ke, Fe);
};
JPoint.prototype.dblp = function I(A) {
  if (A === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!A)
    return this.dbl();
  var G;
  if (this.curve.zeroA || this.curve.threeA) {
    var J = this;
    for (G = 0; G < A; G++)
      J = J.dbl();
    return J;
  }
  var _e = this.curve.a, H = this.curve.tinv, De = this.x, Ie = this.y, qe = this.z, Te = qe.redSqr().redSqr(), Ee = Ie.redAdd(Ie);
  for (G = 0; G < A; G++) {
    var Oe = De.redSqr(), Le = Ee.redSqr(), ke = Le.redSqr(), Fe = Oe.redAdd(Oe).redIAdd(Oe).redIAdd(_e.redMul(Te)), Ge = De.redMul(Le), et = Fe.redSqr().redISub(Ge.redAdd(Ge)), Ve = Ge.redISub(et), Je = Fe.redMul(Ve);
    Je = Je.redIAdd(Je).redISub(ke);
    var ut = Ee.redMul(qe);
    G + 1 < A && (Te = Te.redMul(ke)), De = et, qe = ut, Ee = Je;
  }
  return this.curve.jpoint(De, Ee.redMul(H), qe);
};
JPoint.prototype.dbl = function I() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function I() {
  var A, G, J;
  if (this.zOne) {
    var _e = this.x.redSqr(), H = this.y.redSqr(), De = H.redSqr(), Ie = this.x.redAdd(H).redSqr().redISub(_e).redISub(De);
    Ie = Ie.redIAdd(Ie);
    var qe = _e.redAdd(_e).redIAdd(_e), Te = qe.redSqr().redISub(Ie).redISub(Ie), Ee = De.redIAdd(De);
    Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), A = Te, G = qe.redMul(Ie.redISub(Te)).redISub(Ee), J = this.y.redAdd(this.y);
  } else {
    var Oe = this.x.redSqr(), Le = this.y.redSqr(), ke = Le.redSqr(), Fe = this.x.redAdd(Le).redSqr().redISub(Oe).redISub(ke);
    Fe = Fe.redIAdd(Fe);
    var Ge = Oe.redAdd(Oe).redIAdd(Oe), et = Ge.redSqr(), Ve = ke.redIAdd(ke);
    Ve = Ve.redIAdd(Ve), Ve = Ve.redIAdd(Ve), A = et.redISub(Fe).redISub(Fe), G = Ge.redMul(Fe.redISub(A)).redISub(Ve), J = this.y.redMul(this.z), J = J.redIAdd(J);
  }
  return this.curve.jpoint(A, G, J);
};
JPoint.prototype._threeDbl = function I() {
  var A, G, J;
  if (this.zOne) {
    var _e = this.x.redSqr(), H = this.y.redSqr(), De = H.redSqr(), Ie = this.x.redAdd(H).redSqr().redISub(_e).redISub(De);
    Ie = Ie.redIAdd(Ie);
    var qe = _e.redAdd(_e).redIAdd(_e).redIAdd(this.curve.a), Te = qe.redSqr().redISub(Ie).redISub(Ie);
    A = Te;
    var Ee = De.redIAdd(De);
    Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), G = qe.redMul(Ie.redISub(Te)).redISub(Ee), J = this.y.redAdd(this.y);
  } else {
    var Oe = this.z.redSqr(), Le = this.y.redSqr(), ke = this.x.redMul(Le), Fe = this.x.redSub(Oe).redMul(this.x.redAdd(Oe));
    Fe = Fe.redAdd(Fe).redIAdd(Fe);
    var Ge = ke.redIAdd(ke);
    Ge = Ge.redIAdd(Ge);
    var et = Ge.redAdd(Ge);
    A = Fe.redSqr().redISub(et), J = this.y.redAdd(this.z).redSqr().redISub(Le).redISub(Oe);
    var Ve = Le.redSqr();
    Ve = Ve.redIAdd(Ve), Ve = Ve.redIAdd(Ve), Ve = Ve.redIAdd(Ve), G = Fe.redMul(Ge.redISub(A)).redISub(Ve);
  }
  return this.curve.jpoint(A, G, J);
};
JPoint.prototype._dbl = function I() {
  var A = this.curve.a, G = this.x, J = this.y, _e = this.z, H = _e.redSqr().redSqr(), De = G.redSqr(), Ie = J.redSqr(), qe = De.redAdd(De).redIAdd(De).redIAdd(A.redMul(H)), Te = G.redAdd(G);
  Te = Te.redIAdd(Te);
  var Ee = Te.redMul(Ie), Oe = qe.redSqr().redISub(Ee.redAdd(Ee)), Le = Ee.redISub(Oe), ke = Ie.redSqr();
  ke = ke.redIAdd(ke), ke = ke.redIAdd(ke), ke = ke.redIAdd(ke);
  var Fe = qe.redMul(Le).redISub(ke), Ge = J.redAdd(J).redMul(_e);
  return this.curve.jpoint(Oe, Fe, Ge);
};
JPoint.prototype.trpl = function I() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var A = this.x.redSqr(), G = this.y.redSqr(), J = this.z.redSqr(), _e = G.redSqr(), H = A.redAdd(A).redIAdd(A), De = H.redSqr(), Ie = this.x.redAdd(G).redSqr().redISub(A).redISub(_e);
  Ie = Ie.redIAdd(Ie), Ie = Ie.redAdd(Ie).redIAdd(Ie), Ie = Ie.redISub(De);
  var qe = Ie.redSqr(), Te = _e.redIAdd(_e);
  Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), Te = Te.redIAdd(Te);
  var Ee = H.redIAdd(Ie).redSqr().redISub(De).redISub(qe).redISub(Te), Oe = G.redMul(Ee);
  Oe = Oe.redIAdd(Oe), Oe = Oe.redIAdd(Oe);
  var Le = this.x.redMul(qe).redISub(Oe);
  Le = Le.redIAdd(Le), Le = Le.redIAdd(Le);
  var ke = this.y.redMul(Ee.redMul(Te.redISub(Ee)).redISub(Ie.redMul(qe)));
  ke = ke.redIAdd(ke), ke = ke.redIAdd(ke), ke = ke.redIAdd(ke);
  var Fe = this.z.redAdd(Ie).redSqr().redISub(J).redISub(qe);
  return this.curve.jpoint(Le, ke, Fe);
};
JPoint.prototype.mul = function I(A, G) {
  return A = new BN$6(A, G), this.curve._wnafMul(this, A);
};
JPoint.prototype.eq = function I(A) {
  if (A.type === "affine")
    return this.eq(A.toJ());
  if (this === A)
    return !0;
  var G = this.z.redSqr(), J = A.z.redSqr();
  if (this.x.redMul(J).redISub(A.x.redMul(G)).cmpn(0) !== 0)
    return !1;
  var _e = G.redMul(this.z), H = J.redMul(A.z);
  return this.y.redMul(H).redISub(A.y.redMul(_e)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function I(A) {
  var G = this.z.redSqr(), J = A.toRed(this.curve.red).redMul(G);
  if (this.x.cmp(J) === 0)
    return !0;
  for (var _e = A.clone(), H = this.curve.redN.redMul(G); ; ) {
    if (_e.iadd(this.curve.n), _e.cmp(this.curve.p) >= 0)
      return !1;
    if (J.redIAdd(H), this.x.cmp(J) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function I() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function I() {
  return this.z.cmpn(0) === 0;
};
var BN$5 = bnExports, inherits$1 = inherits_browserExports, Base$1 = base, utils$7 = utils$a;
function MontCurve(I) {
  Base$1.call(this, "mont", I), this.a = new BN$5(I.a, 16).toRed(this.red), this.b = new BN$5(I.b, 16).toRed(this.red), this.i4 = new BN$5(4).toRed(this.red).redInvm(), this.two = new BN$5(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$1(MontCurve, Base$1);
var mont = MontCurve;
MontCurve.prototype.validate = function I(A) {
  var G = A.normalize().x, J = G.redSqr(), _e = J.redMul(G).redAdd(J.redMul(this.a)).redAdd(G), H = _e.redSqrt();
  return H.redSqr().cmp(_e) === 0;
};
function Point$1(I, A, G) {
  Base$1.BasePoint.call(this, I, "projective"), A === null && G === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$5(A, 16), this.z = new BN$5(G, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$1(Point$1, Base$1.BasePoint);
MontCurve.prototype.decodePoint = function I(A, G) {
  return this.point(utils$7.toArray(A, G), 1);
};
MontCurve.prototype.point = function I(A, G) {
  return new Point$1(this, A, G);
};
MontCurve.prototype.pointFromJSON = function I(A) {
  return Point$1.fromJSON(this, A);
};
Point$1.prototype.precompute = function I() {
};
Point$1.prototype._encode = function I() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$1.fromJSON = function I(A, G) {
  return new Point$1(A, G[0], G[1] || A.one);
};
Point$1.prototype.inspect = function I() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function I() {
  return this.z.cmpn(0) === 0;
};
Point$1.prototype.dbl = function I() {
  var A = this.x.redAdd(this.z), G = A.redSqr(), J = this.x.redSub(this.z), _e = J.redSqr(), H = G.redSub(_e), De = G.redMul(_e), Ie = H.redMul(_e.redAdd(this.curve.a24.redMul(H)));
  return this.curve.point(De, Ie);
};
Point$1.prototype.add = function I() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.diffAdd = function I(A, G) {
  var J = this.x.redAdd(this.z), _e = this.x.redSub(this.z), H = A.x.redAdd(A.z), De = A.x.redSub(A.z), Ie = De.redMul(J), qe = H.redMul(_e), Te = G.z.redMul(Ie.redAdd(qe).redSqr()), Ee = G.x.redMul(Ie.redISub(qe).redSqr());
  return this.curve.point(Te, Ee);
};
Point$1.prototype.mul = function I(A) {
  for (var G = A.clone(), J = this, _e = this.curve.point(null, null), H = this, De = []; G.cmpn(0) !== 0; G.iushrn(1))
    De.push(G.andln(1));
  for (var Ie = De.length - 1; Ie >= 0; Ie--)
    De[Ie] === 0 ? (J = J.diffAdd(_e, H), _e = _e.dbl()) : (_e = J.diffAdd(_e, H), J = J.dbl());
  return _e;
};
Point$1.prototype.mulAdd = function I() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.jumlAdd = function I() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.eq = function I(A) {
  return this.getX().cmp(A.getX()) === 0;
};
Point$1.prototype.normalize = function I() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$1.prototype.getX = function I() {
  return this.normalize(), this.x.fromRed();
};
var utils$6 = utils$a, BN$4 = bnExports, inherits = inherits_browserExports, Base = base, assert$6 = utils$6.assert;
function EdwardsCurve(I) {
  this.twisted = (I.a | 0) !== 1, this.mOneA = this.twisted && (I.a | 0) === -1, this.extended = this.mOneA, Base.call(this, "edwards", I), this.a = new BN$4(I.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$4(I.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$4(I.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$6(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (I.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function I(A) {
  return this.mOneA ? A.redNeg() : this.a.redMul(A);
};
EdwardsCurve.prototype._mulC = function I(A) {
  return this.oneC ? A : this.c.redMul(A);
};
EdwardsCurve.prototype.jpoint = function I(A, G, J, _e) {
  return this.point(A, G, J, _e);
};
EdwardsCurve.prototype.pointFromX = function I(A, G) {
  A = new BN$4(A, 16), A.red || (A = A.toRed(this.red));
  var J = A.redSqr(), _e = this.c2.redSub(this.a.redMul(J)), H = this.one.redSub(this.c2.redMul(this.d).redMul(J)), De = _e.redMul(H.redInvm()), Ie = De.redSqrt();
  if (Ie.redSqr().redSub(De).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var qe = Ie.fromRed().isOdd();
  return (G && !qe || !G && qe) && (Ie = Ie.redNeg()), this.point(A, Ie);
};
EdwardsCurve.prototype.pointFromY = function I(A, G) {
  A = new BN$4(A, 16), A.red || (A = A.toRed(this.red));
  var J = A.redSqr(), _e = J.redSub(this.c2), H = J.redMul(this.d).redMul(this.c2).redSub(this.a), De = _e.redMul(H.redInvm());
  if (De.cmp(this.zero) === 0) {
    if (G)
      throw new Error("invalid point");
    return this.point(this.zero, A);
  }
  var Ie = De.redSqrt();
  if (Ie.redSqr().redSub(De).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return Ie.fromRed().isOdd() !== G && (Ie = Ie.redNeg()), this.point(Ie, A);
};
EdwardsCurve.prototype.validate = function I(A) {
  if (A.isInfinity())
    return !0;
  A.normalize();
  var G = A.x.redSqr(), J = A.y.redSqr(), _e = G.redMul(this.a).redAdd(J), H = this.c2.redMul(this.one.redAdd(this.d.redMul(G).redMul(J)));
  return _e.cmp(H) === 0;
};
function Point(I, A, G, J, _e) {
  Base.BasePoint.call(this, I, "projective"), A === null && G === null && J === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$4(A, 16), this.y = new BN$4(G, 16), this.z = J ? new BN$4(J, 16) : this.curve.one, this.t = _e && new BN$4(_e, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function I(A) {
  return Point.fromJSON(this, A);
};
EdwardsCurve.prototype.point = function I(A, G, J, _e) {
  return new Point(this, A, G, J, _e);
};
Point.fromJSON = function I(A, G) {
  return new Point(A, G[0], G[1], G[2]);
};
Point.prototype.inspect = function I() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function I() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function I() {
  var A = this.x.redSqr(), G = this.y.redSqr(), J = this.z.redSqr();
  J = J.redIAdd(J);
  var _e = this.curve._mulA(A), H = this.x.redAdd(this.y).redSqr().redISub(A).redISub(G), De = _e.redAdd(G), Ie = De.redSub(J), qe = _e.redSub(G), Te = H.redMul(Ie), Ee = De.redMul(qe), Oe = H.redMul(qe), Le = Ie.redMul(De);
  return this.curve.point(Te, Ee, Le, Oe);
};
Point.prototype._projDbl = function I() {
  var A = this.x.redAdd(this.y).redSqr(), G = this.x.redSqr(), J = this.y.redSqr(), _e, H, De, Ie, qe, Te;
  if (this.curve.twisted) {
    Ie = this.curve._mulA(G);
    var Ee = Ie.redAdd(J);
    this.zOne ? (_e = A.redSub(G).redSub(J).redMul(Ee.redSub(this.curve.two)), H = Ee.redMul(Ie.redSub(J)), De = Ee.redSqr().redSub(Ee).redSub(Ee)) : (qe = this.z.redSqr(), Te = Ee.redSub(qe).redISub(qe), _e = A.redSub(G).redISub(J).redMul(Te), H = Ee.redMul(Ie.redSub(J)), De = Ee.redMul(Te));
  } else
    Ie = G.redAdd(J), qe = this.curve._mulC(this.z).redSqr(), Te = Ie.redSub(qe).redSub(qe), _e = this.curve._mulC(A.redISub(Ie)).redMul(Te), H = this.curve._mulC(Ie).redMul(G.redISub(J)), De = Ie.redMul(Te);
  return this.curve.point(_e, H, De);
};
Point.prototype.dbl = function I() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point.prototype._extAdd = function I(A) {
  var G = this.y.redSub(this.x).redMul(A.y.redSub(A.x)), J = this.y.redAdd(this.x).redMul(A.y.redAdd(A.x)), _e = this.t.redMul(this.curve.dd).redMul(A.t), H = this.z.redMul(A.z.redAdd(A.z)), De = J.redSub(G), Ie = H.redSub(_e), qe = H.redAdd(_e), Te = J.redAdd(G), Ee = De.redMul(Ie), Oe = qe.redMul(Te), Le = De.redMul(Te), ke = Ie.redMul(qe);
  return this.curve.point(Ee, Oe, ke, Le);
};
Point.prototype._projAdd = function I(A) {
  var G = this.z.redMul(A.z), J = G.redSqr(), _e = this.x.redMul(A.x), H = this.y.redMul(A.y), De = this.curve.d.redMul(_e).redMul(H), Ie = J.redSub(De), qe = J.redAdd(De), Te = this.x.redAdd(this.y).redMul(A.x.redAdd(A.y)).redISub(_e).redISub(H), Ee = G.redMul(Ie).redMul(Te), Oe, Le;
  return this.curve.twisted ? (Oe = G.redMul(qe).redMul(H.redSub(this.curve._mulA(_e))), Le = Ie.redMul(qe)) : (Oe = G.redMul(qe).redMul(H.redSub(_e)), Le = this.curve._mulC(Ie).redMul(qe)), this.curve.point(Ee, Oe, Le);
};
Point.prototype.add = function I(A) {
  return this.isInfinity() ? A : A.isInfinity() ? this : this.curve.extended ? this._extAdd(A) : this._projAdd(A);
};
Point.prototype.mul = function I(A) {
  return this._hasDoubles(A) ? this.curve._fixedNafMul(this, A) : this.curve._wnafMul(this, A);
};
Point.prototype.mulAdd = function I(A, G, J) {
  return this.curve._wnafMulAdd(1, [this, G], [A, J], 2, !1);
};
Point.prototype.jmulAdd = function I(A, G, J) {
  return this.curve._wnafMulAdd(1, [this, G], [A, J], 2, !0);
};
Point.prototype.normalize = function I() {
  if (this.zOne)
    return this;
  var A = this.z.redInvm();
  return this.x = this.x.redMul(A), this.y = this.y.redMul(A), this.t && (this.t = this.t.redMul(A)), this.z = this.curve.one, this.zOne = !0, this;
};
Point.prototype.neg = function I() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point.prototype.getX = function I() {
  return this.normalize(), this.x.fromRed();
};
Point.prototype.getY = function I() {
  return this.normalize(), this.y.fromRed();
};
Point.prototype.eq = function I(A) {
  return this === A || this.getX().cmp(A.getX()) === 0 && this.getY().cmp(A.getY()) === 0;
};
Point.prototype.eqXToP = function I(A) {
  var G = A.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(G) === 0)
    return !0;
  for (var J = A.clone(), _e = this.curve.redN.redMul(this.z); ; ) {
    if (J.iadd(this.curve.n), J.cmp(this.curve.p) >= 0)
      return !1;
    if (G.redIAdd(_e), this.x.cmp(G) === 0)
      return !0;
  }
};
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;
(function(I) {
  var A = I;
  A.base = base, A.short = short, A.mont = mont, A.edwards = edwards;
})(curve);
var curves$2 = {}, secp256k1, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1;
}
(function(I) {
  var A = I, G = hash$2, J = curve, _e = utils$a, H = _e.assert;
  function De(Te) {
    Te.type === "short" ? this.curve = new J.short(Te) : Te.type === "edwards" ? this.curve = new J.edwards(Te) : this.curve = new J.mont(Te), this.g = this.curve.g, this.n = this.curve.n, this.hash = Te.hash, H(this.g.validate(), "Invalid curve"), H(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  A.PresetCurve = De;
  function Ie(Te, Ee) {
    Object.defineProperty(A, Te, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var Oe = new De(Ee);
        return Object.defineProperty(A, Te, {
          configurable: !0,
          enumerable: !0,
          value: Oe
        }), Oe;
      }
    });
  }
  Ie("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: G.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), Ie("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: G.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), Ie("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: G.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), Ie("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: G.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), Ie("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: G.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), Ie("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: G.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), Ie("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: G.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var qe;
  try {
    qe = requireSecp256k1();
  } catch {
    qe = void 0;
  }
  Ie("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: G.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      qe
    ]
  });
})(curves$2);
var BN$3 = bnExports, utils$5 = utils$a, assert$5 = utils$5.assert;
function KeyPair$3(I, A) {
  this.ec = I, this.priv = null, this.pub = null, A.priv && this._importPrivate(A.priv, A.privEnc), A.pub && this._importPublic(A.pub, A.pubEnc);
}
var key$1 = KeyPair$3;
KeyPair$3.fromPublic = function I(A, G, J) {
  return G instanceof KeyPair$3 ? G : new KeyPair$3(A, {
    pub: G,
    pubEnc: J
  });
};
KeyPair$3.fromPrivate = function I(A, G, J) {
  return G instanceof KeyPair$3 ? G : new KeyPair$3(A, {
    priv: G,
    privEnc: J
  });
};
KeyPair$3.prototype.validate = function I() {
  var A = this.getPublic();
  return A.isInfinity() ? { result: !1, reason: "Invalid public key" } : A.validate() ? A.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$3.prototype.getPublic = function I(A, G) {
  return typeof A == "string" && (G = A, A = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), G ? this.pub.encode(G, A) : this.pub;
};
KeyPair$3.prototype.getPrivate = function I(A) {
  return A === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$3.prototype._importPrivate = function I(A, G) {
  this.priv = new BN$3(A, G || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$3.prototype._importPublic = function I(A, G) {
  if (A.x || A.y) {
    this.ec.curve.type === "mont" ? assert$5(A.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$5(A.x && A.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(A.x, A.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(A, G);
};
KeyPair$3.prototype.derive = function I(A) {
  return A.validate() || assert$5(A.validate(), "public point not validated"), A.mul(this.priv).getX();
};
KeyPair$3.prototype.sign = function I(A, G, J) {
  return this.ec.sign(A, this, G, J);
};
KeyPair$3.prototype.verify = function I(A, G, J) {
  return this.ec.verify(A, G, this, void 0, J);
};
KeyPair$3.prototype.inspect = function I() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$2 = bnExports, utils$4 = utils$a, assert$4 = utils$4.assert;
function Signature$3(I, A) {
  if (I instanceof Signature$3)
    return I;
  this._importDER(I, A) || (assert$4(I.r && I.s, "Signature without r or s"), this.r = new BN$2(I.r, 16), this.s = new BN$2(I.s, 16), I.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = I.recoveryParam);
}
var signature$1 = Signature$3;
function Position() {
  this.place = 0;
}
function getLength(I, A) {
  var G = I[A.place++];
  if (!(G & 128))
    return G;
  var J = G & 15;
  if (J === 0 || J > 4 || I[A.place] === 0)
    return !1;
  for (var _e = 0, H = 0, De = A.place; H < J; H++, De++)
    _e <<= 8, _e |= I[De], _e >>>= 0;
  return _e <= 127 ? !1 : (A.place = De, _e);
}
function rmPadding(I) {
  for (var A = 0, G = I.length - 1; !I[A] && !(I[A + 1] & 128) && A < G; )
    A++;
  return A === 0 ? I : I.slice(A);
}
Signature$3.prototype._importDER = function I(A, G) {
  A = utils$4.toArray(A, G);
  var J = new Position();
  if (A[J.place++] !== 48)
    return !1;
  var _e = getLength(A, J);
  if (_e === !1 || _e + J.place !== A.length || A[J.place++] !== 2)
    return !1;
  var H = getLength(A, J);
  if (H === !1 || A[J.place] & 128)
    return !1;
  var De = A.slice(J.place, H + J.place);
  if (J.place += H, A[J.place++] !== 2)
    return !1;
  var Ie = getLength(A, J);
  if (Ie === !1 || A.length !== Ie + J.place || A[J.place] & 128)
    return !1;
  var qe = A.slice(J.place, Ie + J.place);
  if (De[0] === 0)
    if (De[1] & 128)
      De = De.slice(1);
    else
      return !1;
  if (qe[0] === 0)
    if (qe[1] & 128)
      qe = qe.slice(1);
    else
      return !1;
  return this.r = new BN$2(De), this.s = new BN$2(qe), this.recoveryParam = null, !0;
};
function constructLength(I, A) {
  if (A < 128) {
    I.push(A);
    return;
  }
  var G = 1 + (Math.log(A) / Math.LN2 >>> 3);
  for (I.push(G | 128); --G; )
    I.push(A >>> (G << 3) & 255);
  I.push(A);
}
Signature$3.prototype.toDER = function I(A) {
  var G = this.r.toArray(), J = this.s.toArray();
  for (G[0] & 128 && (G = [0].concat(G)), J[0] & 128 && (J = [0].concat(J)), G = rmPadding(G), J = rmPadding(J); !J[0] && !(J[1] & 128); )
    J = J.slice(1);
  var _e = [2];
  constructLength(_e, G.length), _e = _e.concat(G), _e.push(2), constructLength(_e, J.length);
  var H = _e.concat(J), De = [48];
  return constructLength(De, H.length), De = De.concat(H), utils$4.encode(De, A);
};
var BN$1 = bnExports, HmacDRBG = hmacDrbg, utils$3 = utils$a, curves$1 = curves$2, rand = requireBrorand(), assert$3 = utils$3.assert, KeyPair$2 = key$1, Signature$2 = signature$1;
function EC(I) {
  if (!(this instanceof EC))
    return new EC(I);
  typeof I == "string" && (assert$3(
    Object.prototype.hasOwnProperty.call(curves$1, I),
    "Unknown curve " + I
  ), I = curves$1[I]), I instanceof curves$1.PresetCurve && (I = { curve: I }), this.curve = I.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = I.curve.g, this.g.precompute(I.curve.n.bitLength() + 1), this.hash = I.hash || I.curve.hash;
}
var ec = EC;
EC.prototype.keyPair = function I(A) {
  return new KeyPair$2(this, A);
};
EC.prototype.keyFromPrivate = function I(A, G) {
  return KeyPair$2.fromPrivate(this, A, G);
};
EC.prototype.keyFromPublic = function I(A, G) {
  return KeyPair$2.fromPublic(this, A, G);
};
EC.prototype.genKeyPair = function I(A) {
  A || (A = {});
  for (var G = new HmacDRBG({
    hash: this.hash,
    pers: A.pers,
    persEnc: A.persEnc || "utf8",
    entropy: A.entropy || rand(this.hash.hmacStrength),
    entropyEnc: A.entropy && A.entropyEnc || "utf8",
    nonce: this.n.toArray()
  }), J = this.n.byteLength(), _e = this.n.sub(new BN$1(2)); ; ) {
    var H = new BN$1(G.generate(J));
    if (!(H.cmp(_e) > 0))
      return H.iaddn(1), this.keyFromPrivate(H);
  }
};
EC.prototype._truncateToN = function I(A, G, J) {
  var _e;
  if (BN$1.isBN(A) || typeof A == "number")
    A = new BN$1(A, 16), _e = A.byteLength();
  else if (typeof A == "object")
    _e = A.length, A = new BN$1(A, 16);
  else {
    var H = A.toString();
    _e = H.length + 1 >>> 1, A = new BN$1(H, 16);
  }
  typeof J != "number" && (J = _e * 8);
  var De = J - this.n.bitLength();
  return De > 0 && (A = A.ushrn(De)), !G && A.cmp(this.n) >= 0 ? A.sub(this.n) : A;
};
EC.prototype.sign = function I(A, G, J, _e) {
  if (typeof J == "object" && (_e = J, J = null), _e || (_e = {}), typeof A != "string" && typeof A != "number" && !BN$1.isBN(A)) {
    assert$3(
      typeof A == "object" && A && typeof A.length == "number",
      "Expected message to be an array-like, a hex string, or a BN instance"
    ), assert$3(A.length >>> 0 === A.length);
    for (var H = 0; H < A.length; H++) assert$3((A[H] & 255) === A[H]);
  }
  G = this.keyFromPrivate(G, J), A = this._truncateToN(A, !1, _e.msgBitLength), assert$3(!A.isNeg(), "Can not sign a negative message");
  var De = this.n.byteLength(), Ie = G.getPrivate().toArray("be", De), qe = A.toArray("be", De);
  assert$3(new BN$1(qe).eq(A), "Can not sign message");
  for (var Te = new HmacDRBG({
    hash: this.hash,
    entropy: Ie,
    nonce: qe,
    pers: _e.pers,
    persEnc: _e.persEnc || "utf8"
  }), Ee = this.n.sub(new BN$1(1)), Oe = 0; ; Oe++) {
    var Le = _e.k ? _e.k(Oe) : new BN$1(Te.generate(this.n.byteLength()));
    if (Le = this._truncateToN(Le, !0), !(Le.cmpn(1) <= 0 || Le.cmp(Ee) >= 0)) {
      var ke = this.g.mul(Le);
      if (!ke.isInfinity()) {
        var Fe = ke.getX(), Ge = Fe.umod(this.n);
        if (Ge.cmpn(0) !== 0) {
          var et = Le.invm(this.n).mul(Ge.mul(G.getPrivate()).iadd(A));
          if (et = et.umod(this.n), et.cmpn(0) !== 0) {
            var Ve = (ke.getY().isOdd() ? 1 : 0) | (Fe.cmp(Ge) !== 0 ? 2 : 0);
            return _e.canonical && et.cmp(this.nh) > 0 && (et = this.n.sub(et), Ve ^= 1), new Signature$2({ r: Ge, s: et, recoveryParam: Ve });
          }
        }
      }
    }
  }
};
EC.prototype.verify = function I(A, G, J, _e, H) {
  H || (H = {}), A = this._truncateToN(A, !1, H.msgBitLength), J = this.keyFromPublic(J, _e), G = new Signature$2(G, "hex");
  var De = G.r, Ie = G.s;
  if (De.cmpn(1) < 0 || De.cmp(this.n) >= 0 || Ie.cmpn(1) < 0 || Ie.cmp(this.n) >= 0)
    return !1;
  var qe = Ie.invm(this.n), Te = qe.mul(A).umod(this.n), Ee = qe.mul(De).umod(this.n), Oe;
  return this.curve._maxwellTrick ? (Oe = this.g.jmulAdd(Te, J.getPublic(), Ee), Oe.isInfinity() ? !1 : Oe.eqXToP(De)) : (Oe = this.g.mulAdd(Te, J.getPublic(), Ee), Oe.isInfinity() ? !1 : Oe.getX().umod(this.n).cmp(De) === 0);
};
EC.prototype.recoverPubKey = function(I, A, G, J) {
  assert$3((3 & G) === G, "The recovery param is more than two bits"), A = new Signature$2(A, J);
  var _e = this.n, H = new BN$1(I), De = A.r, Ie = A.s, qe = G & 1, Te = G >> 1;
  if (De.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Te)
    throw new Error("Unable to find sencond key candinate");
  Te ? De = this.curve.pointFromX(De.add(this.curve.n), qe) : De = this.curve.pointFromX(De, qe);
  var Ee = A.r.invm(_e), Oe = _e.sub(H).mul(Ee).umod(_e), Le = Ie.mul(Ee).umod(_e);
  return this.g.mulAdd(Oe, De, Le);
};
EC.prototype.getKeyRecoveryParam = function(I, A, G, J) {
  if (A = new Signature$2(A, J), A.recoveryParam !== null)
    return A.recoveryParam;
  for (var _e = 0; _e < 4; _e++) {
    var H;
    try {
      H = this.recoverPubKey(I, A, _e);
    } catch {
      continue;
    }
    if (H.eq(G))
      return _e;
  }
  throw new Error("Unable to find valid recovery factor");
};
var utils$2 = utils$a, assert$2 = utils$2.assert, parseBytes$2 = utils$2.parseBytes, cachedProperty$1 = utils$2.cachedProperty;
function KeyPair$1(I, A) {
  this.eddsa = I, this._secret = parseBytes$2(A.secret), I.isPoint(A.pub) ? this._pub = A.pub : this._pubBytes = parseBytes$2(A.pub);
}
KeyPair$1.fromPublic = function I(A, G) {
  return G instanceof KeyPair$1 ? G : new KeyPair$1(A, { pub: G });
};
KeyPair$1.fromSecret = function I(A, G) {
  return G instanceof KeyPair$1 ? G : new KeyPair$1(A, { secret: G });
};
KeyPair$1.prototype.secret = function I() {
  return this._secret;
};
cachedProperty$1(KeyPair$1, "pubBytes", function I() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$1, "pub", function I() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$1, "privBytes", function I() {
  var A = this.eddsa, G = this.hash(), J = A.encodingLength - 1, _e = G.slice(0, A.encodingLength);
  return _e[0] &= 248, _e[J] &= 127, _e[J] |= 64, _e;
});
cachedProperty$1(KeyPair$1, "priv", function I() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$1, "hash", function I() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$1, "messagePrefix", function I() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$1.prototype.sign = function I(A) {
  return assert$2(this._secret, "KeyPair can only verify"), this.eddsa.sign(A, this);
};
KeyPair$1.prototype.verify = function I(A, G) {
  return this.eddsa.verify(A, G, this);
};
KeyPair$1.prototype.getSecret = function I(A) {
  return assert$2(this._secret, "KeyPair is public only"), utils$2.encode(this.secret(), A);
};
KeyPair$1.prototype.getPublic = function I(A) {
  return utils$2.encode(this.pubBytes(), A);
};
var key = KeyPair$1, BN = bnExports, utils$1 = utils$a, assert$1 = utils$1.assert, cachedProperty = utils$1.cachedProperty, parseBytes$1 = utils$1.parseBytes;
function Signature$1(I, A) {
  this.eddsa = I, typeof A != "object" && (A = parseBytes$1(A)), Array.isArray(A) && (assert$1(A.length === I.encodingLength * 2, "Signature has invalid size"), A = {
    R: A.slice(0, I.encodingLength),
    S: A.slice(I.encodingLength)
  }), assert$1(A.R && A.S, "Signature without R or S"), I.isPoint(A.R) && (this._R = A.R), A.S instanceof BN && (this._S = A.S), this._Rencoded = Array.isArray(A.R) ? A.R : A.Rencoded, this._Sencoded = Array.isArray(A.S) ? A.S : A.Sencoded;
}
cachedProperty(Signature$1, "S", function I() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$1, "R", function I() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$1, "Rencoded", function I() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$1, "Sencoded", function I() {
  return this.eddsa.encodeInt(this.S());
});
Signature$1.prototype.toBytes = function I() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$1.prototype.toHex = function I() {
  return utils$1.encode(this.toBytes(), "hex").toUpperCase();
};
var signature = Signature$1, hash = hash$2, curves = curves$2, utils = utils$a, assert = utils.assert, parseBytes = utils.parseBytes, KeyPair = key, Signature = signature;
function EDDSA(I) {
  if (assert(I === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(I);
  I = curves[I].curve, this.curve = I, this.g = I.g, this.g.precompute(I.n.bitLength() + 1), this.pointClass = I.point().constructor, this.encodingLength = Math.ceil(I.n.bitLength() / 8), this.hash = hash.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function I(A, G) {
  A = parseBytes(A);
  var J = this.keyFromSecret(G), _e = this.hashInt(J.messagePrefix(), A), H = this.g.mul(_e), De = this.encodePoint(H), Ie = this.hashInt(De, J.pubBytes(), A).mul(J.priv()), qe = _e.add(Ie).umod(this.curve.n);
  return this.makeSignature({ R: H, S: qe, Rencoded: De });
};
EDDSA.prototype.verify = function I(A, G, J) {
  if (A = parseBytes(A), G = this.makeSignature(G), G.S().gte(G.eddsa.curve.n) || G.S().isNeg())
    return !1;
  var _e = this.keyFromPublic(J), H = this.hashInt(G.Rencoded(), _e.pubBytes(), A), De = this.g.mul(G.S()), Ie = G.R().add(_e.pub().mul(H));
  return Ie.eq(De);
};
EDDSA.prototype.hashInt = function I() {
  for (var A = this.hash(), G = 0; G < arguments.length; G++)
    A.update(arguments[G]);
  return utils.intFromLE(A.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function I(A) {
  return KeyPair.fromPublic(this, A);
};
EDDSA.prototype.keyFromSecret = function I(A) {
  return KeyPair.fromSecret(this, A);
};
EDDSA.prototype.makeSignature = function I(A) {
  return A instanceof Signature ? A : new Signature(this, A);
};
EDDSA.prototype.encodePoint = function I(A) {
  var G = A.getY().toArray("le", this.encodingLength);
  return G[this.encodingLength - 1] |= A.getX().isOdd() ? 128 : 0, G;
};
EDDSA.prototype.decodePoint = function I(A) {
  A = utils.parseBytes(A);
  var G = A.length - 1, J = A.slice(0, G).concat(A[G] & -129), _e = (A[G] & 128) !== 0, H = utils.intFromLE(J);
  return this.curve.pointFromY(H, _e);
};
EDDSA.prototype.encodeInt = function I(A) {
  return A.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function I(A) {
  return utils.intFromLE(A);
};
EDDSA.prototype.isPoint = function I(A) {
  return A instanceof this.pointClass;
};
(function(I) {
  var A = I;
  A.version = require$$0.version, A.utils = utils$a, A.rand = requireBrorand(), A.curve = curve, A.curves = curves$2, A.ec = ec, A.eddsa = eddsa;
})(elliptic);
var ed25519 = {}, sha512 = {};
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  var A = binary, G = wipe$1;
  I.DIGEST_LENGTH = 64, I.BLOCK_SIZE = 128;
  var J = (
    /** @class */
    function() {
      function Ie() {
        this.digestLength = I.DIGEST_LENGTH, this.blockSize = I.BLOCK_SIZE, this._stateHi = new Int32Array(8), this._stateLo = new Int32Array(8), this._tempHi = new Int32Array(16), this._tempLo = new Int32Array(16), this._buffer = new Uint8Array(256), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
      }
      return Ie.prototype._initState = function() {
        this._stateHi[0] = 1779033703, this._stateHi[1] = 3144134277, this._stateHi[2] = 1013904242, this._stateHi[3] = 2773480762, this._stateHi[4] = 1359893119, this._stateHi[5] = 2600822924, this._stateHi[6] = 528734635, this._stateHi[7] = 1541459225, this._stateLo[0] = 4089235720, this._stateLo[1] = 2227873595, this._stateLo[2] = 4271175723, this._stateLo[3] = 1595750129, this._stateLo[4] = 2917565137, this._stateLo[5] = 725511199, this._stateLo[6] = 4215389547, this._stateLo[7] = 327033209;
      }, Ie.prototype.reset = function() {
        return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
      }, Ie.prototype.clean = function() {
        G.wipe(this._buffer), G.wipe(this._tempHi), G.wipe(this._tempLo), this.reset();
      }, Ie.prototype.update = function(qe, Te) {
        if (Te === void 0 && (Te = qe.length), this._finished)
          throw new Error("SHA512: can't update because hash was finished.");
        var Ee = 0;
        if (this._bytesHashed += Te, this._bufferLength > 0) {
          for (; this._bufferLength < I.BLOCK_SIZE && Te > 0; )
            this._buffer[this._bufferLength++] = qe[Ee++], Te--;
          this._bufferLength === this.blockSize && (H(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize), this._bufferLength = 0);
        }
        for (Te >= this.blockSize && (Ee = H(this._tempHi, this._tempLo, this._stateHi, this._stateLo, qe, Ee, Te), Te %= this.blockSize); Te > 0; )
          this._buffer[this._bufferLength++] = qe[Ee++], Te--;
        return this;
      }, Ie.prototype.finish = function(qe) {
        if (!this._finished) {
          var Te = this._bytesHashed, Ee = this._bufferLength, Oe = Te / 536870912 | 0, Le = Te << 3, ke = Te % 128 < 112 ? 128 : 256;
          this._buffer[Ee] = 128;
          for (var Fe = Ee + 1; Fe < ke - 8; Fe++)
            this._buffer[Fe] = 0;
          A.writeUint32BE(Oe, this._buffer, ke - 8), A.writeUint32BE(Le, this._buffer, ke - 4), H(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, ke), this._finished = !0;
        }
        for (var Fe = 0; Fe < this.digestLength / 8; Fe++)
          A.writeUint32BE(this._stateHi[Fe], qe, Fe * 8), A.writeUint32BE(this._stateLo[Fe], qe, Fe * 8 + 4);
        return this;
      }, Ie.prototype.digest = function() {
        var qe = new Uint8Array(this.digestLength);
        return this.finish(qe), qe;
      }, Ie.prototype.saveState = function() {
        if (this._finished)
          throw new Error("SHA256: cannot save finished state");
        return {
          stateHi: new Int32Array(this._stateHi),
          stateLo: new Int32Array(this._stateLo),
          buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
          bufferLength: this._bufferLength,
          bytesHashed: this._bytesHashed
        };
      }, Ie.prototype.restoreState = function(qe) {
        return this._stateHi.set(qe.stateHi), this._stateLo.set(qe.stateLo), this._bufferLength = qe.bufferLength, qe.buffer && this._buffer.set(qe.buffer), this._bytesHashed = qe.bytesHashed, this._finished = !1, this;
      }, Ie.prototype.cleanSavedState = function(qe) {
        G.wipe(qe.stateHi), G.wipe(qe.stateLo), qe.buffer && G.wipe(qe.buffer), qe.bufferLength = 0, qe.bytesHashed = 0;
      }, Ie;
    }()
  );
  I.SHA512 = J;
  var _e = new Int32Array([
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ]);
  function H(Ie, qe, Te, Ee, Oe, Le, ke) {
    for (var Fe = Te[0], Ge = Te[1], et = Te[2], Ve = Te[3], Je = Te[4], ut = Te[5], rt = Te[6], lt = Te[7], vt = Ee[0], Ye = Ee[1], pt = Ee[2], bt = Ee[3], Yt = Ee[4], Se = Ee[5], t = Ee[6], h = Ee[7], B, Z, ve, ge, xe, X, a, Y; ke >= 128; ) {
      for (var Ne = 0; Ne < 16; Ne++) {
        var Ke = 8 * Ne + Le;
        Ie[Ne] = A.readUint32BE(Oe, Ke), qe[Ne] = A.readUint32BE(Oe, Ke + 4);
      }
      for (var Ne = 0; Ne < 80; Ne++) {
        var tt = Fe, We = Ge, ot = et, He = Ve, Qe = Je, nt = ut, je = rt, it = lt, st = vt, gt = Ye, It = pt, At = bt, Et = Yt, ei = Se, Xt = t, _t = h;
        if (B = lt, Z = h, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = (Je >>> 14 | Yt << 18) ^ (Je >>> 18 | Yt << 14) ^ (Yt >>> 9 | Je << 23), Z = (Yt >>> 14 | Je << 18) ^ (Yt >>> 18 | Je << 14) ^ (Je >>> 9 | Yt << 23), xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, B = Je & ut ^ ~Je & rt, Z = Yt & Se ^ ~Yt & t, xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, B = _e[Ne * 2], Z = _e[Ne * 2 + 1], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, B = Ie[Ne % 16], Z = qe[Ne % 16], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, ve = a & 65535 | Y << 16, ge = xe & 65535 | X << 16, B = ve, Z = ge, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = (Fe >>> 28 | vt << 4) ^ (vt >>> 2 | Fe << 30) ^ (vt >>> 7 | Fe << 25), Z = (vt >>> 28 | Fe << 4) ^ (Fe >>> 2 | vt << 30) ^ (Fe >>> 7 | vt << 25), xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, B = Fe & Ge ^ Fe & et ^ Ge & et, Z = vt & Ye ^ vt & pt ^ Ye & pt, xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, it = a & 65535 | Y << 16, _t = xe & 65535 | X << 16, B = He, Z = At, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = ve, Z = ge, xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, He = a & 65535 | Y << 16, At = xe & 65535 | X << 16, Ge = tt, et = We, Ve = ot, Je = He, ut = Qe, rt = nt, lt = je, Fe = it, Ye = st, pt = gt, bt = It, Yt = At, Se = Et, t = ei, h = Xt, vt = _t, Ne % 16 === 15)
          for (var Ke = 0; Ke < 16; Ke++)
            B = Ie[Ke], Z = qe[Ke], xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Ie[(Ke + 9) % 16], Z = qe[(Ke + 9) % 16], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, ve = Ie[(Ke + 1) % 16], ge = qe[(Ke + 1) % 16], B = (ve >>> 1 | ge << 31) ^ (ve >>> 8 | ge << 24) ^ ve >>> 7, Z = (ge >>> 1 | ve << 31) ^ (ge >>> 8 | ve << 24) ^ (ge >>> 7 | ve << 25), xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, ve = Ie[(Ke + 14) % 16], ge = qe[(Ke + 14) % 16], B = (ve >>> 19 | ge << 13) ^ (ge >>> 29 | ve << 3) ^ ve >>> 6, Z = (ge >>> 19 | ve << 13) ^ (ve >>> 29 | ge << 3) ^ (ge >>> 6 | ve << 26), xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Ie[Ke] = a & 65535 | Y << 16, qe[Ke] = xe & 65535 | X << 16;
      }
      B = Fe, Z = vt, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Te[0], Z = Ee[0], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Te[0] = Fe = a & 65535 | Y << 16, Ee[0] = vt = xe & 65535 | X << 16, B = Ge, Z = Ye, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Te[1], Z = Ee[1], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Te[1] = Ge = a & 65535 | Y << 16, Ee[1] = Ye = xe & 65535 | X << 16, B = et, Z = pt, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Te[2], Z = Ee[2], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Te[2] = et = a & 65535 | Y << 16, Ee[2] = pt = xe & 65535 | X << 16, B = Ve, Z = bt, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Te[3], Z = Ee[3], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Te[3] = Ve = a & 65535 | Y << 16, Ee[3] = bt = xe & 65535 | X << 16, B = Je, Z = Yt, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Te[4], Z = Ee[4], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Te[4] = Je = a & 65535 | Y << 16, Ee[4] = Yt = xe & 65535 | X << 16, B = ut, Z = Se, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Te[5], Z = Ee[5], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Te[5] = ut = a & 65535 | Y << 16, Ee[5] = Se = xe & 65535 | X << 16, B = rt, Z = t, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Te[6], Z = Ee[6], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Te[6] = rt = a & 65535 | Y << 16, Ee[6] = t = xe & 65535 | X << 16, B = lt, Z = h, xe = Z & 65535, X = Z >>> 16, a = B & 65535, Y = B >>> 16, B = Te[7], Z = Ee[7], xe += Z & 65535, X += Z >>> 16, a += B & 65535, Y += B >>> 16, X += xe >>> 16, a += X >>> 16, Y += a >>> 16, Te[7] = lt = a & 65535 | Y << 16, Ee[7] = h = xe & 65535 | X << 16, Le += 128, ke -= 128;
    }
    return Le;
  }
  function De(Ie) {
    var qe = new J();
    qe.update(Ie);
    var Te = qe.digest();
    return qe.clean(), Te;
  }
  I.hash = De;
})(sha512);
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 }), I.convertSecretKeyToX25519 = I.convertPublicKeyToX25519 = I.verify = I.sign = I.extractPublicKeyFromSecretKey = I.generateKeyPair = I.generateKeyPairFromSeed = I.SEED_LENGTH = I.SECRET_KEY_LENGTH = I.PUBLIC_KEY_LENGTH = I.SIGNATURE_LENGTH = void 0;
  const A = random, G = sha512, J = wipe$1;
  I.SIGNATURE_LENGTH = 64, I.PUBLIC_KEY_LENGTH = 32, I.SECRET_KEY_LENGTH = 64, I.SEED_LENGTH = 32;
  function _e(He) {
    const Qe = new Float64Array(16);
    if (He)
      for (let nt = 0; nt < He.length; nt++)
        Qe[nt] = He[nt];
    return Qe;
  }
  const H = new Uint8Array(32);
  H[0] = 9;
  const De = _e(), Ie = _e([1]), qe = _e([
    30883,
    4953,
    19914,
    30187,
    55467,
    16705,
    2637,
    112,
    59544,
    30585,
    16505,
    36039,
    65139,
    11119,
    27886,
    20995
  ]), Te = _e([
    61785,
    9906,
    39828,
    60374,
    45398,
    33411,
    5274,
    224,
    53552,
    61171,
    33010,
    6542,
    64743,
    22239,
    55772,
    9222
  ]), Ee = _e([
    54554,
    36645,
    11616,
    51542,
    42930,
    38181,
    51040,
    26924,
    56412,
    64982,
    57905,
    49316,
    21502,
    52590,
    14035,
    8553
  ]), Oe = _e([
    26200,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214
  ]), Le = _e([
    41136,
    18958,
    6951,
    50414,
    58488,
    44335,
    6150,
    12099,
    55207,
    15867,
    153,
    11085,
    57099,
    20417,
    9344,
    11139
  ]);
  function ke(He, Qe) {
    for (let nt = 0; nt < 16; nt++)
      He[nt] = Qe[nt] | 0;
  }
  function Fe(He) {
    let Qe = 1;
    for (let nt = 0; nt < 16; nt++) {
      let je = He[nt] + Qe + 65535;
      Qe = Math.floor(je / 65536), He[nt] = je - Qe * 65536;
    }
    He[0] += Qe - 1 + 37 * (Qe - 1);
  }
  function Ge(He, Qe, nt) {
    const je = ~(nt - 1);
    for (let it = 0; it < 16; it++) {
      const st = je & (He[it] ^ Qe[it]);
      He[it] ^= st, Qe[it] ^= st;
    }
  }
  function et(He, Qe) {
    const nt = _e(), je = _e();
    for (let it = 0; it < 16; it++)
      je[it] = Qe[it];
    Fe(je), Fe(je), Fe(je);
    for (let it = 0; it < 2; it++) {
      nt[0] = je[0] - 65517;
      for (let gt = 1; gt < 15; gt++)
        nt[gt] = je[gt] - 65535 - (nt[gt - 1] >> 16 & 1), nt[gt - 1] &= 65535;
      nt[15] = je[15] - 32767 - (nt[14] >> 16 & 1);
      const st = nt[15] >> 16 & 1;
      nt[14] &= 65535, Ge(je, nt, 1 - st);
    }
    for (let it = 0; it < 16; it++)
      He[2 * it] = je[it] & 255, He[2 * it + 1] = je[it] >> 8;
  }
  function Ve(He, Qe) {
    let nt = 0;
    for (let je = 0; je < 32; je++)
      nt |= He[je] ^ Qe[je];
    return (1 & nt - 1 >>> 8) - 1;
  }
  function Je(He, Qe) {
    const nt = new Uint8Array(32), je = new Uint8Array(32);
    return et(nt, He), et(je, Qe), Ve(nt, je);
  }
  function ut(He) {
    const Qe = new Uint8Array(32);
    return et(Qe, He), Qe[0] & 1;
  }
  function rt(He, Qe) {
    for (let nt = 0; nt < 16; nt++)
      He[nt] = Qe[2 * nt] + (Qe[2 * nt + 1] << 8);
    He[15] &= 32767;
  }
  function lt(He, Qe, nt) {
    for (let je = 0; je < 16; je++)
      He[je] = Qe[je] + nt[je];
  }
  function vt(He, Qe, nt) {
    for (let je = 0; je < 16; je++)
      He[je] = Qe[je] - nt[je];
  }
  function Ye(He, Qe, nt) {
    let je, it, st = 0, gt = 0, It = 0, At = 0, Et = 0, ei = 0, Xt = 0, _t = 0, ni = 0, Ct = 0, Wt = 0, ii = 0, Pt = 0, Rt = 0, ai = 0, Nt = 0, qt = 0, oi = 0, ct = 0, Ze = 0, at = 0, dt = 0, yt = 0, St = 0, xt = 0, Vt = 0, ci = 0, Qt = 0, rr = 0, ui = 0, Gr = 0, yr = nt[0], pi = nt[1], wr = nt[2], _r = nt[3], di = nt[4], Sr = nt[5], Br = nt[6], vi = nt[7], gr = nt[8], $r = nt[9], li = nt[10], Ir = nt[11], Cr = nt[12], mi = nt[13], Pr = nt[14], Or = nt[15];
    je = Qe[0], st += je * yr, gt += je * pi, It += je * wr, At += je * _r, Et += je * di, ei += je * Sr, Xt += je * Br, _t += je * vi, ni += je * gr, Ct += je * $r, Wt += je * li, ii += je * Ir, Pt += je * Cr, Rt += je * mi, ai += je * Pr, Nt += je * Or, je = Qe[1], gt += je * yr, It += je * pi, At += je * wr, Et += je * _r, ei += je * di, Xt += je * Sr, _t += je * Br, ni += je * vi, Ct += je * gr, Wt += je * $r, ii += je * li, Pt += je * Ir, Rt += je * Cr, ai += je * mi, Nt += je * Pr, qt += je * Or, je = Qe[2], It += je * yr, At += je * pi, Et += je * wr, ei += je * _r, Xt += je * di, _t += je * Sr, ni += je * Br, Ct += je * vi, Wt += je * gr, ii += je * $r, Pt += je * li, Rt += je * Ir, ai += je * Cr, Nt += je * mi, qt += je * Pr, oi += je * Or, je = Qe[3], At += je * yr, Et += je * pi, ei += je * wr, Xt += je * _r, _t += je * di, ni += je * Sr, Ct += je * Br, Wt += je * vi, ii += je * gr, Pt += je * $r, Rt += je * li, ai += je * Ir, Nt += je * Cr, qt += je * mi, oi += je * Pr, ct += je * Or, je = Qe[4], Et += je * yr, ei += je * pi, Xt += je * wr, _t += je * _r, ni += je * di, Ct += je * Sr, Wt += je * Br, ii += je * vi, Pt += je * gr, Rt += je * $r, ai += je * li, Nt += je * Ir, qt += je * Cr, oi += je * mi, ct += je * Pr, Ze += je * Or, je = Qe[5], ei += je * yr, Xt += je * pi, _t += je * wr, ni += je * _r, Ct += je * di, Wt += je * Sr, ii += je * Br, Pt += je * vi, Rt += je * gr, ai += je * $r, Nt += je * li, qt += je * Ir, oi += je * Cr, ct += je * mi, Ze += je * Pr, at += je * Or, je = Qe[6], Xt += je * yr, _t += je * pi, ni += je * wr, Ct += je * _r, Wt += je * di, ii += je * Sr, Pt += je * Br, Rt += je * vi, ai += je * gr, Nt += je * $r, qt += je * li, oi += je * Ir, ct += je * Cr, Ze += je * mi, at += je * Pr, dt += je * Or, je = Qe[7], _t += je * yr, ni += je * pi, Ct += je * wr, Wt += je * _r, ii += je * di, Pt += je * Sr, Rt += je * Br, ai += je * vi, Nt += je * gr, qt += je * $r, oi += je * li, ct += je * Ir, Ze += je * Cr, at += je * mi, dt += je * Pr, yt += je * Or, je = Qe[8], ni += je * yr, Ct += je * pi, Wt += je * wr, ii += je * _r, Pt += je * di, Rt += je * Sr, ai += je * Br, Nt += je * vi, qt += je * gr, oi += je * $r, ct += je * li, Ze += je * Ir, at += je * Cr, dt += je * mi, yt += je * Pr, St += je * Or, je = Qe[9], Ct += je * yr, Wt += je * pi, ii += je * wr, Pt += je * _r, Rt += je * di, ai += je * Sr, Nt += je * Br, qt += je * vi, oi += je * gr, ct += je * $r, Ze += je * li, at += je * Ir, dt += je * Cr, yt += je * mi, St += je * Pr, xt += je * Or, je = Qe[10], Wt += je * yr, ii += je * pi, Pt += je * wr, Rt += je * _r, ai += je * di, Nt += je * Sr, qt += je * Br, oi += je * vi, ct += je * gr, Ze += je * $r, at += je * li, dt += je * Ir, yt += je * Cr, St += je * mi, xt += je * Pr, Vt += je * Or, je = Qe[11], ii += je * yr, Pt += je * pi, Rt += je * wr, ai += je * _r, Nt += je * di, qt += je * Sr, oi += je * Br, ct += je * vi, Ze += je * gr, at += je * $r, dt += je * li, yt += je * Ir, St += je * Cr, xt += je * mi, Vt += je * Pr, ci += je * Or, je = Qe[12], Pt += je * yr, Rt += je * pi, ai += je * wr, Nt += je * _r, qt += je * di, oi += je * Sr, ct += je * Br, Ze += je * vi, at += je * gr, dt += je * $r, yt += je * li, St += je * Ir, xt += je * Cr, Vt += je * mi, ci += je * Pr, Qt += je * Or, je = Qe[13], Rt += je * yr, ai += je * pi, Nt += je * wr, qt += je * _r, oi += je * di, ct += je * Sr, Ze += je * Br, at += je * vi, dt += je * gr, yt += je * $r, St += je * li, xt += je * Ir, Vt += je * Cr, ci += je * mi, Qt += je * Pr, rr += je * Or, je = Qe[14], ai += je * yr, Nt += je * pi, qt += je * wr, oi += je * _r, ct += je * di, Ze += je * Sr, at += je * Br, dt += je * vi, yt += je * gr, St += je * $r, xt += je * li, Vt += je * Ir, ci += je * Cr, Qt += je * mi, rr += je * Pr, ui += je * Or, je = Qe[15], Nt += je * yr, qt += je * pi, oi += je * wr, ct += je * _r, Ze += je * di, at += je * Sr, dt += je * Br, yt += je * vi, St += je * gr, xt += je * $r, Vt += je * li, ci += je * Ir, Qt += je * Cr, rr += je * mi, ui += je * Pr, Gr += je * Or, st += 38 * qt, gt += 38 * oi, It += 38 * ct, At += 38 * Ze, Et += 38 * at, ei += 38 * dt, Xt += 38 * yt, _t += 38 * St, ni += 38 * xt, Ct += 38 * Vt, Wt += 38 * ci, ii += 38 * Qt, Pt += 38 * rr, Rt += 38 * ui, ai += 38 * Gr, it = 1, je = st + it + 65535, it = Math.floor(je / 65536), st = je - it * 65536, je = gt + it + 65535, it = Math.floor(je / 65536), gt = je - it * 65536, je = It + it + 65535, it = Math.floor(je / 65536), It = je - it * 65536, je = At + it + 65535, it = Math.floor(je / 65536), At = je - it * 65536, je = Et + it + 65535, it = Math.floor(je / 65536), Et = je - it * 65536, je = ei + it + 65535, it = Math.floor(je / 65536), ei = je - it * 65536, je = Xt + it + 65535, it = Math.floor(je / 65536), Xt = je - it * 65536, je = _t + it + 65535, it = Math.floor(je / 65536), _t = je - it * 65536, je = ni + it + 65535, it = Math.floor(je / 65536), ni = je - it * 65536, je = Ct + it + 65535, it = Math.floor(je / 65536), Ct = je - it * 65536, je = Wt + it + 65535, it = Math.floor(je / 65536), Wt = je - it * 65536, je = ii + it + 65535, it = Math.floor(je / 65536), ii = je - it * 65536, je = Pt + it + 65535, it = Math.floor(je / 65536), Pt = je - it * 65536, je = Rt + it + 65535, it = Math.floor(je / 65536), Rt = je - it * 65536, je = ai + it + 65535, it = Math.floor(je / 65536), ai = je - it * 65536, je = Nt + it + 65535, it = Math.floor(je / 65536), Nt = je - it * 65536, st += it - 1 + 37 * (it - 1), it = 1, je = st + it + 65535, it = Math.floor(je / 65536), st = je - it * 65536, je = gt + it + 65535, it = Math.floor(je / 65536), gt = je - it * 65536, je = It + it + 65535, it = Math.floor(je / 65536), It = je - it * 65536, je = At + it + 65535, it = Math.floor(je / 65536), At = je - it * 65536, je = Et + it + 65535, it = Math.floor(je / 65536), Et = je - it * 65536, je = ei + it + 65535, it = Math.floor(je / 65536), ei = je - it * 65536, je = Xt + it + 65535, it = Math.floor(je / 65536), Xt = je - it * 65536, je = _t + it + 65535, it = Math.floor(je / 65536), _t = je - it * 65536, je = ni + it + 65535, it = Math.floor(je / 65536), ni = je - it * 65536, je = Ct + it + 65535, it = Math.floor(je / 65536), Ct = je - it * 65536, je = Wt + it + 65535, it = Math.floor(je / 65536), Wt = je - it * 65536, je = ii + it + 65535, it = Math.floor(je / 65536), ii = je - it * 65536, je = Pt + it + 65535, it = Math.floor(je / 65536), Pt = je - it * 65536, je = Rt + it + 65535, it = Math.floor(je / 65536), Rt = je - it * 65536, je = ai + it + 65535, it = Math.floor(je / 65536), ai = je - it * 65536, je = Nt + it + 65535, it = Math.floor(je / 65536), Nt = je - it * 65536, st += it - 1 + 37 * (it - 1), He[0] = st, He[1] = gt, He[2] = It, He[3] = At, He[4] = Et, He[5] = ei, He[6] = Xt, He[7] = _t, He[8] = ni, He[9] = Ct, He[10] = Wt, He[11] = ii, He[12] = Pt, He[13] = Rt, He[14] = ai, He[15] = Nt;
  }
  function pt(He, Qe) {
    Ye(He, Qe, Qe);
  }
  function bt(He, Qe) {
    const nt = _e();
    let je;
    for (je = 0; je < 16; je++)
      nt[je] = Qe[je];
    for (je = 253; je >= 0; je--)
      pt(nt, nt), je !== 2 && je !== 4 && Ye(nt, nt, Qe);
    for (je = 0; je < 16; je++)
      He[je] = nt[je];
  }
  function Yt(He, Qe) {
    const nt = _e();
    let je;
    for (je = 0; je < 16; je++)
      nt[je] = Qe[je];
    for (je = 250; je >= 0; je--)
      pt(nt, nt), je !== 1 && Ye(nt, nt, Qe);
    for (je = 0; je < 16; je++)
      He[je] = nt[je];
  }
  function Se(He, Qe) {
    const nt = _e(), je = _e(), it = _e(), st = _e(), gt = _e(), It = _e(), At = _e(), Et = _e(), ei = _e();
    vt(nt, He[1], He[0]), vt(ei, Qe[1], Qe[0]), Ye(nt, nt, ei), lt(je, He[0], He[1]), lt(ei, Qe[0], Qe[1]), Ye(je, je, ei), Ye(it, He[3], Qe[3]), Ye(it, it, Te), Ye(st, He[2], Qe[2]), lt(st, st, st), vt(gt, je, nt), vt(It, st, it), lt(At, st, it), lt(Et, je, nt), Ye(He[0], gt, It), Ye(He[1], Et, At), Ye(He[2], At, It), Ye(He[3], gt, Et);
  }
  function t(He, Qe, nt) {
    for (let je = 0; je < 4; je++)
      Ge(He[je], Qe[je], nt);
  }
  function h(He, Qe) {
    const nt = _e(), je = _e(), it = _e();
    bt(it, Qe[2]), Ye(nt, Qe[0], it), Ye(je, Qe[1], it), et(He, je), He[31] ^= ut(nt) << 7;
  }
  function B(He, Qe, nt) {
    ke(He[0], De), ke(He[1], Ie), ke(He[2], Ie), ke(He[3], De);
    for (let je = 255; je >= 0; --je) {
      const it = nt[je / 8 | 0] >> (je & 7) & 1;
      t(He, Qe, it), Se(Qe, He), Se(He, He), t(He, Qe, it);
    }
  }
  function Z(He, Qe) {
    const nt = [_e(), _e(), _e(), _e()];
    ke(nt[0], Ee), ke(nt[1], Oe), ke(nt[2], Ie), Ye(nt[3], Ee, Oe), B(He, nt, Qe);
  }
  function ve(He) {
    if (He.length !== I.SEED_LENGTH)
      throw new Error(`ed25519: seed must be ${I.SEED_LENGTH} bytes`);
    const Qe = (0, G.hash)(He);
    Qe[0] &= 248, Qe[31] &= 127, Qe[31] |= 64;
    const nt = new Uint8Array(32), je = [_e(), _e(), _e(), _e()];
    Z(je, Qe), h(nt, je);
    const it = new Uint8Array(64);
    return it.set(He), it.set(nt, 32), {
      publicKey: nt,
      secretKey: it
    };
  }
  I.generateKeyPairFromSeed = ve;
  function ge(He) {
    const Qe = (0, A.randomBytes)(32, He), nt = ve(Qe);
    return (0, J.wipe)(Qe), nt;
  }
  I.generateKeyPair = ge;
  function xe(He) {
    if (He.length !== I.SECRET_KEY_LENGTH)
      throw new Error(`ed25519: secret key must be ${I.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(He.subarray(32));
  }
  I.extractPublicKeyFromSecretKey = xe;
  const X = new Float64Array([
    237,
    211,
    245,
    92,
    26,
    99,
    18,
    88,
    214,
    156,
    247,
    162,
    222,
    249,
    222,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    16
  ]);
  function a(He, Qe) {
    let nt, je, it, st;
    for (je = 63; je >= 32; --je) {
      for (nt = 0, it = je - 32, st = je - 12; it < st; ++it)
        Qe[it] += nt - 16 * Qe[je] * X[it - (je - 32)], nt = Math.floor((Qe[it] + 128) / 256), Qe[it] -= nt * 256;
      Qe[it] += nt, Qe[je] = 0;
    }
    for (nt = 0, it = 0; it < 32; it++)
      Qe[it] += nt - (Qe[31] >> 4) * X[it], nt = Qe[it] >> 8, Qe[it] &= 255;
    for (it = 0; it < 32; it++)
      Qe[it] -= nt * X[it];
    for (je = 0; je < 32; je++)
      Qe[je + 1] += Qe[je] >> 8, He[je] = Qe[je] & 255;
  }
  function Y(He) {
    const Qe = new Float64Array(64);
    for (let nt = 0; nt < 64; nt++)
      Qe[nt] = He[nt];
    for (let nt = 0; nt < 64; nt++)
      He[nt] = 0;
    a(He, Qe);
  }
  function Ne(He, Qe) {
    const nt = new Float64Array(64), je = [_e(), _e(), _e(), _e()], it = (0, G.hash)(He.subarray(0, 32));
    it[0] &= 248, it[31] &= 127, it[31] |= 64;
    const st = new Uint8Array(64);
    st.set(it.subarray(32), 32);
    const gt = new G.SHA512();
    gt.update(st.subarray(32)), gt.update(Qe);
    const It = gt.digest();
    gt.clean(), Y(It), Z(je, It), h(st, je), gt.reset(), gt.update(st.subarray(0, 32)), gt.update(He.subarray(32)), gt.update(Qe);
    const At = gt.digest();
    Y(At);
    for (let Et = 0; Et < 32; Et++)
      nt[Et] = It[Et];
    for (let Et = 0; Et < 32; Et++)
      for (let ei = 0; ei < 32; ei++)
        nt[Et + ei] += At[Et] * it[ei];
    return a(st.subarray(32), nt), st;
  }
  I.sign = Ne;
  function Ke(He, Qe) {
    const nt = _e(), je = _e(), it = _e(), st = _e(), gt = _e(), It = _e(), At = _e();
    return ke(He[2], Ie), rt(He[1], Qe), pt(it, He[1]), Ye(st, it, qe), vt(it, it, He[2]), lt(st, He[2], st), pt(gt, st), pt(It, gt), Ye(At, It, gt), Ye(nt, At, it), Ye(nt, nt, st), Yt(nt, nt), Ye(nt, nt, it), Ye(nt, nt, st), Ye(nt, nt, st), Ye(He[0], nt, st), pt(je, He[0]), Ye(je, je, st), Je(je, it) && Ye(He[0], He[0], Le), pt(je, He[0]), Ye(je, je, st), Je(je, it) ? -1 : (ut(He[0]) === Qe[31] >> 7 && vt(He[0], De, He[0]), Ye(He[3], He[0], He[1]), 0);
  }
  function tt(He, Qe, nt) {
    const je = new Uint8Array(32), it = [_e(), _e(), _e(), _e()], st = [_e(), _e(), _e(), _e()];
    if (nt.length !== I.SIGNATURE_LENGTH)
      throw new Error(`ed25519: signature must be ${I.SIGNATURE_LENGTH} bytes`);
    if (Ke(st, He))
      return !1;
    const gt = new G.SHA512();
    gt.update(nt.subarray(0, 32)), gt.update(He), gt.update(Qe);
    const It = gt.digest();
    return Y(It), B(it, st, It), Z(st, nt.subarray(32)), Se(it, st), h(je, it), !Ve(nt, je);
  }
  I.verify = tt;
  function We(He) {
    let Qe = [_e(), _e(), _e(), _e()];
    if (Ke(Qe, He))
      throw new Error("Ed25519: invalid public key");
    let nt = _e(), je = _e(), it = Qe[1];
    lt(nt, Ie, it), vt(je, Ie, it), bt(je, je), Ye(nt, nt, je);
    let st = new Uint8Array(32);
    return et(st, nt), st;
  }
  I.convertPublicKeyToX25519 = We;
  function ot(He) {
    const Qe = (0, G.hash)(He.subarray(0, 32));
    Qe[0] &= 248, Qe[31] &= 127, Qe[31] |= 64;
    const nt = new Uint8Array(Qe.subarray(0, 32));
    return (0, J.wipe)(Qe), nt;
  }
  I.convertSecretKeyToX25519 = ot;
})(ed25519);
const JSONStringify = (I) => JSON.stringify(I, (A, G) => typeof G == "bigint" ? G.toString() + "n" : G), JSONParse = (I) => {
  const A = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g, G = I.replace(A, '$1"$2n"$3');
  return JSON.parse(G, (J, _e) => typeof _e == "string" && _e.match(/^\d+n$/) ? BigInt(_e.substring(0, _e.length - 1)) : _e);
};
function safeJsonParse(I) {
  if (typeof I != "string")
    throw new Error(`Cannot safe json parse value of type ${typeof I}`);
  try {
    return JSONParse(I);
  } catch {
    return I;
  }
}
function safeJsonStringify(I) {
  return typeof I == "string" ? I : JSONStringify(I) || "";
}
const Rr = ":";
function An(I) {
  const [A, G] = I.split(Rr);
  return { namespace: A, reference: G };
}
function Wo(I, A = []) {
  const G = [];
  return Object.keys(I).forEach((J) => {
    if (A.length && !A.includes(J)) return;
    const _e = I[J];
    G.push(..._e.accounts);
  }), G;
}
function me(I = [], A = []) {
  return [.../* @__PURE__ */ new Set([...I, ...A])];
}
var Kn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Bs(I) {
  var A = I.default;
  if (typeof A == "function") {
    var G = function() {
      return A.apply(this, arguments);
    };
    G.prototype = A.prototype;
  } else G = {};
  return Object.defineProperty(G, "__esModule", { value: !0 }), Object.keys(I).forEach(function(J) {
    var _e = Object.getOwnPropertyDescriptor(I, J);
    Object.defineProperty(G, J, _e.get ? _e : { enumerable: !0, get: function() {
      return I[J];
    } });
  }), G;
}
var Hn = { exports: {} };
/**
* [js-sha3]{@link https://github.com/emn178/js-sha3}
*
* @version 0.8.0
* @author Chen, Yi-Cyuan [emn178@gmail.com]
* @copyright Chen, Yi-Cyuan 2015-2018
* @license MIT
*/
(function(I) {
  (function() {
    var A = "input is invalid type", G = "finalize already called", J = typeof window == "object", _e = J ? window : {};
    _e.JS_SHA3_NO_WINDOW && (J = !1);
    var H = !J && typeof self == "object", De = !_e.JS_SHA3_NO_NODE_JS && typeof process$1 == "object" && process$1.versions && process$1.versions.node;
    De ? _e = Kn : H && (_e = self);
    var Ie = !_e.JS_SHA3_NO_COMMON_JS && !0 && I.exports, qe = !_e.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", Te = "0123456789abcdef".split(""), Ee = [31, 7936, 2031616, 520093696], Oe = [4, 1024, 262144, 67108864], Le = [1, 256, 65536, 16777216], ke = [6, 1536, 393216, 100663296], Fe = [0, 8, 16, 24], Ge = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648], et = [224, 256, 384, 512], Ve = [128, 256], Je = ["hex", "buffer", "arrayBuffer", "array", "digest"], ut = { 128: 168, 256: 136 };
    (_e.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(We) {
      return Object.prototype.toString.call(We) === "[object Array]";
    }), qe && (_e.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(We) {
      return typeof We == "object" && We.buffer && We.buffer.constructor === ArrayBuffer;
    });
    for (var rt = function(We, ot, He) {
      return function(Qe) {
        return new Ne(We, ot, We).update(Qe)[He]();
      };
    }, lt = function(We, ot, He) {
      return function(Qe, nt) {
        return new Ne(We, ot, nt).update(Qe)[He]();
      };
    }, vt = function(We, ot, He) {
      return function(Qe, nt, je, it) {
        return B["cshake" + We].update(Qe, nt, je, it)[He]();
      };
    }, Ye = function(We, ot, He) {
      return function(Qe, nt, je, it) {
        return B["kmac" + We].update(Qe, nt, je, it)[He]();
      };
    }, pt = function(We, ot, He, Qe) {
      for (var nt = 0; nt < Je.length; ++nt) {
        var je = Je[nt];
        We[je] = ot(He, Qe, je);
      }
      return We;
    }, bt = function(We, ot) {
      var He = rt(We, ot, "hex");
      return He.create = function() {
        return new Ne(We, ot, We);
      }, He.update = function(Qe) {
        return He.create().update(Qe);
      }, pt(He, rt, We, ot);
    }, Yt = function(We, ot) {
      var He = lt(We, ot, "hex");
      return He.create = function(Qe) {
        return new Ne(We, ot, Qe);
      }, He.update = function(Qe, nt) {
        return He.create(nt).update(Qe);
      }, pt(He, lt, We, ot);
    }, Se = function(We, ot) {
      var He = ut[We], Qe = vt(We, ot, "hex");
      return Qe.create = function(nt, je, it) {
        return !je && !it ? B["shake" + We].create(nt) : new Ne(We, ot, nt).bytepad([je, it], He);
      }, Qe.update = function(nt, je, it, st) {
        return Qe.create(je, it, st).update(nt);
      }, pt(Qe, vt, We, ot);
    }, t = function(We, ot) {
      var He = ut[We], Qe = Ye(We, ot, "hex");
      return Qe.create = function(nt, je, it) {
        return new Ke(We, ot, je).bytepad(["KMAC", it], He).bytepad([nt], He);
      }, Qe.update = function(nt, je, it, st) {
        return Qe.create(nt, it, st).update(je);
      }, pt(Qe, Ye, We, ot);
    }, h = [{ name: "keccak", padding: Le, bits: et, createMethod: bt }, { name: "sha3", padding: ke, bits: et, createMethod: bt }, { name: "shake", padding: Ee, bits: Ve, createMethod: Yt }, { name: "cshake", padding: Oe, bits: Ve, createMethod: Se }, { name: "kmac", padding: Oe, bits: Ve, createMethod: t }], B = {}, Z = [], ve = 0; ve < h.length; ++ve) for (var ge = h[ve], xe = ge.bits, X = 0; X < xe.length; ++X) {
      var a = ge.name + "_" + xe[X];
      if (Z.push(a), B[a] = ge.createMethod(xe[X], ge.padding), ge.name !== "sha3") {
        var Y = ge.name + xe[X];
        Z.push(Y), B[Y] = B[a];
      }
    }
    function Ne(We, ot, He) {
      this.blocks = [], this.s = [], this.padding = ot, this.outputBits = He, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (We << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = He >> 5, this.extraBytes = (He & 31) >> 3;
      for (var Qe = 0; Qe < 50; ++Qe) this.s[Qe] = 0;
    }
    Ne.prototype.update = function(We) {
      if (this.finalized) throw new Error(G);
      var ot, He = typeof We;
      if (He !== "string") {
        if (He === "object") {
          if (We === null) throw new Error(A);
          if (qe && We.constructor === ArrayBuffer) We = new Uint8Array(We);
          else if (!Array.isArray(We) && (!qe || !ArrayBuffer.isView(We))) throw new Error(A);
        } else throw new Error(A);
        ot = !0;
      }
      for (var Qe = this.blocks, nt = this.byteCount, je = We.length, it = this.blockCount, st = 0, gt = this.s, It, At; st < je; ) {
        if (this.reset) for (this.reset = !1, Qe[0] = this.block, It = 1; It < it + 1; ++It) Qe[It] = 0;
        if (ot) for (It = this.start; st < je && It < nt; ++st) Qe[It >> 2] |= We[st] << Fe[It++ & 3];
        else for (It = this.start; st < je && It < nt; ++st) At = We.charCodeAt(st), At < 128 ? Qe[It >> 2] |= At << Fe[It++ & 3] : At < 2048 ? (Qe[It >> 2] |= (192 | At >> 6) << Fe[It++ & 3], Qe[It >> 2] |= (128 | At & 63) << Fe[It++ & 3]) : At < 55296 || At >= 57344 ? (Qe[It >> 2] |= (224 | At >> 12) << Fe[It++ & 3], Qe[It >> 2] |= (128 | At >> 6 & 63) << Fe[It++ & 3], Qe[It >> 2] |= (128 | At & 63) << Fe[It++ & 3]) : (At = 65536 + ((At & 1023) << 10 | We.charCodeAt(++st) & 1023), Qe[It >> 2] |= (240 | At >> 18) << Fe[It++ & 3], Qe[It >> 2] |= (128 | At >> 12 & 63) << Fe[It++ & 3], Qe[It >> 2] |= (128 | At >> 6 & 63) << Fe[It++ & 3], Qe[It >> 2] |= (128 | At & 63) << Fe[It++ & 3]);
        if (this.lastByteIndex = It, It >= nt) {
          for (this.start = It - nt, this.block = Qe[it], It = 0; It < it; ++It) gt[It] ^= Qe[It];
          tt(gt), this.reset = !0;
        } else this.start = It;
      }
      return this;
    }, Ne.prototype.encode = function(We, ot) {
      var He = We & 255, Qe = 1, nt = [He];
      for (We = We >> 8, He = We & 255; He > 0; ) nt.unshift(He), We = We >> 8, He = We & 255, ++Qe;
      return ot ? nt.push(Qe) : nt.unshift(Qe), this.update(nt), nt.length;
    }, Ne.prototype.encodeString = function(We) {
      var ot, He = typeof We;
      if (He !== "string") {
        if (He === "object") {
          if (We === null) throw new Error(A);
          if (qe && We.constructor === ArrayBuffer) We = new Uint8Array(We);
          else if (!Array.isArray(We) && (!qe || !ArrayBuffer.isView(We))) throw new Error(A);
        } else throw new Error(A);
        ot = !0;
      }
      var Qe = 0, nt = We.length;
      if (ot) Qe = nt;
      else for (var je = 0; je < We.length; ++je) {
        var it = We.charCodeAt(je);
        it < 128 ? Qe += 1 : it < 2048 ? Qe += 2 : it < 55296 || it >= 57344 ? Qe += 3 : (it = 65536 + ((it & 1023) << 10 | We.charCodeAt(++je) & 1023), Qe += 4);
      }
      return Qe += this.encode(Qe * 8), this.update(We), Qe;
    }, Ne.prototype.bytepad = function(We, ot) {
      for (var He = this.encode(ot), Qe = 0; Qe < We.length; ++Qe) He += this.encodeString(We[Qe]);
      var nt = ot - He % ot, je = [];
      return je.length = nt, this.update(je), this;
    }, Ne.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var We = this.blocks, ot = this.lastByteIndex, He = this.blockCount, Qe = this.s;
        if (We[ot >> 2] |= this.padding[ot & 3], this.lastByteIndex === this.byteCount) for (We[0] = We[He], ot = 1; ot < He + 1; ++ot) We[ot] = 0;
        for (We[He - 1] |= 2147483648, ot = 0; ot < He; ++ot) Qe[ot] ^= We[ot];
        tt(Qe);
      }
    }, Ne.prototype.toString = Ne.prototype.hex = function() {
      this.finalize();
      for (var We = this.blockCount, ot = this.s, He = this.outputBlocks, Qe = this.extraBytes, nt = 0, je = 0, it = "", st; je < He; ) {
        for (nt = 0; nt < We && je < He; ++nt, ++je) st = ot[nt], it += Te[st >> 4 & 15] + Te[st & 15] + Te[st >> 12 & 15] + Te[st >> 8 & 15] + Te[st >> 20 & 15] + Te[st >> 16 & 15] + Te[st >> 28 & 15] + Te[st >> 24 & 15];
        je % We === 0 && (tt(ot), nt = 0);
      }
      return Qe && (st = ot[nt], it += Te[st >> 4 & 15] + Te[st & 15], Qe > 1 && (it += Te[st >> 12 & 15] + Te[st >> 8 & 15]), Qe > 2 && (it += Te[st >> 20 & 15] + Te[st >> 16 & 15])), it;
    }, Ne.prototype.arrayBuffer = function() {
      this.finalize();
      var We = this.blockCount, ot = this.s, He = this.outputBlocks, Qe = this.extraBytes, nt = 0, je = 0, it = this.outputBits >> 3, st;
      Qe ? st = new ArrayBuffer(He + 1 << 2) : st = new ArrayBuffer(it);
      for (var gt = new Uint32Array(st); je < He; ) {
        for (nt = 0; nt < We && je < He; ++nt, ++je) gt[je] = ot[nt];
        je % We === 0 && tt(ot);
      }
      return Qe && (gt[nt] = ot[nt], st = st.slice(0, it)), st;
    }, Ne.prototype.buffer = Ne.prototype.arrayBuffer, Ne.prototype.digest = Ne.prototype.array = function() {
      this.finalize();
      for (var We = this.blockCount, ot = this.s, He = this.outputBlocks, Qe = this.extraBytes, nt = 0, je = 0, it = [], st, gt; je < He; ) {
        for (nt = 0; nt < We && je < He; ++nt, ++je) st = je << 2, gt = ot[nt], it[st] = gt & 255, it[st + 1] = gt >> 8 & 255, it[st + 2] = gt >> 16 & 255, it[st + 3] = gt >> 24 & 255;
        je % We === 0 && tt(ot);
      }
      return Qe && (st = je << 2, gt = ot[nt], it[st] = gt & 255, Qe > 1 && (it[st + 1] = gt >> 8 & 255), Qe > 2 && (it[st + 2] = gt >> 16 & 255)), it;
    };
    function Ke(We, ot, He) {
      Ne.call(this, We, ot, He);
    }
    Ke.prototype = new Ne(), Ke.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), Ne.prototype.finalize.call(this);
    };
    var tt = function(We) {
      var ot, He, Qe, nt, je, it, st, gt, It, At, Et, ei, Xt, _t, ni, Ct, Wt, ii, Pt, Rt, ai, Nt, qt, oi, ct, Ze, at, dt, yt, St, xt, Vt, ci, Qt, rr, ui, Gr, yr, pi, wr, _r, di, Sr, Br, vi, gr, $r, li, Ir, Cr, mi, Pr, Or, yi, Zr, Vr, bi, Ai, Zi, Ji, Vi, Yi, Xi;
      for (Qe = 0; Qe < 48; Qe += 2) nt = We[0] ^ We[10] ^ We[20] ^ We[30] ^ We[40], je = We[1] ^ We[11] ^ We[21] ^ We[31] ^ We[41], it = We[2] ^ We[12] ^ We[22] ^ We[32] ^ We[42], st = We[3] ^ We[13] ^ We[23] ^ We[33] ^ We[43], gt = We[4] ^ We[14] ^ We[24] ^ We[34] ^ We[44], It = We[5] ^ We[15] ^ We[25] ^ We[35] ^ We[45], At = We[6] ^ We[16] ^ We[26] ^ We[36] ^ We[46], Et = We[7] ^ We[17] ^ We[27] ^ We[37] ^ We[47], ei = We[8] ^ We[18] ^ We[28] ^ We[38] ^ We[48], Xt = We[9] ^ We[19] ^ We[29] ^ We[39] ^ We[49], ot = ei ^ (it << 1 | st >>> 31), He = Xt ^ (st << 1 | it >>> 31), We[0] ^= ot, We[1] ^= He, We[10] ^= ot, We[11] ^= He, We[20] ^= ot, We[21] ^= He, We[30] ^= ot, We[31] ^= He, We[40] ^= ot, We[41] ^= He, ot = nt ^ (gt << 1 | It >>> 31), He = je ^ (It << 1 | gt >>> 31), We[2] ^= ot, We[3] ^= He, We[12] ^= ot, We[13] ^= He, We[22] ^= ot, We[23] ^= He, We[32] ^= ot, We[33] ^= He, We[42] ^= ot, We[43] ^= He, ot = it ^ (At << 1 | Et >>> 31), He = st ^ (Et << 1 | At >>> 31), We[4] ^= ot, We[5] ^= He, We[14] ^= ot, We[15] ^= He, We[24] ^= ot, We[25] ^= He, We[34] ^= ot, We[35] ^= He, We[44] ^= ot, We[45] ^= He, ot = gt ^ (ei << 1 | Xt >>> 31), He = It ^ (Xt << 1 | ei >>> 31), We[6] ^= ot, We[7] ^= He, We[16] ^= ot, We[17] ^= He, We[26] ^= ot, We[27] ^= He, We[36] ^= ot, We[37] ^= He, We[46] ^= ot, We[47] ^= He, ot = At ^ (nt << 1 | je >>> 31), He = Et ^ (je << 1 | nt >>> 31), We[8] ^= ot, We[9] ^= He, We[18] ^= ot, We[19] ^= He, We[28] ^= ot, We[29] ^= He, We[38] ^= ot, We[39] ^= He, We[48] ^= ot, We[49] ^= He, _t = We[0], ni = We[1], gr = We[11] << 4 | We[10] >>> 28, $r = We[10] << 4 | We[11] >>> 28, dt = We[20] << 3 | We[21] >>> 29, yt = We[21] << 3 | We[20] >>> 29, Ji = We[31] << 9 | We[30] >>> 23, Vi = We[30] << 9 | We[31] >>> 23, di = We[40] << 18 | We[41] >>> 14, Sr = We[41] << 18 | We[40] >>> 14, Qt = We[2] << 1 | We[3] >>> 31, rr = We[3] << 1 | We[2] >>> 31, Ct = We[13] << 12 | We[12] >>> 20, Wt = We[12] << 12 | We[13] >>> 20, li = We[22] << 10 | We[23] >>> 22, Ir = We[23] << 10 | We[22] >>> 22, St = We[33] << 13 | We[32] >>> 19, xt = We[32] << 13 | We[33] >>> 19, Yi = We[42] << 2 | We[43] >>> 30, Xi = We[43] << 2 | We[42] >>> 30, yi = We[5] << 30 | We[4] >>> 2, Zr = We[4] << 30 | We[5] >>> 2, ui = We[14] << 6 | We[15] >>> 26, Gr = We[15] << 6 | We[14] >>> 26, ii = We[25] << 11 | We[24] >>> 21, Pt = We[24] << 11 | We[25] >>> 21, Cr = We[34] << 15 | We[35] >>> 17, mi = We[35] << 15 | We[34] >>> 17, Vt = We[45] << 29 | We[44] >>> 3, ci = We[44] << 29 | We[45] >>> 3, oi = We[6] << 28 | We[7] >>> 4, ct = We[7] << 28 | We[6] >>> 4, Vr = We[17] << 23 | We[16] >>> 9, bi = We[16] << 23 | We[17] >>> 9, yr = We[26] << 25 | We[27] >>> 7, pi = We[27] << 25 | We[26] >>> 7, Rt = We[36] << 21 | We[37] >>> 11, ai = We[37] << 21 | We[36] >>> 11, Pr = We[47] << 24 | We[46] >>> 8, Or = We[46] << 24 | We[47] >>> 8, Br = We[8] << 27 | We[9] >>> 5, vi = We[9] << 27 | We[8] >>> 5, Ze = We[18] << 20 | We[19] >>> 12, at = We[19] << 20 | We[18] >>> 12, Ai = We[29] << 7 | We[28] >>> 25, Zi = We[28] << 7 | We[29] >>> 25, wr = We[38] << 8 | We[39] >>> 24, _r = We[39] << 8 | We[38] >>> 24, Nt = We[48] << 14 | We[49] >>> 18, qt = We[49] << 14 | We[48] >>> 18, We[0] = _t ^ ~Ct & ii, We[1] = ni ^ ~Wt & Pt, We[10] = oi ^ ~Ze & dt, We[11] = ct ^ ~at & yt, We[20] = Qt ^ ~ui & yr, We[21] = rr ^ ~Gr & pi, We[30] = Br ^ ~gr & li, We[31] = vi ^ ~$r & Ir, We[40] = yi ^ ~Vr & Ai, We[41] = Zr ^ ~bi & Zi, We[2] = Ct ^ ~ii & Rt, We[3] = Wt ^ ~Pt & ai, We[12] = Ze ^ ~dt & St, We[13] = at ^ ~yt & xt, We[22] = ui ^ ~yr & wr, We[23] = Gr ^ ~pi & _r, We[32] = gr ^ ~li & Cr, We[33] = $r ^ ~Ir & mi, We[42] = Vr ^ ~Ai & Ji, We[43] = bi ^ ~Zi & Vi, We[4] = ii ^ ~Rt & Nt, We[5] = Pt ^ ~ai & qt, We[14] = dt ^ ~St & Vt, We[15] = yt ^ ~xt & ci, We[24] = yr ^ ~wr & di, We[25] = pi ^ ~_r & Sr, We[34] = li ^ ~Cr & Pr, We[35] = Ir ^ ~mi & Or, We[44] = Ai ^ ~Ji & Yi, We[45] = Zi ^ ~Vi & Xi, We[6] = Rt ^ ~Nt & _t, We[7] = ai ^ ~qt & ni, We[16] = St ^ ~Vt & oi, We[17] = xt ^ ~ci & ct, We[26] = wr ^ ~di & Qt, We[27] = _r ^ ~Sr & rr, We[36] = Cr ^ ~Pr & Br, We[37] = mi ^ ~Or & vi, We[46] = Ji ^ ~Yi & yi, We[47] = Vi ^ ~Xi & Zr, We[8] = Nt ^ ~_t & Ct, We[9] = qt ^ ~ni & Wt, We[18] = Vt ^ ~oi & Ze, We[19] = ci ^ ~ct & at, We[28] = di ^ ~Qt & ui, We[29] = Sr ^ ~rr & Gr, We[38] = Pr ^ ~Br & gr, We[39] = Or ^ ~vi & $r, We[48] = Yi ^ ~yi & Vr, We[49] = Xi ^ ~Zr & bi, We[0] ^= Ge[Qe], We[1] ^= Ge[Qe + 1];
    };
    if (Ie) I.exports = B;
    else for (ve = 0; ve < Z.length; ++ve) _e[Z[ve]] = B[Z[ve]];
  })();
})(Hn);
const Rs = "logger/5.7.0";
let Ln = !1, zn = !1;
const Tr = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let jn = Tr.default, Mi$1 = null;
function Os() {
  try {
    const I = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((A) => {
      try {
        if ("test".normalize(A) !== "test") throw new Error("bad normalize");
      } catch {
        I.push(A);
      }
    }), I.length) throw new Error("missing " + I.join(", "));
    if ("é".normalize("NFD") !== "é") throw new Error("broken implementation");
  } catch (I) {
    return I.message;
  }
  return null;
}
const Qn = Os();
var Ei;
(function(I) {
  I.DEBUG = "DEBUG", I.INFO = "INFO", I.WARNING = "WARNING", I.ERROR = "ERROR", I.OFF = "OFF";
})(Ei || (Ei = {}));
var re;
(function(I) {
  I.UNKNOWN_ERROR = "UNKNOWN_ERROR", I.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", I.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", I.NETWORK_ERROR = "NETWORK_ERROR", I.SERVER_ERROR = "SERVER_ERROR", I.TIMEOUT = "TIMEOUT", I.BUFFER_OVERRUN = "BUFFER_OVERRUN", I.NUMERIC_FAULT = "NUMERIC_FAULT", I.MISSING_NEW = "MISSING_NEW", I.INVALID_ARGUMENT = "INVALID_ARGUMENT", I.MISSING_ARGUMENT = "MISSING_ARGUMENT", I.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", I.CALL_EXCEPTION = "CALL_EXCEPTION", I.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", I.NONCE_EXPIRED = "NONCE_EXPIRED", I.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", I.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", I.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", I.ACTION_REJECTED = "ACTION_REJECTED";
})(re || (re = {}));
const Jn = "0123456789abcdef";
let z$1 = class Nn {
  constructor(A) {
    Object.defineProperty(this, "version", { enumerable: !0, value: A, writable: !1 });
  }
  _log(A, G) {
    const J = A.toLowerCase();
    Tr[J] == null && this.throwArgumentError("invalid log level name", "logLevel", A), !(jn > Tr[J]) && console.log.apply(console, G);
  }
  debug(...A) {
    this._log(Nn.levels.DEBUG, A);
  }
  info(...A) {
    this._log(Nn.levels.INFO, A);
  }
  warn(...A) {
    this._log(Nn.levels.WARNING, A);
  }
  makeError(A, G, J) {
    if (zn) return this.makeError("censored error", G, {});
    G || (G = Nn.errors.UNKNOWN_ERROR), J || (J = {});
    const _e = [];
    Object.keys(J).forEach((qe) => {
      const Te = J[qe];
      try {
        if (Te instanceof Uint8Array) {
          let Ee = "";
          for (let Oe = 0; Oe < Te.length; Oe++) Ee += Jn[Te[Oe] >> 4], Ee += Jn[Te[Oe] & 15];
          _e.push(qe + "=Uint8Array(0x" + Ee + ")");
        } else _e.push(qe + "=" + JSON.stringify(Te));
      } catch {
        _e.push(qe + "=" + JSON.stringify(J[qe].toString()));
      }
    }), _e.push(`code=${G}`), _e.push(`version=${this.version}`);
    const H = A;
    let De = "";
    switch (G) {
      case re.NUMERIC_FAULT: {
        De = "NUMERIC_FAULT";
        const qe = A;
        switch (qe) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            De += "-" + qe;
            break;
          case "negative-power":
          case "negative-width":
            De += "-unsupported";
            break;
          case "unbound-bitwise-result":
            De += "-unbound-result";
            break;
        }
        break;
      }
      case re.CALL_EXCEPTION:
      case re.INSUFFICIENT_FUNDS:
      case re.MISSING_NEW:
      case re.NONCE_EXPIRED:
      case re.REPLACEMENT_UNDERPRICED:
      case re.TRANSACTION_REPLACED:
      case re.UNPREDICTABLE_GAS_LIMIT:
        De = G;
        break;
    }
    De && (A += " [ See: https://links.ethers.org/v5-errors-" + De + " ]"), _e.length && (A += " (" + _e.join(", ") + ")");
    const Ie = new Error(A);
    return Ie.reason = H, Ie.code = G, Object.keys(J).forEach(function(qe) {
      Ie[qe] = J[qe];
    }), Ie;
  }
  throwError(A, G, J) {
    throw this.makeError(A, G, J);
  }
  throwArgumentError(A, G, J) {
    return this.throwError(A, Nn.errors.INVALID_ARGUMENT, { argument: G, value: J });
  }
  assert(A, G, J, _e) {
    A || this.throwError(G, J, _e);
  }
  assertArgument(A, G, J, _e) {
    A || this.throwArgumentError(G, J, _e);
  }
  checkNormalize(A) {
    Qn && this.throwError("platform missing String.prototype.normalize", Nn.errors.UNSUPPORTED_OPERATION, { operation: "String.prototype.normalize", form: Qn });
  }
  checkSafeUint53(A, G) {
    typeof A == "number" && (G == null && (G = "value not safe"), (A < 0 || A >= 9007199254740991) && this.throwError(G, Nn.errors.NUMERIC_FAULT, { operation: "checkSafeInteger", fault: "out-of-safe-range", value: A }), A % 1 && this.throwError(G, Nn.errors.NUMERIC_FAULT, { operation: "checkSafeInteger", fault: "non-integer", value: A }));
  }
  checkArgumentCount(A, G, J) {
    J ? J = ": " + J : J = "", A < G && this.throwError("missing argument" + J, Nn.errors.MISSING_ARGUMENT, { count: A, expectedCount: G }), A > G && this.throwError("too many arguments" + J, Nn.errors.UNEXPECTED_ARGUMENT, { count: A, expectedCount: G });
  }
  checkNew(A, G) {
    (A === Object || A == null) && this.throwError("missing new", Nn.errors.MISSING_NEW, { name: G.name });
  }
  checkAbstract(A, G) {
    A === G ? this.throwError("cannot instantiate abstract class " + JSON.stringify(G.name) + " directly; use a sub-class", Nn.errors.UNSUPPORTED_OPERATION, { name: A.name, operation: "new" }) : (A === Object || A == null) && this.throwError("missing new", Nn.errors.MISSING_NEW, { name: G.name });
  }
  static globalLogger() {
    return Mi$1 || (Mi$1 = new Nn(Rs)), Mi$1;
  }
  static setCensorship(A, G) {
    if (!A && G && this.globalLogger().throwError("cannot permanently disable censorship", Nn.errors.UNSUPPORTED_OPERATION, { operation: "setCensorship" }), Ln) {
      if (!A) return;
      this.globalLogger().throwError("error censorship permanent", Nn.errors.UNSUPPORTED_OPERATION, { operation: "setCensorship" });
    }
    zn = !!A, Ln = !!G;
  }
  static setLogLevel(A) {
    const G = Tr[A.toLowerCase()];
    if (G == null) {
      Nn.globalLogger().warn("invalid log level - " + A);
      return;
    }
    jn = G;
  }
  static from(A) {
    return new Nn(A);
  }
};
z$1.errors = re, z$1.levels = Ei;
const Ps = "bytes/5.7.0", Tt$1 = new z$1(Ps);
function Gn(I) {
  return !!I.toHexString;
}
function ir(I) {
  return I.slice || (I.slice = function() {
    const A = Array.prototype.slice.call(arguments);
    return ir(new Uint8Array(Array.prototype.slice.apply(I, A)));
  }), I;
}
function Yn(I) {
  return typeof I == "number" && I == I && I % 1 === 0;
}
function nr(I) {
  if (I == null) return !1;
  if (I.constructor === Uint8Array) return !0;
  if (typeof I == "string" || !Yn(I.length) || I.length < 0) return !1;
  for (let A = 0; A < I.length; A++) {
    const G = I[A];
    if (!Yn(G) || G < 0 || G >= 256) return !1;
  }
  return !0;
}
function Ot(I, A) {
  if (A || (A = {}), typeof I == "number") {
    Tt$1.checkSafeUint53(I, "invalid arrayify value");
    const G = [];
    for (; I; ) G.unshift(I & 255), I = parseInt(String(I / 256));
    return G.length === 0 && G.push(0), ir(new Uint8Array(G));
  }
  if (A.allowMissingPrefix && typeof I == "string" && I.substring(0, 2) !== "0x" && (I = "0x" + I), Gn(I) && (I = I.toHexString()), Jt(I)) {
    let G = I.substring(2);
    G.length % 2 && (A.hexPad === "left" ? G = "0" + G : A.hexPad === "right" ? G += "0" : Tt$1.throwArgumentError("hex data is odd-length", "value", I));
    const J = [];
    for (let _e = 0; _e < G.length; _e += 2) J.push(parseInt(G.substring(_e, _e + 2), 16));
    return ir(new Uint8Array(J));
  }
  return nr(I) ? ir(new Uint8Array(I)) : Tt$1.throwArgumentError("invalid arrayify value", "value", I);
}
function Jt(I, A) {
  return !(typeof I != "string" || !I.match(/^0x[0-9A-Fa-f]*$/) || A);
}
const Si = "0123456789abcdef";
function Kt(I, A) {
  if (A || (A = {}), typeof I == "number") {
    Tt$1.checkSafeUint53(I, "invalid hexlify value");
    let G = "";
    for (; I; ) G = Si[I & 15] + G, I = Math.floor(I / 16);
    return G.length ? (G.length % 2 && (G = "0" + G), "0x" + G) : "0x00";
  }
  if (typeof I == "bigint") return I = I.toString(16), I.length % 2 ? "0x0" + I : "0x" + I;
  if (A.allowMissingPrefix && typeof I == "string" && I.substring(0, 2) !== "0x" && (I = "0x" + I), Gn(I)) return I.toHexString();
  if (Jt(I)) return I.length % 2 && (A.hexPad === "left" ? I = "0x0" + I.substring(2) : A.hexPad === "right" ? I += "0" : Tt$1.throwArgumentError("hex data is odd-length", "value", I)), I.toLowerCase();
  if (nr(I)) {
    let G = "0x";
    for (let J = 0; J < I.length; J++) {
      let _e = I[J];
      G += Si[(_e & 240) >> 4] + Si[_e & 15];
    }
    return G;
  }
  return Tt$1.throwArgumentError("invalid hexlify value", "value", I);
}
function oe(I, A) {
  for (typeof I != "string" ? I = Kt(I) : Jt(I) || Tt$1.throwArgumentError("invalid hex string", "value", I), I.length > 2 * A + 2 && Tt$1.throwArgumentError("value out of range", "value", arguments[1]); I.length < 2 * A + 2; ) I = "0x0" + I.substring(2);
  return I;
}
var Xn = { exports: {} }, ks = {}, qs = Object.freeze({ __proto__: null, default: ks }), Ks = Bs(qs);
(function(I) {
  (function(A, G) {
    function J(h, B) {
      if (!h) throw new Error(B || "Assertion failed");
    }
    function _e(h, B) {
      h.super_ = B;
      var Z = function() {
      };
      Z.prototype = B.prototype, h.prototype = new Z(), h.prototype.constructor = h;
    }
    function H(h, B, Z) {
      if (H.isBN(h)) return h;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, h !== null && ((B === "le" || B === "be") && (Z = B, B = 10), this._init(h || 0, B || 10, Z || "be"));
    }
    typeof A == "object" ? A.exports = H : G.BN = H, H.BN = H, H.wordSize = 26;
    var De;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? De = window.Buffer : De = Ks.Buffer;
    } catch {
    }
    H.isBN = function(h) {
      return h instanceof H ? !0 : h !== null && typeof h == "object" && h.constructor.wordSize === H.wordSize && Array.isArray(h.words);
    }, H.max = function(h, B) {
      return h.cmp(B) > 0 ? h : B;
    }, H.min = function(h, B) {
      return h.cmp(B) < 0 ? h : B;
    }, H.prototype._init = function(h, B, Z) {
      if (typeof h == "number") return this._initNumber(h, B, Z);
      if (typeof h == "object") return this._initArray(h, B, Z);
      B === "hex" && (B = 16), J(B === (B | 0) && B >= 2 && B <= 36), h = h.toString().replace(/\s+/g, "");
      var ve = 0;
      h[0] === "-" && (ve++, this.negative = 1), ve < h.length && (B === 16 ? this._parseHex(h, ve, Z) : (this._parseBase(h, B, ve), Z === "le" && this._initArray(this.toArray(), B, Z)));
    }, H.prototype._initNumber = function(h, B, Z) {
      h < 0 && (this.negative = 1, h = -h), h < 67108864 ? (this.words = [h & 67108863], this.length = 1) : h < 4503599627370496 ? (this.words = [h & 67108863, h / 67108864 & 67108863], this.length = 2) : (J(h < 9007199254740992), this.words = [h & 67108863, h / 67108864 & 67108863, 1], this.length = 3), Z === "le" && this._initArray(this.toArray(), B, Z);
    }, H.prototype._initArray = function(h, B, Z) {
      if (J(typeof h.length == "number"), h.length <= 0) return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(h.length / 3), this.words = new Array(this.length);
      for (var ve = 0; ve < this.length; ve++) this.words[ve] = 0;
      var ge, xe, X = 0;
      if (Z === "be") for (ve = h.length - 1, ge = 0; ve >= 0; ve -= 3) xe = h[ve] | h[ve - 1] << 8 | h[ve - 2] << 16, this.words[ge] |= xe << X & 67108863, this.words[ge + 1] = xe >>> 26 - X & 67108863, X += 24, X >= 26 && (X -= 26, ge++);
      else if (Z === "le") for (ve = 0, ge = 0; ve < h.length; ve += 3) xe = h[ve] | h[ve + 1] << 8 | h[ve + 2] << 16, this.words[ge] |= xe << X & 67108863, this.words[ge + 1] = xe >>> 26 - X & 67108863, X += 24, X >= 26 && (X -= 26, ge++);
      return this._strip();
    };
    function Ie(h, B) {
      var Z = h.charCodeAt(B);
      if (Z >= 48 && Z <= 57) return Z - 48;
      if (Z >= 65 && Z <= 70) return Z - 55;
      if (Z >= 97 && Z <= 102) return Z - 87;
      J(!1, "Invalid character in " + h);
    }
    function qe(h, B, Z) {
      var ve = Ie(h, Z);
      return Z - 1 >= B && (ve |= Ie(h, Z - 1) << 4), ve;
    }
    H.prototype._parseHex = function(h, B, Z) {
      this.length = Math.ceil((h.length - B) / 6), this.words = new Array(this.length);
      for (var ve = 0; ve < this.length; ve++) this.words[ve] = 0;
      var ge = 0, xe = 0, X;
      if (Z === "be") for (ve = h.length - 1; ve >= B; ve -= 2) X = qe(h, B, ve) << ge, this.words[xe] |= X & 67108863, ge >= 18 ? (ge -= 18, xe += 1, this.words[xe] |= X >>> 26) : ge += 8;
      else {
        var a = h.length - B;
        for (ve = a % 2 === 0 ? B + 1 : B; ve < h.length; ve += 2) X = qe(h, B, ve) << ge, this.words[xe] |= X & 67108863, ge >= 18 ? (ge -= 18, xe += 1, this.words[xe] |= X >>> 26) : ge += 8;
      }
      this._strip();
    };
    function Te(h, B, Z, ve) {
      for (var ge = 0, xe = 0, X = Math.min(h.length, Z), a = B; a < X; a++) {
        var Y = h.charCodeAt(a) - 48;
        ge *= ve, Y >= 49 ? xe = Y - 49 + 10 : Y >= 17 ? xe = Y - 17 + 10 : xe = Y, J(Y >= 0 && xe < ve, "Invalid character"), ge += xe;
      }
      return ge;
    }
    H.prototype._parseBase = function(h, B, Z) {
      this.words = [0], this.length = 1;
      for (var ve = 0, ge = 1; ge <= 67108863; ge *= B) ve++;
      ve--, ge = ge / B | 0;
      for (var xe = h.length - Z, X = xe % ve, a = Math.min(xe, xe - X) + Z, Y = 0, Ne = Z; Ne < a; Ne += ve) Y = Te(h, Ne, Ne + ve, B), this.imuln(ge), this.words[0] + Y < 67108864 ? this.words[0] += Y : this._iaddn(Y);
      if (X !== 0) {
        var Ke = 1;
        for (Y = Te(h, Ne, h.length, B), Ne = 0; Ne < X; Ne++) Ke *= B;
        this.imuln(Ke), this.words[0] + Y < 67108864 ? this.words[0] += Y : this._iaddn(Y);
      }
      this._strip();
    }, H.prototype.copy = function(h) {
      h.words = new Array(this.length);
      for (var B = 0; B < this.length; B++) h.words[B] = this.words[B];
      h.length = this.length, h.negative = this.negative, h.red = this.red;
    };
    function Ee(h, B) {
      h.words = B.words, h.length = B.length, h.negative = B.negative, h.red = B.red;
    }
    if (H.prototype._move = function(h) {
      Ee(h, this);
    }, H.prototype.clone = function() {
      var h = new H(null);
      return this.copy(h), h;
    }, H.prototype._expand = function(h) {
      for (; this.length < h; ) this.words[this.length++] = 0;
      return this;
    }, H.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
      return this._normSign();
    }, H.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function") try {
      H.prototype[Symbol.for("nodejs.util.inspect.custom")] = Oe;
    } catch {
      H.prototype.inspect = Oe;
    }
    else H.prototype.inspect = Oe;
    function Oe() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var Le = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"], ke = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5], Fe = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
    H.prototype.toString = function(h, B) {
      h = h || 10, B = B | 0 || 1;
      var Z;
      if (h === 16 || h === "hex") {
        Z = "";
        for (var ve = 0, ge = 0, xe = 0; xe < this.length; xe++) {
          var X = this.words[xe], a = ((X << ve | ge) & 16777215).toString(16);
          ge = X >>> 24 - ve & 16777215, ve += 2, ve >= 26 && (ve -= 26, xe--), ge !== 0 || xe !== this.length - 1 ? Z = Le[6 - a.length] + a + Z : Z = a + Z;
        }
        for (ge !== 0 && (Z = ge.toString(16) + Z); Z.length % B !== 0; ) Z = "0" + Z;
        return this.negative !== 0 && (Z = "-" + Z), Z;
      }
      if (h === (h | 0) && h >= 2 && h <= 36) {
        var Y = ke[h], Ne = Fe[h];
        Z = "";
        var Ke = this.clone();
        for (Ke.negative = 0; !Ke.isZero(); ) {
          var tt = Ke.modrn(Ne).toString(h);
          Ke = Ke.idivn(Ne), Ke.isZero() ? Z = tt + Z : Z = Le[Y - tt.length] + tt + Z;
        }
        for (this.isZero() && (Z = "0" + Z); Z.length % B !== 0; ) Z = "0" + Z;
        return this.negative !== 0 && (Z = "-" + Z), Z;
      }
      J(!1, "Base should be between 2 and 36");
    }, H.prototype.toNumber = function() {
      var h = this.words[0];
      return this.length === 2 ? h += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? h += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && J(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -h : h;
    }, H.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, De && (H.prototype.toBuffer = function(h, B) {
      return this.toArrayLike(De, h, B);
    }), H.prototype.toArray = function(h, B) {
      return this.toArrayLike(Array, h, B);
    };
    var Ge = function(h, B) {
      return h.allocUnsafe ? h.allocUnsafe(B) : new h(B);
    };
    H.prototype.toArrayLike = function(h, B, Z) {
      this._strip();
      var ve = this.byteLength(), ge = Z || Math.max(1, ve);
      J(ve <= ge, "byte array longer than desired length"), J(ge > 0, "Requested array length <= 0");
      var xe = Ge(h, ge), X = B === "le" ? "LE" : "BE";
      return this["_toArrayLike" + X](xe, ve), xe;
    }, H.prototype._toArrayLikeLE = function(h, B) {
      for (var Z = 0, ve = 0, ge = 0, xe = 0; ge < this.length; ge++) {
        var X = this.words[ge] << xe | ve;
        h[Z++] = X & 255, Z < h.length && (h[Z++] = X >> 8 & 255), Z < h.length && (h[Z++] = X >> 16 & 255), xe === 6 ? (Z < h.length && (h[Z++] = X >> 24 & 255), ve = 0, xe = 0) : (ve = X >>> 24, xe += 2);
      }
      if (Z < h.length) for (h[Z++] = ve; Z < h.length; ) h[Z++] = 0;
    }, H.prototype._toArrayLikeBE = function(h, B) {
      for (var Z = h.length - 1, ve = 0, ge = 0, xe = 0; ge < this.length; ge++) {
        var X = this.words[ge] << xe | ve;
        h[Z--] = X & 255, Z >= 0 && (h[Z--] = X >> 8 & 255), Z >= 0 && (h[Z--] = X >> 16 & 255), xe === 6 ? (Z >= 0 && (h[Z--] = X >> 24 & 255), ve = 0, xe = 0) : (ve = X >>> 24, xe += 2);
      }
      if (Z >= 0) for (h[Z--] = ve; Z >= 0; ) h[Z--] = 0;
    }, Math.clz32 ? H.prototype._countBits = function(h) {
      return 32 - Math.clz32(h);
    } : H.prototype._countBits = function(h) {
      var B = h, Z = 0;
      return B >= 4096 && (Z += 13, B >>>= 13), B >= 64 && (Z += 7, B >>>= 7), B >= 8 && (Z += 4, B >>>= 4), B >= 2 && (Z += 2, B >>>= 2), Z + B;
    }, H.prototype._zeroBits = function(h) {
      if (h === 0) return 26;
      var B = h, Z = 0;
      return B & 8191 || (Z += 13, B >>>= 13), B & 127 || (Z += 7, B >>>= 7), B & 15 || (Z += 4, B >>>= 4), B & 3 || (Z += 2, B >>>= 2), B & 1 || Z++, Z;
    }, H.prototype.bitLength = function() {
      var h = this.words[this.length - 1], B = this._countBits(h);
      return (this.length - 1) * 26 + B;
    };
    function et(h) {
      for (var B = new Array(h.bitLength()), Z = 0; Z < B.length; Z++) {
        var ve = Z / 26 | 0, ge = Z % 26;
        B[Z] = h.words[ve] >>> ge & 1;
      }
      return B;
    }
    H.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var h = 0, B = 0; B < this.length; B++) {
        var Z = this._zeroBits(this.words[B]);
        if (h += Z, Z !== 26) break;
      }
      return h;
    }, H.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, H.prototype.toTwos = function(h) {
      return this.negative !== 0 ? this.abs().inotn(h).iaddn(1) : this.clone();
    }, H.prototype.fromTwos = function(h) {
      return this.testn(h - 1) ? this.notn(h).iaddn(1).ineg() : this.clone();
    }, H.prototype.isNeg = function() {
      return this.negative !== 0;
    }, H.prototype.neg = function() {
      return this.clone().ineg();
    }, H.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, H.prototype.iuor = function(h) {
      for (; this.length < h.length; ) this.words[this.length++] = 0;
      for (var B = 0; B < h.length; B++) this.words[B] = this.words[B] | h.words[B];
      return this._strip();
    }, H.prototype.ior = function(h) {
      return J((this.negative | h.negative) === 0), this.iuor(h);
    }, H.prototype.or = function(h) {
      return this.length > h.length ? this.clone().ior(h) : h.clone().ior(this);
    }, H.prototype.uor = function(h) {
      return this.length > h.length ? this.clone().iuor(h) : h.clone().iuor(this);
    }, H.prototype.iuand = function(h) {
      var B;
      this.length > h.length ? B = h : B = this;
      for (var Z = 0; Z < B.length; Z++) this.words[Z] = this.words[Z] & h.words[Z];
      return this.length = B.length, this._strip();
    }, H.prototype.iand = function(h) {
      return J((this.negative | h.negative) === 0), this.iuand(h);
    }, H.prototype.and = function(h) {
      return this.length > h.length ? this.clone().iand(h) : h.clone().iand(this);
    }, H.prototype.uand = function(h) {
      return this.length > h.length ? this.clone().iuand(h) : h.clone().iuand(this);
    }, H.prototype.iuxor = function(h) {
      var B, Z;
      this.length > h.length ? (B = this, Z = h) : (B = h, Z = this);
      for (var ve = 0; ve < Z.length; ve++) this.words[ve] = B.words[ve] ^ Z.words[ve];
      if (this !== B) for (; ve < B.length; ve++) this.words[ve] = B.words[ve];
      return this.length = B.length, this._strip();
    }, H.prototype.ixor = function(h) {
      return J((this.negative | h.negative) === 0), this.iuxor(h);
    }, H.prototype.xor = function(h) {
      return this.length > h.length ? this.clone().ixor(h) : h.clone().ixor(this);
    }, H.prototype.uxor = function(h) {
      return this.length > h.length ? this.clone().iuxor(h) : h.clone().iuxor(this);
    }, H.prototype.inotn = function(h) {
      J(typeof h == "number" && h >= 0);
      var B = Math.ceil(h / 26) | 0, Z = h % 26;
      this._expand(B), Z > 0 && B--;
      for (var ve = 0; ve < B; ve++) this.words[ve] = ~this.words[ve] & 67108863;
      return Z > 0 && (this.words[ve] = ~this.words[ve] & 67108863 >> 26 - Z), this._strip();
    }, H.prototype.notn = function(h) {
      return this.clone().inotn(h);
    }, H.prototype.setn = function(h, B) {
      J(typeof h == "number" && h >= 0);
      var Z = h / 26 | 0, ve = h % 26;
      return this._expand(Z + 1), B ? this.words[Z] = this.words[Z] | 1 << ve : this.words[Z] = this.words[Z] & ~(1 << ve), this._strip();
    }, H.prototype.iadd = function(h) {
      var B;
      if (this.negative !== 0 && h.negative === 0) return this.negative = 0, B = this.isub(h), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && h.negative !== 0) return h.negative = 0, B = this.isub(h), h.negative = 1, B._normSign();
      var Z, ve;
      this.length > h.length ? (Z = this, ve = h) : (Z = h, ve = this);
      for (var ge = 0, xe = 0; xe < ve.length; xe++) B = (Z.words[xe] | 0) + (ve.words[xe] | 0) + ge, this.words[xe] = B & 67108863, ge = B >>> 26;
      for (; ge !== 0 && xe < Z.length; xe++) B = (Z.words[xe] | 0) + ge, this.words[xe] = B & 67108863, ge = B >>> 26;
      if (this.length = Z.length, ge !== 0) this.words[this.length] = ge, this.length++;
      else if (Z !== this) for (; xe < Z.length; xe++) this.words[xe] = Z.words[xe];
      return this;
    }, H.prototype.add = function(h) {
      var B;
      return h.negative !== 0 && this.negative === 0 ? (h.negative = 0, B = this.sub(h), h.negative ^= 1, B) : h.negative === 0 && this.negative !== 0 ? (this.negative = 0, B = h.sub(this), this.negative = 1, B) : this.length > h.length ? this.clone().iadd(h) : h.clone().iadd(this);
    }, H.prototype.isub = function(h) {
      if (h.negative !== 0) {
        h.negative = 0;
        var B = this.iadd(h);
        return h.negative = 1, B._normSign();
      } else if (this.negative !== 0) return this.negative = 0, this.iadd(h), this.negative = 1, this._normSign();
      var Z = this.cmp(h);
      if (Z === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var ve, ge;
      Z > 0 ? (ve = this, ge = h) : (ve = h, ge = this);
      for (var xe = 0, X = 0; X < ge.length; X++) B = (ve.words[X] | 0) - (ge.words[X] | 0) + xe, xe = B >> 26, this.words[X] = B & 67108863;
      for (; xe !== 0 && X < ve.length; X++) B = (ve.words[X] | 0) + xe, xe = B >> 26, this.words[X] = B & 67108863;
      if (xe === 0 && X < ve.length && ve !== this) for (; X < ve.length; X++) this.words[X] = ve.words[X];
      return this.length = Math.max(this.length, X), ve !== this && (this.negative = 1), this._strip();
    }, H.prototype.sub = function(h) {
      return this.clone().isub(h);
    };
    function Ve(h, B, Z) {
      Z.negative = B.negative ^ h.negative;
      var ve = h.length + B.length | 0;
      Z.length = ve, ve = ve - 1 | 0;
      var ge = h.words[0] | 0, xe = B.words[0] | 0, X = ge * xe, a = X & 67108863, Y = X / 67108864 | 0;
      Z.words[0] = a;
      for (var Ne = 1; Ne < ve; Ne++) {
        for (var Ke = Y >>> 26, tt = Y & 67108863, We = Math.min(Ne, B.length - 1), ot = Math.max(0, Ne - h.length + 1); ot <= We; ot++) {
          var He = Ne - ot | 0;
          ge = h.words[He] | 0, xe = B.words[ot] | 0, X = ge * xe + tt, Ke += X / 67108864 | 0, tt = X & 67108863;
        }
        Z.words[Ne] = tt | 0, Y = Ke | 0;
      }
      return Y !== 0 ? Z.words[Ne] = Y | 0 : Z.length--, Z._strip();
    }
    var Je = function(h, B, Z) {
      var ve = h.words, ge = B.words, xe = Z.words, X = 0, a, Y, Ne, Ke = ve[0] | 0, tt = Ke & 8191, We = Ke >>> 13, ot = ve[1] | 0, He = ot & 8191, Qe = ot >>> 13, nt = ve[2] | 0, je = nt & 8191, it = nt >>> 13, st = ve[3] | 0, gt = st & 8191, It = st >>> 13, At = ve[4] | 0, Et = At & 8191, ei = At >>> 13, Xt = ve[5] | 0, _t = Xt & 8191, ni = Xt >>> 13, Ct = ve[6] | 0, Wt = Ct & 8191, ii = Ct >>> 13, Pt = ve[7] | 0, Rt = Pt & 8191, ai = Pt >>> 13, Nt = ve[8] | 0, qt = Nt & 8191, oi = Nt >>> 13, ct = ve[9] | 0, Ze = ct & 8191, at = ct >>> 13, dt = ge[0] | 0, yt = dt & 8191, St = dt >>> 13, xt = ge[1] | 0, Vt = xt & 8191, ci = xt >>> 13, Qt = ge[2] | 0, rr = Qt & 8191, ui = Qt >>> 13, Gr = ge[3] | 0, yr = Gr & 8191, pi = Gr >>> 13, wr = ge[4] | 0, _r = wr & 8191, di = wr >>> 13, Sr = ge[5] | 0, Br = Sr & 8191, vi = Sr >>> 13, gr = ge[6] | 0, $r = gr & 8191, li = gr >>> 13, Ir = ge[7] | 0, Cr = Ir & 8191, mi = Ir >>> 13, Pr = ge[8] | 0, Or = Pr & 8191, yi = Pr >>> 13, Zr = ge[9] | 0, Vr = Zr & 8191, bi = Zr >>> 13;
      Z.negative = h.negative ^ B.negative, Z.length = 19, a = Math.imul(tt, yt), Y = Math.imul(tt, St), Y = Y + Math.imul(We, yt) | 0, Ne = Math.imul(We, St);
      var Ai = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, a = Math.imul(He, yt), Y = Math.imul(He, St), Y = Y + Math.imul(Qe, yt) | 0, Ne = Math.imul(Qe, St), a = a + Math.imul(tt, Vt) | 0, Y = Y + Math.imul(tt, ci) | 0, Y = Y + Math.imul(We, Vt) | 0, Ne = Ne + Math.imul(We, ci) | 0;
      var Zi = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (Zi >>> 26) | 0, Zi &= 67108863, a = Math.imul(je, yt), Y = Math.imul(je, St), Y = Y + Math.imul(it, yt) | 0, Ne = Math.imul(it, St), a = a + Math.imul(He, Vt) | 0, Y = Y + Math.imul(He, ci) | 0, Y = Y + Math.imul(Qe, Vt) | 0, Ne = Ne + Math.imul(Qe, ci) | 0, a = a + Math.imul(tt, rr) | 0, Y = Y + Math.imul(tt, ui) | 0, Y = Y + Math.imul(We, rr) | 0, Ne = Ne + Math.imul(We, ui) | 0;
      var Ji = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (Ji >>> 26) | 0, Ji &= 67108863, a = Math.imul(gt, yt), Y = Math.imul(gt, St), Y = Y + Math.imul(It, yt) | 0, Ne = Math.imul(It, St), a = a + Math.imul(je, Vt) | 0, Y = Y + Math.imul(je, ci) | 0, Y = Y + Math.imul(it, Vt) | 0, Ne = Ne + Math.imul(it, ci) | 0, a = a + Math.imul(He, rr) | 0, Y = Y + Math.imul(He, ui) | 0, Y = Y + Math.imul(Qe, rr) | 0, Ne = Ne + Math.imul(Qe, ui) | 0, a = a + Math.imul(tt, yr) | 0, Y = Y + Math.imul(tt, pi) | 0, Y = Y + Math.imul(We, yr) | 0, Ne = Ne + Math.imul(We, pi) | 0;
      var Vi = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (Vi >>> 26) | 0, Vi &= 67108863, a = Math.imul(Et, yt), Y = Math.imul(Et, St), Y = Y + Math.imul(ei, yt) | 0, Ne = Math.imul(ei, St), a = a + Math.imul(gt, Vt) | 0, Y = Y + Math.imul(gt, ci) | 0, Y = Y + Math.imul(It, Vt) | 0, Ne = Ne + Math.imul(It, ci) | 0, a = a + Math.imul(je, rr) | 0, Y = Y + Math.imul(je, ui) | 0, Y = Y + Math.imul(it, rr) | 0, Ne = Ne + Math.imul(it, ui) | 0, a = a + Math.imul(He, yr) | 0, Y = Y + Math.imul(He, pi) | 0, Y = Y + Math.imul(Qe, yr) | 0, Ne = Ne + Math.imul(Qe, pi) | 0, a = a + Math.imul(tt, _r) | 0, Y = Y + Math.imul(tt, di) | 0, Y = Y + Math.imul(We, _r) | 0, Ne = Ne + Math.imul(We, di) | 0;
      var Yi = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (Yi >>> 26) | 0, Yi &= 67108863, a = Math.imul(_t, yt), Y = Math.imul(_t, St), Y = Y + Math.imul(ni, yt) | 0, Ne = Math.imul(ni, St), a = a + Math.imul(Et, Vt) | 0, Y = Y + Math.imul(Et, ci) | 0, Y = Y + Math.imul(ei, Vt) | 0, Ne = Ne + Math.imul(ei, ci) | 0, a = a + Math.imul(gt, rr) | 0, Y = Y + Math.imul(gt, ui) | 0, Y = Y + Math.imul(It, rr) | 0, Ne = Ne + Math.imul(It, ui) | 0, a = a + Math.imul(je, yr) | 0, Y = Y + Math.imul(je, pi) | 0, Y = Y + Math.imul(it, yr) | 0, Ne = Ne + Math.imul(it, pi) | 0, a = a + Math.imul(He, _r) | 0, Y = Y + Math.imul(He, di) | 0, Y = Y + Math.imul(Qe, _r) | 0, Ne = Ne + Math.imul(Qe, di) | 0, a = a + Math.imul(tt, Br) | 0, Y = Y + Math.imul(tt, vi) | 0, Y = Y + Math.imul(We, Br) | 0, Ne = Ne + Math.imul(We, vi) | 0;
      var Xi = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (Xi >>> 26) | 0, Xi &= 67108863, a = Math.imul(Wt, yt), Y = Math.imul(Wt, St), Y = Y + Math.imul(ii, yt) | 0, Ne = Math.imul(ii, St), a = a + Math.imul(_t, Vt) | 0, Y = Y + Math.imul(_t, ci) | 0, Y = Y + Math.imul(ni, Vt) | 0, Ne = Ne + Math.imul(ni, ci) | 0, a = a + Math.imul(Et, rr) | 0, Y = Y + Math.imul(Et, ui) | 0, Y = Y + Math.imul(ei, rr) | 0, Ne = Ne + Math.imul(ei, ui) | 0, a = a + Math.imul(gt, yr) | 0, Y = Y + Math.imul(gt, pi) | 0, Y = Y + Math.imul(It, yr) | 0, Ne = Ne + Math.imul(It, pi) | 0, a = a + Math.imul(je, _r) | 0, Y = Y + Math.imul(je, di) | 0, Y = Y + Math.imul(it, _r) | 0, Ne = Ne + Math.imul(it, di) | 0, a = a + Math.imul(He, Br) | 0, Y = Y + Math.imul(He, vi) | 0, Y = Y + Math.imul(Qe, Br) | 0, Ne = Ne + Math.imul(Qe, vi) | 0, a = a + Math.imul(tt, $r) | 0, Y = Y + Math.imul(tt, li) | 0, Y = Y + Math.imul(We, $r) | 0, Ne = Ne + Math.imul(We, li) | 0;
      var en = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (en >>> 26) | 0, en &= 67108863, a = Math.imul(Rt, yt), Y = Math.imul(Rt, St), Y = Y + Math.imul(ai, yt) | 0, Ne = Math.imul(ai, St), a = a + Math.imul(Wt, Vt) | 0, Y = Y + Math.imul(Wt, ci) | 0, Y = Y + Math.imul(ii, Vt) | 0, Ne = Ne + Math.imul(ii, ci) | 0, a = a + Math.imul(_t, rr) | 0, Y = Y + Math.imul(_t, ui) | 0, Y = Y + Math.imul(ni, rr) | 0, Ne = Ne + Math.imul(ni, ui) | 0, a = a + Math.imul(Et, yr) | 0, Y = Y + Math.imul(Et, pi) | 0, Y = Y + Math.imul(ei, yr) | 0, Ne = Ne + Math.imul(ei, pi) | 0, a = a + Math.imul(gt, _r) | 0, Y = Y + Math.imul(gt, di) | 0, Y = Y + Math.imul(It, _r) | 0, Ne = Ne + Math.imul(It, di) | 0, a = a + Math.imul(je, Br) | 0, Y = Y + Math.imul(je, vi) | 0, Y = Y + Math.imul(it, Br) | 0, Ne = Ne + Math.imul(it, vi) | 0, a = a + Math.imul(He, $r) | 0, Y = Y + Math.imul(He, li) | 0, Y = Y + Math.imul(Qe, $r) | 0, Ne = Ne + Math.imul(Qe, li) | 0, a = a + Math.imul(tt, Cr) | 0, Y = Y + Math.imul(tt, mi) | 0, Y = Y + Math.imul(We, Cr) | 0, Ne = Ne + Math.imul(We, mi) | 0;
      var hn = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, a = Math.imul(qt, yt), Y = Math.imul(qt, St), Y = Y + Math.imul(oi, yt) | 0, Ne = Math.imul(oi, St), a = a + Math.imul(Rt, Vt) | 0, Y = Y + Math.imul(Rt, ci) | 0, Y = Y + Math.imul(ai, Vt) | 0, Ne = Ne + Math.imul(ai, ci) | 0, a = a + Math.imul(Wt, rr) | 0, Y = Y + Math.imul(Wt, ui) | 0, Y = Y + Math.imul(ii, rr) | 0, Ne = Ne + Math.imul(ii, ui) | 0, a = a + Math.imul(_t, yr) | 0, Y = Y + Math.imul(_t, pi) | 0, Y = Y + Math.imul(ni, yr) | 0, Ne = Ne + Math.imul(ni, pi) | 0, a = a + Math.imul(Et, _r) | 0, Y = Y + Math.imul(Et, di) | 0, Y = Y + Math.imul(ei, _r) | 0, Ne = Ne + Math.imul(ei, di) | 0, a = a + Math.imul(gt, Br) | 0, Y = Y + Math.imul(gt, vi) | 0, Y = Y + Math.imul(It, Br) | 0, Ne = Ne + Math.imul(It, vi) | 0, a = a + Math.imul(je, $r) | 0, Y = Y + Math.imul(je, li) | 0, Y = Y + Math.imul(it, $r) | 0, Ne = Ne + Math.imul(it, li) | 0, a = a + Math.imul(He, Cr) | 0, Y = Y + Math.imul(He, mi) | 0, Y = Y + Math.imul(Qe, Cr) | 0, Ne = Ne + Math.imul(Qe, mi) | 0, a = a + Math.imul(tt, Or) | 0, Y = Y + Math.imul(tt, yi) | 0, Y = Y + Math.imul(We, Or) | 0, Ne = Ne + Math.imul(We, yi) | 0;
      var tn = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (tn >>> 26) | 0, tn &= 67108863, a = Math.imul(Ze, yt), Y = Math.imul(Ze, St), Y = Y + Math.imul(at, yt) | 0, Ne = Math.imul(at, St), a = a + Math.imul(qt, Vt) | 0, Y = Y + Math.imul(qt, ci) | 0, Y = Y + Math.imul(oi, Vt) | 0, Ne = Ne + Math.imul(oi, ci) | 0, a = a + Math.imul(Rt, rr) | 0, Y = Y + Math.imul(Rt, ui) | 0, Y = Y + Math.imul(ai, rr) | 0, Ne = Ne + Math.imul(ai, ui) | 0, a = a + Math.imul(Wt, yr) | 0, Y = Y + Math.imul(Wt, pi) | 0, Y = Y + Math.imul(ii, yr) | 0, Ne = Ne + Math.imul(ii, pi) | 0, a = a + Math.imul(_t, _r) | 0, Y = Y + Math.imul(_t, di) | 0, Y = Y + Math.imul(ni, _r) | 0, Ne = Ne + Math.imul(ni, di) | 0, a = a + Math.imul(Et, Br) | 0, Y = Y + Math.imul(Et, vi) | 0, Y = Y + Math.imul(ei, Br) | 0, Ne = Ne + Math.imul(ei, vi) | 0, a = a + Math.imul(gt, $r) | 0, Y = Y + Math.imul(gt, li) | 0, Y = Y + Math.imul(It, $r) | 0, Ne = Ne + Math.imul(It, li) | 0, a = a + Math.imul(je, Cr) | 0, Y = Y + Math.imul(je, mi) | 0, Y = Y + Math.imul(it, Cr) | 0, Ne = Ne + Math.imul(it, mi) | 0, a = a + Math.imul(He, Or) | 0, Y = Y + Math.imul(He, yi) | 0, Y = Y + Math.imul(Qe, Or) | 0, Ne = Ne + Math.imul(Qe, yi) | 0, a = a + Math.imul(tt, Vr) | 0, Y = Y + Math.imul(tt, bi) | 0, Y = Y + Math.imul(We, Vr) | 0, Ne = Ne + Math.imul(We, bi) | 0;
      var un = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (un >>> 26) | 0, un &= 67108863, a = Math.imul(Ze, Vt), Y = Math.imul(Ze, ci), Y = Y + Math.imul(at, Vt) | 0, Ne = Math.imul(at, ci), a = a + Math.imul(qt, rr) | 0, Y = Y + Math.imul(qt, ui) | 0, Y = Y + Math.imul(oi, rr) | 0, Ne = Ne + Math.imul(oi, ui) | 0, a = a + Math.imul(Rt, yr) | 0, Y = Y + Math.imul(Rt, pi) | 0, Y = Y + Math.imul(ai, yr) | 0, Ne = Ne + Math.imul(ai, pi) | 0, a = a + Math.imul(Wt, _r) | 0, Y = Y + Math.imul(Wt, di) | 0, Y = Y + Math.imul(ii, _r) | 0, Ne = Ne + Math.imul(ii, di) | 0, a = a + Math.imul(_t, Br) | 0, Y = Y + Math.imul(_t, vi) | 0, Y = Y + Math.imul(ni, Br) | 0, Ne = Ne + Math.imul(ni, vi) | 0, a = a + Math.imul(Et, $r) | 0, Y = Y + Math.imul(Et, li) | 0, Y = Y + Math.imul(ei, $r) | 0, Ne = Ne + Math.imul(ei, li) | 0, a = a + Math.imul(gt, Cr) | 0, Y = Y + Math.imul(gt, mi) | 0, Y = Y + Math.imul(It, Cr) | 0, Ne = Ne + Math.imul(It, mi) | 0, a = a + Math.imul(je, Or) | 0, Y = Y + Math.imul(je, yi) | 0, Y = Y + Math.imul(it, Or) | 0, Ne = Ne + Math.imul(it, yi) | 0, a = a + Math.imul(He, Vr) | 0, Y = Y + Math.imul(He, bi) | 0, Y = Y + Math.imul(Qe, Vr) | 0, Ne = Ne + Math.imul(Qe, bi) | 0;
      var cn = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (cn >>> 26) | 0, cn &= 67108863, a = Math.imul(Ze, rr), Y = Math.imul(Ze, ui), Y = Y + Math.imul(at, rr) | 0, Ne = Math.imul(at, ui), a = a + Math.imul(qt, yr) | 0, Y = Y + Math.imul(qt, pi) | 0, Y = Y + Math.imul(oi, yr) | 0, Ne = Ne + Math.imul(oi, pi) | 0, a = a + Math.imul(Rt, _r) | 0, Y = Y + Math.imul(Rt, di) | 0, Y = Y + Math.imul(ai, _r) | 0, Ne = Ne + Math.imul(ai, di) | 0, a = a + Math.imul(Wt, Br) | 0, Y = Y + Math.imul(Wt, vi) | 0, Y = Y + Math.imul(ii, Br) | 0, Ne = Ne + Math.imul(ii, vi) | 0, a = a + Math.imul(_t, $r) | 0, Y = Y + Math.imul(_t, li) | 0, Y = Y + Math.imul(ni, $r) | 0, Ne = Ne + Math.imul(ni, li) | 0, a = a + Math.imul(Et, Cr) | 0, Y = Y + Math.imul(Et, mi) | 0, Y = Y + Math.imul(ei, Cr) | 0, Ne = Ne + Math.imul(ei, mi) | 0, a = a + Math.imul(gt, Or) | 0, Y = Y + Math.imul(gt, yi) | 0, Y = Y + Math.imul(It, Or) | 0, Ne = Ne + Math.imul(It, yi) | 0, a = a + Math.imul(je, Vr) | 0, Y = Y + Math.imul(je, bi) | 0, Y = Y + Math.imul(it, Vr) | 0, Ne = Ne + Math.imul(it, bi) | 0;
      var ln = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (ln >>> 26) | 0, ln &= 67108863, a = Math.imul(Ze, yr), Y = Math.imul(Ze, pi), Y = Y + Math.imul(at, yr) | 0, Ne = Math.imul(at, pi), a = a + Math.imul(qt, _r) | 0, Y = Y + Math.imul(qt, di) | 0, Y = Y + Math.imul(oi, _r) | 0, Ne = Ne + Math.imul(oi, di) | 0, a = a + Math.imul(Rt, Br) | 0, Y = Y + Math.imul(Rt, vi) | 0, Y = Y + Math.imul(ai, Br) | 0, Ne = Ne + Math.imul(ai, vi) | 0, a = a + Math.imul(Wt, $r) | 0, Y = Y + Math.imul(Wt, li) | 0, Y = Y + Math.imul(ii, $r) | 0, Ne = Ne + Math.imul(ii, li) | 0, a = a + Math.imul(_t, Cr) | 0, Y = Y + Math.imul(_t, mi) | 0, Y = Y + Math.imul(ni, Cr) | 0, Ne = Ne + Math.imul(ni, mi) | 0, a = a + Math.imul(Et, Or) | 0, Y = Y + Math.imul(Et, yi) | 0, Y = Y + Math.imul(ei, Or) | 0, Ne = Ne + Math.imul(ei, yi) | 0, a = a + Math.imul(gt, Vr) | 0, Y = Y + Math.imul(gt, bi) | 0, Y = Y + Math.imul(It, Vr) | 0, Ne = Ne + Math.imul(It, bi) | 0;
      var an = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (an >>> 26) | 0, an &= 67108863, a = Math.imul(Ze, _r), Y = Math.imul(Ze, di), Y = Y + Math.imul(at, _r) | 0, Ne = Math.imul(at, di), a = a + Math.imul(qt, Br) | 0, Y = Y + Math.imul(qt, vi) | 0, Y = Y + Math.imul(oi, Br) | 0, Ne = Ne + Math.imul(oi, vi) | 0, a = a + Math.imul(Rt, $r) | 0, Y = Y + Math.imul(Rt, li) | 0, Y = Y + Math.imul(ai, $r) | 0, Ne = Ne + Math.imul(ai, li) | 0, a = a + Math.imul(Wt, Cr) | 0, Y = Y + Math.imul(Wt, mi) | 0, Y = Y + Math.imul(ii, Cr) | 0, Ne = Ne + Math.imul(ii, mi) | 0, a = a + Math.imul(_t, Or) | 0, Y = Y + Math.imul(_t, yi) | 0, Y = Y + Math.imul(ni, Or) | 0, Ne = Ne + Math.imul(ni, yi) | 0, a = a + Math.imul(Et, Vr) | 0, Y = Y + Math.imul(Et, bi) | 0, Y = Y + Math.imul(ei, Vr) | 0, Ne = Ne + Math.imul(ei, bi) | 0;
      var fn = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, a = Math.imul(Ze, Br), Y = Math.imul(Ze, vi), Y = Y + Math.imul(at, Br) | 0, Ne = Math.imul(at, vi), a = a + Math.imul(qt, $r) | 0, Y = Y + Math.imul(qt, li) | 0, Y = Y + Math.imul(oi, $r) | 0, Ne = Ne + Math.imul(oi, li) | 0, a = a + Math.imul(Rt, Cr) | 0, Y = Y + Math.imul(Rt, mi) | 0, Y = Y + Math.imul(ai, Cr) | 0, Ne = Ne + Math.imul(ai, mi) | 0, a = a + Math.imul(Wt, Or) | 0, Y = Y + Math.imul(Wt, yi) | 0, Y = Y + Math.imul(ii, Or) | 0, Ne = Ne + Math.imul(ii, yi) | 0, a = a + Math.imul(_t, Vr) | 0, Y = Y + Math.imul(_t, bi) | 0, Y = Y + Math.imul(ni, Vr) | 0, Ne = Ne + Math.imul(ni, bi) | 0;
      var sn = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (sn >>> 26) | 0, sn &= 67108863, a = Math.imul(Ze, $r), Y = Math.imul(Ze, li), Y = Y + Math.imul(at, $r) | 0, Ne = Math.imul(at, li), a = a + Math.imul(qt, Cr) | 0, Y = Y + Math.imul(qt, mi) | 0, Y = Y + Math.imul(oi, Cr) | 0, Ne = Ne + Math.imul(oi, mi) | 0, a = a + Math.imul(Rt, Or) | 0, Y = Y + Math.imul(Rt, yi) | 0, Y = Y + Math.imul(ai, Or) | 0, Ne = Ne + Math.imul(ai, yi) | 0, a = a + Math.imul(Wt, Vr) | 0, Y = Y + Math.imul(Wt, bi) | 0, Y = Y + Math.imul(ii, Vr) | 0, Ne = Ne + Math.imul(ii, bi) | 0;
      var dn = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, a = Math.imul(Ze, Cr), Y = Math.imul(Ze, mi), Y = Y + Math.imul(at, Cr) | 0, Ne = Math.imul(at, mi), a = a + Math.imul(qt, Or) | 0, Y = Y + Math.imul(qt, yi) | 0, Y = Y + Math.imul(oi, Or) | 0, Ne = Ne + Math.imul(oi, yi) | 0, a = a + Math.imul(Rt, Vr) | 0, Y = Y + Math.imul(Rt, bi) | 0, Y = Y + Math.imul(ai, Vr) | 0, Ne = Ne + Math.imul(ai, bi) | 0;
      var pn = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, a = Math.imul(Ze, Or), Y = Math.imul(Ze, yi), Y = Y + Math.imul(at, Or) | 0, Ne = Math.imul(at, yi), a = a + Math.imul(qt, Vr) | 0, Y = Y + Math.imul(qt, bi) | 0, Y = Y + Math.imul(oi, Vr) | 0, Ne = Ne + Math.imul(oi, bi) | 0;
      var vn = (X + a | 0) + ((Y & 8191) << 13) | 0;
      X = (Ne + (Y >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, a = Math.imul(Ze, Vr), Y = Math.imul(Ze, bi), Y = Y + Math.imul(at, Vr) | 0, Ne = Math.imul(at, bi);
      var us = (X + a | 0) + ((Y & 8191) << 13) | 0;
      return X = (Ne + (Y >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, xe[0] = Ai, xe[1] = Zi, xe[2] = Ji, xe[3] = Vi, xe[4] = Yi, xe[5] = Xi, xe[6] = en, xe[7] = hn, xe[8] = tn, xe[9] = un, xe[10] = cn, xe[11] = ln, xe[12] = an, xe[13] = fn, xe[14] = sn, xe[15] = dn, xe[16] = pn, xe[17] = vn, xe[18] = us, X !== 0 && (xe[19] = X, Z.length++), Z;
    };
    Math.imul || (Je = Ve);
    function ut(h, B, Z) {
      Z.negative = B.negative ^ h.negative, Z.length = h.length + B.length;
      for (var ve = 0, ge = 0, xe = 0; xe < Z.length - 1; xe++) {
        var X = ge;
        ge = 0;
        for (var a = ve & 67108863, Y = Math.min(xe, B.length - 1), Ne = Math.max(0, xe - h.length + 1); Ne <= Y; Ne++) {
          var Ke = xe - Ne, tt = h.words[Ke] | 0, We = B.words[Ne] | 0, ot = tt * We, He = ot & 67108863;
          X = X + (ot / 67108864 | 0) | 0, He = He + a | 0, a = He & 67108863, X = X + (He >>> 26) | 0, ge += X >>> 26, X &= 67108863;
        }
        Z.words[xe] = a, ve = X, X = ge;
      }
      return ve !== 0 ? Z.words[xe] = ve : Z.length--, Z._strip();
    }
    function rt(h, B, Z) {
      return ut(h, B, Z);
    }
    H.prototype.mulTo = function(h, B) {
      var Z, ve = this.length + h.length;
      return this.length === 10 && h.length === 10 ? Z = Je(this, h, B) : ve < 63 ? Z = Ve(this, h, B) : ve < 1024 ? Z = ut(this, h, B) : Z = rt(this, h, B), Z;
    }, H.prototype.mul = function(h) {
      var B = new H(null);
      return B.words = new Array(this.length + h.length), this.mulTo(h, B);
    }, H.prototype.mulf = function(h) {
      var B = new H(null);
      return B.words = new Array(this.length + h.length), rt(this, h, B);
    }, H.prototype.imul = function(h) {
      return this.clone().mulTo(h, this);
    }, H.prototype.imuln = function(h) {
      var B = h < 0;
      B && (h = -h), J(typeof h == "number"), J(h < 67108864);
      for (var Z = 0, ve = 0; ve < this.length; ve++) {
        var ge = (this.words[ve] | 0) * h, xe = (ge & 67108863) + (Z & 67108863);
        Z >>= 26, Z += ge / 67108864 | 0, Z += xe >>> 26, this.words[ve] = xe & 67108863;
      }
      return Z !== 0 && (this.words[ve] = Z, this.length++), B ? this.ineg() : this;
    }, H.prototype.muln = function(h) {
      return this.clone().imuln(h);
    }, H.prototype.sqr = function() {
      return this.mul(this);
    }, H.prototype.isqr = function() {
      return this.imul(this.clone());
    }, H.prototype.pow = function(h) {
      var B = et(h);
      if (B.length === 0) return new H(1);
      for (var Z = this, ve = 0; ve < B.length && B[ve] === 0; ve++, Z = Z.sqr()) ;
      if (++ve < B.length) for (var ge = Z.sqr(); ve < B.length; ve++, ge = ge.sqr()) B[ve] !== 0 && (Z = Z.mul(ge));
      return Z;
    }, H.prototype.iushln = function(h) {
      J(typeof h == "number" && h >= 0);
      var B = h % 26, Z = (h - B) / 26, ve = 67108863 >>> 26 - B << 26 - B, ge;
      if (B !== 0) {
        var xe = 0;
        for (ge = 0; ge < this.length; ge++) {
          var X = this.words[ge] & ve, a = (this.words[ge] | 0) - X << B;
          this.words[ge] = a | xe, xe = X >>> 26 - B;
        }
        xe && (this.words[ge] = xe, this.length++);
      }
      if (Z !== 0) {
        for (ge = this.length - 1; ge >= 0; ge--) this.words[ge + Z] = this.words[ge];
        for (ge = 0; ge < Z; ge++) this.words[ge] = 0;
        this.length += Z;
      }
      return this._strip();
    }, H.prototype.ishln = function(h) {
      return J(this.negative === 0), this.iushln(h);
    }, H.prototype.iushrn = function(h, B, Z) {
      J(typeof h == "number" && h >= 0);
      var ve;
      B ? ve = (B - B % 26) / 26 : ve = 0;
      var ge = h % 26, xe = Math.min((h - ge) / 26, this.length), X = 67108863 ^ 67108863 >>> ge << ge, a = Z;
      if (ve -= xe, ve = Math.max(0, ve), a) {
        for (var Y = 0; Y < xe; Y++) a.words[Y] = this.words[Y];
        a.length = xe;
      }
      if (xe !== 0) if (this.length > xe) for (this.length -= xe, Y = 0; Y < this.length; Y++) this.words[Y] = this.words[Y + xe];
      else this.words[0] = 0, this.length = 1;
      var Ne = 0;
      for (Y = this.length - 1; Y >= 0 && (Ne !== 0 || Y >= ve); Y--) {
        var Ke = this.words[Y] | 0;
        this.words[Y] = Ne << 26 - ge | Ke >>> ge, Ne = Ke & X;
      }
      return a && Ne !== 0 && (a.words[a.length++] = Ne), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, H.prototype.ishrn = function(h, B, Z) {
      return J(this.negative === 0), this.iushrn(h, B, Z);
    }, H.prototype.shln = function(h) {
      return this.clone().ishln(h);
    }, H.prototype.ushln = function(h) {
      return this.clone().iushln(h);
    }, H.prototype.shrn = function(h) {
      return this.clone().ishrn(h);
    }, H.prototype.ushrn = function(h) {
      return this.clone().iushrn(h);
    }, H.prototype.testn = function(h) {
      J(typeof h == "number" && h >= 0);
      var B = h % 26, Z = (h - B) / 26, ve = 1 << B;
      if (this.length <= Z) return !1;
      var ge = this.words[Z];
      return !!(ge & ve);
    }, H.prototype.imaskn = function(h) {
      J(typeof h == "number" && h >= 0);
      var B = h % 26, Z = (h - B) / 26;
      if (J(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Z) return this;
      if (B !== 0 && Z++, this.length = Math.min(Z, this.length), B !== 0) {
        var ve = 67108863 ^ 67108863 >>> B << B;
        this.words[this.length - 1] &= ve;
      }
      return this._strip();
    }, H.prototype.maskn = function(h) {
      return this.clone().imaskn(h);
    }, H.prototype.iaddn = function(h) {
      return J(typeof h == "number"), J(h < 67108864), h < 0 ? this.isubn(-h) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= h ? (this.words[0] = h - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(h), this.negative = 1, this) : this._iaddn(h);
    }, H.prototype._iaddn = function(h) {
      this.words[0] += h;
      for (var B = 0; B < this.length && this.words[B] >= 67108864; B++) this.words[B] -= 67108864, B === this.length - 1 ? this.words[B + 1] = 1 : this.words[B + 1]++;
      return this.length = Math.max(this.length, B + 1), this;
    }, H.prototype.isubn = function(h) {
      if (J(typeof h == "number"), J(h < 67108864), h < 0) return this.iaddn(-h);
      if (this.negative !== 0) return this.negative = 0, this.iaddn(h), this.negative = 1, this;
      if (this.words[0] -= h, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
      else for (var B = 0; B < this.length && this.words[B] < 0; B++) this.words[B] += 67108864, this.words[B + 1] -= 1;
      return this._strip();
    }, H.prototype.addn = function(h) {
      return this.clone().iaddn(h);
    }, H.prototype.subn = function(h) {
      return this.clone().isubn(h);
    }, H.prototype.iabs = function() {
      return this.negative = 0, this;
    }, H.prototype.abs = function() {
      return this.clone().iabs();
    }, H.prototype._ishlnsubmul = function(h, B, Z) {
      var ve = h.length + Z, ge;
      this._expand(ve);
      var xe, X = 0;
      for (ge = 0; ge < h.length; ge++) {
        xe = (this.words[ge + Z] | 0) + X;
        var a = (h.words[ge] | 0) * B;
        xe -= a & 67108863, X = (xe >> 26) - (a / 67108864 | 0), this.words[ge + Z] = xe & 67108863;
      }
      for (; ge < this.length - Z; ge++) xe = (this.words[ge + Z] | 0) + X, X = xe >> 26, this.words[ge + Z] = xe & 67108863;
      if (X === 0) return this._strip();
      for (J(X === -1), X = 0, ge = 0; ge < this.length; ge++) xe = -(this.words[ge] | 0) + X, X = xe >> 26, this.words[ge] = xe & 67108863;
      return this.negative = 1, this._strip();
    }, H.prototype._wordDiv = function(h, B) {
      var Z = this.length - h.length, ve = this.clone(), ge = h, xe = ge.words[ge.length - 1] | 0, X = this._countBits(xe);
      Z = 26 - X, Z !== 0 && (ge = ge.ushln(Z), ve.iushln(Z), xe = ge.words[ge.length - 1] | 0);
      var a = ve.length - ge.length, Y;
      if (B !== "mod") {
        Y = new H(null), Y.length = a + 1, Y.words = new Array(Y.length);
        for (var Ne = 0; Ne < Y.length; Ne++) Y.words[Ne] = 0;
      }
      var Ke = ve.clone()._ishlnsubmul(ge, 1, a);
      Ke.negative === 0 && (ve = Ke, Y && (Y.words[a] = 1));
      for (var tt = a - 1; tt >= 0; tt--) {
        var We = (ve.words[ge.length + tt] | 0) * 67108864 + (ve.words[ge.length + tt - 1] | 0);
        for (We = Math.min(We / xe | 0, 67108863), ve._ishlnsubmul(ge, We, tt); ve.negative !== 0; ) We--, ve.negative = 0, ve._ishlnsubmul(ge, 1, tt), ve.isZero() || (ve.negative ^= 1);
        Y && (Y.words[tt] = We);
      }
      return Y && Y._strip(), ve._strip(), B !== "div" && Z !== 0 && ve.iushrn(Z), { div: Y || null, mod: ve };
    }, H.prototype.divmod = function(h, B, Z) {
      if (J(!h.isZero()), this.isZero()) return { div: new H(0), mod: new H(0) };
      var ve, ge, xe;
      return this.negative !== 0 && h.negative === 0 ? (xe = this.neg().divmod(h, B), B !== "mod" && (ve = xe.div.neg()), B !== "div" && (ge = xe.mod.neg(), Z && ge.negative !== 0 && ge.iadd(h)), { div: ve, mod: ge }) : this.negative === 0 && h.negative !== 0 ? (xe = this.divmod(h.neg(), B), B !== "mod" && (ve = xe.div.neg()), { div: ve, mod: xe.mod }) : this.negative & h.negative ? (xe = this.neg().divmod(h.neg(), B), B !== "div" && (ge = xe.mod.neg(), Z && ge.negative !== 0 && ge.isub(h)), { div: xe.div, mod: ge }) : h.length > this.length || this.cmp(h) < 0 ? { div: new H(0), mod: this } : h.length === 1 ? B === "div" ? { div: this.divn(h.words[0]), mod: null } : B === "mod" ? { div: null, mod: new H(this.modrn(h.words[0])) } : { div: this.divn(h.words[0]), mod: new H(this.modrn(h.words[0])) } : this._wordDiv(h, B);
    }, H.prototype.div = function(h) {
      return this.divmod(h, "div", !1).div;
    }, H.prototype.mod = function(h) {
      return this.divmod(h, "mod", !1).mod;
    }, H.prototype.umod = function(h) {
      return this.divmod(h, "mod", !0).mod;
    }, H.prototype.divRound = function(h) {
      var B = this.divmod(h);
      if (B.mod.isZero()) return B.div;
      var Z = B.div.negative !== 0 ? B.mod.isub(h) : B.mod, ve = h.ushrn(1), ge = h.andln(1), xe = Z.cmp(ve);
      return xe < 0 || ge === 1 && xe === 0 ? B.div : B.div.negative !== 0 ? B.div.isubn(1) : B.div.iaddn(1);
    }, H.prototype.modrn = function(h) {
      var B = h < 0;
      B && (h = -h), J(h <= 67108863);
      for (var Z = (1 << 26) % h, ve = 0, ge = this.length - 1; ge >= 0; ge--) ve = (Z * ve + (this.words[ge] | 0)) % h;
      return B ? -ve : ve;
    }, H.prototype.modn = function(h) {
      return this.modrn(h);
    }, H.prototype.idivn = function(h) {
      var B = h < 0;
      B && (h = -h), J(h <= 67108863);
      for (var Z = 0, ve = this.length - 1; ve >= 0; ve--) {
        var ge = (this.words[ve] | 0) + Z * 67108864;
        this.words[ve] = ge / h | 0, Z = ge % h;
      }
      return this._strip(), B ? this.ineg() : this;
    }, H.prototype.divn = function(h) {
      return this.clone().idivn(h);
    }, H.prototype.egcd = function(h) {
      J(h.negative === 0), J(!h.isZero());
      var B = this, Z = h.clone();
      B.negative !== 0 ? B = B.umod(h) : B = B.clone();
      for (var ve = new H(1), ge = new H(0), xe = new H(0), X = new H(1), a = 0; B.isEven() && Z.isEven(); ) B.iushrn(1), Z.iushrn(1), ++a;
      for (var Y = Z.clone(), Ne = B.clone(); !B.isZero(); ) {
        for (var Ke = 0, tt = 1; !(B.words[0] & tt) && Ke < 26; ++Ke, tt <<= 1) ;
        if (Ke > 0) for (B.iushrn(Ke); Ke-- > 0; ) (ve.isOdd() || ge.isOdd()) && (ve.iadd(Y), ge.isub(Ne)), ve.iushrn(1), ge.iushrn(1);
        for (var We = 0, ot = 1; !(Z.words[0] & ot) && We < 26; ++We, ot <<= 1) ;
        if (We > 0) for (Z.iushrn(We); We-- > 0; ) (xe.isOdd() || X.isOdd()) && (xe.iadd(Y), X.isub(Ne)), xe.iushrn(1), X.iushrn(1);
        B.cmp(Z) >= 0 ? (B.isub(Z), ve.isub(xe), ge.isub(X)) : (Z.isub(B), xe.isub(ve), X.isub(ge));
      }
      return { a: xe, b: X, gcd: Z.iushln(a) };
    }, H.prototype._invmp = function(h) {
      J(h.negative === 0), J(!h.isZero());
      var B = this, Z = h.clone();
      B.negative !== 0 ? B = B.umod(h) : B = B.clone();
      for (var ve = new H(1), ge = new H(0), xe = Z.clone(); B.cmpn(1) > 0 && Z.cmpn(1) > 0; ) {
        for (var X = 0, a = 1; !(B.words[0] & a) && X < 26; ++X, a <<= 1) ;
        if (X > 0) for (B.iushrn(X); X-- > 0; ) ve.isOdd() && ve.iadd(xe), ve.iushrn(1);
        for (var Y = 0, Ne = 1; !(Z.words[0] & Ne) && Y < 26; ++Y, Ne <<= 1) ;
        if (Y > 0) for (Z.iushrn(Y); Y-- > 0; ) ge.isOdd() && ge.iadd(xe), ge.iushrn(1);
        B.cmp(Z) >= 0 ? (B.isub(Z), ve.isub(ge)) : (Z.isub(B), ge.isub(ve));
      }
      var Ke;
      return B.cmpn(1) === 0 ? Ke = ve : Ke = ge, Ke.cmpn(0) < 0 && Ke.iadd(h), Ke;
    }, H.prototype.gcd = function(h) {
      if (this.isZero()) return h.abs();
      if (h.isZero()) return this.abs();
      var B = this.clone(), Z = h.clone();
      B.negative = 0, Z.negative = 0;
      for (var ve = 0; B.isEven() && Z.isEven(); ve++) B.iushrn(1), Z.iushrn(1);
      do {
        for (; B.isEven(); ) B.iushrn(1);
        for (; Z.isEven(); ) Z.iushrn(1);
        var ge = B.cmp(Z);
        if (ge < 0) {
          var xe = B;
          B = Z, Z = xe;
        } else if (ge === 0 || Z.cmpn(1) === 0) break;
        B.isub(Z);
      } while (!0);
      return Z.iushln(ve);
    }, H.prototype.invm = function(h) {
      return this.egcd(h).a.umod(h);
    }, H.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, H.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, H.prototype.andln = function(h) {
      return this.words[0] & h;
    }, H.prototype.bincn = function(h) {
      J(typeof h == "number");
      var B = h % 26, Z = (h - B) / 26, ve = 1 << B;
      if (this.length <= Z) return this._expand(Z + 1), this.words[Z] |= ve, this;
      for (var ge = ve, xe = Z; ge !== 0 && xe < this.length; xe++) {
        var X = this.words[xe] | 0;
        X += ge, ge = X >>> 26, X &= 67108863, this.words[xe] = X;
      }
      return ge !== 0 && (this.words[xe] = ge, this.length++), this;
    }, H.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, H.prototype.cmpn = function(h) {
      var B = h < 0;
      if (this.negative !== 0 && !B) return -1;
      if (this.negative === 0 && B) return 1;
      this._strip();
      var Z;
      if (this.length > 1) Z = 1;
      else {
        B && (h = -h), J(h <= 67108863, "Number is too big");
        var ve = this.words[0] | 0;
        Z = ve === h ? 0 : ve < h ? -1 : 1;
      }
      return this.negative !== 0 ? -Z | 0 : Z;
    }, H.prototype.cmp = function(h) {
      if (this.negative !== 0 && h.negative === 0) return -1;
      if (this.negative === 0 && h.negative !== 0) return 1;
      var B = this.ucmp(h);
      return this.negative !== 0 ? -B | 0 : B;
    }, H.prototype.ucmp = function(h) {
      if (this.length > h.length) return 1;
      if (this.length < h.length) return -1;
      for (var B = 0, Z = this.length - 1; Z >= 0; Z--) {
        var ve = this.words[Z] | 0, ge = h.words[Z] | 0;
        if (ve !== ge) {
          ve < ge ? B = -1 : ve > ge && (B = 1);
          break;
        }
      }
      return B;
    }, H.prototype.gtn = function(h) {
      return this.cmpn(h) === 1;
    }, H.prototype.gt = function(h) {
      return this.cmp(h) === 1;
    }, H.prototype.gten = function(h) {
      return this.cmpn(h) >= 0;
    }, H.prototype.gte = function(h) {
      return this.cmp(h) >= 0;
    }, H.prototype.ltn = function(h) {
      return this.cmpn(h) === -1;
    }, H.prototype.lt = function(h) {
      return this.cmp(h) === -1;
    }, H.prototype.lten = function(h) {
      return this.cmpn(h) <= 0;
    }, H.prototype.lte = function(h) {
      return this.cmp(h) <= 0;
    }, H.prototype.eqn = function(h) {
      return this.cmpn(h) === 0;
    }, H.prototype.eq = function(h) {
      return this.cmp(h) === 0;
    }, H.red = function(h) {
      return new Se(h);
    }, H.prototype.toRed = function(h) {
      return J(!this.red, "Already a number in reduction context"), J(this.negative === 0, "red works only with positives"), h.convertTo(this)._forceRed(h);
    }, H.prototype.fromRed = function() {
      return J(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, H.prototype._forceRed = function(h) {
      return this.red = h, this;
    }, H.prototype.forceRed = function(h) {
      return J(!this.red, "Already a number in reduction context"), this._forceRed(h);
    }, H.prototype.redAdd = function(h) {
      return J(this.red, "redAdd works only with red numbers"), this.red.add(this, h);
    }, H.prototype.redIAdd = function(h) {
      return J(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, h);
    }, H.prototype.redSub = function(h) {
      return J(this.red, "redSub works only with red numbers"), this.red.sub(this, h);
    }, H.prototype.redISub = function(h) {
      return J(this.red, "redISub works only with red numbers"), this.red.isub(this, h);
    }, H.prototype.redShl = function(h) {
      return J(this.red, "redShl works only with red numbers"), this.red.shl(this, h);
    }, H.prototype.redMul = function(h) {
      return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, h), this.red.mul(this, h);
    }, H.prototype.redIMul = function(h) {
      return J(this.red, "redMul works only with red numbers"), this.red._verify2(this, h), this.red.imul(this, h);
    }, H.prototype.redSqr = function() {
      return J(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, H.prototype.redISqr = function() {
      return J(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, H.prototype.redSqrt = function() {
      return J(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, H.prototype.redInvm = function() {
      return J(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, H.prototype.redNeg = function() {
      return J(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, H.prototype.redPow = function(h) {
      return J(this.red && !h.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, h);
    };
    var lt = { k256: null, p224: null, p192: null, p25519: null };
    function vt(h, B) {
      this.name = h, this.p = new H(B, 16), this.n = this.p.bitLength(), this.k = new H(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    vt.prototype._tmp = function() {
      var h = new H(null);
      return h.words = new Array(Math.ceil(this.n / 13)), h;
    }, vt.prototype.ireduce = function(h) {
      var B = h, Z;
      do
        this.split(B, this.tmp), B = this.imulK(B), B = B.iadd(this.tmp), Z = B.bitLength();
      while (Z > this.n);
      var ve = Z < this.n ? -1 : B.ucmp(this.p);
      return ve === 0 ? (B.words[0] = 0, B.length = 1) : ve > 0 ? B.isub(this.p) : B.strip !== void 0 ? B.strip() : B._strip(), B;
    }, vt.prototype.split = function(h, B) {
      h.iushrn(this.n, 0, B);
    }, vt.prototype.imulK = function(h) {
      return h.imul(this.k);
    };
    function Ye() {
      vt.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    _e(Ye, vt), Ye.prototype.split = function(h, B) {
      for (var Z = 4194303, ve = Math.min(h.length, 9), ge = 0; ge < ve; ge++) B.words[ge] = h.words[ge];
      if (B.length = ve, h.length <= 9) {
        h.words[0] = 0, h.length = 1;
        return;
      }
      var xe = h.words[9];
      for (B.words[B.length++] = xe & Z, ge = 10; ge < h.length; ge++) {
        var X = h.words[ge] | 0;
        h.words[ge - 10] = (X & Z) << 4 | xe >>> 22, xe = X;
      }
      xe >>>= 22, h.words[ge - 10] = xe, xe === 0 && h.length > 10 ? h.length -= 10 : h.length -= 9;
    }, Ye.prototype.imulK = function(h) {
      h.words[h.length] = 0, h.words[h.length + 1] = 0, h.length += 2;
      for (var B = 0, Z = 0; Z < h.length; Z++) {
        var ve = h.words[Z] | 0;
        B += ve * 977, h.words[Z] = B & 67108863, B = ve * 64 + (B / 67108864 | 0);
      }
      return h.words[h.length - 1] === 0 && (h.length--, h.words[h.length - 1] === 0 && h.length--), h;
    };
    function pt() {
      vt.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    _e(pt, vt);
    function bt() {
      vt.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    _e(bt, vt);
    function Yt() {
      vt.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    _e(Yt, vt), Yt.prototype.imulK = function(h) {
      for (var B = 0, Z = 0; Z < h.length; Z++) {
        var ve = (h.words[Z] | 0) * 19 + B, ge = ve & 67108863;
        ve >>>= 26, h.words[Z] = ge, B = ve;
      }
      return B !== 0 && (h.words[h.length++] = B), h;
    }, H._prime = function(h) {
      if (lt[h]) return lt[h];
      var B;
      if (h === "k256") B = new Ye();
      else if (h === "p224") B = new pt();
      else if (h === "p192") B = new bt();
      else if (h === "p25519") B = new Yt();
      else throw new Error("Unknown prime " + h);
      return lt[h] = B, B;
    };
    function Se(h) {
      if (typeof h == "string") {
        var B = H._prime(h);
        this.m = B.p, this.prime = B;
      } else J(h.gtn(1), "modulus must be greater than 1"), this.m = h, this.prime = null;
    }
    Se.prototype._verify1 = function(h) {
      J(h.negative === 0, "red works only with positives"), J(h.red, "red works only with red numbers");
    }, Se.prototype._verify2 = function(h, B) {
      J((h.negative | B.negative) === 0, "red works only with positives"), J(h.red && h.red === B.red, "red works only with red numbers");
    }, Se.prototype.imod = function(h) {
      return this.prime ? this.prime.ireduce(h)._forceRed(this) : (Ee(h, h.umod(this.m)._forceRed(this)), h);
    }, Se.prototype.neg = function(h) {
      return h.isZero() ? h.clone() : this.m.sub(h)._forceRed(this);
    }, Se.prototype.add = function(h, B) {
      this._verify2(h, B);
      var Z = h.add(B);
      return Z.cmp(this.m) >= 0 && Z.isub(this.m), Z._forceRed(this);
    }, Se.prototype.iadd = function(h, B) {
      this._verify2(h, B);
      var Z = h.iadd(B);
      return Z.cmp(this.m) >= 0 && Z.isub(this.m), Z;
    }, Se.prototype.sub = function(h, B) {
      this._verify2(h, B);
      var Z = h.sub(B);
      return Z.cmpn(0) < 0 && Z.iadd(this.m), Z._forceRed(this);
    }, Se.prototype.isub = function(h, B) {
      this._verify2(h, B);
      var Z = h.isub(B);
      return Z.cmpn(0) < 0 && Z.iadd(this.m), Z;
    }, Se.prototype.shl = function(h, B) {
      return this._verify1(h), this.imod(h.ushln(B));
    }, Se.prototype.imul = function(h, B) {
      return this._verify2(h, B), this.imod(h.imul(B));
    }, Se.prototype.mul = function(h, B) {
      return this._verify2(h, B), this.imod(h.mul(B));
    }, Se.prototype.isqr = function(h) {
      return this.imul(h, h.clone());
    }, Se.prototype.sqr = function(h) {
      return this.mul(h, h);
    }, Se.prototype.sqrt = function(h) {
      if (h.isZero()) return h.clone();
      var B = this.m.andln(3);
      if (J(B % 2 === 1), B === 3) {
        var Z = this.m.add(new H(1)).iushrn(2);
        return this.pow(h, Z);
      }
      for (var ve = this.m.subn(1), ge = 0; !ve.isZero() && ve.andln(1) === 0; ) ge++, ve.iushrn(1);
      J(!ve.isZero());
      var xe = new H(1).toRed(this), X = xe.redNeg(), a = this.m.subn(1).iushrn(1), Y = this.m.bitLength();
      for (Y = new H(2 * Y * Y).toRed(this); this.pow(Y, a).cmp(X) !== 0; ) Y.redIAdd(X);
      for (var Ne = this.pow(Y, ve), Ke = this.pow(h, ve.addn(1).iushrn(1)), tt = this.pow(h, ve), We = ge; tt.cmp(xe) !== 0; ) {
        for (var ot = tt, He = 0; ot.cmp(xe) !== 0; He++) ot = ot.redSqr();
        J(He < We);
        var Qe = this.pow(Ne, new H(1).iushln(We - He - 1));
        Ke = Ke.redMul(Qe), Ne = Qe.redSqr(), tt = tt.redMul(Ne), We = He;
      }
      return Ke;
    }, Se.prototype.invm = function(h) {
      var B = h._invmp(this.m);
      return B.negative !== 0 ? (B.negative = 0, this.imod(B).redNeg()) : this.imod(B);
    }, Se.prototype.pow = function(h, B) {
      if (B.isZero()) return new H(1).toRed(this);
      if (B.cmpn(1) === 0) return h.clone();
      var Z = 4, ve = new Array(1 << Z);
      ve[0] = new H(1).toRed(this), ve[1] = h;
      for (var ge = 2; ge < ve.length; ge++) ve[ge] = this.mul(ve[ge - 1], h);
      var xe = ve[0], X = 0, a = 0, Y = B.bitLength() % 26;
      for (Y === 0 && (Y = 26), ge = B.length - 1; ge >= 0; ge--) {
        for (var Ne = B.words[ge], Ke = Y - 1; Ke >= 0; Ke--) {
          var tt = Ne >> Ke & 1;
          if (xe !== ve[0] && (xe = this.sqr(xe)), tt === 0 && X === 0) {
            a = 0;
            continue;
          }
          X <<= 1, X |= tt, a++, !(a !== Z && (ge !== 0 || Ke !== 0)) && (xe = this.mul(xe, ve[X]), a = 0, X = 0);
        }
        Y = 26;
      }
      return xe;
    }, Se.prototype.convertTo = function(h) {
      var B = h.umod(this.m);
      return B === h ? B.clone() : B;
    }, Se.prototype.convertFrom = function(h) {
      var B = h.clone();
      return B.red = null, B;
    }, H.mont = function(h) {
      return new t(h);
    };
    function t(h) {
      Se.call(this, h), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new H(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    _e(t, Se), t.prototype.convertTo = function(h) {
      return this.imod(h.ushln(this.shift));
    }, t.prototype.convertFrom = function(h) {
      var B = this.imod(h.mul(this.rinv));
      return B.red = null, B;
    }, t.prototype.imul = function(h, B) {
      if (h.isZero() || B.isZero()) return h.words[0] = 0, h.length = 1, h;
      var Z = h.imul(B), ve = Z.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ge = Z.isub(ve).iushrn(this.shift), xe = ge;
      return ge.cmp(this.m) >= 0 ? xe = ge.isub(this.m) : ge.cmpn(0) < 0 && (xe = ge.iadd(this.m)), xe._forceRed(this);
    }, t.prototype.mul = function(h, B) {
      if (h.isZero() || B.isZero()) return new H(0)._forceRed(this);
      var Z = h.mul(B), ve = Z.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ge = Z.isub(ve).iushrn(this.shift), xe = ge;
      return ge.cmp(this.m) >= 0 ? xe = ge.isub(this.m) : ge.cmpn(0) < 0 && (xe = ge.iadd(this.m)), xe._forceRed(this);
    }, t.prototype.invm = function(h) {
      var B = this.imod(h._invmp(this.m).mul(this.r2));
      return B._forceRed(this);
    };
  })(I, Kn);
})(Xn);
var K = Xn.exports;
const $n = "bignumber/5.7.0";
var Dr = K.BN;
const Ae$1 = new z$1($n), Ni = {}, Zn = 9007199254740991;
function Hs(I) {
  return I != null && (V.isBigNumber(I) || typeof I == "number" && I % 1 === 0 || typeof I == "string" && !!I.match(/^-?[0-9]+$/) || Jt(I) || typeof I == "bigint" || nr(I));
}
let tf = !1;
class V {
  constructor(A, G) {
    A !== Ni && Ae$1.throwError("cannot call constructor directly; use BigNumber.from", z$1.errors.UNSUPPORTED_OPERATION, { operation: "new (BigNumber)" }), this._hex = G, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(A) {
    return zt(j$2(this).fromTwos(A));
  }
  toTwos(A) {
    return zt(j$2(this).toTwos(A));
  }
  abs() {
    return this._hex[0] === "-" ? V.from(this._hex.substring(1)) : this;
  }
  add(A) {
    return zt(j$2(this).add(j$2(A)));
  }
  sub(A) {
    return zt(j$2(this).sub(j$2(A)));
  }
  div(A) {
    return V.from(A).isZero() && $t("division-by-zero", "div"), zt(j$2(this).div(j$2(A)));
  }
  mul(A) {
    return zt(j$2(this).mul(j$2(A)));
  }
  mod(A) {
    const G = j$2(A);
    return G.isNeg() && $t("division-by-zero", "mod"), zt(j$2(this).umod(G));
  }
  pow(A) {
    const G = j$2(A);
    return G.isNeg() && $t("negative-power", "pow"), zt(j$2(this).pow(G));
  }
  and(A) {
    const G = j$2(A);
    return (this.isNegative() || G.isNeg()) && $t("unbound-bitwise-result", "and"), zt(j$2(this).and(G));
  }
  or(A) {
    const G = j$2(A);
    return (this.isNegative() || G.isNeg()) && $t("unbound-bitwise-result", "or"), zt(j$2(this).or(G));
  }
  xor(A) {
    const G = j$2(A);
    return (this.isNegative() || G.isNeg()) && $t("unbound-bitwise-result", "xor"), zt(j$2(this).xor(G));
  }
  mask(A) {
    return (this.isNegative() || A < 0) && $t("negative-width", "mask"), zt(j$2(this).maskn(A));
  }
  shl(A) {
    return (this.isNegative() || A < 0) && $t("negative-width", "shl"), zt(j$2(this).shln(A));
  }
  shr(A) {
    return (this.isNegative() || A < 0) && $t("negative-width", "shr"), zt(j$2(this).shrn(A));
  }
  eq(A) {
    return j$2(this).eq(j$2(A));
  }
  lt(A) {
    return j$2(this).lt(j$2(A));
  }
  lte(A) {
    return j$2(this).lte(j$2(A));
  }
  gt(A) {
    return j$2(this).gt(j$2(A));
  }
  gte(A) {
    return j$2(this).gte(j$2(A));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return j$2(this).isZero();
  }
  toNumber() {
    try {
      return j$2(this).toNumber();
    } catch {
      $t("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return Ae$1.throwError("this platform does not support BigInt", z$1.errors.UNSUPPORTED_OPERATION, { value: this.toString() });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? tf || (tf = !0, Ae$1.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? Ae$1.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", z$1.errors.UNEXPECTED_ARGUMENT, {}) : Ae$1.throwError("BigNumber.toString does not accept parameters", z$1.errors.UNEXPECTED_ARGUMENT, {})), j$2(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(A) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(A) {
    if (A instanceof V) return A;
    if (typeof A == "string") return A.match(/^-?0x[0-9a-f]+$/i) ? new V(Ni, mr(A)) : A.match(/^-?[0-9]+$/) ? new V(Ni, mr(new Dr(A))) : Ae$1.throwArgumentError("invalid BigNumber string", "value", A);
    if (typeof A == "number") return A % 1 && $t("underflow", "BigNumber.from", A), (A >= Zn || A <= -Zn) && $t("overflow", "BigNumber.from", A), V.from(String(A));
    const G = A;
    if (typeof G == "bigint") return V.from(G.toString());
    if (nr(G)) return V.from(Kt(G));
    if (G) if (G.toHexString) {
      const J = G.toHexString();
      if (typeof J == "string") return V.from(J);
    } else {
      let J = G._hex;
      if (J == null && G.type === "BigNumber" && (J = G.hex), typeof J == "string" && (Jt(J) || J[0] === "-" && Jt(J.substring(1)))) return V.from(J);
    }
    return Ae$1.throwArgumentError("invalid BigNumber value", "value", A);
  }
  static isBigNumber(A) {
    return !!(A && A._isBigNumber);
  }
}
function mr(I) {
  if (typeof I != "string") return mr(I.toString(16));
  if (I[0] === "-") return I = I.substring(1), I[0] === "-" && Ae$1.throwArgumentError("invalid hex", "value", I), I = mr(I), I === "0x00" ? I : "-" + I;
  if (I.substring(0, 2) !== "0x" && (I = "0x" + I), I === "0x") return "0x00";
  for (I.length % 2 && (I = "0x0" + I.substring(2)); I.length > 4 && I.substring(0, 4) === "0x00"; ) I = "0x" + I.substring(4);
  return I;
}
function zt(I) {
  return V.from(mr(I));
}
function j$2(I) {
  const A = V.from(I).toHexString();
  return A[0] === "-" ? new Dr("-" + A.substring(3), 16) : new Dr(A.substring(2), 16);
}
function $t(I, A, G) {
  const J = { fault: I, operation: A };
  return G != null && (J.value = G), Ae$1.throwError(I, z$1.errors.NUMERIC_FAULT, J);
}
const Ht = new z$1($n), Ar = {}, ef = V.from(0), rf = V.from(-1);
function nf(I, A, G, J) {
  const _e = { fault: A, operation: G };
  return J !== void 0 && (_e.value = J), Ht.throwError(I, z$1.errors.NUMERIC_FAULT, _e);
}
let br = "0";
for (; br.length < 256; ) br += br;
function _i(I) {
  if (typeof I != "number") try {
    I = V.from(I).toNumber();
  } catch {
  }
  return typeof I == "number" && I >= 0 && I <= 256 && !(I % 1) ? "1" + br.substring(0, I) : Ht.throwArgumentError("invalid decimal size", "decimals", I);
}
function Bi$1(I, A) {
  A == null && (A = 0);
  const G = _i(A);
  I = V.from(I);
  const J = I.lt(ef);
  J && (I = I.mul(rf));
  let _e = I.mod(G).toString();
  for (; _e.length < G.length - 1; ) _e = "0" + _e;
  _e = _e.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const H = I.div(G).toString();
  return G.length === 1 ? I = H : I = H + "." + _e, J && (I = "-" + I), I;
}
function be(I, A) {
  A == null && (A = 0);
  const G = _i(A);
  (typeof I != "string" || !I.match(/^-?[0-9.]+$/)) && Ht.throwArgumentError("invalid decimal value", "value", I);
  const J = I.substring(0, 1) === "-";
  J && (I = I.substring(1)), I === "." && Ht.throwArgumentError("missing value", "value", I);
  const _e = I.split(".");
  _e.length > 2 && Ht.throwArgumentError("too many decimal points", "value", I);
  let H = _e[0], De = _e[1];
  for (H || (H = "0"), De || (De = "0"); De[De.length - 1] === "0"; ) De = De.substring(0, De.length - 1);
  for (De.length > G.length - 1 && nf("fractional component exceeds decimals", "underflow", "parseFixed"), De === "" && (De = "0"); De.length < G.length - 1; ) De += "0";
  const Ie = V.from(H), qe = V.from(De);
  let Te = Ie.mul(G).add(qe);
  return J && (Te = Te.mul(rf)), Te;
}
class vr {
  constructor(A, G, J, _e) {
    A !== Ar && Ht.throwError("cannot use FixedFormat constructor; use FixedFormat.from", z$1.errors.UNSUPPORTED_OPERATION, { operation: "new FixedFormat" }), this.signed = G, this.width = J, this.decimals = _e, this.name = (G ? "" : "u") + "fixed" + String(J) + "x" + String(_e), this._multiplier = _i(_e), Object.freeze(this);
  }
  static from(A) {
    if (A instanceof vr) return A;
    typeof A == "number" && (A = `fixed128x${A}`);
    let G = !0, J = 128, _e = 18;
    if (typeof A == "string") {
      if (A !== "fixed") if (A === "ufixed") G = !1;
      else {
        const H = A.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
        H || Ht.throwArgumentError("invalid fixed format", "format", A), G = H[1] !== "u", J = parseInt(H[2]), _e = parseInt(H[3]);
      }
    } else if (A) {
      const H = (De, Ie, qe) => A[De] == null ? qe : (typeof A[De] !== Ie && Ht.throwArgumentError("invalid fixed format (" + De + " not " + Ie + ")", "format." + De, A[De]), A[De]);
      G = H("signed", "boolean", G), J = H("width", "number", J), _e = H("decimals", "number", _e);
    }
    return J % 8 && Ht.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", J), _e > 80 && Ht.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", _e), new vr(Ar, G, J, _e);
  }
}
class Ut {
  constructor(A, G, J, _e) {
    A !== Ar && Ht.throwError("cannot use FixedNumber constructor; use FixedNumber.from", z$1.errors.UNSUPPORTED_OPERATION, { operation: "new FixedFormat" }), this.format = _e, this._hex = G, this._value = J, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(A) {
    this.format.name !== A.format.name && Ht.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", A);
  }
  addUnsafe(A) {
    this._checkFormat(A);
    const G = be(this._value, this.format.decimals), J = be(A._value, A.format.decimals);
    return Ut.fromValue(G.add(J), this.format.decimals, this.format);
  }
  subUnsafe(A) {
    this._checkFormat(A);
    const G = be(this._value, this.format.decimals), J = be(A._value, A.format.decimals);
    return Ut.fromValue(G.sub(J), this.format.decimals, this.format);
  }
  mulUnsafe(A) {
    this._checkFormat(A);
    const G = be(this._value, this.format.decimals), J = be(A._value, A.format.decimals);
    return Ut.fromValue(G.mul(J).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(A) {
    this._checkFormat(A);
    const G = be(this._value, this.format.decimals), J = be(A._value, A.format.decimals);
    return Ut.fromValue(G.mul(this.format._multiplier).div(J), this.format.decimals, this.format);
  }
  floor() {
    const A = this.toString().split(".");
    A.length === 1 && A.push("0");
    let G = Ut.from(A[0], this.format);
    const J = !A[1].match(/^(0*)$/);
    return this.isNegative() && J && (G = G.subUnsafe(ff.toFormat(G.format))), G;
  }
  ceiling() {
    const A = this.toString().split(".");
    A.length === 1 && A.push("0");
    let G = Ut.from(A[0], this.format);
    const J = !A[1].match(/^(0*)$/);
    return !this.isNegative() && J && (G = G.addUnsafe(ff.toFormat(G.format))), G;
  }
  round(A) {
    A == null && (A = 0);
    const G = this.toString().split(".");
    if (G.length === 1 && G.push("0"), (A < 0 || A > 80 || A % 1) && Ht.throwArgumentError("invalid decimal count", "decimals", A), G[1].length <= A) return this;
    const J = Ut.from("1" + br.substring(0, A), this.format), _e = zs.toFormat(this.format);
    return this.mulUnsafe(J).addUnsafe(_e).floor().divUnsafe(J);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(A) {
    if (A == null) return this._hex;
    A % 8 && Ht.throwArgumentError("invalid byte width", "width", A);
    const G = V.from(this._hex).fromTwos(this.format.width).toTwos(A).toHexString();
    return oe(G, A / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(A) {
    return Ut.fromString(this._value, A);
  }
  static fromValue(A, G, J) {
    return J == null && G != null && !Hs(G) && (J = G, G = null), G == null && (G = 0), J == null && (J = "fixed"), Ut.fromString(Bi$1(A, G), vr.from(J));
  }
  static fromString(A, G) {
    G == null && (G = "fixed");
    const J = vr.from(G), _e = be(A, J.decimals);
    !J.signed && _e.lt(ef) && nf("unsigned value cannot be negative", "overflow", "value", A);
    let H = null;
    J.signed ? H = _e.toTwos(J.width).toHexString() : (H = _e.toHexString(), H = oe(H, J.width / 8));
    const De = Bi$1(_e, J.decimals);
    return new Ut(Ar, H, De, J);
  }
  static fromBytes(A, G) {
    G == null && (G = "fixed");
    const J = vr.from(G);
    if (Ot(A).length > J.width / 8) throw new Error("overflow");
    let _e = V.from(A);
    J.signed && (_e = _e.fromTwos(J.width));
    const H = _e.toTwos((J.signed ? 0 : 1) + J.width).toHexString(), De = Bi$1(_e, J.decimals);
    return new Ut(Ar, H, De, J);
  }
  static from(A, G) {
    if (typeof A == "string") return Ut.fromString(A, G);
    if (nr(A)) return Ut.fromBytes(A, G);
    try {
      return Ut.fromValue(A, 0, G);
    } catch (J) {
      if (J.code !== z$1.errors.INVALID_ARGUMENT) throw J;
    }
    return Ht.throwArgumentError("invalid FixedNumber value", "value", A);
  }
  static isFixedNumber(A) {
    return !!(A && A._isFixedNumber);
  }
}
const ff = Ut.from(1), zs = Ut.from("0.5");
var Fr;
(function(I) {
  I.current = "", I.NFC = "NFC", I.NFD = "NFD", I.NFKC = "NFKC", I.NFKD = "NFKD";
})(Fr || (Fr = {}));
var fr;
(function(I) {
  I.UNEXPECTED_CONTINUE = "unexpected continuation byte", I.BAD_PREFIX = "bad codepoint prefix", I.OVERRUN = "string overrun", I.MISSING_CONTINUE = "missing continuation byte", I.OUT_OF_RANGE = "out of UTF-8 range", I.UTF16_SURROGATE = "UTF-16 surrogate", I.OVERLONG = "overlong representation";
})(fr || (fr = {}));
function Gs(I) {
  if (I.length % 4 !== 0) throw new Error("bad data");
  let A = [];
  for (let G = 0; G < I.length; G += 4) A.push(parseInt(I.substring(G, G + 4), 16));
  return A;
}
function Ri(I, A) {
  A || (A = function(_e) {
    return [parseInt(_e, 16)];
  });
  let G = 0, J = {};
  return I.split(",").forEach((_e) => {
    let H = _e.split(":");
    G += parseInt(H[0], 16), J[G] = A(H[1]);
  }), J;
}
function af(I) {
  let A = 0;
  return I.split(",").map((G) => {
    let J = G.split("-");
    J.length === 1 ? J[1] = "0" : J[1] === "" && (J[1] = "1");
    let _e = A + parseInt(J[0], 16);
    return A = parseInt(J[1], 16), { l: _e, h: A };
  });
}
af("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((I) => parseInt(I, 16)), Ri("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), Ri("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), Ri("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", Gs), af("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function Ys(I) {
  I = atob(I);
  const A = [];
  for (let G = 0; G < I.length; G++) A.push(I.charCodeAt(G));
  return Ot(A);
}
function hf(I, A) {
  A == null && (A = 1);
  const G = [], J = G.forEach, _e = function(H, De) {
    J.call(H, function(Ie) {
      De > 0 && Array.isArray(Ie) ? _e(Ie, De - 1) : G.push(Ie);
    });
  };
  return _e(I, A), G;
}
function Vs(I) {
  const A = {};
  for (let G = 0; G < I.length; G++) {
    const J = I[G];
    A[J[0]] = J[1];
  }
  return A;
}
function Ws(I) {
  let A = 0;
  function G() {
    return I[A++] << 8 | I[A++];
  }
  let J = G(), _e = 1, H = [0, 1];
  for (let lt = 1; lt < J; lt++) H.push(_e += G());
  let De = G(), Ie = A;
  A += De;
  let qe = 0, Te = 0;
  function Ee() {
    return qe == 0 && (Te = Te << 8 | I[A++], qe = 8), Te >> --qe & 1;
  }
  const Oe = 31, Le = Math.pow(2, Oe), ke = Le >>> 1, Fe = ke >> 1, Ge = Le - 1;
  let et = 0;
  for (let lt = 0; lt < Oe; lt++) et = et << 1 | Ee();
  let Ve = [], Je = 0, ut = Le;
  for (; ; ) {
    let lt = Math.floor(((et - Je + 1) * _e - 1) / ut), vt = 0, Ye = J;
    for (; Ye - vt > 1; ) {
      let Yt = vt + Ye >>> 1;
      lt < H[Yt] ? Ye = Yt : vt = Yt;
    }
    if (vt == 0) break;
    Ve.push(vt);
    let pt = Je + Math.floor(ut * H[vt] / _e), bt = Je + Math.floor(ut * H[vt + 1] / _e) - 1;
    for (; !((pt ^ bt) & ke); ) et = et << 1 & Ge | Ee(), pt = pt << 1 & Ge, bt = bt << 1 & Ge | 1;
    for (; pt & ~bt & Fe; ) et = et & ke | et << 1 & Ge >>> 1 | Ee(), pt = pt << 1 ^ ke, bt = (bt ^ ke) << 1 | ke | 1;
    Je = pt, ut = 1 + bt - pt;
  }
  let rt = J - 4;
  return Ve.map((lt) => {
    switch (lt - rt) {
      case 3:
        return rt + 65792 + (I[Ie++] << 16 | I[Ie++] << 8 | I[Ie++]);
      case 2:
        return rt + 256 + (I[Ie++] << 8 | I[Ie++]);
      case 1:
        return rt + I[Ie++];
      default:
        return lt - 1;
    }
  });
}
function Xs(I) {
  let A = 0;
  return () => I[A++];
}
function $s(I) {
  return Xs(Ws(I));
}
function Zs(I) {
  return I & 1 ? ~I >> 1 : I >> 1;
}
function t0(I, A) {
  let G = Array(I);
  for (let J = 0; J < I; J++) G[J] = 1 + A();
  return G;
}
function cf(I, A) {
  let G = Array(I);
  for (let J = 0, _e = -1; J < I; J++) G[J] = _e += 1 + A();
  return G;
}
function e0(I, A) {
  let G = Array(I);
  for (let J = 0, _e = 0; J < I; J++) G[J] = _e += Zs(A());
  return G;
}
function Ur(I, A) {
  let G = cf(I(), I), J = I(), _e = cf(J, I), H = t0(J, I);
  for (let De = 0; De < J; De++) for (let Ie = 0; Ie < H[De]; Ie++) G.push(_e[De] + Ie);
  return A ? G.map((De) => A[De]) : G;
}
function r0(I) {
  let A = [];
  for (; ; ) {
    let G = I();
    if (G == 0) break;
    A.push(n0(G, I));
  }
  for (; ; ) {
    let G = I() - 1;
    if (G < 0) break;
    A.push(f0(G, I));
  }
  return Vs(hf(A));
}
function i0(I) {
  let A = [];
  for (; ; ) {
    let G = I();
    if (G == 0) break;
    A.push(G);
  }
  return A;
}
function lf(I, A, G) {
  let J = Array(I).fill(void 0).map(() => []);
  for (let _e = 0; _e < A; _e++) e0(I, G).forEach((H, De) => J[De].push(H));
  return J;
}
function n0(I, A) {
  let G = 1 + A(), J = A(), _e = i0(A), H = lf(_e.length, 1 + I, A);
  return hf(H.map((De, Ie) => {
    const qe = De[0], Te = De.slice(1);
    return Array(_e[Ie]).fill(void 0).map((Ee, Oe) => {
      let Le = Oe * J;
      return [qe + Oe * G, Te.map((ke) => ke + Le)];
    });
  }));
}
function f0(I, A) {
  let G = 1 + A();
  return lf(G, 1 + I, A).map((J) => [J[0], J.slice(1)]);
}
function o0(I) {
  let A = Ur(I).sort((J, _e) => J - _e);
  return G();
  function G() {
    let J = [];
    for (; ; ) {
      let Te = Ur(I, A);
      if (Te.length == 0) break;
      J.push({ set: new Set(Te), node: G() });
    }
    J.sort((Te, Ee) => Ee.set.size - Te.set.size);
    let _e = I(), H = _e % 3;
    _e = _e / 3 | 0;
    let De = !!(_e & 1);
    _e >>= 1;
    let Ie = _e == 1, qe = _e == 2;
    return { branches: J, valid: H, fe0f: De, save: Ie, check: qe };
  }
}
function s0() {
  return $s(Ys("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"));
}
const kr = s0();
new Set(Ur(kr)), new Set(Ur(kr)), r0(kr), o0(kr);
const a0 = new Uint8Array(32);
a0.fill(0);
const m0 = new Uint8Array(32);
m0.fill(0), V.from(-1);
const A0 = V.from(0), b0 = V.from(1);
V.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), oe(b0.toHexString(), 32), oe(A0.toHexString(), 32);
var se = {}, Q$1 = {}, xr = gf;
function gf(I, A) {
  if (!I) throw new Error(A || "Assertion failed");
}
gf.equal = function(I, A, G) {
  if (I != A) throw new Error(G || "Assertion failed: " + I + " != " + A);
};
var Pi = { exports: {} };
typeof Object.create == "function" ? Pi.exports = function(I, A) {
  A && (I.super_ = A, I.prototype = Object.create(A.prototype, { constructor: { value: I, enumerable: !1, writable: !0, configurable: !0 } }));
} : Pi.exports = function(I, A) {
  if (A) {
    I.super_ = A;
    var G = function() {
    };
    G.prototype = A.prototype, I.prototype = new G(), I.prototype.constructor = I;
  }
};
var y0 = xr, w0 = Pi.exports;
Q$1.inherits = w0;
function x0(I, A) {
  return (I.charCodeAt(A) & 64512) !== 55296 || A < 0 || A + 1 >= I.length ? !1 : (I.charCodeAt(A + 1) & 64512) === 56320;
}
function M0(I, A) {
  if (Array.isArray(I)) return I.slice();
  if (!I) return [];
  var G = [];
  if (typeof I == "string") if (A) {
    if (A === "hex") for (I = I.replace(/[^a-z0-9]+/ig, ""), I.length % 2 !== 0 && (I = "0" + I), _e = 0; _e < I.length; _e += 2) G.push(parseInt(I[_e] + I[_e + 1], 16));
  } else for (var J = 0, _e = 0; _e < I.length; _e++) {
    var H = I.charCodeAt(_e);
    H < 128 ? G[J++] = H : H < 2048 ? (G[J++] = H >> 6 | 192, G[J++] = H & 63 | 128) : x0(I, _e) ? (H = 65536 + ((H & 1023) << 10) + (I.charCodeAt(++_e) & 1023), G[J++] = H >> 18 | 240, G[J++] = H >> 12 & 63 | 128, G[J++] = H >> 6 & 63 | 128, G[J++] = H & 63 | 128) : (G[J++] = H >> 12 | 224, G[J++] = H >> 6 & 63 | 128, G[J++] = H & 63 | 128);
  }
  else for (_e = 0; _e < I.length; _e++) G[_e] = I[_e] | 0;
  return G;
}
Q$1.toArray = M0;
function E0(I) {
  for (var A = "", G = 0; G < I.length; G++) A += Af(I[G].toString(16));
  return A;
}
Q$1.toHex = E0;
function mf(I) {
  var A = I >>> 24 | I >>> 8 & 65280 | I << 8 & 16711680 | (I & 255) << 24;
  return A >>> 0;
}
Q$1.htonl = mf;
function S0(I, A) {
  for (var G = "", J = 0; J < I.length; J++) {
    var _e = I[J];
    A === "little" && (_e = mf(_e)), G += bf(_e.toString(16));
  }
  return G;
}
Q$1.toHex32 = S0;
function Af(I) {
  return I.length === 1 ? "0" + I : I;
}
Q$1.zero2 = Af;
function bf(I) {
  return I.length === 7 ? "0" + I : I.length === 6 ? "00" + I : I.length === 5 ? "000" + I : I.length === 4 ? "0000" + I : I.length === 3 ? "00000" + I : I.length === 2 ? "000000" + I : I.length === 1 ? "0000000" + I : I;
}
Q$1.zero8 = bf;
function I0(I, A, G, J) {
  var _e = G - A;
  y0(_e % 4 === 0);
  for (var H = new Array(_e / 4), De = 0, Ie = A; De < H.length; De++, Ie += 4) {
    var qe;
    J === "big" ? qe = I[Ie] << 24 | I[Ie + 1] << 16 | I[Ie + 2] << 8 | I[Ie + 3] : qe = I[Ie + 3] << 24 | I[Ie + 2] << 16 | I[Ie + 1] << 8 | I[Ie], H[De] = qe >>> 0;
  }
  return H;
}
Q$1.join32 = I0;
function N0(I, A) {
  for (var G = new Array(I.length * 4), J = 0, _e = 0; J < I.length; J++, _e += 4) {
    var H = I[J];
    A === "big" ? (G[_e] = H >>> 24, G[_e + 1] = H >>> 16 & 255, G[_e + 2] = H >>> 8 & 255, G[_e + 3] = H & 255) : (G[_e + 3] = H >>> 24, G[_e + 2] = H >>> 16 & 255, G[_e + 1] = H >>> 8 & 255, G[_e] = H & 255);
  }
  return G;
}
Q$1.split32 = N0;
function _0(I, A) {
  return I >>> A | I << 32 - A;
}
Q$1.rotr32 = _0;
function B0(I, A) {
  return I << A | I >>> 32 - A;
}
Q$1.rotl32 = B0;
function C0(I, A) {
  return I + A >>> 0;
}
Q$1.sum32 = C0;
function R0(I, A, G) {
  return I + A + G >>> 0;
}
Q$1.sum32_3 = R0;
function O0(I, A, G, J) {
  return I + A + G + J >>> 0;
}
Q$1.sum32_4 = O0;
function P0(I, A, G, J, _e) {
  return I + A + G + J + _e >>> 0;
}
Q$1.sum32_5 = P0;
function T0(I, A, G, J) {
  var _e = I[A], H = I[A + 1], De = J + H >>> 0, Ie = (De < J ? 1 : 0) + G + _e;
  I[A] = Ie >>> 0, I[A + 1] = De;
}
Q$1.sum64 = T0;
function D0(I, A, G, J) {
  var _e = A + J >>> 0, H = (_e < A ? 1 : 0) + I + G;
  return H >>> 0;
}
Q$1.sum64_hi = D0;
function F0(I, A, G, J) {
  var _e = A + J;
  return _e >>> 0;
}
Q$1.sum64_lo = F0;
function U0(I, A, G, J, _e, H, De, Ie) {
  var qe = 0, Te = A;
  Te = Te + J >>> 0, qe += Te < A ? 1 : 0, Te = Te + H >>> 0, qe += Te < H ? 1 : 0, Te = Te + Ie >>> 0, qe += Te < Ie ? 1 : 0;
  var Ee = I + G + _e + De + qe;
  return Ee >>> 0;
}
Q$1.sum64_4_hi = U0;
function k0(I, A, G, J, _e, H, De, Ie) {
  var qe = A + J + H + Ie;
  return qe >>> 0;
}
Q$1.sum64_4_lo = k0;
function q0(I, A, G, J, _e, H, De, Ie, qe, Te) {
  var Ee = 0, Oe = A;
  Oe = Oe + J >>> 0, Ee += Oe < A ? 1 : 0, Oe = Oe + H >>> 0, Ee += Oe < H ? 1 : 0, Oe = Oe + Ie >>> 0, Ee += Oe < Ie ? 1 : 0, Oe = Oe + Te >>> 0, Ee += Oe < Te ? 1 : 0;
  var Le = I + G + _e + De + qe + Ee;
  return Le >>> 0;
}
Q$1.sum64_5_hi = q0;
function K0(I, A, G, J, _e, H, De, Ie, qe, Te) {
  var Ee = A + J + H + Ie + Te;
  return Ee >>> 0;
}
Q$1.sum64_5_lo = K0;
function H0(I, A, G) {
  var J = A << 32 - G | I >>> G;
  return J >>> 0;
}
Q$1.rotr64_hi = H0;
function L0(I, A, G) {
  var J = I << 32 - G | A >>> G;
  return J >>> 0;
}
Q$1.rotr64_lo = L0;
function z0(I, A, G) {
  return I >>> G;
}
Q$1.shr64_hi = z0;
function j0(I, A, G) {
  var J = I << 32 - G | A >>> G;
  return J >>> 0;
}
Q$1.shr64_lo = j0;
var or = {}, yf = Q$1, Q0 = xr;
function qr() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
or.BlockHash = qr, qr.prototype.update = function(I, A) {
  if (I = yf.toArray(I, A), this.pending ? this.pending = this.pending.concat(I) : this.pending = I, this.pendingTotal += I.length, this.pending.length >= this._delta8) {
    I = this.pending;
    var G = I.length % this._delta8;
    this.pending = I.slice(I.length - G, I.length), this.pending.length === 0 && (this.pending = null), I = yf.join32(I, 0, I.length - G, this.endian);
    for (var J = 0; J < I.length; J += this._delta32) this._update(I, J, J + this._delta32);
  }
  return this;
}, qr.prototype.digest = function(I) {
  return this.update(this._pad()), Q0(this.pending === null), this._digest(I);
}, qr.prototype._pad = function() {
  var I = this.pendingTotal, A = this._delta8, G = A - (I + this.padLength) % A, J = new Array(G + this.padLength);
  J[0] = 128;
  for (var _e = 1; _e < G; _e++) J[_e] = 0;
  if (I <<= 3, this.endian === "big") {
    for (var H = 8; H < this.padLength; H++) J[_e++] = 0;
    J[_e++] = 0, J[_e++] = 0, J[_e++] = 0, J[_e++] = 0, J[_e++] = I >>> 24 & 255, J[_e++] = I >>> 16 & 255, J[_e++] = I >>> 8 & 255, J[_e++] = I & 255;
  } else for (J[_e++] = I & 255, J[_e++] = I >>> 8 & 255, J[_e++] = I >>> 16 & 255, J[_e++] = I >>> 24 & 255, J[_e++] = 0, J[_e++] = 0, J[_e++] = 0, J[_e++] = 0, H = 8; H < this.padLength; H++) J[_e++] = 0;
  return J;
};
var sr = {}, ae = {}, J0 = Q$1, ue = J0.rotr32;
function G0(I, A, G, J) {
  if (I === 0) return wf(A, G, J);
  if (I === 1 || I === 3) return Mf(A, G, J);
  if (I === 2) return xf(A, G, J);
}
ae.ft_1 = G0;
function wf(I, A, G) {
  return I & A ^ ~I & G;
}
ae.ch32 = wf;
function xf(I, A, G) {
  return I & A ^ I & G ^ A & G;
}
ae.maj32 = xf;
function Mf(I, A, G) {
  return I ^ A ^ G;
}
ae.p32 = Mf;
function Y0(I) {
  return ue(I, 2) ^ ue(I, 13) ^ ue(I, 22);
}
ae.s0_256 = Y0;
function V0(I) {
  return ue(I, 6) ^ ue(I, 11) ^ ue(I, 25);
}
ae.s1_256 = V0;
function W0(I) {
  return ue(I, 7) ^ ue(I, 18) ^ I >>> 3;
}
ae.g0_256 = W0;
function X0(I) {
  return ue(I, 17) ^ ue(I, 19) ^ I >>> 10;
}
ae.g1_256 = X0;
var ar = Q$1, $0 = or, Z0 = ae, Ti = ar.rotl32, Mr = ar.sum32, ta = ar.sum32_5, ea = Z0.ft_1, Ef = $0.BlockHash, ra = [1518500249, 1859775393, 2400959708, 3395469782];
function he() {
  if (!(this instanceof he)) return new he();
  Ef.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
}
ar.inherits(he, Ef);
var ia = he;
he.blockSize = 512, he.outSize = 160, he.hmacStrength = 80, he.padLength = 64, he.prototype._update = function(I, A) {
  for (var G = this.W, J = 0; J < 16; J++) G[J] = I[A + J];
  for (; J < G.length; J++) G[J] = Ti(G[J - 3] ^ G[J - 8] ^ G[J - 14] ^ G[J - 16], 1);
  var _e = this.h[0], H = this.h[1], De = this.h[2], Ie = this.h[3], qe = this.h[4];
  for (J = 0; J < G.length; J++) {
    var Te = ~~(J / 20), Ee = ta(Ti(_e, 5), ea(Te, H, De, Ie), qe, G[J], ra[Te]);
    qe = Ie, Ie = De, De = Ti(H, 30), H = _e, _e = Ee;
  }
  this.h[0] = Mr(this.h[0], _e), this.h[1] = Mr(this.h[1], H), this.h[2] = Mr(this.h[2], De), this.h[3] = Mr(this.h[3], Ie), this.h[4] = Mr(this.h[4], qe);
}, he.prototype._digest = function(I) {
  return I === "hex" ? ar.toHex32(this.h, "big") : ar.split32(this.h, "big");
};
var ur = Q$1, na = or, hr = ae, fa = xr, ie = ur.sum32, oa = ur.sum32_4, sa = ur.sum32_5, aa = hr.ch32, ua = hr.maj32, ha = hr.s0_256, ca = hr.s1_256, la = hr.g0_256, da = hr.g1_256, Sf = na.BlockHash, pa = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
function ce() {
  if (!(this instanceof ce)) return new ce();
  Sf.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = pa, this.W = new Array(64);
}
ur.inherits(ce, Sf);
var If = ce;
ce.blockSize = 512, ce.outSize = 256, ce.hmacStrength = 192, ce.padLength = 64, ce.prototype._update = function(I, A) {
  for (var G = this.W, J = 0; J < 16; J++) G[J] = I[A + J];
  for (; J < G.length; J++) G[J] = oa(da(G[J - 2]), G[J - 7], la(G[J - 15]), G[J - 16]);
  var _e = this.h[0], H = this.h[1], De = this.h[2], Ie = this.h[3], qe = this.h[4], Te = this.h[5], Ee = this.h[6], Oe = this.h[7];
  for (fa(this.k.length === G.length), J = 0; J < G.length; J++) {
    var Le = sa(Oe, ca(qe), aa(qe, Te, Ee), this.k[J], G[J]), ke = ie(ha(_e), ua(_e, H, De));
    Oe = Ee, Ee = Te, Te = qe, qe = ie(Ie, Le), Ie = De, De = H, H = _e, _e = ie(Le, ke);
  }
  this.h[0] = ie(this.h[0], _e), this.h[1] = ie(this.h[1], H), this.h[2] = ie(this.h[2], De), this.h[3] = ie(this.h[3], Ie), this.h[4] = ie(this.h[4], qe), this.h[5] = ie(this.h[5], Te), this.h[6] = ie(this.h[6], Ee), this.h[7] = ie(this.h[7], Oe);
}, ce.prototype._digest = function(I) {
  return I === "hex" ? ur.toHex32(this.h, "big") : ur.split32(this.h, "big");
};
var Di = Q$1, Nf = If;
function ye() {
  if (!(this instanceof ye)) return new ye();
  Nf.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
}
Di.inherits(ye, Nf);
var va = ye;
ye.blockSize = 512, ye.outSize = 224, ye.hmacStrength = 192, ye.padLength = 64, ye.prototype._digest = function(I) {
  return I === "hex" ? Di.toHex32(this.h.slice(0, 7), "big") : Di.split32(this.h.slice(0, 7), "big");
};
var jt = Q$1, ga = or, ma = xr, le = jt.rotr64_hi, de = jt.rotr64_lo, _f = jt.shr64_hi, Bf = jt.shr64_lo, Be = jt.sum64, Fi$1 = jt.sum64_hi, Ui = jt.sum64_lo, Aa = jt.sum64_4_hi, ba$1 = jt.sum64_4_lo, ya$1 = jt.sum64_5_hi, wa = jt.sum64_5_lo, Cf = ga.BlockHash, xa = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];
function ne() {
  if (!(this instanceof ne)) return new ne();
  Cf.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = xa, this.W = new Array(160);
}
jt.inherits(ne, Cf);
var Rf = ne;
ne.blockSize = 1024, ne.outSize = 512, ne.hmacStrength = 192, ne.padLength = 128, ne.prototype._prepareBlock = function(I, A) {
  for (var G = this.W, J = 0; J < 32; J++) G[J] = I[A + J];
  for (; J < G.length; J += 2) {
    var _e = Pa(G[J - 4], G[J - 3]), H = Ta$1(G[J - 4], G[J - 3]), De = G[J - 14], Ie = G[J - 13], qe = Ra$1(G[J - 30], G[J - 29]), Te = Oa$1(G[J - 30], G[J - 29]), Ee = G[J - 32], Oe = G[J - 31];
    G[J] = Aa(_e, H, De, Ie, qe, Te, Ee, Oe), G[J + 1] = ba$1(_e, H, De, Ie, qe, Te, Ee, Oe);
  }
}, ne.prototype._update = function(I, A) {
  this._prepareBlock(I, A);
  var G = this.W, J = this.h[0], _e = this.h[1], H = this.h[2], De = this.h[3], Ie = this.h[4], qe = this.h[5], Te = this.h[6], Ee = this.h[7], Oe = this.h[8], Le = this.h[9], ke = this.h[10], Fe = this.h[11], Ge = this.h[12], et = this.h[13], Ve = this.h[14], Je = this.h[15];
  ma(this.k.length === G.length);
  for (var ut = 0; ut < G.length; ut += 2) {
    var rt = Ve, lt = Je, vt = Ba(Oe, Le), Ye = Ca(Oe, Le), pt = Ma(Oe, Le, ke, Fe, Ge), bt = Ea(Oe, Le, ke, Fe, Ge, et), Yt = this.k[ut], Se = this.k[ut + 1], t = G[ut], h = G[ut + 1], B = ya$1(rt, lt, vt, Ye, pt, bt, Yt, Se, t, h), Z = wa(rt, lt, vt, Ye, pt, bt, Yt, Se, t, h);
    rt = Na$1(J, _e), lt = _a(J, _e), vt = Sa$1(J, _e, H, De, Ie), Ye = Ia(J, _e, H, De, Ie, qe);
    var ve = Fi$1(rt, lt, vt, Ye), ge = Ui(rt, lt, vt, Ye);
    Ve = Ge, Je = et, Ge = ke, et = Fe, ke = Oe, Fe = Le, Oe = Fi$1(Te, Ee, B, Z), Le = Ui(Ee, Ee, B, Z), Te = Ie, Ee = qe, Ie = H, qe = De, H = J, De = _e, J = Fi$1(B, Z, ve, ge), _e = Ui(B, Z, ve, ge);
  }
  Be(this.h, 0, J, _e), Be(this.h, 2, H, De), Be(this.h, 4, Ie, qe), Be(this.h, 6, Te, Ee), Be(this.h, 8, Oe, Le), Be(this.h, 10, ke, Fe), Be(this.h, 12, Ge, et), Be(this.h, 14, Ve, Je);
}, ne.prototype._digest = function(I) {
  return I === "hex" ? jt.toHex32(this.h, "big") : jt.split32(this.h, "big");
};
function Ma(I, A, G, J, _e) {
  var H = I & G ^ ~I & _e;
  return H < 0 && (H += 4294967296), H;
}
function Ea(I, A, G, J, _e, H) {
  var De = A & J ^ ~A & H;
  return De < 0 && (De += 4294967296), De;
}
function Sa$1(I, A, G, J, _e) {
  var H = I & G ^ I & _e ^ G & _e;
  return H < 0 && (H += 4294967296), H;
}
function Ia(I, A, G, J, _e, H) {
  var De = A & J ^ A & H ^ J & H;
  return De < 0 && (De += 4294967296), De;
}
function Na$1(I, A) {
  var G = le(I, A, 28), J = le(A, I, 2), _e = le(A, I, 7), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function _a(I, A) {
  var G = de(I, A, 28), J = de(A, I, 2), _e = de(A, I, 7), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function Ba(I, A) {
  var G = le(I, A, 14), J = le(I, A, 18), _e = le(A, I, 9), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function Ca(I, A) {
  var G = de(I, A, 14), J = de(I, A, 18), _e = de(A, I, 9), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function Ra$1(I, A) {
  var G = le(I, A, 1), J = le(I, A, 8), _e = _f(I, A, 7), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function Oa$1(I, A) {
  var G = de(I, A, 1), J = de(I, A, 8), _e = Bf(I, A, 7), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function Pa(I, A) {
  var G = le(I, A, 19), J = le(A, I, 29), _e = _f(I, A, 6), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
function Ta$1(I, A) {
  var G = de(I, A, 19), J = de(A, I, 29), _e = Bf(I, A, 6), H = G ^ J ^ _e;
  return H < 0 && (H += 4294967296), H;
}
var ki = Q$1, Of = Rf;
function we() {
  if (!(this instanceof we)) return new we();
  Of.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
}
ki.inherits(we, Of);
var Da$1 = we;
we.blockSize = 1024, we.outSize = 384, we.hmacStrength = 192, we.padLength = 128, we.prototype._digest = function(I) {
  return I === "hex" ? ki.toHex32(this.h.slice(0, 12), "big") : ki.split32(this.h.slice(0, 12), "big");
}, sr.sha1 = ia, sr.sha224 = va, sr.sha256 = If, sr.sha384 = Da$1, sr.sha512 = Rf;
var Pf = {}, Xe = Q$1, Fa$1 = or, Kr = Xe.rotl32, Tf = Xe.sum32, Er = Xe.sum32_3, Df = Xe.sum32_4, Ff = Fa$1.BlockHash;
function pe() {
  if (!(this instanceof pe)) return new pe();
  Ff.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
Xe.inherits(pe, Ff), Pf.ripemd160 = pe, pe.blockSize = 512, pe.outSize = 160, pe.hmacStrength = 192, pe.padLength = 64, pe.prototype._update = function(I, A) {
  for (var G = this.h[0], J = this.h[1], _e = this.h[2], H = this.h[3], De = this.h[4], Ie = G, qe = J, Te = _e, Ee = H, Oe = De, Le = 0; Le < 80; Le++) {
    var ke = Tf(Kr(Df(G, Uf(Le, J, _e, H), I[qa$1[Le] + A], Ua$1(Le)), Ha$1[Le]), De);
    G = De, De = H, H = Kr(_e, 10), _e = J, J = ke, ke = Tf(Kr(Df(Ie, Uf(79 - Le, qe, Te, Ee), I[Ka[Le] + A], ka(Le)), La$1[Le]), Oe), Ie = Oe, Oe = Ee, Ee = Kr(Te, 10), Te = qe, qe = ke;
  }
  ke = Er(this.h[1], _e, Ee), this.h[1] = Er(this.h[2], H, Oe), this.h[2] = Er(this.h[3], De, Ie), this.h[3] = Er(this.h[4], G, qe), this.h[4] = Er(this.h[0], J, Te), this.h[0] = ke;
}, pe.prototype._digest = function(I) {
  return I === "hex" ? Xe.toHex32(this.h, "little") : Xe.split32(this.h, "little");
};
function Uf(I, A, G, J) {
  return I <= 15 ? A ^ G ^ J : I <= 31 ? A & G | ~A & J : I <= 47 ? (A | ~G) ^ J : I <= 63 ? A & J | G & ~J : A ^ (G | ~J);
}
function Ua$1(I) {
  return I <= 15 ? 0 : I <= 31 ? 1518500249 : I <= 47 ? 1859775393 : I <= 63 ? 2400959708 : 2840853838;
}
function ka(I) {
  return I <= 15 ? 1352829926 : I <= 31 ? 1548603684 : I <= 47 ? 1836072691 : I <= 63 ? 2053994217 : 0;
}
var qa$1 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13], Ka = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11], Ha$1 = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6], La$1 = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11], za = Q$1, ja = xr;
function cr(I, A, G) {
  if (!(this instanceof cr)) return new cr(I, A, G);
  this.Hash = I, this.blockSize = I.blockSize / 8, this.outSize = I.outSize / 8, this.inner = null, this.outer = null, this._init(za.toArray(A, G));
}
var Qa = cr;
cr.prototype._init = function(I) {
  I.length > this.blockSize && (I = new this.Hash().update(I).digest()), ja(I.length <= this.blockSize);
  for (var A = I.length; A < this.blockSize; A++) I.push(0);
  for (A = 0; A < I.length; A++) I[A] ^= 54;
  for (this.inner = new this.Hash().update(I), A = 0; A < I.length; A++) I[A] ^= 106;
  this.outer = new this.Hash().update(I);
}, cr.prototype.update = function(I, A) {
  return this.inner.update(I, A), this;
}, cr.prototype.digest = function(I) {
  return this.outer.update(this.inner.digest()), this.outer.digest(I);
}, function(I) {
  var A = I;
  A.utils = Q$1, A.common = or, A.sha = sr, A.ripemd = Pf, A.hmac = Qa, A.sha1 = A.sha.sha1, A.sha256 = A.sha.sha256, A.sha224 = A.sha.sha224, A.sha384 = A.sha.sha384, A.sha512 = A.sha.sha512, A.ripemd160 = A.ripemd.ripemd160;
}(se);
function lr$1(I, A, G) {
  return G = { path: A, exports: {}, require: function(J, _e) {
    return Ja(J, _e ?? G.path);
  } }, I(G, G.exports), G.exports;
}
function Ja() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var qi$1 = kf;
function kf(I, A) {
  if (!I) throw new Error(A || "Assertion failed");
}
kf.equal = function(I, A, G) {
  if (I != A) throw new Error(G || "Assertion failed: " + I + " != " + A);
};
var fe = lr$1(function(I, A) {
  var G = A;
  function J(De, Ie) {
    if (Array.isArray(De)) return De.slice();
    if (!De) return [];
    var qe = [];
    if (typeof De != "string") {
      for (var Te = 0; Te < De.length; Te++) qe[Te] = De[Te] | 0;
      return qe;
    }
    if (Ie === "hex") {
      De = De.replace(/[^a-z0-9]+/ig, ""), De.length % 2 !== 0 && (De = "0" + De);
      for (var Te = 0; Te < De.length; Te += 2) qe.push(parseInt(De[Te] + De[Te + 1], 16));
    } else for (var Te = 0; Te < De.length; Te++) {
      var Ee = De.charCodeAt(Te), Oe = Ee >> 8, Le = Ee & 255;
      Oe ? qe.push(Oe, Le) : qe.push(Le);
    }
    return qe;
  }
  G.toArray = J;
  function _e(De) {
    return De.length === 1 ? "0" + De : De;
  }
  G.zero2 = _e;
  function H(De) {
    for (var Ie = "", qe = 0; qe < De.length; qe++) Ie += _e(De[qe].toString(16));
    return Ie;
  }
  G.toHex = H, G.encode = function(De, Ie) {
    return Ie === "hex" ? H(De) : De;
  };
}), Gt = lr$1(function(I, A) {
  var G = A;
  G.assert = qi$1, G.toArray = fe.toArray, G.zero2 = fe.zero2, G.toHex = fe.toHex, G.encode = fe.encode;
  function J(qe, Te, Ee) {
    var Oe = new Array(Math.max(qe.bitLength(), Ee) + 1);
    Oe.fill(0);
    for (var Le = 1 << Te + 1, ke = qe.clone(), Fe = 0; Fe < Oe.length; Fe++) {
      var Ge, et = ke.andln(Le - 1);
      ke.isOdd() ? (et > (Le >> 1) - 1 ? Ge = (Le >> 1) - et : Ge = et, ke.isubn(Ge)) : Ge = 0, Oe[Fe] = Ge, ke.iushrn(1);
    }
    return Oe;
  }
  G.getNAF = J;
  function _e(qe, Te) {
    var Ee = [[], []];
    qe = qe.clone(), Te = Te.clone();
    for (var Oe = 0, Le = 0, ke; qe.cmpn(-Oe) > 0 || Te.cmpn(-Le) > 0; ) {
      var Fe = qe.andln(3) + Oe & 3, Ge = Te.andln(3) + Le & 3;
      Fe === 3 && (Fe = -1), Ge === 3 && (Ge = -1);
      var et;
      Fe & 1 ? (ke = qe.andln(7) + Oe & 7, (ke === 3 || ke === 5) && Ge === 2 ? et = -Fe : et = Fe) : et = 0, Ee[0].push(et);
      var Ve;
      Ge & 1 ? (ke = Te.andln(7) + Le & 7, (ke === 3 || ke === 5) && Fe === 2 ? Ve = -Ge : Ve = Ge) : Ve = 0, Ee[1].push(Ve), 2 * Oe === et + 1 && (Oe = 1 - Oe), 2 * Le === Ve + 1 && (Le = 1 - Le), qe.iushrn(1), Te.iushrn(1);
    }
    return Ee;
  }
  G.getJSF = _e;
  function H(qe, Te, Ee) {
    var Oe = "_" + Te;
    qe.prototype[Te] = function() {
      return this[Oe] !== void 0 ? this[Oe] : this[Oe] = Ee.call(this);
    };
  }
  G.cachedProperty = H;
  function De(qe) {
    return typeof qe == "string" ? G.toArray(qe, "hex") : qe;
  }
  G.parseBytes = De;
  function Ie(qe) {
    return new K(qe, "hex", "le");
  }
  G.intFromLE = Ie;
}), Hr = Gt.getNAF, Ga = Gt.getJSF, Lr = Gt.assert;
function Ce(I, A) {
  this.type = I, this.p = new K(A.p, 16), this.red = A.prime ? K.red(A.prime) : K.mont(this.p), this.zero = new K(0).toRed(this.red), this.one = new K(1).toRed(this.red), this.two = new K(2).toRed(this.red), this.n = A.n && new K(A.n, 16), this.g = A.g && this.pointFromJSON(A.g, A.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var G = this.n && this.p.div(this.n);
  !G || G.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var $e = Ce;
Ce.prototype.point = function() {
  throw new Error("Not implemented");
}, Ce.prototype.validate = function() {
  throw new Error("Not implemented");
}, Ce.prototype._fixedNafMul = function(I, A) {
  Lr(I.precomputed);
  var G = I._getDoubles(), J = Hr(A, 1, this._bitLength), _e = (1 << G.step + 1) - (G.step % 2 === 0 ? 2 : 1);
  _e /= 3;
  var H = [], De, Ie;
  for (De = 0; De < J.length; De += G.step) {
    Ie = 0;
    for (var qe = De + G.step - 1; qe >= De; qe--) Ie = (Ie << 1) + J[qe];
    H.push(Ie);
  }
  for (var Te = this.jpoint(null, null, null), Ee = this.jpoint(null, null, null), Oe = _e; Oe > 0; Oe--) {
    for (De = 0; De < H.length; De++) Ie = H[De], Ie === Oe ? Ee = Ee.mixedAdd(G.points[De]) : Ie === -Oe && (Ee = Ee.mixedAdd(G.points[De].neg()));
    Te = Te.add(Ee);
  }
  return Te.toP();
}, Ce.prototype._wnafMul = function(I, A) {
  var G = 4, J = I._getNAFPoints(G);
  G = J.wnd;
  for (var _e = J.points, H = Hr(A, G, this._bitLength), De = this.jpoint(null, null, null), Ie = H.length - 1; Ie >= 0; Ie--) {
    for (var qe = 0; Ie >= 0 && H[Ie] === 0; Ie--) qe++;
    if (Ie >= 0 && qe++, De = De.dblp(qe), Ie < 0) break;
    var Te = H[Ie];
    Lr(Te !== 0), I.type === "affine" ? Te > 0 ? De = De.mixedAdd(_e[Te - 1 >> 1]) : De = De.mixedAdd(_e[-Te - 1 >> 1].neg()) : Te > 0 ? De = De.add(_e[Te - 1 >> 1]) : De = De.add(_e[-Te - 1 >> 1].neg());
  }
  return I.type === "affine" ? De.toP() : De;
}, Ce.prototype._wnafMulAdd = function(I, A, G, J, _e) {
  var H = this._wnafT1, De = this._wnafT2, Ie = this._wnafT3, qe = 0, Te, Ee, Oe;
  for (Te = 0; Te < J; Te++) {
    Oe = A[Te];
    var Le = Oe._getNAFPoints(I);
    H[Te] = Le.wnd, De[Te] = Le.points;
  }
  for (Te = J - 1; Te >= 1; Te -= 2) {
    var ke = Te - 1, Fe = Te;
    if (H[ke] !== 1 || H[Fe] !== 1) {
      Ie[ke] = Hr(G[ke], H[ke], this._bitLength), Ie[Fe] = Hr(G[Fe], H[Fe], this._bitLength), qe = Math.max(Ie[ke].length, qe), qe = Math.max(Ie[Fe].length, qe);
      continue;
    }
    var Ge = [A[ke], null, null, A[Fe]];
    A[ke].y.cmp(A[Fe].y) === 0 ? (Ge[1] = A[ke].add(A[Fe]), Ge[2] = A[ke].toJ().mixedAdd(A[Fe].neg())) : A[ke].y.cmp(A[Fe].y.redNeg()) === 0 ? (Ge[1] = A[ke].toJ().mixedAdd(A[Fe]), Ge[2] = A[ke].add(A[Fe].neg())) : (Ge[1] = A[ke].toJ().mixedAdd(A[Fe]), Ge[2] = A[ke].toJ().mixedAdd(A[Fe].neg()));
    var et = [-3, -1, -5, -7, 0, 7, 5, 1, 3], Ve = Ga(G[ke], G[Fe]);
    for (qe = Math.max(Ve[0].length, qe), Ie[ke] = new Array(qe), Ie[Fe] = new Array(qe), Ee = 0; Ee < qe; Ee++) {
      var Je = Ve[0][Ee] | 0, ut = Ve[1][Ee] | 0;
      Ie[ke][Ee] = et[(Je + 1) * 3 + (ut + 1)], Ie[Fe][Ee] = 0, De[ke] = Ge;
    }
  }
  var rt = this.jpoint(null, null, null), lt = this._wnafT4;
  for (Te = qe; Te >= 0; Te--) {
    for (var vt = 0; Te >= 0; ) {
      var Ye = !0;
      for (Ee = 0; Ee < J; Ee++) lt[Ee] = Ie[Ee][Te] | 0, lt[Ee] !== 0 && (Ye = !1);
      if (!Ye) break;
      vt++, Te--;
    }
    if (Te >= 0 && vt++, rt = rt.dblp(vt), Te < 0) break;
    for (Ee = 0; Ee < J; Ee++) {
      var pt = lt[Ee];
      pt !== 0 && (pt > 0 ? Oe = De[Ee][pt - 1 >> 1] : pt < 0 && (Oe = De[Ee][-pt - 1 >> 1].neg()), Oe.type === "affine" ? rt = rt.mixedAdd(Oe) : rt = rt.add(Oe));
    }
  }
  for (Te = 0; Te < J; Te++) De[Te] = null;
  return _e ? rt : rt.toP();
};
function Zt(I, A) {
  this.curve = I, this.type = A, this.precomputed = null;
}
Ce.BasePoint = Zt, Zt.prototype.eq = function() {
  throw new Error("Not implemented");
}, Zt.prototype.validate = function() {
  return this.curve.validate(this);
}, Ce.prototype.decodePoint = function(I, A) {
  I = Gt.toArray(I, A);
  var G = this.p.byteLength();
  if ((I[0] === 4 || I[0] === 6 || I[0] === 7) && I.length - 1 === 2 * G) {
    I[0] === 6 ? Lr(I[I.length - 1] % 2 === 0) : I[0] === 7 && Lr(I[I.length - 1] % 2 === 1);
    var J = this.point(I.slice(1, 1 + G), I.slice(1 + G, 1 + 2 * G));
    return J;
  } else if ((I[0] === 2 || I[0] === 3) && I.length - 1 === G) return this.pointFromX(I.slice(1, 1 + G), I[0] === 3);
  throw new Error("Unknown point format");
}, Zt.prototype.encodeCompressed = function(I) {
  return this.encode(I, !0);
}, Zt.prototype._encode = function(I) {
  var A = this.curve.p.byteLength(), G = this.getX().toArray("be", A);
  return I ? [this.getY().isEven() ? 2 : 3].concat(G) : [4].concat(G, this.getY().toArray("be", A));
}, Zt.prototype.encode = function(I, A) {
  return Gt.encode(this._encode(A), I);
}, Zt.prototype.precompute = function(I) {
  if (this.precomputed) return this;
  var A = { doubles: null, naf: null, beta: null };
  return A.naf = this._getNAFPoints(8), A.doubles = this._getDoubles(4, I), A.beta = this._getBeta(), this.precomputed = A, this;
}, Zt.prototype._hasDoubles = function(I) {
  if (!this.precomputed) return !1;
  var A = this.precomputed.doubles;
  return A ? A.points.length >= Math.ceil((I.bitLength() + 1) / A.step) : !1;
}, Zt.prototype._getDoubles = function(I, A) {
  if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
  for (var G = [this], J = this, _e = 0; _e < A; _e += I) {
    for (var H = 0; H < I; H++) J = J.dbl();
    G.push(J);
  }
  return { step: I, points: G };
}, Zt.prototype._getNAFPoints = function(I) {
  if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
  for (var A = [this], G = (1 << I) - 1, J = G === 1 ? null : this.dbl(), _e = 1; _e < G; _e++) A[_e] = A[_e - 1].add(J);
  return { wnd: I, points: A };
}, Zt.prototype._getBeta = function() {
  return null;
}, Zt.prototype.dblp = function(I) {
  for (var A = this, G = 0; G < I; G++) A = A.dbl();
  return A;
};
var Ki = lr$1(function(I) {
  typeof Object.create == "function" ? I.exports = function(A, G) {
    G && (A.super_ = G, A.prototype = Object.create(G.prototype, { constructor: { value: A, enumerable: !1, writable: !0, configurable: !0 } }));
  } : I.exports = function(A, G) {
    if (G) {
      A.super_ = G;
      var J = function() {
      };
      J.prototype = G.prototype, A.prototype = new J(), A.prototype.constructor = A;
    }
  };
}), Ya = Gt.assert;
function te(I) {
  $e.call(this, "short", I), this.a = new K(I.a, 16).toRed(this.red), this.b = new K(I.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(I), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
Ki(te, $e);
var Va = te;
te.prototype._getEndomorphism = function(I) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var A, G;
    if (I.beta) A = new K(I.beta, 16).toRed(this.red);
    else {
      var J = this._getEndoRoots(this.p);
      A = J[0].cmp(J[1]) < 0 ? J[0] : J[1], A = A.toRed(this.red);
    }
    if (I.lambda) G = new K(I.lambda, 16);
    else {
      var _e = this._getEndoRoots(this.n);
      this.g.mul(_e[0]).x.cmp(this.g.x.redMul(A)) === 0 ? G = _e[0] : (G = _e[1], Ya(this.g.mul(G).x.cmp(this.g.x.redMul(A)) === 0));
    }
    var H;
    return I.basis ? H = I.basis.map(function(De) {
      return { a: new K(De.a, 16), b: new K(De.b, 16) };
    }) : H = this._getEndoBasis(G), { beta: A, lambda: G, basis: H };
  }
}, te.prototype._getEndoRoots = function(I) {
  var A = I === this.p ? this.red : K.mont(I), G = new K(2).toRed(A).redInvm(), J = G.redNeg(), _e = new K(3).toRed(A).redNeg().redSqrt().redMul(G), H = J.redAdd(_e).fromRed(), De = J.redSub(_e).fromRed();
  return [H, De];
}, te.prototype._getEndoBasis = function(I) {
  for (var A = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), G = I, J = this.n.clone(), _e = new K(1), H = new K(0), De = new K(0), Ie = new K(1), qe, Te, Ee, Oe, Le, ke, Fe, Ge = 0, et, Ve; G.cmpn(0) !== 0; ) {
    var Je = J.div(G);
    et = J.sub(Je.mul(G)), Ve = De.sub(Je.mul(_e));
    var ut = Ie.sub(Je.mul(H));
    if (!Ee && et.cmp(A) < 0) qe = Fe.neg(), Te = _e, Ee = et.neg(), Oe = Ve;
    else if (Ee && ++Ge === 2) break;
    Fe = et, J = G, G = et, De = _e, _e = Ve, Ie = H, H = ut;
  }
  Le = et.neg(), ke = Ve;
  var rt = Ee.sqr().add(Oe.sqr()), lt = Le.sqr().add(ke.sqr());
  return lt.cmp(rt) >= 0 && (Le = qe, ke = Te), Ee.negative && (Ee = Ee.neg(), Oe = Oe.neg()), Le.negative && (Le = Le.neg(), ke = ke.neg()), [{ a: Ee, b: Oe }, { a: Le, b: ke }];
}, te.prototype._endoSplit = function(I) {
  var A = this.endo.basis, G = A[0], J = A[1], _e = J.b.mul(I).divRound(this.n), H = G.b.neg().mul(I).divRound(this.n), De = _e.mul(G.a), Ie = H.mul(J.a), qe = _e.mul(G.b), Te = H.mul(J.b), Ee = I.sub(De).sub(Ie), Oe = qe.add(Te).neg();
  return { k1: Ee, k2: Oe };
}, te.prototype.pointFromX = function(I, A) {
  I = new K(I, 16), I.red || (I = I.toRed(this.red));
  var G = I.redSqr().redMul(I).redIAdd(I.redMul(this.a)).redIAdd(this.b), J = G.redSqrt();
  if (J.redSqr().redSub(G).cmp(this.zero) !== 0) throw new Error("invalid point");
  var _e = J.fromRed().isOdd();
  return (A && !_e || !A && _e) && (J = J.redNeg()), this.point(I, J);
}, te.prototype.validate = function(I) {
  if (I.inf) return !0;
  var A = I.x, G = I.y, J = this.a.redMul(A), _e = A.redSqr().redMul(A).redIAdd(J).redIAdd(this.b);
  return G.redSqr().redISub(_e).cmpn(0) === 0;
}, te.prototype._endoWnafMulAdd = function(I, A, G) {
  for (var J = this._endoWnafT1, _e = this._endoWnafT2, H = 0; H < I.length; H++) {
    var De = this._endoSplit(A[H]), Ie = I[H], qe = Ie._getBeta();
    De.k1.negative && (De.k1.ineg(), Ie = Ie.neg(!0)), De.k2.negative && (De.k2.ineg(), qe = qe.neg(!0)), J[H * 2] = Ie, J[H * 2 + 1] = qe, _e[H * 2] = De.k1, _e[H * 2 + 1] = De.k2;
  }
  for (var Te = this._wnafMulAdd(1, J, _e, H * 2, G), Ee = 0; Ee < H * 2; Ee++) J[Ee] = null, _e[Ee] = null;
  return Te;
};
function Dt(I, A, G, J) {
  $e.BasePoint.call(this, I, "affine"), A === null && G === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new K(A, 16), this.y = new K(G, 16), J && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
Ki(Dt, $e.BasePoint), te.prototype.point = function(I, A, G) {
  return new Dt(this, I, A, G);
}, te.prototype.pointFromJSON = function(I, A) {
  return Dt.fromJSON(this, I, A);
}, Dt.prototype._getBeta = function() {
  if (this.curve.endo) {
    var I = this.precomputed;
    if (I && I.beta) return I.beta;
    var A = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (I) {
      var G = this.curve, J = function(_e) {
        return G.point(_e.x.redMul(G.endo.beta), _e.y);
      };
      I.beta = A, A.precomputed = { beta: null, naf: I.naf && { wnd: I.naf.wnd, points: I.naf.points.map(J) }, doubles: I.doubles && { step: I.doubles.step, points: I.doubles.points.map(J) } };
    }
    return A;
  }
}, Dt.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && { doubles: this.precomputed.doubles && { step: this.precomputed.doubles.step, points: this.precomputed.doubles.points.slice(1) }, naf: this.precomputed.naf && { wnd: this.precomputed.naf.wnd, points: this.precomputed.naf.points.slice(1) } }] : [this.x, this.y];
}, Dt.fromJSON = function(I, A, G) {
  typeof A == "string" && (A = JSON.parse(A));
  var J = I.point(A[0], A[1], G);
  if (!A[2]) return J;
  function _e(De) {
    return I.point(De[0], De[1], G);
  }
  var H = A[2];
  return J.precomputed = { beta: null, doubles: H.doubles && { step: H.doubles.step, points: [J].concat(H.doubles.points.map(_e)) }, naf: H.naf && { wnd: H.naf.wnd, points: [J].concat(H.naf.points.map(_e)) } }, J;
}, Dt.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
}, Dt.prototype.isInfinity = function() {
  return this.inf;
}, Dt.prototype.add = function(I) {
  if (this.inf) return I;
  if (I.inf) return this;
  if (this.eq(I)) return this.dbl();
  if (this.neg().eq(I)) return this.curve.point(null, null);
  if (this.x.cmp(I.x) === 0) return this.curve.point(null, null);
  var A = this.y.redSub(I.y);
  A.cmpn(0) !== 0 && (A = A.redMul(this.x.redSub(I.x).redInvm()));
  var G = A.redSqr().redISub(this.x).redISub(I.x), J = A.redMul(this.x.redSub(G)).redISub(this.y);
  return this.curve.point(G, J);
}, Dt.prototype.dbl = function() {
  if (this.inf) return this;
  var I = this.y.redAdd(this.y);
  if (I.cmpn(0) === 0) return this.curve.point(null, null);
  var A = this.curve.a, G = this.x.redSqr(), J = I.redInvm(), _e = G.redAdd(G).redIAdd(G).redIAdd(A).redMul(J), H = _e.redSqr().redISub(this.x.redAdd(this.x)), De = _e.redMul(this.x.redSub(H)).redISub(this.y);
  return this.curve.point(H, De);
}, Dt.prototype.getX = function() {
  return this.x.fromRed();
}, Dt.prototype.getY = function() {
  return this.y.fromRed();
}, Dt.prototype.mul = function(I) {
  return I = new K(I, 16), this.isInfinity() ? this : this._hasDoubles(I) ? this.curve._fixedNafMul(this, I) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [I]) : this.curve._wnafMul(this, I);
}, Dt.prototype.mulAdd = function(I, A, G) {
  var J = [this, A], _e = [I, G];
  return this.curve.endo ? this.curve._endoWnafMulAdd(J, _e) : this.curve._wnafMulAdd(1, J, _e, 2);
}, Dt.prototype.jmulAdd = function(I, A, G) {
  var J = [this, A], _e = [I, G];
  return this.curve.endo ? this.curve._endoWnafMulAdd(J, _e, !0) : this.curve._wnafMulAdd(1, J, _e, 2, !0);
}, Dt.prototype.eq = function(I) {
  return this === I || this.inf === I.inf && (this.inf || this.x.cmp(I.x) === 0 && this.y.cmp(I.y) === 0);
}, Dt.prototype.neg = function(I) {
  if (this.inf) return this;
  var A = this.curve.point(this.x, this.y.redNeg());
  if (I && this.precomputed) {
    var G = this.precomputed, J = function(_e) {
      return _e.neg();
    };
    A.precomputed = { naf: G.naf && { wnd: G.naf.wnd, points: G.naf.points.map(J) }, doubles: G.doubles && { step: G.doubles.step, points: G.doubles.points.map(J) } };
  }
  return A;
}, Dt.prototype.toJ = function() {
  if (this.inf) return this.curve.jpoint(null, null, null);
  var I = this.curve.jpoint(this.x, this.y, this.curve.one);
  return I;
};
function Ft(I, A, G, J) {
  $e.BasePoint.call(this, I, "jacobian"), A === null && G === null && J === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new K(0)) : (this.x = new K(A, 16), this.y = new K(G, 16), this.z = new K(J, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
Ki(Ft, $e.BasePoint), te.prototype.jpoint = function(I, A, G) {
  return new Ft(this, I, A, G);
}, Ft.prototype.toP = function() {
  if (this.isInfinity()) return this.curve.point(null, null);
  var I = this.z.redInvm(), A = I.redSqr(), G = this.x.redMul(A), J = this.y.redMul(A).redMul(I);
  return this.curve.point(G, J);
}, Ft.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
}, Ft.prototype.add = function(I) {
  if (this.isInfinity()) return I;
  if (I.isInfinity()) return this;
  var A = I.z.redSqr(), G = this.z.redSqr(), J = this.x.redMul(A), _e = I.x.redMul(G), H = this.y.redMul(A.redMul(I.z)), De = I.y.redMul(G.redMul(this.z)), Ie = J.redSub(_e), qe = H.redSub(De);
  if (Ie.cmpn(0) === 0) return qe.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var Te = Ie.redSqr(), Ee = Te.redMul(Ie), Oe = J.redMul(Te), Le = qe.redSqr().redIAdd(Ee).redISub(Oe).redISub(Oe), ke = qe.redMul(Oe.redISub(Le)).redISub(H.redMul(Ee)), Fe = this.z.redMul(I.z).redMul(Ie);
  return this.curve.jpoint(Le, ke, Fe);
}, Ft.prototype.mixedAdd = function(I) {
  if (this.isInfinity()) return I.toJ();
  if (I.isInfinity()) return this;
  var A = this.z.redSqr(), G = this.x, J = I.x.redMul(A), _e = this.y, H = I.y.redMul(A).redMul(this.z), De = G.redSub(J), Ie = _e.redSub(H);
  if (De.cmpn(0) === 0) return Ie.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var qe = De.redSqr(), Te = qe.redMul(De), Ee = G.redMul(qe), Oe = Ie.redSqr().redIAdd(Te).redISub(Ee).redISub(Ee), Le = Ie.redMul(Ee.redISub(Oe)).redISub(_e.redMul(Te)), ke = this.z.redMul(De);
  return this.curve.jpoint(Oe, Le, ke);
}, Ft.prototype.dblp = function(I) {
  if (I === 0) return this;
  if (this.isInfinity()) return this;
  if (!I) return this.dbl();
  var A;
  if (this.curve.zeroA || this.curve.threeA) {
    var G = this;
    for (A = 0; A < I; A++) G = G.dbl();
    return G;
  }
  var J = this.curve.a, _e = this.curve.tinv, H = this.x, De = this.y, Ie = this.z, qe = Ie.redSqr().redSqr(), Te = De.redAdd(De);
  for (A = 0; A < I; A++) {
    var Ee = H.redSqr(), Oe = Te.redSqr(), Le = Oe.redSqr(), ke = Ee.redAdd(Ee).redIAdd(Ee).redIAdd(J.redMul(qe)), Fe = H.redMul(Oe), Ge = ke.redSqr().redISub(Fe.redAdd(Fe)), et = Fe.redISub(Ge), Ve = ke.redMul(et);
    Ve = Ve.redIAdd(Ve).redISub(Le);
    var Je = Te.redMul(Ie);
    A + 1 < I && (qe = qe.redMul(Le)), H = Ge, Ie = Je, Te = Ve;
  }
  return this.curve.jpoint(H, Te.redMul(_e), Ie);
}, Ft.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
}, Ft.prototype._zeroDbl = function() {
  var I, A, G;
  if (this.zOne) {
    var J = this.x.redSqr(), _e = this.y.redSqr(), H = _e.redSqr(), De = this.x.redAdd(_e).redSqr().redISub(J).redISub(H);
    De = De.redIAdd(De);
    var Ie = J.redAdd(J).redIAdd(J), qe = Ie.redSqr().redISub(De).redISub(De), Te = H.redIAdd(H);
    Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), I = qe, A = Ie.redMul(De.redISub(qe)).redISub(Te), G = this.y.redAdd(this.y);
  } else {
    var Ee = this.x.redSqr(), Oe = this.y.redSqr(), Le = Oe.redSqr(), ke = this.x.redAdd(Oe).redSqr().redISub(Ee).redISub(Le);
    ke = ke.redIAdd(ke);
    var Fe = Ee.redAdd(Ee).redIAdd(Ee), Ge = Fe.redSqr(), et = Le.redIAdd(Le);
    et = et.redIAdd(et), et = et.redIAdd(et), I = Ge.redISub(ke).redISub(ke), A = Fe.redMul(ke.redISub(I)).redISub(et), G = this.y.redMul(this.z), G = G.redIAdd(G);
  }
  return this.curve.jpoint(I, A, G);
}, Ft.prototype._threeDbl = function() {
  var I, A, G;
  if (this.zOne) {
    var J = this.x.redSqr(), _e = this.y.redSqr(), H = _e.redSqr(), De = this.x.redAdd(_e).redSqr().redISub(J).redISub(H);
    De = De.redIAdd(De);
    var Ie = J.redAdd(J).redIAdd(J).redIAdd(this.curve.a), qe = Ie.redSqr().redISub(De).redISub(De);
    I = qe;
    var Te = H.redIAdd(H);
    Te = Te.redIAdd(Te), Te = Te.redIAdd(Te), A = Ie.redMul(De.redISub(qe)).redISub(Te), G = this.y.redAdd(this.y);
  } else {
    var Ee = this.z.redSqr(), Oe = this.y.redSqr(), Le = this.x.redMul(Oe), ke = this.x.redSub(Ee).redMul(this.x.redAdd(Ee));
    ke = ke.redAdd(ke).redIAdd(ke);
    var Fe = Le.redIAdd(Le);
    Fe = Fe.redIAdd(Fe);
    var Ge = Fe.redAdd(Fe);
    I = ke.redSqr().redISub(Ge), G = this.y.redAdd(this.z).redSqr().redISub(Oe).redISub(Ee);
    var et = Oe.redSqr();
    et = et.redIAdd(et), et = et.redIAdd(et), et = et.redIAdd(et), A = ke.redMul(Fe.redISub(I)).redISub(et);
  }
  return this.curve.jpoint(I, A, G);
}, Ft.prototype._dbl = function() {
  var I = this.curve.a, A = this.x, G = this.y, J = this.z, _e = J.redSqr().redSqr(), H = A.redSqr(), De = G.redSqr(), Ie = H.redAdd(H).redIAdd(H).redIAdd(I.redMul(_e)), qe = A.redAdd(A);
  qe = qe.redIAdd(qe);
  var Te = qe.redMul(De), Ee = Ie.redSqr().redISub(Te.redAdd(Te)), Oe = Te.redISub(Ee), Le = De.redSqr();
  Le = Le.redIAdd(Le), Le = Le.redIAdd(Le), Le = Le.redIAdd(Le);
  var ke = Ie.redMul(Oe).redISub(Le), Fe = G.redAdd(G).redMul(J);
  return this.curve.jpoint(Ee, ke, Fe);
}, Ft.prototype.trpl = function() {
  if (!this.curve.zeroA) return this.dbl().add(this);
  var I = this.x.redSqr(), A = this.y.redSqr(), G = this.z.redSqr(), J = A.redSqr(), _e = I.redAdd(I).redIAdd(I), H = _e.redSqr(), De = this.x.redAdd(A).redSqr().redISub(I).redISub(J);
  De = De.redIAdd(De), De = De.redAdd(De).redIAdd(De), De = De.redISub(H);
  var Ie = De.redSqr(), qe = J.redIAdd(J);
  qe = qe.redIAdd(qe), qe = qe.redIAdd(qe), qe = qe.redIAdd(qe);
  var Te = _e.redIAdd(De).redSqr().redISub(H).redISub(Ie).redISub(qe), Ee = A.redMul(Te);
  Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee);
  var Oe = this.x.redMul(Ie).redISub(Ee);
  Oe = Oe.redIAdd(Oe), Oe = Oe.redIAdd(Oe);
  var Le = this.y.redMul(Te.redMul(qe.redISub(Te)).redISub(De.redMul(Ie)));
  Le = Le.redIAdd(Le), Le = Le.redIAdd(Le), Le = Le.redIAdd(Le);
  var ke = this.z.redAdd(De).redSqr().redISub(G).redISub(Ie);
  return this.curve.jpoint(Oe, Le, ke);
}, Ft.prototype.mul = function(I, A) {
  return I = new K(I, A), this.curve._wnafMul(this, I);
}, Ft.prototype.eq = function(I) {
  if (I.type === "affine") return this.eq(I.toJ());
  if (this === I) return !0;
  var A = this.z.redSqr(), G = I.z.redSqr();
  if (this.x.redMul(G).redISub(I.x.redMul(A)).cmpn(0) !== 0) return !1;
  var J = A.redMul(this.z), _e = G.redMul(I.z);
  return this.y.redMul(_e).redISub(I.y.redMul(J)).cmpn(0) === 0;
}, Ft.prototype.eqXToP = function(I) {
  var A = this.z.redSqr(), G = I.toRed(this.curve.red).redMul(A);
  if (this.x.cmp(G) === 0) return !0;
  for (var J = I.clone(), _e = this.curve.redN.redMul(A); ; ) {
    if (J.iadd(this.curve.n), J.cmp(this.curve.p) >= 0) return !1;
    if (G.redIAdd(_e), this.x.cmp(G) === 0) return !0;
  }
}, Ft.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
}, Ft.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var zr = lr$1(function(I, A) {
  var G = A;
  G.base = $e, G.short = Va, G.mont = null, G.edwards = null;
}), jr = lr$1(function(I, A) {
  var G = A, J = Gt.assert;
  function _e(Ie) {
    Ie.type === "short" ? this.curve = new zr.short(Ie) : Ie.type === "edwards" ? this.curve = new zr.edwards(Ie) : this.curve = new zr.mont(Ie), this.g = this.curve.g, this.n = this.curve.n, this.hash = Ie.hash, J(this.g.validate(), "Invalid curve"), J(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  G.PresetCurve = _e;
  function H(Ie, qe) {
    Object.defineProperty(G, Ie, { configurable: !0, enumerable: !0, get: function() {
      var Te = new _e(qe);
      return Object.defineProperty(G, Ie, { configurable: !0, enumerable: !0, value: Te }), Te;
    } });
  }
  H("p192", { type: "short", prime: "p192", p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff", a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc", b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1", n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831", hash: se.sha256, gRed: !1, g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"] }), H("p224", { type: "short", prime: "p224", p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001", a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe", b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4", n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d", hash: se.sha256, gRed: !1, g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"] }), H("p256", { type: "short", prime: null, p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff", a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc", b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b", n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551", hash: se.sha256, gRed: !1, g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"] }), H("p384", { type: "short", prime: null, p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff", a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc", b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef", n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973", hash: se.sha384, gRed: !1, g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"] }), H("p521", { type: "short", prime: null, p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff", a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc", b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00", n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409", hash: se.sha512, gRed: !1, g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"] }), H("curve25519", { type: "mont", prime: "p25519", p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed", a: "76d06", b: "1", n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed", hash: se.sha256, gRed: !1, g: ["9"] }), H("ed25519", { type: "edwards", prime: "p25519", p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed", a: "-1", c: "1", d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3", n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed", hash: se.sha256, gRed: !1, g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"] });
  var De;
  try {
    De = null.crash();
  } catch {
    De = void 0;
  }
  H("secp256k1", { type: "short", prime: "k256", p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f", a: "0", b: "7", n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141", h: "1", hash: se.sha256, beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee", lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72", basis: [{ a: "3086d221a7d46bcde86c90e49284eb15", b: "-e4437ed6010e88286f547fa90abfe4c3" }, { a: "114ca50f7a8e2f3f657c1108d9d44cfd8", b: "3086d221a7d46bcde86c90e49284eb15" }], gRed: !1, g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", De] });
});
function Re(I) {
  if (!(this instanceof Re)) return new Re(I);
  this.hash = I.hash, this.predResist = !!I.predResist, this.outLen = this.hash.outSize, this.minEntropy = I.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var A = fe.toArray(I.entropy, I.entropyEnc || "hex"), G = fe.toArray(I.nonce, I.nonceEnc || "hex"), J = fe.toArray(I.pers, I.persEnc || "hex");
  qi$1(A.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(A, G, J);
}
var qf = Re;
Re.prototype._init = function(I, A, G) {
  var J = I.concat(A).concat(G);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var _e = 0; _e < this.V.length; _e++) this.K[_e] = 0, this.V[_e] = 1;
  this._update(J), this._reseed = 1, this.reseedInterval = 281474976710656;
}, Re.prototype._hmac = function() {
  return new se.hmac(this.hash, this.K);
}, Re.prototype._update = function(I) {
  var A = this._hmac().update(this.V).update([0]);
  I && (A = A.update(I)), this.K = A.digest(), this.V = this._hmac().update(this.V).digest(), I && (this.K = this._hmac().update(this.V).update([1]).update(I).digest(), this.V = this._hmac().update(this.V).digest());
}, Re.prototype.reseed = function(I, A, G, J) {
  typeof A != "string" && (J = G, G = A, A = null), I = fe.toArray(I, A), G = fe.toArray(G, J), qi$1(I.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(I.concat(G || [])), this._reseed = 1;
}, Re.prototype.generate = function(I, A, G, J) {
  if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
  typeof A != "string" && (J = G, G = A, A = null), G && (G = fe.toArray(G, J || "hex"), this._update(G));
  for (var _e = []; _e.length < I; ) this.V = this._hmac().update(this.V).digest(), _e = _e.concat(this.V);
  var H = _e.slice(0, I);
  return this._update(G), this._reseed++, fe.encode(H, A);
};
var Hi = Gt.assert;
function kt(I, A) {
  this.ec = I, this.priv = null, this.pub = null, A.priv && this._importPrivate(A.priv, A.privEnc), A.pub && this._importPublic(A.pub, A.pubEnc);
}
var Li = kt;
kt.fromPublic = function(I, A, G) {
  return A instanceof kt ? A : new kt(I, { pub: A, pubEnc: G });
}, kt.fromPrivate = function(I, A, G) {
  return A instanceof kt ? A : new kt(I, { priv: A, privEnc: G });
}, kt.prototype.validate = function() {
  var I = this.getPublic();
  return I.isInfinity() ? { result: !1, reason: "Invalid public key" } : I.validate() ? I.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
}, kt.prototype.getPublic = function(I, A) {
  return typeof I == "string" && (A = I, I = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), A ? this.pub.encode(A, I) : this.pub;
}, kt.prototype.getPrivate = function(I) {
  return I === "hex" ? this.priv.toString(16, 2) : this.priv;
}, kt.prototype._importPrivate = function(I, A) {
  this.priv = new K(I, A || 16), this.priv = this.priv.umod(this.ec.curve.n);
}, kt.prototype._importPublic = function(I, A) {
  if (I.x || I.y) {
    this.ec.curve.type === "mont" ? Hi(I.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && Hi(I.x && I.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(I.x, I.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(I, A);
}, kt.prototype.derive = function(I) {
  return I.validate() || Hi(I.validate(), "public point not validated"), I.mul(this.priv).getX();
}, kt.prototype.sign = function(I, A, G) {
  return this.ec.sign(I, this, A, G);
}, kt.prototype.verify = function(I, A) {
  return this.ec.verify(I, A, this);
}, kt.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var Wa$1 = Gt.assert;
function Qr(I, A) {
  if (I instanceof Qr) return I;
  this._importDER(I, A) || (Wa$1(I.r && I.s, "Signature without r or s"), this.r = new K(I.r, 16), this.s = new K(I.s, 16), I.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = I.recoveryParam);
}
var Jr = Qr;
function Xa() {
  this.place = 0;
}
function zi(I, A) {
  var G = I[A.place++];
  if (!(G & 128)) return G;
  var J = G & 15;
  if (J === 0 || J > 4) return !1;
  for (var _e = 0, H = 0, De = A.place; H < J; H++, De++) _e <<= 8, _e |= I[De], _e >>>= 0;
  return _e <= 127 ? !1 : (A.place = De, _e);
}
function Kf(I) {
  for (var A = 0, G = I.length - 1; !I[A] && !(I[A + 1] & 128) && A < G; ) A++;
  return A === 0 ? I : I.slice(A);
}
Qr.prototype._importDER = function(I, A) {
  I = Gt.toArray(I, A);
  var G = new Xa();
  if (I[G.place++] !== 48) return !1;
  var J = zi(I, G);
  if (J === !1 || J + G.place !== I.length || I[G.place++] !== 2) return !1;
  var _e = zi(I, G);
  if (_e === !1) return !1;
  var H = I.slice(G.place, _e + G.place);
  if (G.place += _e, I[G.place++] !== 2) return !1;
  var De = zi(I, G);
  if (De === !1 || I.length !== De + G.place) return !1;
  var Ie = I.slice(G.place, De + G.place);
  if (H[0] === 0) if (H[1] & 128) H = H.slice(1);
  else return !1;
  if (Ie[0] === 0) if (Ie[1] & 128) Ie = Ie.slice(1);
  else return !1;
  return this.r = new K(H), this.s = new K(Ie), this.recoveryParam = null, !0;
};
function ji(I, A) {
  if (A < 128) {
    I.push(A);
    return;
  }
  var G = 1 + (Math.log(A) / Math.LN2 >>> 3);
  for (I.push(G | 128); --G; ) I.push(A >>> (G << 3) & 255);
  I.push(A);
}
Qr.prototype.toDER = function(I) {
  var A = this.r.toArray(), G = this.s.toArray();
  for (A[0] & 128 && (A = [0].concat(A)), G[0] & 128 && (G = [0].concat(G)), A = Kf(A), G = Kf(G); !G[0] && !(G[1] & 128); ) G = G.slice(1);
  var J = [2];
  ji(J, A.length), J = J.concat(A), J.push(2), ji(J, G.length);
  var _e = J.concat(G), H = [48];
  return ji(H, _e.length), H = H.concat(_e), Gt.encode(H, I);
};
var $a$1 = function() {
  throw new Error("unsupported");
}, Hf = Gt.assert;
function ee(I) {
  if (!(this instanceof ee)) return new ee(I);
  typeof I == "string" && (Hf(Object.prototype.hasOwnProperty.call(jr, I), "Unknown curve " + I), I = jr[I]), I instanceof jr.PresetCurve && (I = { curve: I }), this.curve = I.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = I.curve.g, this.g.precompute(I.curve.n.bitLength() + 1), this.hash = I.hash || I.curve.hash;
}
var Za = ee;
ee.prototype.keyPair = function(I) {
  return new Li(this, I);
}, ee.prototype.keyFromPrivate = function(I, A) {
  return Li.fromPrivate(this, I, A);
}, ee.prototype.keyFromPublic = function(I, A) {
  return Li.fromPublic(this, I, A);
}, ee.prototype.genKeyPair = function(I) {
  I || (I = {});
  for (var A = new qf({ hash: this.hash, pers: I.pers, persEnc: I.persEnc || "utf8", entropy: I.entropy || $a$1(this.hash.hmacStrength), entropyEnc: I.entropy && I.entropyEnc || "utf8", nonce: this.n.toArray() }), G = this.n.byteLength(), J = this.n.sub(new K(2)); ; ) {
    var _e = new K(A.generate(G));
    if (!(_e.cmp(J) > 0)) return _e.iaddn(1), this.keyFromPrivate(_e);
  }
}, ee.prototype._truncateToN = function(I, A) {
  var G = I.byteLength() * 8 - this.n.bitLength();
  return G > 0 && (I = I.ushrn(G)), !A && I.cmp(this.n) >= 0 ? I.sub(this.n) : I;
}, ee.prototype.sign = function(I, A, G, J) {
  typeof G == "object" && (J = G, G = null), J || (J = {}), A = this.keyFromPrivate(A, G), I = this._truncateToN(new K(I, 16));
  for (var _e = this.n.byteLength(), H = A.getPrivate().toArray("be", _e), De = I.toArray("be", _e), Ie = new qf({ hash: this.hash, entropy: H, nonce: De, pers: J.pers, persEnc: J.persEnc || "utf8" }), qe = this.n.sub(new K(1)), Te = 0; ; Te++) {
    var Ee = J.k ? J.k(Te) : new K(Ie.generate(this.n.byteLength()));
    if (Ee = this._truncateToN(Ee, !0), !(Ee.cmpn(1) <= 0 || Ee.cmp(qe) >= 0)) {
      var Oe = this.g.mul(Ee);
      if (!Oe.isInfinity()) {
        var Le = Oe.getX(), ke = Le.umod(this.n);
        if (ke.cmpn(0) !== 0) {
          var Fe = Ee.invm(this.n).mul(ke.mul(A.getPrivate()).iadd(I));
          if (Fe = Fe.umod(this.n), Fe.cmpn(0) !== 0) {
            var Ge = (Oe.getY().isOdd() ? 1 : 0) | (Le.cmp(ke) !== 0 ? 2 : 0);
            return J.canonical && Fe.cmp(this.nh) > 0 && (Fe = this.n.sub(Fe), Ge ^= 1), new Jr({ r: ke, s: Fe, recoveryParam: Ge });
          }
        }
      }
    }
  }
}, ee.prototype.verify = function(I, A, G, J) {
  I = this._truncateToN(new K(I, 16)), G = this.keyFromPublic(G, J), A = new Jr(A, "hex");
  var _e = A.r, H = A.s;
  if (_e.cmpn(1) < 0 || _e.cmp(this.n) >= 0 || H.cmpn(1) < 0 || H.cmp(this.n) >= 0) return !1;
  var De = H.invm(this.n), Ie = De.mul(I).umod(this.n), qe = De.mul(_e).umod(this.n), Te;
  return this.curve._maxwellTrick ? (Te = this.g.jmulAdd(Ie, G.getPublic(), qe), Te.isInfinity() ? !1 : Te.eqXToP(_e)) : (Te = this.g.mulAdd(Ie, G.getPublic(), qe), Te.isInfinity() ? !1 : Te.getX().umod(this.n).cmp(_e) === 0);
}, ee.prototype.recoverPubKey = function(I, A, G, J) {
  Hf((3 & G) === G, "The recovery param is more than two bits"), A = new Jr(A, J);
  var _e = this.n, H = new K(I), De = A.r, Ie = A.s, qe = G & 1, Te = G >> 1;
  if (De.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Te) throw new Error("Unable to find sencond key candinate");
  Te ? De = this.curve.pointFromX(De.add(this.curve.n), qe) : De = this.curve.pointFromX(De, qe);
  var Ee = A.r.invm(_e), Oe = _e.sub(H).mul(Ee).umod(_e), Le = Ie.mul(Ee).umod(_e);
  return this.g.mulAdd(Oe, De, Le);
}, ee.prototype.getKeyRecoveryParam = function(I, A, G, J) {
  if (A = new Jr(A, J), A.recoveryParam !== null) return A.recoveryParam;
  for (var _e = 0; _e < 4; _e++) {
    var H;
    try {
      H = this.recoverPubKey(I, A, _e);
    } catch {
      continue;
    }
    if (H.eq(G)) return _e;
  }
  throw new Error("Unable to find valid recovery factor");
};
var tu = lr$1(function(I, A) {
  var G = A;
  G.version = "6.5.4", G.utils = Gt, G.rand = function() {
    throw new Error("unsupported");
  }, G.curve = zr, G.curves = jr, G.ec = Za, G.eddsa = null;
});
tu.ec;
var zf;
(function(I) {
  I[I.legacy = 0] = "legacy", I[I.eip2930 = 1] = "eip2930", I[I.eip1559 = 2] = "eip1559";
})(zf || (zf = {}));
function on(I) {
  return I.includes(":");
}
function xo(I) {
  return on(I) ? I.split(":")[0] : I;
}
const Eo = { INVALID_METHOD: { message: "Invalid method.", code: 1001 }, INVALID_EVENT: { message: "Invalid event.", code: 1002 }, INVALID_UPDATE_REQUEST: { message: "Invalid update request.", code: 1003 }, INVALID_EXTEND_REQUEST: { message: "Invalid extend request.", code: 1004 }, INVALID_SESSION_SETTLE_REQUEST: { message: "Invalid session settle request.", code: 1005 }, UNAUTHORIZED_METHOD: { message: "Unauthorized method.", code: 3001 }, UNAUTHORIZED_EVENT: { message: "Unauthorized event.", code: 3002 }, UNAUTHORIZED_UPDATE_REQUEST: { message: "Unauthorized update request.", code: 3003 }, UNAUTHORIZED_EXTEND_REQUEST: { message: "Unauthorized extend request.", code: 3004 }, USER_REJECTED: { message: "User rejected.", code: 5e3 }, USER_REJECTED_CHAINS: { message: "User rejected chains.", code: 5001 }, USER_REJECTED_METHODS: { message: "User rejected methods.", code: 5002 }, USER_REJECTED_EVENTS: { message: "User rejected events.", code: 5003 }, UNSUPPORTED_CHAINS: { message: "Unsupported chains.", code: 5100 }, UNSUPPORTED_METHODS: { message: "Unsupported methods.", code: 5101 }, UNSUPPORTED_EVENTS: { message: "Unsupported events.", code: 5102 }, UNSUPPORTED_ACCOUNTS: { message: "Unsupported accounts.", code: 5103 }, UNSUPPORTED_NAMESPACE_KEY: { message: "Unsupported namespace key.", code: 5104 }, USER_DISCONNECTED: { message: "User disconnected.", code: 6e3 }, SESSION_SETTLEMENT_FAILED: { message: "Session settlement failed.", code: 7e3 }, WC_METHOD_UNSUPPORTED: { message: "Unsupported wc_ method.", code: 10001 } };
function er(I, A) {
  const { message: G, code: J } = Eo[I];
  return { message: G, code: J };
}
function Nr(I, A) {
  return !!Array.isArray(I);
}
function Xr(I) {
  return Object.getPrototypeOf(I) === Object.prototype && Object.keys(I).length;
}
function tryStringify(I) {
  try {
    return JSON.stringify(I);
  } catch {
    return '"[Circular]"';
  }
}
var quickFormatUnescaped = format$1;
function format$1(I, A, G) {
  var J = G && G.stringify || tryStringify, _e = 1;
  if (typeof I == "object" && I !== null) {
    var H = A.length + _e;
    if (H === 1) return I;
    var De = new Array(H);
    De[0] = J(I);
    for (var Ie = 1; Ie < H; Ie++)
      De[Ie] = J(A[Ie]);
    return De.join(" ");
  }
  if (typeof I != "string")
    return I;
  var qe = A.length;
  if (qe === 0) return I;
  for (var Te = "", Ee = 1 - _e, Oe = -1, Le = I && I.length || 0, ke = 0; ke < Le; ) {
    if (I.charCodeAt(ke) === 37 && ke + 1 < Le) {
      switch (Oe = Oe > -1 ? Oe : 0, I.charCodeAt(ke + 1)) {
        case 100:
        case 102:
          if (Ee >= qe || A[Ee] == null) break;
          Oe < ke && (Te += I.slice(Oe, ke)), Te += Number(A[Ee]), Oe = ke + 2, ke++;
          break;
        case 105:
          if (Ee >= qe || A[Ee] == null) break;
          Oe < ke && (Te += I.slice(Oe, ke)), Te += Math.floor(Number(A[Ee])), Oe = ke + 2, ke++;
          break;
        case 79:
        case 111:
        case 106:
          if (Ee >= qe || A[Ee] === void 0) break;
          Oe < ke && (Te += I.slice(Oe, ke));
          var Fe = typeof A[Ee];
          if (Fe === "string") {
            Te += "'" + A[Ee] + "'", Oe = ke + 2, ke++;
            break;
          }
          if (Fe === "function") {
            Te += A[Ee].name || "<anonymous>", Oe = ke + 2, ke++;
            break;
          }
          Te += J(A[Ee]), Oe = ke + 2, ke++;
          break;
        case 115:
          if (Ee >= qe)
            break;
          Oe < ke && (Te += I.slice(Oe, ke)), Te += String(A[Ee]), Oe = ke + 2, ke++;
          break;
        case 37:
          Oe < ke && (Te += I.slice(Oe, ke)), Te += "%", Oe = ke + 2, ke++, Ee--;
          break;
      }
      ++Ee;
    }
    ++ke;
  }
  return Oe === -1 ? I : (Oe < Le && (Te += I.slice(Oe)), Te);
}
const format = quickFormatUnescaped;
var browser = pino;
const _console = pfGlobalThisOrFallback().console || {}, stdSerializers = {
  mapHttpRequest: mock,
  mapHttpResponse: mock,
  wrapRequestSerializer: passthrough,
  wrapResponseSerializer: passthrough,
  wrapErrorSerializer: passthrough,
  req: mock,
  res: mock,
  err: asErrValue
};
function shouldSerialize(I, A) {
  return Array.isArray(I) ? I.filter(function(J) {
    return J !== "!stdSerializers.err";
  }) : I === !0 ? Object.keys(A) : !1;
}
function pino(I) {
  I = I || {}, I.browser = I.browser || {};
  const A = I.browser.transmit;
  if (A && typeof A.send != "function")
    throw Error("pino: transmit option must have a send function");
  const G = I.browser.write || _console;
  I.browser.write && (I.browser.asObject = !0);
  const J = I.serializers || {}, _e = shouldSerialize(I.browser.serialize, J);
  let H = I.browser.serialize;
  Array.isArray(I.browser.serialize) && I.browser.serialize.indexOf("!stdSerializers.err") > -1 && (H = !1);
  const De = ["error", "fatal", "warn", "info", "debug", "trace"];
  typeof G == "function" && (G.error = G.fatal = G.warn = G.info = G.debug = G.trace = G), I.enabled === !1 && (I.level = "silent");
  const Ie = I.level || "info", qe = Object.create(G);
  qe.log || (qe.log = noop), Object.defineProperty(qe, "levelVal", {
    get: Ee
  }), Object.defineProperty(qe, "level", {
    get: Oe,
    set: Le
  });
  const Te = {
    transmit: A,
    serialize: _e,
    asObject: I.browser.asObject,
    levels: De,
    timestamp: getTimeFunction(I)
  };
  qe.levels = pino.levels, qe.level = Ie, qe.setMaxListeners = qe.getMaxListeners = qe.emit = qe.addListener = qe.on = qe.prependListener = qe.once = qe.prependOnceListener = qe.removeListener = qe.removeAllListeners = qe.listeners = qe.listenerCount = qe.eventNames = qe.write = qe.flush = noop, qe.serializers = J, qe._serialize = _e, qe._stdErrSerialize = H, qe.child = ke, A && (qe._logEvent = createLogEventShape());
  function Ee() {
    return this.level === "silent" ? 1 / 0 : this.levels.values[this.level];
  }
  function Oe() {
    return this._level;
  }
  function Le(Fe) {
    if (Fe !== "silent" && !this.levels.values[Fe])
      throw Error("unknown level " + Fe);
    this._level = Fe, set(Te, qe, "error", "log"), set(Te, qe, "fatal", "error"), set(Te, qe, "warn", "error"), set(Te, qe, "info", "log"), set(Te, qe, "debug", "log"), set(Te, qe, "trace", "log");
  }
  function ke(Fe, Ge) {
    if (!Fe)
      throw new Error("missing bindings for child Pino");
    Ge = Ge || {}, _e && Fe.serializers && (Ge.serializers = Fe.serializers);
    const et = Ge.serializers;
    if (_e && et) {
      var Ve = Object.assign({}, J, et), Je = I.browser.serialize === !0 ? Object.keys(Ve) : _e;
      delete Fe.serializers, applySerializers([Fe], Je, Ve, this._stdErrSerialize);
    }
    function ut(rt) {
      this._childLevel = (rt._childLevel | 0) + 1, this.error = bind(rt, Fe, "error"), this.fatal = bind(rt, Fe, "fatal"), this.warn = bind(rt, Fe, "warn"), this.info = bind(rt, Fe, "info"), this.debug = bind(rt, Fe, "debug"), this.trace = bind(rt, Fe, "trace"), Ve && (this.serializers = Ve, this._serialize = Je), A && (this._logEvent = createLogEventShape(
        [].concat(rt._logEvent.bindings, Fe)
      ));
    }
    return ut.prototype = this, new ut(this);
  }
  return qe;
}
pino.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
pino.stdSerializers = stdSerializers;
pino.stdTimeFunctions = Object.assign({}, { nullTime, epochTime, unixTime, isoTime });
function set(I, A, G, J) {
  const _e = Object.getPrototypeOf(A);
  A[G] = A.levelVal > A.levels.values[G] ? noop : _e[G] ? _e[G] : _console[G] || _console[J] || noop, wrap(I, A, G);
}
function wrap(I, A, G) {
  !I.transmit && A[G] === noop || (A[G] = /* @__PURE__ */ function(J) {
    return function() {
      const H = I.timestamp(), De = new Array(arguments.length), Ie = Object.getPrototypeOf && Object.getPrototypeOf(this) === _console ? _console : this;
      for (var qe = 0; qe < De.length; qe++) De[qe] = arguments[qe];
      if (I.serialize && !I.asObject && applySerializers(De, this._serialize, this.serializers, this._stdErrSerialize), I.asObject ? J.call(Ie, asObject(this, G, De, H)) : J.apply(Ie, De), I.transmit) {
        const Te = I.transmit.level || A.level, Ee = pino.levels.values[Te], Oe = pino.levels.values[G];
        if (Oe < Ee) return;
        transmit(this, {
          ts: H,
          methodLevel: G,
          methodValue: Oe,
          transmitLevel: Te,
          transmitValue: pino.levels.values[I.transmit.level || A.level],
          send: I.transmit.send,
          val: A.levelVal
        }, De);
      }
    };
  }(A[G]));
}
function asObject(I, A, G, J) {
  I._serialize && applySerializers(G, I._serialize, I.serializers, I._stdErrSerialize);
  const _e = G.slice();
  let H = _e[0];
  const De = {};
  J && (De.time = J), De.level = pino.levels.values[A];
  let Ie = (I._childLevel | 0) + 1;
  if (Ie < 1 && (Ie = 1), H !== null && typeof H == "object") {
    for (; Ie-- && typeof _e[0] == "object"; )
      Object.assign(De, _e.shift());
    H = _e.length ? format(_e.shift(), _e) : void 0;
  } else typeof H == "string" && (H = format(_e.shift(), _e));
  return H !== void 0 && (De.msg = H), De;
}
function applySerializers(I, A, G, J) {
  for (const _e in I)
    if (J && I[_e] instanceof Error)
      I[_e] = pino.stdSerializers.err(I[_e]);
    else if (typeof I[_e] == "object" && !Array.isArray(I[_e]))
      for (const H in I[_e])
        A && A.indexOf(H) > -1 && H in G && (I[_e][H] = G[H](I[_e][H]));
}
function bind(I, A, G) {
  return function() {
    const J = new Array(1 + arguments.length);
    J[0] = A;
    for (var _e = 1; _e < J.length; _e++)
      J[_e] = arguments[_e - 1];
    return I[G].apply(this, J);
  };
}
function transmit(I, A, G) {
  const J = A.send, _e = A.ts, H = A.methodLevel, De = A.methodValue, Ie = A.val, qe = I._logEvent.bindings;
  applySerializers(
    G,
    I._serialize || Object.keys(I.serializers),
    I.serializers,
    I._stdErrSerialize === void 0 ? !0 : I._stdErrSerialize
  ), I._logEvent.ts = _e, I._logEvent.messages = G.filter(function(Te) {
    return qe.indexOf(Te) === -1;
  }), I._logEvent.level.label = H, I._logEvent.level.value = De, J(H, I._logEvent, Ie), I._logEvent = createLogEventShape(qe);
}
function createLogEventShape(I) {
  return {
    ts: 0,
    messages: [],
    bindings: I || [],
    level: { label: "", value: 0 }
  };
}
function asErrValue(I) {
  const A = {
    type: I.constructor.name,
    msg: I.message,
    stack: I.stack
  };
  for (const G in I)
    A[G] === void 0 && (A[G] = I[G]);
  return A;
}
function getTimeFunction(I) {
  return typeof I.timestamp == "function" ? I.timestamp : I.timestamp === !1 ? nullTime : epochTime;
}
function mock() {
  return {};
}
function passthrough(I) {
  return I;
}
function noop() {
}
function nullTime() {
  return !1;
}
function epochTime() {
  return Date.now();
}
function unixTime() {
  return Math.round(Date.now() / 1e3);
}
function isoTime() {
  return new Date(Date.now()).toISOString();
}
function pfGlobalThisOrFallback() {
  function I(A) {
    return typeof A < "u" && A;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return I(self) || I(window) || I(this) || {};
  }
}
const Mg = /* @__PURE__ */ getDefaultExportFromCjs(browser), c$1 = { level: "info" };
var x$1 = Object.defineProperty, S = Object.defineProperties, _ = Object.getOwnPropertyDescriptors, p$2 = Object.getOwnPropertySymbols, T$2 = Object.prototype.hasOwnProperty, z = Object.prototype.propertyIsEnumerable, f$1 = (I, A, G) => A in I ? x$1(I, A, { enumerable: !0, configurable: !0, writable: !0, value: G }) : I[A] = G, i = (I, A) => {
  for (var G in A || (A = {})) T$2.call(A, G) && f$1(I, G, A[G]);
  if (p$2) for (var G of p$2(A)) z.call(A, G) && f$1(I, G, A[G]);
  return I;
}, g$2 = (I, A) => S(I, _(A));
function k(I) {
  return g$2(i({}, I), { level: (I == null ? void 0 : I.level) || c$1.level });
}
var browserPonyfill = { exports: {} };
(function(I, A) {
  var G = typeof self < "u" ? self : commonjsGlobal, J = function() {
    function H() {
      this.fetch = !1, this.DOMException = G.DOMException;
    }
    return H.prototype = G, new H();
  }();
  (function(H) {
    (function(De) {
      var Ie = {
        searchParams: "URLSearchParams" in H,
        iterable: "Symbol" in H && "iterator" in Symbol,
        blob: "FileReader" in H && "Blob" in H && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in H,
        arrayBuffer: "ArrayBuffer" in H
      };
      function qe(B) {
        return B && DataView.prototype.isPrototypeOf(B);
      }
      if (Ie.arrayBuffer)
        var Te = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], Ee = ArrayBuffer.isView || function(B) {
          return B && Te.indexOf(Object.prototype.toString.call(B)) > -1;
        };
      function Oe(B) {
        if (typeof B != "string" && (B = String(B)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(B))
          throw new TypeError("Invalid character in header field name");
        return B.toLowerCase();
      }
      function Le(B) {
        return typeof B != "string" && (B = String(B)), B;
      }
      function ke(B) {
        var Z = {
          next: function() {
            var ve = B.shift();
            return { done: ve === void 0, value: ve };
          }
        };
        return Ie.iterable && (Z[Symbol.iterator] = function() {
          return Z;
        }), Z;
      }
      function Fe(B) {
        this.map = {}, B instanceof Fe ? B.forEach(function(Z, ve) {
          this.append(ve, Z);
        }, this) : Array.isArray(B) ? B.forEach(function(Z) {
          this.append(Z[0], Z[1]);
        }, this) : B && Object.getOwnPropertyNames(B).forEach(function(Z) {
          this.append(Z, B[Z]);
        }, this);
      }
      Fe.prototype.append = function(B, Z) {
        B = Oe(B), Z = Le(Z);
        var ve = this.map[B];
        this.map[B] = ve ? ve + ", " + Z : Z;
      }, Fe.prototype.delete = function(B) {
        delete this.map[Oe(B)];
      }, Fe.prototype.get = function(B) {
        return B = Oe(B), this.has(B) ? this.map[B] : null;
      }, Fe.prototype.has = function(B) {
        return this.map.hasOwnProperty(Oe(B));
      }, Fe.prototype.set = function(B, Z) {
        this.map[Oe(B)] = Le(Z);
      }, Fe.prototype.forEach = function(B, Z) {
        for (var ve in this.map)
          this.map.hasOwnProperty(ve) && B.call(Z, this.map[ve], ve, this);
      }, Fe.prototype.keys = function() {
        var B = [];
        return this.forEach(function(Z, ve) {
          B.push(ve);
        }), ke(B);
      }, Fe.prototype.values = function() {
        var B = [];
        return this.forEach(function(Z) {
          B.push(Z);
        }), ke(B);
      }, Fe.prototype.entries = function() {
        var B = [];
        return this.forEach(function(Z, ve) {
          B.push([ve, Z]);
        }), ke(B);
      }, Ie.iterable && (Fe.prototype[Symbol.iterator] = Fe.prototype.entries);
      function Ge(B) {
        if (B.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        B.bodyUsed = !0;
      }
      function et(B) {
        return new Promise(function(Z, ve) {
          B.onload = function() {
            Z(B.result);
          }, B.onerror = function() {
            ve(B.error);
          };
        });
      }
      function Ve(B) {
        var Z = new FileReader(), ve = et(Z);
        return Z.readAsArrayBuffer(B), ve;
      }
      function Je(B) {
        var Z = new FileReader(), ve = et(Z);
        return Z.readAsText(B), ve;
      }
      function ut(B) {
        for (var Z = new Uint8Array(B), ve = new Array(Z.length), ge = 0; ge < Z.length; ge++)
          ve[ge] = String.fromCharCode(Z[ge]);
        return ve.join("");
      }
      function rt(B) {
        if (B.slice)
          return B.slice(0);
        var Z = new Uint8Array(B.byteLength);
        return Z.set(new Uint8Array(B)), Z.buffer;
      }
      function lt() {
        return this.bodyUsed = !1, this._initBody = function(B) {
          this._bodyInit = B, B ? typeof B == "string" ? this._bodyText = B : Ie.blob && Blob.prototype.isPrototypeOf(B) ? this._bodyBlob = B : Ie.formData && FormData.prototype.isPrototypeOf(B) ? this._bodyFormData = B : Ie.searchParams && URLSearchParams.prototype.isPrototypeOf(B) ? this._bodyText = B.toString() : Ie.arrayBuffer && Ie.blob && qe(B) ? (this._bodyArrayBuffer = rt(B.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : Ie.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(B) || Ee(B)) ? this._bodyArrayBuffer = rt(B) : this._bodyText = B = Object.prototype.toString.call(B) : this._bodyText = "", this.headers.get("content-type") || (typeof B == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : Ie.searchParams && URLSearchParams.prototype.isPrototypeOf(B) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, Ie.blob && (this.blob = function() {
          var B = Ge(this);
          if (B)
            return B;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? Ge(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(Ve);
        }), this.text = function() {
          var B = Ge(this);
          if (B)
            return B;
          if (this._bodyBlob)
            return Je(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(ut(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, Ie.formData && (this.formData = function() {
          return this.text().then(bt);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var vt = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function Ye(B) {
        var Z = B.toUpperCase();
        return vt.indexOf(Z) > -1 ? Z : B;
      }
      function pt(B, Z) {
        Z = Z || {};
        var ve = Z.body;
        if (B instanceof pt) {
          if (B.bodyUsed)
            throw new TypeError("Already read");
          this.url = B.url, this.credentials = B.credentials, Z.headers || (this.headers = new Fe(B.headers)), this.method = B.method, this.mode = B.mode, this.signal = B.signal, !ve && B._bodyInit != null && (ve = B._bodyInit, B.bodyUsed = !0);
        } else
          this.url = String(B);
        if (this.credentials = Z.credentials || this.credentials || "same-origin", (Z.headers || !this.headers) && (this.headers = new Fe(Z.headers)), this.method = Ye(Z.method || this.method || "GET"), this.mode = Z.mode || this.mode || null, this.signal = Z.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && ve)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(ve);
      }
      pt.prototype.clone = function() {
        return new pt(this, { body: this._bodyInit });
      };
      function bt(B) {
        var Z = new FormData();
        return B.trim().split("&").forEach(function(ve) {
          if (ve) {
            var ge = ve.split("="), xe = ge.shift().replace(/\+/g, " "), X = ge.join("=").replace(/\+/g, " ");
            Z.append(decodeURIComponent(xe), decodeURIComponent(X));
          }
        }), Z;
      }
      function Yt(B) {
        var Z = new Fe(), ve = B.replace(/\r?\n[\t ]+/g, " ");
        return ve.split(/\r?\n/).forEach(function(ge) {
          var xe = ge.split(":"), X = xe.shift().trim();
          if (X) {
            var a = xe.join(":").trim();
            Z.append(X, a);
          }
        }), Z;
      }
      lt.call(pt.prototype);
      function Se(B, Z) {
        Z || (Z = {}), this.type = "default", this.status = Z.status === void 0 ? 200 : Z.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in Z ? Z.statusText : "OK", this.headers = new Fe(Z.headers), this.url = Z.url || "", this._initBody(B);
      }
      lt.call(Se.prototype), Se.prototype.clone = function() {
        return new Se(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Fe(this.headers),
          url: this.url
        });
      }, Se.error = function() {
        var B = new Se(null, { status: 0, statusText: "" });
        return B.type = "error", B;
      };
      var t = [301, 302, 303, 307, 308];
      Se.redirect = function(B, Z) {
        if (t.indexOf(Z) === -1)
          throw new RangeError("Invalid status code");
        return new Se(null, { status: Z, headers: { location: B } });
      }, De.DOMException = H.DOMException;
      try {
        new De.DOMException();
      } catch {
        De.DOMException = function(Z, ve) {
          this.message = Z, this.name = ve;
          var ge = Error(Z);
          this.stack = ge.stack;
        }, De.DOMException.prototype = Object.create(Error.prototype), De.DOMException.prototype.constructor = De.DOMException;
      }
      function h(B, Z) {
        return new Promise(function(ve, ge) {
          var xe = new pt(B, Z);
          if (xe.signal && xe.signal.aborted)
            return ge(new De.DOMException("Aborted", "AbortError"));
          var X = new XMLHttpRequest();
          function a() {
            X.abort();
          }
          X.onload = function() {
            var Y = {
              status: X.status,
              statusText: X.statusText,
              headers: Yt(X.getAllResponseHeaders() || "")
            };
            Y.url = "responseURL" in X ? X.responseURL : Y.headers.get("X-Request-URL");
            var Ne = "response" in X ? X.response : X.responseText;
            ve(new Se(Ne, Y));
          }, X.onerror = function() {
            ge(new TypeError("Network request failed"));
          }, X.ontimeout = function() {
            ge(new TypeError("Network request failed"));
          }, X.onabort = function() {
            ge(new De.DOMException("Aborted", "AbortError"));
          }, X.open(xe.method, xe.url, !0), xe.credentials === "include" ? X.withCredentials = !0 : xe.credentials === "omit" && (X.withCredentials = !1), "responseType" in X && Ie.blob && (X.responseType = "blob"), xe.headers.forEach(function(Y, Ne) {
            X.setRequestHeader(Ne, Y);
          }), xe.signal && (xe.signal.addEventListener("abort", a), X.onreadystatechange = function() {
            X.readyState === 4 && xe.signal.removeEventListener("abort", a);
          }), X.send(typeof xe._bodyInit > "u" ? null : xe._bodyInit);
        });
      }
      return h.polyfill = !0, H.fetch || (H.fetch = h, H.Headers = Fe, H.Request = pt, H.Response = Se), De.Headers = Fe, De.Request = pt, De.Response = Se, De.fetch = h, Object.defineProperty(De, "__esModule", { value: !0 }), De;
    })({});
  })(J), J.fetch.ponyfill = !0, delete J.fetch.polyfill;
  var _e = J;
  A = _e.fetch, A.default = _e.fetch, A.fetch = _e.fetch, A.Headers = _e.Headers, A.Request = _e.Request, A.Response = _e.Response, I.exports = A;
})(browserPonyfill, browserPonyfill.exports);
var browserPonyfillExports = browserPonyfill.exports;
const o$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserPonyfillExports), PARSE_ERROR = "PARSE_ERROR", INVALID_REQUEST = "INVALID_REQUEST", METHOD_NOT_FOUND = "METHOD_NOT_FOUND", INVALID_PARAMS = "INVALID_PARAMS", INTERNAL_ERROR = "INTERNAL_ERROR", SERVER_ERROR = "SERVER_ERROR", RESERVED_ERROR_CODES = [-32700, -32600, -32601, -32602, -32603], STANDARD_ERROR_MAP = {
  [PARSE_ERROR]: { code: -32700, message: "Parse error" },
  [INVALID_REQUEST]: { code: -32600, message: "Invalid Request" },
  [METHOD_NOT_FOUND]: { code: -32601, message: "Method not found" },
  [INVALID_PARAMS]: { code: -32602, message: "Invalid params" },
  [INTERNAL_ERROR]: { code: -32603, message: "Internal error" },
  [SERVER_ERROR]: { code: -32e3, message: "Server error" }
}, DEFAULT_ERROR = SERVER_ERROR;
function isReservedErrorCode(I) {
  return RESERVED_ERROR_CODES.includes(I);
}
function getError(I) {
  return Object.keys(STANDARD_ERROR_MAP).includes(I) ? STANDARD_ERROR_MAP[I] : STANDARD_ERROR_MAP[DEFAULT_ERROR];
}
function getErrorByCode(I) {
  const A = Object.values(STANDARD_ERROR_MAP).find((G) => G.code === I);
  return A || STANDARD_ERROR_MAP[DEFAULT_ERROR];
}
function parseConnectionError(I, A, G) {
  return I.message.includes("getaddrinfo ENOTFOUND") || I.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${G} RPC url at ${A}`) : I;
}
var cjs = {}, crypto$1 = {}, hasRequiredCrypto;
function requireCrypto() {
  if (hasRequiredCrypto) return crypto$1;
  hasRequiredCrypto = 1, Object.defineProperty(crypto$1, "__esModule", { value: !0 }), crypto$1.isBrowserCryptoAvailable = crypto$1.getSubtleCrypto = crypto$1.getBrowerCrypto = void 0;
  function I() {
    return (commonjsGlobal === null || commonjsGlobal === void 0 ? void 0 : commonjsGlobal.crypto) || (commonjsGlobal === null || commonjsGlobal === void 0 ? void 0 : commonjsGlobal.msCrypto) || {};
  }
  crypto$1.getBrowerCrypto = I;
  function A() {
    const J = I();
    return J.subtle || J.webkitSubtle;
  }
  crypto$1.getSubtleCrypto = A;
  function G() {
    return !!I() && !!A();
  }
  return crypto$1.isBrowserCryptoAvailable = G, crypto$1;
}
var env = {}, hasRequiredEnv;
function requireEnv() {
  if (hasRequiredEnv) return env;
  hasRequiredEnv = 1, Object.defineProperty(env, "__esModule", { value: !0 }), env.isBrowser = env.isNode = env.isReactNative = void 0;
  function I() {
    return typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative";
  }
  env.isReactNative = I;
  function A() {
    return typeof process$1 < "u" && typeof process$1.versions < "u" && typeof process$1.versions.node < "u";
  }
  env.isNode = A;
  function G() {
    return !I() && !A();
  }
  return env.isBrowser = G, env;
}
(function(I) {
  Object.defineProperty(I, "__esModule", { value: !0 });
  const A = require$$0$2;
  A.__exportStar(requireCrypto(), I), A.__exportStar(requireEnv(), I);
})(cjs);
function payloadId(I = 3) {
  const A = Date.now() * Math.pow(10, I), G = Math.floor(Math.random() * Math.pow(10, I));
  return A + G;
}
function getBigIntRpcId(I = 6) {
  return BigInt(payloadId(I));
}
function formatJsonRpcRequest(I, A, G) {
  return {
    id: G || payloadId(),
    jsonrpc: "2.0",
    method: I,
    params: A
  };
}
function formatJsonRpcResult(I, A) {
  return {
    id: I,
    jsonrpc: "2.0",
    result: A
  };
}
function formatJsonRpcError(I, A, G) {
  return {
    id: I,
    jsonrpc: "2.0",
    error: formatErrorMessage(A)
  };
}
function formatErrorMessage(I, A) {
  return typeof I > "u" ? getError(INTERNAL_ERROR) : (typeof I == "string" && (I = Object.assign(Object.assign({}, getError(SERVER_ERROR)), { message: I })), isReservedErrorCode(I.code) && (I = getErrorByCode(I.code)), I);
}
class e {
}
class n extends e {
  constructor() {
    super();
  }
}
class r extends n {
  constructor(A) {
    super();
  }
}
const HTTP_REGEX = "^https?:";
function getUrlProtocol(I) {
  const A = I.match(new RegExp(/^\w+:/, "gi"));
  if (!(!A || !A.length))
    return A[0];
}
function matchRegexProtocol(I, A) {
  const G = getUrlProtocol(I);
  return typeof G > "u" ? !1 : new RegExp(A).test(G);
}
function isHttpUrl(I) {
  return matchRegexProtocol(I, HTTP_REGEX);
}
function isJsonRpcPayload(I) {
  return typeof I == "object" && "id" in I && "jsonrpc" in I && I.jsonrpc === "2.0";
}
function isJsonRpcResponse(I) {
  return isJsonRpcPayload(I) && (isJsonRpcResult(I) || isJsonRpcError(I));
}
function isJsonRpcResult(I) {
  return "result" in I;
}
function isJsonRpcError(I) {
  return "error" in I;
}
var P = Object.defineProperty, w = Object.defineProperties, E$1 = Object.getOwnPropertyDescriptors, c = Object.getOwnPropertySymbols, L$1 = Object.prototype.hasOwnProperty, O$1 = Object.prototype.propertyIsEnumerable, l = (I, A, G) => A in I ? P(I, A, { enumerable: !0, configurable: !0, writable: !0, value: G }) : I[A] = G, p$1 = (I, A) => {
  for (var G in A || (A = {})) L$1.call(A, G) && l(I, G, A[G]);
  if (c) for (var G of c(A)) O$1.call(A, G) && l(I, G, A[G]);
  return I;
}, v$1 = (I, A) => w(I, E$1(A));
const j$1 = { Accept: "application/json", "Content-Type": "application/json" }, T$1 = "POST", d = { headers: j$1, method: T$1 }, g$1 = 10;
class f {
  constructor(A, G = !1) {
    if (this.url = A, this.disableProviderPing = G, this.events = new eventsExports.EventEmitter(), this.isAvailable = !1, this.registering = !1, !isHttpUrl(A)) throw new Error(`Provided URL is not compatible with HTTP connection: ${A}`);
    this.url = A, this.disableProviderPing = G;
  }
  get connected() {
    return this.isAvailable;
  }
  get connecting() {
    return this.registering;
  }
  on(A, G) {
    this.events.on(A, G);
  }
  once(A, G) {
    this.events.once(A, G);
  }
  off(A, G) {
    this.events.off(A, G);
  }
  removeListener(A, G) {
    this.events.removeListener(A, G);
  }
  async open(A = this.url) {
    await this.register(A);
  }
  async close() {
    if (!this.isAvailable) throw new Error("Connection already closed");
    this.onClose();
  }
  async send(A) {
    this.isAvailable || await this.register();
    try {
      const G = safeJsonStringify(A), J = await (await o$1(this.url, v$1(p$1({}, d), { body: G }))).json();
      this.onPayload({ data: J });
    } catch (G) {
      this.onError(A.id, G);
    }
  }
  async register(A = this.url) {
    if (!isHttpUrl(A)) throw new Error(`Provided URL is not compatible with HTTP connection: ${A}`);
    if (this.registering) {
      const G = this.events.getMaxListeners();
      return (this.events.listenerCount("register_error") >= G || this.events.listenerCount("open") >= G) && this.events.setMaxListeners(G + 1), new Promise((J, _e) => {
        this.events.once("register_error", (H) => {
          this.resetMaxListeners(), _e(H);
        }), this.events.once("open", () => {
          if (this.resetMaxListeners(), typeof this.isAvailable > "u") return _e(new Error("HTTP connection is missing or invalid"));
          J();
        });
      });
    }
    this.url = A, this.registering = !0;
    try {
      if (!this.disableProviderPing) {
        const G = safeJsonStringify({ id: 1, jsonrpc: "2.0", method: "test", params: [] });
        await o$1(A, v$1(p$1({}, d), { body: G }));
      }
      this.onOpen();
    } catch (G) {
      const J = this.parseError(G);
      throw this.events.emit("register_error", J), this.onClose(), J;
    }
  }
  onOpen() {
    this.isAvailable = !0, this.registering = !1, this.events.emit("open");
  }
  onClose() {
    this.isAvailable = !1, this.registering = !1, this.events.emit("close");
  }
  onPayload(A) {
    if (typeof A.data > "u") return;
    const G = typeof A.data == "string" ? safeJsonParse(A.data) : A.data;
    this.events.emit("payload", G);
  }
  onError(A, G) {
    const J = this.parseError(G), _e = J.message || J.toString(), H = formatJsonRpcError(A, _e);
    this.events.emit("payload", H);
  }
  parseError(A, G = this.url) {
    return parseConnectionError(A, G, "HTTP");
  }
  resetMaxListeners() {
    this.events.getMaxListeners() > g$1 && this.events.setMaxListeners(g$1);
  }
}
class o extends r {
  constructor(A) {
    super(A), this.events = new eventsExports.EventEmitter(), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(A), this.connection.connected && this.registerEventListeners();
  }
  async connect(A = this.connection) {
    await this.open(A);
  }
  async disconnect() {
    await this.close();
  }
  on(A, G) {
    this.events.on(A, G);
  }
  once(A, G) {
    this.events.once(A, G);
  }
  off(A, G) {
    this.events.off(A, G);
  }
  removeListener(A, G) {
    this.events.removeListener(A, G);
  }
  async request(A, G) {
    return this.requestStrict(formatJsonRpcRequest(A.method, A.params || [], A.id || getBigIntRpcId().toString()), G);
  }
  async requestStrict(A, G) {
    return new Promise(async (J, _e) => {
      if (!this.connection.connected) try {
        await this.open();
      } catch (H) {
        _e(H);
      }
      this.events.on(`${A.id}`, (H) => {
        isJsonRpcError(H) ? _e(H.error) : J(H.result);
      });
      try {
        await this.connection.send(A, G);
      } catch (H) {
        _e(H);
      }
    });
  }
  setConnection(A = this.connection) {
    return A;
  }
  onPayload(A) {
    this.events.emit("payload", A), isJsonRpcResponse(A) ? this.events.emit(`${A.id}`, A) : this.events.emit("message", { type: A.method, data: A.params });
  }
  onClose(A) {
    A && A.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${A.code} ${A.reason ? `(${A.reason})` : ""}`)), this.events.emit("disconnect");
  }
  async open(A = this.connection) {
    this.connection === A && this.connection.connected || (this.connection.connected && this.close(), typeof A == "string" && (await this.connection.open(A), A = this.connection), this.connection = this.setConnection(A), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
  }
  async close() {
    await this.connection.close();
  }
  registerEventListeners() {
    this.hasRegisteredEventListeners || (this.connection.on("payload", (A) => this.onPayload(A)), this.connection.on("close", (A) => this.onClose(A)), this.connection.on("error", (A) => this.events.emit("error", A)), this.connection.on("register_error", (A) => this.onClose()), this.hasRegisteredEventListeners = !0);
  }
}
const ya = "error", Yg = "wss://relay.walletconnect.org", Zg = "wc", Xg = "universal_provider", Sa = `${Zg}@2:${Xg}:`, Oa = "https://rpc.walletconnect.org/v1/", ze = "generic", Qg = `${Oa}bundler`, Tt = { DEFAULT_CHAIN_CHANGED: "default_chain_changed" };
var _n = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, qi = { exports: {} };
/**
* @license
* Lodash <https://lodash.com/>
* Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
* Released under MIT license <https://lodash.com/license>
* Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
* Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
*/
(function(I, A) {
  (function() {
    var G, J = "4.17.21", _e = 200, H = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", De = "Expected a function", Ie = "Invalid `variable` option passed into `_.template`", qe = "__lodash_hash_undefined__", Te = 500, Ee = "__lodash_placeholder__", Oe = 1, Le = 2, ke = 4, Fe = 1, Ge = 2, et = 1, Ve = 2, Je = 4, ut = 8, rt = 16, lt = 32, vt = 64, Ye = 128, pt = 256, bt = 512, Yt = 30, Se = "...", t = 800, h = 16, B = 1, Z = 2, ve = 3, ge = 1 / 0, xe = 9007199254740991, X = 17976931348623157e292, a = NaN, Y = 4294967295, Ne = Y - 1, Ke = Y >>> 1, tt = [["ary", Ye], ["bind", et], ["bindKey", Ve], ["curry", ut], ["curryRight", rt], ["flip", bt], ["partial", lt], ["partialRight", vt], ["rearg", pt]], We = "[object Arguments]", ot = "[object Array]", He = "[object AsyncFunction]", Qe = "[object Boolean]", nt = "[object Date]", je = "[object DOMException]", it = "[object Error]", st = "[object Function]", gt = "[object GeneratorFunction]", It = "[object Map]", At = "[object Number]", Et = "[object Null]", ei = "[object Object]", Xt = "[object Promise]", _t = "[object Proxy]", ni = "[object RegExp]", Ct = "[object Set]", Wt = "[object String]", ii = "[object Symbol]", Pt = "[object Undefined]", Rt = "[object WeakMap]", ai = "[object WeakSet]", Nt = "[object ArrayBuffer]", qt = "[object DataView]", oi = "[object Float32Array]", ct = "[object Float64Array]", Ze = "[object Int8Array]", at = "[object Int16Array]", dt = "[object Int32Array]", yt = "[object Uint8Array]", St = "[object Uint8ClampedArray]", xt = "[object Uint16Array]", Vt = "[object Uint32Array]", ci = /\b__p \+= '';/g, Qt = /\b(__p \+=) '' \+/g, rr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ui = /&(?:amp|lt|gt|quot|#39);/g, Gr = /[&<>"']/g, yr = RegExp(ui.source), pi = RegExp(Gr.source), wr = /<%-([\s\S]+?)%>/g, _r = /<%([\s\S]+?)%>/g, di = /<%=([\s\S]+?)%>/g, Sr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Br = /^\w*$/, vi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, gr = /[\\^$.*+?()[\]{}|]/g, $r = RegExp(gr.source), li = /^\s+/, Ir = /\s/, Cr = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, mi = /\{\n\/\* \[wrapped with (.+)\] \*/, Pr = /,? & /, Or = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, yi = /[()=,{}\[\]\/\s]/, Zr = /\\(\\)?/g, Vr = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, bi = /\w*$/, Ai = /^[-+]0x[0-9a-f]+$/i, Zi = /^0b[01]+$/i, Ji = /^\[object .+?Constructor\]$/, Vi = /^0o[0-7]+$/i, Yi = /^(?:0|[1-9]\d*)$/, Xi = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, en = /($^)/, hn = /['\n\r\u2028\u2029\\]/g, tn = "\\ud800-\\udfff", un = "\\u0300-\\u036f", cn = "\\ufe20-\\ufe2f", ln = "\\u20d0-\\u20ff", an = un + cn + ln, fn = "\\u2700-\\u27bf", sn = "a-z\\xdf-\\xf6\\xf8-\\xff", dn = "\\xac\\xb1\\xd7\\xf7", pn = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", vn = "\\u2000-\\u206f", us = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", eo = "A-Z\\xc0-\\xd6\\xd8-\\xde", $u = "\\ufe0e\\ufe0f", Du = dn + pn + vn + us, mh = "['’]", Yl = "[" + tn + "]", Iu = "[" + Du + "]", Co = "[" + an + "]", qu = "\\d+", Xl = "[" + fn + "]", Cu = "[" + sn + "]", Pu = "[^" + tn + Du + qu + fn + sn + eo + "]", bh = "\\ud83c[\\udffb-\\udfff]", Ql = "(?:" + Co + "|" + bh + ")", Tu = "[^" + tn + "]", gh = "(?:\\ud83c[\\udde6-\\uddff]){2}", yh = "[\\ud800-\\udbff][\\udc00-\\udfff]", to = "[" + eo + "]", Nu = "\\u200d", Ou = "(?:" + Cu + "|" + Pu + ")", ed = "(?:" + to + "|" + Pu + ")", ku = "(?:" + mh + "(?:d|ll|m|re|s|t|ve))?", Lu = "(?:" + mh + "(?:D|LL|M|RE|S|T|VE))?", Fu = Ql + "?", Uu = "[" + $u + "]?", td = "(?:" + Nu + "(?:" + [Tu, gh, yh].join("|") + ")" + Uu + Fu + ")*", rd = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", id = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Hu = Uu + Fu + td, nd = "(?:" + [Xl, gh, yh].join("|") + ")" + Hu, ad = "(?:" + [Tu + Co + "?", Co, gh, yh, Yl].join("|") + ")", fd = RegExp(mh, "g"), sd = RegExp(Co, "g"), wh = RegExp(bh + "(?=" + bh + ")|" + ad + Hu, "g"), od = RegExp([to + "?" + Cu + "+" + ku + "(?=" + [Iu, to, "$"].join("|") + ")", ed + "+" + Lu + "(?=" + [Iu, to + Ou, "$"].join("|") + ")", to + "?" + Ou + "+" + ku, to + "+" + Lu, id, rd, qu, nd].join("|"), "g"), hd = RegExp("[" + Nu + tn + an + $u + "]"), ud = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, cd = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], ld = -1, Bn = {};
    Bn[oi] = Bn[ct] = Bn[Ze] = Bn[at] = Bn[dt] = Bn[yt] = Bn[St] = Bn[xt] = Bn[Vt] = !0, Bn[We] = Bn[ot] = Bn[Nt] = Bn[Qe] = Bn[qt] = Bn[nt] = Bn[it] = Bn[st] = Bn[It] = Bn[At] = Bn[ei] = Bn[ni] = Bn[Ct] = Bn[Wt] = Bn[Rt] = !1;
    var Sn = {};
    Sn[We] = Sn[ot] = Sn[Nt] = Sn[qt] = Sn[Qe] = Sn[nt] = Sn[oi] = Sn[ct] = Sn[Ze] = Sn[at] = Sn[dt] = Sn[It] = Sn[At] = Sn[ei] = Sn[ni] = Sn[Ct] = Sn[Wt] = Sn[ii] = Sn[yt] = Sn[St] = Sn[xt] = Sn[Vt] = !0, Sn[it] = Sn[st] = Sn[Rt] = !1;
    var dd = { À: "A", Á: "A", Â: "A", Ã: "A", Ä: "A", Å: "A", à: "a", á: "a", â: "a", ã: "a", ä: "a", å: "a", Ç: "C", ç: "c", Ð: "D", ð: "d", È: "E", É: "E", Ê: "E", Ë: "E", è: "e", é: "e", ê: "e", ë: "e", Ì: "I", Í: "I", Î: "I", Ï: "I", ì: "i", í: "i", î: "i", ï: "i", Ñ: "N", ñ: "n", Ò: "O", Ó: "O", Ô: "O", Õ: "O", Ö: "O", Ø: "O", ò: "o", ó: "o", ô: "o", õ: "o", ö: "o", ø: "o", Ù: "U", Ú: "U", Û: "U", Ü: "U", ù: "u", ú: "u", û: "u", ü: "u", Ý: "Y", ý: "y", ÿ: "y", Æ: "Ae", æ: "ae", Þ: "Th", þ: "th", ß: "ss", Ā: "A", Ă: "A", Ą: "A", ā: "a", ă: "a", ą: "a", Ć: "C", Ĉ: "C", Ċ: "C", Č: "C", ć: "c", ĉ: "c", ċ: "c", č: "c", Ď: "D", Đ: "D", ď: "d", đ: "d", Ē: "E", Ĕ: "E", Ė: "E", Ę: "E", Ě: "E", ē: "e", ĕ: "e", ė: "e", ę: "e", ě: "e", Ĝ: "G", Ğ: "G", Ġ: "G", Ģ: "G", ĝ: "g", ğ: "g", ġ: "g", ģ: "g", Ĥ: "H", Ħ: "H", ĥ: "h", ħ: "h", Ĩ: "I", Ī: "I", Ĭ: "I", Į: "I", İ: "I", ĩ: "i", ī: "i", ĭ: "i", į: "i", ı: "i", Ĵ: "J", ĵ: "j", Ķ: "K", ķ: "k", ĸ: "k", Ĺ: "L", Ļ: "L", Ľ: "L", Ŀ: "L", Ł: "L", ĺ: "l", ļ: "l", ľ: "l", ŀ: "l", ł: "l", Ń: "N", Ņ: "N", Ň: "N", Ŋ: "N", ń: "n", ņ: "n", ň: "n", ŋ: "n", Ō: "O", Ŏ: "O", Ő: "O", ō: "o", ŏ: "o", ő: "o", Ŕ: "R", Ŗ: "R", Ř: "R", ŕ: "r", ŗ: "r", ř: "r", Ś: "S", Ŝ: "S", Ş: "S", Š: "S", ś: "s", ŝ: "s", ş: "s", š: "s", Ţ: "T", Ť: "T", Ŧ: "T", ţ: "t", ť: "t", ŧ: "t", Ũ: "U", Ū: "U", Ŭ: "U", Ů: "U", Ű: "U", Ų: "U", ũ: "u", ū: "u", ŭ: "u", ů: "u", ű: "u", ų: "u", Ŵ: "W", ŵ: "w", Ŷ: "Y", ŷ: "y", Ÿ: "Y", Ź: "Z", Ż: "Z", Ž: "Z", ź: "z", ż: "z", ž: "z", Ĳ: "IJ", ĳ: "ij", Œ: "Oe", œ: "oe", ŉ: "'n", ſ: "s" }, pd = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, vd = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, md = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, bd = parseFloat, gd = parseInt, zu = typeof _n == "object" && _n && _n.Object === Object && _n, yd = typeof self == "object" && self && self.Object === Object && self, kn = zu || yd || Function("return this")(), Mh = A && !A.nodeType && A, Cs = Mh && !0 && I && !I.nodeType && I, ju = Cs && Cs.exports === Mh, _h = ju && zu.process, Jf = function() {
      try {
        var Wr = Cs && Cs.require && Cs.require("util").types;
        return Wr || _h && _h.binding && _h.binding("util");
      } catch {
      }
    }(), Ku = Jf && Jf.isArrayBuffer, Gu = Jf && Jf.isDate, Wu = Jf && Jf.isMap, Zu = Jf && Jf.isRegExp, Ju = Jf && Jf.isSet, Vu = Jf && Jf.isTypedArray;
    function $f(Wr, ri, ti) {
      switch (ti.length) {
        case 0:
          return Wr.call(ri);
        case 1:
          return Wr.call(ri, ti[0]);
        case 2:
          return Wr.call(ri, ti[0], ti[1]);
        case 3:
          return Wr.call(ri, ti[0], ti[1], ti[2]);
      }
      return Wr.apply(ri, ti);
    }
    function wd(Wr, ri, ti, wi) {
      for (var Oi = -1, wn = Wr == null ? 0 : Wr.length; ++Oi < wn; ) {
        var Pn = Wr[Oi];
        ri(wi, Pn, ti(Pn), Wr);
      }
      return wi;
    }
    function Vf(Wr, ri) {
      for (var ti = -1, wi = Wr == null ? 0 : Wr.length; ++ti < wi && ri(Wr[ti], ti, Wr) !== !1; ) ;
      return Wr;
    }
    function Md(Wr, ri) {
      for (var ti = Wr == null ? 0 : Wr.length; ti-- && ri(Wr[ti], ti, Wr) !== !1; ) ;
      return Wr;
    }
    function Yu(Wr, ri) {
      for (var ti = -1, wi = Wr == null ? 0 : Wr.length; ++ti < wi; ) if (!ri(Wr[ti], ti, Wr)) return !1;
      return !0;
    }
    function ws(Wr, ri) {
      for (var ti = -1, wi = Wr == null ? 0 : Wr.length, Oi = 0, wn = []; ++ti < wi; ) {
        var Pn = Wr[ti];
        ri(Pn, ti, Wr) && (wn[Oi++] = Pn);
      }
      return wn;
    }
    function Po(Wr, ri) {
      var ti = Wr == null ? 0 : Wr.length;
      return !!ti && ro(Wr, ri, 0) > -1;
    }
    function xh(Wr, ri, ti) {
      for (var wi = -1, Oi = Wr == null ? 0 : Wr.length; ++wi < Oi; ) if (ti(ri, Wr[wi])) return !0;
      return !1;
    }
    function Rn(Wr, ri) {
      for (var ti = -1, wi = Wr == null ? 0 : Wr.length, Oi = Array(wi); ++ti < wi; ) Oi[ti] = ri(Wr[ti], ti, Wr);
      return Oi;
    }
    function Ms(Wr, ri) {
      for (var ti = -1, wi = ri.length, Oi = Wr.length; ++ti < wi; ) Wr[Oi + ti] = ri[ti];
      return Wr;
    }
    function Ah(Wr, ri, ti, wi) {
      var Oi = -1, wn = Wr == null ? 0 : Wr.length;
      for (wi && wn && (ti = Wr[++Oi]); ++Oi < wn; ) ti = ri(ti, Wr[Oi], Oi, Wr);
      return ti;
    }
    function _d(Wr, ri, ti, wi) {
      var Oi = Wr == null ? 0 : Wr.length;
      for (wi && Oi && (ti = Wr[--Oi]); Oi--; ) ti = ri(ti, Wr[Oi], Oi, Wr);
      return ti;
    }
    function Eh(Wr, ri) {
      for (var ti = -1, wi = Wr == null ? 0 : Wr.length; ++ti < wi; ) if (ri(Wr[ti], ti, Wr)) return !0;
      return !1;
    }
    var xd = Sh("length");
    function Ad(Wr) {
      return Wr.split("");
    }
    function Ed(Wr) {
      return Wr.match(Or) || [];
    }
    function Xu(Wr, ri, ti) {
      var wi;
      return ti(Wr, function(Oi, wn, Pn) {
        if (ri(Oi, wn, Pn)) return wi = wn, !1;
      }), wi;
    }
    function To(Wr, ri, ti, wi) {
      for (var Oi = Wr.length, wn = ti + (wi ? 1 : -1); wi ? wn-- : ++wn < Oi; ) if (ri(Wr[wn], wn, Wr)) return wn;
      return -1;
    }
    function ro(Wr, ri, ti) {
      return ri === ri ? Od(Wr, ri, ti) : To(Wr, Qu, ti);
    }
    function Sd(Wr, ri, ti, wi) {
      for (var Oi = ti - 1, wn = Wr.length; ++Oi < wn; ) if (wi(Wr[Oi], ri)) return Oi;
      return -1;
    }
    function Qu(Wr) {
      return Wr !== Wr;
    }
    function tc(Wr, ri) {
      var ti = Wr == null ? 0 : Wr.length;
      return ti ? Rh(Wr, ri) / ti : a;
    }
    function Sh(Wr) {
      return function(ri) {
        return ri == null ? G : ri[Wr];
      };
    }
    function Bh(Wr) {
      return function(ri) {
        return Wr == null ? G : Wr[ri];
      };
    }
    function rc(Wr, ri, ti, wi, Oi) {
      return Oi(Wr, function(wn, Pn, En) {
        ti = wi ? (wi = !1, wn) : ri(ti, wn, Pn, En);
      }), ti;
    }
    function Bd(Wr, ri) {
      var ti = Wr.length;
      for (Wr.sort(ri); ti--; ) Wr[ti] = Wr[ti].value;
      return Wr;
    }
    function Rh(Wr, ri) {
      for (var ti, wi = -1, Oi = Wr.length; ++wi < Oi; ) {
        var wn = ri(Wr[wi]);
        wn !== G && (ti = ti === G ? wn : ti + wn);
      }
      return ti;
    }
    function $h(Wr, ri) {
      for (var ti = -1, wi = Array(Wr); ++ti < Wr; ) wi[ti] = ri(ti);
      return wi;
    }
    function Rd(Wr, ri) {
      return Rn(ri, function(ti) {
        return [ti, Wr[ti]];
      });
    }
    function ic(Wr) {
      return Wr && Wr.slice(0, sc(Wr) + 1).replace(li, "");
    }
    function Lf(Wr) {
      return function(ri) {
        return Wr(ri);
      };
    }
    function Dh(Wr, ri) {
      return Rn(ri, function(ti) {
        return Wr[ti];
      });
    }
    function mo(Wr, ri) {
      return Wr.has(ri);
    }
    function nc(Wr, ri) {
      for (var ti = -1, wi = Wr.length; ++ti < wi && ro(ri, Wr[ti], 0) > -1; ) ;
      return ti;
    }
    function ac(Wr, ri) {
      for (var ti = Wr.length; ti-- && ro(ri, Wr[ti], 0) > -1; ) ;
      return ti;
    }
    function $d(Wr, ri) {
      for (var ti = Wr.length, wi = 0; ti--; ) Wr[ti] === ri && ++wi;
      return wi;
    }
    var Dd = Bh(dd), Id = Bh(pd);
    function qd(Wr) {
      return "\\" + md[Wr];
    }
    function Cd(Wr, ri) {
      return Wr == null ? G : Wr[ri];
    }
    function io(Wr) {
      return hd.test(Wr);
    }
    function Pd(Wr) {
      return ud.test(Wr);
    }
    function Td(Wr) {
      for (var ri, ti = []; !(ri = Wr.next()).done; ) ti.push(ri.value);
      return ti;
    }
    function Ih(Wr) {
      var ri = -1, ti = Array(Wr.size);
      return Wr.forEach(function(wi, Oi) {
        ti[++ri] = [Oi, wi];
      }), ti;
    }
    function fc(Wr, ri) {
      return function(ti) {
        return Wr(ri(ti));
      };
    }
    function _s(Wr, ri) {
      for (var ti = -1, wi = Wr.length, Oi = 0, wn = []; ++ti < wi; ) {
        var Pn = Wr[ti];
        (Pn === ri || Pn === Ee) && (Wr[ti] = Ee, wn[Oi++] = ti);
      }
      return wn;
    }
    function No(Wr) {
      var ri = -1, ti = Array(Wr.size);
      return Wr.forEach(function(wi) {
        ti[++ri] = wi;
      }), ti;
    }
    function Nd(Wr) {
      var ri = -1, ti = Array(Wr.size);
      return Wr.forEach(function(wi) {
        ti[++ri] = [wi, wi];
      }), ti;
    }
    function Od(Wr, ri, ti) {
      for (var wi = ti - 1, Oi = Wr.length; ++wi < Oi; ) if (Wr[wi] === ri) return wi;
      return -1;
    }
    function kd(Wr, ri, ti) {
      for (var wi = ti + 1; wi--; ) if (Wr[wi] === ri) return wi;
      return wi;
    }
    function no(Wr) {
      return io(Wr) ? Fd(Wr) : xd(Wr);
    }
    function is(Wr) {
      return io(Wr) ? Ud(Wr) : Ad(Wr);
    }
    function sc(Wr) {
      for (var ri = Wr.length; ri-- && Ir.test(Wr.charAt(ri)); ) ;
      return ri;
    }
    var Ld = Bh(vd);
    function Fd(Wr) {
      for (var ri = wh.lastIndex = 0; wh.test(Wr); ) ++ri;
      return ri;
    }
    function Ud(Wr) {
      return Wr.match(wh) || [];
    }
    function Hd(Wr) {
      return Wr.match(od) || [];
    }
    var zd = function Wr(ri) {
      ri = ri == null ? kn : ao.defaults(kn.Object(), ri, ao.pick(kn, cd));
      var ti = ri.Array, wi = ri.Date, Oi = ri.Error, wn = ri.Function, Pn = ri.Math, En = ri.Object, qh = ri.RegExp, jd = ri.String, Yf = ri.TypeError, Oo = ti.prototype, Kd = wn.prototype, fo = En.prototype, ko = ri["__core-js_shared__"], Lo = Kd.toString, xn = fo.hasOwnProperty, Gd = 0, oc = function() {
        var Me = /[^.]+$/.exec(ko && ko.keys && ko.keys.IE_PROTO || "");
        return Me ? "Symbol(src)_1." + Me : "";
      }(), Fo = fo.toString, Wd = Lo.call(En), Zd = kn._, Jd = qh("^" + Lo.call(xn).replace(gr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Uo = ju ? ri.Buffer : G, xs = ri.Symbol, Ho = ri.Uint8Array, hc = Uo ? Uo.allocUnsafe : G, zo = fc(En.getPrototypeOf, En), uc = En.create, cc = fo.propertyIsEnumerable, jo = Oo.splice, lc = xs ? xs.isConcatSpreadable : G, bo = xs ? xs.iterator : G, Ts = xs ? xs.toStringTag : G, Ko = function() {
        try {
          var Me = js(En, "defineProperty");
          return Me({}, "", {}), Me;
        } catch {
        }
      }(), Vd = ri.clearTimeout !== kn.clearTimeout && ri.clearTimeout, Yd = wi && wi.now !== kn.Date.now && wi.now, Xd = ri.setTimeout !== kn.setTimeout && ri.setTimeout, Go = Pn.ceil, Zo = Pn.floor, Ph = En.getOwnPropertySymbols, Qd = Uo ? Uo.isBuffer : G, dc = ri.isFinite, e1 = Oo.join, t1 = fc(En.keys, En), Tn = Pn.max, Un = Pn.min, r1 = wi.now, i1 = ri.parseInt, pc = Pn.random, n1 = Oo.reverse, Th = js(ri, "DataView"), go = js(ri, "Map"), Nh = js(ri, "Promise"), so = js(ri, "Set"), yo = js(ri, "WeakMap"), wo = js(En, "create"), Jo = yo && new yo(), oo = {}, a1 = Js(Th), f1 = Js(go), s1 = Js(Nh), o1 = Js(so), h1 = Js(yo), Vo = xs ? xs.prototype : G, Mo = Vo ? Vo.valueOf : G, vc = Vo ? Vo.toString : G;
      function wt(Me) {
        if (In(Me) && !Gi(Me) && !(Me instanceof gn)) {
          if (Me instanceof Xf) return Me;
          if (xn.call(Me, "__wrapped__")) return ml(Me);
        }
        return new Xf(Me);
      }
      var ho = /* @__PURE__ */ function() {
        function Me() {
        }
        return function(Pe) {
          if (!Dn(Pe)) return {};
          if (uc) return uc(Pe);
          Me.prototype = Pe;
          var Ue = new Me();
          return Me.prototype = G, Ue;
        };
      }();
      function Yo() {
      }
      function Xf(Me, Pe) {
        this.__wrapped__ = Me, this.__actions__ = [], this.__chain__ = !!Pe, this.__index__ = 0, this.__values__ = G;
      }
      wt.templateSettings = { escape: wr, evaluate: _r, interpolate: di, variable: "", imports: { _: wt } }, wt.prototype = Yo.prototype, wt.prototype.constructor = wt, Xf.prototype = ho(Yo.prototype), Xf.prototype.constructor = Xf;
      function gn(Me) {
        this.__wrapped__ = Me, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Y, this.__views__ = [];
      }
      function u1() {
        var Me = new gn(this.__wrapped__);
        return Me.__actions__ = uf(this.__actions__), Me.__dir__ = this.__dir__, Me.__filtered__ = this.__filtered__, Me.__iteratees__ = uf(this.__iteratees__), Me.__takeCount__ = this.__takeCount__, Me.__views__ = uf(this.__views__), Me;
      }
      function c1() {
        if (this.__filtered__) {
          var Me = new gn(this);
          Me.__dir__ = -1, Me.__filtered__ = !0;
        } else Me = this.clone(), Me.__dir__ *= -1;
        return Me;
      }
      function l1() {
        var Me = this.__wrapped__.value(), Pe = this.__dir__, Ue = Gi(Me), ht = Pe < 0, mt = Ue ? Me.length : 0, Mt = Ep(0, mt, this.__views__), Bt = Mt.start, tr = Mt.end, Yr = tr - Bt, fi = ht ? tr : Bt - 1, si = this.__iteratees__, hi = si.length, gi = 0, xi = Un(Yr, this.__takeCount__);
        if (!Ue || !ht && mt == Yr && xi == Yr) return Lc(Me, this.__actions__);
        var Ii = [];
        e: for (; Yr-- && gi < xi; ) {
          fi += Pe;
          for (var rn = -1, Ci = Me[fi]; ++rn < hi; ) {
            var mn = si[rn], yn = mn.iteratee, Wf = mn.type, of = yn(Ci);
            if (Wf == Z) Ci = of;
            else if (!of) {
              if (Wf == B) continue e;
              break e;
            }
          }
          Ii[gi++] = Ci;
        }
        return Ii;
      }
      gn.prototype = ho(Yo.prototype), gn.prototype.constructor = gn;
      function Ns(Me) {
        var Pe = -1, Ue = Me == null ? 0 : Me.length;
        for (this.clear(); ++Pe < Ue; ) {
          var ht = Me[Pe];
          this.set(ht[0], ht[1]);
        }
      }
      function d1() {
        this.__data__ = wo ? wo(null) : {}, this.size = 0;
      }
      function p1(Me) {
        var Pe = this.has(Me) && delete this.__data__[Me];
        return this.size -= Pe ? 1 : 0, Pe;
      }
      function v1(Me) {
        var Pe = this.__data__;
        if (wo) {
          var Ue = Pe[Me];
          return Ue === qe ? G : Ue;
        }
        return xn.call(Pe, Me) ? Pe[Me] : G;
      }
      function m1(Me) {
        var Pe = this.__data__;
        return wo ? Pe[Me] !== G : xn.call(Pe, Me);
      }
      function b1(Me, Pe) {
        var Ue = this.__data__;
        return this.size += this.has(Me) ? 0 : 1, Ue[Me] = wo && Pe === G ? qe : Pe, this;
      }
      Ns.prototype.clear = d1, Ns.prototype.delete = p1, Ns.prototype.get = v1, Ns.prototype.has = m1, Ns.prototype.set = b1;
      function cs(Me) {
        var Pe = -1, Ue = Me == null ? 0 : Me.length;
        for (this.clear(); ++Pe < Ue; ) {
          var ht = Me[Pe];
          this.set(ht[0], ht[1]);
        }
      }
      function g1() {
        this.__data__ = [], this.size = 0;
      }
      function y1(Me) {
        var Pe = this.__data__, Ue = Xo(Pe, Me);
        if (Ue < 0) return !1;
        var ht = Pe.length - 1;
        return Ue == ht ? Pe.pop() : jo.call(Pe, Ue, 1), --this.size, !0;
      }
      function w1(Me) {
        var Pe = this.__data__, Ue = Xo(Pe, Me);
        return Ue < 0 ? G : Pe[Ue][1];
      }
      function M1(Me) {
        return Xo(this.__data__, Me) > -1;
      }
      function x1(Me, Pe) {
        var Ue = this.__data__, ht = Xo(Ue, Me);
        return ht < 0 ? (++this.size, Ue.push([Me, Pe])) : Ue[ht][1] = Pe, this;
      }
      cs.prototype.clear = g1, cs.prototype.delete = y1, cs.prototype.get = w1, cs.prototype.has = M1, cs.prototype.set = x1;
      function ls(Me) {
        var Pe = -1, Ue = Me == null ? 0 : Me.length;
        for (this.clear(); ++Pe < Ue; ) {
          var ht = Me[Pe];
          this.set(ht[0], ht[1]);
        }
      }
      function A1() {
        this.size = 0, this.__data__ = { hash: new Ns(), map: new (go || cs)(), string: new Ns() };
      }
      function E1(Me) {
        var Pe = ih(this, Me).delete(Me);
        return this.size -= Pe ? 1 : 0, Pe;
      }
      function S1(Me) {
        return ih(this, Me).get(Me);
      }
      function B1(Me) {
        return ih(this, Me).has(Me);
      }
      function R1(Me, Pe) {
        var Ue = ih(this, Me), ht = Ue.size;
        return Ue.set(Me, Pe), this.size += Ue.size == ht ? 0 : 1, this;
      }
      ls.prototype.clear = A1, ls.prototype.delete = E1, ls.prototype.get = S1, ls.prototype.has = B1, ls.prototype.set = R1;
      function Ls(Me) {
        var Pe = -1, Ue = Me == null ? 0 : Me.length;
        for (this.__data__ = new ls(); ++Pe < Ue; ) this.add(Me[Pe]);
      }
      function $1(Me) {
        return this.__data__.set(Me, qe), this;
      }
      function D1(Me) {
        return this.__data__.has(Me);
      }
      Ls.prototype.add = Ls.prototype.push = $1, Ls.prototype.has = D1;
      function ns(Me) {
        var Pe = this.__data__ = new cs(Me);
        this.size = Pe.size;
      }
      function I1() {
        this.__data__ = new cs(), this.size = 0;
      }
      function q1(Me) {
        var Pe = this.__data__, Ue = Pe.delete(Me);
        return this.size = Pe.size, Ue;
      }
      function C1(Me) {
        return this.__data__.get(Me);
      }
      function P1(Me) {
        return this.__data__.has(Me);
      }
      function T1(Me, Pe) {
        var Ue = this.__data__;
        if (Ue instanceof cs) {
          var ht = Ue.__data__;
          if (!go || ht.length < _e - 1) return ht.push([Me, Pe]), this.size = ++Ue.size, this;
          Ue = this.__data__ = new ls(ht);
        }
        return Ue.set(Me, Pe), this.size = Ue.size, this;
      }
      ns.prototype.clear = I1, ns.prototype.delete = q1, ns.prototype.get = C1, ns.prototype.has = P1, ns.prototype.set = T1;
      function mc(Me, Pe) {
        var Ue = Gi(Me), ht = !Ue && Qs(Me), mt = !Ue && !ht && Is(Me), Mt = !Ue && !ht && !mt && po(Me), Bt = Ue || ht || mt || Mt, tr = Bt ? $h(Me.length, jd) : [], Yr = tr.length;
        for (var fi in Me) (Pe || xn.call(Me, fi)) && !(Bt && (fi == "length" || mt && (fi == "offset" || fi == "parent") || Mt && (fi == "buffer" || fi == "byteLength" || fi == "byteOffset") || ms(fi, Yr))) && tr.push(fi);
        return tr;
      }
      function bc(Me) {
        var Pe = Me.length;
        return Pe ? Me[Zh(0, Pe - 1)] : G;
      }
      function N1(Me, Pe) {
        return nh(uf(Me), Fs(Pe, 0, Me.length));
      }
      function O1(Me) {
        return nh(uf(Me));
      }
      function Oh(Me, Pe, Ue) {
        (Ue !== G && !as(Me[Pe], Ue) || Ue === G && !(Pe in Me)) && ds(Me, Pe, Ue);
      }
      function _o(Me, Pe, Ue) {
        var ht = Me[Pe];
        (!(xn.call(Me, Pe) && as(ht, Ue)) || Ue === G && !(Pe in Me)) && ds(Me, Pe, Ue);
      }
      function Xo(Me, Pe) {
        for (var Ue = Me.length; Ue--; ) if (as(Me[Ue][0], Pe)) return Ue;
        return -1;
      }
      function k1(Me, Pe, Ue, ht) {
        return As(Me, function(mt, Mt, Bt) {
          Pe(ht, mt, Ue(mt), Bt);
        }), ht;
      }
      function gc(Me, Pe) {
        return Me && os(Pe, On(Pe), Me);
      }
      function L1(Me, Pe) {
        return Me && os(Pe, pf(Pe), Me);
      }
      function ds(Me, Pe, Ue) {
        Pe == "__proto__" && Ko ? Ko(Me, Pe, { configurable: !0, enumerable: !0, value: Ue, writable: !0 }) : Me[Pe] = Ue;
      }
      function kh(Me, Pe) {
        for (var Ue = -1, ht = Pe.length, mt = ti(ht), Mt = Me == null; ++Ue < ht; ) mt[Ue] = Mt ? G : wu(Me, Pe[Ue]);
        return mt;
      }
      function Fs(Me, Pe, Ue) {
        return Me === Me && (Ue !== G && (Me = Me <= Ue ? Me : Ue), Pe !== G && (Me = Me >= Pe ? Me : Pe)), Me;
      }
      function Qf(Me, Pe, Ue, ht, mt, Mt) {
        var Bt, tr = Pe & Oe, Yr = Pe & Le, fi = Pe & ke;
        if (Ue && (Bt = mt ? Ue(Me, ht, mt, Mt) : Ue(Me)), Bt !== G) return Bt;
        if (!Dn(Me)) return Me;
        var si = Gi(Me);
        if (si) {
          if (Bt = Bp(Me), !tr) return uf(Me, Bt);
        } else {
          var hi = Wn(Me), gi = hi == st || hi == gt;
          if (Is(Me)) return Hc(Me, tr);
          if (hi == ei || hi == We || gi && !mt) {
            if (Bt = Yr || gi ? {} : sl(Me), !tr) return Yr ? mp(Me, L1(Bt, Me)) : vp(Me, gc(Bt, Me));
          } else {
            if (!Sn[hi]) return mt ? Me : {};
            Bt = Rp(Me, hi, tr);
          }
        }
        Mt || (Mt = new ns());
        var xi = Mt.get(Me);
        if (xi) return xi;
        Mt.set(Me, Bt), Nl(Me) ? Me.forEach(function(Ci) {
          Bt.add(Qf(Ci, Pe, Ue, Ci, Me, Mt));
        }) : Pl(Me) && Me.forEach(function(Ci, mn) {
          Bt.set(mn, Qf(Ci, Pe, Ue, mn, Me, Mt));
        });
        var Ii = fi ? Yr ? fu : au : Yr ? pf : On, rn = si ? G : Ii(Me);
        return Vf(rn || Me, function(Ci, mn) {
          rn && (mn = Ci, Ci = Me[mn]), _o(Bt, mn, Qf(Ci, Pe, Ue, mn, Me, Mt));
        }), Bt;
      }
      function F1(Me) {
        var Pe = On(Me);
        return function(Ue) {
          return yc(Ue, Me, Pe);
        };
      }
      function yc(Me, Pe, Ue) {
        var ht = Ue.length;
        if (Me == null) return !ht;
        for (Me = En(Me); ht--; ) {
          var mt = Ue[ht], Mt = Pe[mt], Bt = Me[mt];
          if (Bt === G && !(mt in Me) || !Mt(Bt)) return !1;
        }
        return !0;
      }
      function wc(Me, Pe, Ue) {
        if (typeof Me != "function") throw new Yf(De);
        return Io(function() {
          Me.apply(G, Ue);
        }, Pe);
      }
      function Ao(Me, Pe, Ue, ht) {
        var mt = -1, Mt = Po, Bt = !0, tr = Me.length, Yr = [], fi = Pe.length;
        if (!tr) return Yr;
        Ue && (Pe = Rn(Pe, Lf(Ue))), ht ? (Mt = xh, Bt = !1) : Pe.length >= _e && (Mt = mo, Bt = !1, Pe = new Ls(Pe));
        e: for (; ++mt < tr; ) {
          var si = Me[mt], hi = Ue == null ? si : Ue(si);
          if (si = ht || si !== 0 ? si : 0, Bt && hi === hi) {
            for (var gi = fi; gi--; ) if (Pe[gi] === hi) continue e;
            Yr.push(si);
          } else Mt(Pe, hi, ht) || Yr.push(si);
        }
        return Yr;
      }
      var As = Wc(ss), Mc = Wc(Fh, !0);
      function U1(Me, Pe) {
        var Ue = !0;
        return As(Me, function(ht, mt, Mt) {
          return Ue = !!Pe(ht, mt, Mt), Ue;
        }), Ue;
      }
      function Qo(Me, Pe, Ue) {
        for (var ht = -1, mt = Me.length; ++ht < mt; ) {
          var Mt = Me[ht], Bt = Pe(Mt);
          if (Bt != null && (tr === G ? Bt === Bt && !Gf(Bt) : Ue(Bt, tr))) var tr = Bt, Yr = Mt;
        }
        return Yr;
      }
      function H1(Me, Pe, Ue, ht) {
        var mt = Me.length;
        for (Ue = Qi(Ue), Ue < 0 && (Ue = -Ue > mt ? 0 : mt + Ue), ht = ht === G || ht > mt ? mt : Qi(ht), ht < 0 && (ht += mt), ht = Ue > ht ? 0 : kl(ht); Ue < ht; ) Me[Ue++] = Pe;
        return Me;
      }
      function _c(Me, Pe) {
        var Ue = [];
        return As(Me, function(ht, mt, Mt) {
          Pe(ht, mt, Mt) && Ue.push(ht);
        }), Ue;
      }
      function Fn(Me, Pe, Ue, ht, mt) {
        var Mt = -1, Bt = Me.length;
        for (Ue || (Ue = Dp), mt || (mt = []); ++Mt < Bt; ) {
          var tr = Me[Mt];
          Pe > 0 && Ue(tr) ? Pe > 1 ? Fn(tr, Pe - 1, Ue, ht, mt) : Ms(mt, tr) : ht || (mt[mt.length] = tr);
        }
        return mt;
      }
      var Lh = Zc(), xc = Zc(!0);
      function ss(Me, Pe) {
        return Me && Lh(Me, Pe, On);
      }
      function Fh(Me, Pe) {
        return Me && xc(Me, Pe, On);
      }
      function h0(Me, Pe) {
        return ws(Pe, function(Ue) {
          return bs(Me[Ue]);
        });
      }
      function Us(Me, Pe) {
        Pe = Ss(Pe, Me);
        for (var Ue = 0, ht = Pe.length; Me != null && Ue < ht; ) Me = Me[hs(Pe[Ue++])];
        return Ue && Ue == ht ? Me : G;
      }
      function Ac(Me, Pe, Ue) {
        var ht = Pe(Me);
        return Gi(Me) ? ht : Ms(ht, Ue(Me));
      }
      function Vn(Me) {
        return Me == null ? Me === G ? Pt : Et : Ts && Ts in En(Me) ? Ap(Me) : Op(Me);
      }
      function Uh(Me, Pe) {
        return Me > Pe;
      }
      function z1(Me, Pe) {
        return Me != null && xn.call(Me, Pe);
      }
      function j1(Me, Pe) {
        return Me != null && Pe in En(Me);
      }
      function K1(Me, Pe, Ue) {
        return Me >= Un(Pe, Ue) && Me < Tn(Pe, Ue);
      }
      function Hh(Me, Pe, Ue) {
        for (var ht = Ue ? xh : Po, mt = Me[0].length, Mt = Me.length, Bt = Mt, tr = ti(Mt), Yr = 1 / 0, fi = []; Bt--; ) {
          var si = Me[Bt];
          Bt && Pe && (si = Rn(si, Lf(Pe))), Yr = Un(si.length, Yr), tr[Bt] = !Ue && (Pe || mt >= 120 && si.length >= 120) ? new Ls(Bt && si) : G;
        }
        si = Me[0];
        var hi = -1, gi = tr[0];
        e: for (; ++hi < mt && fi.length < Yr; ) {
          var xi = si[hi], Ii = Pe ? Pe(xi) : xi;
          if (xi = Ue || xi !== 0 ? xi : 0, !(gi ? mo(gi, Ii) : ht(fi, Ii, Ue))) {
            for (Bt = Mt; --Bt; ) {
              var rn = tr[Bt];
              if (!(rn ? mo(rn, Ii) : ht(Me[Bt], Ii, Ue))) continue e;
            }
            gi && gi.push(Ii), fi.push(xi);
          }
        }
        return fi;
      }
      function G1(Me, Pe, Ue, ht) {
        return ss(Me, function(mt, Mt, Bt) {
          Pe(ht, Ue(mt), Mt, Bt);
        }), ht;
      }
      function So(Me, Pe, Ue) {
        Pe = Ss(Pe, Me), Me = cl(Me, Pe);
        var ht = Me == null ? Me : Me[hs(ts(Pe))];
        return ht == null ? G : $f(ht, Me, Ue);
      }
      function Ec(Me) {
        return In(Me) && Vn(Me) == We;
      }
      function W1(Me) {
        return In(Me) && Vn(Me) == Nt;
      }
      function Z1(Me) {
        return In(Me) && Vn(Me) == nt;
      }
      function Bo(Me, Pe, Ue, ht, mt) {
        return Me === Pe ? !0 : Me == null || Pe == null || !In(Me) && !In(Pe) ? Me !== Me && Pe !== Pe : J1(Me, Pe, Ue, ht, Bo, mt);
      }
      function J1(Me, Pe, Ue, ht, mt, Mt) {
        var Bt = Gi(Me), tr = Gi(Pe), Yr = Bt ? ot : Wn(Me), fi = tr ? ot : Wn(Pe);
        Yr = Yr == We ? ei : Yr, fi = fi == We ? ei : fi;
        var si = Yr == ei, hi = fi == ei, gi = Yr == fi;
        if (gi && Is(Me)) {
          if (!Is(Pe)) return !1;
          Bt = !0, si = !1;
        }
        if (gi && !si) return Mt || (Mt = new ns()), Bt || po(Me) ? nl(Me, Pe, Ue, ht, mt, Mt) : _p(Me, Pe, Yr, Ue, ht, mt, Mt);
        if (!(Ue & Fe)) {
          var xi = si && xn.call(Me, "__wrapped__"), Ii = hi && xn.call(Pe, "__wrapped__");
          if (xi || Ii) {
            var rn = xi ? Me.value() : Me, Ci = Ii ? Pe.value() : Pe;
            return Mt || (Mt = new ns()), mt(rn, Ci, Ue, ht, Mt);
          }
        }
        return gi ? (Mt || (Mt = new ns()), xp(Me, Pe, Ue, ht, mt, Mt)) : !1;
      }
      function V1(Me) {
        return In(Me) && Wn(Me) == It;
      }
      function zh(Me, Pe, Ue, ht) {
        var mt = Ue.length, Mt = mt, Bt = !ht;
        if (Me == null) return !Mt;
        for (Me = En(Me); mt--; ) {
          var tr = Ue[mt];
          if (Bt && tr[2] ? tr[1] !== Me[tr[0]] : !(tr[0] in Me)) return !1;
        }
        for (; ++mt < Mt; ) {
          tr = Ue[mt];
          var Yr = tr[0], fi = Me[Yr], si = tr[1];
          if (Bt && tr[2]) {
            if (fi === G && !(Yr in Me)) return !1;
          } else {
            var hi = new ns();
            if (ht) var gi = ht(fi, si, Yr, Me, Pe, hi);
            if (!(gi === G ? Bo(si, fi, Fe | Ge, ht, hi) : gi)) return !1;
          }
        }
        return !0;
      }
      function Sc(Me) {
        if (!Dn(Me) || qp(Me)) return !1;
        var Pe = bs(Me) ? Jd : Ji;
        return Pe.test(Js(Me));
      }
      function Y1(Me) {
        return In(Me) && Vn(Me) == ni;
      }
      function X1(Me) {
        return In(Me) && Wn(Me) == Ct;
      }
      function Q1(Me) {
        return In(Me) && lh(Me.length) && !!Bn[Vn(Me)];
      }
      function Bc(Me) {
        return typeof Me == "function" ? Me : Me == null ? vf : typeof Me == "object" ? Gi(Me) ? Dc(Me[0], Me[1]) : $c(Me) : Jl(Me);
      }
      function jh(Me) {
        if (!Do(Me)) return t1(Me);
        var Pe = [];
        for (var Ue in En(Me)) xn.call(Me, Ue) && Ue != "constructor" && Pe.push(Ue);
        return Pe;
      }
      function ep(Me) {
        if (!Dn(Me)) return Np(Me);
        var Pe = Do(Me), Ue = [];
        for (var ht in Me) ht == "constructor" && (Pe || !xn.call(Me, ht)) || Ue.push(ht);
        return Ue;
      }
      function Gh(Me, Pe) {
        return Me < Pe;
      }
      function Rc(Me, Pe) {
        var Ue = -1, ht = df(Me) ? ti(Me.length) : [];
        return As(Me, function(mt, Mt, Bt) {
          ht[++Ue] = Pe(mt, Mt, Bt);
        }), ht;
      }
      function $c(Me) {
        var Pe = ou(Me);
        return Pe.length == 1 && Pe[0][2] ? hl(Pe[0][0], Pe[0][1]) : function(Ue) {
          return Ue === Me || zh(Ue, Me, Pe);
        };
      }
      function Dc(Me, Pe) {
        return uu(Me) && ol(Pe) ? hl(hs(Me), Pe) : function(Ue) {
          var ht = wu(Ue, Me);
          return ht === G && ht === Pe ? Mu(Ue, Me) : Bo(Pe, ht, Fe | Ge);
        };
      }
      function u0(Me, Pe, Ue, ht, mt) {
        Me !== Pe && Lh(Pe, function(Mt, Bt) {
          if (mt || (mt = new ns()), Dn(Mt)) tp(Me, Pe, Bt, Ue, u0, ht, mt);
          else {
            var tr = ht ? ht(lu(Me, Bt), Mt, Bt + "", Me, Pe, mt) : G;
            tr === G && (tr = Mt), Oh(Me, Bt, tr);
          }
        }, pf);
      }
      function tp(Me, Pe, Ue, ht, mt, Mt, Bt) {
        var tr = lu(Me, Ue), Yr = lu(Pe, Ue), fi = Bt.get(Yr);
        if (fi) {
          Oh(Me, Ue, fi);
          return;
        }
        var si = Mt ? Mt(tr, Yr, Ue + "", Me, Pe, Bt) : G, hi = si === G;
        if (hi) {
          var gi = Gi(Yr), xi = !gi && Is(Yr), Ii = !gi && !xi && po(Yr);
          si = Yr, gi || xi || Ii ? Gi(tr) ? si = tr : qn(tr) ? si = uf(tr) : xi ? (hi = !1, si = Hc(Yr, !0)) : Ii ? (hi = !1, si = zc(Yr, !0)) : si = [] : qo(Yr) || Qs(Yr) ? (si = tr, Qs(tr) ? si = Ll(tr) : (!Dn(tr) || bs(tr)) && (si = sl(Yr))) : hi = !1;
        }
        hi && (Bt.set(Yr, si), mt(si, Yr, ht, Mt, Bt), Bt.delete(Yr)), Oh(Me, Ue, si);
      }
      function Ic(Me, Pe) {
        var Ue = Me.length;
        if (Ue) return Pe += Pe < 0 ? Ue : 0, ms(Pe, Ue) ? Me[Pe] : G;
      }
      function qc(Me, Pe, Ue) {
        Pe.length ? Pe = Rn(Pe, function(Mt) {
          return Gi(Mt) ? function(Bt) {
            return Us(Bt, Mt.length === 1 ? Mt[0] : Mt);
          } : Mt;
        }) : Pe = [vf];
        var ht = -1;
        Pe = Rn(Pe, Lf($i()));
        var mt = Rc(Me, function(Mt, Bt, tr) {
          var Yr = Rn(Pe, function(fi) {
            return fi(Mt);
          });
          return { criteria: Yr, index: ++ht, value: Mt };
        });
        return Bd(mt, function(Mt, Bt) {
          return pp(Mt, Bt, Ue);
        });
      }
      function rp(Me, Pe) {
        return Cc(Me, Pe, function(Ue, ht) {
          return Mu(Me, ht);
        });
      }
      function Cc(Me, Pe, Ue) {
        for (var ht = -1, mt = Pe.length, Mt = {}; ++ht < mt; ) {
          var Bt = Pe[ht], tr = Us(Me, Bt);
          Ue(tr, Bt) && Ro(Mt, Ss(Bt, Me), tr);
        }
        return Mt;
      }
      function ip(Me) {
        return function(Pe) {
          return Us(Pe, Me);
        };
      }
      function Wh(Me, Pe, Ue, ht) {
        var mt = ht ? Sd : ro, Mt = -1, Bt = Pe.length, tr = Me;
        for (Me === Pe && (Pe = uf(Pe)), Ue && (tr = Rn(Me, Lf(Ue))); ++Mt < Bt; ) for (var Yr = 0, fi = Pe[Mt], si = Ue ? Ue(fi) : fi; (Yr = mt(tr, si, Yr, ht)) > -1; ) tr !== Me && jo.call(tr, Yr, 1), jo.call(Me, Yr, 1);
        return Me;
      }
      function Pc(Me, Pe) {
        for (var Ue = Me ? Pe.length : 0, ht = Ue - 1; Ue--; ) {
          var mt = Pe[Ue];
          if (Ue == ht || mt !== Mt) {
            var Mt = mt;
            ms(mt) ? jo.call(Me, mt, 1) : Yh(Me, mt);
          }
        }
        return Me;
      }
      function Zh(Me, Pe) {
        return Me + Zo(pc() * (Pe - Me + 1));
      }
      function np(Me, Pe, Ue, ht) {
        for (var mt = -1, Mt = Tn(Go((Pe - Me) / (Ue || 1)), 0), Bt = ti(Mt); Mt--; ) Bt[ht ? Mt : ++mt] = Me, Me += Ue;
        return Bt;
      }
      function Jh(Me, Pe) {
        var Ue = "";
        if (!Me || Pe < 1 || Pe > xe) return Ue;
        do
          Pe % 2 && (Ue += Me), Pe = Zo(Pe / 2), Pe && (Me += Me);
        while (Pe);
        return Ue;
      }
      function nn(Me, Pe) {
        return du(ul(Me, Pe, vf), Me + "");
      }
      function ap(Me) {
        return bc(vo(Me));
      }
      function fp(Me, Pe) {
        var Ue = vo(Me);
        return nh(Ue, Fs(Pe, 0, Ue.length));
      }
      function Ro(Me, Pe, Ue, ht) {
        if (!Dn(Me)) return Me;
        Pe = Ss(Pe, Me);
        for (var mt = -1, Mt = Pe.length, Bt = Mt - 1, tr = Me; tr != null && ++mt < Mt; ) {
          var Yr = hs(Pe[mt]), fi = Ue;
          if (Yr === "__proto__" || Yr === "constructor" || Yr === "prototype") return Me;
          if (mt != Bt) {
            var si = tr[Yr];
            fi = ht ? ht(si, Yr, tr) : G, fi === G && (fi = Dn(si) ? si : ms(Pe[mt + 1]) ? [] : {});
          }
          _o(tr, Yr, fi), tr = tr[Yr];
        }
        return Me;
      }
      var Tc = Jo ? function(Me, Pe) {
        return Jo.set(Me, Pe), Me;
      } : vf, sp = Ko ? function(Me, Pe) {
        return Ko(Me, "toString", { configurable: !0, enumerable: !1, value: xu(Pe), writable: !0 });
      } : vf;
      function op(Me) {
        return nh(vo(Me));
      }
      function es(Me, Pe, Ue) {
        var ht = -1, mt = Me.length;
        Pe < 0 && (Pe = -Pe > mt ? 0 : mt + Pe), Ue = Ue > mt ? mt : Ue, Ue < 0 && (Ue += mt), mt = Pe > Ue ? 0 : Ue - Pe >>> 0, Pe >>>= 0;
        for (var Mt = ti(mt); ++ht < mt; ) Mt[ht] = Me[ht + Pe];
        return Mt;
      }
      function hp(Me, Pe) {
        var Ue;
        return As(Me, function(ht, mt, Mt) {
          return Ue = Pe(ht, mt, Mt), !Ue;
        }), !!Ue;
      }
      function c0(Me, Pe, Ue) {
        var ht = 0, mt = Me == null ? ht : Me.length;
        if (typeof Pe == "number" && Pe === Pe && mt <= Ke) {
          for (; ht < mt; ) {
            var Mt = ht + mt >>> 1, Bt = Me[Mt];
            Bt !== null && !Gf(Bt) && (Ue ? Bt <= Pe : Bt < Pe) ? ht = Mt + 1 : mt = Mt;
          }
          return mt;
        }
        return Vh(Me, Pe, vf, Ue);
      }
      function Vh(Me, Pe, Ue, ht) {
        var mt = 0, Mt = Me == null ? 0 : Me.length;
        if (Mt === 0) return 0;
        Pe = Ue(Pe);
        for (var Bt = Pe !== Pe, tr = Pe === null, Yr = Gf(Pe), fi = Pe === G; mt < Mt; ) {
          var si = Zo((mt + Mt) / 2), hi = Ue(Me[si]), gi = hi !== G, xi = hi === null, Ii = hi === hi, rn = Gf(hi);
          if (Bt) var Ci = ht || Ii;
          else fi ? Ci = Ii && (ht || gi) : tr ? Ci = Ii && gi && (ht || !xi) : Yr ? Ci = Ii && gi && !xi && (ht || !rn) : xi || rn ? Ci = !1 : Ci = ht ? hi <= Pe : hi < Pe;
          Ci ? mt = si + 1 : Mt = si;
        }
        return Un(Mt, Ne);
      }
      function Nc(Me, Pe) {
        for (var Ue = -1, ht = Me.length, mt = 0, Mt = []; ++Ue < ht; ) {
          var Bt = Me[Ue], tr = Pe ? Pe(Bt) : Bt;
          if (!Ue || !as(tr, Yr)) {
            var Yr = tr;
            Mt[mt++] = Bt === 0 ? 0 : Bt;
          }
        }
        return Mt;
      }
      function Oc(Me) {
        return typeof Me == "number" ? Me : Gf(Me) ? a : +Me;
      }
      function jf(Me) {
        if (typeof Me == "string") return Me;
        if (Gi(Me)) return Rn(Me, jf) + "";
        if (Gf(Me)) return vc ? vc.call(Me) : "";
        var Pe = Me + "";
        return Pe == "0" && 1 / Me == -ge ? "-0" : Pe;
      }
      function Es(Me, Pe, Ue) {
        var ht = -1, mt = Po, Mt = Me.length, Bt = !0, tr = [], Yr = tr;
        if (Ue) Bt = !1, mt = xh;
        else if (Mt >= _e) {
          var fi = Pe ? null : wp(Me);
          if (fi) return No(fi);
          Bt = !1, mt = mo, Yr = new Ls();
        } else Yr = Pe ? [] : tr;
        e: for (; ++ht < Mt; ) {
          var si = Me[ht], hi = Pe ? Pe(si) : si;
          if (si = Ue || si !== 0 ? si : 0, Bt && hi === hi) {
            for (var gi = Yr.length; gi--; ) if (Yr[gi] === hi) continue e;
            Pe && Yr.push(hi), tr.push(si);
          } else mt(Yr, hi, Ue) || (Yr !== tr && Yr.push(hi), tr.push(si));
        }
        return tr;
      }
      function Yh(Me, Pe) {
        return Pe = Ss(Pe, Me), Me = cl(Me, Pe), Me == null || delete Me[hs(ts(Pe))];
      }
      function kc(Me, Pe, Ue, ht) {
        return Ro(Me, Pe, Ue(Us(Me, Pe)), ht);
      }
      function l0(Me, Pe, Ue, ht) {
        for (var mt = Me.length, Mt = ht ? mt : -1; (ht ? Mt-- : ++Mt < mt) && Pe(Me[Mt], Mt, Me); ) ;
        return Ue ? es(Me, ht ? 0 : Mt, ht ? Mt + 1 : mt) : es(Me, ht ? Mt + 1 : 0, ht ? mt : Mt);
      }
      function Lc(Me, Pe) {
        var Ue = Me;
        return Ue instanceof gn && (Ue = Ue.value()), Ah(Pe, function(ht, mt) {
          return mt.func.apply(mt.thisArg, Ms([ht], mt.args));
        }, Ue);
      }
      function Xh(Me, Pe, Ue) {
        var ht = Me.length;
        if (ht < 2) return ht ? Es(Me[0]) : [];
        for (var mt = -1, Mt = ti(ht); ++mt < ht; ) for (var Bt = Me[mt], tr = -1; ++tr < ht; ) tr != mt && (Mt[mt] = Ao(Mt[mt] || Bt, Me[tr], Pe, Ue));
        return Es(Fn(Mt, 1), Pe, Ue);
      }
      function Fc(Me, Pe, Ue) {
        for (var ht = -1, mt = Me.length, Mt = Pe.length, Bt = {}; ++ht < mt; ) {
          var tr = ht < Mt ? Pe[ht] : G;
          Ue(Bt, Me[ht], tr);
        }
        return Bt;
      }
      function Qh(Me) {
        return qn(Me) ? Me : [];
      }
      function eu(Me) {
        return typeof Me == "function" ? Me : vf;
      }
      function Ss(Me, Pe) {
        return Gi(Me) ? Me : uu(Me, Pe) ? [Me] : vl(Mn(Me));
      }
      var up = nn;
      function Ds(Me, Pe, Ue) {
        var ht = Me.length;
        return Ue = Ue === G ? ht : Ue, !Pe && Ue >= ht ? Me : es(Me, Pe, Ue);
      }
      var Uc = Vd || function(Me) {
        return kn.clearTimeout(Me);
      };
      function Hc(Me, Pe) {
        if (Pe) return Me.slice();
        var Ue = Me.length, ht = hc ? hc(Ue) : new Me.constructor(Ue);
        return Me.copy(ht), ht;
      }
      function ru(Me) {
        var Pe = new Me.constructor(Me.byteLength);
        return new Ho(Pe).set(new Ho(Me)), Pe;
      }
      function cp(Me, Pe) {
        var Ue = Pe ? ru(Me.buffer) : Me.buffer;
        return new Me.constructor(Ue, Me.byteOffset, Me.byteLength);
      }
      function lp(Me) {
        var Pe = new Me.constructor(Me.source, bi.exec(Me));
        return Pe.lastIndex = Me.lastIndex, Pe;
      }
      function dp(Me) {
        return Mo ? En(Mo.call(Me)) : {};
      }
      function zc(Me, Pe) {
        var Ue = Pe ? ru(Me.buffer) : Me.buffer;
        return new Me.constructor(Ue, Me.byteOffset, Me.length);
      }
      function jc(Me, Pe) {
        if (Me !== Pe) {
          var Ue = Me !== G, ht = Me === null, mt = Me === Me, Mt = Gf(Me), Bt = Pe !== G, tr = Pe === null, Yr = Pe === Pe, fi = Gf(Pe);
          if (!tr && !fi && !Mt && Me > Pe || Mt && Bt && Yr && !tr && !fi || ht && Bt && Yr || !Ue && Yr || !mt) return 1;
          if (!ht && !Mt && !fi && Me < Pe || fi && Ue && mt && !ht && !Mt || tr && Ue && mt || !Bt && mt || !Yr) return -1;
        }
        return 0;
      }
      function pp(Me, Pe, Ue) {
        for (var ht = -1, mt = Me.criteria, Mt = Pe.criteria, Bt = mt.length, tr = Ue.length; ++ht < Bt; ) {
          var Yr = jc(mt[ht], Mt[ht]);
          if (Yr) {
            if (ht >= tr) return Yr;
            var fi = Ue[ht];
            return Yr * (fi == "desc" ? -1 : 1);
          }
        }
        return Me.index - Pe.index;
      }
      function Kc(Me, Pe, Ue, ht) {
        for (var mt = -1, Mt = Me.length, Bt = Ue.length, tr = -1, Yr = Pe.length, fi = Tn(Mt - Bt, 0), si = ti(Yr + fi), hi = !ht; ++tr < Yr; ) si[tr] = Pe[tr];
        for (; ++mt < Bt; ) (hi || mt < Mt) && (si[Ue[mt]] = Me[mt]);
        for (; fi--; ) si[tr++] = Me[mt++];
        return si;
      }
      function Gc(Me, Pe, Ue, ht) {
        for (var mt = -1, Mt = Me.length, Bt = -1, tr = Ue.length, Yr = -1, fi = Pe.length, si = Tn(Mt - tr, 0), hi = ti(si + fi), gi = !ht; ++mt < si; ) hi[mt] = Me[mt];
        for (var xi = mt; ++Yr < fi; ) hi[xi + Yr] = Pe[Yr];
        for (; ++Bt < tr; ) (gi || mt < Mt) && (hi[xi + Ue[Bt]] = Me[mt++]);
        return hi;
      }
      function uf(Me, Pe) {
        var Ue = -1, ht = Me.length;
        for (Pe || (Pe = ti(ht)); ++Ue < ht; ) Pe[Ue] = Me[Ue];
        return Pe;
      }
      function os(Me, Pe, Ue, ht) {
        var mt = !Ue;
        Ue || (Ue = {});
        for (var Mt = -1, Bt = Pe.length; ++Mt < Bt; ) {
          var tr = Pe[Mt], Yr = ht ? ht(Ue[tr], Me[tr], tr, Ue, Me) : G;
          Yr === G && (Yr = Me[tr]), mt ? ds(Ue, tr, Yr) : _o(Ue, tr, Yr);
        }
        return Ue;
      }
      function vp(Me, Pe) {
        return os(Me, hu(Me), Pe);
      }
      function mp(Me, Pe) {
        return os(Me, al(Me), Pe);
      }
      function d0(Me, Pe) {
        return function(Ue, ht) {
          var mt = Gi(Ue) ? wd : k1, Mt = Pe ? Pe() : {};
          return mt(Ue, Me, $i(ht, 2), Mt);
        };
      }
      function uo(Me) {
        return nn(function(Pe, Ue) {
          var ht = -1, mt = Ue.length, Mt = mt > 1 ? Ue[mt - 1] : G, Bt = mt > 2 ? Ue[2] : G;
          for (Mt = Me.length > 3 && typeof Mt == "function" ? (mt--, Mt) : G, Bt && sf(Ue[0], Ue[1], Bt) && (Mt = mt < 3 ? G : Mt, mt = 1), Pe = En(Pe); ++ht < mt; ) {
            var tr = Ue[ht];
            tr && Me(Pe, tr, ht, Mt);
          }
          return Pe;
        });
      }
      function Wc(Me, Pe) {
        return function(Ue, ht) {
          if (Ue == null) return Ue;
          if (!df(Ue)) return Me(Ue, ht);
          for (var mt = Ue.length, Mt = Pe ? mt : -1, Bt = En(Ue); (Pe ? Mt-- : ++Mt < mt) && ht(Bt[Mt], Mt, Bt) !== !1; ) ;
          return Ue;
        };
      }
      function Zc(Me) {
        return function(Pe, Ue, ht) {
          for (var mt = -1, Mt = En(Pe), Bt = ht(Pe), tr = Bt.length; tr--; ) {
            var Yr = Bt[Me ? tr : ++mt];
            if (Ue(Mt[Yr], Yr, Mt) === !1) break;
          }
          return Pe;
        };
      }
      function bp(Me, Pe, Ue) {
        var ht = Pe & et, mt = $o(Me);
        function Mt() {
          var Bt = this && this !== kn && this instanceof Mt ? mt : Me;
          return Bt.apply(ht ? Ue : this, arguments);
        }
        return Mt;
      }
      function Jc(Me) {
        return function(Pe) {
          Pe = Mn(Pe);
          var Ue = io(Pe) ? is(Pe) : G, ht = Ue ? Ue[0] : Pe.charAt(0), mt = Ue ? Ds(Ue, 1).join("") : Pe.slice(1);
          return ht[Me]() + mt;
        };
      }
      function co(Me) {
        return function(Pe) {
          return Ah(Wl(Gl(Pe).replace(fd, "")), Me, "");
        };
      }
      function $o(Me) {
        return function() {
          var Pe = arguments;
          switch (Pe.length) {
            case 0:
              return new Me();
            case 1:
              return new Me(Pe[0]);
            case 2:
              return new Me(Pe[0], Pe[1]);
            case 3:
              return new Me(Pe[0], Pe[1], Pe[2]);
            case 4:
              return new Me(Pe[0], Pe[1], Pe[2], Pe[3]);
            case 5:
              return new Me(Pe[0], Pe[1], Pe[2], Pe[3], Pe[4]);
            case 6:
              return new Me(Pe[0], Pe[1], Pe[2], Pe[3], Pe[4], Pe[5]);
            case 7:
              return new Me(Pe[0], Pe[1], Pe[2], Pe[3], Pe[4], Pe[5], Pe[6]);
          }
          var Ue = ho(Me.prototype), ht = Me.apply(Ue, Pe);
          return Dn(ht) ? ht : Ue;
        };
      }
      function gp(Me, Pe, Ue) {
        var ht = $o(Me);
        function mt() {
          for (var Mt = arguments.length, Bt = ti(Mt), tr = Mt, Yr = lo(mt); tr--; ) Bt[tr] = arguments[tr];
          var fi = Mt < 3 && Bt[0] !== Yr && Bt[Mt - 1] !== Yr ? [] : _s(Bt, Yr);
          if (Mt -= fi.length, Mt < Ue) return el(Me, Pe, p0, mt.placeholder, G, Bt, fi, G, G, Ue - Mt);
          var si = this && this !== kn && this instanceof mt ? ht : Me;
          return $f(si, this, Bt);
        }
        return mt;
      }
      function Vc(Me) {
        return function(Pe, Ue, ht) {
          var mt = En(Pe);
          if (!df(Pe)) {
            var Mt = $i(Ue, 3);
            Pe = On(Pe), Ue = function(tr) {
              return Mt(mt[tr], tr, mt);
            };
          }
          var Bt = Me(Pe, Ue, ht);
          return Bt > -1 ? mt[Mt ? Pe[Bt] : Bt] : G;
        };
      }
      function Yc(Me) {
        return vs(function(Pe) {
          var Ue = Pe.length, ht = Ue, mt = Xf.prototype.thru;
          for (Me && Pe.reverse(); ht--; ) {
            var Mt = Pe[ht];
            if (typeof Mt != "function") throw new Yf(De);
            if (mt && !Bt && th(Mt) == "wrapper") var Bt = new Xf([], !0);
          }
          for (ht = Bt ? ht : Ue; ++ht < Ue; ) {
            Mt = Pe[ht];
            var tr = th(Mt), Yr = tr == "wrapper" ? su(Mt) : G;
            Yr && cu(Yr[0]) && Yr[1] == (Ye | ut | lt | pt) && !Yr[4].length && Yr[9] == 1 ? Bt = Bt[th(Yr[0])].apply(Bt, Yr[3]) : Bt = Mt.length == 1 && cu(Mt) ? Bt[tr]() : Bt.thru(Mt);
          }
          return function() {
            var fi = arguments, si = fi[0];
            if (Bt && fi.length == 1 && Gi(si)) return Bt.plant(si).value();
            for (var hi = 0, gi = Ue ? Pe[hi].apply(this, fi) : si; ++hi < Ue; ) gi = Pe[hi].call(this, gi);
            return gi;
          };
        });
      }
      function p0(Me, Pe, Ue, ht, mt, Mt, Bt, tr, Yr, fi) {
        var si = Pe & Ye, hi = Pe & et, gi = Pe & Ve, xi = Pe & (ut | rt), Ii = Pe & bt, rn = gi ? G : $o(Me);
        function Ci() {
          for (var mn = arguments.length, yn = ti(mn), Wf = mn; Wf--; ) yn[Wf] = arguments[Wf];
          if (xi) var of = lo(Ci), Zf = $d(yn, of);
          if (ht && (yn = Kc(yn, ht, mt, xi)), Mt && (yn = Gc(yn, Mt, Bt, xi)), mn -= Zf, xi && mn < fi) {
            var Cn = _s(yn, of);
            return el(Me, Pe, p0, Ci.placeholder, Ue, yn, Cn, tr, Yr, fi - mn);
          }
          var fs = hi ? Ue : this, ys = gi ? fs[Me] : Me;
          return mn = yn.length, tr ? yn = kp(yn, tr) : Ii && mn > 1 && yn.reverse(), si && Yr < mn && (yn.length = Yr), this && this !== kn && this instanceof Ci && (ys = rn || $o(ys)), ys.apply(fs, yn);
        }
        return Ci;
      }
      function Xc(Me, Pe) {
        return function(Ue, ht) {
          return G1(Ue, Me, Pe(ht), {});
        };
      }
      function v0(Me, Pe) {
        return function(Ue, ht) {
          var mt;
          if (Ue === G && ht === G) return Pe;
          if (Ue !== G && (mt = Ue), ht !== G) {
            if (mt === G) return ht;
            typeof Ue == "string" || typeof ht == "string" ? (Ue = jf(Ue), ht = jf(ht)) : (Ue = Oc(Ue), ht = Oc(ht)), mt = Me(Ue, ht);
          }
          return mt;
        };
      }
      function iu(Me) {
        return vs(function(Pe) {
          return Pe = Rn(Pe, Lf($i())), nn(function(Ue) {
            var ht = this;
            return Me(Pe, function(mt) {
              return $f(mt, ht, Ue);
            });
          });
        });
      }
      function g0(Me, Pe) {
        Pe = Pe === G ? " " : jf(Pe);
        var Ue = Pe.length;
        if (Ue < 2) return Ue ? Jh(Pe, Me) : Pe;
        var ht = Jh(Pe, Go(Me / no(Pe)));
        return io(Pe) ? Ds(is(ht), 0, Me).join("") : ht.slice(0, Me);
      }
      function yp(Me, Pe, Ue, ht) {
        var mt = Pe & et, Mt = $o(Me);
        function Bt() {
          for (var tr = -1, Yr = arguments.length, fi = -1, si = ht.length, hi = ti(si + Yr), gi = this && this !== kn && this instanceof Bt ? Mt : Me; ++fi < si; ) hi[fi] = ht[fi];
          for (; Yr--; ) hi[fi++] = arguments[++tr];
          return $f(gi, mt ? Ue : this, hi);
        }
        return Bt;
      }
      function Qc(Me) {
        return function(Pe, Ue, ht) {
          return ht && typeof ht != "number" && sf(Pe, Ue, ht) && (Ue = ht = G), Pe = gs(Pe), Ue === G ? (Ue = Pe, Pe = 0) : Ue = gs(Ue), ht = ht === G ? Pe < Ue ? 1 : -1 : gs(ht), np(Pe, Ue, ht, Me);
        };
      }
      function eh(Me) {
        return function(Pe, Ue) {
          return typeof Pe == "string" && typeof Ue == "string" || (Pe = rs(Pe), Ue = rs(Ue)), Me(Pe, Ue);
        };
      }
      function el(Me, Pe, Ue, ht, mt, Mt, Bt, tr, Yr, fi) {
        var si = Pe & ut, hi = si ? Bt : G, gi = si ? G : Bt, xi = si ? Mt : G, Ii = si ? G : Mt;
        Pe |= si ? lt : vt, Pe &= ~(si ? vt : lt), Pe & Je || (Pe &= ~(et | Ve));
        var rn = [Me, Pe, mt, xi, hi, Ii, gi, tr, Yr, fi], Ci = Ue.apply(G, rn);
        return cu(Me) && ll(Ci, rn), Ci.placeholder = ht, dl(Ci, Me, Pe);
      }
      function nu(Me) {
        var Pe = Pn[Me];
        return function(Ue, ht) {
          if (Ue = rs(Ue), ht = ht == null ? 0 : Un(Qi(ht), 292), ht && dc(Ue)) {
            var mt = (Mn(Ue) + "e").split("e"), Mt = Pe(mt[0] + "e" + (+mt[1] + ht));
            return mt = (Mn(Mt) + "e").split("e"), +(mt[0] + "e" + (+mt[1] - ht));
          }
          return Pe(Ue);
        };
      }
      var wp = so && 1 / No(new so([, -0]))[1] == ge ? function(Me) {
        return new so(Me);
      } : Su;
      function tl(Me) {
        return function(Pe) {
          var Ue = Wn(Pe);
          return Ue == It ? Ih(Pe) : Ue == Ct ? Nd(Pe) : Rd(Pe, Me(Pe));
        };
      }
      function ps(Me, Pe, Ue, ht, mt, Mt, Bt, tr) {
        var Yr = Pe & Ve;
        if (!Yr && typeof Me != "function") throw new Yf(De);
        var fi = ht ? ht.length : 0;
        if (fi || (Pe &= ~(lt | vt), ht = mt = G), Bt = Bt === G ? Bt : Tn(Qi(Bt), 0), tr = tr === G ? tr : Qi(tr), fi -= mt ? mt.length : 0, Pe & vt) {
          var si = ht, hi = mt;
          ht = mt = G;
        }
        var gi = Yr ? G : su(Me), xi = [Me, Pe, Ue, ht, mt, si, hi, Mt, Bt, tr];
        if (gi && Tp(xi, gi), Me = xi[0], Pe = xi[1], Ue = xi[2], ht = xi[3], mt = xi[4], tr = xi[9] = xi[9] === G ? Yr ? 0 : Me.length : Tn(xi[9] - fi, 0), !tr && Pe & (ut | rt) && (Pe &= ~(ut | rt)), !Pe || Pe == et) var Ii = bp(Me, Pe, Ue);
        else Pe == ut || Pe == rt ? Ii = gp(Me, Pe, tr) : (Pe == lt || Pe == (et | lt)) && !mt.length ? Ii = yp(Me, Pe, Ue, ht) : Ii = p0.apply(G, xi);
        var rn = gi ? Tc : ll;
        return dl(rn(Ii, xi), Me, Pe);
      }
      function rl(Me, Pe, Ue, ht) {
        return Me === G || as(Me, fo[Ue]) && !xn.call(ht, Ue) ? Pe : Me;
      }
      function il(Me, Pe, Ue, ht, mt, Mt) {
        return Dn(Me) && Dn(Pe) && (Mt.set(Pe, Me), u0(Me, Pe, G, il, Mt), Mt.delete(Pe)), Me;
      }
      function Mp(Me) {
        return qo(Me) ? G : Me;
      }
      function nl(Me, Pe, Ue, ht, mt, Mt) {
        var Bt = Ue & Fe, tr = Me.length, Yr = Pe.length;
        if (tr != Yr && !(Bt && Yr > tr)) return !1;
        var fi = Mt.get(Me), si = Mt.get(Pe);
        if (fi && si) return fi == Pe && si == Me;
        var hi = -1, gi = !0, xi = Ue & Ge ? new Ls() : G;
        for (Mt.set(Me, Pe), Mt.set(Pe, Me); ++hi < tr; ) {
          var Ii = Me[hi], rn = Pe[hi];
          if (ht) var Ci = Bt ? ht(rn, Ii, hi, Pe, Me, Mt) : ht(Ii, rn, hi, Me, Pe, Mt);
          if (Ci !== G) {
            if (Ci) continue;
            gi = !1;
            break;
          }
          if (xi) {
            if (!Eh(Pe, function(mn, yn) {
              if (!mo(xi, yn) && (Ii === mn || mt(Ii, mn, Ue, ht, Mt))) return xi.push(yn);
            })) {
              gi = !1;
              break;
            }
          } else if (!(Ii === rn || mt(Ii, rn, Ue, ht, Mt))) {
            gi = !1;
            break;
          }
        }
        return Mt.delete(Me), Mt.delete(Pe), gi;
      }
      function _p(Me, Pe, Ue, ht, mt, Mt, Bt) {
        switch (Ue) {
          case qt:
            if (Me.byteLength != Pe.byteLength || Me.byteOffset != Pe.byteOffset) return !1;
            Me = Me.buffer, Pe = Pe.buffer;
          case Nt:
            return !(Me.byteLength != Pe.byteLength || !Mt(new Ho(Me), new Ho(Pe)));
          case Qe:
          case nt:
          case At:
            return as(+Me, +Pe);
          case it:
            return Me.name == Pe.name && Me.message == Pe.message;
          case ni:
          case Wt:
            return Me == Pe + "";
          case It:
            var tr = Ih;
          case Ct:
            var Yr = ht & Fe;
            if (tr || (tr = No), Me.size != Pe.size && !Yr) return !1;
            var fi = Bt.get(Me);
            if (fi) return fi == Pe;
            ht |= Ge, Bt.set(Me, Pe);
            var si = nl(tr(Me), tr(Pe), ht, mt, Mt, Bt);
            return Bt.delete(Me), si;
          case ii:
            if (Mo) return Mo.call(Me) == Mo.call(Pe);
        }
        return !1;
      }
      function xp(Me, Pe, Ue, ht, mt, Mt) {
        var Bt = Ue & Fe, tr = au(Me), Yr = tr.length, fi = au(Pe), si = fi.length;
        if (Yr != si && !Bt) return !1;
        for (var hi = Yr; hi--; ) {
          var gi = tr[hi];
          if (!(Bt ? gi in Pe : xn.call(Pe, gi))) return !1;
        }
        var xi = Mt.get(Me), Ii = Mt.get(Pe);
        if (xi && Ii) return xi == Pe && Ii == Me;
        var rn = !0;
        Mt.set(Me, Pe), Mt.set(Pe, Me);
        for (var Ci = Bt; ++hi < Yr; ) {
          gi = tr[hi];
          var mn = Me[gi], yn = Pe[gi];
          if (ht) var Wf = Bt ? ht(yn, mn, gi, Pe, Me, Mt) : ht(mn, yn, gi, Me, Pe, Mt);
          if (!(Wf === G ? mn === yn || mt(mn, yn, Ue, ht, Mt) : Wf)) {
            rn = !1;
            break;
          }
          Ci || (Ci = gi == "constructor");
        }
        if (rn && !Ci) {
          var of = Me.constructor, Zf = Pe.constructor;
          of != Zf && "constructor" in Me && "constructor" in Pe && !(typeof of == "function" && of instanceof of && typeof Zf == "function" && Zf instanceof Zf) && (rn = !1);
        }
        return Mt.delete(Me), Mt.delete(Pe), rn;
      }
      function vs(Me) {
        return du(ul(Me, G, yl), Me + "");
      }
      function au(Me) {
        return Ac(Me, On, hu);
      }
      function fu(Me) {
        return Ac(Me, pf, al);
      }
      var su = Jo ? function(Me) {
        return Jo.get(Me);
      } : Su;
      function th(Me) {
        for (var Pe = Me.name + "", Ue = oo[Pe], ht = xn.call(oo, Pe) ? Ue.length : 0; ht--; ) {
          var mt = Ue[ht], Mt = mt.func;
          if (Mt == null || Mt == Me) return mt.name;
        }
        return Pe;
      }
      function lo(Me) {
        var Pe = xn.call(wt, "placeholder") ? wt : Me;
        return Pe.placeholder;
      }
      function $i() {
        var Me = wt.iteratee || Au;
        return Me = Me === Au ? Bc : Me, arguments.length ? Me(arguments[0], arguments[1]) : Me;
      }
      function ih(Me, Pe) {
        var Ue = Me.__data__;
        return Ip(Pe) ? Ue[typeof Pe == "string" ? "string" : "hash"] : Ue.map;
      }
      function ou(Me) {
        for (var Pe = On(Me), Ue = Pe.length; Ue--; ) {
          var ht = Pe[Ue], mt = Me[ht];
          Pe[Ue] = [ht, mt, ol(mt)];
        }
        return Pe;
      }
      function js(Me, Pe) {
        var Ue = Cd(Me, Pe);
        return Sc(Ue) ? Ue : G;
      }
      function Ap(Me) {
        var Pe = xn.call(Me, Ts), Ue = Me[Ts];
        try {
          Me[Ts] = G;
          var ht = !0;
        } catch {
        }
        var mt = Fo.call(Me);
        return ht && (Pe ? Me[Ts] = Ue : delete Me[Ts]), mt;
      }
      var hu = Ph ? function(Me) {
        return Me == null ? [] : (Me = En(Me), ws(Ph(Me), function(Pe) {
          return cc.call(Me, Pe);
        }));
      } : Bu, al = Ph ? function(Me) {
        for (var Pe = []; Me; ) Ms(Pe, hu(Me)), Me = zo(Me);
        return Pe;
      } : Bu, Wn = Vn;
      (Th && Wn(new Th(new ArrayBuffer(1))) != qt || go && Wn(new go()) != It || Nh && Wn(Nh.resolve()) != Xt || so && Wn(new so()) != Ct || yo && Wn(new yo()) != Rt) && (Wn = function(Me) {
        var Pe = Vn(Me), Ue = Pe == ei ? Me.constructor : G, ht = Ue ? Js(Ue) : "";
        if (ht) switch (ht) {
          case a1:
            return qt;
          case f1:
            return It;
          case s1:
            return Xt;
          case o1:
            return Ct;
          case h1:
            return Rt;
        }
        return Pe;
      });
      function Ep(Me, Pe, Ue) {
        for (var ht = -1, mt = Ue.length; ++ht < mt; ) {
          var Mt = Ue[ht], Bt = Mt.size;
          switch (Mt.type) {
            case "drop":
              Me += Bt;
              break;
            case "dropRight":
              Pe -= Bt;
              break;
            case "take":
              Pe = Un(Pe, Me + Bt);
              break;
            case "takeRight":
              Me = Tn(Me, Pe - Bt);
              break;
          }
        }
        return { start: Me, end: Pe };
      }
      function Sp(Me) {
        var Pe = Me.match(mi);
        return Pe ? Pe[1].split(Pr) : [];
      }
      function fl(Me, Pe, Ue) {
        Pe = Ss(Pe, Me);
        for (var ht = -1, mt = Pe.length, Mt = !1; ++ht < mt; ) {
          var Bt = hs(Pe[ht]);
          if (!(Mt = Me != null && Ue(Me, Bt))) break;
          Me = Me[Bt];
        }
        return Mt || ++ht != mt ? Mt : (mt = Me == null ? 0 : Me.length, !!mt && lh(mt) && ms(Bt, mt) && (Gi(Me) || Qs(Me)));
      }
      function Bp(Me) {
        var Pe = Me.length, Ue = new Me.constructor(Pe);
        return Pe && typeof Me[0] == "string" && xn.call(Me, "index") && (Ue.index = Me.index, Ue.input = Me.input), Ue;
      }
      function sl(Me) {
        return typeof Me.constructor == "function" && !Do(Me) ? ho(zo(Me)) : {};
      }
      function Rp(Me, Pe, Ue) {
        var ht = Me.constructor;
        switch (Pe) {
          case Nt:
            return ru(Me);
          case Qe:
          case nt:
            return new ht(+Me);
          case qt:
            return cp(Me, Ue);
          case oi:
          case ct:
          case Ze:
          case at:
          case dt:
          case yt:
          case St:
          case xt:
          case Vt:
            return zc(Me, Ue);
          case It:
            return new ht();
          case At:
          case Wt:
            return new ht(Me);
          case ni:
            return lp(Me);
          case Ct:
            return new ht();
          case ii:
            return dp(Me);
        }
      }
      function $p(Me, Pe) {
        var Ue = Pe.length;
        if (!Ue) return Me;
        var ht = Ue - 1;
        return Pe[ht] = (Ue > 1 ? "& " : "") + Pe[ht], Pe = Pe.join(Ue > 2 ? ", " : " "), Me.replace(Cr, `{
/* [wrapped with ` + Pe + `] */
`);
      }
      function Dp(Me) {
        return Gi(Me) || Qs(Me) || !!(lc && Me && Me[lc]);
      }
      function ms(Me, Pe) {
        var Ue = typeof Me;
        return Pe = Pe ?? xe, !!Pe && (Ue == "number" || Ue != "symbol" && Yi.test(Me)) && Me > -1 && Me % 1 == 0 && Me < Pe;
      }
      function sf(Me, Pe, Ue) {
        if (!Dn(Ue)) return !1;
        var ht = typeof Pe;
        return (ht == "number" ? df(Ue) && ms(Pe, Ue.length) : ht == "string" && Pe in Ue) ? as(Ue[Pe], Me) : !1;
      }
      function uu(Me, Pe) {
        if (Gi(Me)) return !1;
        var Ue = typeof Me;
        return Ue == "number" || Ue == "symbol" || Ue == "boolean" || Me == null || Gf(Me) ? !0 : Br.test(Me) || !Sr.test(Me) || Pe != null && Me in En(Pe);
      }
      function Ip(Me) {
        var Pe = typeof Me;
        return Pe == "string" || Pe == "number" || Pe == "symbol" || Pe == "boolean" ? Me !== "__proto__" : Me === null;
      }
      function cu(Me) {
        var Pe = th(Me), Ue = wt[Pe];
        if (typeof Ue != "function" || !(Pe in gn.prototype)) return !1;
        if (Me === Ue) return !0;
        var ht = su(Ue);
        return !!ht && Me === ht[0];
      }
      function qp(Me) {
        return !!oc && oc in Me;
      }
      var Cp = ko ? bs : Ru;
      function Do(Me) {
        var Pe = Me && Me.constructor, Ue = typeof Pe == "function" && Pe.prototype || fo;
        return Me === Ue;
      }
      function ol(Me) {
        return Me === Me && !Dn(Me);
      }
      function hl(Me, Pe) {
        return function(Ue) {
          return Ue == null ? !1 : Ue[Me] === Pe && (Pe !== G || Me in En(Ue));
        };
      }
      function Pp(Me) {
        var Pe = hh(Me, function(ht) {
          return Ue.size === Te && Ue.clear(), ht;
        }), Ue = Pe.cache;
        return Pe;
      }
      function Tp(Me, Pe) {
        var Ue = Me[1], ht = Pe[1], mt = Ue | ht, Mt = mt < (et | Ve | Ye), Bt = ht == Ye && Ue == ut || ht == Ye && Ue == pt && Me[7].length <= Pe[8] || ht == (Ye | pt) && Pe[7].length <= Pe[8] && Ue == ut;
        if (!(Mt || Bt)) return Me;
        ht & et && (Me[2] = Pe[2], mt |= Ue & et ? 0 : Je);
        var tr = Pe[3];
        if (tr) {
          var Yr = Me[3];
          Me[3] = Yr ? Kc(Yr, tr, Pe[4]) : tr, Me[4] = Yr ? _s(Me[3], Ee) : Pe[4];
        }
        return tr = Pe[5], tr && (Yr = Me[5], Me[5] = Yr ? Gc(Yr, tr, Pe[6]) : tr, Me[6] = Yr ? _s(Me[5], Ee) : Pe[6]), tr = Pe[7], tr && (Me[7] = tr), ht & Ye && (Me[8] = Me[8] == null ? Pe[8] : Un(Me[8], Pe[8])), Me[9] == null && (Me[9] = Pe[9]), Me[0] = Pe[0], Me[1] = mt, Me;
      }
      function Np(Me) {
        var Pe = [];
        if (Me != null) for (var Ue in En(Me)) Pe.push(Ue);
        return Pe;
      }
      function Op(Me) {
        return Fo.call(Me);
      }
      function ul(Me, Pe, Ue) {
        return Pe = Tn(Pe === G ? Me.length - 1 : Pe, 0), function() {
          for (var ht = arguments, mt = -1, Mt = Tn(ht.length - Pe, 0), Bt = ti(Mt); ++mt < Mt; ) Bt[mt] = ht[Pe + mt];
          mt = -1;
          for (var tr = ti(Pe + 1); ++mt < Pe; ) tr[mt] = ht[mt];
          return tr[Pe] = Ue(Bt), $f(Me, this, tr);
        };
      }
      function cl(Me, Pe) {
        return Pe.length < 2 ? Me : Us(Me, es(Pe, 0, -1));
      }
      function kp(Me, Pe) {
        for (var Ue = Me.length, ht = Un(Pe.length, Ue), mt = uf(Me); ht--; ) {
          var Mt = Pe[ht];
          Me[ht] = ms(Mt, Ue) ? mt[Mt] : G;
        }
        return Me;
      }
      function lu(Me, Pe) {
        if (!(Pe === "constructor" && typeof Me[Pe] == "function") && Pe != "__proto__") return Me[Pe];
      }
      var ll = pl(Tc), Io = Xd || function(Me, Pe) {
        return kn.setTimeout(Me, Pe);
      }, du = pl(sp);
      function dl(Me, Pe, Ue) {
        var ht = Pe + "";
        return du(Me, $p(ht, Lp(Sp(ht), Ue)));
      }
      function pl(Me) {
        var Pe = 0, Ue = 0;
        return function() {
          var ht = r1(), mt = h - (ht - Ue);
          if (Ue = ht, mt > 0) {
            if (++Pe >= t) return arguments[0];
          } else Pe = 0;
          return Me.apply(G, arguments);
        };
      }
      function nh(Me, Pe) {
        var Ue = -1, ht = Me.length, mt = ht - 1;
        for (Pe = Pe === G ? ht : Pe; ++Ue < Pe; ) {
          var Mt = Zh(Ue, mt), Bt = Me[Mt];
          Me[Mt] = Me[Ue], Me[Ue] = Bt;
        }
        return Me.length = Pe, Me;
      }
      var vl = Pp(function(Me) {
        var Pe = [];
        return Me.charCodeAt(0) === 46 && Pe.push(""), Me.replace(vi, function(Ue, ht, mt, Mt) {
          Pe.push(mt ? Mt.replace(Zr, "$1") : ht || Ue);
        }), Pe;
      });
      function hs(Me) {
        if (typeof Me == "string" || Gf(Me)) return Me;
        var Pe = Me + "";
        return Pe == "0" && 1 / Me == -ge ? "-0" : Pe;
      }
      function Js(Me) {
        if (Me != null) {
          try {
            return Lo.call(Me);
          } catch {
          }
          try {
            return Me + "";
          } catch {
          }
        }
        return "";
      }
      function Lp(Me, Pe) {
        return Vf(tt, function(Ue) {
          var ht = "_." + Ue[0];
          Pe & Ue[1] && !Po(Me, ht) && Me.push(ht);
        }), Me.sort();
      }
      function ml(Me) {
        if (Me instanceof gn) return Me.clone();
        var Pe = new Xf(Me.__wrapped__, Me.__chain__);
        return Pe.__actions__ = uf(Me.__actions__), Pe.__index__ = Me.__index__, Pe.__values__ = Me.__values__, Pe;
      }
      function Fp(Me, Pe, Ue) {
        (Ue ? sf(Me, Pe, Ue) : Pe === G) ? Pe = 1 : Pe = Tn(Qi(Pe), 0);
        var ht = Me == null ? 0 : Me.length;
        if (!ht || Pe < 1) return [];
        for (var mt = 0, Mt = 0, Bt = ti(Go(ht / Pe)); mt < ht; ) Bt[Mt++] = es(Me, mt, mt += Pe);
        return Bt;
      }
      function Up(Me) {
        for (var Pe = -1, Ue = Me == null ? 0 : Me.length, ht = 0, mt = []; ++Pe < Ue; ) {
          var Mt = Me[Pe];
          Mt && (mt[ht++] = Mt);
        }
        return mt;
      }
      function Hp() {
        var Me = arguments.length;
        if (!Me) return [];
        for (var Pe = ti(Me - 1), Ue = arguments[0], ht = Me; ht--; ) Pe[ht - 1] = arguments[ht];
        return Ms(Gi(Ue) ? uf(Ue) : [Ue], Fn(Pe, 1));
      }
      var zp = nn(function(Me, Pe) {
        return qn(Me) ? Ao(Me, Fn(Pe, 1, qn, !0)) : [];
      }), jp = nn(function(Me, Pe) {
        var Ue = ts(Pe);
        return qn(Ue) && (Ue = G), qn(Me) ? Ao(Me, Fn(Pe, 1, qn, !0), $i(Ue, 2)) : [];
      }), Kp = nn(function(Me, Pe) {
        var Ue = ts(Pe);
        return qn(Ue) && (Ue = G), qn(Me) ? Ao(Me, Fn(Pe, 1, qn, !0), G, Ue) : [];
      });
      function Gp(Me, Pe, Ue) {
        var ht = Me == null ? 0 : Me.length;
        return ht ? (Pe = Ue || Pe === G ? 1 : Qi(Pe), es(Me, Pe < 0 ? 0 : Pe, ht)) : [];
      }
      function Wp(Me, Pe, Ue) {
        var ht = Me == null ? 0 : Me.length;
        return ht ? (Pe = Ue || Pe === G ? 1 : Qi(Pe), Pe = ht - Pe, es(Me, 0, Pe < 0 ? 0 : Pe)) : [];
      }
      function Zp(Me, Pe) {
        return Me && Me.length ? l0(Me, $i(Pe, 3), !0, !0) : [];
      }
      function Jp(Me, Pe) {
        return Me && Me.length ? l0(Me, $i(Pe, 3), !0) : [];
      }
      function Vp(Me, Pe, Ue, ht) {
        var mt = Me == null ? 0 : Me.length;
        return mt ? (Ue && typeof Ue != "number" && sf(Me, Pe, Ue) && (Ue = 0, ht = mt), H1(Me, Pe, Ue, ht)) : [];
      }
      function bl(Me, Pe, Ue) {
        var ht = Me == null ? 0 : Me.length;
        if (!ht) return -1;
        var mt = Ue == null ? 0 : Qi(Ue);
        return mt < 0 && (mt = Tn(ht + mt, 0)), To(Me, $i(Pe, 3), mt);
      }
      function gl(Me, Pe, Ue) {
        var ht = Me == null ? 0 : Me.length;
        if (!ht) return -1;
        var mt = ht - 1;
        return Ue !== G && (mt = Qi(Ue), mt = Ue < 0 ? Tn(ht + mt, 0) : Un(mt, ht - 1)), To(Me, $i(Pe, 3), mt, !0);
      }
      function yl(Me) {
        var Pe = Me == null ? 0 : Me.length;
        return Pe ? Fn(Me, 1) : [];
      }
      function Yp(Me) {
        var Pe = Me == null ? 0 : Me.length;
        return Pe ? Fn(Me, ge) : [];
      }
      function Xp(Me, Pe) {
        var Ue = Me == null ? 0 : Me.length;
        return Ue ? (Pe = Pe === G ? 1 : Qi(Pe), Fn(Me, Pe)) : [];
      }
      function Qp(Me) {
        for (var Pe = -1, Ue = Me == null ? 0 : Me.length, ht = {}; ++Pe < Ue; ) {
          var mt = Me[Pe];
          ht[mt[0]] = mt[1];
        }
        return ht;
      }
      function wl(Me) {
        return Me && Me.length ? Me[0] : G;
      }
      function bv(Me, Pe, Ue) {
        var ht = Me == null ? 0 : Me.length;
        if (!ht) return -1;
        var mt = Ue == null ? 0 : Qi(Ue);
        return mt < 0 && (mt = Tn(ht + mt, 0)), ro(Me, Pe, mt);
      }
      function yv(Me) {
        var Pe = Me == null ? 0 : Me.length;
        return Pe ? es(Me, 0, -1) : [];
      }
      var Mv = nn(function(Me) {
        var Pe = Rn(Me, Qh);
        return Pe.length && Pe[0] === Me[0] ? Hh(Pe) : [];
      }), Sv = nn(function(Me) {
        var Pe = ts(Me), Ue = Rn(Me, Qh);
        return Pe === ts(Ue) ? Pe = G : Ue.pop(), Ue.length && Ue[0] === Me[0] ? Hh(Ue, $i(Pe, 2)) : [];
      }), Bv = nn(function(Me) {
        var Pe = ts(Me), Ue = Rn(Me, Qh);
        return Pe = typeof Pe == "function" ? Pe : G, Pe && Ue.pop(), Ue.length && Ue[0] === Me[0] ? Hh(Ue, G, Pe) : [];
      });
      function Rv(Me, Pe) {
        return Me == null ? "" : e1.call(Me, Pe);
      }
      function ts(Me) {
        var Pe = Me == null ? 0 : Me.length;
        return Pe ? Me[Pe - 1] : G;
      }
      function $v(Me, Pe, Ue) {
        var ht = Me == null ? 0 : Me.length;
        if (!ht) return -1;
        var mt = ht;
        return Ue !== G && (mt = Qi(Ue), mt = mt < 0 ? Tn(ht + mt, 0) : Un(mt, ht - 1)), Pe === Pe ? kd(Me, Pe, mt) : To(Me, Qu, mt, !0);
      }
      function Dv(Me, Pe) {
        return Me && Me.length ? Ic(Me, Qi(Pe)) : G;
      }
      var qv = nn(Ml);
      function Ml(Me, Pe) {
        return Me && Me.length && Pe && Pe.length ? Wh(Me, Pe) : Me;
      }
      function Tv(Me, Pe, Ue) {
        return Me && Me.length && Pe && Pe.length ? Wh(Me, Pe, $i(Ue, 2)) : Me;
      }
      function Nv(Me, Pe, Ue) {
        return Me && Me.length && Pe && Pe.length ? Wh(Me, Pe, G, Ue) : Me;
      }
      var Ov = vs(function(Me, Pe) {
        var Ue = Me == null ? 0 : Me.length, ht = kh(Me, Pe);
        return Pc(Me, Rn(Pe, function(mt) {
          return ms(mt, Ue) ? +mt : mt;
        }).sort(jc)), ht;
      });
      function kv(Me, Pe) {
        var Ue = [];
        if (!(Me && Me.length)) return Ue;
        var ht = -1, mt = [], Mt = Me.length;
        for (Pe = $i(Pe, 3); ++ht < Mt; ) {
          var Bt = Me[ht];
          Pe(Bt, ht, Me) && (Ue.push(Bt), mt.push(ht));
        }
        return Pc(Me, mt), Ue;
      }
      function pu(Me) {
        return Me == null ? Me : n1.call(Me);
      }
      function Lv(Me, Pe, Ue) {
        var ht = Me == null ? 0 : Me.length;
        return ht ? (Ue && typeof Ue != "number" && sf(Me, Pe, Ue) ? (Pe = 0, Ue = ht) : (Pe = Pe == null ? 0 : Qi(Pe), Ue = Ue === G ? ht : Qi(Ue)), es(Me, Pe, Ue)) : [];
      }
      function Fv(Me, Pe) {
        return c0(Me, Pe);
      }
      function Uv(Me, Pe, Ue) {
        return Vh(Me, Pe, $i(Ue, 2));
      }
      function Hv(Me, Pe) {
        var Ue = Me == null ? 0 : Me.length;
        if (Ue) {
          var ht = c0(Me, Pe);
          if (ht < Ue && as(Me[ht], Pe)) return ht;
        }
        return -1;
      }
      function zv(Me, Pe) {
        return c0(Me, Pe, !0);
      }
      function jv(Me, Pe, Ue) {
        return Vh(Me, Pe, $i(Ue, 2), !0);
      }
      function Kv(Me, Pe) {
        var Ue = Me == null ? 0 : Me.length;
        if (Ue) {
          var ht = c0(Me, Pe, !0) - 1;
          if (as(Me[ht], Pe)) return ht;
        }
        return -1;
      }
      function Gv(Me) {
        return Me && Me.length ? Nc(Me) : [];
      }
      function Wv(Me, Pe) {
        return Me && Me.length ? Nc(Me, $i(Pe, 2)) : [];
      }
      function Zv(Me) {
        var Pe = Me == null ? 0 : Me.length;
        return Pe ? es(Me, 1, Pe) : [];
      }
      function Jv(Me, Pe, Ue) {
        return Me && Me.length ? (Pe = Ue || Pe === G ? 1 : Qi(Pe), es(Me, 0, Pe < 0 ? 0 : Pe)) : [];
      }
      function Vv(Me, Pe, Ue) {
        var ht = Me == null ? 0 : Me.length;
        return ht ? (Pe = Ue || Pe === G ? 1 : Qi(Pe), Pe = ht - Pe, es(Me, Pe < 0 ? 0 : Pe, ht)) : [];
      }
      function Yv(Me, Pe) {
        return Me && Me.length ? l0(Me, $i(Pe, 3), !1, !0) : [];
      }
      function Xv(Me, Pe) {
        return Me && Me.length ? l0(Me, $i(Pe, 3)) : [];
      }
      var Qv = nn(function(Me) {
        return Es(Fn(Me, 1, qn, !0));
      }), e2 = nn(function(Me) {
        var Pe = ts(Me);
        return qn(Pe) && (Pe = G), Es(Fn(Me, 1, qn, !0), $i(Pe, 2));
      }), t2 = nn(function(Me) {
        var Pe = ts(Me);
        return Pe = typeof Pe == "function" ? Pe : G, Es(Fn(Me, 1, qn, !0), G, Pe);
      });
      function r2(Me) {
        return Me && Me.length ? Es(Me) : [];
      }
      function i2(Me, Pe) {
        return Me && Me.length ? Es(Me, $i(Pe, 2)) : [];
      }
      function n2(Me, Pe) {
        return Pe = typeof Pe == "function" ? Pe : G, Me && Me.length ? Es(Me, G, Pe) : [];
      }
      function vu(Me) {
        if (!(Me && Me.length)) return [];
        var Pe = 0;
        return Me = ws(Me, function(Ue) {
          if (qn(Ue)) return Pe = Tn(Ue.length, Pe), !0;
        }), $h(Pe, function(Ue) {
          return Rn(Me, Sh(Ue));
        });
      }
      function _l(Me, Pe) {
        if (!(Me && Me.length)) return [];
        var Ue = vu(Me);
        return Pe == null ? Ue : Rn(Ue, function(ht) {
          return $f(Pe, G, ht);
        });
      }
      var a2 = nn(function(Me, Pe) {
        return qn(Me) ? Ao(Me, Pe) : [];
      }), f2 = nn(function(Me) {
        return Xh(ws(Me, qn));
      }), s2 = nn(function(Me) {
        var Pe = ts(Me);
        return qn(Pe) && (Pe = G), Xh(ws(Me, qn), $i(Pe, 2));
      }), o2 = nn(function(Me) {
        var Pe = ts(Me);
        return Pe = typeof Pe == "function" ? Pe : G, Xh(ws(Me, qn), G, Pe);
      }), h2 = nn(vu);
      function u2(Me, Pe) {
        return Fc(Me || [], Pe || [], _o);
      }
      function c2(Me, Pe) {
        return Fc(Me || [], Pe || [], Ro);
      }
      var l2 = nn(function(Me) {
        var Pe = Me.length, Ue = Pe > 1 ? Me[Pe - 1] : G;
        return Ue = typeof Ue == "function" ? (Me.pop(), Ue) : G, _l(Me, Ue);
      });
      function xl(Me) {
        var Pe = wt(Me);
        return Pe.__chain__ = !0, Pe;
      }
      function d2(Me, Pe) {
        return Pe(Me), Me;
      }
      function ah(Me, Pe) {
        return Pe(Me);
      }
      var p2 = vs(function(Me) {
        var Pe = Me.length, Ue = Pe ? Me[0] : 0, ht = this.__wrapped__, mt = function(Mt) {
          return kh(Mt, Me);
        };
        return Pe > 1 || this.__actions__.length || !(ht instanceof gn) || !ms(Ue) ? this.thru(mt) : (ht = ht.slice(Ue, +Ue + (Pe ? 1 : 0)), ht.__actions__.push({ func: ah, args: [mt], thisArg: G }), new Xf(ht, this.__chain__).thru(function(Mt) {
          return Pe && !Mt.length && Mt.push(G), Mt;
        }));
      });
      function v2() {
        return xl(this);
      }
      function m2() {
        return new Xf(this.value(), this.__chain__);
      }
      function b2() {
        this.__values__ === G && (this.__values__ = Ol(this.value()));
        var Me = this.__index__ >= this.__values__.length, Pe = Me ? G : this.__values__[this.__index__++];
        return { done: Me, value: Pe };
      }
      function g2() {
        return this;
      }
      function y2(Me) {
        for (var Pe, Ue = this; Ue instanceof Yo; ) {
          var ht = ml(Ue);
          ht.__index__ = 0, ht.__values__ = G, Pe ? mt.__wrapped__ = ht : Pe = ht;
          var mt = ht;
          Ue = Ue.__wrapped__;
        }
        return mt.__wrapped__ = Me, Pe;
      }
      function w2() {
        var Me = this.__wrapped__;
        if (Me instanceof gn) {
          var Pe = Me;
          return this.__actions__.length && (Pe = new gn(this)), Pe = Pe.reverse(), Pe.__actions__.push({ func: ah, args: [pu], thisArg: G }), new Xf(Pe, this.__chain__);
        }
        return this.thru(pu);
      }
      function M2() {
        return Lc(this.__wrapped__, this.__actions__);
      }
      var _2 = d0(function(Me, Pe, Ue) {
        xn.call(Me, Ue) ? ++Me[Ue] : ds(Me, Ue, 1);
      });
      function x2(Me, Pe, Ue) {
        var ht = Gi(Me) ? Yu : U1;
        return Ue && sf(Me, Pe, Ue) && (Pe = G), ht(Me, $i(Pe, 3));
      }
      function A2(Me, Pe) {
        var Ue = Gi(Me) ? ws : _c;
        return Ue(Me, $i(Pe, 3));
      }
      var E2 = Vc(bl), S2 = Vc(gl);
      function B2(Me, Pe) {
        return Fn(fh(Me, Pe), 1);
      }
      function R2(Me, Pe) {
        return Fn(fh(Me, Pe), ge);
      }
      function $2(Me, Pe, Ue) {
        return Ue = Ue === G ? 1 : Qi(Ue), Fn(fh(Me, Pe), Ue);
      }
      function Al(Me, Pe) {
        var Ue = Gi(Me) ? Vf : As;
        return Ue(Me, $i(Pe, 3));
      }
      function El(Me, Pe) {
        var Ue = Gi(Me) ? Md : Mc;
        return Ue(Me, $i(Pe, 3));
      }
      var D2 = d0(function(Me, Pe, Ue) {
        xn.call(Me, Ue) ? Me[Ue].push(Pe) : ds(Me, Ue, [Pe]);
      });
      function I2(Me, Pe, Ue, ht) {
        Me = df(Me) ? Me : vo(Me), Ue = Ue && !ht ? Qi(Ue) : 0;
        var mt = Me.length;
        return Ue < 0 && (Ue = Tn(mt + Ue, 0)), ph(Me) ? Ue <= mt && Me.indexOf(Pe, Ue) > -1 : !!mt && ro(Me, Pe, Ue) > -1;
      }
      var q2 = nn(function(Me, Pe, Ue) {
        var ht = -1, mt = typeof Pe == "function", Mt = df(Me) ? ti(Me.length) : [];
        return As(Me, function(Bt) {
          Mt[++ht] = mt ? $f(Pe, Bt, Ue) : So(Bt, Pe, Ue);
        }), Mt;
      }), C2 = d0(function(Me, Pe, Ue) {
        ds(Me, Ue, Pe);
      });
      function fh(Me, Pe) {
        var Ue = Gi(Me) ? Rn : Rc;
        return Ue(Me, $i(Pe, 3));
      }
      function P2(Me, Pe, Ue, ht) {
        return Me == null ? [] : (Gi(Pe) || (Pe = Pe == null ? [] : [Pe]), Ue = ht ? G : Ue, Gi(Ue) || (Ue = Ue == null ? [] : [Ue]), qc(Me, Pe, Ue));
      }
      var T2 = d0(function(Me, Pe, Ue) {
        Me[Ue ? 0 : 1].push(Pe);
      }, function() {
        return [[], []];
      });
      function N2(Me, Pe, Ue) {
        var ht = Gi(Me) ? Ah : rc, mt = arguments.length < 3;
        return ht(Me, $i(Pe, 4), Ue, mt, As);
      }
      function O2(Me, Pe, Ue) {
        var ht = Gi(Me) ? _d : rc, mt = arguments.length < 3;
        return ht(Me, $i(Pe, 4), Ue, mt, Mc);
      }
      function k2(Me, Pe) {
        var Ue = Gi(Me) ? ws : _c;
        return Ue(Me, uh($i(Pe, 3)));
      }
      function L2(Me) {
        var Pe = Gi(Me) ? bc : ap;
        return Pe(Me);
      }
      function F2(Me, Pe, Ue) {
        (Ue ? sf(Me, Pe, Ue) : Pe === G) ? Pe = 1 : Pe = Qi(Pe);
        var ht = Gi(Me) ? N1 : fp;
        return ht(Me, Pe);
      }
      function U2(Me) {
        var Pe = Gi(Me) ? O1 : op;
        return Pe(Me);
      }
      function H2(Me) {
        if (Me == null) return 0;
        if (df(Me)) return ph(Me) ? no(Me) : Me.length;
        var Pe = Wn(Me);
        return Pe == It || Pe == Ct ? Me.size : jh(Me).length;
      }
      function z2(Me, Pe, Ue) {
        var ht = Gi(Me) ? Eh : hp;
        return Ue && sf(Me, Pe, Ue) && (Pe = G), ht(Me, $i(Pe, 3));
      }
      var j2 = nn(function(Me, Pe) {
        if (Me == null) return [];
        var Ue = Pe.length;
        return Ue > 1 && sf(Me, Pe[0], Pe[1]) ? Pe = [] : Ue > 2 && sf(Pe[0], Pe[1], Pe[2]) && (Pe = [Pe[0]]), qc(Me, Fn(Pe, 1), []);
      }), oh = Yd || function() {
        return kn.Date.now();
      };
      function K2(Me, Pe) {
        if (typeof Pe != "function") throw new Yf(De);
        return Me = Qi(Me), function() {
          if (--Me < 1) return Pe.apply(this, arguments);
        };
      }
      function Sl(Me, Pe, Ue) {
        return Pe = Ue ? G : Pe, Pe = Me && Pe == null ? Me.length : Pe, ps(Me, Ye, G, G, G, G, Pe);
      }
      function Bl(Me, Pe) {
        var Ue;
        if (typeof Pe != "function") throw new Yf(De);
        return Me = Qi(Me), function() {
          return --Me > 0 && (Ue = Pe.apply(this, arguments)), Me <= 1 && (Pe = G), Ue;
        };
      }
      var mu = nn(function(Me, Pe, Ue) {
        var ht = et;
        if (Ue.length) {
          var mt = _s(Ue, lo(mu));
          ht |= lt;
        }
        return ps(Me, ht, Pe, Ue, mt);
      }), Rl = nn(function(Me, Pe, Ue) {
        var ht = et | Ve;
        if (Ue.length) {
          var mt = _s(Ue, lo(Rl));
          ht |= lt;
        }
        return ps(Pe, ht, Me, Ue, mt);
      });
      function $l(Me, Pe, Ue) {
        Pe = Ue ? G : Pe;
        var ht = ps(Me, ut, G, G, G, G, G, Pe);
        return ht.placeholder = $l.placeholder, ht;
      }
      function Dl(Me, Pe, Ue) {
        Pe = Ue ? G : Pe;
        var ht = ps(Me, rt, G, G, G, G, G, Pe);
        return ht.placeholder = Dl.placeholder, ht;
      }
      function Il(Me, Pe, Ue) {
        var ht, mt, Mt, Bt, tr, Yr, fi = 0, si = !1, hi = !1, gi = !0;
        if (typeof Me != "function") throw new Yf(De);
        Pe = rs(Pe) || 0, Dn(Ue) && (si = !!Ue.leading, hi = "maxWait" in Ue, Mt = hi ? Tn(rs(Ue.maxWait) || 0, Pe) : Mt, gi = "trailing" in Ue ? !!Ue.trailing : gi);
        function xi(Cn) {
          var fs = ht, ys = mt;
          return ht = mt = G, fi = Cn, Bt = Me.apply(ys, fs), Bt;
        }
        function Ii(Cn) {
          return fi = Cn, tr = Io(mn, Pe), si ? xi(Cn) : Bt;
        }
        function rn(Cn) {
          var fs = Cn - Yr, ys = Cn - fi, Vl = Pe - fs;
          return hi ? Un(Vl, Mt - ys) : Vl;
        }
        function Ci(Cn) {
          var fs = Cn - Yr, ys = Cn - fi;
          return Yr === G || fs >= Pe || fs < 0 || hi && ys >= Mt;
        }
        function mn() {
          var Cn = oh();
          if (Ci(Cn)) return yn(Cn);
          tr = Io(mn, rn(Cn));
        }
        function yn(Cn) {
          return tr = G, gi && ht ? xi(Cn) : (ht = mt = G, Bt);
        }
        function Wf() {
          tr !== G && Uc(tr), fi = 0, ht = Yr = mt = tr = G;
        }
        function of() {
          return tr === G ? Bt : yn(oh());
        }
        function Zf() {
          var Cn = oh(), fs = Ci(Cn);
          if (ht = arguments, mt = this, Yr = Cn, fs) {
            if (tr === G) return Ii(Yr);
            if (hi) return Uc(tr), tr = Io(mn, Pe), xi(Yr);
          }
          return tr === G && (tr = Io(mn, Pe)), Bt;
        }
        return Zf.cancel = Wf, Zf.flush = of, Zf;
      }
      var G2 = nn(function(Me, Pe) {
        return wc(Me, 1, Pe);
      }), W2 = nn(function(Me, Pe, Ue) {
        return wc(Me, rs(Pe) || 0, Ue);
      });
      function Z2(Me) {
        return ps(Me, bt);
      }
      function hh(Me, Pe) {
        if (typeof Me != "function" || Pe != null && typeof Pe != "function") throw new Yf(De);
        var Ue = function() {
          var ht = arguments, mt = Pe ? Pe.apply(this, ht) : ht[0], Mt = Ue.cache;
          if (Mt.has(mt)) return Mt.get(mt);
          var Bt = Me.apply(this, ht);
          return Ue.cache = Mt.set(mt, Bt) || Mt, Bt;
        };
        return Ue.cache = new (hh.Cache || ls)(), Ue;
      }
      hh.Cache = ls;
      function uh(Me) {
        if (typeof Me != "function") throw new Yf(De);
        return function() {
          var Pe = arguments;
          switch (Pe.length) {
            case 0:
              return !Me.call(this);
            case 1:
              return !Me.call(this, Pe[0]);
            case 2:
              return !Me.call(this, Pe[0], Pe[1]);
            case 3:
              return !Me.call(this, Pe[0], Pe[1], Pe[2]);
          }
          return !Me.apply(this, Pe);
        };
      }
      function J2(Me) {
        return Bl(2, Me);
      }
      var V2 = up(function(Me, Pe) {
        Pe = Pe.length == 1 && Gi(Pe[0]) ? Rn(Pe[0], Lf($i())) : Rn(Fn(Pe, 1), Lf($i()));
        var Ue = Pe.length;
        return nn(function(ht) {
          for (var mt = -1, Mt = Un(ht.length, Ue); ++mt < Mt; ) ht[mt] = Pe[mt].call(this, ht[mt]);
          return $f(Me, this, ht);
        });
      }), bu = nn(function(Me, Pe) {
        var Ue = _s(Pe, lo(bu));
        return ps(Me, lt, G, Pe, Ue);
      }), ql = nn(function(Me, Pe) {
        var Ue = _s(Pe, lo(ql));
        return ps(Me, vt, G, Pe, Ue);
      }), Y2 = vs(function(Me, Pe) {
        return ps(Me, pt, G, G, G, Pe);
      });
      function X2(Me, Pe) {
        if (typeof Me != "function") throw new Yf(De);
        return Pe = Pe === G ? Pe : Qi(Pe), nn(Me, Pe);
      }
      function Q2(Me, Pe) {
        if (typeof Me != "function") throw new Yf(De);
        return Pe = Pe == null ? 0 : Tn(Qi(Pe), 0), nn(function(Ue) {
          var ht = Ue[Pe], mt = Ds(Ue, 0, Pe);
          return ht && Ms(mt, ht), $f(Me, this, mt);
        });
      }
      function em(Me, Pe, Ue) {
        var ht = !0, mt = !0;
        if (typeof Me != "function") throw new Yf(De);
        return Dn(Ue) && (ht = "leading" in Ue ? !!Ue.leading : ht, mt = "trailing" in Ue ? !!Ue.trailing : mt), Il(Me, Pe, { leading: ht, maxWait: Pe, trailing: mt });
      }
      function tm(Me) {
        return Sl(Me, 1);
      }
      function rm(Me, Pe) {
        return bu(eu(Pe), Me);
      }
      function im() {
        if (!arguments.length) return [];
        var Me = arguments[0];
        return Gi(Me) ? Me : [Me];
      }
      function nm(Me) {
        return Qf(Me, ke);
      }
      function am(Me, Pe) {
        return Pe = typeof Pe == "function" ? Pe : G, Qf(Me, ke, Pe);
      }
      function fm(Me) {
        return Qf(Me, Oe | ke);
      }
      function sm(Me, Pe) {
        return Pe = typeof Pe == "function" ? Pe : G, Qf(Me, Oe | ke, Pe);
      }
      function om(Me, Pe) {
        return Pe == null || yc(Me, Pe, On(Pe));
      }
      function as(Me, Pe) {
        return Me === Pe || Me !== Me && Pe !== Pe;
      }
      var hm = eh(Uh), um = eh(function(Me, Pe) {
        return Me >= Pe;
      }), Qs = Ec(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Ec : function(Me) {
        return In(Me) && xn.call(Me, "callee") && !cc.call(Me, "callee");
      }, Gi = ti.isArray, cm = Ku ? Lf(Ku) : W1;
      function df(Me) {
        return Me != null && lh(Me.length) && !bs(Me);
      }
      function qn(Me) {
        return In(Me) && df(Me);
      }
      function lm(Me) {
        return Me === !0 || Me === !1 || In(Me) && Vn(Me) == Qe;
      }
      var Is = Qd || Ru, dm = Gu ? Lf(Gu) : Z1;
      function pm(Me) {
        return In(Me) && Me.nodeType === 1 && !qo(Me);
      }
      function vm(Me) {
        if (Me == null) return !0;
        if (df(Me) && (Gi(Me) || typeof Me == "string" || typeof Me.splice == "function" || Is(Me) || po(Me) || Qs(Me))) return !Me.length;
        var Pe = Wn(Me);
        if (Pe == It || Pe == Ct) return !Me.size;
        if (Do(Me)) return !jh(Me).length;
        for (var Ue in Me) if (xn.call(Me, Ue)) return !1;
        return !0;
      }
      function mm(Me, Pe) {
        return Bo(Me, Pe);
      }
      function bm(Me, Pe, Ue) {
        Ue = typeof Ue == "function" ? Ue : G;
        var ht = Ue ? Ue(Me, Pe) : G;
        return ht === G ? Bo(Me, Pe, G, Ue) : !!ht;
      }
      function gu(Me) {
        if (!In(Me)) return !1;
        var Pe = Vn(Me);
        return Pe == it || Pe == je || typeof Me.message == "string" && typeof Me.name == "string" && !qo(Me);
      }
      function gm(Me) {
        return typeof Me == "number" && dc(Me);
      }
      function bs(Me) {
        if (!Dn(Me)) return !1;
        var Pe = Vn(Me);
        return Pe == st || Pe == gt || Pe == He || Pe == _t;
      }
      function Cl(Me) {
        return typeof Me == "number" && Me == Qi(Me);
      }
      function lh(Me) {
        return typeof Me == "number" && Me > -1 && Me % 1 == 0 && Me <= xe;
      }
      function Dn(Me) {
        var Pe = typeof Me;
        return Me != null && (Pe == "object" || Pe == "function");
      }
      function In(Me) {
        return Me != null && typeof Me == "object";
      }
      var Pl = Wu ? Lf(Wu) : V1;
      function ym(Me, Pe) {
        return Me === Pe || zh(Me, Pe, ou(Pe));
      }
      function wm(Me, Pe, Ue) {
        return Ue = typeof Ue == "function" ? Ue : G, zh(Me, Pe, ou(Pe), Ue);
      }
      function Mm(Me) {
        return Tl(Me) && Me != +Me;
      }
      function _m(Me) {
        if (Cp(Me)) throw new Oi(H);
        return Sc(Me);
      }
      function xm(Me) {
        return Me === null;
      }
      function Am(Me) {
        return Me == null;
      }
      function Tl(Me) {
        return typeof Me == "number" || In(Me) && Vn(Me) == At;
      }
      function qo(Me) {
        if (!In(Me) || Vn(Me) != ei) return !1;
        var Pe = zo(Me);
        if (Pe === null) return !0;
        var Ue = xn.call(Pe, "constructor") && Pe.constructor;
        return typeof Ue == "function" && Ue instanceof Ue && Lo.call(Ue) == Wd;
      }
      var yu = Zu ? Lf(Zu) : Y1;
      function Em(Me) {
        return Cl(Me) && Me >= -xe && Me <= xe;
      }
      var Nl = Ju ? Lf(Ju) : X1;
      function ph(Me) {
        return typeof Me == "string" || !Gi(Me) && In(Me) && Vn(Me) == Wt;
      }
      function Gf(Me) {
        return typeof Me == "symbol" || In(Me) && Vn(Me) == ii;
      }
      var po = Vu ? Lf(Vu) : Q1;
      function Sm(Me) {
        return Me === G;
      }
      function Bm(Me) {
        return In(Me) && Wn(Me) == Rt;
      }
      function Rm(Me) {
        return In(Me) && Vn(Me) == ai;
      }
      var $m = eh(Gh), Dm = eh(function(Me, Pe) {
        return Me <= Pe;
      });
      function Ol(Me) {
        if (!Me) return [];
        if (df(Me)) return ph(Me) ? is(Me) : uf(Me);
        if (bo && Me[bo]) return Td(Me[bo]());
        var Pe = Wn(Me), Ue = Pe == It ? Ih : Pe == Ct ? No : vo;
        return Ue(Me);
      }
      function gs(Me) {
        if (!Me) return Me === 0 ? Me : 0;
        if (Me = rs(Me), Me === ge || Me === -ge) {
          var Pe = Me < 0 ? -1 : 1;
          return Pe * X;
        }
        return Me === Me ? Me : 0;
      }
      function Qi(Me) {
        var Pe = gs(Me), Ue = Pe % 1;
        return Pe === Pe ? Ue ? Pe - Ue : Pe : 0;
      }
      function kl(Me) {
        return Me ? Fs(Qi(Me), 0, Y) : 0;
      }
      function rs(Me) {
        if (typeof Me == "number") return Me;
        if (Gf(Me)) return a;
        if (Dn(Me)) {
          var Pe = typeof Me.valueOf == "function" ? Me.valueOf() : Me;
          Me = Dn(Pe) ? Pe + "" : Pe;
        }
        if (typeof Me != "string") return Me === 0 ? Me : +Me;
        Me = ic(Me);
        var Ue = Zi.test(Me);
        return Ue || Vi.test(Me) ? gd(Me.slice(2), Ue ? 2 : 8) : Ai.test(Me) ? a : +Me;
      }
      function Ll(Me) {
        return os(Me, pf(Me));
      }
      function Im(Me) {
        return Me ? Fs(Qi(Me), -xe, xe) : Me === 0 ? Me : 0;
      }
      function Mn(Me) {
        return Me == null ? "" : jf(Me);
      }
      var qm = uo(function(Me, Pe) {
        if (Do(Pe) || df(Pe)) {
          os(Pe, On(Pe), Me);
          return;
        }
        for (var Ue in Pe) xn.call(Pe, Ue) && _o(Me, Ue, Pe[Ue]);
      }), Fl = uo(function(Me, Pe) {
        os(Pe, pf(Pe), Me);
      }), vh = uo(function(Me, Pe, Ue, ht) {
        os(Pe, pf(Pe), Me, ht);
      }), Cm = uo(function(Me, Pe, Ue, ht) {
        os(Pe, On(Pe), Me, ht);
      }), Pm = vs(kh);
      function Tm(Me, Pe) {
        var Ue = ho(Me);
        return Pe == null ? Ue : gc(Ue, Pe);
      }
      var Nm = nn(function(Me, Pe) {
        Me = En(Me);
        var Ue = -1, ht = Pe.length, mt = ht > 2 ? Pe[2] : G;
        for (mt && sf(Pe[0], Pe[1], mt) && (ht = 1); ++Ue < ht; ) for (var Mt = Pe[Ue], Bt = pf(Mt), tr = -1, Yr = Bt.length; ++tr < Yr; ) {
          var fi = Bt[tr], si = Me[fi];
          (si === G || as(si, fo[fi]) && !xn.call(Me, fi)) && (Me[fi] = Mt[fi]);
        }
        return Me;
      }), Om = nn(function(Me) {
        return Me.push(G, il), $f(Ul, G, Me);
      });
      function km(Me, Pe) {
        return Xu(Me, $i(Pe, 3), ss);
      }
      function Lm(Me, Pe) {
        return Xu(Me, $i(Pe, 3), Fh);
      }
      function Fm(Me, Pe) {
        return Me == null ? Me : Lh(Me, $i(Pe, 3), pf);
      }
      function Um(Me, Pe) {
        return Me == null ? Me : xc(Me, $i(Pe, 3), pf);
      }
      function Hm(Me, Pe) {
        return Me && ss(Me, $i(Pe, 3));
      }
      function zm(Me, Pe) {
        return Me && Fh(Me, $i(Pe, 3));
      }
      function jm(Me) {
        return Me == null ? [] : h0(Me, On(Me));
      }
      function Km(Me) {
        return Me == null ? [] : h0(Me, pf(Me));
      }
      function wu(Me, Pe, Ue) {
        var ht = Me == null ? G : Us(Me, Pe);
        return ht === G ? Ue : ht;
      }
      function Gm(Me, Pe) {
        return Me != null && fl(Me, Pe, z1);
      }
      function Mu(Me, Pe) {
        return Me != null && fl(Me, Pe, j1);
      }
      var Wm = Xc(function(Me, Pe, Ue) {
        Pe != null && typeof Pe.toString != "function" && (Pe = Fo.call(Pe)), Me[Pe] = Ue;
      }, xu(vf)), Zm = Xc(function(Me, Pe, Ue) {
        Pe != null && typeof Pe.toString != "function" && (Pe = Fo.call(Pe)), xn.call(Me, Pe) ? Me[Pe].push(Ue) : Me[Pe] = [Ue];
      }, $i), Jm = nn(So);
      function On(Me) {
        return df(Me) ? mc(Me) : jh(Me);
      }
      function pf(Me) {
        return df(Me) ? mc(Me, !0) : ep(Me);
      }
      function Vm(Me, Pe) {
        var Ue = {};
        return Pe = $i(Pe, 3), ss(Me, function(ht, mt, Mt) {
          ds(Ue, Pe(ht, mt, Mt), ht);
        }), Ue;
      }
      function Ym(Me, Pe) {
        var Ue = {};
        return Pe = $i(Pe, 3), ss(Me, function(ht, mt, Mt) {
          ds(Ue, mt, Pe(ht, mt, Mt));
        }), Ue;
      }
      var Xm = uo(function(Me, Pe, Ue) {
        u0(Me, Pe, Ue);
      }), Ul = uo(function(Me, Pe, Ue, ht) {
        u0(Me, Pe, Ue, ht);
      }), Qm = vs(function(Me, Pe) {
        var Ue = {};
        if (Me == null) return Ue;
        var ht = !1;
        Pe = Rn(Pe, function(Mt) {
          return Mt = Ss(Mt, Me), ht || (ht = Mt.length > 1), Mt;
        }), os(Me, fu(Me), Ue), ht && (Ue = Qf(Ue, Oe | Le | ke, Mp));
        for (var mt = Pe.length; mt--; ) Yh(Ue, Pe[mt]);
        return Ue;
      });
      function eb(Me, Pe) {
        return Hl(Me, uh($i(Pe)));
      }
      var tb = vs(function(Me, Pe) {
        return Me == null ? {} : rp(Me, Pe);
      });
      function Hl(Me, Pe) {
        if (Me == null) return {};
        var Ue = Rn(fu(Me), function(ht) {
          return [ht];
        });
        return Pe = $i(Pe), Cc(Me, Ue, function(ht, mt) {
          return Pe(ht, mt[0]);
        });
      }
      function rb(Me, Pe, Ue) {
        Pe = Ss(Pe, Me);
        var ht = -1, mt = Pe.length;
        for (mt || (mt = 1, Me = G); ++ht < mt; ) {
          var Mt = Me == null ? G : Me[hs(Pe[ht])];
          Mt === G && (ht = mt, Mt = Ue), Me = bs(Mt) ? Mt.call(Me) : Mt;
        }
        return Me;
      }
      function ib(Me, Pe, Ue) {
        return Me == null ? Me : Ro(Me, Pe, Ue);
      }
      function nb(Me, Pe, Ue, ht) {
        return ht = typeof ht == "function" ? ht : G, Me == null ? Me : Ro(Me, Pe, Ue, ht);
      }
      var zl = tl(On), jl = tl(pf);
      function ab(Me, Pe, Ue) {
        var ht = Gi(Me), mt = ht || Is(Me) || po(Me);
        if (Pe = $i(Pe, 4), Ue == null) {
          var Mt = Me && Me.constructor;
          mt ? Ue = ht ? new Mt() : [] : Dn(Me) ? Ue = bs(Mt) ? ho(zo(Me)) : {} : Ue = {};
        }
        return (mt ? Vf : ss)(Me, function(Bt, tr, Yr) {
          return Pe(Ue, Bt, tr, Yr);
        }), Ue;
      }
      function fb(Me, Pe) {
        return Me == null ? !0 : Yh(Me, Pe);
      }
      function sb(Me, Pe, Ue) {
        return Me == null ? Me : kc(Me, Pe, eu(Ue));
      }
      function ob(Me, Pe, Ue, ht) {
        return ht = typeof ht == "function" ? ht : G, Me == null ? Me : kc(Me, Pe, eu(Ue), ht);
      }
      function vo(Me) {
        return Me == null ? [] : Dh(Me, On(Me));
      }
      function hb(Me) {
        return Me == null ? [] : Dh(Me, pf(Me));
      }
      function ub(Me, Pe, Ue) {
        return Ue === G && (Ue = Pe, Pe = G), Ue !== G && (Ue = rs(Ue), Ue = Ue === Ue ? Ue : 0), Pe !== G && (Pe = rs(Pe), Pe = Pe === Pe ? Pe : 0), Fs(rs(Me), Pe, Ue);
      }
      function cb(Me, Pe, Ue) {
        return Pe = gs(Pe), Ue === G ? (Ue = Pe, Pe = 0) : Ue = gs(Ue), Me = rs(Me), K1(Me, Pe, Ue);
      }
      function lb(Me, Pe, Ue) {
        if (Ue && typeof Ue != "boolean" && sf(Me, Pe, Ue) && (Pe = Ue = G), Ue === G && (typeof Pe == "boolean" ? (Ue = Pe, Pe = G) : typeof Me == "boolean" && (Ue = Me, Me = G)), Me === G && Pe === G ? (Me = 0, Pe = 1) : (Me = gs(Me), Pe === G ? (Pe = Me, Me = 0) : Pe = gs(Pe)), Me > Pe) {
          var ht = Me;
          Me = Pe, Pe = ht;
        }
        if (Ue || Me % 1 || Pe % 1) {
          var mt = pc();
          return Un(Me + mt * (Pe - Me + bd("1e-" + ((mt + "").length - 1))), Pe);
        }
        return Zh(Me, Pe);
      }
      var db = co(function(Me, Pe, Ue) {
        return Pe = Pe.toLowerCase(), Me + (Ue ? Kl(Pe) : Pe);
      });
      function Kl(Me) {
        return _u(Mn(Me).toLowerCase());
      }
      function Gl(Me) {
        return Me = Mn(Me), Me && Me.replace(Xi, Dd).replace(sd, "");
      }
      function pb(Me, Pe, Ue) {
        Me = Mn(Me), Pe = jf(Pe);
        var ht = Me.length;
        Ue = Ue === G ? ht : Fs(Qi(Ue), 0, ht);
        var mt = Ue;
        return Ue -= Pe.length, Ue >= 0 && Me.slice(Ue, mt) == Pe;
      }
      function vb(Me) {
        return Me = Mn(Me), Me && pi.test(Me) ? Me.replace(Gr, Id) : Me;
      }
      function mb(Me) {
        return Me = Mn(Me), Me && $r.test(Me) ? Me.replace(gr, "\\$&") : Me;
      }
      var bb = co(function(Me, Pe, Ue) {
        return Me + (Ue ? "-" : "") + Pe.toLowerCase();
      }), gb = co(function(Me, Pe, Ue) {
        return Me + (Ue ? " " : "") + Pe.toLowerCase();
      }), yb = Jc("toLowerCase");
      function wb(Me, Pe, Ue) {
        Me = Mn(Me), Pe = Qi(Pe);
        var ht = Pe ? no(Me) : 0;
        if (!Pe || ht >= Pe) return Me;
        var mt = (Pe - ht) / 2;
        return g0(Zo(mt), Ue) + Me + g0(Go(mt), Ue);
      }
      function Mb(Me, Pe, Ue) {
        Me = Mn(Me), Pe = Qi(Pe);
        var ht = Pe ? no(Me) : 0;
        return Pe && ht < Pe ? Me + g0(Pe - ht, Ue) : Me;
      }
      function _b(Me, Pe, Ue) {
        Me = Mn(Me), Pe = Qi(Pe);
        var ht = Pe ? no(Me) : 0;
        return Pe && ht < Pe ? g0(Pe - ht, Ue) + Me : Me;
      }
      function xb(Me, Pe, Ue) {
        return Ue || Pe == null ? Pe = 0 : Pe && (Pe = +Pe), i1(Mn(Me).replace(li, ""), Pe || 0);
      }
      function Ab(Me, Pe, Ue) {
        return (Ue ? sf(Me, Pe, Ue) : Pe === G) ? Pe = 1 : Pe = Qi(Pe), Jh(Mn(Me), Pe);
      }
      function Eb() {
        var Me = arguments, Pe = Mn(Me[0]);
        return Me.length < 3 ? Pe : Pe.replace(Me[1], Me[2]);
      }
      var Sb = co(function(Me, Pe, Ue) {
        return Me + (Ue ? "_" : "") + Pe.toLowerCase();
      });
      function Bb(Me, Pe, Ue) {
        return Ue && typeof Ue != "number" && sf(Me, Pe, Ue) && (Pe = Ue = G), Ue = Ue === G ? Y : Ue >>> 0, Ue ? (Me = Mn(Me), Me && (typeof Pe == "string" || Pe != null && !yu(Pe)) && (Pe = jf(Pe), !Pe && io(Me)) ? Ds(is(Me), 0, Ue) : Me.split(Pe, Ue)) : [];
      }
      var Rb = co(function(Me, Pe, Ue) {
        return Me + (Ue ? " " : "") + _u(Pe);
      });
      function $b(Me, Pe, Ue) {
        return Me = Mn(Me), Ue = Ue == null ? 0 : Fs(Qi(Ue), 0, Me.length), Pe = jf(Pe), Me.slice(Ue, Ue + Pe.length) == Pe;
      }
      function Db(Me, Pe, Ue) {
        var ht = wt.templateSettings;
        Ue && sf(Me, Pe, Ue) && (Pe = G), Me = Mn(Me), Pe = vh({}, Pe, ht, rl);
        var mt = vh({}, Pe.imports, ht.imports, rl), Mt = On(mt), Bt = Dh(mt, Mt), tr, Yr, fi = 0, si = Pe.interpolate || en, hi = "__p += '", gi = qh((Pe.escape || en).source + "|" + si.source + "|" + (si === di ? Vr : en).source + "|" + (Pe.evaluate || en).source + "|$", "g"), xi = "//# sourceURL=" + (xn.call(Pe, "sourceURL") ? (Pe.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ld + "]") + `
`;
        Me.replace(gi, function(Ci, mn, yn, Wf, of, Zf) {
          return yn || (yn = Wf), hi += Me.slice(fi, Zf).replace(hn, qd), mn && (tr = !0, hi += `' +
__e(` + mn + `) +
'`), of && (Yr = !0, hi += `';
` + of + `;
__p += '`), yn && (hi += `' +
((__t = (` + yn + `)) == null ? '' : __t) +
'`), fi = Zf + Ci.length, Ci;
        }), hi += `';
`;
        var Ii = xn.call(Pe, "variable") && Pe.variable;
        if (!Ii) hi = `with (obj) {
` + hi + `
}
`;
        else if (yi.test(Ii)) throw new Oi(Ie);
        hi = (Yr ? hi.replace(ci, "") : hi).replace(Qt, "$1").replace(rr, "$1;"), hi = "function(" + (Ii || "obj") + `) {
` + (Ii ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (tr ? ", __e = _.escape" : "") + (Yr ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + hi + `return __p
}`;
        var rn = Zl(function() {
          return wn(Mt, xi + "return " + hi).apply(G, Bt);
        });
        if (rn.source = hi, gu(rn)) throw rn;
        return rn;
      }
      function Ib(Me) {
        return Mn(Me).toLowerCase();
      }
      function qb(Me) {
        return Mn(Me).toUpperCase();
      }
      function Cb(Me, Pe, Ue) {
        if (Me = Mn(Me), Me && (Ue || Pe === G)) return ic(Me);
        if (!Me || !(Pe = jf(Pe))) return Me;
        var ht = is(Me), mt = is(Pe), Mt = nc(ht, mt), Bt = ac(ht, mt) + 1;
        return Ds(ht, Mt, Bt).join("");
      }
      function Pb(Me, Pe, Ue) {
        if (Me = Mn(Me), Me && (Ue || Pe === G)) return Me.slice(0, sc(Me) + 1);
        if (!Me || !(Pe = jf(Pe))) return Me;
        var ht = is(Me), mt = ac(ht, is(Pe)) + 1;
        return Ds(ht, 0, mt).join("");
      }
      function Tb(Me, Pe, Ue) {
        if (Me = Mn(Me), Me && (Ue || Pe === G)) return Me.replace(li, "");
        if (!Me || !(Pe = jf(Pe))) return Me;
        var ht = is(Me), mt = nc(ht, is(Pe));
        return Ds(ht, mt).join("");
      }
      function Nb(Me, Pe) {
        var Ue = Yt, ht = Se;
        if (Dn(Pe)) {
          var mt = "separator" in Pe ? Pe.separator : mt;
          Ue = "length" in Pe ? Qi(Pe.length) : Ue, ht = "omission" in Pe ? jf(Pe.omission) : ht;
        }
        Me = Mn(Me);
        var Mt = Me.length;
        if (io(Me)) {
          var Bt = is(Me);
          Mt = Bt.length;
        }
        if (Ue >= Mt) return Me;
        var tr = Ue - no(ht);
        if (tr < 1) return ht;
        var Yr = Bt ? Ds(Bt, 0, tr).join("") : Me.slice(0, tr);
        if (mt === G) return Yr + ht;
        if (Bt && (tr += Yr.length - tr), yu(mt)) {
          if (Me.slice(tr).search(mt)) {
            var fi, si = Yr;
            for (mt.global || (mt = qh(mt.source, Mn(bi.exec(mt)) + "g")), mt.lastIndex = 0; fi = mt.exec(si); ) var hi = fi.index;
            Yr = Yr.slice(0, hi === G ? tr : hi);
          }
        } else if (Me.indexOf(jf(mt), tr) != tr) {
          var gi = Yr.lastIndexOf(mt);
          gi > -1 && (Yr = Yr.slice(0, gi));
        }
        return Yr + ht;
      }
      function Ob(Me) {
        return Me = Mn(Me), Me && yr.test(Me) ? Me.replace(ui, Ld) : Me;
      }
      var kb = co(function(Me, Pe, Ue) {
        return Me + (Ue ? " " : "") + Pe.toUpperCase();
      }), _u = Jc("toUpperCase");
      function Wl(Me, Pe, Ue) {
        return Me = Mn(Me), Pe = Ue ? G : Pe, Pe === G ? Pd(Me) ? Hd(Me) : Ed(Me) : Me.match(Pe) || [];
      }
      var Zl = nn(function(Me, Pe) {
        try {
          return $f(Me, G, Pe);
        } catch (Ue) {
          return gu(Ue) ? Ue : new Oi(Ue);
        }
      }), Lb = vs(function(Me, Pe) {
        return Vf(Pe, function(Ue) {
          Ue = hs(Ue), ds(Me, Ue, mu(Me[Ue], Me));
        }), Me;
      });
      function Fb(Me) {
        var Pe = Me == null ? 0 : Me.length, Ue = $i();
        return Me = Pe ? Rn(Me, function(ht) {
          if (typeof ht[1] != "function") throw new Yf(De);
          return [Ue(ht[0]), ht[1]];
        }) : [], nn(function(ht) {
          for (var mt = -1; ++mt < Pe; ) {
            var Mt = Me[mt];
            if ($f(Mt[0], this, ht)) return $f(Mt[1], this, ht);
          }
        });
      }
      function Ub(Me) {
        return F1(Qf(Me, Oe));
      }
      function xu(Me) {
        return function() {
          return Me;
        };
      }
      function Hb(Me, Pe) {
        return Me == null || Me !== Me ? Pe : Me;
      }
      var zb = Yc(), jb = Yc(!0);
      function vf(Me) {
        return Me;
      }
      function Au(Me) {
        return Bc(typeof Me == "function" ? Me : Qf(Me, Oe));
      }
      function Kb(Me) {
        return $c(Qf(Me, Oe));
      }
      function Gb(Me, Pe) {
        return Dc(Me, Qf(Pe, Oe));
      }
      var Wb = nn(function(Me, Pe) {
        return function(Ue) {
          return So(Ue, Me, Pe);
        };
      }), Zb = nn(function(Me, Pe) {
        return function(Ue) {
          return So(Me, Ue, Pe);
        };
      });
      function Eu(Me, Pe, Ue) {
        var ht = On(Pe), mt = h0(Pe, ht);
        Ue == null && !(Dn(Pe) && (mt.length || !ht.length)) && (Ue = Pe, Pe = Me, Me = this, mt = h0(Pe, On(Pe)));
        var Mt = !(Dn(Ue) && "chain" in Ue) || !!Ue.chain, Bt = bs(Me);
        return Vf(mt, function(tr) {
          var Yr = Pe[tr];
          Me[tr] = Yr, Bt && (Me.prototype[tr] = function() {
            var fi = this.__chain__;
            if (Mt || fi) {
              var si = Me(this.__wrapped__), hi = si.__actions__ = uf(this.__actions__);
              return hi.push({ func: Yr, args: arguments, thisArg: Me }), si.__chain__ = fi, si;
            }
            return Yr.apply(Me, Ms([this.value()], arguments));
          });
        }), Me;
      }
      function Jb() {
        return kn._ === this && (kn._ = Zd), this;
      }
      function Su() {
      }
      function Vb(Me) {
        return Me = Qi(Me), nn(function(Pe) {
          return Ic(Pe, Me);
        });
      }
      var Yb = iu(Rn), Xb = iu(Yu), Qb = iu(Eh);
      function Jl(Me) {
        return uu(Me) ? Sh(hs(Me)) : ip(Me);
      }
      function e3(Me) {
        return function(Pe) {
          return Me == null ? G : Us(Me, Pe);
        };
      }
      var t3 = Qc(), r3 = Qc(!0);
      function Bu() {
        return [];
      }
      function Ru() {
        return !1;
      }
      function i3() {
        return {};
      }
      function n3() {
        return "";
      }
      function a3() {
        return !0;
      }
      function f3(Me, Pe) {
        if (Me = Qi(Me), Me < 1 || Me > xe) return [];
        var Ue = Y, ht = Un(Me, Y);
        Pe = $i(Pe), Me -= Y;
        for (var mt = $h(ht, Pe); ++Ue < Me; ) Pe(Ue);
        return mt;
      }
      function s3(Me) {
        return Gi(Me) ? Rn(Me, hs) : Gf(Me) ? [Me] : uf(vl(Mn(Me)));
      }
      function o3(Me) {
        var Pe = ++Gd;
        return Mn(Me) + Pe;
      }
      var h3 = v0(function(Me, Pe) {
        return Me + Pe;
      }, 0), u3 = nu("ceil"), c3 = v0(function(Me, Pe) {
        return Me / Pe;
      }, 1), l3 = nu("floor");
      function d3(Me) {
        return Me && Me.length ? Qo(Me, vf, Uh) : G;
      }
      function p3(Me, Pe) {
        return Me && Me.length ? Qo(Me, $i(Pe, 2), Uh) : G;
      }
      function v3(Me) {
        return tc(Me, vf);
      }
      function m3(Me, Pe) {
        return tc(Me, $i(Pe, 2));
      }
      function b3(Me) {
        return Me && Me.length ? Qo(Me, vf, Gh) : G;
      }
      function g3(Me, Pe) {
        return Me && Me.length ? Qo(Me, $i(Pe, 2), Gh) : G;
      }
      var y3 = v0(function(Me, Pe) {
        return Me * Pe;
      }, 1), w3 = nu("round"), M3 = v0(function(Me, Pe) {
        return Me - Pe;
      }, 0);
      function _3(Me) {
        return Me && Me.length ? Rh(Me, vf) : 0;
      }
      function x3(Me, Pe) {
        return Me && Me.length ? Rh(Me, $i(Pe, 2)) : 0;
      }
      return wt.after = K2, wt.ary = Sl, wt.assign = qm, wt.assignIn = Fl, wt.assignInWith = vh, wt.assignWith = Cm, wt.at = Pm, wt.before = Bl, wt.bind = mu, wt.bindAll = Lb, wt.bindKey = Rl, wt.castArray = im, wt.chain = xl, wt.chunk = Fp, wt.compact = Up, wt.concat = Hp, wt.cond = Fb, wt.conforms = Ub, wt.constant = xu, wt.countBy = _2, wt.create = Tm, wt.curry = $l, wt.curryRight = Dl, wt.debounce = Il, wt.defaults = Nm, wt.defaultsDeep = Om, wt.defer = G2, wt.delay = W2, wt.difference = zp, wt.differenceBy = jp, wt.differenceWith = Kp, wt.drop = Gp, wt.dropRight = Wp, wt.dropRightWhile = Zp, wt.dropWhile = Jp, wt.fill = Vp, wt.filter = A2, wt.flatMap = B2, wt.flatMapDeep = R2, wt.flatMapDepth = $2, wt.flatten = yl, wt.flattenDeep = Yp, wt.flattenDepth = Xp, wt.flip = Z2, wt.flow = zb, wt.flowRight = jb, wt.fromPairs = Qp, wt.functions = jm, wt.functionsIn = Km, wt.groupBy = D2, wt.initial = yv, wt.intersection = Mv, wt.intersectionBy = Sv, wt.intersectionWith = Bv, wt.invert = Wm, wt.invertBy = Zm, wt.invokeMap = q2, wt.iteratee = Au, wt.keyBy = C2, wt.keys = On, wt.keysIn = pf, wt.map = fh, wt.mapKeys = Vm, wt.mapValues = Ym, wt.matches = Kb, wt.matchesProperty = Gb, wt.memoize = hh, wt.merge = Xm, wt.mergeWith = Ul, wt.method = Wb, wt.methodOf = Zb, wt.mixin = Eu, wt.negate = uh, wt.nthArg = Vb, wt.omit = Qm, wt.omitBy = eb, wt.once = J2, wt.orderBy = P2, wt.over = Yb, wt.overArgs = V2, wt.overEvery = Xb, wt.overSome = Qb, wt.partial = bu, wt.partialRight = ql, wt.partition = T2, wt.pick = tb, wt.pickBy = Hl, wt.property = Jl, wt.propertyOf = e3, wt.pull = qv, wt.pullAll = Ml, wt.pullAllBy = Tv, wt.pullAllWith = Nv, wt.pullAt = Ov, wt.range = t3, wt.rangeRight = r3, wt.rearg = Y2, wt.reject = k2, wt.remove = kv, wt.rest = X2, wt.reverse = pu, wt.sampleSize = F2, wt.set = ib, wt.setWith = nb, wt.shuffle = U2, wt.slice = Lv, wt.sortBy = j2, wt.sortedUniq = Gv, wt.sortedUniqBy = Wv, wt.split = Bb, wt.spread = Q2, wt.tail = Zv, wt.take = Jv, wt.takeRight = Vv, wt.takeRightWhile = Yv, wt.takeWhile = Xv, wt.tap = d2, wt.throttle = em, wt.thru = ah, wt.toArray = Ol, wt.toPairs = zl, wt.toPairsIn = jl, wt.toPath = s3, wt.toPlainObject = Ll, wt.transform = ab, wt.unary = tm, wt.union = Qv, wt.unionBy = e2, wt.unionWith = t2, wt.uniq = r2, wt.uniqBy = i2, wt.uniqWith = n2, wt.unset = fb, wt.unzip = vu, wt.unzipWith = _l, wt.update = sb, wt.updateWith = ob, wt.values = vo, wt.valuesIn = hb, wt.without = a2, wt.words = Wl, wt.wrap = rm, wt.xor = f2, wt.xorBy = s2, wt.xorWith = o2, wt.zip = h2, wt.zipObject = u2, wt.zipObjectDeep = c2, wt.zipWith = l2, wt.entries = zl, wt.entriesIn = jl, wt.extend = Fl, wt.extendWith = vh, Eu(wt, wt), wt.add = h3, wt.attempt = Zl, wt.camelCase = db, wt.capitalize = Kl, wt.ceil = u3, wt.clamp = ub, wt.clone = nm, wt.cloneDeep = fm, wt.cloneDeepWith = sm, wt.cloneWith = am, wt.conformsTo = om, wt.deburr = Gl, wt.defaultTo = Hb, wt.divide = c3, wt.endsWith = pb, wt.eq = as, wt.escape = vb, wt.escapeRegExp = mb, wt.every = x2, wt.find = E2, wt.findIndex = bl, wt.findKey = km, wt.findLast = S2, wt.findLastIndex = gl, wt.findLastKey = Lm, wt.floor = l3, wt.forEach = Al, wt.forEachRight = El, wt.forIn = Fm, wt.forInRight = Um, wt.forOwn = Hm, wt.forOwnRight = zm, wt.get = wu, wt.gt = hm, wt.gte = um, wt.has = Gm, wt.hasIn = Mu, wt.head = wl, wt.identity = vf, wt.includes = I2, wt.indexOf = bv, wt.inRange = cb, wt.invoke = Jm, wt.isArguments = Qs, wt.isArray = Gi, wt.isArrayBuffer = cm, wt.isArrayLike = df, wt.isArrayLikeObject = qn, wt.isBoolean = lm, wt.isBuffer = Is, wt.isDate = dm, wt.isElement = pm, wt.isEmpty = vm, wt.isEqual = mm, wt.isEqualWith = bm, wt.isError = gu, wt.isFinite = gm, wt.isFunction = bs, wt.isInteger = Cl, wt.isLength = lh, wt.isMap = Pl, wt.isMatch = ym, wt.isMatchWith = wm, wt.isNaN = Mm, wt.isNative = _m, wt.isNil = Am, wt.isNull = xm, wt.isNumber = Tl, wt.isObject = Dn, wt.isObjectLike = In, wt.isPlainObject = qo, wt.isRegExp = yu, wt.isSafeInteger = Em, wt.isSet = Nl, wt.isString = ph, wt.isSymbol = Gf, wt.isTypedArray = po, wt.isUndefined = Sm, wt.isWeakMap = Bm, wt.isWeakSet = Rm, wt.join = Rv, wt.kebabCase = bb, wt.last = ts, wt.lastIndexOf = $v, wt.lowerCase = gb, wt.lowerFirst = yb, wt.lt = $m, wt.lte = Dm, wt.max = d3, wt.maxBy = p3, wt.mean = v3, wt.meanBy = m3, wt.min = b3, wt.minBy = g3, wt.stubArray = Bu, wt.stubFalse = Ru, wt.stubObject = i3, wt.stubString = n3, wt.stubTrue = a3, wt.multiply = y3, wt.nth = Dv, wt.noConflict = Jb, wt.noop = Su, wt.now = oh, wt.pad = wb, wt.padEnd = Mb, wt.padStart = _b, wt.parseInt = xb, wt.random = lb, wt.reduce = N2, wt.reduceRight = O2, wt.repeat = Ab, wt.replace = Eb, wt.result = rb, wt.round = w3, wt.runInContext = Wr, wt.sample = L2, wt.size = H2, wt.snakeCase = Sb, wt.some = z2, wt.sortedIndex = Fv, wt.sortedIndexBy = Uv, wt.sortedIndexOf = Hv, wt.sortedLastIndex = zv, wt.sortedLastIndexBy = jv, wt.sortedLastIndexOf = Kv, wt.startCase = Rb, wt.startsWith = $b, wt.subtract = M3, wt.sum = _3, wt.sumBy = x3, wt.template = Db, wt.times = f3, wt.toFinite = gs, wt.toInteger = Qi, wt.toLength = kl, wt.toLower = Ib, wt.toNumber = rs, wt.toSafeInteger = Im, wt.toString = Mn, wt.toUpper = qb, wt.trim = Cb, wt.trimEnd = Pb, wt.trimStart = Tb, wt.truncate = Nb, wt.unescape = Ob, wt.uniqueId = o3, wt.upperCase = kb, wt.upperFirst = _u, wt.each = Al, wt.eachRight = El, wt.first = wl, Eu(wt, function() {
        var Me = {};
        return ss(wt, function(Pe, Ue) {
          xn.call(wt.prototype, Ue) || (Me[Ue] = Pe);
        }), Me;
      }(), { chain: !1 }), wt.VERSION = J, Vf(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(Me) {
        wt[Me].placeholder = wt;
      }), Vf(["drop", "take"], function(Me, Pe) {
        gn.prototype[Me] = function(Ue) {
          Ue = Ue === G ? 1 : Tn(Qi(Ue), 0);
          var ht = this.__filtered__ && !Pe ? new gn(this) : this.clone();
          return ht.__filtered__ ? ht.__takeCount__ = Un(Ue, ht.__takeCount__) : ht.__views__.push({ size: Un(Ue, Y), type: Me + (ht.__dir__ < 0 ? "Right" : "") }), ht;
        }, gn.prototype[Me + "Right"] = function(Ue) {
          return this.reverse()[Me](Ue).reverse();
        };
      }), Vf(["filter", "map", "takeWhile"], function(Me, Pe) {
        var Ue = Pe + 1, ht = Ue == B || Ue == ve;
        gn.prototype[Me] = function(mt) {
          var Mt = this.clone();
          return Mt.__iteratees__.push({ iteratee: $i(mt, 3), type: Ue }), Mt.__filtered__ = Mt.__filtered__ || ht, Mt;
        };
      }), Vf(["head", "last"], function(Me, Pe) {
        var Ue = "take" + (Pe ? "Right" : "");
        gn.prototype[Me] = function() {
          return this[Ue](1).value()[0];
        };
      }), Vf(["initial", "tail"], function(Me, Pe) {
        var Ue = "drop" + (Pe ? "" : "Right");
        gn.prototype[Me] = function() {
          return this.__filtered__ ? new gn(this) : this[Ue](1);
        };
      }), gn.prototype.compact = function() {
        return this.filter(vf);
      }, gn.prototype.find = function(Me) {
        return this.filter(Me).head();
      }, gn.prototype.findLast = function(Me) {
        return this.reverse().find(Me);
      }, gn.prototype.invokeMap = nn(function(Me, Pe) {
        return typeof Me == "function" ? new gn(this) : this.map(function(Ue) {
          return So(Ue, Me, Pe);
        });
      }), gn.prototype.reject = function(Me) {
        return this.filter(uh($i(Me)));
      }, gn.prototype.slice = function(Me, Pe) {
        Me = Qi(Me);
        var Ue = this;
        return Ue.__filtered__ && (Me > 0 || Pe < 0) ? new gn(Ue) : (Me < 0 ? Ue = Ue.takeRight(-Me) : Me && (Ue = Ue.drop(Me)), Pe !== G && (Pe = Qi(Pe), Ue = Pe < 0 ? Ue.dropRight(-Pe) : Ue.take(Pe - Me)), Ue);
      }, gn.prototype.takeRightWhile = function(Me) {
        return this.reverse().takeWhile(Me).reverse();
      }, gn.prototype.toArray = function() {
        return this.take(Y);
      }, ss(gn.prototype, function(Me, Pe) {
        var Ue = /^(?:filter|find|map|reject)|While$/.test(Pe), ht = /^(?:head|last)$/.test(Pe), mt = wt[ht ? "take" + (Pe == "last" ? "Right" : "") : Pe], Mt = ht || /^find/.test(Pe);
        mt && (wt.prototype[Pe] = function() {
          var Bt = this.__wrapped__, tr = ht ? [1] : arguments, Yr = Bt instanceof gn, fi = tr[0], si = Yr || Gi(Bt), hi = function(mn) {
            var yn = mt.apply(wt, Ms([mn], tr));
            return ht && gi ? yn[0] : yn;
          };
          si && Ue && typeof fi == "function" && fi.length != 1 && (Yr = si = !1);
          var gi = this.__chain__, xi = !!this.__actions__.length, Ii = Mt && !gi, rn = Yr && !xi;
          if (!Mt && si) {
            Bt = rn ? Bt : new gn(this);
            var Ci = Me.apply(Bt, tr);
            return Ci.__actions__.push({ func: ah, args: [hi], thisArg: G }), new Xf(Ci, gi);
          }
          return Ii && rn ? Me.apply(this, tr) : (Ci = this.thru(hi), Ii ? ht ? Ci.value()[0] : Ci.value() : Ci);
        });
      }), Vf(["pop", "push", "shift", "sort", "splice", "unshift"], function(Me) {
        var Pe = Oo[Me], Ue = /^(?:push|sort|unshift)$/.test(Me) ? "tap" : "thru", ht = /^(?:pop|shift)$/.test(Me);
        wt.prototype[Me] = function() {
          var mt = arguments;
          if (ht && !this.__chain__) {
            var Mt = this.value();
            return Pe.apply(Gi(Mt) ? Mt : [], mt);
          }
          return this[Ue](function(Bt) {
            return Pe.apply(Gi(Bt) ? Bt : [], mt);
          });
        };
      }), ss(gn.prototype, function(Me, Pe) {
        var Ue = wt[Pe];
        if (Ue) {
          var ht = Ue.name + "";
          xn.call(oo, ht) || (oo[ht] = []), oo[ht].push({ name: Pe, func: Ue });
        }
      }), oo[p0(G, Ve).name] = [{ name: "wrapper", func: G }], gn.prototype.clone = u1, gn.prototype.reverse = c1, gn.prototype.value = l1, wt.prototype.at = p2, wt.prototype.chain = v2, wt.prototype.commit = m2, wt.prototype.next = b2, wt.prototype.plant = y2, wt.prototype.reverse = w2, wt.prototype.toJSON = wt.prototype.valueOf = wt.prototype.value = M2, wt.prototype.first = wt.prototype.head, bo && (wt.prototype[bo] = g2), wt;
    }, ao = zd();
    Cs ? ((Cs.exports = ao)._ = ao, Mh._ = ao) : kn._ = ao;
  }).call(_n);
})(qi, qi.exports);
var Vg = Object.defineProperty, kg = Object.defineProperties, jg = Object.getOwnPropertyDescriptors, Ra = Object.getOwnPropertySymbols, tv = Object.prototype.hasOwnProperty, ev = Object.prototype.propertyIsEnumerable, ba = (I, A, G) => A in I ? Vg(I, A, { enumerable: !0, configurable: !0, writable: !0, value: G }) : I[A] = G, lr = (I, A) => {
  for (var G in A || (A = {})) tv.call(A, G) && ba(I, G, A[G]);
  if (Ra) for (var G of Ra(A)) ev.call(A, G) && ba(I, G, A[G]);
  return I;
}, nv = (I, A) => kg(I, jg(A));
function Lt(I, A, G) {
  var J;
  const _e = An(I);
  return ((J = A.rpcMap) == null ? void 0 : J[_e.reference]) || `${Oa}?chainId=${_e.namespace}:${_e.reference}&projectId=${G}`;
}
function Ae(I) {
  return I.includes(":") ? I.split(":")[1] : I;
}
function Ta(I) {
  return I.map((A) => `${A.split(":")[0]}:${A.split(":")[1]}`);
}
function rv(I, A) {
  const G = Object.keys(A.namespaces).filter((_e) => _e.includes(I));
  if (!G.length) return [];
  const J = [];
  return G.forEach((_e) => {
    const H = A.namespaces[_e].accounts;
    J.push(...H);
  }), J;
}
function Fi(I = {}, A = {}) {
  const G = La(I), J = La(A);
  return qi.exports.merge(G, J);
}
function La(I) {
  var A, G, J, _e;
  const H = {};
  if (!Xr(I)) return H;
  for (const [De, Ie] of Object.entries(I)) {
    const qe = on(De) ? [De] : Ie.chains, Te = Ie.methods || [], Ee = Ie.events || [], Oe = Ie.rpcMap || {}, Le = xo(De);
    H[Le] = nv(lr(lr({}, H[Le]), Ie), { chains: me(qe, (A = H[Le]) == null ? void 0 : A.chains), methods: me(Te, (G = H[Le]) == null ? void 0 : G.methods), events: me(Ee, (J = H[Le]) == null ? void 0 : J.events), rpcMap: lr(lr({}, Oe), (_e = H[Le]) == null ? void 0 : _e.rpcMap) });
  }
  return H;
}
function iv(I) {
  return I.includes(":") ? I.split(":")[2] : I;
}
function Ha(I) {
  const A = {};
  for (const [G, J] of Object.entries(I)) {
    const _e = J.methods || [], H = J.events || [], De = J.accounts || [], Ie = on(G) ? [G] : J.chains ? J.chains : Ta(J.accounts);
    A[G] = { chains: Ie, methods: _e, events: H, accounts: De };
  }
  return A;
}
function Wi(I) {
  return typeof I == "number" ? I : I.includes("0x") ? parseInt(I, 16) : (I = I.includes(":") ? I.split(":")[1] : I, isNaN(Number(I)) ? I : Number(I));
}
const Da = {}, F = (I) => Da[I], Mi = (I, A) => {
  Da[I] = A;
};
class sv {
  constructor(A) {
    this.name = "polkadot", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  setDefaultChain(A, G) {
    this.httpProviders[A] || this.setHttpProvider(A, G), this.chainId = A, this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${A}`);
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]) || [] : [];
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      var J;
      const _e = Ae(G);
      A[_e] = this.createHttpProvider(_e, (J = this.namespace.rpcMap) == null ? void 0 : J[G]);
    }), A;
  }
  getHttpProvider() {
    const A = `${this.name}:${this.chainId}`, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || Lt(A, this.namespace, this.client.core.projectId);
    if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
    return new o(new f(J, F("disableProviderPing")));
  }
}
var uv = Object.defineProperty, av = Object.defineProperties, ov = Object.getOwnPropertyDescriptors, Na = Object.getOwnPropertySymbols, cv = Object.prototype.hasOwnProperty, fv = Object.prototype.propertyIsEnumerable, $a = (I, A, G) => A in I ? uv(I, A, { enumerable: !0, configurable: !0, writable: !0, value: G }) : I[A] = G, Ua = (I, A) => {
  for (var G in A || (A = {})) cv.call(A, G) && $a(I, G, A[G]);
  if (Na) for (var G of Na(A)) fv.call(A, G) && $a(I, G, A[G]);
  return I;
}, qa = (I, A) => av(I, ov(A));
class hv {
  constructor(A) {
    this.name = "eip155", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
  }
  async request(A) {
    switch (A.request.method) {
      case "eth_requestAccounts":
        return this.getAccounts();
      case "eth_accounts":
        return this.getAccounts();
      case "wallet_switchEthereumChain":
        return await this.handleSwitchChain(A);
      case "eth_chainId":
        return parseInt(this.getDefaultChain());
      case "wallet_getCapabilities":
        return await this.getCapabilities(A);
      case "wallet_getCallsStatus":
        return await this.getCallStatus(A);
    }
    return this.namespace.methods.includes(A.request.method) ? await this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  setDefaultChain(A, G) {
    this.httpProviders[A] || this.setHttpProvider(parseInt(A), G), this.chainId = parseInt(A), this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${A}`);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId.toString();
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  createHttpProvider(A, G) {
    const J = G || Lt(`${this.name}:${A}`, this.namespace, this.client.core.projectId);
    if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
    return new o(new f(J, F("disableProviderPing")));
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      var J;
      const _e = parseInt(Ae(G));
      A[_e] = this.createHttpProvider(_e, (J = this.namespace.rpcMap) == null ? void 0 : J[G]);
    }), A;
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? [...new Set(A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]))] : [];
  }
  getHttpProvider() {
    const A = this.chainId, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  async handleSwitchChain(A) {
    var G, J;
    let _e = A.request.params ? (G = A.request.params[0]) == null ? void 0 : G.chainId : "0x0";
    _e = _e.startsWith("0x") ? _e : `0x${_e}`;
    const H = parseInt(_e, 16);
    if (this.isChainApproved(H)) this.setDefaultChain(`${H}`);
    else if (this.namespace.methods.includes("wallet_switchEthereumChain")) await this.client.request({ topic: A.topic, request: { method: A.request.method, params: [{ chainId: _e }] }, chainId: (J = this.namespace.chains) == null ? void 0 : J[0] }), this.setDefaultChain(`${H}`);
    else throw new Error(`Failed to switch to chain 'eip155:${H}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
    return null;
  }
  isChainApproved(A) {
    return this.namespace.chains.includes(`${this.name}:${A}`);
  }
  async getCapabilities(A) {
    var G, J, _e;
    const H = (J = (G = A.request) == null ? void 0 : G.params) == null ? void 0 : J[0];
    if (!H) throw new Error("Missing address parameter in `wallet_getCapabilities` request");
    const De = this.client.session.get(A.topic), Ie = ((_e = De == null ? void 0 : De.sessionProperties) == null ? void 0 : _e.capabilities) || {};
    if (Ie != null && Ie[H]) return Ie == null ? void 0 : Ie[H];
    const qe = await this.client.request(A);
    try {
      await this.client.session.update(A.topic, { sessionProperties: qa(Ua({}, De.sessionProperties || {}), { capabilities: qa(Ua({}, Ie || {}), { [H]: qe }) }) });
    } catch (Te) {
      console.warn("Failed to update session with capabilities", Te);
    }
    return qe;
  }
  async getCallStatus(A) {
    var G, J;
    const _e = this.client.session.get(A.topic), H = (G = _e.sessionProperties) == null ? void 0 : G.bundler_name;
    if (H) {
      const Ie = this.getBundlerUrl(A.chainId, H);
      try {
        return await this.getUserOperationReceipt(Ie, A);
      } catch (qe) {
        console.warn("Failed to fetch call status from bundler", qe, Ie);
      }
    }
    const De = (J = _e.sessionProperties) == null ? void 0 : J.bundler_url;
    if (De) try {
      return await this.getUserOperationReceipt(De, A);
    } catch (Ie) {
      console.warn("Failed to fetch call status from custom bundler", Ie, De);
    }
    if (this.namespace.methods.includes(A.request.method)) return await this.client.request(A);
    throw new Error("Fetching call status not approved by the wallet.");
  }
  async getUserOperationReceipt(A, G) {
    var J;
    const _e = new URL(A), H = await fetch(_e, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(formatJsonRpcRequest("eth_getUserOperationReceipt", [(J = G.request.params) == null ? void 0 : J[0]])) });
    if (!H.ok) throw new Error(`Failed to fetch user operation receipt - ${H.status}`);
    return await H.json();
  }
  getBundlerUrl(A, G) {
    return `${Qg}?projectId=${this.client.core.projectId}&chainId=${A}&bundler=${G}`;
  }
}
class lv {
  constructor(A) {
    this.name = "solana", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  setDefaultChain(A, G) {
    this.httpProviders[A] || this.setHttpProvider(A, G), this.chainId = A, this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${A}`);
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? [...new Set(A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      var J;
      const _e = Ae(G);
      A[_e] = this.createHttpProvider(_e, (J = this.namespace.rpcMap) == null ? void 0 : J[G]);
    }), A;
  }
  getHttpProvider() {
    const A = `${this.name}:${this.chainId}`, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || Lt(A, this.namespace, this.client.core.projectId);
    if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
    return new o(new f(J, F("disableProviderPing")));
  }
}
class pv {
  constructor(A) {
    this.name = "cosmos", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  setDefaultChain(A, G) {
    this.httpProviders[A] || this.setHttpProvider(A, G), this.chainId = A, this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? [...new Set(A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      var J;
      const _e = Ae(G);
      A[_e] = this.createHttpProvider(_e, (J = this.namespace.rpcMap) == null ? void 0 : J[G]);
    }), A;
  }
  getHttpProvider() {
    const A = `${this.name}:${this.chainId}`, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || Lt(A, this.namespace, this.client.core.projectId);
    if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
    return new o(new f(J, F("disableProviderPing")));
  }
}
class dv {
  constructor(A) {
    this.name = "algorand", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  setDefaultChain(A, G) {
    if (!this.httpProviders[A]) {
      const J = G || Lt(`${this.name}:${A}`, this.namespace, this.client.core.projectId);
      if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
      this.setHttpProvider(A, J);
    }
    this.chainId = A, this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? [...new Set(A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      var J;
      A[G] = this.createHttpProvider(G, (J = this.namespace.rpcMap) == null ? void 0 : J[G]);
    }), A;
  }
  getHttpProvider() {
    const A = `${this.name}:${this.chainId}`, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || Lt(A, this.namespace, this.client.core.projectId);
    return typeof J > "u" ? void 0 : new o(new f(J, F("disableProviderPing")));
  }
}
class gv {
  constructor(A) {
    this.name = "cip34", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  setDefaultChain(A, G) {
    this.httpProviders[A] || this.setHttpProvider(A, G), this.chainId = A, this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? [...new Set(A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      const J = this.getCardanoRPCUrl(G), _e = Ae(G);
      A[_e] = this.createHttpProvider(_e, J);
    }), A;
  }
  getHttpProvider() {
    const A = `${this.name}:${this.chainId}`, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  getCardanoRPCUrl(A) {
    const G = this.namespace.rpcMap;
    if (G) return G[A];
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || this.getCardanoRPCUrl(A);
    if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
    return new o(new f(J, F("disableProviderPing")));
  }
}
class vv {
  constructor(A) {
    this.name = "elrond", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  setDefaultChain(A, G) {
    this.httpProviders[A] || this.setHttpProvider(A, G), this.chainId = A, this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${A}`);
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? [...new Set(A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      var J;
      const _e = Ae(G);
      A[_e] = this.createHttpProvider(_e, (J = this.namespace.rpcMap) == null ? void 0 : J[G]);
    }), A;
  }
  getHttpProvider() {
    const A = `${this.name}:${this.chainId}`, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || Lt(A, this.namespace, this.client.core.projectId);
    if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
    return new o(new f(J, F("disableProviderPing")));
  }
}
class _v {
  constructor(A) {
    this.name = "multiversx", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  setDefaultChain(A, G) {
    this.httpProviders[A] || this.setHttpProvider(A, G), this.chainId = A, this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${A}`);
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? [...new Set(A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      var J;
      const _e = Ae(G);
      A[_e] = this.createHttpProvider(_e, (J = this.namespace.rpcMap) == null ? void 0 : J[G]);
    }), A;
  }
  getHttpProvider() {
    const A = `${this.name}:${this.chainId}`, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || Lt(A, this.namespace, this.client.core.projectId);
    if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
    return new o(new f(J, F("disableProviderPing")));
  }
}
class mv {
  constructor(A) {
    this.name = "near", this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace = Object.assign(this.namespace, A);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider().request(A.request);
  }
  setDefaultChain(A, G) {
    if (this.chainId = A, !this.httpProviders[A]) {
      const J = G || Lt(`${this.name}:${A}`, this.namespace);
      if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
      this.setHttpProvider(A, J);
    }
    this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]) || [] : [];
  }
  createHttpProviders() {
    const A = {};
    return this.namespace.chains.forEach((G) => {
      var J;
      A[G] = this.createHttpProvider(G, (J = this.namespace.rpcMap) == null ? void 0 : J[G]);
    }), A;
  }
  getHttpProvider() {
    const A = `${this.name}:${this.chainId}`, G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || Lt(A, this.namespace);
    return typeof J > "u" ? void 0 : new o(new f(J, F("disableProviderPing")));
  }
}
class wv {
  constructor(A) {
    this.name = ze, this.namespace = A.namespace, this.events = F("events"), this.client = F("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(A) {
    this.namespace.chains = [...new Set((this.namespace.chains || []).concat(A.chains || []))], this.namespace.accounts = [...new Set((this.namespace.accounts || []).concat(A.accounts || []))], this.namespace.methods = [...new Set((this.namespace.methods || []).concat(A.methods || []))], this.namespace.events = [...new Set((this.namespace.events || []).concat(A.events || []))], this.httpProviders = this.createHttpProviders();
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(A) {
    return this.namespace.methods.includes(A.request.method) ? this.client.request(A) : this.getHttpProvider(A.chainId).request(A.request);
  }
  setDefaultChain(A, G) {
    this.httpProviders[A] || this.setHttpProvider(A, G), this.chainId = A, this.events.emit(Tt.DEFAULT_CHAIN_CHANGED, `${this.name}:${A}`);
  }
  getDefaultChain() {
    if (this.chainId) return this.chainId;
    if (this.namespace.defaultChain) return this.namespace.defaultChain;
    const A = this.namespace.chains[0];
    if (!A) throw new Error("ChainId not found");
    return A.split(":")[1];
  }
  getAccounts() {
    const A = this.namespace.accounts;
    return A ? [...new Set(A.filter((G) => G.split(":")[1] === this.chainId.toString()).map((G) => G.split(":")[2]))] : [];
  }
  createHttpProviders() {
    var A, G;
    const J = {};
    return (G = (A = this.namespace) == null ? void 0 : A.accounts) == null || G.forEach((_e) => {
      const H = An(_e);
      J[`${H.namespace}:${H.reference}`] = this.createHttpProvider(_e);
    }), J;
  }
  getHttpProvider(A) {
    const G = this.httpProviders[A];
    if (typeof G > "u") throw new Error(`JSON-RPC provider for ${A} not found`);
    return G;
  }
  setHttpProvider(A, G) {
    const J = this.createHttpProvider(A, G);
    J && (this.httpProviders[A] = J);
  }
  createHttpProvider(A, G) {
    const J = G || Lt(A, this.namespace, this.client.core.projectId);
    if (!J) throw new Error(`No RPC url provided for chainId: ${A}`);
    return new o(new f(J, F("disableProviderPing")));
  }
}
var Pv = Object.defineProperty, Cv = Object.defineProperties, Av = Object.getOwnPropertyDescriptors, Fa = Object.getOwnPropertySymbols, Iv = Object.prototype.hasOwnProperty, xv = Object.prototype.propertyIsEnumerable, Wa = (I, A, G) => A in I ? Pv(I, A, { enumerable: !0, configurable: !0, writable: !0, value: G }) : I[A] = G, pr = (I, A) => {
  for (var G in A || (A = {})) Iv.call(A, G) && Wa(I, G, A[G]);
  if (Fa) for (var G of Fa(A)) xv.call(A, G) && Wa(I, G, A[G]);
  return I;
}, Bi = (I, A) => Cv(I, Av(A));
class dr {
  constructor(A) {
    this.events = new Jg(), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = A, this.logger = typeof (A == null ? void 0 : A.logger) < "u" && typeof (A == null ? void 0 : A.logger) != "string" ? A.logger : Mg(k({ level: (A == null ? void 0 : A.logger) || ya })), this.disableProviderPing = (A == null ? void 0 : A.disableProviderPing) || !1;
  }
  static async init(A) {
    const G = new dr(A);
    return await G.initialize(), G;
  }
  async request(A, G, J) {
    const [_e, H] = this.validateChain(G);
    if (!this.session) throw new Error("Please call connect() before request()");
    return await this.getProvider(_e).request({ request: pr({}, A), chainId: `${_e}:${H}`, topic: this.session.topic, expiry: J });
  }
  sendAsync(A, G, J, _e) {
    const H = (/* @__PURE__ */ new Date()).getTime();
    this.request(A, J, _e).then((De) => G(null, formatJsonRpcResult(H, De))).catch((De) => G(De, void 0));
  }
  async enable() {
    if (!this.client) throw new Error("Sign Client not initialized");
    return this.session || await this.connect({ namespaces: this.namespaces, optionalNamespaces: this.optionalNamespaces, sessionProperties: this.sessionProperties }), await this.requestAccounts();
  }
  async disconnect() {
    var A;
    if (!this.session) throw new Error("Please call connect() before enable()");
    await this.client.disconnect({ topic: (A = this.session) == null ? void 0 : A.topic, reason: er("USER_DISCONNECTED") }), await this.cleanup();
  }
  async connect(A) {
    if (!this.client) throw new Error("Sign Client not initialized");
    if (this.setNamespaces(A), await this.cleanupPendingPairings(), !A.skipPairing) return await this.pair(A.pairingTopic);
  }
  async authenticate(A, G) {
    if (!this.client) throw new Error("Sign Client not initialized");
    this.setNamespaces(A), await this.cleanupPendingPairings();
    const { uri: J, response: _e } = await this.client.authenticate(A, G);
    J && (this.uri = J, this.events.emit("display_uri", J));
    const H = await _e();
    if (this.session = H.session, this.session) {
      const De = Ha(this.session.namespaces);
      this.namespaces = Fi(this.namespaces, De), this.persist("namespaces", this.namespaces), this.onConnect();
    }
    return H;
  }
  on(A, G) {
    this.events.on(A, G);
  }
  once(A, G) {
    this.events.once(A, G);
  }
  removeListener(A, G) {
    this.events.removeListener(A, G);
  }
  off(A, G) {
    this.events.off(A, G);
  }
  get isWalletConnect() {
    return !0;
  }
  async pair(A) {
    this.shouldAbortPairingAttempt = !1;
    let G = 0;
    do {
      if (this.shouldAbortPairingAttempt) throw new Error("Pairing aborted");
      if (G >= this.maxPairingAttempts) throw new Error("Max auto pairing attempts reached");
      const { uri: J, approval: _e } = await this.client.connect({ pairingTopic: A, requiredNamespaces: this.namespaces, optionalNamespaces: this.optionalNamespaces, sessionProperties: this.sessionProperties });
      J && (this.uri = J, this.events.emit("display_uri", J)), await _e().then((H) => {
        this.session = H;
        const De = Ha(H.namespaces);
        this.namespaces = Fi(this.namespaces, De), this.persist("namespaces", this.namespaces);
      }).catch((H) => {
        if (H.message !== PROPOSAL_EXPIRY_MESSAGE) throw H;
        G++;
      });
    } while (!this.session);
    return this.onConnect(), this.session;
  }
  setDefaultChain(A, G) {
    try {
      if (!this.session) return;
      const [J, _e] = this.validateChain(A), H = this.getProvider(J);
      H.name === ze ? H.setDefaultChain(`${J}:${_e}`, G) : H.setDefaultChain(_e, G);
    } catch (J) {
      if (!/Please call connect/.test(J.message)) throw J;
    }
  }
  async cleanupPendingPairings(A = {}) {
    this.logger.info("Cleaning up inactive pairings...");
    const G = this.client.pairing.getAll();
    if (Nr(G)) {
      for (const J of G) A.deletePairings ? this.client.core.expirer.set(J.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(J.topic);
      this.logger.info(`Inactive pairings cleared: ${G.length}`);
    }
  }
  abortPairingAttempt() {
    this.shouldAbortPairingAttempt = !0;
  }
  async checkStorage() {
    if (this.namespaces = await this.getFromStore("namespaces"), this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.client.session.length) {
      const A = this.client.session.keys.length - 1;
      this.session = this.client.session.get(this.client.session.keys[A]), this.createProviders();
    }
  }
  async initialize() {
    this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
  }
  async createClient() {
    this.client = this.providerOpts.client || await qg.init({ core: this.providerOpts.core, logger: this.providerOpts.logger || ya, relayUrl: this.providerOpts.relayUrl || Yg, projectId: this.providerOpts.projectId, metadata: this.providerOpts.metadata, storageOptions: this.providerOpts.storageOptions, storage: this.providerOpts.storage, name: this.providerOpts.name, customStoragePrefix: this.providerOpts.customStoragePrefix, telemetryEnabled: this.providerOpts.telemetryEnabled }), this.logger.trace("SignClient Initialized");
  }
  createProviders() {
    if (!this.client) throw new Error("Sign Client not initialized");
    if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
    const A = [...new Set(Object.keys(this.session.namespaces).map((G) => xo(G)))];
    Mi("client", this.client), Mi("events", this.events), Mi("disableProviderPing", this.disableProviderPing), A.forEach((G) => {
      if (!this.session) return;
      const J = rv(G, this.session), _e = Ta(J), H = Fi(this.namespaces, this.optionalNamespaces), De = Bi(pr({}, H[G]), { accounts: J, chains: _e });
      switch (G) {
        case "eip155":
          this.rpcProviders[G] = new hv({ namespace: De });
          break;
        case "algorand":
          this.rpcProviders[G] = new dv({ namespace: De });
          break;
        case "solana":
          this.rpcProviders[G] = new lv({ namespace: De });
          break;
        case "cosmos":
          this.rpcProviders[G] = new pv({ namespace: De });
          break;
        case "polkadot":
          this.rpcProviders[G] = new sv({ namespace: De });
          break;
        case "cip34":
          this.rpcProviders[G] = new gv({ namespace: De });
          break;
        case "elrond":
          this.rpcProviders[G] = new vv({ namespace: De });
          break;
        case "multiversx":
          this.rpcProviders[G] = new _v({ namespace: De });
          break;
        case "near":
          this.rpcProviders[G] = new mv({ namespace: De });
          break;
        default:
          this.rpcProviders[ze] ? this.rpcProviders[ze].updateNamespace(De) : this.rpcProviders[ze] = new wv({ namespace: De });
      }
    });
  }
  registerEventListeners() {
    if (typeof this.client > "u") throw new Error("Sign Client is not initialized");
    this.client.on("session_ping", (A) => {
      this.events.emit("session_ping", A);
    }), this.client.on("session_event", (A) => {
      const { params: G } = A, { event: J } = G;
      if (J.name === "accountsChanged") {
        const _e = J.data;
        _e && Nr(_e) && this.events.emit("accountsChanged", _e.map(iv));
      } else if (J.name === "chainChanged") {
        const _e = G.chainId, H = G.event.data, De = xo(_e), Ie = Wi(_e) !== Wi(H) ? `${De}:${Wi(H)}` : _e;
        this.onChainChanged(Ie);
      } else this.events.emit(J.name, J.data);
      this.events.emit("session_event", A);
    }), this.client.on("session_update", ({ topic: A, params: G }) => {
      var J;
      const { namespaces: _e } = G, H = (J = this.client) == null ? void 0 : J.session.get(A);
      this.session = Bi(pr({}, H), { namespaces: _e }), this.onSessionUpdate(), this.events.emit("session_update", { topic: A, params: G });
    }), this.client.on("session_delete", async (A) => {
      await this.cleanup(), this.events.emit("session_delete", A), this.events.emit("disconnect", Bi(pr({}, er("USER_DISCONNECTED")), { data: A.topic }));
    }), this.on(Tt.DEFAULT_CHAIN_CHANGED, (A) => {
      this.onChainChanged(A, !0);
    });
  }
  getProvider(A) {
    return this.rpcProviders[A] || this.rpcProviders[ze];
  }
  onSessionUpdate() {
    Object.keys(this.rpcProviders).forEach((A) => {
      var G;
      this.getProvider(A).updateNamespace((G = this.session) == null ? void 0 : G.namespaces[A]);
    });
  }
  setNamespaces(A) {
    const { namespaces: G, optionalNamespaces: J, sessionProperties: _e } = A;
    G && Object.keys(G).length && (this.namespaces = G), J && Object.keys(J).length && (this.optionalNamespaces = J), this.sessionProperties = _e, this.persist("namespaces", G), this.persist("optionalNamespaces", J);
  }
  validateChain(A) {
    const [G, J] = (A == null ? void 0 : A.split(":")) || ["", ""];
    if (!this.namespaces || !Object.keys(this.namespaces).length) return [G, J];
    if (G && !Object.keys(this.namespaces || {}).map((De) => xo(De)).includes(G)) throw new Error(`Namespace '${G}' is not configured. Please call connect() first with namespace config.`);
    if (G && J) return [G, J];
    const _e = xo(Object.keys(this.namespaces)[0]), H = this.rpcProviders[_e].getDefaultChain();
    return [_e, H];
  }
  async requestAccounts() {
    const [A] = this.validateChain();
    return await this.getProvider(A).requestAccounts();
  }
  onChainChanged(A, G = !1) {
    if (!this.namespaces) return;
    const [J, _e] = this.validateChain(A);
    _e && (G || this.getProvider(J).setDefaultChain(_e), this.namespaces[J] ? this.namespaces[J].defaultChain = _e : this.namespaces[`${J}:${_e}`] ? this.namespaces[`${J}:${_e}`].defaultChain = _e : this.namespaces[`${J}:${_e}`] = { defaultChain: _e }, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", _e));
  }
  onConnect() {
    this.createProviders(), this.events.emit("connect", { session: this.session });
  }
  async cleanup() {
    this.session = void 0, this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, this.persist("namespaces", void 0), this.persist("optionalNamespaces", void 0), this.persist("sessionProperties", void 0), await this.cleanupPendingPairings({ deletePairings: !0 });
  }
  persist(A, G) {
    this.client.core.storage.setItem(`${Sa}/${A}`, G);
  }
  async getFromStore(A) {
    return await this.client.core.storage.getItem(`${Sa}/${A}`);
  }
}
const Ev = dr, R = "wc", T = "ethereum_provider", $ = `${R}@2:${T}:`, j = "https://rpc.walletconnect.org/v1/", u = ["eth_sendTransaction", "personal_sign"], y = ["eth_accounts", "eth_requestAccounts", "eth_sendRawTransaction", "eth_sign", "eth_signTransaction", "eth_signTypedData", "eth_signTypedData_v3", "eth_signTypedData_v4", "eth_sendTransaction", "personal_sign", "wallet_switchEthereumChain", "wallet_addEthereumChain", "wallet_getPermissions", "wallet_requestPermissions", "wallet_registerOnboarding", "wallet_watchAsset", "wallet_scanQRCode", "wallet_sendCalls", "wallet_getCapabilities", "wallet_getCallsStatus", "wallet_showCallsStatus"], g = ["chainChanged", "accountsChanged"], b = ["chainChanged", "accountsChanged", "message", "disconnect", "connect"];
var q = Object.defineProperty, N = Object.defineProperties, D = Object.getOwnPropertyDescriptors, M = Object.getOwnPropertySymbols, U = Object.prototype.hasOwnProperty, Q = Object.prototype.propertyIsEnumerable, O = (I, A, G) => A in I ? q(I, A, { enumerable: !0, configurable: !0, writable: !0, value: G }) : I[A] = G, p = (I, A) => {
  for (var G in A || (A = {})) U.call(A, G) && O(I, G, A[G]);
  if (M) for (var G of M(A)) Q.call(A, G) && O(I, G, A[G]);
  return I;
}, E = (I, A) => N(I, D(A));
function m(I) {
  return Number(I[0].split(":")[1]);
}
function v(I) {
  return `0x${I.toString(16)}`;
}
function L(I) {
  const { chains: A, optionalChains: G, methods: J, optionalMethods: _e, events: H, optionalEvents: De, rpcMap: Ie } = I;
  if (!Nr(A)) throw new Error("Invalid chains");
  const qe = { chains: A, methods: J || u, events: H || g, rpcMap: p({}, A.length ? { [m(A)]: Ie[m(A)] } : {}) }, Te = H == null ? void 0 : H.filter((ke) => !g.includes(ke)), Ee = J == null ? void 0 : J.filter((ke) => !u.includes(ke));
  if (!G && !De && !_e && !(Te != null && Te.length) && !(Ee != null && Ee.length)) return { required: A.length ? qe : void 0 };
  const Oe = (Te == null ? void 0 : Te.length) && (Ee == null ? void 0 : Ee.length) || !G, Le = { chains: [...new Set(Oe ? qe.chains.concat(G || []) : G)], methods: [...new Set(qe.methods.concat(_e != null && _e.length ? _e : y))], events: [...new Set(qe.events.concat(De != null && De.length ? De : b))], rpcMap: Ie };
  return { required: A.length ? qe : void 0, optional: G.length ? Le : void 0 };
}
class C {
  constructor() {
    this.events = new eventsExports.EventEmitter(), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = $, this.on = (A, G) => (this.events.on(A, G), this), this.once = (A, G) => (this.events.once(A, G), this), this.removeListener = (A, G) => (this.events.removeListener(A, G), this), this.off = (A, G) => (this.events.off(A, G), this), this.parseAccount = (A) => this.isCompatibleChainId(A) ? this.parseAccountId(A).address : A, this.signer = {}, this.rpc = {};
  }
  static async init(A) {
    const G = new C();
    return await G.initialize(A), G;
  }
  async request(A, G) {
    return await this.signer.request(A, this.formatChainId(this.chainId), G);
  }
  sendAsync(A, G, J) {
    this.signer.sendAsync(A, G, this.formatChainId(this.chainId), J);
  }
  get connected() {
    return this.signer.client ? this.signer.client.core.relayer.connected : !1;
  }
  get connecting() {
    return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
  }
  async enable() {
    return this.session || await this.connect(), await this.request({ method: "eth_requestAccounts" });
  }
  async connect(A) {
    if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
    this.loadConnectOpts(A);
    const { required: G, optional: J } = L(this.rpc);
    try {
      const _e = await new Promise(async (De, Ie) => {
        var qe;
        this.rpc.showQrModal && ((qe = this.modal) == null || qe.subscribeModal((Te) => {
          !Te.open && !this.signer.session && (this.signer.abortPairingAttempt(), Ie(new Error("Connection request reset. Please try again.")));
        })), await this.signer.connect(E(p({ namespaces: p({}, G && { [this.namespace]: G }) }, J && { optionalNamespaces: { [this.namespace]: J } }), { pairingTopic: A == null ? void 0 : A.pairingTopic })).then((Te) => {
          De(Te);
        }).catch((Te) => {
          Ie(new Error(Te.message));
        });
      });
      if (!_e) return;
      const H = Wo(_e.namespaces, [this.namespace]);
      this.setChainIds(this.rpc.chains.length ? this.rpc.chains : H), this.setAccounts(H), this.events.emit("connect", { chainId: v(this.chainId) });
    } catch (_e) {
      throw this.signer.logger.error(_e), _e;
    } finally {
      this.modal && this.modal.closeModal();
    }
  }
  async authenticate(A, G) {
    if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
    this.loadConnectOpts({ chains: A == null ? void 0 : A.chains });
    try {
      const J = await new Promise(async (H, De) => {
        var Ie;
        this.rpc.showQrModal && ((Ie = this.modal) == null || Ie.subscribeModal((qe) => {
          !qe.open && !this.signer.session && (this.signer.abortPairingAttempt(), De(new Error("Connection request reset. Please try again.")));
        })), await this.signer.authenticate(E(p({}, A), { chains: this.rpc.chains }), G).then((qe) => {
          H(qe);
        }).catch((qe) => {
          De(new Error(qe.message));
        });
      }), _e = J.session;
      if (_e) {
        const H = Wo(_e.namespaces, [this.namespace]);
        this.setChainIds(this.rpc.chains.length ? this.rpc.chains : H), this.setAccounts(H), this.events.emit("connect", { chainId: v(this.chainId) });
      }
      return J;
    } catch (J) {
      throw this.signer.logger.error(J), J;
    } finally {
      this.modal && this.modal.closeModal();
    }
  }
  async disconnect() {
    this.session && await this.signer.disconnect(), this.reset();
  }
  get isWalletConnect() {
    return !0;
  }
  get session() {
    return this.signer.session;
  }
  registerEventListeners() {
    this.signer.on("session_event", (A) => {
      const { params: G } = A, { event: J } = G;
      J.name === "accountsChanged" ? (this.accounts = this.parseAccounts(J.data), this.events.emit("accountsChanged", this.accounts)) : J.name === "chainChanged" ? this.setChainId(this.formatChainId(J.data)) : this.events.emit(J.name, J.data), this.events.emit("session_event", A);
    }), this.signer.on("chainChanged", (A) => {
      const G = parseInt(A);
      this.chainId = G, this.events.emit("chainChanged", v(this.chainId)), this.persist();
    }), this.signer.on("session_update", (A) => {
      this.events.emit("session_update", A);
    }), this.signer.on("session_delete", (A) => {
      this.reset(), this.events.emit("session_delete", A), this.events.emit("disconnect", E(p({}, er("USER_DISCONNECTED")), { data: A.topic, name: "USER_DISCONNECTED" }));
    }), this.signer.on("display_uri", (A) => {
      var G, J;
      this.rpc.showQrModal && ((G = this.modal) == null || G.closeModal(), (J = this.modal) == null || J.openModal({ uri: A })), this.events.emit("display_uri", A);
    });
  }
  switchEthereumChain(A) {
    this.request({ method: "wallet_switchEthereumChain", params: [{ chainId: A.toString(16) }] });
  }
  isCompatibleChainId(A) {
    return typeof A == "string" ? A.startsWith(`${this.namespace}:`) : !1;
  }
  formatChainId(A) {
    return `${this.namespace}:${A}`;
  }
  parseChainId(A) {
    return Number(A.split(":")[1]);
  }
  setChainIds(A) {
    const G = A.filter((J) => this.isCompatibleChainId(J)).map((J) => this.parseChainId(J));
    G.length && (this.chainId = G[0], this.events.emit("chainChanged", v(this.chainId)), this.persist());
  }
  setChainId(A) {
    if (this.isCompatibleChainId(A)) {
      const G = this.parseChainId(A);
      this.chainId = G, this.switchEthereumChain(G);
    }
  }
  parseAccountId(A) {
    const [G, J, _e] = A.split(":");
    return { chainId: `${G}:${J}`, address: _e };
  }
  setAccounts(A) {
    this.accounts = A.filter((G) => this.parseChainId(this.parseAccountId(G).chainId) === this.chainId).map((G) => this.parseAccountId(G).address), this.events.emit("accountsChanged", this.accounts);
  }
  getRpcConfig(A) {
    var G, J;
    const _e = (G = A == null ? void 0 : A.chains) != null ? G : [], H = (J = A == null ? void 0 : A.optionalChains) != null ? J : [], De = _e.concat(H);
    if (!De.length) throw new Error("No chains specified in either `chains` or `optionalChains`");
    const Ie = _e.length ? (A == null ? void 0 : A.methods) || u : [], qe = _e.length ? (A == null ? void 0 : A.events) || g : [], Te = (A == null ? void 0 : A.optionalMethods) || [], Ee = (A == null ? void 0 : A.optionalEvents) || [], Oe = (A == null ? void 0 : A.rpcMap) || this.buildRpcMap(De, A.projectId), Le = (A == null ? void 0 : A.qrModalOptions) || void 0;
    return { chains: _e == null ? void 0 : _e.map((ke) => this.formatChainId(ke)), optionalChains: H.map((ke) => this.formatChainId(ke)), methods: Ie, events: qe, optionalMethods: Te, optionalEvents: Ee, rpcMap: Oe, showQrModal: !!(A != null && A.showQrModal), qrModalOptions: Le, projectId: A.projectId, metadata: A.metadata };
  }
  buildRpcMap(A, G) {
    const J = {};
    return A.forEach((_e) => {
      J[_e] = this.getRpcUrl(_e, G);
    }), J;
  }
  async initialize(A) {
    if (this.rpc = this.getRpcConfig(A), this.chainId = this.rpc.chains.length ? m(this.rpc.chains) : m(this.rpc.optionalChains), this.signer = await Ev.init({ projectId: this.rpc.projectId, metadata: this.rpc.metadata, disableProviderPing: A.disableProviderPing, relayUrl: A.relayUrl, storageOptions: A.storageOptions, customStoragePrefix: A.customStoragePrefix, telemetryEnabled: A.telemetryEnabled }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
      let G;
      try {
        const { WalletConnectModal: J } = await import("@walletconnect/modal");
        G = J;
      } catch {
        throw new Error("To use QR modal, please install @walletconnect/modal package");
      }
      if (G) try {
        this.modal = new G(p({ projectId: this.rpc.projectId }, this.rpc.qrModalOptions));
      } catch (J) {
        throw this.signer.logger.error(J), new Error("Could not generate WalletConnectModal Instance");
      }
    }
  }
  loadConnectOpts(A) {
    if (!A) return;
    const { chains: G, optionalChains: J, rpcMap: _e } = A;
    G && Nr(G) && (this.rpc.chains = G.map((H) => this.formatChainId(H)), G.forEach((H) => {
      this.rpc.rpcMap[H] = (_e == null ? void 0 : _e[H]) || this.getRpcUrl(H);
    })), J && Nr(J) && (this.rpc.optionalChains = [], this.rpc.optionalChains = J == null ? void 0 : J.map((H) => this.formatChainId(H)), J.forEach((H) => {
      this.rpc.rpcMap[H] = (_e == null ? void 0 : _e[H]) || this.getRpcUrl(H);
    }));
  }
  getRpcUrl(A, G) {
    var J;
    return ((J = this.rpc.rpcMap) == null ? void 0 : J[A]) || `${j}?chainId=eip155:${A}&projectId=${G || this.rpc.projectId}`;
  }
  async loadPersistedSession() {
    if (this.session) try {
      const A = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), G = this.session.namespaces[`${this.namespace}:${A}`] ? this.session.namespaces[`${this.namespace}:${A}`] : this.session.namespaces[this.namespace];
      this.setChainIds(A ? [this.formatChainId(A)] : G == null ? void 0 : G.accounts), this.setAccounts(G == null ? void 0 : G.accounts);
    } catch (A) {
      this.signer.logger.error("Failed to load persisted session, clearing state..."), this.signer.logger.error(A), await this.disconnect().catch((G) => this.signer.logger.warn(G));
    }
  }
  reset() {
    this.chainId = 1, this.accounts = [];
  }
  persist() {
    this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
  }
  parseAccounts(A) {
    return typeof A == "string" || A instanceof String ? [this.parseAccount(A)] : A.map((G) => this.parseAccount(G));
  }
}
const x = C;
export {
  x as EthereumProvider,
  b as OPTIONAL_EVENTS,
  y as OPTIONAL_METHODS,
  g as REQUIRED_EVENTS,
  u as REQUIRED_METHODS,
  C as default
};
